var OT = Object.defineProperty, yT = Object.defineProperties;
var NT = Object.getOwnPropertyDescriptors;
var X_ = Object.getOwnPropertySymbols;
var LT = Object.prototype.hasOwnProperty, MT = Object.prototype.propertyIsEnumerable;
var Do = (e, r) => (r = Symbol[e]) ? r : Symbol.for("Symbol." + e), bT = (e) => {
  throw TypeError(e);
};
var Q_ = (e, r, t) => r in e ? OT(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, be = (e, r) => {
  for (var t in r || (r = {}))
    LT.call(r, t) && Q_(e, t, r[t]);
  if (X_)
    for (var t of X_(r))
      MT.call(r, t) && Q_(e, t, r[t]);
  return e;
}, Qi = (e, r) => yT(e, NT(r));
var Ae = (e, r, t) => new Promise((a, o) => {
  var l = (p) => {
    try {
      f(t.next(p));
    } catch (u) {
      o(u);
    }
  }, c = (p) => {
    try {
      f(t.throw(p));
    } catch (u) {
      o(u);
    }
  }, f = (p) => p.done ? a(p.value) : Promise.resolve(p.value).then(l, c);
  f((t = t.apply(e, r)).next());
}), ya = function(e, r) {
  this[0] = e, this[1] = r;
}, r0 = (e, r, t) => {
  var a = (c, f, p, u) => {
    try {
      var h = t[c](f), C = (f = h.value) instanceof ya, E = h.done;
      Promise.resolve(C ? f[0] : f).then((_) => C ? a(c === "return" ? c : "next", f[1] ? { done: _.done, value: _.value } : _, p, u) : p({ value: _, done: E })).catch((_) => a("throw", _, p, u));
    } catch (_) {
      u(_);
    }
  }, o = (c) => l[c] = (f) => new Promise((p, u) => a(c, f, p, u)), l = {};
  return t = t.apply(e, r), l[Do("asyncIterator")] = () => l, o("next"), o("throw"), o("return"), l;
}, n0 = (e) => {
  var r = e[Do("asyncIterator")], t = !1, a, o = {};
  return r == null ? (r = e[Do("iterator")](), a = (l) => o[l] = (c) => r[l](c)) : (r = r.call(e), a = (l) => o[l] = (c) => {
    if (t) {
      if (t = !1, l === "throw") throw c;
      return c;
    }
    return t = !0, {
      done: !1,
      value: new ya(new Promise((f) => {
        var p = r[l](c);
        p instanceof Object || bT("Object expected"), f(p);
      }), 1)
    };
  }), o[Do("iterator")] = () => o, a("next"), "throw" in r ? a("throw") : o.throw = (l) => {
    throw l;
  }, "return" in r && a("return"), o;
}, J_ = (e, r, t) => (r = e[Do("asyncIterator")]) ? r.call(e) : (e = e[Do("iterator")](), r = {}, t = (a, o) => (o = e[a]) && (r[a] = (l) => new Promise((c, f, p) => (l = o.call(e, l), p = l.done, Promise.resolve(l.value).then((u) => c({ value: u, done: p }), f)))), t("next"), t("return"), r);
var yo = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : {};
function Zs(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
var eE = {}, As, tE;
function It() {
  if (tE) return As;
  tE = 1;
  var e = function(r) {
    return r && r.Math === Math && r;
  };
  return As = // eslint-disable-next-line es/no-global-this -- safe
  e(typeof globalThis == "object" && globalThis) || e(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  e(typeof self == "object" && self) || e(typeof yo == "object" && yo) || e(typeof As == "object" && As) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Function("return this")(), As;
}
var i0, rE;
function PT() {
  return rE || (rE = 1, i0 = {
    CSSRuleList: 0,
    CSSStyleDeclaration: 0,
    CSSValueList: 0,
    ClientRectList: 0,
    DOMRectList: 0,
    DOMStringList: 0,
    DOMTokenList: 1,
    DataTransferItemList: 0,
    FileList: 0,
    HTMLAllCollection: 0,
    HTMLCollection: 0,
    HTMLFormElement: 0,
    HTMLSelectElement: 0,
    MediaList: 0,
    MimeTypeArray: 0,
    NamedNodeMap: 0,
    NodeList: 1,
    PaintRequestList: 0,
    Plugin: 0,
    PluginArray: 0,
    SVGLengthList: 0,
    SVGNumberList: 0,
    SVGPathSegList: 0,
    SVGPointList: 0,
    SVGStringList: 0,
    SVGTransformList: 0,
    SourceBufferList: 0,
    StyleSheetList: 0,
    TextTrackCueList: 0,
    TextTrackList: 0,
    TouchList: 0
  }), i0;
}
var a0, nE;
function Xt() {
  if (nE) return a0;
  nE = 1;
  var e = typeof document == "object" && document.all;
  return a0 = typeof e == "undefined" && e !== void 0 ? function(r) {
    return typeof r == "function" || r === e;
  } : function(r) {
    return typeof r == "function";
  }, a0;
}
var o0, iE;
function Vr() {
  if (iE) return o0;
  iE = 1;
  var e = Xt();
  return o0 = function(r) {
    return typeof r == "object" ? r !== null : e(r);
  }, o0;
}
var s0, aE;
function Bp() {
  if (aE) return s0;
  aE = 1;
  var e = It(), r = Vr(), t = e.document, a = r(t) && r(t.createElement);
  return s0 = function(o) {
    return a ? t.createElement(o) : {};
  }, s0;
}
var l0, oE;
function wT() {
  if (oE) return l0;
  oE = 1;
  var e = Bp(), r = e("span").classList, t = r && r.constructor && r.constructor.prototype;
  return l0 = t === Object.prototype ? void 0 : t, l0;
}
var c0, sE;
function gt() {
  return sE || (sE = 1, c0 = function(e) {
    try {
      return !!e();
    } catch (r) {
      return !0;
    }
  }), c0;
}
var u0, lE;
function Xl() {
  if (lE) return u0;
  lE = 1;
  var e = gt();
  return u0 = !e(function() {
    var r = function() {
    }.bind();
    return typeof r != "function" || r.hasOwnProperty("prototype");
  }), u0;
}
var f0, cE;
function vt() {
  if (cE) return f0;
  cE = 1;
  var e = Xl(), r = Function.prototype, t = r.call, a = e && r.bind.bind(t, t);
  return f0 = e ? a : function(o) {
    return function() {
      return t.apply(o, arguments);
    };
  }, f0;
}
var d0, uE;
function aa() {
  if (uE) return d0;
  uE = 1;
  var e = vt(), r = e({}.toString), t = e("".slice);
  return d0 = function(a) {
    return t(r(a), 8, -1);
  }, d0;
}
var p0, fE;
function Ql() {
  if (fE) return p0;
  fE = 1;
  var e = vt(), r = gt(), t = aa(), a = Object, o = e("".split);
  return p0 = r(function() {
    return !a("z").propertyIsEnumerable(0);
  }) ? function(l) {
    return t(l) === "String" ? o(l, "") : a(l);
  } : a, p0;
}
var h0, dE;
function $p() {
  return dE || (dE = 1, h0 = function(e) {
    return e == null;
  }), h0;
}
var m0, pE;
function ko() {
  if (pE) return m0;
  pE = 1;
  var e = $p(), r = TypeError;
  return m0 = function(t) {
    if (e(t)) throw new r("Can't call method on " + t);
    return t;
  }, m0;
}
var _0, hE;
function js() {
  if (hE) return _0;
  hE = 1;
  var e = Ql(), r = ko();
  return _0 = function(t) {
    return e(r(t));
  }, _0;
}
var E0 = { exports: {} }, C0, mE;
function bi() {
  return mE || (mE = 1, C0 = !1), C0;
}
var S0, _E;
function Gp() {
  if (_E) return S0;
  _E = 1;
  var e = It(), r = Object.defineProperty;
  return S0 = function(t, a) {
    try {
      r(e, t, { value: a, configurable: !0, writable: !0 });
    } catch (o) {
      e[t] = a;
    }
    return a;
  }, S0;
}
var EE;
function Zp() {
  if (EE) return E0.exports;
  EE = 1;
  var e = bi(), r = It(), t = Gp(), a = "__core-js_shared__", o = E0.exports = r[a] || t(a, {});
  return (o.versions || (o.versions = [])).push({
    version: "3.46.0",
    mode: e ? "pure" : "global",
    copyright: "© 2014-2025 Denis Pushkarev (zloirock.ru), 2025 CoreJS Company (core-js.io)",
    license: "https://github.com/zloirock/core-js/blob/v3.46.0/LICENSE",
    source: "https://github.com/zloirock/core-js"
  }), E0.exports;
}
var I0, CE;
function jp() {
  if (CE) return I0;
  CE = 1;
  var e = Zp();
  return I0 = function(r, t) {
    return e[r] || (e[r] = t || {});
  }, I0;
}
var v0, SE;
function On() {
  if (SE) return v0;
  SE = 1;
  var e = ko(), r = Object;
  return v0 = function(t) {
    return r(e(t));
  }, v0;
}
var g0, IE;
function kr() {
  if (IE) return g0;
  IE = 1;
  var e = vt(), r = On(), t = e({}.hasOwnProperty);
  return g0 = Object.hasOwn || function(o, l) {
    return t(r(o), l);
  }, g0;
}
var D0, vE;
function zp() {
  if (vE) return D0;
  vE = 1;
  var e = vt(), r = 0, t = Math.random(), a = e(1.1.toString);
  return D0 = function(o) {
    return "Symbol(" + (o === void 0 ? "" : o) + ")_" + a(++r + t, 36);
  }, D0;
}
var R0, gE;
function zs() {
  if (gE) return R0;
  gE = 1;
  var e = It(), r = e.navigator, t = r && r.userAgent;
  return R0 = t ? String(t) : "", R0;
}
var A0, DE;
function Jl() {
  if (DE) return A0;
  DE = 1;
  var e = It(), r = zs(), t = e.process, a = e.Deno, o = t && t.versions || a && a.version, l = o && o.v8, c, f;
  return l && (c = l.split("."), f = c[0] > 0 && c[0] < 4 ? 1 : +(c[0] + c[1])), !f && r && (c = r.match(/Edge\/(\d+)/), (!c || c[1] >= 74) && (c = r.match(/Chrome\/(\d+)/), c && (f = +c[1]))), A0 = f, A0;
}
var T0, RE;
function qp() {
  if (RE) return T0;
  RE = 1;
  var e = Jl(), r = gt(), t = It(), a = t.String;
  return T0 = !!Object.getOwnPropertySymbols && !r(function() {
    var o = Symbol("symbol detection");
    return !a(o) || !(Object(o) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && e && e < 41;
  }), T0;
}
var O0, AE;
function jg() {
  if (AE) return O0;
  AE = 1;
  var e = qp();
  return O0 = e && !Symbol.sham && typeof Symbol.iterator == "symbol", O0;
}
var y0, TE;
function cr() {
  if (TE) return y0;
  TE = 1;
  var e = It(), r = jp(), t = kr(), a = zp(), o = qp(), l = jg(), c = e.Symbol, f = r("wks"), p = l ? c.for || c : c && c.withoutSetter || a;
  return y0 = function(u) {
    return t(f, u) || (f[u] = o && t(c, u) ? c[u] : p("Symbol." + u)), f[u];
  }, y0;
}
var N0, OE;
function or() {
  if (OE) return N0;
  OE = 1;
  var e = Vr(), r = String, t = TypeError;
  return N0 = function(a) {
    if (e(a)) return a;
    throw new t(r(a) + " is not an object");
  }, N0;
}
var L0 = {}, M0, yE;
function jt() {
  if (yE) return M0;
  yE = 1;
  var e = gt();
  return M0 = !e(function() {
    return Object.defineProperty({}, 1, { get: function() {
      return 7;
    } })[1] !== 7;
  }), M0;
}
var b0, NE;
function zg() {
  if (NE) return b0;
  NE = 1;
  var e = jt(), r = gt();
  return b0 = e && r(function() {
    return Object.defineProperty(function() {
    }, "prototype", {
      value: 42,
      writable: !1
    }).prototype !== 42;
  }), b0;
}
var P0 = {}, w0, LE;
function qg() {
  if (LE) return w0;
  LE = 1;
  var e = jt(), r = gt(), t = Bp();
  return w0 = !e && !r(function() {
    return Object.defineProperty(t("div"), "a", {
      get: function() {
        return 7;
      }
    }).a !== 7;
  }), w0;
}
var H0, ME;
function Mt() {
  if (ME) return H0;
  ME = 1;
  var e = Xl(), r = Function.prototype.call;
  return H0 = e ? r.bind(r) : function() {
    return r.apply(r, arguments);
  }, H0;
}
var V0, bE;
function oa() {
  if (bE) return V0;
  bE = 1;
  var e = It(), r = Xt(), t = function(a) {
    return r(a) ? a : void 0;
  };
  return V0 = function(a, o) {
    return arguments.length < 2 ? t(e[a]) : e[a] && e[a][o];
  }, V0;
}
var k0, PE;
function xa() {
  if (PE) return k0;
  PE = 1;
  var e = vt();
  return k0 = e({}.isPrototypeOf), k0;
}
var F0, wE;
function ec() {
  if (wE) return F0;
  wE = 1;
  var e = oa(), r = Xt(), t = xa(), a = jg(), o = Object;
  return F0 = a ? function(l) {
    return typeof l == "symbol";
  } : function(l) {
    var c = e("Symbol");
    return r(c) && t(c.prototype, o(l));
  }, F0;
}
var x0, HE;
function Fo() {
  if (HE) return x0;
  HE = 1;
  var e = String;
  return x0 = function(r) {
    try {
      return e(r);
    } catch (t) {
      return "Object";
    }
  }, x0;
}
var U0, VE;
function en() {
  if (VE) return U0;
  VE = 1;
  var e = Xt(), r = Fo(), t = TypeError;
  return U0 = function(a) {
    if (e(a)) return a;
    throw new t(r(a) + " is not a function");
  }, U0;
}
var B0, kE;
function qs() {
  if (kE) return B0;
  kE = 1;
  var e = en(), r = $p();
  return B0 = function(t, a) {
    var o = t[a];
    return r(o) ? void 0 : e(o);
  }, B0;
}
var $0, FE;
function HT() {
  if (FE) return $0;
  FE = 1;
  var e = Mt(), r = Xt(), t = Vr(), a = TypeError;
  return $0 = function(o, l) {
    var c, f;
    if (l === "string" && r(c = o.toString) && !t(f = e(c, o)) || r(c = o.valueOf) && !t(f = e(c, o)) || l !== "string" && r(c = o.toString) && !t(f = e(c, o))) return f;
    throw new a("Can't convert object to primitive value");
  }, $0;
}
var G0, xE;
function Wg() {
  if (xE) return G0;
  xE = 1;
  var e = Mt(), r = Vr(), t = ec(), a = qs(), o = HT(), l = cr(), c = TypeError, f = l("toPrimitive");
  return G0 = function(p, u) {
    if (!r(p) || t(p)) return p;
    var h = a(p, f), C;
    if (h) {
      if (u === void 0 && (u = "default"), C = e(h, p, u), !r(C) || t(C)) return C;
      throw new c("Can't convert object to primitive value");
    }
    return u === void 0 && (u = "number"), o(p, u);
  }, G0;
}
var Z0, UE;
function Wp() {
  if (UE) return Z0;
  UE = 1;
  var e = Wg(), r = ec();
  return Z0 = function(t) {
    var a = e(t, "string");
    return r(a) ? a : a + "";
  }, Z0;
}
var BE;
function Wn() {
  if (BE) return P0;
  BE = 1;
  var e = jt(), r = qg(), t = zg(), a = or(), o = Wp(), l = TypeError, c = Object.defineProperty, f = Object.getOwnPropertyDescriptor, p = "enumerable", u = "configurable", h = "writable";
  return P0.f = e ? t ? function(E, _, S) {
    if (a(E), _ = o(_), a(S), typeof E == "function" && _ === "prototype" && "value" in S && h in S && !S[h]) {
      var v = f(E, _);
      v && v[h] && (E[_] = S.value, S = {
        configurable: u in S ? S[u] : v[u],
        enumerable: p in S ? S[p] : v[p],
        writable: !1
      });
    }
    return c(E, _, S);
  } : c : function(E, _, S) {
    if (a(E), _ = o(_), a(S), r) try {
      return c(E, _, S);
    } catch (v) {
    }
    if ("get" in S || "set" in S) throw new l("Accessors not supported");
    return "value" in S && (E[_] = S.value), E;
  }, P0;
}
var j0, $E;
function VT() {
  if ($E) return j0;
  $E = 1;
  var e = Math.ceil, r = Math.floor;
  return j0 = Math.trunc || function(a) {
    var o = +a;
    return (o > 0 ? r : e)(o);
  }, j0;
}
var z0, GE;
function fi() {
  if (GE) return z0;
  GE = 1;
  var e = VT();
  return z0 = function(r) {
    var t = +r;
    return t !== t || t === 0 ? 0 : e(t);
  }, z0;
}
var q0, ZE;
function tc() {
  if (ZE) return q0;
  ZE = 1;
  var e = fi(), r = Math.max, t = Math.min;
  return q0 = function(a, o) {
    var l = e(a);
    return l < 0 ? r(l + o, 0) : t(l, o);
  }, q0;
}
var W0, jE;
function xo() {
  if (jE) return W0;
  jE = 1;
  var e = fi(), r = Math.min;
  return W0 = function(t) {
    var a = e(t);
    return a > 0 ? r(a, 9007199254740991) : 0;
  }, W0;
}
var Y0, zE;
function tn() {
  if (zE) return Y0;
  zE = 1;
  var e = xo();
  return Y0 = function(r) {
    return e(r.length);
  }, Y0;
}
var K0, qE;
function kT() {
  if (qE) return K0;
  qE = 1;
  var e = js(), r = tc(), t = tn(), a = function(o) {
    return function(l, c, f) {
      var p = e(l), u = t(p);
      if (u === 0) return !o && -1;
      var h = r(f, u), C;
      if (o && c !== c) {
        for (; u > h; )
          if (C = p[h++], C !== C) return !0;
      } else for (; u > h; h++)
        if ((o || h in p) && p[h] === c) return o || h || 0;
      return !o && -1;
    };
  };
  return K0 = {
    // `Array.prototype.includes` method
    // https://tc39.es/ecma262/#sec-array.prototype.includes
    includes: a(!0),
    // `Array.prototype.indexOf` method
    // https://tc39.es/ecma262/#sec-array.prototype.indexof
    indexOf: a(!1)
  }, K0;
}
var X0, WE;
function Yp() {
  return WE || (WE = 1, X0 = {}), X0;
}
var Q0, YE;
function Yg() {
  if (YE) return Q0;
  YE = 1;
  var e = vt(), r = kr(), t = js(), a = kT().indexOf, o = Yp(), l = e([].push);
  return Q0 = function(c, f) {
    var p = t(c), u = 0, h = [], C;
    for (C in p) !r(o, C) && r(p, C) && l(h, C);
    for (; f.length > u; ) r(p, C = f[u++]) && (~a(h, C) || l(h, C));
    return h;
  }, Q0;
}
var J0, KE;
function Kp() {
  return KE || (KE = 1, J0 = [
    "constructor",
    "hasOwnProperty",
    "isPrototypeOf",
    "propertyIsEnumerable",
    "toLocaleString",
    "toString",
    "valueOf"
  ]), J0;
}
var e3, XE;
function Kg() {
  if (XE) return e3;
  XE = 1;
  var e = Yg(), r = Kp();
  return e3 = Object.keys || function(a) {
    return e(a, r);
  }, e3;
}
var QE;
function FT() {
  if (QE) return L0;
  QE = 1;
  var e = jt(), r = zg(), t = Wn(), a = or(), o = js(), l = Kg();
  return L0.f = e && !r ? Object.defineProperties : function(f, p) {
    a(f);
    for (var u = o(p), h = l(p), C = h.length, E = 0, _; C > E; ) t.f(f, _ = h[E++], u[_]);
    return f;
  }, L0;
}
var t3, JE;
function xT() {
  if (JE) return t3;
  JE = 1;
  var e = oa();
  return t3 = e("document", "documentElement"), t3;
}
var r3, e4;
function Xp() {
  if (e4) return r3;
  e4 = 1;
  var e = jp(), r = zp(), t = e("keys");
  return r3 = function(a) {
    return t[a] || (t[a] = r(a));
  }, r3;
}
var n3, t4;
function Ua() {
  if (t4) return n3;
  t4 = 1;
  var e = or(), r = FT(), t = Kp(), a = Yp(), o = xT(), l = Bp(), c = Xp(), f = ">", p = "<", u = "prototype", h = "script", C = c("IE_PROTO"), E = function() {
  }, _ = function(R) {
    return p + h + f + R + p + "/" + h + f;
  }, S = function(R) {
    R.write(_("")), R.close();
    var D = R.parentWindow.Object;
    return R = null, D;
  }, v = function() {
    var R = l("iframe"), D = "java" + h + ":", T;
    return R.style.display = "none", o.appendChild(R), R.src = String(D), T = R.contentWindow.document, T.open(), T.write(_("document.F=Object")), T.close(), T.F;
  }, g, O = function() {
    try {
      g = new ActiveXObject("htmlfile");
    } catch (D) {
    }
    O = typeof document != "undefined" ? document.domain && g ? S(g) : v() : S(g);
    for (var R = t.length; R--; ) delete O[u][t[R]];
    return O();
  };
  return a[C] = !0, n3 = Object.create || function(D, T) {
    var L;
    return D !== null ? (E[u] = e(D), L = new E(), E[u] = null, L[C] = D) : L = O(), T === void 0 ? L : r.f(L, T);
  }, n3;
}
var i3, r4;
function UT() {
  if (r4) return i3;
  r4 = 1;
  var e = cr(), r = Ua(), t = Wn().f, a = e("unscopables"), o = Array.prototype;
  return o[a] === void 0 && t(o, a, {
    configurable: !0,
    value: r(null)
  }), i3 = function(l) {
    o[a][l] = !0;
  }, i3;
}
var a3, n4;
function Ws() {
  return n4 || (n4 = 1, a3 = {}), a3;
}
var o3, i4;
function BT() {
  if (i4) return o3;
  i4 = 1;
  var e = It(), r = Xt(), t = e.WeakMap;
  return o3 = r(t) && /native code/.test(String(t)), o3;
}
var s3, a4;
function Ba() {
  return a4 || (a4 = 1, s3 = function(e, r) {
    return {
      enumerable: !(e & 1),
      configurable: !(e & 2),
      writable: !(e & 4),
      value: r
    };
  }), s3;
}
var l3, o4;
function yn() {
  if (o4) return l3;
  o4 = 1;
  var e = jt(), r = Wn(), t = Ba();
  return l3 = e ? function(a, o, l) {
    return r.f(a, o, t(1, l));
  } : function(a, o, l) {
    return a[o] = l, a;
  }, l3;
}
var c3, s4;
function di() {
  if (s4) return c3;
  s4 = 1;
  var e = BT(), r = It(), t = Vr(), a = yn(), o = kr(), l = Zp(), c = Xp(), f = Yp(), p = "Object already initialized", u = r.TypeError, h = r.WeakMap, C, E, _, S = function(R) {
    return _(R) ? E(R) : C(R, {});
  }, v = function(R) {
    return function(D) {
      var T;
      if (!t(D) || (T = E(D)).type !== R)
        throw new u("Incompatible receiver, " + R + " required");
      return T;
    };
  };
  if (e || l.state) {
    var g = l.state || (l.state = new h());
    g.get = g.get, g.has = g.has, g.set = g.set, C = function(R, D) {
      if (g.has(R)) throw new u(p);
      return D.facade = R, g.set(R, D), D;
    }, E = function(R) {
      return g.get(R) || {};
    }, _ = function(R) {
      return g.has(R);
    };
  } else {
    var O = c("state");
    f[O] = !0, C = function(R, D) {
      if (o(R, O)) throw new u(p);
      return D.facade = R, a(R, O, D), D;
    }, E = function(R) {
      return o(R, O) ? R[O] : {};
    }, _ = function(R) {
      return o(R, O);
    };
  }
  return c3 = {
    set: C,
    get: E,
    has: _,
    enforce: S,
    getterFor: v
  }, c3;
}
var u3 = {}, f3 = {}, l4;
function Xg() {
  if (l4) return f3;
  l4 = 1;
  var e = {}.propertyIsEnumerable, r = Object.getOwnPropertyDescriptor, t = r && !e.call({ 1: 2 }, 1);
  return f3.f = t ? function(o) {
    var l = r(this, o);
    return !!l && l.enumerable;
  } : e, f3;
}
var c4;
function Qp() {
  if (c4) return u3;
  c4 = 1;
  var e = jt(), r = Mt(), t = Xg(), a = Ba(), o = js(), l = Wp(), c = kr(), f = qg(), p = Object.getOwnPropertyDescriptor;
  return u3.f = e ? p : function(h, C) {
    if (h = o(h), C = l(C), f) try {
      return p(h, C);
    } catch (E) {
    }
    if (c(h, C)) return a(!r(t.f, h, C), h[C]);
  }, u3;
}
var d3 = { exports: {} }, p3, u4;
function rc() {
  if (u4) return p3;
  u4 = 1;
  var e = jt(), r = kr(), t = Function.prototype, a = e && Object.getOwnPropertyDescriptor, o = r(t, "name"), l = o && function() {
  }.name === "something", c = o && (!e || e && a(t, "name").configurable);
  return p3 = {
    EXISTS: o,
    PROPER: l,
    CONFIGURABLE: c
  }, p3;
}
var h3, f4;
function Qg() {
  if (f4) return h3;
  f4 = 1;
  var e = vt(), r = Xt(), t = Zp(), a = e(Function.toString);
  return r(t.inspectSource) || (t.inspectSource = function(o) {
    return a(o);
  }), h3 = t.inspectSource, h3;
}
var d4;
function Jg() {
  if (d4) return d3.exports;
  d4 = 1;
  var e = vt(), r = gt(), t = Xt(), a = kr(), o = jt(), l = rc().CONFIGURABLE, c = Qg(), f = di(), p = f.enforce, u = f.get, h = String, C = Object.defineProperty, E = e("".slice), _ = e("".replace), S = e([].join), v = o && !r(function() {
    return C(function() {
    }, "length", { value: 8 }).length !== 8;
  }), g = String(String).split("String"), O = d3.exports = function(R, D, T) {
    E(h(D), 0, 7) === "Symbol(" && (D = "[" + _(h(D), /^Symbol\(([^)]*)\).*$/, "$1") + "]"), T && T.getter && (D = "get " + D), T && T.setter && (D = "set " + D), (!a(R, "name") || l && R.name !== D) && (o ? C(R, "name", { value: D, configurable: !0 }) : R.name = D), v && T && a(T, "arity") && R.length !== T.arity && C(R, "length", { value: T.arity });
    try {
      T && a(T, "constructor") && T.constructor ? o && C(R, "prototype", { writable: !1 }) : R.prototype && (R.prototype = void 0);
    } catch (P) {
    }
    var L = p(R);
    return a(L, "source") || (L.source = S(g, typeof D == "string" ? D : "")), R;
  };
  return Function.prototype.toString = O(function() {
    return t(this) && u(this).source || c(this);
  }, "toString"), d3.exports;
}
var m3, p4;
function pi() {
  if (p4) return m3;
  p4 = 1;
  var e = Xt(), r = Wn(), t = Jg(), a = Gp();
  return m3 = function(o, l, c, f) {
    f || (f = {});
    var p = f.enumerable, u = f.name !== void 0 ? f.name : l;
    if (e(c) && t(c, u, f), f.global)
      p ? o[l] = c : a(l, c);
    else {
      try {
        f.unsafe ? o[l] && (p = !0) : delete o[l];
      } catch (h) {
      }
      p ? o[l] = c : r.f(o, l, {
        value: c,
        enumerable: !1,
        configurable: !f.nonConfigurable,
        writable: !f.nonWritable
      });
    }
    return o;
  }, m3;
}
var _3 = {}, h4;
function e8() {
  if (h4) return _3;
  h4 = 1;
  var e = Yg(), r = Kp(), t = r.concat("length", "prototype");
  return _3.f = Object.getOwnPropertyNames || function(o) {
    return e(o, t);
  }, _3;
}
var E3 = {}, m4;
function t8() {
  return m4 || (m4 = 1, E3.f = Object.getOwnPropertySymbols), E3;
}
var C3, _4;
function $T() {
  if (_4) return C3;
  _4 = 1;
  var e = oa(), r = vt(), t = e8(), a = t8(), o = or(), l = r([].concat);
  return C3 = e("Reflect", "ownKeys") || function(f) {
    var p = t.f(o(f)), u = a.f;
    return u ? l(p, u(f)) : p;
  }, C3;
}
var S3, E4;
function Jp() {
  if (E4) return S3;
  E4 = 1;
  var e = kr(), r = $T(), t = Qp(), a = Wn();
  return S3 = function(o, l, c) {
    for (var f = r(l), p = a.f, u = t.f, h = 0; h < f.length; h++) {
      var C = f[h];
      !e(o, C) && !(c && e(c, C)) && p(o, C, u(l, C));
    }
  }, S3;
}
var I3, C4;
function GT() {
  if (C4) return I3;
  C4 = 1;
  var e = gt(), r = Xt(), t = /#|\.prototype\./, a = function(p, u) {
    var h = l[o(p)];
    return h === f ? !0 : h === c ? !1 : r(u) ? e(u) : !!u;
  }, o = a.normalize = function(p) {
    return String(p).replace(t, ".").toLowerCase();
  }, l = a.data = {}, c = a.NATIVE = "N", f = a.POLYFILL = "P";
  return I3 = a, I3;
}
var v3, S4;
function zt() {
  if (S4) return v3;
  S4 = 1;
  var e = It(), r = Qp().f, t = yn(), a = pi(), o = Gp(), l = Jp(), c = GT();
  return v3 = function(f, p) {
    var u = f.target, h = f.global, C = f.stat, E, _, S, v, g, O;
    if (h ? _ = e : C ? _ = e[u] || o(u, {}) : _ = e[u] && e[u].prototype, _) for (S in p) {
      if (g = p[S], f.dontCallGetSet ? (O = r(_, S), v = O && O.value) : v = _[S], E = c(h ? S : u + (C ? "." : "#") + S, f.forced), !E && v !== void 0) {
        if (typeof g == typeof v) continue;
        l(g, v);
      }
      (f.sham || v && v.sham) && t(g, "sham", !0), a(_, S, g, f);
    }
  }, v3;
}
var g3, I4;
function ZT() {
  if (I4) return g3;
  I4 = 1;
  var e = gt();
  return g3 = !e(function() {
    function r() {
    }
    return r.prototype.constructor = null, Object.getPrototypeOf(new r()) !== r.prototype;
  }), g3;
}
var D3, v4;
function Ys() {
  if (v4) return D3;
  v4 = 1;
  var e = kr(), r = Xt(), t = On(), a = Xp(), o = ZT(), l = a("IE_PROTO"), c = Object, f = c.prototype;
  return D3 = o ? c.getPrototypeOf : function(p) {
    var u = t(p);
    if (e(u, l)) return u[l];
    var h = u.constructor;
    return r(h) && u instanceof h ? h.prototype : u instanceof c ? f : null;
  }, D3;
}
var R3, g4;
function nc() {
  if (g4) return R3;
  g4 = 1;
  var e = gt(), r = Xt(), t = Vr(), a = Ua(), o = Ys(), l = pi(), c = cr(), f = bi(), p = c("iterator"), u = !1, h, C, E;
  [].keys && (E = [].keys(), "next" in E ? (C = o(o(E)), C !== Object.prototype && (h = C)) : u = !0);
  var _ = !t(h) || e(function() {
    var S = {};
    return h[p].call(S) !== S;
  });
  return _ ? h = {} : f && (h = a(h)), r(h[p]) || l(h, p, function() {
    return this;
  }), R3 = {
    IteratorPrototype: h,
    BUGGY_SAFARI_ITERATORS: u
  }, R3;
}
var A3, D4;
function Uo() {
  if (D4) return A3;
  D4 = 1;
  var e = Wn().f, r = kr(), t = cr(), a = t("toStringTag");
  return A3 = function(o, l, c) {
    o && !c && (o = o.prototype), o && !r(o, a) && e(o, a, { configurable: !0, value: l });
  }, A3;
}
var T3, R4;
function r8() {
  if (R4) return T3;
  R4 = 1;
  var e = nc().IteratorPrototype, r = Ua(), t = Ba(), a = Uo(), o = Ws(), l = function() {
    return this;
  };
  return T3 = function(c, f, p, u) {
    var h = f + " Iterator";
    return c.prototype = r(e, { next: t(+!u, p) }), a(c, h, !1, !0), o[h] = l, c;
  }, T3;
}
var O3, A4;
function eh() {
  if (A4) return O3;
  A4 = 1;
  var e = vt(), r = en();
  return O3 = function(t, a, o) {
    try {
      return e(r(Object.getOwnPropertyDescriptor(t, a)[o]));
    } catch (l) {
    }
  }, O3;
}
var y3, T4;
function jT() {
  if (T4) return y3;
  T4 = 1;
  var e = Vr();
  return y3 = function(r) {
    return e(r) || r === null;
  }, y3;
}
var N3, O4;
function zT() {
  if (O4) return N3;
  O4 = 1;
  var e = jT(), r = String, t = TypeError;
  return N3 = function(a) {
    if (e(a)) return a;
    throw new t("Can't set " + r(a) + " as a prototype");
  }, N3;
}
var L3, y4;
function Bo() {
  if (y4) return L3;
  y4 = 1;
  var e = eh(), r = Vr(), t = ko(), a = zT();
  return L3 = Object.setPrototypeOf || ("__proto__" in {} ? function() {
    var o = !1, l = {}, c;
    try {
      c = e(Object.prototype, "__proto__", "set"), c(l, []), o = l instanceof Array;
    } catch (f) {
    }
    return function(p, u) {
      return t(p), a(u), r(p) && (o ? c(p, u) : p.__proto__ = u), p;
    };
  }() : void 0), L3;
}
var M3, N4;
function n8() {
  if (N4) return M3;
  N4 = 1;
  var e = zt(), r = Mt(), t = bi(), a = rc(), o = Xt(), l = r8(), c = Ys(), f = Bo(), p = Uo(), u = yn(), h = pi(), C = cr(), E = Ws(), _ = nc(), S = a.PROPER, v = a.CONFIGURABLE, g = _.IteratorPrototype, O = _.BUGGY_SAFARI_ITERATORS, R = C("iterator"), D = "keys", T = "values", L = "entries", P = function() {
    return this;
  };
  return M3 = function(M, k, H, w, $, B, Y) {
    l(H, k, w);
    var j = function(ue) {
      if (ue === $ && X) return X;
      if (!O && ue && ue in le) return le[ue];
      switch (ue) {
        case D:
          return function() {
            return new H(this, ue);
          };
        case T:
          return function() {
            return new H(this, ue);
          };
        case L:
          return function() {
            return new H(this, ue);
          };
      }
      return function() {
        return new H(this);
      };
    }, ie = k + " Iterator", se = !1, le = M.prototype, U = le[R] || le["@@iterator"] || $ && le[$], X = !O && U || j($), K = k === "Array" && le.entries || U, y, G, ce;
    if (K && (y = c(K.call(new M())), y !== Object.prototype && y.next && (!t && c(y) !== g && (f ? f(y, g) : o(y[R]) || h(y, R, P)), p(y, ie, !0, !0), t && (E[ie] = P))), S && $ === T && U && U.name !== T && (!t && v ? u(le, "name", T) : (se = !0, X = function() {
      return r(U, this);
    })), $)
      if (G = {
        values: j(T),
        keys: B ? X : j(D),
        entries: j(L)
      }, Y) for (ce in G)
        (O || se || !(ce in le)) && h(le, ce, G[ce]);
      else e({ target: k, proto: !0, forced: O || se }, G);
    return (!t || Y) && le[R] !== X && h(le, R, X, { name: $ }), E[k] = X, G;
  }, M3;
}
var b3, L4;
function ic() {
  return L4 || (L4 = 1, b3 = function(e, r) {
    return { value: e, done: r };
  }), b3;
}
var P3, M4;
function i8() {
  if (M4) return P3;
  M4 = 1;
  var e = js(), r = UT(), t = Ws(), a = di(), o = Wn().f, l = n8(), c = ic(), f = bi(), p = jt(), u = "Array Iterator", h = a.set, C = a.getterFor(u);
  P3 = l(Array, "Array", function(_, S) {
    h(this, {
      type: u,
      target: e(_),
      // target
      index: 0,
      // next index
      kind: S
      // kind
    });
  }, function() {
    var _ = C(this), S = _.target, v = _.index++;
    if (!S || v >= S.length)
      return _.target = null, c(void 0, !0);
    switch (_.kind) {
      case "keys":
        return c(v, !1);
      case "values":
        return c(S[v], !1);
    }
    return c([v, S[v]], !1);
  }, "values");
  var E = t.Arguments = t.Array;
  if (r("keys"), r("values"), r("entries"), !f && p && E.name !== "values") try {
    o(E, "name", { value: "values" });
  } catch (_) {
  }
  return P3;
}
var b4;
function qT() {
  if (b4) return eE;
  b4 = 1;
  var e = It(), r = PT(), t = wT(), a = i8(), o = yn(), l = Uo(), c = cr(), f = c("iterator"), p = a.values, u = function(C, E) {
    if (C) {
      if (C[f] !== p) try {
        o(C, f, p);
      } catch (S) {
        C[f] = p;
      }
      if (l(C, E, !0), r[E]) {
        for (var _ in a)
          if (C[_] !== a[_]) try {
            o(C, _, a[_]);
          } catch (S) {
            C[_] = a[_];
          }
      }
    }
  };
  for (var h in r)
    u(e[h] && e[h].prototype, h);
  return u(t, "DOMTokenList"), eE;
}
qT();
var w3 = { exports: {} }, Ts = {}, H3 = { exports: {} }, mt = {}, P4;
function WT() {
  if (P4) return mt;
  P4 = 1;
  /**
   * @license React
   * react.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var e = Symbol.for("react.element"), r = Symbol.for("react.portal"), t = Symbol.for("react.fragment"), a = Symbol.for("react.strict_mode"), o = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), c = Symbol.for("react.context"), f = Symbol.for("react.forward_ref"), p = Symbol.for("react.suspense"), u = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), C = Symbol.iterator;
  function E(y) {
    return y === null || typeof y != "object" ? null : (y = C && y[C] || y["@@iterator"], typeof y == "function" ? y : null);
  }
  var _ = { isMounted: function() {
    return !1;
  }, enqueueForceUpdate: function() {
  }, enqueueReplaceState: function() {
  }, enqueueSetState: function() {
  } }, S = Object.assign, v = {};
  function g(y, G, ce) {
    this.props = y, this.context = G, this.refs = v, this.updater = ce || _;
  }
  g.prototype.isReactComponent = {}, g.prototype.setState = function(y, G) {
    if (typeof y != "object" && typeof y != "function" && y != null) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, y, G, "setState");
  }, g.prototype.forceUpdate = function(y) {
    this.updater.enqueueForceUpdate(this, y, "forceUpdate");
  };
  function O() {
  }
  O.prototype = g.prototype;
  function R(y, G, ce) {
    this.props = y, this.context = G, this.refs = v, this.updater = ce || _;
  }
  var D = R.prototype = new O();
  D.constructor = R, S(D, g.prototype), D.isPureReactComponent = !0;
  var T = Array.isArray, L = Object.prototype.hasOwnProperty, P = { current: null }, M = { key: !0, ref: !0, __self: !0, __source: !0 };
  function k(y, G, ce) {
    var ue, ee = {}, ge = null, Oe = null;
    if (G != null) for (ue in G.ref !== void 0 && (Oe = G.ref), G.key !== void 0 && (ge = "" + G.key), G) L.call(G, ue) && !M.hasOwnProperty(ue) && (ee[ue] = G[ue]);
    var Se = arguments.length - 2;
    if (Se === 1) ee.children = ce;
    else if (1 < Se) {
      for (var Ne = Array(Se), Le = 0; Le < Se; Le++) Ne[Le] = arguments[Le + 2];
      ee.children = Ne;
    }
    if (y && y.defaultProps) for (ue in Se = y.defaultProps, Se) ee[ue] === void 0 && (ee[ue] = Se[ue]);
    return { $$typeof: e, type: y, key: ge, ref: Oe, props: ee, _owner: P.current };
  }
  function H(y, G) {
    return { $$typeof: e, type: y.type, key: G, ref: y.ref, props: y.props, _owner: y._owner };
  }
  function w(y) {
    return typeof y == "object" && y !== null && y.$$typeof === e;
  }
  function $(y) {
    var G = { "=": "=0", ":": "=2" };
    return "$" + y.replace(/[=:]/g, function(ce) {
      return G[ce];
    });
  }
  var B = /\/+/g;
  function Y(y, G) {
    return typeof y == "object" && y !== null && y.key != null ? $("" + y.key) : G.toString(36);
  }
  function j(y, G, ce, ue, ee) {
    var ge = typeof y;
    (ge === "undefined" || ge === "boolean") && (y = null);
    var Oe = !1;
    if (y === null) Oe = !0;
    else switch (ge) {
      case "string":
      case "number":
        Oe = !0;
        break;
      case "object":
        switch (y.$$typeof) {
          case e:
          case r:
            Oe = !0;
        }
    }
    if (Oe) return Oe = y, ee = ee(Oe), y = ue === "" ? "." + Y(Oe, 0) : ue, T(ee) ? (ce = "", y != null && (ce = y.replace(B, "$&/") + "/"), j(ee, G, ce, "", function(Le) {
      return Le;
    })) : ee != null && (w(ee) && (ee = H(ee, ce + (!ee.key || Oe && Oe.key === ee.key ? "" : ("" + ee.key).replace(B, "$&/") + "/") + y)), G.push(ee)), 1;
    if (Oe = 0, ue = ue === "" ? "." : ue + ":", T(y)) for (var Se = 0; Se < y.length; Se++) {
      ge = y[Se];
      var Ne = ue + Y(ge, Se);
      Oe += j(ge, G, ce, Ne, ee);
    }
    else if (Ne = E(y), typeof Ne == "function") for (y = Ne.call(y), Se = 0; !(ge = y.next()).done; ) ge = ge.value, Ne = ue + Y(ge, Se++), Oe += j(ge, G, ce, Ne, ee);
    else if (ge === "object") throw G = String(y), Error("Objects are not valid as a React child (found: " + (G === "[object Object]" ? "object with keys {" + Object.keys(y).join(", ") + "}" : G) + "). If you meant to render a collection of children, use an array instead.");
    return Oe;
  }
  function ie(y, G, ce) {
    if (y == null) return y;
    var ue = [], ee = 0;
    return j(y, ue, "", "", function(ge) {
      return G.call(ce, ge, ee++);
    }), ue;
  }
  function se(y) {
    if (y._status === -1) {
      var G = y._result;
      G = G(), G.then(function(ce) {
        (y._status === 0 || y._status === -1) && (y._status = 1, y._result = ce);
      }, function(ce) {
        (y._status === 0 || y._status === -1) && (y._status = 2, y._result = ce);
      }), y._status === -1 && (y._status = 0, y._result = G);
    }
    if (y._status === 1) return y._result.default;
    throw y._result;
  }
  var le = { current: null }, U = { transition: null }, X = { ReactCurrentDispatcher: le, ReactCurrentBatchConfig: U, ReactCurrentOwner: P };
  function K() {
    throw Error("act(...) is not supported in production builds of React.");
  }
  return mt.Children = { map: ie, forEach: function(y, G, ce) {
    ie(y, function() {
      G.apply(this, arguments);
    }, ce);
  }, count: function(y) {
    var G = 0;
    return ie(y, function() {
      G++;
    }), G;
  }, toArray: function(y) {
    return ie(y, function(G) {
      return G;
    }) || [];
  }, only: function(y) {
    if (!w(y)) throw Error("React.Children.only expected to receive a single React element child.");
    return y;
  } }, mt.Component = g, mt.Fragment = t, mt.Profiler = o, mt.PureComponent = R, mt.StrictMode = a, mt.Suspense = p, mt.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = X, mt.act = K, mt.cloneElement = function(y, G, ce) {
    if (y == null) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + y + ".");
    var ue = S({}, y.props), ee = y.key, ge = y.ref, Oe = y._owner;
    if (G != null) {
      if (G.ref !== void 0 && (ge = G.ref, Oe = P.current), G.key !== void 0 && (ee = "" + G.key), y.type && y.type.defaultProps) var Se = y.type.defaultProps;
      for (Ne in G) L.call(G, Ne) && !M.hasOwnProperty(Ne) && (ue[Ne] = G[Ne] === void 0 && Se !== void 0 ? Se[Ne] : G[Ne]);
    }
    var Ne = arguments.length - 2;
    if (Ne === 1) ue.children = ce;
    else if (1 < Ne) {
      Se = Array(Ne);
      for (var Le = 0; Le < Ne; Le++) Se[Le] = arguments[Le + 2];
      ue.children = Se;
    }
    return { $$typeof: e, type: y.type, key: ee, ref: ge, props: ue, _owner: Oe };
  }, mt.createContext = function(y) {
    return y = { $$typeof: c, _currentValue: y, _currentValue2: y, _threadCount: 0, Provider: null, Consumer: null, _defaultValue: null, _globalName: null }, y.Provider = { $$typeof: l, _context: y }, y.Consumer = y;
  }, mt.createElement = k, mt.createFactory = function(y) {
    var G = k.bind(null, y);
    return G.type = y, G;
  }, mt.createRef = function() {
    return { current: null };
  }, mt.forwardRef = function(y) {
    return { $$typeof: f, render: y };
  }, mt.isValidElement = w, mt.lazy = function(y) {
    return { $$typeof: h, _payload: { _status: -1, _result: y }, _init: se };
  }, mt.memo = function(y, G) {
    return { $$typeof: u, type: y, compare: G === void 0 ? null : G };
  }, mt.startTransition = function(y) {
    var G = U.transition;
    U.transition = {};
    try {
      y();
    } finally {
      U.transition = G;
    }
  }, mt.unstable_act = K, mt.useCallback = function(y, G) {
    return le.current.useCallback(y, G);
  }, mt.useContext = function(y) {
    return le.current.useContext(y);
  }, mt.useDebugValue = function() {
  }, mt.useDeferredValue = function(y) {
    return le.current.useDeferredValue(y);
  }, mt.useEffect = function(y, G) {
    return le.current.useEffect(y, G);
  }, mt.useId = function() {
    return le.current.useId();
  }, mt.useImperativeHandle = function(y, G, ce) {
    return le.current.useImperativeHandle(y, G, ce);
  }, mt.useInsertionEffect = function(y, G) {
    return le.current.useInsertionEffect(y, G);
  }, mt.useLayoutEffect = function(y, G) {
    return le.current.useLayoutEffect(y, G);
  }, mt.useMemo = function(y, G) {
    return le.current.useMemo(y, G);
  }, mt.useReducer = function(y, G, ce) {
    return le.current.useReducer(y, G, ce);
  }, mt.useRef = function(y) {
    return le.current.useRef(y);
  }, mt.useState = function(y) {
    return le.current.useState(y);
  }, mt.useSyncExternalStore = function(y, G, ce) {
    return le.current.useSyncExternalStore(y, G, ce);
  }, mt.useTransition = function() {
    return le.current.useTransition();
  }, mt.version = "18.3.1", mt;
}
var w4;
function Ks() {
  return w4 || (w4 = 1, H3.exports = WT()), H3.exports;
}
var H4;
function YT() {
  if (H4) return Ts;
  H4 = 1;
  /**
   * @license React
   * react-jsx-runtime.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var e = Ks(), r = Symbol.for("react.element"), t = Symbol.for("react.fragment"), a = Object.prototype.hasOwnProperty, o = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, l = { key: !0, ref: !0, __self: !0, __source: !0 };
  function c(f, p, u) {
    var h, C = {}, E = null, _ = null;
    u !== void 0 && (E = "" + u), p.key !== void 0 && (E = "" + p.key), p.ref !== void 0 && (_ = p.ref);
    for (h in p) a.call(p, h) && !l.hasOwnProperty(h) && (C[h] = p[h]);
    if (f && f.defaultProps) for (h in p = f.defaultProps, p) C[h] === void 0 && (C[h] = p[h]);
    return { $$typeof: r, type: f, key: E, ref: _, props: C, _owner: o.current };
  }
  return Ts.Fragment = t, Ts.jsx = c, Ts.jsxs = c, Ts;
}
var V4;
function KT() {
  return V4 || (V4 = 1, w3.exports = YT()), w3.exports;
}
var Z = KT(), k4 = {}, V3, F4;
function ac() {
  if (F4) return V3;
  F4 = 1;
  var e = Xl(), r = Function.prototype, t = r.apply, a = r.call;
  return V3 = typeof Reflect == "object" && Reflect.apply || (e ? a.bind(t) : function() {
    return a.apply(t, arguments);
  }), V3;
}
var k3, x4;
function XT() {
  if (x4) return k3;
  x4 = 1;
  var e = Wn().f;
  return k3 = function(r, t, a) {
    a in r || e(r, a, {
      configurable: !0,
      get: function() {
        return t[a];
      },
      set: function(o) {
        t[a] = o;
      }
    });
  }, k3;
}
var F3, U4;
function th() {
  if (U4) return F3;
  U4 = 1;
  var e = Xt(), r = Vr(), t = Bo();
  return F3 = function(a, o, l) {
    var c, f;
    return (
      // it can work only with native `setPrototypeOf`
      t && // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
      e(c = o.constructor) && c !== l && r(f = c.prototype) && f !== l.prototype && t(a, f), a
    );
  }, F3;
}
var x3, B4;
function QT() {
  if (B4) return x3;
  B4 = 1;
  var e = cr(), r = e("toStringTag"), t = {};
  return t[r] = "z", x3 = String(t) === "[object z]", x3;
}
var U3, $4;
function sa() {
  if ($4) return U3;
  $4 = 1;
  var e = QT(), r = Xt(), t = aa(), a = cr(), o = a("toStringTag"), l = Object, c = t(/* @__PURE__ */ function() {
    return arguments;
  }()) === "Arguments", f = function(p, u) {
    try {
      return p[u];
    } catch (h) {
    }
  };
  return U3 = e ? t : function(p) {
    var u, h, C;
    return p === void 0 ? "Undefined" : p === null ? "Null" : typeof (h = f(u = l(p), o)) == "string" ? h : c ? t(u) : (C = t(u)) === "Object" && r(u.callee) ? "Arguments" : C;
  }, U3;
}
var B3, G4;
function Nn() {
  if (G4) return B3;
  G4 = 1;
  var e = sa(), r = String;
  return B3 = function(t) {
    if (e(t) === "Symbol") throw new TypeError("Cannot convert a Symbol value to a string");
    return r(t);
  }, B3;
}
var $3, Z4;
function JT() {
  if (Z4) return $3;
  Z4 = 1;
  var e = Nn();
  return $3 = function(r, t) {
    return r === void 0 ? arguments.length < 2 ? "" : t : e(r);
  }, $3;
}
var G3, j4;
function e9() {
  if (j4) return G3;
  j4 = 1;
  var e = Vr(), r = yn();
  return G3 = function(t, a) {
    e(a) && "cause" in a && r(t, "cause", a.cause);
  }, G3;
}
var Z3, z4;
function t9() {
  if (z4) return Z3;
  z4 = 1;
  var e = vt(), r = Error, t = e("".replace), a = function(c) {
    return String(new r(c).stack);
  }("zxcasd"), o = /\n\s*at [^:]*:[^\n]*/, l = o.test(a);
  return Z3 = function(c, f) {
    if (l && typeof c == "string" && !r.prepareStackTrace)
      for (; f--; ) c = t(c, o, "");
    return c;
  }, Z3;
}
var j3, q4;
function r9() {
  if (q4) return j3;
  q4 = 1;
  var e = gt(), r = Ba();
  return j3 = !e(function() {
    var t = new Error("a");
    return "stack" in t ? (Object.defineProperty(t, "stack", r(1, 7)), t.stack !== 7) : !0;
  }), j3;
}
var z3, W4;
function n9() {
  if (W4) return z3;
  W4 = 1;
  var e = yn(), r = t9(), t = r9(), a = Error.captureStackTrace;
  return z3 = function(o, l, c, f) {
    t && (a ? a(o, l) : e(o, "stack", r(c, f)));
  }, z3;
}
var q3, Y4;
function i9() {
  if (Y4) return q3;
  Y4 = 1;
  var e = oa(), r = kr(), t = yn(), a = xa(), o = Bo(), l = Jp(), c = XT(), f = th(), p = JT(), u = e9(), h = n9(), C = jt(), E = bi();
  return q3 = function(_, S, v, g) {
    var O = "stackTraceLimit", R = g ? 2 : 1, D = _.split("."), T = D[D.length - 1], L = e.apply(null, D);
    if (L) {
      var P = L.prototype;
      if (!E && r(P, "cause") && delete P.cause, !v) return L;
      var M = e("Error"), k = S(function(H, w) {
        var $ = p(g ? w : H, void 0), B = g ? new L(H) : new L();
        return $ !== void 0 && t(B, "message", $), h(B, k, B.stack, 2), this && a(P, this) && f(B, this, k), arguments.length > R && u(B, arguments[R]), B;
      });
      if (k.prototype = P, T !== "Error" ? o ? o(k, M) : l(k, M, { name: !0 }) : C && O in L && (c(k, L, O), c(k, L, "prepareStackTrace")), l(k, L), !E) try {
        P.name !== T && t(P, "name", T), P.constructor = k;
      } catch (H) {
      }
      return k;
    }
  }, q3;
}
var K4;
function a9() {
  if (K4) return k4;
  K4 = 1;
  var e = zt(), r = It(), t = ac(), a = i9(), o = "WebAssembly", l = r[o], c = new Error("e", { cause: 7 }).cause !== 7, f = function(u, h) {
    var C = {};
    C[u] = a(u, h, c), e({ global: !0, constructor: !0, arity: 1, forced: c }, C);
  }, p = function(u, h) {
    if (l && l[u]) {
      var C = {};
      C[u] = a(o + "." + u, h, c), e({ target: o, stat: !0, constructor: !0, arity: 1, forced: c }, C);
    }
  };
  return f("Error", function(u) {
    return function(C) {
      return t(u, this, arguments);
    };
  }), f("EvalError", function(u) {
    return function(C) {
      return t(u, this, arguments);
    };
  }), f("RangeError", function(u) {
    return function(C) {
      return t(u, this, arguments);
    };
  }), f("ReferenceError", function(u) {
    return function(C) {
      return t(u, this, arguments);
    };
  }), f("SyntaxError", function(u) {
    return function(C) {
      return t(u, this, arguments);
    };
  }), f("TypeError", function(u) {
    return function(C) {
      return t(u, this, arguments);
    };
  }), f("URIError", function(u) {
    return function(C) {
      return t(u, this, arguments);
    };
  }), p("CompileError", function(u) {
    return function(C) {
      return t(u, this, arguments);
    };
  }), p("LinkError", function(u) {
    return function(C) {
      return t(u, this, arguments);
    };
  }), p("RuntimeError", function(u) {
    return function(C) {
      return t(u, this, arguments);
    };
  }), k4;
}
a9();
var X4 = {}, W3, Q4;
function oc() {
  if (Q4) return W3;
  Q4 = 1;
  var e = vt();
  return W3 = e([].slice), W3;
}
var Y3, J4;
function rh() {
  if (J4) return Y3;
  J4 = 1;
  var e = aa();
  return Y3 = Array.isArray || function(t) {
    return e(t) === "Array";
  }, Y3;
}
var K3, e6;
function o9() {
  if (e6) return K3;
  e6 = 1;
  var e = vt(), r = rh(), t = Xt(), a = aa(), o = Nn(), l = e([].push);
  return K3 = function(c) {
    if (t(c)) return c;
    if (r(c)) {
      for (var f = c.length, p = [], u = 0; u < f; u++) {
        var h = c[u];
        typeof h == "string" ? l(p, h) : (typeof h == "number" || a(h) === "Number" || a(h) === "String") && l(p, o(h));
      }
      var C = p.length, E = !0;
      return function(_, S) {
        if (E)
          return E = !1, S;
        if (r(this)) return S;
        for (var v = 0; v < C; v++) if (p[v] === _) return S;
      };
    }
  }, K3;
}
var t6;
function s9() {
  if (t6) return X4;
  t6 = 1;
  var e = zt(), r = oa(), t = ac(), a = Mt(), o = vt(), l = gt(), c = Xt(), f = ec(), p = oc(), u = o9(), h = qp(), C = String, E = r("JSON", "stringify"), _ = o(/./.exec), S = o("".charAt), v = o("".charCodeAt), g = o("".replace), O = o(1.1.toString), R = /[\uD800-\uDFFF]/g, D = /^[\uD800-\uDBFF]$/, T = /^[\uDC00-\uDFFF]$/, L = !h || l(function() {
    var H = r("Symbol")("stringify detection");
    return E([H]) !== "[null]" || E({ a: H }) !== "{}" || E(Object(H)) !== "{}";
  }), P = l(function() {
    return E("\uDF06\uD834") !== '"\\udf06\\ud834"' || E("\uDEAD") !== '"\\udead"';
  }), M = function(H, w) {
    var $ = p(arguments), B = u(w);
    if (!(!c(B) && (H === void 0 || f(H))))
      return $[1] = function(Y, j) {
        if (c(B) && (j = a(B, this, C(Y), j)), !f(j)) return j;
      }, t(E, null, $);
  }, k = function(H, w, $) {
    var B = S($, w - 1), Y = S($, w + 1);
    return _(D, H) && !_(T, Y) || _(T, H) && !_(D, B) ? "\\u" + O(v(H, 0), 16) : H;
  };
  return E && e({ target: "JSON", stat: !0, arity: 3, forced: L || P }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function(w, $, B) {
      var Y = p(arguments), j = t(L ? M : E, null, Y);
      return P && typeof j == "string" ? g(j, R, k) : j;
    }
  }), X4;
}
s9();
var ml = {}, X3 = { exports: {} }, Xr = {}, Q3 = { exports: {} }, J3 = {}, r6;
function l9() {
  return r6 || (r6 = 1, function(e) {
    /**
     * @license React
     * scheduler.production.min.js
     *
     * Copyright (c) Facebook, Inc. and its affiliates.
     *
     * This source code is licensed under the MIT license found in the
     * LICENSE file in the root directory of this source tree.
     */
    function r(U, X) {
      var K = U.length;
      U.push(X);
      e: for (; 0 < K; ) {
        var y = K - 1 >>> 1, G = U[y];
        if (0 < o(G, X)) U[y] = X, U[K] = G, K = y;
        else break e;
      }
    }
    function t(U) {
      return U.length === 0 ? null : U[0];
    }
    function a(U) {
      if (U.length === 0) return null;
      var X = U[0], K = U.pop();
      if (K !== X) {
        U[0] = K;
        e: for (var y = 0, G = U.length, ce = G >>> 1; y < ce; ) {
          var ue = 2 * (y + 1) - 1, ee = U[ue], ge = ue + 1, Oe = U[ge];
          if (0 > o(ee, K)) ge < G && 0 > o(Oe, ee) ? (U[y] = Oe, U[ge] = K, y = ge) : (U[y] = ee, U[ue] = K, y = ue);
          else if (ge < G && 0 > o(Oe, K)) U[y] = Oe, U[ge] = K, y = ge;
          else break e;
        }
      }
      return X;
    }
    function o(U, X) {
      var K = U.sortIndex - X.sortIndex;
      return K !== 0 ? K : U.id - X.id;
    }
    if (typeof performance == "object" && typeof performance.now == "function") {
      var l = performance;
      e.unstable_now = function() {
        return l.now();
      };
    } else {
      var c = Date, f = c.now();
      e.unstable_now = function() {
        return c.now() - f;
      };
    }
    var p = [], u = [], h = 1, C = null, E = 3, _ = !1, S = !1, v = !1, g = typeof setTimeout == "function" ? setTimeout : null, O = typeof clearTimeout == "function" ? clearTimeout : null, R = typeof setImmediate != "undefined" ? setImmediate : null;
    typeof navigator != "undefined" && navigator.scheduling !== void 0 && navigator.scheduling.isInputPending !== void 0 && navigator.scheduling.isInputPending.bind(navigator.scheduling);
    function D(U) {
      for (var X = t(u); X !== null; ) {
        if (X.callback === null) a(u);
        else if (X.startTime <= U) a(u), X.sortIndex = X.expirationTime, r(p, X);
        else break;
        X = t(u);
      }
    }
    function T(U) {
      if (v = !1, D(U), !S) if (t(p) !== null) S = !0, se(L);
      else {
        var X = t(u);
        X !== null && le(T, X.startTime - U);
      }
    }
    function L(U, X) {
      S = !1, v && (v = !1, O(k), k = -1), _ = !0;
      var K = E;
      try {
        for (D(X), C = t(p); C !== null && (!(C.expirationTime > X) || U && !$()); ) {
          var y = C.callback;
          if (typeof y == "function") {
            C.callback = null, E = C.priorityLevel;
            var G = y(C.expirationTime <= X);
            X = e.unstable_now(), typeof G == "function" ? C.callback = G : C === t(p) && a(p), D(X);
          } else a(p);
          C = t(p);
        }
        if (C !== null) var ce = !0;
        else {
          var ue = t(u);
          ue !== null && le(T, ue.startTime - X), ce = !1;
        }
        return ce;
      } finally {
        C = null, E = K, _ = !1;
      }
    }
    var P = !1, M = null, k = -1, H = 5, w = -1;
    function $() {
      return !(e.unstable_now() - w < H);
    }
    function B() {
      if (M !== null) {
        var U = e.unstable_now();
        w = U;
        var X = !0;
        try {
          X = M(!0, U);
        } finally {
          X ? Y() : (P = !1, M = null);
        }
      } else P = !1;
    }
    var Y;
    if (typeof R == "function") Y = function() {
      R(B);
    };
    else if (typeof MessageChannel != "undefined") {
      var j = new MessageChannel(), ie = j.port2;
      j.port1.onmessage = B, Y = function() {
        ie.postMessage(null);
      };
    } else Y = function() {
      g(B, 0);
    };
    function se(U) {
      M = U, P || (P = !0, Y());
    }
    function le(U, X) {
      k = g(function() {
        U(e.unstable_now());
      }, X);
    }
    e.unstable_IdlePriority = 5, e.unstable_ImmediatePriority = 1, e.unstable_LowPriority = 4, e.unstable_NormalPriority = 3, e.unstable_Profiling = null, e.unstable_UserBlockingPriority = 2, e.unstable_cancelCallback = function(U) {
      U.callback = null;
    }, e.unstable_continueExecution = function() {
      S || _ || (S = !0, se(L));
    }, e.unstable_forceFrameRate = function(U) {
      0 > U || 125 < U ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : H = 0 < U ? Math.floor(1e3 / U) : 5;
    }, e.unstable_getCurrentPriorityLevel = function() {
      return E;
    }, e.unstable_getFirstCallbackNode = function() {
      return t(p);
    }, e.unstable_next = function(U) {
      switch (E) {
        case 1:
        case 2:
        case 3:
          var X = 3;
          break;
        default:
          X = E;
      }
      var K = E;
      E = X;
      try {
        return U();
      } finally {
        E = K;
      }
    }, e.unstable_pauseExecution = function() {
    }, e.unstable_requestPaint = function() {
    }, e.unstable_runWithPriority = function(U, X) {
      switch (U) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          U = 3;
      }
      var K = E;
      E = U;
      try {
        return X();
      } finally {
        E = K;
      }
    }, e.unstable_scheduleCallback = function(U, X, K) {
      var y = e.unstable_now();
      switch (typeof K == "object" && K !== null ? (K = K.delay, K = typeof K == "number" && 0 < K ? y + K : y) : K = y, U) {
        case 1:
          var G = -1;
          break;
        case 2:
          G = 250;
          break;
        case 5:
          G = 1073741823;
          break;
        case 4:
          G = 1e4;
          break;
        default:
          G = 5e3;
      }
      return G = K + G, U = { id: h++, callback: X, priorityLevel: U, startTime: K, expirationTime: G, sortIndex: -1 }, K > y ? (U.sortIndex = K, r(u, U), t(p) === null && U === t(u) && (v ? (O(k), k = -1) : v = !0, le(T, K - y))) : (U.sortIndex = G, r(p, U), S || _ || (S = !0, se(L))), U;
    }, e.unstable_shouldYield = $, e.unstable_wrapCallback = function(U) {
      var X = E;
      return function() {
        var K = E;
        E = X;
        try {
          return U.apply(this, arguments);
        } finally {
          E = K;
        }
      };
    };
  }(J3)), J3;
}
var n6;
function c9() {
  return n6 || (n6 = 1, Q3.exports = l9()), Q3.exports;
}
var i6;
function u9() {
  if (i6) return Xr;
  i6 = 1;
  /**
   * @license React
   * react-dom.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   */
  var e = Ks(), r = c9();
  function t(n) {
    for (var i = "https://reactjs.org/docs/error-decoder.html?invariant=" + n, s = 1; s < arguments.length; s++) i += "&args[]=" + encodeURIComponent(arguments[s]);
    return "Minified React error #" + n + "; visit " + i + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  var a = /* @__PURE__ */ new Set(), o = {};
  function l(n, i) {
    c(n, i), c(n + "Capture", i);
  }
  function c(n, i) {
    for (o[n] = i, n = 0; n < i.length; n++) a.add(i[n]);
  }
  var f = !(typeof window == "undefined" || typeof window.document == "undefined" || typeof window.document.createElement == "undefined"), p = Object.prototype.hasOwnProperty, u = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, h = {}, C = {};
  function E(n) {
    return p.call(C, n) ? !0 : p.call(h, n) ? !1 : u.test(n) ? C[n] = !0 : (h[n] = !0, !1);
  }
  function _(n, i, s, d) {
    if (s !== null && s.type === 0) return !1;
    switch (typeof i) {
      case "function":
      case "symbol":
        return !0;
      case "boolean":
        return d ? !1 : s !== null ? !s.acceptsBooleans : (n = n.toLowerCase().slice(0, 5), n !== "data-" && n !== "aria-");
      default:
        return !1;
    }
  }
  function S(n, i, s, d) {
    if (i === null || typeof i == "undefined" || _(n, i, s, d)) return !0;
    if (d) return !1;
    if (s !== null) switch (s.type) {
      case 3:
        return !i;
      case 4:
        return i === !1;
      case 5:
        return isNaN(i);
      case 6:
        return isNaN(i) || 1 > i;
    }
    return !1;
  }
  function v(n, i, s, d, m, I, A) {
    this.acceptsBooleans = i === 2 || i === 3 || i === 4, this.attributeName = d, this.attributeNamespace = m, this.mustUseProperty = s, this.propertyName = n, this.type = i, this.sanitizeURL = I, this.removeEmptyString = A;
  }
  var g = {};
  "children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(n) {
    g[n] = new v(n, 0, !1, n, null, !1, !1);
  }), [["acceptCharset", "accept-charset"], ["className", "class"], ["htmlFor", "for"], ["httpEquiv", "http-equiv"]].forEach(function(n) {
    var i = n[0];
    g[i] = new v(i, 1, !1, n[1], null, !1, !1);
  }), ["contentEditable", "draggable", "spellCheck", "value"].forEach(function(n) {
    g[n] = new v(n, 2, !1, n.toLowerCase(), null, !1, !1);
  }), ["autoReverse", "externalResourcesRequired", "focusable", "preserveAlpha"].forEach(function(n) {
    g[n] = new v(n, 2, !1, n, null, !1, !1);
  }), "allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(n) {
    g[n] = new v(n, 3, !1, n.toLowerCase(), null, !1, !1);
  }), ["checked", "multiple", "muted", "selected"].forEach(function(n) {
    g[n] = new v(n, 3, !0, n, null, !1, !1);
  }), ["capture", "download"].forEach(function(n) {
    g[n] = new v(n, 4, !1, n, null, !1, !1);
  }), ["cols", "rows", "size", "span"].forEach(function(n) {
    g[n] = new v(n, 6, !1, n, null, !1, !1);
  }), ["rowSpan", "start"].forEach(function(n) {
    g[n] = new v(n, 5, !1, n.toLowerCase(), null, !1, !1);
  });
  var O = /[\-:]([a-z])/g;
  function R(n) {
    return n[1].toUpperCase();
  }
  "accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(n) {
    var i = n.replace(
      O,
      R
    );
    g[i] = new v(i, 1, !1, n, null, !1, !1);
  }), "xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(n) {
    var i = n.replace(O, R);
    g[i] = new v(i, 1, !1, n, "http://www.w3.org/1999/xlink", !1, !1);
  }), ["xml:base", "xml:lang", "xml:space"].forEach(function(n) {
    var i = n.replace(O, R);
    g[i] = new v(i, 1, !1, n, "http://www.w3.org/XML/1998/namespace", !1, !1);
  }), ["tabIndex", "crossOrigin"].forEach(function(n) {
    g[n] = new v(n, 1, !1, n.toLowerCase(), null, !1, !1);
  }), g.xlinkHref = new v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1), ["src", "href", "action", "formAction"].forEach(function(n) {
    g[n] = new v(n, 1, !1, n.toLowerCase(), null, !0, !0);
  });
  function D(n, i, s, d) {
    var m = g.hasOwnProperty(i) ? g[i] : null;
    (m !== null ? m.type !== 0 : d || !(2 < i.length) || i[0] !== "o" && i[0] !== "O" || i[1] !== "n" && i[1] !== "N") && (S(i, s, m, d) && (s = null), d || m === null ? E(i) && (s === null ? n.removeAttribute(i) : n.setAttribute(i, "" + s)) : m.mustUseProperty ? n[m.propertyName] = s === null ? m.type === 3 ? !1 : "" : s : (i = m.attributeName, d = m.attributeNamespace, s === null ? n.removeAttribute(i) : (m = m.type, s = m === 3 || m === 4 && s === !0 ? "" : "" + s, d ? n.setAttributeNS(d, i, s) : n.setAttribute(i, s))));
  }
  var T = e.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, L = Symbol.for("react.element"), P = Symbol.for("react.portal"), M = Symbol.for("react.fragment"), k = Symbol.for("react.strict_mode"), H = Symbol.for("react.profiler"), w = Symbol.for("react.provider"), $ = Symbol.for("react.context"), B = Symbol.for("react.forward_ref"), Y = Symbol.for("react.suspense"), j = Symbol.for("react.suspense_list"), ie = Symbol.for("react.memo"), se = Symbol.for("react.lazy"), le = Symbol.for("react.offscreen"), U = Symbol.iterator;
  function X(n) {
    return n === null || typeof n != "object" ? null : (n = U && n[U] || n["@@iterator"], typeof n == "function" ? n : null);
  }
  var K = Object.assign, y;
  function G(n) {
    if (y === void 0) try {
      throw Error();
    } catch (s) {
      var i = s.stack.trim().match(/\n( *(at )?)/);
      y = i && i[1] || "";
    }
    return `
` + y + n;
  }
  var ce = !1;
  function ue(n, i) {
    if (!n || ce) return "";
    ce = !0;
    var s = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      if (i) if (i = function() {
        throw Error();
      }, Object.defineProperty(i.prototype, "props", { set: function() {
        throw Error();
      } }), typeof Reflect == "object" && Reflect.construct) {
        try {
          Reflect.construct(i, []);
        } catch (te) {
          var d = te;
        }
        Reflect.construct(n, [], i);
      } else {
        try {
          i.call();
        } catch (te) {
          d = te;
        }
        n.call(i.prototype);
      }
      else {
        try {
          throw Error();
        } catch (te) {
          d = te;
        }
        n();
      }
    } catch (te) {
      if (te && d && typeof te.stack == "string") {
        for (var m = te.stack.split(`
`), I = d.stack.split(`
`), A = m.length - 1, b = I.length - 1; 1 <= A && 0 <= b && m[A] !== I[b]; ) b--;
        for (; 1 <= A && 0 <= b; A--, b--) if (m[A] !== I[b]) {
          if (A !== 1 || b !== 1)
            do
              if (A--, b--, 0 > b || m[A] !== I[b]) {
                var F = `
` + m[A].replace(" at new ", " at ");
                return n.displayName && F.includes("<anonymous>") && (F = F.replace("<anonymous>", n.displayName)), F;
              }
            while (1 <= A && 0 <= b);
          break;
        }
      }
    } finally {
      ce = !1, Error.prepareStackTrace = s;
    }
    return (n = n ? n.displayName || n.name : "") ? G(n) : "";
  }
  function ee(n) {
    switch (n.tag) {
      case 5:
        return G(n.type);
      case 16:
        return G("Lazy");
      case 13:
        return G("Suspense");
      case 19:
        return G("SuspenseList");
      case 0:
      case 2:
      case 15:
        return n = ue(n.type, !1), n;
      case 11:
        return n = ue(n.type.render, !1), n;
      case 1:
        return n = ue(n.type, !0), n;
      default:
        return "";
    }
  }
  function ge(n) {
    if (n == null) return null;
    if (typeof n == "function") return n.displayName || n.name || null;
    if (typeof n == "string") return n;
    switch (n) {
      case M:
        return "Fragment";
      case P:
        return "Portal";
      case H:
        return "Profiler";
      case k:
        return "StrictMode";
      case Y:
        return "Suspense";
      case j:
        return "SuspenseList";
    }
    if (typeof n == "object") switch (n.$$typeof) {
      case $:
        return (n.displayName || "Context") + ".Consumer";
      case w:
        return (n._context.displayName || "Context") + ".Provider";
      case B:
        var i = n.render;
        return n = n.displayName, n || (n = i.displayName || i.name || "", n = n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef"), n;
      case ie:
        return i = n.displayName || null, i !== null ? i : ge(n.type) || "Memo";
      case se:
        i = n._payload, n = n._init;
        try {
          return ge(n(i));
        } catch (s) {
        }
    }
    return null;
  }
  function Oe(n) {
    var i = n.type;
    switch (n.tag) {
      case 24:
        return "Cache";
      case 9:
        return (i.displayName || "Context") + ".Consumer";
      case 10:
        return (i._context.displayName || "Context") + ".Provider";
      case 18:
        return "DehydratedFragment";
      case 11:
        return n = i.render, n = n.displayName || n.name || "", i.displayName || (n !== "" ? "ForwardRef(" + n + ")" : "ForwardRef");
      case 7:
        return "Fragment";
      case 5:
        return i;
      case 4:
        return "Portal";
      case 3:
        return "Root";
      case 6:
        return "Text";
      case 16:
        return ge(i);
      case 8:
        return i === k ? "StrictMode" : "Mode";
      case 22:
        return "Offscreen";
      case 12:
        return "Profiler";
      case 21:
        return "Scope";
      case 13:
        return "Suspense";
      case 19:
        return "SuspenseList";
      case 25:
        return "TracingMarker";
      case 1:
      case 0:
      case 17:
      case 2:
      case 14:
      case 15:
        if (typeof i == "function") return i.displayName || i.name || null;
        if (typeof i == "string") return i;
    }
    return null;
  }
  function Se(n) {
    switch (typeof n) {
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return n;
      case "object":
        return n;
      default:
        return "";
    }
  }
  function Ne(n) {
    var i = n.type;
    return (n = n.nodeName) && n.toLowerCase() === "input" && (i === "checkbox" || i === "radio");
  }
  function Le(n) {
    var i = Ne(n) ? "checked" : "value", s = Object.getOwnPropertyDescriptor(n.constructor.prototype, i), d = "" + n[i];
    if (!n.hasOwnProperty(i) && typeof s != "undefined" && typeof s.get == "function" && typeof s.set == "function") {
      var m = s.get, I = s.set;
      return Object.defineProperty(n, i, { configurable: !0, get: function() {
        return m.call(this);
      }, set: function(A) {
        d = "" + A, I.call(this, A);
      } }), Object.defineProperty(n, i, { enumerable: s.enumerable }), { getValue: function() {
        return d;
      }, setValue: function(A) {
        d = "" + A;
      }, stopTracking: function() {
        n._valueTracker = null, delete n[i];
      } };
    }
  }
  function ct(n) {
    n._valueTracker || (n._valueTracker = Le(n));
  }
  function Ye(n) {
    if (!n) return !1;
    var i = n._valueTracker;
    if (!i) return !0;
    var s = i.getValue(), d = "";
    return n && (d = Ne(n) ? n.checked ? "true" : "false" : n.value), n = d, n !== s ? (i.setValue(n), !0) : !1;
  }
  function nt(n) {
    if (n = n || (typeof document != "undefined" ? document : void 0), typeof n == "undefined") return null;
    try {
      return n.activeElement || n.body;
    } catch (i) {
      return n.body;
    }
  }
  function Ke(n, i) {
    var s = i.checked;
    return K({}, i, { defaultChecked: void 0, defaultValue: void 0, value: void 0, checked: s != null ? s : n._wrapperState.initialChecked });
  }
  function ot(n, i) {
    var s = i.defaultValue == null ? "" : i.defaultValue, d = i.checked != null ? i.checked : i.defaultChecked;
    s = Se(i.value != null ? i.value : s), n._wrapperState = { initialChecked: d, initialValue: s, controlled: i.type === "checkbox" || i.type === "radio" ? i.checked != null : i.value != null };
  }
  function St(n, i) {
    i = i.checked, i != null && D(n, "checked", i, !1);
  }
  function dt(n, i) {
    St(n, i);
    var s = Se(i.value), d = i.type;
    if (s != null) d === "number" ? (s === 0 && n.value === "" || n.value != s) && (n.value = "" + s) : n.value !== "" + s && (n.value = "" + s);
    else if (d === "submit" || d === "reset") {
      n.removeAttribute("value");
      return;
    }
    i.hasOwnProperty("value") ? je(n, i.type, s) : i.hasOwnProperty("defaultValue") && je(n, i.type, Se(i.defaultValue)), i.checked == null && i.defaultChecked != null && (n.defaultChecked = !!i.defaultChecked);
  }
  function Je(n, i, s) {
    if (i.hasOwnProperty("value") || i.hasOwnProperty("defaultValue")) {
      var d = i.type;
      if (!(d !== "submit" && d !== "reset" || i.value !== void 0 && i.value !== null)) return;
      i = "" + n._wrapperState.initialValue, s || i === n.value || (n.value = i), n.defaultValue = i;
    }
    s = n.name, s !== "" && (n.name = ""), n.defaultChecked = !!n._wrapperState.initialChecked, s !== "" && (n.name = s);
  }
  function je(n, i, s) {
    (i !== "number" || nt(n.ownerDocument) !== n) && (s == null ? n.defaultValue = "" + n._wrapperState.initialValue : n.defaultValue !== "" + s && (n.defaultValue = "" + s));
  }
  var st = Array.isArray;
  function de(n, i, s, d) {
    if (n = n.options, i) {
      i = {};
      for (var m = 0; m < s.length; m++) i["$" + s[m]] = !0;
      for (s = 0; s < n.length; s++) m = i.hasOwnProperty("$" + n[s].value), n[s].selected !== m && (n[s].selected = m), m && d && (n[s].defaultSelected = !0);
    } else {
      for (s = "" + Se(s), i = null, m = 0; m < n.length; m++) {
        if (n[m].value === s) {
          n[m].selected = !0, d && (n[m].defaultSelected = !0);
          return;
        }
        i !== null || n[m].disabled || (i = n[m]);
      }
      i !== null && (i.selected = !0);
    }
  }
  function Te(n, i) {
    if (i.dangerouslySetInnerHTML != null) throw Error(t(91));
    return K({}, i, { value: void 0, defaultValue: void 0, children: "" + n._wrapperState.initialValue });
  }
  function Ue(n, i) {
    var s = i.value;
    if (s == null) {
      if (s = i.children, i = i.defaultValue, s != null) {
        if (i != null) throw Error(t(92));
        if (st(s)) {
          if (1 < s.length) throw Error(t(93));
          s = s[0];
        }
        i = s;
      }
      i == null && (i = ""), s = i;
    }
    n._wrapperState = { initialValue: Se(s) };
  }
  function Lt(n, i) {
    var s = Se(i.value), d = Se(i.defaultValue);
    s != null && (s = "" + s, s !== n.value && (n.value = s), i.defaultValue == null && n.defaultValue !== s && (n.defaultValue = s)), d != null && (n.defaultValue = "" + d);
  }
  function Et(n) {
    var i = n.textContent;
    i === n._wrapperState.initialValue && i !== "" && i !== null && (n.value = i);
  }
  function Re(n) {
    switch (n) {
      case "svg":
        return "http://www.w3.org/2000/svg";
      case "math":
        return "http://www.w3.org/1998/Math/MathML";
      default:
        return "http://www.w3.org/1999/xhtml";
    }
  }
  function ke(n, i) {
    return n == null || n === "http://www.w3.org/1999/xhtml" ? Re(i) : n === "http://www.w3.org/2000/svg" && i === "foreignObject" ? "http://www.w3.org/1999/xhtml" : n;
  }
  var $e, rt = function(n) {
    return typeof MSApp != "undefined" && MSApp.execUnsafeLocalFunction ? function(i, s, d, m) {
      MSApp.execUnsafeLocalFunction(function() {
        return n(i, s, d, m);
      });
    } : n;
  }(function(n, i) {
    if (n.namespaceURI !== "http://www.w3.org/2000/svg" || "innerHTML" in n) n.innerHTML = i;
    else {
      for ($e = $e || document.createElement("div"), $e.innerHTML = "<svg>" + i.valueOf().toString() + "</svg>", i = $e.firstChild; n.firstChild; ) n.removeChild(n.firstChild);
      for (; i.firstChild; ) n.appendChild(i.firstChild);
    }
  });
  function ht(n, i) {
    if (i) {
      var s = n.firstChild;
      if (s && s === n.lastChild && s.nodeType === 3) {
        s.nodeValue = i;
        return;
      }
    }
    n.textContent = i;
  }
  var Ot = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
  }, Xe = ["Webkit", "ms", "Moz", "O"];
  Object.keys(Ot).forEach(function(n) {
    Xe.forEach(function(i) {
      i = i + n.charAt(0).toUpperCase() + n.substring(1), Ot[i] = Ot[n];
    });
  });
  function De(n, i, s) {
    return i == null || typeof i == "boolean" || i === "" ? "" : s || typeof i != "number" || i === 0 || Ot.hasOwnProperty(n) && Ot[n] ? ("" + i).trim() : i + "px";
  }
  function et(n, i) {
    n = n.style;
    for (var s in i) if (i.hasOwnProperty(s)) {
      var d = s.indexOf("--") === 0, m = De(s, i[s], d);
      s === "float" && (s = "cssFloat"), d ? n.setProperty(s, m) : n[s] = m;
    }
  }
  var Pt = K({ menuitem: !0 }, { area: !0, base: !0, br: !0, col: !0, embed: !0, hr: !0, img: !0, input: !0, keygen: !0, link: !0, meta: !0, param: !0, source: !0, track: !0, wbr: !0 });
  function bt(n, i) {
    if (i) {
      if (Pt[n] && (i.children != null || i.dangerouslySetInnerHTML != null)) throw Error(t(137, n));
      if (i.dangerouslySetInnerHTML != null) {
        if (i.children != null) throw Error(t(60));
        if (typeof i.dangerouslySetInnerHTML != "object" || !("__html" in i.dangerouslySetInnerHTML)) throw Error(t(61));
      }
      if (i.style != null && typeof i.style != "object") throw Error(t(62));
    }
  }
  function Or(n, i) {
    if (n.indexOf("-") === -1) return typeof i.is == "string";
    switch (n) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return !1;
      default:
        return !0;
    }
  }
  var Ie = null;
  function Pe(n) {
    return n = n.target || n.srcElement || window, n.correspondingUseElement && (n = n.correspondingUseElement), n.nodeType === 3 ? n.parentNode : n;
  }
  var ye = null, we = null, ze = null;
  function ut(n) {
    if (n = us(n)) {
      if (typeof ye != "function") throw Error(t(280));
      var i = n.stateNode;
      i && (i = L2(i), ye(n.stateNode, n.type, i));
    }
  }
  function At(n) {
    we ? ze ? ze.push(n) : ze = [n] : we = n;
  }
  function Nt() {
    if (we) {
      var n = we, i = ze;
      if (ze = we = null, ut(n), i) for (n = 0; n < i.length; n++) ut(i[n]);
    }
  }
  function wt(n, i) {
    return n(i);
  }
  function Qt() {
  }
  var vr = !1;
  function hi(n, i, s) {
    if (vr) return n(i, s);
    vr = !0;
    try {
      return wt(n, i, s);
    } finally {
      vr = !1, (we !== null || ze !== null) && (Qt(), Nt());
    }
  }
  function Fr(n, i) {
    var s = n.stateNode;
    if (s === null) return null;
    var d = L2(s);
    if (d === null) return null;
    s = d[i];
    e: switch (i) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (d = !d.disabled) || (n = n.type, d = !(n === "button" || n === "input" || n === "select" || n === "textarea")), n = !d;
        break e;
      default:
        n = !1;
    }
    if (n) return null;
    if (s && typeof s != "function") throw Error(t(231, i, typeof s));
    return s;
  }
  var Xn = !1;
  if (f) try {
    var qt = {};
    Object.defineProperty(qt, "passive", { get: function() {
      Xn = !0;
    } }), window.addEventListener("test", qt, qt), window.removeEventListener("test", qt, qt);
  } catch (n) {
    Xn = !1;
  }
  function xr(n, i, s, d, m, I, A, b, F) {
    var te = Array.prototype.slice.call(arguments, 3);
    try {
      i.apply(s, te);
    } catch (me) {
      this.onError(me);
    }
  }
  var Mn = !1, Ur = null, gr = !1, Qn = null, bn = { onError: function(n) {
    Mn = !0, Ur = n;
  } };
  function sr(n, i, s, d, m, I, A, b, F) {
    Mn = !1, Ur = null, xr.apply(bn, arguments);
  }
  function yr(n, i, s, d, m, I, A, b, F) {
    if (sr.apply(this, arguments), Mn) {
      if (Mn) {
        var te = Ur;
        Mn = !1, Ur = null;
      } else throw Error(t(198));
      gr || (gr = !0, Qn = te);
    }
  }
  function mn(n) {
    var i = n, s = n;
    if (n.alternate) for (; i.return; ) i = i.return;
    else {
      n = i;
      do
        i = n, (i.flags & 4098) !== 0 && (s = i.return), n = i.return;
      while (n);
    }
    return i.tag === 3 ? s : null;
  }
  function ca(n) {
    if (n.tag === 13) {
      var i = n.memoizedState;
      if (i === null && (n = n.alternate, n !== null && (i = n.memoizedState)), i !== null) return i.dehydrated;
    }
    return null;
  }
  function J(n) {
    if (mn(n) !== n) throw Error(t(188));
  }
  function Ee(n) {
    var i = n.alternate;
    if (!i) {
      if (i = mn(n), i === null) throw Error(t(188));
      return i !== n ? null : n;
    }
    for (var s = n, d = i; ; ) {
      var m = s.return;
      if (m === null) break;
      var I = m.alternate;
      if (I === null) {
        if (d = m.return, d !== null) {
          s = d;
          continue;
        }
        break;
      }
      if (m.child === I.child) {
        for (I = m.child; I; ) {
          if (I === s) return J(m), n;
          if (I === d) return J(m), i;
          I = I.sibling;
        }
        throw Error(t(188));
      }
      if (s.return !== d.return) s = m, d = I;
      else {
        for (var A = !1, b = m.child; b; ) {
          if (b === s) {
            A = !0, s = m, d = I;
            break;
          }
          if (b === d) {
            A = !0, d = m, s = I;
            break;
          }
          b = b.sibling;
        }
        if (!A) {
          for (b = I.child; b; ) {
            if (b === s) {
              A = !0, s = I, d = m;
              break;
            }
            if (b === d) {
              A = !0, d = I, s = m;
              break;
            }
            b = b.sibling;
          }
          if (!A) throw Error(t(189));
        }
      }
      if (s.alternate !== d) throw Error(t(190));
    }
    if (s.tag !== 3) throw Error(t(188));
    return s.stateNode.current === s ? n : i;
  }
  function ne(n) {
    return n = Ee(n), n !== null ? z(n) : null;
  }
  function z(n) {
    if (n.tag === 5 || n.tag === 6) return n;
    for (n = n.child; n !== null; ) {
      var i = z(n);
      if (i !== null) return i;
      n = n.sibling;
    }
    return null;
  }
  var fe = r.unstable_scheduleCallback, Qe = r.unstable_cancelCallback, Fe = r.unstable_shouldYield, Ht = r.unstable_requestPaint, lt = r.unstable_now, ir = r.unstable_getCurrentPriorityLevel, hr = r.unstable_ImmediatePriority, _e = r.unstable_UserBlockingPriority, Vt = r.unstable_NormalPriority, rn = r.unstable_LowPriority, ki = r.unstable_IdlePriority, mi = null, Br = null;
  function ua(n) {
    if (Br && typeof Br.onCommitFiberRoot == "function") try {
      Br.onCommitFiberRoot(mi, n, void 0, (n.current.flags & 128) === 128);
    } catch (i) {
    }
  }
  var nn = Math.clz32 ? Math.clz32 : Tc, Rc = Math.log, Ac = Math.LN2;
  function Tc(n) {
    return n >>>= 0, n === 0 ? 32 : 31 - (Rc(n) / Ac | 0) | 0;
  }
  var qa = 64, Wa = 4194304;
  function fa(n) {
    switch (n & -n) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return n & 4194240;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return n & 130023424;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 1073741824;
      default:
        return n;
    }
  }
  function Ya(n, i) {
    var s = n.pendingLanes;
    if (s === 0) return 0;
    var d = 0, m = n.suspendedLanes, I = n.pingedLanes, A = s & 268435455;
    if (A !== 0) {
      var b = A & ~m;
      b !== 0 ? d = fa(b) : (I &= A, I !== 0 && (d = fa(I)));
    } else A = s & ~m, A !== 0 ? d = fa(A) : I !== 0 && (d = fa(I));
    if (d === 0) return 0;
    if (i !== 0 && i !== d && (i & m) === 0 && (m = d & -d, I = i & -i, m >= I || m === 16 && (I & 4194240) !== 0)) return i;
    if ((d & 4) !== 0 && (d |= s & 16), i = n.entangledLanes, i !== 0) for (n = n.entanglements, i &= d; 0 < i; ) s = 31 - nn(i), m = 1 << s, d |= n[s], i &= ~m;
    return d;
  }
  function Oc(n, i) {
    switch (n) {
      case 1:
      case 2:
      case 4:
        return i + 250;
      case 8:
      case 16:
      case 32:
      case 64:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return i + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
      case 67108864:
        return -1;
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function yc(n, i) {
    for (var s = n.suspendedLanes, d = n.pingedLanes, m = n.expirationTimes, I = n.pendingLanes; 0 < I; ) {
      var A = 31 - nn(I), b = 1 << A, F = m[A];
      F === -1 ? ((b & s) === 0 || (b & d) !== 0) && (m[A] = Oc(b, i)) : F <= i && (n.expiredLanes |= b), I &= ~b;
    }
  }
  function zo(n) {
    return n = n.pendingLanes & -1073741825, n !== 0 ? n : n & 1073741824 ? 1073741824 : 0;
  }
  function u2() {
    var n = qa;
    return qa <<= 1, (qa & 4194240) === 0 && (qa = 64), n;
  }
  function qo(n) {
    for (var i = [], s = 0; 31 > s; s++) i.push(n);
    return i;
  }
  function da(n, i, s) {
    n.pendingLanes |= i, i !== 536870912 && (n.suspendedLanes = 0, n.pingedLanes = 0), n = n.eventTimes, i = 31 - nn(i), n[i] = s;
  }
  function Nc(n, i) {
    var s = n.pendingLanes & ~i;
    n.pendingLanes = i, n.suspendedLanes = 0, n.pingedLanes = 0, n.expiredLanes &= i, n.mutableReadLanes &= i, n.entangledLanes &= i, i = n.entanglements;
    var d = n.eventTimes;
    for (n = n.expirationTimes; 0 < s; ) {
      var m = 31 - nn(s), I = 1 << m;
      i[m] = 0, d[m] = -1, n[m] = -1, s &= ~I;
    }
  }
  function Wo(n, i) {
    var s = n.entangledLanes |= i;
    for (n = n.entanglements; s; ) {
      var d = 31 - nn(s), m = 1 << d;
      m & i | n[d] & i && (n[d] |= i), s &= ~m;
    }
  }
  var yt = 0;
  function f2(n) {
    return n &= -n, 1 < n ? 4 < n ? (n & 268435455) !== 0 ? 16 : 536870912 : 4 : 1;
  }
  var d2, Yo, p2, h2, m2, Ko = !1, Ka = [], Jn = null, ei = null, ti = null, pa = /* @__PURE__ */ new Map(), ha = /* @__PURE__ */ new Map(), ri = [], Lc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
  function _2(n, i) {
    switch (n) {
      case "focusin":
      case "focusout":
        Jn = null;
        break;
      case "dragenter":
      case "dragleave":
        ei = null;
        break;
      case "mouseover":
      case "mouseout":
        ti = null;
        break;
      case "pointerover":
      case "pointerout":
        pa.delete(i.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        ha.delete(i.pointerId);
    }
  }
  function ma(n, i, s, d, m, I) {
    return n === null || n.nativeEvent !== I ? (n = { blockedOn: i, domEventName: s, eventSystemFlags: d, nativeEvent: I, targetContainers: [m] }, i !== null && (i = us(i), i !== null && Yo(i)), n) : (n.eventSystemFlags |= d, i = n.targetContainers, m !== null && i.indexOf(m) === -1 && i.push(m), n);
  }
  function E2(n, i, s, d, m) {
    switch (i) {
      case "focusin":
        return Jn = ma(Jn, n, i, s, d, m), !0;
      case "dragenter":
        return ei = ma(ei, n, i, s, d, m), !0;
      case "mouseover":
        return ti = ma(ti, n, i, s, d, m), !0;
      case "pointerover":
        var I = m.pointerId;
        return pa.set(I, ma(pa.get(I) || null, n, i, s, d, m)), !0;
      case "gotpointercapture":
        return I = m.pointerId, ha.set(I, ma(ha.get(I) || null, n, i, s, d, m)), !0;
    }
    return !1;
  }
  function C2(n) {
    var i = _a(n.target);
    if (i !== null) {
      var s = mn(i);
      if (s !== null) {
        if (i = s.tag, i === 13) {
          if (i = ca(s), i !== null) {
            n.blockedOn = i, m2(n.priority, function() {
              p2(s);
            });
            return;
          }
        } else if (i === 3 && s.stateNode.current.memoizedState.isDehydrated) {
          n.blockedOn = s.tag === 3 ? s.stateNode.containerInfo : null;
          return;
        }
      }
    }
    n.blockedOn = null;
  }
  function q(n) {
    if (n.blockedOn !== null) return !1;
    for (var i = n.targetContainers; 0 < i.length; ) {
      var s = Ja(n.domEventName, n.eventSystemFlags, i[0], n.nativeEvent);
      if (s === null) {
        s = n.nativeEvent;
        var d = new s.constructor(s.type, s);
        Ie = d, s.target.dispatchEvent(d), Ie = null;
      } else return i = us(s), i !== null && Yo(i), n.blockedOn = s, !1;
      i.shift();
    }
    return !0;
  }
  function N(n, i, s) {
    q(n) && s.delete(i);
  }
  function V() {
    Ko = !1, Jn !== null && q(Jn) && (Jn = null), ei !== null && q(ei) && (ei = null), ti !== null && q(ti) && (ti = null), pa.forEach(N), ha.forEach(N);
  }
  function ae(n, i) {
    n.blockedOn === i && (n.blockedOn = null, Ko || (Ko = !0, r.unstable_scheduleCallback(r.unstable_NormalPriority, V)));
  }
  function pe(n) {
    function i(m) {
      return ae(m, n);
    }
    if (0 < Ka.length) {
      ae(Ka[0], n);
      for (var s = 1; s < Ka.length; s++) {
        var d = Ka[s];
        d.blockedOn === n && (d.blockedOn = null);
      }
    }
    for (Jn !== null && ae(Jn, n), ei !== null && ae(ei, n), ti !== null && ae(ti, n), pa.forEach(i), ha.forEach(i), s = 0; s < ri.length; s++) d = ri[s], d.blockedOn === n && (d.blockedOn = null);
    for (; 0 < ri.length && (s = ri[0], s.blockedOn === null); ) C2(s), s.blockedOn === null && ri.shift();
  }
  var it = T.ReactCurrentBatchConfig, xt = !0;
  function Nr(n, i, s, d) {
    var m = yt, I = it.transition;
    it.transition = null;
    try {
      yt = 1, Xo(n, i, s, d);
    } finally {
      yt = m, it.transition = I;
    }
  }
  function Xa(n, i, s, d) {
    var m = yt, I = it.transition;
    it.transition = null;
    try {
      yt = 4, Xo(n, i, s, d);
    } finally {
      yt = m, it.transition = I;
    }
  }
  function Xo(n, i, s, d) {
    if (xt) {
      var m = Ja(n, i, s, d);
      if (m === null) zc(n, i, d, Qa, s), _2(n, d);
      else if (E2(m, n, i, s, d)) d.stopPropagation();
      else if (_2(n, d), i & 4 && -1 < Lc.indexOf(n)) {
        for (; m !== null; ) {
          var I = us(m);
          if (I !== null && d2(I), I = Ja(n, i, s, d), I === null && zc(n, i, d, Qa, s), I === m) break;
          m = I;
        }
        m !== null && d.stopPropagation();
      } else zc(n, i, d, null, s);
    }
  }
  var Qa = null;
  function Ja(n, i, s, d) {
    if (Qa = null, n = Pe(d), n = _a(n), n !== null) if (i = mn(n), i === null) n = null;
    else if (s = i.tag, s === 13) {
      if (n = ca(i), n !== null) return n;
      n = null;
    } else if (s === 3) {
      if (i.stateNode.current.memoizedState.isDehydrated) return i.tag === 3 ? i.stateNode.containerInfo : null;
      n = null;
    } else i !== n && (n = null);
    return Qa = n, null;
  }
  function Qo(n) {
    switch (n) {
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 1;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "toggle":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 4;
      case "message":
        switch (ir()) {
          case hr:
            return 1;
          case _e:
            return 4;
          case Vt:
          case rn:
            return 16;
          case ki:
            return 536870912;
          default:
            return 16;
        }
      default:
        return 16;
    }
  }
  var Pn = null, eo = null, S2 = null;
  function Fh() {
    if (S2) return S2;
    var n, i = eo, s = i.length, d, m = "value" in Pn ? Pn.value : Pn.textContent, I = m.length;
    for (n = 0; n < s && i[n] === m[n]; n++) ;
    var A = s - n;
    for (d = 1; d <= A && i[s - d] === m[I - d]; d++) ;
    return S2 = m.slice(n, 1 < d ? 1 - d : void 0);
  }
  function I2(n) {
    var i = n.keyCode;
    return "charCode" in n ? (n = n.charCode, n === 0 && i === 13 && (n = 13)) : n = i, n === 10 && (n = 13), 32 <= n || n === 13 ? n : 0;
  }
  function v2() {
    return !0;
  }
  function xh() {
    return !1;
  }
  function an(n) {
    function i(s, d, m, I, A) {
      this._reactName = s, this._targetInst = m, this.type = d, this.nativeEvent = I, this.target = A, this.currentTarget = null;
      for (var b in n) n.hasOwnProperty(b) && (s = n[b], this[b] = s ? s(I) : I[b]);
      return this.isDefaultPrevented = (I.defaultPrevented != null ? I.defaultPrevented : I.returnValue === !1) ? v2 : xh, this.isPropagationStopped = xh, this;
    }
    return K(i.prototype, { preventDefault: function() {
      this.defaultPrevented = !0;
      var s = this.nativeEvent;
      s && (s.preventDefault ? s.preventDefault() : typeof s.returnValue != "unknown" && (s.returnValue = !1), this.isDefaultPrevented = v2);
    }, stopPropagation: function() {
      var s = this.nativeEvent;
      s && (s.stopPropagation ? s.stopPropagation() : typeof s.cancelBubble != "unknown" && (s.cancelBubble = !0), this.isPropagationStopped = v2);
    }, persist: function() {
    }, isPersistent: v2 }), i;
  }
  var to = { eventPhase: 0, bubbles: 0, cancelable: 0, timeStamp: function(n) {
    return n.timeStamp || Date.now();
  }, defaultPrevented: 0, isTrusted: 0 }, Mc = an(to), Jo = K({}, to, { view: 0, detail: 0 }), eA = an(Jo), bc, Pc, es, g2 = K({}, Jo, { screenX: 0, screenY: 0, clientX: 0, clientY: 0, pageX: 0, pageY: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, getModifierState: Hc, button: 0, buttons: 0, relatedTarget: function(n) {
    return n.relatedTarget === void 0 ? n.fromElement === n.srcElement ? n.toElement : n.fromElement : n.relatedTarget;
  }, movementX: function(n) {
    return "movementX" in n ? n.movementX : (n !== es && (es && n.type === "mousemove" ? (bc = n.screenX - es.screenX, Pc = n.screenY - es.screenY) : Pc = bc = 0, es = n), bc);
  }, movementY: function(n) {
    return "movementY" in n ? n.movementY : Pc;
  } }), Uh = an(g2), tA = K({}, g2, { dataTransfer: 0 }), rA = an(tA), nA = K({}, Jo, { relatedTarget: 0 }), wc = an(nA), iA = K({}, to, { animationName: 0, elapsedTime: 0, pseudoElement: 0 }), aA = an(iA), oA = K({}, to, { clipboardData: function(n) {
    return "clipboardData" in n ? n.clipboardData : window.clipboardData;
  } }), sA = an(oA), lA = K({}, to, { data: 0 }), Bh = an(lA), cA = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, uA = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, fA = { Alt: "altKey", Control: "ctrlKey", Meta: "metaKey", Shift: "shiftKey" };
  function dA(n) {
    var i = this.nativeEvent;
    return i.getModifierState ? i.getModifierState(n) : (n = fA[n]) ? !!i[n] : !1;
  }
  function Hc() {
    return dA;
  }
  var pA = K({}, Jo, { key: function(n) {
    if (n.key) {
      var i = cA[n.key] || n.key;
      if (i !== "Unidentified") return i;
    }
    return n.type === "keypress" ? (n = I2(n), n === 13 ? "Enter" : String.fromCharCode(n)) : n.type === "keydown" || n.type === "keyup" ? uA[n.keyCode] || "Unidentified" : "";
  }, code: 0, location: 0, ctrlKey: 0, shiftKey: 0, altKey: 0, metaKey: 0, repeat: 0, locale: 0, getModifierState: Hc, charCode: function(n) {
    return n.type === "keypress" ? I2(n) : 0;
  }, keyCode: function(n) {
    return n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
  }, which: function(n) {
    return n.type === "keypress" ? I2(n) : n.type === "keydown" || n.type === "keyup" ? n.keyCode : 0;
  } }), hA = an(pA), mA = K({}, g2, { pointerId: 0, width: 0, height: 0, pressure: 0, tangentialPressure: 0, tiltX: 0, tiltY: 0, twist: 0, pointerType: 0, isPrimary: 0 }), $h = an(mA), _A = K({}, Jo, { touches: 0, targetTouches: 0, changedTouches: 0, altKey: 0, metaKey: 0, ctrlKey: 0, shiftKey: 0, getModifierState: Hc }), EA = an(_A), CA = K({}, to, { propertyName: 0, elapsedTime: 0, pseudoElement: 0 }), SA = an(CA), IA = K({}, g2, {
    deltaX: function(n) {
      return "deltaX" in n ? n.deltaX : "wheelDeltaX" in n ? -n.wheelDeltaX : 0;
    },
    deltaY: function(n) {
      return "deltaY" in n ? n.deltaY : "wheelDeltaY" in n ? -n.wheelDeltaY : "wheelDelta" in n ? -n.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), vA = an(IA), gA = [9, 13, 27, 32], Vc = f && "CompositionEvent" in window, ts = null;
  f && "documentMode" in document && (ts = document.documentMode);
  var DA = f && "TextEvent" in window && !ts, Gh = f && (!Vc || ts && 8 < ts && 11 >= ts), Zh = " ", jh = !1;
  function zh(n, i) {
    switch (n) {
      case "keyup":
        return gA.indexOf(i.keyCode) !== -1;
      case "keydown":
        return i.keyCode !== 229;
      case "keypress":
      case "mousedown":
      case "focusout":
        return !0;
      default:
        return !1;
    }
  }
  function qh(n) {
    return n = n.detail, typeof n == "object" && "data" in n ? n.data : null;
  }
  var ro = !1;
  function RA(n, i) {
    switch (n) {
      case "compositionend":
        return qh(i);
      case "keypress":
        return i.which !== 32 ? null : (jh = !0, Zh);
      case "textInput":
        return n = i.data, n === Zh && jh ? null : n;
      default:
        return null;
    }
  }
  function AA(n, i) {
    if (ro) return n === "compositionend" || !Vc && zh(n, i) ? (n = Fh(), S2 = eo = Pn = null, ro = !1, n) : null;
    switch (n) {
      case "paste":
        return null;
      case "keypress":
        if (!(i.ctrlKey || i.altKey || i.metaKey) || i.ctrlKey && i.altKey) {
          if (i.char && 1 < i.char.length) return i.char;
          if (i.which) return String.fromCharCode(i.which);
        }
        return null;
      case "compositionend":
        return Gh && i.locale !== "ko" ? null : i.data;
      default:
        return null;
    }
  }
  var TA = { color: !0, date: !0, datetime: !0, "datetime-local": !0, email: !0, month: !0, number: !0, password: !0, range: !0, search: !0, tel: !0, text: !0, time: !0, url: !0, week: !0 };
  function Wh(n) {
    var i = n && n.nodeName && n.nodeName.toLowerCase();
    return i === "input" ? !!TA[n.type] : i === "textarea";
  }
  function Yh(n, i, s, d) {
    At(d), i = O2(i, "onChange"), 0 < i.length && (s = new Mc("onChange", "change", null, s, d), n.push({ event: s, listeners: i }));
  }
  var rs = null, ns = null;
  function OA(n) {
    pm(n, 0);
  }
  function D2(n) {
    var i = so(n);
    if (Ye(i)) return n;
  }
  function yA(n, i) {
    if (n === "change") return i;
  }
  var Kh = !1;
  if (f) {
    var kc;
    if (f) {
      var Fc = "oninput" in document;
      if (!Fc) {
        var Xh = document.createElement("div");
        Xh.setAttribute("oninput", "return;"), Fc = typeof Xh.oninput == "function";
      }
      kc = Fc;
    } else kc = !1;
    Kh = kc && (!document.documentMode || 9 < document.documentMode);
  }
  function Qh() {
    rs && (rs.detachEvent("onpropertychange", Jh), ns = rs = null);
  }
  function Jh(n) {
    if (n.propertyName === "value" && D2(ns)) {
      var i = [];
      Yh(i, ns, n, Pe(n)), hi(OA, i);
    }
  }
  function NA(n, i, s) {
    n === "focusin" ? (Qh(), rs = i, ns = s, rs.attachEvent("onpropertychange", Jh)) : n === "focusout" && Qh();
  }
  function LA(n) {
    if (n === "selectionchange" || n === "keyup" || n === "keydown") return D2(ns);
  }
  function MA(n, i) {
    if (n === "click") return D2(i);
  }
  function bA(n, i) {
    if (n === "input" || n === "change") return D2(i);
  }
  function PA(n, i) {
    return n === i && (n !== 0 || 1 / n === 1 / i) || n !== n && i !== i;
  }
  var wn = typeof Object.is == "function" ? Object.is : PA;
  function is(n, i) {
    if (wn(n, i)) return !0;
    if (typeof n != "object" || n === null || typeof i != "object" || i === null) return !1;
    var s = Object.keys(n), d = Object.keys(i);
    if (s.length !== d.length) return !1;
    for (d = 0; d < s.length; d++) {
      var m = s[d];
      if (!p.call(i, m) || !wn(n[m], i[m])) return !1;
    }
    return !0;
  }
  function em(n) {
    for (; n && n.firstChild; ) n = n.firstChild;
    return n;
  }
  function tm(n, i) {
    var s = em(n);
    n = 0;
    for (var d; s; ) {
      if (s.nodeType === 3) {
        if (d = n + s.textContent.length, n <= i && d >= i) return { node: s, offset: i - n };
        n = d;
      }
      e: {
        for (; s; ) {
          if (s.nextSibling) {
            s = s.nextSibling;
            break e;
          }
          s = s.parentNode;
        }
        s = void 0;
      }
      s = em(s);
    }
  }
  function rm(n, i) {
    return n && i ? n === i ? !0 : n && n.nodeType === 3 ? !1 : i && i.nodeType === 3 ? rm(n, i.parentNode) : "contains" in n ? n.contains(i) : n.compareDocumentPosition ? !!(n.compareDocumentPosition(i) & 16) : !1 : !1;
  }
  function nm() {
    for (var n = window, i = nt(); i instanceof n.HTMLIFrameElement; ) {
      try {
        var s = typeof i.contentWindow.location.href == "string";
      } catch (d) {
        s = !1;
      }
      if (s) n = i.contentWindow;
      else break;
      i = nt(n.document);
    }
    return i;
  }
  function xc(n) {
    var i = n && n.nodeName && n.nodeName.toLowerCase();
    return i && (i === "input" && (n.type === "text" || n.type === "search" || n.type === "tel" || n.type === "url" || n.type === "password") || i === "textarea" || n.contentEditable === "true");
  }
  function wA(n) {
    var i = nm(), s = n.focusedElem, d = n.selectionRange;
    if (i !== s && s && s.ownerDocument && rm(s.ownerDocument.documentElement, s)) {
      if (d !== null && xc(s)) {
        if (i = d.start, n = d.end, n === void 0 && (n = i), "selectionStart" in s) s.selectionStart = i, s.selectionEnd = Math.min(n, s.value.length);
        else if (n = (i = s.ownerDocument || document) && i.defaultView || window, n.getSelection) {
          n = n.getSelection();
          var m = s.textContent.length, I = Math.min(d.start, m);
          d = d.end === void 0 ? I : Math.min(d.end, m), !n.extend && I > d && (m = d, d = I, I = m), m = tm(s, I);
          var A = tm(
            s,
            d
          );
          m && A && (n.rangeCount !== 1 || n.anchorNode !== m.node || n.anchorOffset !== m.offset || n.focusNode !== A.node || n.focusOffset !== A.offset) && (i = i.createRange(), i.setStart(m.node, m.offset), n.removeAllRanges(), I > d ? (n.addRange(i), n.extend(A.node, A.offset)) : (i.setEnd(A.node, A.offset), n.addRange(i)));
        }
      }
      for (i = [], n = s; n = n.parentNode; ) n.nodeType === 1 && i.push({ element: n, left: n.scrollLeft, top: n.scrollTop });
      for (typeof s.focus == "function" && s.focus(), s = 0; s < i.length; s++) n = i[s], n.element.scrollLeft = n.left, n.element.scrollTop = n.top;
    }
  }
  var HA = f && "documentMode" in document && 11 >= document.documentMode, no = null, Uc = null, as = null, Bc = !1;
  function im(n, i, s) {
    var d = s.window === s ? s.document : s.nodeType === 9 ? s : s.ownerDocument;
    Bc || no == null || no !== nt(d) || (d = no, "selectionStart" in d && xc(d) ? d = { start: d.selectionStart, end: d.selectionEnd } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = { anchorNode: d.anchorNode, anchorOffset: d.anchorOffset, focusNode: d.focusNode, focusOffset: d.focusOffset }), as && is(as, d) || (as = d, d = O2(Uc, "onSelect"), 0 < d.length && (i = new Mc("onSelect", "select", null, i, s), n.push({ event: i, listeners: d }), i.target = no)));
  }
  function R2(n, i) {
    var s = {};
    return s[n.toLowerCase()] = i.toLowerCase(), s["Webkit" + n] = "webkit" + i, s["Moz" + n] = "moz" + i, s;
  }
  var io = { animationend: R2("Animation", "AnimationEnd"), animationiteration: R2("Animation", "AnimationIteration"), animationstart: R2("Animation", "AnimationStart"), transitionend: R2("Transition", "TransitionEnd") }, $c = {}, am = {};
  f && (am = document.createElement("div").style, "AnimationEvent" in window || (delete io.animationend.animation, delete io.animationiteration.animation, delete io.animationstart.animation), "TransitionEvent" in window || delete io.transitionend.transition);
  function A2(n) {
    if ($c[n]) return $c[n];
    if (!io[n]) return n;
    var i = io[n], s;
    for (s in i) if (i.hasOwnProperty(s) && s in am) return $c[n] = i[s];
    return n;
  }
  var om = A2("animationend"), sm = A2("animationiteration"), lm = A2("animationstart"), cm = A2("transitionend"), um = /* @__PURE__ */ new Map(), fm = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
  function Fi(n, i) {
    um.set(n, i), l(i, [n]);
  }
  for (var Gc = 0; Gc < fm.length; Gc++) {
    var Zc = fm[Gc], VA = Zc.toLowerCase(), kA = Zc[0].toUpperCase() + Zc.slice(1);
    Fi(VA, "on" + kA);
  }
  Fi(om, "onAnimationEnd"), Fi(sm, "onAnimationIteration"), Fi(lm, "onAnimationStart"), Fi("dblclick", "onDoubleClick"), Fi("focusin", "onFocus"), Fi("focusout", "onBlur"), Fi(cm, "onTransitionEnd"), c("onMouseEnter", ["mouseout", "mouseover"]), c("onMouseLeave", ["mouseout", "mouseover"]), c("onPointerEnter", ["pointerout", "pointerover"]), c("onPointerLeave", ["pointerout", "pointerover"]), l("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" ")), l("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" ")), l("onBeforeInput", ["compositionend", "keypress", "textInput", "paste"]), l("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" ")), l("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" ")), l("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
  var os = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), FA = new Set("cancel close invalid load scroll toggle".split(" ").concat(os));
  function dm(n, i, s) {
    var d = n.type || "unknown-event";
    n.currentTarget = s, yr(d, i, void 0, n), n.currentTarget = null;
  }
  function pm(n, i) {
    i = (i & 4) !== 0;
    for (var s = 0; s < n.length; s++) {
      var d = n[s], m = d.event;
      d = d.listeners;
      e: {
        var I = void 0;
        if (i) for (var A = d.length - 1; 0 <= A; A--) {
          var b = d[A], F = b.instance, te = b.currentTarget;
          if (b = b.listener, F !== I && m.isPropagationStopped()) break e;
          dm(m, b, te), I = F;
        }
        else for (A = 0; A < d.length; A++) {
          if (b = d[A], F = b.instance, te = b.currentTarget, b = b.listener, F !== I && m.isPropagationStopped()) break e;
          dm(m, b, te), I = F;
        }
      }
    }
    if (gr) throw n = Qn, gr = !1, Qn = null, n;
  }
  function Ut(n, i) {
    var s = i[Qc];
    s === void 0 && (s = i[Qc] = /* @__PURE__ */ new Set());
    var d = n + "__bubble";
    s.has(d) || (hm(i, n, 2, !1), s.add(d));
  }
  function jc(n, i, s) {
    var d = 0;
    i && (d |= 4), hm(s, n, d, i);
  }
  var T2 = "_reactListening" + Math.random().toString(36).slice(2);
  function ss(n) {
    if (!n[T2]) {
      n[T2] = !0, a.forEach(function(s) {
        s !== "selectionchange" && (FA.has(s) || jc(s, !1, n), jc(s, !0, n));
      });
      var i = n.nodeType === 9 ? n : n.ownerDocument;
      i === null || i[T2] || (i[T2] = !0, jc("selectionchange", !1, i));
    }
  }
  function hm(n, i, s, d) {
    switch (Qo(i)) {
      case 1:
        var m = Nr;
        break;
      case 4:
        m = Xa;
        break;
      default:
        m = Xo;
    }
    s = m.bind(null, i, s, n), m = void 0, !Xn || i !== "touchstart" && i !== "touchmove" && i !== "wheel" || (m = !0), d ? m !== void 0 ? n.addEventListener(i, s, { capture: !0, passive: m }) : n.addEventListener(i, s, !0) : m !== void 0 ? n.addEventListener(i, s, { passive: m }) : n.addEventListener(i, s, !1);
  }
  function zc(n, i, s, d, m) {
    var I = d;
    if ((i & 1) === 0 && (i & 2) === 0 && d !== null) e: for (; ; ) {
      if (d === null) return;
      var A = d.tag;
      if (A === 3 || A === 4) {
        var b = d.stateNode.containerInfo;
        if (b === m || b.nodeType === 8 && b.parentNode === m) break;
        if (A === 4) for (A = d.return; A !== null; ) {
          var F = A.tag;
          if ((F === 3 || F === 4) && (F = A.stateNode.containerInfo, F === m || F.nodeType === 8 && F.parentNode === m))
            return;
          A = A.return;
        }
        for (; b !== null; ) {
          if (A = _a(b), A === null) return;
          if (F = A.tag, F === 5 || F === 6) {
            d = I = A;
            continue e;
          }
          b = b.parentNode;
        }
      }
      d = d.return;
    }
    hi(function() {
      var te = I, me = Pe(s), Ce = [];
      e: {
        var he = um.get(n);
        if (he !== void 0) {
          var He = Mc, Be = n;
          switch (n) {
            case "keypress":
              if (I2(s) === 0) break e;
            case "keydown":
            case "keyup":
              He = hA;
              break;
            case "focusin":
              Be = "focus", He = wc;
              break;
            case "focusout":
              Be = "blur", He = wc;
              break;
            case "beforeblur":
            case "afterblur":
              He = wc;
              break;
            case "click":
              if (s.button === 2) break e;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              He = Uh;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              He = rA;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              He = EA;
              break;
            case om:
            case sm:
            case lm:
              He = aA;
              break;
            case cm:
              He = SA;
              break;
            case "scroll":
              He = eA;
              break;
            case "wheel":
              He = vA;
              break;
            case "copy":
            case "cut":
            case "paste":
              He = sA;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              He = $h;
          }
          var Ge = (i & 4) !== 0, ar = !Ge && n === "scroll", W = Ge ? he !== null ? he + "Capture" : null : he;
          Ge = [];
          for (var x = te, Q; x !== null; ) {
            Q = x;
            var ve = Q.stateNode;
            if (Q.tag === 5 && ve !== null && (Q = ve, W !== null && (ve = Fr(x, W), ve != null && Ge.push(ls(x, ve, Q)))), ar) break;
            x = x.return;
          }
          0 < Ge.length && (he = new He(he, Be, null, s, me), Ce.push({ event: he, listeners: Ge }));
        }
      }
      if ((i & 7) === 0) {
        e: {
          if (he = n === "mouseover" || n === "pointerover", He = n === "mouseout" || n === "pointerout", he && s !== Ie && (Be = s.relatedTarget || s.fromElement) && (_a(Be) || Be[_i])) break e;
          if ((He || he) && (he = me.window === me ? me : (he = me.ownerDocument) ? he.defaultView || he.parentWindow : window, He ? (Be = s.relatedTarget || s.toElement, He = te, Be = Be ? _a(Be) : null, Be !== null && (ar = mn(Be), Be !== ar || Be.tag !== 5 && Be.tag !== 6) && (Be = null)) : (He = null, Be = te), He !== Be)) {
            if (Ge = Uh, ve = "onMouseLeave", W = "onMouseEnter", x = "mouse", (n === "pointerout" || n === "pointerover") && (Ge = $h, ve = "onPointerLeave", W = "onPointerEnter", x = "pointer"), ar = He == null ? he : so(He), Q = Be == null ? he : so(Be), he = new Ge(ve, x + "leave", He, s, me), he.target = ar, he.relatedTarget = Q, ve = null, _a(me) === te && (Ge = new Ge(W, x + "enter", Be, s, me), Ge.target = Q, Ge.relatedTarget = ar, ve = Ge), ar = ve, He && Be) t: {
              for (Ge = He, W = Be, x = 0, Q = Ge; Q; Q = ao(Q)) x++;
              for (Q = 0, ve = W; ve; ve = ao(ve)) Q++;
              for (; 0 < x - Q; ) Ge = ao(Ge), x--;
              for (; 0 < Q - x; ) W = ao(W), Q--;
              for (; x--; ) {
                if (Ge === W || W !== null && Ge === W.alternate) break t;
                Ge = ao(Ge), W = ao(W);
              }
              Ge = null;
            }
            else Ge = null;
            He !== null && mm(Ce, he, He, Ge, !1), Be !== null && ar !== null && mm(Ce, ar, Be, Ge, !0);
          }
        }
        e: {
          if (he = te ? so(te) : window, He = he.nodeName && he.nodeName.toLowerCase(), He === "select" || He === "input" && he.type === "file") var Ze = yA;
          else if (Wh(he)) if (Kh) Ze = bA;
          else {
            Ze = LA;
            var qe = NA;
          }
          else (He = he.nodeName) && He.toLowerCase() === "input" && (he.type === "checkbox" || he.type === "radio") && (Ze = MA);
          if (Ze && (Ze = Ze(n, te))) {
            Yh(Ce, Ze, s, me);
            break e;
          }
          qe && qe(n, he, te), n === "focusout" && (qe = he._wrapperState) && qe.controlled && he.type === "number" && je(he, "number", he.value);
        }
        switch (qe = te ? so(te) : window, n) {
          case "focusin":
            (Wh(qe) || qe.contentEditable === "true") && (no = qe, Uc = te, as = null);
            break;
          case "focusout":
            as = Uc = no = null;
            break;
          case "mousedown":
            Bc = !0;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            Bc = !1, im(Ce, s, me);
            break;
          case "selectionchange":
            if (HA) break;
          case "keydown":
          case "keyup":
            im(Ce, s, me);
        }
        var We;
        if (Vc) e: {
          switch (n) {
            case "compositionstart":
              var tt = "onCompositionStart";
              break e;
            case "compositionend":
              tt = "onCompositionEnd";
              break e;
            case "compositionupdate":
              tt = "onCompositionUpdate";
              break e;
          }
          tt = void 0;
        }
        else ro ? zh(n, s) && (tt = "onCompositionEnd") : n === "keydown" && s.keyCode === 229 && (tt = "onCompositionStart");
        tt && (Gh && s.locale !== "ko" && (ro || tt !== "onCompositionStart" ? tt === "onCompositionEnd" && ro && (We = Fh()) : (Pn = me, eo = "value" in Pn ? Pn.value : Pn.textContent, ro = !0)), qe = O2(te, tt), 0 < qe.length && (tt = new Bh(tt, n, null, s, me), Ce.push({ event: tt, listeners: qe }), We ? tt.data = We : (We = qh(s), We !== null && (tt.data = We)))), (We = DA ? RA(n, s) : AA(n, s)) && (te = O2(te, "onBeforeInput"), 0 < te.length && (me = new Bh("onBeforeInput", "beforeinput", null, s, me), Ce.push({ event: me, listeners: te }), me.data = We));
      }
      pm(Ce, i);
    });
  }
  function ls(n, i, s) {
    return { instance: n, listener: i, currentTarget: s };
  }
  function O2(n, i) {
    for (var s = i + "Capture", d = []; n !== null; ) {
      var m = n, I = m.stateNode;
      m.tag === 5 && I !== null && (m = I, I = Fr(n, s), I != null && d.unshift(ls(n, I, m)), I = Fr(n, i), I != null && d.push(ls(n, I, m))), n = n.return;
    }
    return d;
  }
  function ao(n) {
    if (n === null) return null;
    do
      n = n.return;
    while (n && n.tag !== 5);
    return n || null;
  }
  function mm(n, i, s, d, m) {
    for (var I = i._reactName, A = []; s !== null && s !== d; ) {
      var b = s, F = b.alternate, te = b.stateNode;
      if (F !== null && F === d) break;
      b.tag === 5 && te !== null && (b = te, m ? (F = Fr(s, I), F != null && A.unshift(ls(s, F, b))) : m || (F = Fr(s, I), F != null && A.push(ls(s, F, b)))), s = s.return;
    }
    A.length !== 0 && n.push({ event: i, listeners: A });
  }
  var xA = /\r\n?/g, UA = /\u0000|\uFFFD/g;
  function _m(n) {
    return (typeof n == "string" ? n : "" + n).replace(xA, `
`).replace(UA, "");
  }
  function y2(n, i, s) {
    if (i = _m(i), _m(n) !== i && s) throw Error(t(425));
  }
  function N2() {
  }
  var qc = null, Wc = null;
  function Yc(n, i) {
    return n === "textarea" || n === "noscript" || typeof i.children == "string" || typeof i.children == "number" || typeof i.dangerouslySetInnerHTML == "object" && i.dangerouslySetInnerHTML !== null && i.dangerouslySetInnerHTML.__html != null;
  }
  var Kc = typeof setTimeout == "function" ? setTimeout : void 0, BA = typeof clearTimeout == "function" ? clearTimeout : void 0, Em = typeof Promise == "function" ? Promise : void 0, $A = typeof queueMicrotask == "function" ? queueMicrotask : typeof Em != "undefined" ? function(n) {
    return Em.resolve(null).then(n).catch(GA);
  } : Kc;
  function GA(n) {
    setTimeout(function() {
      throw n;
    });
  }
  function Xc(n, i) {
    var s = i, d = 0;
    do {
      var m = s.nextSibling;
      if (n.removeChild(s), m && m.nodeType === 8) if (s = m.data, s === "/$") {
        if (d === 0) {
          n.removeChild(m), pe(i);
          return;
        }
        d--;
      } else s !== "$" && s !== "$?" && s !== "$!" || d++;
      s = m;
    } while (s);
    pe(i);
  }
  function xi(n) {
    for (; n != null; n = n.nextSibling) {
      var i = n.nodeType;
      if (i === 1 || i === 3) break;
      if (i === 8) {
        if (i = n.data, i === "$" || i === "$!" || i === "$?") break;
        if (i === "/$") return null;
      }
    }
    return n;
  }
  function Cm(n) {
    n = n.previousSibling;
    for (var i = 0; n; ) {
      if (n.nodeType === 8) {
        var s = n.data;
        if (s === "$" || s === "$!" || s === "$?") {
          if (i === 0) return n;
          i--;
        } else s === "/$" && i++;
      }
      n = n.previousSibling;
    }
    return null;
  }
  var oo = Math.random().toString(36).slice(2), ni = "__reactFiber$" + oo, cs = "__reactProps$" + oo, _i = "__reactContainer$" + oo, Qc = "__reactEvents$" + oo, ZA = "__reactListeners$" + oo, jA = "__reactHandles$" + oo;
  function _a(n) {
    var i = n[ni];
    if (i) return i;
    for (var s = n.parentNode; s; ) {
      if (i = s[_i] || s[ni]) {
        if (s = i.alternate, i.child !== null || s !== null && s.child !== null) for (n = Cm(n); n !== null; ) {
          if (s = n[ni]) return s;
          n = Cm(n);
        }
        return i;
      }
      n = s, s = n.parentNode;
    }
    return null;
  }
  function us(n) {
    return n = n[ni] || n[_i], !n || n.tag !== 5 && n.tag !== 6 && n.tag !== 13 && n.tag !== 3 ? null : n;
  }
  function so(n) {
    if (n.tag === 5 || n.tag === 6) return n.stateNode;
    throw Error(t(33));
  }
  function L2(n) {
    return n[cs] || null;
  }
  var Jc = [], lo = -1;
  function Ui(n) {
    return { current: n };
  }
  function Bt(n) {
    0 > lo || (n.current = Jc[lo], Jc[lo] = null, lo--);
  }
  function kt(n, i) {
    lo++, Jc[lo] = n.current, n.current = i;
  }
  var Bi = {}, Lr = Ui(Bi), zr = Ui(!1), Ea = Bi;
  function co(n, i) {
    var s = n.type.contextTypes;
    if (!s) return Bi;
    var d = n.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === i) return d.__reactInternalMemoizedMaskedChildContext;
    var m = {}, I;
    for (I in s) m[I] = i[I];
    return d && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = i, n.__reactInternalMemoizedMaskedChildContext = m), m;
  }
  function qr(n) {
    return n = n.childContextTypes, n != null;
  }
  function M2() {
    Bt(zr), Bt(Lr);
  }
  function Sm(n, i, s) {
    if (Lr.current !== Bi) throw Error(t(168));
    kt(Lr, i), kt(zr, s);
  }
  function Im(n, i, s) {
    var d = n.stateNode;
    if (i = i.childContextTypes, typeof d.getChildContext != "function") return s;
    d = d.getChildContext();
    for (var m in d) if (!(m in i)) throw Error(t(108, Oe(n) || "Unknown", m));
    return K({}, s, d);
  }
  function b2(n) {
    return n = (n = n.stateNode) && n.__reactInternalMemoizedMergedChildContext || Bi, Ea = Lr.current, kt(Lr, n), kt(zr, zr.current), !0;
  }
  function vm(n, i, s) {
    var d = n.stateNode;
    if (!d) throw Error(t(169));
    s ? (n = Im(n, i, Ea), d.__reactInternalMemoizedMergedChildContext = n, Bt(zr), Bt(Lr), kt(Lr, n)) : Bt(zr), kt(zr, s);
  }
  var Ei = null, P2 = !1, eu = !1;
  function gm(n) {
    Ei === null ? Ei = [n] : Ei.push(n);
  }
  function zA(n) {
    P2 = !0, gm(n);
  }
  function $i() {
    if (!eu && Ei !== null) {
      eu = !0;
      var n = 0, i = yt;
      try {
        var s = Ei;
        for (yt = 1; n < s.length; n++) {
          var d = s[n];
          do
            d = d(!0);
          while (d !== null);
        }
        Ei = null, P2 = !1;
      } catch (m) {
        throw Ei !== null && (Ei = Ei.slice(n + 1)), fe(hr, $i), m;
      } finally {
        yt = i, eu = !1;
      }
    }
    return null;
  }
  var uo = [], fo = 0, w2 = null, H2 = 0, _n = [], En = 0, Ca = null, Ci = 1, Si = "";
  function Sa(n, i) {
    uo[fo++] = H2, uo[fo++] = w2, w2 = n, H2 = i;
  }
  function Dm(n, i, s) {
    _n[En++] = Ci, _n[En++] = Si, _n[En++] = Ca, Ca = n;
    var d = Ci;
    n = Si;
    var m = 32 - nn(d) - 1;
    d &= ~(1 << m), s += 1;
    var I = 32 - nn(i) + m;
    if (30 < I) {
      var A = m - m % 5;
      I = (d & (1 << A) - 1).toString(32), d >>= A, m -= A, Ci = 1 << 32 - nn(i) + m | s << m | d, Si = I + n;
    } else Ci = 1 << I | s << m | d, Si = n;
  }
  function tu(n) {
    n.return !== null && (Sa(n, 1), Dm(n, 1, 0));
  }
  function ru(n) {
    for (; n === w2; ) w2 = uo[--fo], uo[fo] = null, H2 = uo[--fo], uo[fo] = null;
    for (; n === Ca; ) Ca = _n[--En], _n[En] = null, Si = _n[--En], _n[En] = null, Ci = _n[--En], _n[En] = null;
  }
  var on = null, sn = null, Gt = !1, Hn = null;
  function Rm(n, i) {
    var s = vn(5, null, null, 0);
    s.elementType = "DELETED", s.stateNode = i, s.return = n, i = n.deletions, i === null ? (n.deletions = [s], n.flags |= 16) : i.push(s);
  }
  function Am(n, i) {
    switch (n.tag) {
      case 5:
        var s = n.type;
        return i = i.nodeType !== 1 || s.toLowerCase() !== i.nodeName.toLowerCase() ? null : i, i !== null ? (n.stateNode = i, on = n, sn = xi(i.firstChild), !0) : !1;
      case 6:
        return i = n.pendingProps === "" || i.nodeType !== 3 ? null : i, i !== null ? (n.stateNode = i, on = n, sn = null, !0) : !1;
      case 13:
        return i = i.nodeType !== 8 ? null : i, i !== null ? (s = Ca !== null ? { id: Ci, overflow: Si } : null, n.memoizedState = { dehydrated: i, treeContext: s, retryLane: 1073741824 }, s = vn(18, null, null, 0), s.stateNode = i, s.return = n, n.child = s, on = n, sn = null, !0) : !1;
      default:
        return !1;
    }
  }
  function nu(n) {
    return (n.mode & 1) !== 0 && (n.flags & 128) === 0;
  }
  function iu(n) {
    if (Gt) {
      var i = sn;
      if (i) {
        var s = i;
        if (!Am(n, i)) {
          if (nu(n)) throw Error(t(418));
          i = xi(s.nextSibling);
          var d = on;
          i && Am(n, i) ? Rm(d, s) : (n.flags = n.flags & -4097 | 2, Gt = !1, on = n);
        }
      } else {
        if (nu(n)) throw Error(t(418));
        n.flags = n.flags & -4097 | 2, Gt = !1, on = n;
      }
    }
  }
  function Tm(n) {
    for (n = n.return; n !== null && n.tag !== 5 && n.tag !== 3 && n.tag !== 13; ) n = n.return;
    on = n;
  }
  function V2(n) {
    if (n !== on) return !1;
    if (!Gt) return Tm(n), Gt = !0, !1;
    var i;
    if ((i = n.tag !== 3) && !(i = n.tag !== 5) && (i = n.type, i = i !== "head" && i !== "body" && !Yc(n.type, n.memoizedProps)), i && (i = sn)) {
      if (nu(n)) throw Om(), Error(t(418));
      for (; i; ) Rm(n, i), i = xi(i.nextSibling);
    }
    if (Tm(n), n.tag === 13) {
      if (n = n.memoizedState, n = n !== null ? n.dehydrated : null, !n) throw Error(t(317));
      e: {
        for (n = n.nextSibling, i = 0; n; ) {
          if (n.nodeType === 8) {
            var s = n.data;
            if (s === "/$") {
              if (i === 0) {
                sn = xi(n.nextSibling);
                break e;
              }
              i--;
            } else s !== "$" && s !== "$!" && s !== "$?" || i++;
          }
          n = n.nextSibling;
        }
        sn = null;
      }
    } else sn = on ? xi(n.stateNode.nextSibling) : null;
    return !0;
  }
  function Om() {
    for (var n = sn; n; ) n = xi(n.nextSibling);
  }
  function po() {
    sn = on = null, Gt = !1;
  }
  function au(n) {
    Hn === null ? Hn = [n] : Hn.push(n);
  }
  var qA = T.ReactCurrentBatchConfig;
  function fs(n, i, s) {
    if (n = s.ref, n !== null && typeof n != "function" && typeof n != "object") {
      if (s._owner) {
        if (s = s._owner, s) {
          if (s.tag !== 1) throw Error(t(309));
          var d = s.stateNode;
        }
        if (!d) throw Error(t(147, n));
        var m = d, I = "" + n;
        return i !== null && i.ref !== null && typeof i.ref == "function" && i.ref._stringRef === I ? i.ref : (i = function(A) {
          var b = m.refs;
          A === null ? delete b[I] : b[I] = A;
        }, i._stringRef = I, i);
      }
      if (typeof n != "string") throw Error(t(284));
      if (!s._owner) throw Error(t(290, n));
    }
    return n;
  }
  function k2(n, i) {
    throw n = Object.prototype.toString.call(i), Error(t(31, n === "[object Object]" ? "object with keys {" + Object.keys(i).join(", ") + "}" : n));
  }
  function ym(n) {
    var i = n._init;
    return i(n._payload);
  }
  function Nm(n) {
    function i(W, x) {
      if (n) {
        var Q = W.deletions;
        Q === null ? (W.deletions = [x], W.flags |= 16) : Q.push(x);
      }
    }
    function s(W, x) {
      if (!n) return null;
      for (; x !== null; ) i(W, x), x = x.sibling;
      return null;
    }
    function d(W, x) {
      for (W = /* @__PURE__ */ new Map(); x !== null; ) x.key !== null ? W.set(x.key, x) : W.set(x.index, x), x = x.sibling;
      return W;
    }
    function m(W, x) {
      return W = Ki(W, x), W.index = 0, W.sibling = null, W;
    }
    function I(W, x, Q) {
      return W.index = Q, n ? (Q = W.alternate, Q !== null ? (Q = Q.index, Q < x ? (W.flags |= 2, x) : Q) : (W.flags |= 2, x)) : (W.flags |= 1048576, x);
    }
    function A(W) {
      return n && W.alternate === null && (W.flags |= 2), W;
    }
    function b(W, x, Q, ve) {
      return x === null || x.tag !== 6 ? (x = Ku(Q, W.mode, ve), x.return = W, x) : (x = m(x, Q), x.return = W, x);
    }
    function F(W, x, Q, ve) {
      var Ze = Q.type;
      return Ze === M ? me(W, x, Q.props.children, ve, Q.key) : x !== null && (x.elementType === Ze || typeof Ze == "object" && Ze !== null && Ze.$$typeof === se && ym(Ze) === x.type) ? (ve = m(x, Q.props), ve.ref = fs(W, x, Q), ve.return = W, ve) : (ve = sl(Q.type, Q.key, Q.props, null, W.mode, ve), ve.ref = fs(W, x, Q), ve.return = W, ve);
    }
    function te(W, x, Q, ve) {
      return x === null || x.tag !== 4 || x.stateNode.containerInfo !== Q.containerInfo || x.stateNode.implementation !== Q.implementation ? (x = Xu(Q, W.mode, ve), x.return = W, x) : (x = m(x, Q.children || []), x.return = W, x);
    }
    function me(W, x, Q, ve, Ze) {
      return x === null || x.tag !== 7 ? (x = Oa(Q, W.mode, ve, Ze), x.return = W, x) : (x = m(x, Q), x.return = W, x);
    }
    function Ce(W, x, Q) {
      if (typeof x == "string" && x !== "" || typeof x == "number") return x = Ku("" + x, W.mode, Q), x.return = W, x;
      if (typeof x == "object" && x !== null) {
        switch (x.$$typeof) {
          case L:
            return Q = sl(x.type, x.key, x.props, null, W.mode, Q), Q.ref = fs(W, null, x), Q.return = W, Q;
          case P:
            return x = Xu(x, W.mode, Q), x.return = W, x;
          case se:
            var ve = x._init;
            return Ce(W, ve(x._payload), Q);
        }
        if (st(x) || X(x)) return x = Oa(x, W.mode, Q, null), x.return = W, x;
        k2(W, x);
      }
      return null;
    }
    function he(W, x, Q, ve) {
      var Ze = x !== null ? x.key : null;
      if (typeof Q == "string" && Q !== "" || typeof Q == "number") return Ze !== null ? null : b(W, x, "" + Q, ve);
      if (typeof Q == "object" && Q !== null) {
        switch (Q.$$typeof) {
          case L:
            return Q.key === Ze ? F(W, x, Q, ve) : null;
          case P:
            return Q.key === Ze ? te(W, x, Q, ve) : null;
          case se:
            return Ze = Q._init, he(
              W,
              x,
              Ze(Q._payload),
              ve
            );
        }
        if (st(Q) || X(Q)) return Ze !== null ? null : me(W, x, Q, ve, null);
        k2(W, Q);
      }
      return null;
    }
    function He(W, x, Q, ve, Ze) {
      if (typeof ve == "string" && ve !== "" || typeof ve == "number") return W = W.get(Q) || null, b(x, W, "" + ve, Ze);
      if (typeof ve == "object" && ve !== null) {
        switch (ve.$$typeof) {
          case L:
            return W = W.get(ve.key === null ? Q : ve.key) || null, F(x, W, ve, Ze);
          case P:
            return W = W.get(ve.key === null ? Q : ve.key) || null, te(x, W, ve, Ze);
          case se:
            var qe = ve._init;
            return He(W, x, Q, qe(ve._payload), Ze);
        }
        if (st(ve) || X(ve)) return W = W.get(Q) || null, me(x, W, ve, Ze, null);
        k2(x, ve);
      }
      return null;
    }
    function Be(W, x, Q, ve) {
      for (var Ze = null, qe = null, We = x, tt = x = 0, Er = null; We !== null && tt < Q.length; tt++) {
        We.index > tt ? (Er = We, We = null) : Er = We.sibling;
        var Tt = he(W, We, Q[tt], ve);
        if (Tt === null) {
          We === null && (We = Er);
          break;
        }
        n && We && Tt.alternate === null && i(W, We), x = I(Tt, x, tt), qe === null ? Ze = Tt : qe.sibling = Tt, qe = Tt, We = Er;
      }
      if (tt === Q.length) return s(W, We), Gt && Sa(W, tt), Ze;
      if (We === null) {
        for (; tt < Q.length; tt++) We = Ce(W, Q[tt], ve), We !== null && (x = I(We, x, tt), qe === null ? Ze = We : qe.sibling = We, qe = We);
        return Gt && Sa(W, tt), Ze;
      }
      for (We = d(W, We); tt < Q.length; tt++) Er = He(We, W, tt, Q[tt], ve), Er !== null && (n && Er.alternate !== null && We.delete(Er.key === null ? tt : Er.key), x = I(Er, x, tt), qe === null ? Ze = Er : qe.sibling = Er, qe = Er);
      return n && We.forEach(function(Xi) {
        return i(W, Xi);
      }), Gt && Sa(W, tt), Ze;
    }
    function Ge(W, x, Q, ve) {
      var Ze = X(Q);
      if (typeof Ze != "function") throw Error(t(150));
      if (Q = Ze.call(Q), Q == null) throw Error(t(151));
      for (var qe = Ze = null, We = x, tt = x = 0, Er = null, Tt = Q.next(); We !== null && !Tt.done; tt++, Tt = Q.next()) {
        We.index > tt ? (Er = We, We = null) : Er = We.sibling;
        var Xi = he(W, We, Tt.value, ve);
        if (Xi === null) {
          We === null && (We = Er);
          break;
        }
        n && We && Xi.alternate === null && i(W, We), x = I(Xi, x, tt), qe === null ? Ze = Xi : qe.sibling = Xi, qe = Xi, We = Er;
      }
      if (Tt.done) return s(
        W,
        We
      ), Gt && Sa(W, tt), Ze;
      if (We === null) {
        for (; !Tt.done; tt++, Tt = Q.next()) Tt = Ce(W, Tt.value, ve), Tt !== null && (x = I(Tt, x, tt), qe === null ? Ze = Tt : qe.sibling = Tt, qe = Tt);
        return Gt && Sa(W, tt), Ze;
      }
      for (We = d(W, We); !Tt.done; tt++, Tt = Q.next()) Tt = He(We, W, tt, Tt.value, ve), Tt !== null && (n && Tt.alternate !== null && We.delete(Tt.key === null ? tt : Tt.key), x = I(Tt, x, tt), qe === null ? Ze = Tt : qe.sibling = Tt, qe = Tt);
      return n && We.forEach(function(TT) {
        return i(W, TT);
      }), Gt && Sa(W, tt), Ze;
    }
    function ar(W, x, Q, ve) {
      if (typeof Q == "object" && Q !== null && Q.type === M && Q.key === null && (Q = Q.props.children), typeof Q == "object" && Q !== null) {
        switch (Q.$$typeof) {
          case L:
            e: {
              for (var Ze = Q.key, qe = x; qe !== null; ) {
                if (qe.key === Ze) {
                  if (Ze = Q.type, Ze === M) {
                    if (qe.tag === 7) {
                      s(W, qe.sibling), x = m(qe, Q.props.children), x.return = W, W = x;
                      break e;
                    }
                  } else if (qe.elementType === Ze || typeof Ze == "object" && Ze !== null && Ze.$$typeof === se && ym(Ze) === qe.type) {
                    s(W, qe.sibling), x = m(qe, Q.props), x.ref = fs(W, qe, Q), x.return = W, W = x;
                    break e;
                  }
                  s(W, qe);
                  break;
                } else i(W, qe);
                qe = qe.sibling;
              }
              Q.type === M ? (x = Oa(Q.props.children, W.mode, ve, Q.key), x.return = W, W = x) : (ve = sl(Q.type, Q.key, Q.props, null, W.mode, ve), ve.ref = fs(W, x, Q), ve.return = W, W = ve);
            }
            return A(W);
          case P:
            e: {
              for (qe = Q.key; x !== null; ) {
                if (x.key === qe) if (x.tag === 4 && x.stateNode.containerInfo === Q.containerInfo && x.stateNode.implementation === Q.implementation) {
                  s(W, x.sibling), x = m(x, Q.children || []), x.return = W, W = x;
                  break e;
                } else {
                  s(W, x);
                  break;
                }
                else i(W, x);
                x = x.sibling;
              }
              x = Xu(Q, W.mode, ve), x.return = W, W = x;
            }
            return A(W);
          case se:
            return qe = Q._init, ar(W, x, qe(Q._payload), ve);
        }
        if (st(Q)) return Be(W, x, Q, ve);
        if (X(Q)) return Ge(W, x, Q, ve);
        k2(W, Q);
      }
      return typeof Q == "string" && Q !== "" || typeof Q == "number" ? (Q = "" + Q, x !== null && x.tag === 6 ? (s(W, x.sibling), x = m(x, Q), x.return = W, W = x) : (s(W, x), x = Ku(Q, W.mode, ve), x.return = W, W = x), A(W)) : s(W, x);
    }
    return ar;
  }
  var ho = Nm(!0), Lm = Nm(!1), F2 = Ui(null), x2 = null, mo = null, ou = null;
  function su() {
    ou = mo = x2 = null;
  }
  function lu(n) {
    var i = F2.current;
    Bt(F2), n._currentValue = i;
  }
  function cu(n, i, s) {
    for (; n !== null; ) {
      var d = n.alternate;
      if ((n.childLanes & i) !== i ? (n.childLanes |= i, d !== null && (d.childLanes |= i)) : d !== null && (d.childLanes & i) !== i && (d.childLanes |= i), n === s) break;
      n = n.return;
    }
  }
  function _o(n, i) {
    x2 = n, ou = mo = null, n = n.dependencies, n !== null && n.firstContext !== null && ((n.lanes & i) !== 0 && (Wr = !0), n.firstContext = null);
  }
  function Cn(n) {
    var i = n._currentValue;
    if (ou !== n) if (n = { context: n, memoizedValue: i, next: null }, mo === null) {
      if (x2 === null) throw Error(t(308));
      mo = n, x2.dependencies = { lanes: 0, firstContext: n };
    } else mo = mo.next = n;
    return i;
  }
  var Ia = null;
  function uu(n) {
    Ia === null ? Ia = [n] : Ia.push(n);
  }
  function Mm(n, i, s, d) {
    var m = i.interleaved;
    return m === null ? (s.next = s, uu(i)) : (s.next = m.next, m.next = s), i.interleaved = s, Ii(n, d);
  }
  function Ii(n, i) {
    n.lanes |= i;
    var s = n.alternate;
    for (s !== null && (s.lanes |= i), s = n, n = n.return; n !== null; ) n.childLanes |= i, s = n.alternate, s !== null && (s.childLanes |= i), s = n, n = n.return;
    return s.tag === 3 ? s.stateNode : null;
  }
  var Gi = !1;
  function fu(n) {
    n.updateQueue = { baseState: n.memoizedState, firstBaseUpdate: null, lastBaseUpdate: null, shared: { pending: null, interleaved: null, lanes: 0 }, effects: null };
  }
  function bm(n, i) {
    n = n.updateQueue, i.updateQueue === n && (i.updateQueue = { baseState: n.baseState, firstBaseUpdate: n.firstBaseUpdate, lastBaseUpdate: n.lastBaseUpdate, shared: n.shared, effects: n.effects });
  }
  function vi(n, i) {
    return { eventTime: n, lane: i, tag: 0, payload: null, callback: null, next: null };
  }
  function Zi(n, i, s) {
    var d = n.updateQueue;
    if (d === null) return null;
    if (d = d.shared, (Dt & 2) !== 0) {
      var m = d.pending;
      return m === null ? i.next = i : (i.next = m.next, m.next = i), d.pending = i, Ii(n, s);
    }
    return m = d.interleaved, m === null ? (i.next = i, uu(d)) : (i.next = m.next, m.next = i), d.interleaved = i, Ii(n, s);
  }
  function U2(n, i, s) {
    if (i = i.updateQueue, i !== null && (i = i.shared, (s & 4194240) !== 0)) {
      var d = i.lanes;
      d &= n.pendingLanes, s |= d, i.lanes = s, Wo(n, s);
    }
  }
  function Pm(n, i) {
    var s = n.updateQueue, d = n.alternate;
    if (d !== null && (d = d.updateQueue, s === d)) {
      var m = null, I = null;
      if (s = s.firstBaseUpdate, s !== null) {
        do {
          var A = { eventTime: s.eventTime, lane: s.lane, tag: s.tag, payload: s.payload, callback: s.callback, next: null };
          I === null ? m = I = A : I = I.next = A, s = s.next;
        } while (s !== null);
        I === null ? m = I = i : I = I.next = i;
      } else m = I = i;
      s = { baseState: d.baseState, firstBaseUpdate: m, lastBaseUpdate: I, shared: d.shared, effects: d.effects }, n.updateQueue = s;
      return;
    }
    n = s.lastBaseUpdate, n === null ? s.firstBaseUpdate = i : n.next = i, s.lastBaseUpdate = i;
  }
  function B2(n, i, s, d) {
    var m = n.updateQueue;
    Gi = !1;
    var I = m.firstBaseUpdate, A = m.lastBaseUpdate, b = m.shared.pending;
    if (b !== null) {
      m.shared.pending = null;
      var F = b, te = F.next;
      F.next = null, A === null ? I = te : A.next = te, A = F;
      var me = n.alternate;
      me !== null && (me = me.updateQueue, b = me.lastBaseUpdate, b !== A && (b === null ? me.firstBaseUpdate = te : b.next = te, me.lastBaseUpdate = F));
    }
    if (I !== null) {
      var Ce = m.baseState;
      A = 0, me = te = F = null, b = I;
      do {
        var he = b.lane, He = b.eventTime;
        if ((d & he) === he) {
          me !== null && (me = me.next = {
            eventTime: He,
            lane: 0,
            tag: b.tag,
            payload: b.payload,
            callback: b.callback,
            next: null
          });
          e: {
            var Be = n, Ge = b;
            switch (he = i, He = s, Ge.tag) {
              case 1:
                if (Be = Ge.payload, typeof Be == "function") {
                  Ce = Be.call(He, Ce, he);
                  break e;
                }
                Ce = Be;
                break e;
              case 3:
                Be.flags = Be.flags & -65537 | 128;
              case 0:
                if (Be = Ge.payload, he = typeof Be == "function" ? Be.call(He, Ce, he) : Be, he == null) break e;
                Ce = K({}, Ce, he);
                break e;
              case 2:
                Gi = !0;
            }
          }
          b.callback !== null && b.lane !== 0 && (n.flags |= 64, he = m.effects, he === null ? m.effects = [b] : he.push(b));
        } else He = { eventTime: He, lane: he, tag: b.tag, payload: b.payload, callback: b.callback, next: null }, me === null ? (te = me = He, F = Ce) : me = me.next = He, A |= he;
        if (b = b.next, b === null) {
          if (b = m.shared.pending, b === null) break;
          he = b, b = he.next, he.next = null, m.lastBaseUpdate = he, m.shared.pending = null;
        }
      } while (!0);
      if (me === null && (F = Ce), m.baseState = F, m.firstBaseUpdate = te, m.lastBaseUpdate = me, i = m.shared.interleaved, i !== null) {
        m = i;
        do
          A |= m.lane, m = m.next;
        while (m !== i);
      } else I === null && (m.shared.lanes = 0);
      Da |= A, n.lanes = A, n.memoizedState = Ce;
    }
  }
  function wm(n, i, s) {
    if (n = i.effects, i.effects = null, n !== null) for (i = 0; i < n.length; i++) {
      var d = n[i], m = d.callback;
      if (m !== null) {
        if (d.callback = null, d = s, typeof m != "function") throw Error(t(191, m));
        m.call(d);
      }
    }
  }
  var ds = {}, ii = Ui(ds), ps = Ui(ds), hs = Ui(ds);
  function va(n) {
    if (n === ds) throw Error(t(174));
    return n;
  }
  function du(n, i) {
    switch (kt(hs, i), kt(ps, n), kt(ii, ds), n = i.nodeType, n) {
      case 9:
      case 11:
        i = (i = i.documentElement) ? i.namespaceURI : ke(null, "");
        break;
      default:
        n = n === 8 ? i.parentNode : i, i = n.namespaceURI || null, n = n.tagName, i = ke(i, n);
    }
    Bt(ii), kt(ii, i);
  }
  function Eo() {
    Bt(ii), Bt(ps), Bt(hs);
  }
  function Hm(n) {
    va(hs.current);
    var i = va(ii.current), s = ke(i, n.type);
    i !== s && (kt(ps, n), kt(ii, s));
  }
  function pu(n) {
    ps.current === n && (Bt(ii), Bt(ps));
  }
  var Wt = Ui(0);
  function $2(n) {
    for (var i = n; i !== null; ) {
      if (i.tag === 13) {
        var s = i.memoizedState;
        if (s !== null && (s = s.dehydrated, s === null || s.data === "$?" || s.data === "$!")) return i;
      } else if (i.tag === 19 && i.memoizedProps.revealOrder !== void 0) {
        if ((i.flags & 128) !== 0) return i;
      } else if (i.child !== null) {
        i.child.return = i, i = i.child;
        continue;
      }
      if (i === n) break;
      for (; i.sibling === null; ) {
        if (i.return === null || i.return === n) return null;
        i = i.return;
      }
      i.sibling.return = i.return, i = i.sibling;
    }
    return null;
  }
  var hu = [];
  function mu() {
    for (var n = 0; n < hu.length; n++) hu[n]._workInProgressVersionPrimary = null;
    hu.length = 0;
  }
  var G2 = T.ReactCurrentDispatcher, _u = T.ReactCurrentBatchConfig, ga = 0, Yt = null, ur = null, mr = null, Z2 = !1, ms = !1, _s = 0, WA = 0;
  function Mr() {
    throw Error(t(321));
  }
  function Eu(n, i) {
    if (i === null) return !1;
    for (var s = 0; s < i.length && s < n.length; s++) if (!wn(n[s], i[s])) return !1;
    return !0;
  }
  function Cu(n, i, s, d, m, I) {
    if (ga = I, Yt = i, i.memoizedState = null, i.updateQueue = null, i.lanes = 0, G2.current = n === null || n.memoizedState === null ? QA : JA, n = s(d, m), ms) {
      I = 0;
      do {
        if (ms = !1, _s = 0, 25 <= I) throw Error(t(301));
        I += 1, mr = ur = null, i.updateQueue = null, G2.current = eT, n = s(d, m);
      } while (ms);
    }
    if (G2.current = q2, i = ur !== null && ur.next !== null, ga = 0, mr = ur = Yt = null, Z2 = !1, i) throw Error(t(300));
    return n;
  }
  function Su() {
    var n = _s !== 0;
    return _s = 0, n;
  }
  function ai() {
    var n = { memoizedState: null, baseState: null, baseQueue: null, queue: null, next: null };
    return mr === null ? Yt.memoizedState = mr = n : mr = mr.next = n, mr;
  }
  function Sn() {
    if (ur === null) {
      var n = Yt.alternate;
      n = n !== null ? n.memoizedState : null;
    } else n = ur.next;
    var i = mr === null ? Yt.memoizedState : mr.next;
    if (i !== null) mr = i, ur = n;
    else {
      if (n === null) throw Error(t(310));
      ur = n, n = { memoizedState: ur.memoizedState, baseState: ur.baseState, baseQueue: ur.baseQueue, queue: ur.queue, next: null }, mr === null ? Yt.memoizedState = mr = n : mr = mr.next = n;
    }
    return mr;
  }
  function Es(n, i) {
    return typeof i == "function" ? i(n) : i;
  }
  function Iu(n) {
    var i = Sn(), s = i.queue;
    if (s === null) throw Error(t(311));
    s.lastRenderedReducer = n;
    var d = ur, m = d.baseQueue, I = s.pending;
    if (I !== null) {
      if (m !== null) {
        var A = m.next;
        m.next = I.next, I.next = A;
      }
      d.baseQueue = m = I, s.pending = null;
    }
    if (m !== null) {
      I = m.next, d = d.baseState;
      var b = A = null, F = null, te = I;
      do {
        var me = te.lane;
        if ((ga & me) === me) F !== null && (F = F.next = { lane: 0, action: te.action, hasEagerState: te.hasEagerState, eagerState: te.eagerState, next: null }), d = te.hasEagerState ? te.eagerState : n(d, te.action);
        else {
          var Ce = {
            lane: me,
            action: te.action,
            hasEagerState: te.hasEagerState,
            eagerState: te.eagerState,
            next: null
          };
          F === null ? (b = F = Ce, A = d) : F = F.next = Ce, Yt.lanes |= me, Da |= me;
        }
        te = te.next;
      } while (te !== null && te !== I);
      F === null ? A = d : F.next = b, wn(d, i.memoizedState) || (Wr = !0), i.memoizedState = d, i.baseState = A, i.baseQueue = F, s.lastRenderedState = d;
    }
    if (n = s.interleaved, n !== null) {
      m = n;
      do
        I = m.lane, Yt.lanes |= I, Da |= I, m = m.next;
      while (m !== n);
    } else m === null && (s.lanes = 0);
    return [i.memoizedState, s.dispatch];
  }
  function vu(n) {
    var i = Sn(), s = i.queue;
    if (s === null) throw Error(t(311));
    s.lastRenderedReducer = n;
    var d = s.dispatch, m = s.pending, I = i.memoizedState;
    if (m !== null) {
      s.pending = null;
      var A = m = m.next;
      do
        I = n(I, A.action), A = A.next;
      while (A !== m);
      wn(I, i.memoizedState) || (Wr = !0), i.memoizedState = I, i.baseQueue === null && (i.baseState = I), s.lastRenderedState = I;
    }
    return [I, d];
  }
  function Vm() {
  }
  function km(n, i) {
    var s = Yt, d = Sn(), m = i(), I = !wn(d.memoizedState, m);
    if (I && (d.memoizedState = m, Wr = !0), d = d.queue, gu(Um.bind(null, s, d, n), [n]), d.getSnapshot !== i || I || mr !== null && mr.memoizedState.tag & 1) {
      if (s.flags |= 2048, Cs(9, xm.bind(null, s, d, m, i), void 0, null), _r === null) throw Error(t(349));
      (ga & 30) !== 0 || Fm(s, i, m);
    }
    return m;
  }
  function Fm(n, i, s) {
    n.flags |= 16384, n = { getSnapshot: i, value: s }, i = Yt.updateQueue, i === null ? (i = { lastEffect: null, stores: null }, Yt.updateQueue = i, i.stores = [n]) : (s = i.stores, s === null ? i.stores = [n] : s.push(n));
  }
  function xm(n, i, s, d) {
    i.value = s, i.getSnapshot = d, Bm(i) && $m(n);
  }
  function Um(n, i, s) {
    return s(function() {
      Bm(i) && $m(n);
    });
  }
  function Bm(n) {
    var i = n.getSnapshot;
    n = n.value;
    try {
      var s = i();
      return !wn(n, s);
    } catch (d) {
      return !0;
    }
  }
  function $m(n) {
    var i = Ii(n, 1);
    i !== null && xn(i, n, 1, -1);
  }
  function Gm(n) {
    var i = ai();
    return typeof n == "function" && (n = n()), i.memoizedState = i.baseState = n, n = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: Es, lastRenderedState: n }, i.queue = n, n = n.dispatch = XA.bind(null, Yt, n), [i.memoizedState, n];
  }
  function Cs(n, i, s, d) {
    return n = { tag: n, create: i, destroy: s, deps: d, next: null }, i = Yt.updateQueue, i === null ? (i = { lastEffect: null, stores: null }, Yt.updateQueue = i, i.lastEffect = n.next = n) : (s = i.lastEffect, s === null ? i.lastEffect = n.next = n : (d = s.next, s.next = n, n.next = d, i.lastEffect = n)), n;
  }
  function Zm() {
    return Sn().memoizedState;
  }
  function j2(n, i, s, d) {
    var m = ai();
    Yt.flags |= n, m.memoizedState = Cs(1 | i, s, void 0, d === void 0 ? null : d);
  }
  function z2(n, i, s, d) {
    var m = Sn();
    d = d === void 0 ? null : d;
    var I = void 0;
    if (ur !== null) {
      var A = ur.memoizedState;
      if (I = A.destroy, d !== null && Eu(d, A.deps)) {
        m.memoizedState = Cs(i, s, I, d);
        return;
      }
    }
    Yt.flags |= n, m.memoizedState = Cs(1 | i, s, I, d);
  }
  function jm(n, i) {
    return j2(8390656, 8, n, i);
  }
  function gu(n, i) {
    return z2(2048, 8, n, i);
  }
  function zm(n, i) {
    return z2(4, 2, n, i);
  }
  function qm(n, i) {
    return z2(4, 4, n, i);
  }
  function Wm(n, i) {
    if (typeof i == "function") return n = n(), i(n), function() {
      i(null);
    };
    if (i != null) return n = n(), i.current = n, function() {
      i.current = null;
    };
  }
  function Ym(n, i, s) {
    return s = s != null ? s.concat([n]) : null, z2(4, 4, Wm.bind(null, i, n), s);
  }
  function Du() {
  }
  function Km(n, i) {
    var s = Sn();
    i = i === void 0 ? null : i;
    var d = s.memoizedState;
    return d !== null && i !== null && Eu(i, d[1]) ? d[0] : (s.memoizedState = [n, i], n);
  }
  function Xm(n, i) {
    var s = Sn();
    i = i === void 0 ? null : i;
    var d = s.memoizedState;
    return d !== null && i !== null && Eu(i, d[1]) ? d[0] : (n = n(), s.memoizedState = [n, i], n);
  }
  function Qm(n, i, s) {
    return (ga & 21) === 0 ? (n.baseState && (n.baseState = !1, Wr = !0), n.memoizedState = s) : (wn(s, i) || (s = u2(), Yt.lanes |= s, Da |= s, n.baseState = !0), i);
  }
  function YA(n, i) {
    var s = yt;
    yt = s !== 0 && 4 > s ? s : 4, n(!0);
    var d = _u.transition;
    _u.transition = {};
    try {
      n(!1), i();
    } finally {
      yt = s, _u.transition = d;
    }
  }
  function Jm() {
    return Sn().memoizedState;
  }
  function KA(n, i, s) {
    var d = Wi(n);
    if (s = { lane: d, action: s, hasEagerState: !1, eagerState: null, next: null }, e_(n)) t_(i, s);
    else if (s = Mm(n, i, s, d), s !== null) {
      var m = Gr();
      xn(s, n, d, m), r_(s, i, d);
    }
  }
  function XA(n, i, s) {
    var d = Wi(n), m = { lane: d, action: s, hasEagerState: !1, eagerState: null, next: null };
    if (e_(n)) t_(i, m);
    else {
      var I = n.alternate;
      if (n.lanes === 0 && (I === null || I.lanes === 0) && (I = i.lastRenderedReducer, I !== null)) try {
        var A = i.lastRenderedState, b = I(A, s);
        if (m.hasEagerState = !0, m.eagerState = b, wn(b, A)) {
          var F = i.interleaved;
          F === null ? (m.next = m, uu(i)) : (m.next = F.next, F.next = m), i.interleaved = m;
          return;
        }
      } catch (te) {
      } finally {
      }
      s = Mm(n, i, m, d), s !== null && (m = Gr(), xn(s, n, d, m), r_(s, i, d));
    }
  }
  function e_(n) {
    var i = n.alternate;
    return n === Yt || i !== null && i === Yt;
  }
  function t_(n, i) {
    ms = Z2 = !0;
    var s = n.pending;
    s === null ? i.next = i : (i.next = s.next, s.next = i), n.pending = i;
  }
  function r_(n, i, s) {
    if ((s & 4194240) !== 0) {
      var d = i.lanes;
      d &= n.pendingLanes, s |= d, i.lanes = s, Wo(n, s);
    }
  }
  var q2 = { readContext: Cn, useCallback: Mr, useContext: Mr, useEffect: Mr, useImperativeHandle: Mr, useInsertionEffect: Mr, useLayoutEffect: Mr, useMemo: Mr, useReducer: Mr, useRef: Mr, useState: Mr, useDebugValue: Mr, useDeferredValue: Mr, useTransition: Mr, useMutableSource: Mr, useSyncExternalStore: Mr, useId: Mr, unstable_isNewReconciler: !1 }, QA = { readContext: Cn, useCallback: function(n, i) {
    return ai().memoizedState = [n, i === void 0 ? null : i], n;
  }, useContext: Cn, useEffect: jm, useImperativeHandle: function(n, i, s) {
    return s = s != null ? s.concat([n]) : null, j2(
      4194308,
      4,
      Wm.bind(null, i, n),
      s
    );
  }, useLayoutEffect: function(n, i) {
    return j2(4194308, 4, n, i);
  }, useInsertionEffect: function(n, i) {
    return j2(4, 2, n, i);
  }, useMemo: function(n, i) {
    var s = ai();
    return i = i === void 0 ? null : i, n = n(), s.memoizedState = [n, i], n;
  }, useReducer: function(n, i, s) {
    var d = ai();
    return i = s !== void 0 ? s(i) : i, d.memoizedState = d.baseState = i, n = { pending: null, interleaved: null, lanes: 0, dispatch: null, lastRenderedReducer: n, lastRenderedState: i }, d.queue = n, n = n.dispatch = KA.bind(null, Yt, n), [d.memoizedState, n];
  }, useRef: function(n) {
    var i = ai();
    return n = { current: n }, i.memoizedState = n;
  }, useState: Gm, useDebugValue: Du, useDeferredValue: function(n) {
    return ai().memoizedState = n;
  }, useTransition: function() {
    var n = Gm(!1), i = n[0];
    return n = YA.bind(null, n[1]), ai().memoizedState = n, [i, n];
  }, useMutableSource: function() {
  }, useSyncExternalStore: function(n, i, s) {
    var d = Yt, m = ai();
    if (Gt) {
      if (s === void 0) throw Error(t(407));
      s = s();
    } else {
      if (s = i(), _r === null) throw Error(t(349));
      (ga & 30) !== 0 || Fm(d, i, s);
    }
    m.memoizedState = s;
    var I = { value: s, getSnapshot: i };
    return m.queue = I, jm(Um.bind(
      null,
      d,
      I,
      n
    ), [n]), d.flags |= 2048, Cs(9, xm.bind(null, d, I, s, i), void 0, null), s;
  }, useId: function() {
    var n = ai(), i = _r.identifierPrefix;
    if (Gt) {
      var s = Si, d = Ci;
      s = (d & ~(1 << 32 - nn(d) - 1)).toString(32) + s, i = ":" + i + "R" + s, s = _s++, 0 < s && (i += "H" + s.toString(32)), i += ":";
    } else s = WA++, i = ":" + i + "r" + s.toString(32) + ":";
    return n.memoizedState = i;
  }, unstable_isNewReconciler: !1 }, JA = {
    readContext: Cn,
    useCallback: Km,
    useContext: Cn,
    useEffect: gu,
    useImperativeHandle: Ym,
    useInsertionEffect: zm,
    useLayoutEffect: qm,
    useMemo: Xm,
    useReducer: Iu,
    useRef: Zm,
    useState: function() {
      return Iu(Es);
    },
    useDebugValue: Du,
    useDeferredValue: function(n) {
      var i = Sn();
      return Qm(i, ur.memoizedState, n);
    },
    useTransition: function() {
      var n = Iu(Es)[0], i = Sn().memoizedState;
      return [n, i];
    },
    useMutableSource: Vm,
    useSyncExternalStore: km,
    useId: Jm,
    unstable_isNewReconciler: !1
  }, eT = { readContext: Cn, useCallback: Km, useContext: Cn, useEffect: gu, useImperativeHandle: Ym, useInsertionEffect: zm, useLayoutEffect: qm, useMemo: Xm, useReducer: vu, useRef: Zm, useState: function() {
    return vu(Es);
  }, useDebugValue: Du, useDeferredValue: function(n) {
    var i = Sn();
    return ur === null ? i.memoizedState = n : Qm(i, ur.memoizedState, n);
  }, useTransition: function() {
    var n = vu(Es)[0], i = Sn().memoizedState;
    return [n, i];
  }, useMutableSource: Vm, useSyncExternalStore: km, useId: Jm, unstable_isNewReconciler: !1 };
  function Vn(n, i) {
    if (n && n.defaultProps) {
      i = K({}, i), n = n.defaultProps;
      for (var s in n) i[s] === void 0 && (i[s] = n[s]);
      return i;
    }
    return i;
  }
  function Ru(n, i, s, d) {
    i = n.memoizedState, s = s(d, i), s = s == null ? i : K({}, i, s), n.memoizedState = s, n.lanes === 0 && (n.updateQueue.baseState = s);
  }
  var W2 = { isMounted: function(n) {
    return (n = n._reactInternals) ? mn(n) === n : !1;
  }, enqueueSetState: function(n, i, s) {
    n = n._reactInternals;
    var d = Gr(), m = Wi(n), I = vi(d, m);
    I.payload = i, s != null && (I.callback = s), i = Zi(n, I, m), i !== null && (xn(i, n, m, d), U2(i, n, m));
  }, enqueueReplaceState: function(n, i, s) {
    n = n._reactInternals;
    var d = Gr(), m = Wi(n), I = vi(d, m);
    I.tag = 1, I.payload = i, s != null && (I.callback = s), i = Zi(n, I, m), i !== null && (xn(i, n, m, d), U2(i, n, m));
  }, enqueueForceUpdate: function(n, i) {
    n = n._reactInternals;
    var s = Gr(), d = Wi(n), m = vi(s, d);
    m.tag = 2, i != null && (m.callback = i), i = Zi(n, m, d), i !== null && (xn(i, n, d, s), U2(i, n, d));
  } };
  function n_(n, i, s, d, m, I, A) {
    return n = n.stateNode, typeof n.shouldComponentUpdate == "function" ? n.shouldComponentUpdate(d, I, A) : i.prototype && i.prototype.isPureReactComponent ? !is(s, d) || !is(m, I) : !0;
  }
  function i_(n, i, s) {
    var d = !1, m = Bi, I = i.contextType;
    return typeof I == "object" && I !== null ? I = Cn(I) : (m = qr(i) ? Ea : Lr.current, d = i.contextTypes, I = (d = d != null) ? co(n, m) : Bi), i = new i(s, I), n.memoizedState = i.state !== null && i.state !== void 0 ? i.state : null, i.updater = W2, n.stateNode = i, i._reactInternals = n, d && (n = n.stateNode, n.__reactInternalMemoizedUnmaskedChildContext = m, n.__reactInternalMemoizedMaskedChildContext = I), i;
  }
  function a_(n, i, s, d) {
    n = i.state, typeof i.componentWillReceiveProps == "function" && i.componentWillReceiveProps(s, d), typeof i.UNSAFE_componentWillReceiveProps == "function" && i.UNSAFE_componentWillReceiveProps(s, d), i.state !== n && W2.enqueueReplaceState(i, i.state, null);
  }
  function Au(n, i, s, d) {
    var m = n.stateNode;
    m.props = s, m.state = n.memoizedState, m.refs = {}, fu(n);
    var I = i.contextType;
    typeof I == "object" && I !== null ? m.context = Cn(I) : (I = qr(i) ? Ea : Lr.current, m.context = co(n, I)), m.state = n.memoizedState, I = i.getDerivedStateFromProps, typeof I == "function" && (Ru(n, i, I, s), m.state = n.memoizedState), typeof i.getDerivedStateFromProps == "function" || typeof m.getSnapshotBeforeUpdate == "function" || typeof m.UNSAFE_componentWillMount != "function" && typeof m.componentWillMount != "function" || (i = m.state, typeof m.componentWillMount == "function" && m.componentWillMount(), typeof m.UNSAFE_componentWillMount == "function" && m.UNSAFE_componentWillMount(), i !== m.state && W2.enqueueReplaceState(m, m.state, null), B2(n, s, m, d), m.state = n.memoizedState), typeof m.componentDidMount == "function" && (n.flags |= 4194308);
  }
  function Co(n, i) {
    try {
      var s = "", d = i;
      do
        s += ee(d), d = d.return;
      while (d);
      var m = s;
    } catch (I) {
      m = `
Error generating stack: ` + I.message + `
` + I.stack;
    }
    return { value: n, source: i, stack: m, digest: null };
  }
  function Tu(n, i, s) {
    return { value: n, source: null, stack: s != null ? s : null, digest: i != null ? i : null };
  }
  function Ou(n, i) {
    try {
      console.error(i.value);
    } catch (s) {
      setTimeout(function() {
        throw s;
      });
    }
  }
  var tT = typeof WeakMap == "function" ? WeakMap : Map;
  function o_(n, i, s) {
    s = vi(-1, s), s.tag = 3, s.payload = { element: null };
    var d = i.value;
    return s.callback = function() {
      tl || (tl = !0, $u = d), Ou(n, i);
    }, s;
  }
  function s_(n, i, s) {
    s = vi(-1, s), s.tag = 3;
    var d = n.type.getDerivedStateFromError;
    if (typeof d == "function") {
      var m = i.value;
      s.payload = function() {
        return d(m);
      }, s.callback = function() {
        Ou(n, i);
      };
    }
    var I = n.stateNode;
    return I !== null && typeof I.componentDidCatch == "function" && (s.callback = function() {
      Ou(n, i), typeof d != "function" && (zi === null ? zi = /* @__PURE__ */ new Set([this]) : zi.add(this));
      var A = i.stack;
      this.componentDidCatch(i.value, { componentStack: A !== null ? A : "" });
    }), s;
  }
  function l_(n, i, s) {
    var d = n.pingCache;
    if (d === null) {
      d = n.pingCache = new tT();
      var m = /* @__PURE__ */ new Set();
      d.set(i, m);
    } else m = d.get(i), m === void 0 && (m = /* @__PURE__ */ new Set(), d.set(i, m));
    m.has(s) || (m.add(s), n = mT.bind(null, n, i, s), i.then(n, n));
  }
  function c_(n) {
    do {
      var i;
      if ((i = n.tag === 13) && (i = n.memoizedState, i = i !== null ? i.dehydrated !== null : !0), i) return n;
      n = n.return;
    } while (n !== null);
    return null;
  }
  function u_(n, i, s, d, m) {
    return (n.mode & 1) === 0 ? (n === i ? n.flags |= 65536 : (n.flags |= 128, s.flags |= 131072, s.flags &= -52805, s.tag === 1 && (s.alternate === null ? s.tag = 17 : (i = vi(-1, 1), i.tag = 2, Zi(s, i, 1))), s.lanes |= 1), n) : (n.flags |= 65536, n.lanes = m, n);
  }
  var rT = T.ReactCurrentOwner, Wr = !1;
  function $r(n, i, s, d) {
    i.child = n === null ? Lm(i, null, s, d) : ho(i, n.child, s, d);
  }
  function f_(n, i, s, d, m) {
    s = s.render;
    var I = i.ref;
    return _o(i, m), d = Cu(n, i, s, d, I, m), s = Su(), n !== null && !Wr ? (i.updateQueue = n.updateQueue, i.flags &= -2053, n.lanes &= ~m, gi(n, i, m)) : (Gt && s && tu(i), i.flags |= 1, $r(n, i, d, m), i.child);
  }
  function d_(n, i, s, d, m) {
    if (n === null) {
      var I = s.type;
      return typeof I == "function" && !Yu(I) && I.defaultProps === void 0 && s.compare === null && s.defaultProps === void 0 ? (i.tag = 15, i.type = I, p_(n, i, I, d, m)) : (n = sl(s.type, null, d, i, i.mode, m), n.ref = i.ref, n.return = i, i.child = n);
    }
    if (I = n.child, (n.lanes & m) === 0) {
      var A = I.memoizedProps;
      if (s = s.compare, s = s !== null ? s : is, s(A, d) && n.ref === i.ref) return gi(n, i, m);
    }
    return i.flags |= 1, n = Ki(I, d), n.ref = i.ref, n.return = i, i.child = n;
  }
  function p_(n, i, s, d, m) {
    if (n !== null) {
      var I = n.memoizedProps;
      if (is(I, d) && n.ref === i.ref) if (Wr = !1, i.pendingProps = d = I, (n.lanes & m) !== 0) (n.flags & 131072) !== 0 && (Wr = !0);
      else return i.lanes = n.lanes, gi(n, i, m);
    }
    return yu(n, i, s, d, m);
  }
  function h_(n, i, s) {
    var d = i.pendingProps, m = d.children, I = n !== null ? n.memoizedState : null;
    if (d.mode === "hidden") if ((i.mode & 1) === 0) i.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, kt(Io, ln), ln |= s;
    else {
      if ((s & 1073741824) === 0) return n = I !== null ? I.baseLanes | s : s, i.lanes = i.childLanes = 1073741824, i.memoizedState = { baseLanes: n, cachePool: null, transitions: null }, i.updateQueue = null, kt(Io, ln), ln |= n, null;
      i.memoizedState = { baseLanes: 0, cachePool: null, transitions: null }, d = I !== null ? I.baseLanes : s, kt(Io, ln), ln |= d;
    }
    else I !== null ? (d = I.baseLanes | s, i.memoizedState = null) : d = s, kt(Io, ln), ln |= d;
    return $r(n, i, m, s), i.child;
  }
  function m_(n, i) {
    var s = i.ref;
    (n === null && s !== null || n !== null && n.ref !== s) && (i.flags |= 512, i.flags |= 2097152);
  }
  function yu(n, i, s, d, m) {
    var I = qr(s) ? Ea : Lr.current;
    return I = co(i, I), _o(i, m), s = Cu(n, i, s, d, I, m), d = Su(), n !== null && !Wr ? (i.updateQueue = n.updateQueue, i.flags &= -2053, n.lanes &= ~m, gi(n, i, m)) : (Gt && d && tu(i), i.flags |= 1, $r(n, i, s, m), i.child);
  }
  function __(n, i, s, d, m) {
    if (qr(s)) {
      var I = !0;
      b2(i);
    } else I = !1;
    if (_o(i, m), i.stateNode === null) K2(n, i), i_(i, s, d), Au(i, s, d, m), d = !0;
    else if (n === null) {
      var A = i.stateNode, b = i.memoizedProps;
      A.props = b;
      var F = A.context, te = s.contextType;
      typeof te == "object" && te !== null ? te = Cn(te) : (te = qr(s) ? Ea : Lr.current, te = co(i, te));
      var me = s.getDerivedStateFromProps, Ce = typeof me == "function" || typeof A.getSnapshotBeforeUpdate == "function";
      Ce || typeof A.UNSAFE_componentWillReceiveProps != "function" && typeof A.componentWillReceiveProps != "function" || (b !== d || F !== te) && a_(i, A, d, te), Gi = !1;
      var he = i.memoizedState;
      A.state = he, B2(i, d, A, m), F = i.memoizedState, b !== d || he !== F || zr.current || Gi ? (typeof me == "function" && (Ru(i, s, me, d), F = i.memoizedState), (b = Gi || n_(i, s, b, d, he, F, te)) ? (Ce || typeof A.UNSAFE_componentWillMount != "function" && typeof A.componentWillMount != "function" || (typeof A.componentWillMount == "function" && A.componentWillMount(), typeof A.UNSAFE_componentWillMount == "function" && A.UNSAFE_componentWillMount()), typeof A.componentDidMount == "function" && (i.flags |= 4194308)) : (typeof A.componentDidMount == "function" && (i.flags |= 4194308), i.memoizedProps = d, i.memoizedState = F), A.props = d, A.state = F, A.context = te, d = b) : (typeof A.componentDidMount == "function" && (i.flags |= 4194308), d = !1);
    } else {
      A = i.stateNode, bm(n, i), b = i.memoizedProps, te = i.type === i.elementType ? b : Vn(i.type, b), A.props = te, Ce = i.pendingProps, he = A.context, F = s.contextType, typeof F == "object" && F !== null ? F = Cn(F) : (F = qr(s) ? Ea : Lr.current, F = co(i, F));
      var He = s.getDerivedStateFromProps;
      (me = typeof He == "function" || typeof A.getSnapshotBeforeUpdate == "function") || typeof A.UNSAFE_componentWillReceiveProps != "function" && typeof A.componentWillReceiveProps != "function" || (b !== Ce || he !== F) && a_(i, A, d, F), Gi = !1, he = i.memoizedState, A.state = he, B2(i, d, A, m);
      var Be = i.memoizedState;
      b !== Ce || he !== Be || zr.current || Gi ? (typeof He == "function" && (Ru(i, s, He, d), Be = i.memoizedState), (te = Gi || n_(i, s, te, d, he, Be, F) || !1) ? (me || typeof A.UNSAFE_componentWillUpdate != "function" && typeof A.componentWillUpdate != "function" || (typeof A.componentWillUpdate == "function" && A.componentWillUpdate(d, Be, F), typeof A.UNSAFE_componentWillUpdate == "function" && A.UNSAFE_componentWillUpdate(d, Be, F)), typeof A.componentDidUpdate == "function" && (i.flags |= 4), typeof A.getSnapshotBeforeUpdate == "function" && (i.flags |= 1024)) : (typeof A.componentDidUpdate != "function" || b === n.memoizedProps && he === n.memoizedState || (i.flags |= 4), typeof A.getSnapshotBeforeUpdate != "function" || b === n.memoizedProps && he === n.memoizedState || (i.flags |= 1024), i.memoizedProps = d, i.memoizedState = Be), A.props = d, A.state = Be, A.context = F, d = te) : (typeof A.componentDidUpdate != "function" || b === n.memoizedProps && he === n.memoizedState || (i.flags |= 4), typeof A.getSnapshotBeforeUpdate != "function" || b === n.memoizedProps && he === n.memoizedState || (i.flags |= 1024), d = !1);
    }
    return Nu(n, i, s, d, I, m);
  }
  function Nu(n, i, s, d, m, I) {
    m_(n, i);
    var A = (i.flags & 128) !== 0;
    if (!d && !A) return m && vm(i, s, !1), gi(n, i, I);
    d = i.stateNode, rT.current = i;
    var b = A && typeof s.getDerivedStateFromError != "function" ? null : d.render();
    return i.flags |= 1, n !== null && A ? (i.child = ho(i, n.child, null, I), i.child = ho(i, null, b, I)) : $r(n, i, b, I), i.memoizedState = d.state, m && vm(i, s, !0), i.child;
  }
  function E_(n) {
    var i = n.stateNode;
    i.pendingContext ? Sm(n, i.pendingContext, i.pendingContext !== i.context) : i.context && Sm(n, i.context, !1), du(n, i.containerInfo);
  }
  function C_(n, i, s, d, m) {
    return po(), au(m), i.flags |= 256, $r(n, i, s, d), i.child;
  }
  var Lu = { dehydrated: null, treeContext: null, retryLane: 0 };
  function Mu(n) {
    return { baseLanes: n, cachePool: null, transitions: null };
  }
  function S_(n, i, s) {
    var d = i.pendingProps, m = Wt.current, I = !1, A = (i.flags & 128) !== 0, b;
    if ((b = A) || (b = n !== null && n.memoizedState === null ? !1 : (m & 2) !== 0), b ? (I = !0, i.flags &= -129) : (n === null || n.memoizedState !== null) && (m |= 1), kt(Wt, m & 1), n === null)
      return iu(i), n = i.memoizedState, n !== null && (n = n.dehydrated, n !== null) ? ((i.mode & 1) === 0 ? i.lanes = 1 : n.data === "$!" ? i.lanes = 8 : i.lanes = 1073741824, null) : (A = d.children, n = d.fallback, I ? (d = i.mode, I = i.child, A = { mode: "hidden", children: A }, (d & 1) === 0 && I !== null ? (I.childLanes = 0, I.pendingProps = A) : I = ll(A, d, 0, null), n = Oa(n, d, s, null), I.return = i, n.return = i, I.sibling = n, i.child = I, i.child.memoizedState = Mu(s), i.memoizedState = Lu, n) : bu(i, A));
    if (m = n.memoizedState, m !== null && (b = m.dehydrated, b !== null)) return nT(n, i, A, d, b, m, s);
    if (I) {
      I = d.fallback, A = i.mode, m = n.child, b = m.sibling;
      var F = { mode: "hidden", children: d.children };
      return (A & 1) === 0 && i.child !== m ? (d = i.child, d.childLanes = 0, d.pendingProps = F, i.deletions = null) : (d = Ki(m, F), d.subtreeFlags = m.subtreeFlags & 14680064), b !== null ? I = Ki(b, I) : (I = Oa(I, A, s, null), I.flags |= 2), I.return = i, d.return = i, d.sibling = I, i.child = d, d = I, I = i.child, A = n.child.memoizedState, A = A === null ? Mu(s) : { baseLanes: A.baseLanes | s, cachePool: null, transitions: A.transitions }, I.memoizedState = A, I.childLanes = n.childLanes & ~s, i.memoizedState = Lu, d;
    }
    return I = n.child, n = I.sibling, d = Ki(I, { mode: "visible", children: d.children }), (i.mode & 1) === 0 && (d.lanes = s), d.return = i, d.sibling = null, n !== null && (s = i.deletions, s === null ? (i.deletions = [n], i.flags |= 16) : s.push(n)), i.child = d, i.memoizedState = null, d;
  }
  function bu(n, i) {
    return i = ll({ mode: "visible", children: i }, n.mode, 0, null), i.return = n, n.child = i;
  }
  function Y2(n, i, s, d) {
    return d !== null && au(d), ho(i, n.child, null, s), n = bu(i, i.pendingProps.children), n.flags |= 2, i.memoizedState = null, n;
  }
  function nT(n, i, s, d, m, I, A) {
    if (s)
      return i.flags & 256 ? (i.flags &= -257, d = Tu(Error(t(422))), Y2(n, i, A, d)) : i.memoizedState !== null ? (i.child = n.child, i.flags |= 128, null) : (I = d.fallback, m = i.mode, d = ll({ mode: "visible", children: d.children }, m, 0, null), I = Oa(I, m, A, null), I.flags |= 2, d.return = i, I.return = i, d.sibling = I, i.child = d, (i.mode & 1) !== 0 && ho(i, n.child, null, A), i.child.memoizedState = Mu(A), i.memoizedState = Lu, I);
    if ((i.mode & 1) === 0) return Y2(n, i, A, null);
    if (m.data === "$!") {
      if (d = m.nextSibling && m.nextSibling.dataset, d) var b = d.dgst;
      return d = b, I = Error(t(419)), d = Tu(I, d, void 0), Y2(n, i, A, d);
    }
    if (b = (A & n.childLanes) !== 0, Wr || b) {
      if (d = _r, d !== null) {
        switch (A & -A) {
          case 4:
            m = 2;
            break;
          case 16:
            m = 8;
            break;
          case 64:
          case 128:
          case 256:
          case 512:
          case 1024:
          case 2048:
          case 4096:
          case 8192:
          case 16384:
          case 32768:
          case 65536:
          case 131072:
          case 262144:
          case 524288:
          case 1048576:
          case 2097152:
          case 4194304:
          case 8388608:
          case 16777216:
          case 33554432:
          case 67108864:
            m = 32;
            break;
          case 536870912:
            m = 268435456;
            break;
          default:
            m = 0;
        }
        m = (m & (d.suspendedLanes | A)) !== 0 ? 0 : m, m !== 0 && m !== I.retryLane && (I.retryLane = m, Ii(n, m), xn(d, n, m, -1));
      }
      return Wu(), d = Tu(Error(t(421))), Y2(n, i, A, d);
    }
    return m.data === "$?" ? (i.flags |= 128, i.child = n.child, i = _T.bind(null, n), m._reactRetry = i, null) : (n = I.treeContext, sn = xi(m.nextSibling), on = i, Gt = !0, Hn = null, n !== null && (_n[En++] = Ci, _n[En++] = Si, _n[En++] = Ca, Ci = n.id, Si = n.overflow, Ca = i), i = bu(i, d.children), i.flags |= 4096, i);
  }
  function I_(n, i, s) {
    n.lanes |= i;
    var d = n.alternate;
    d !== null && (d.lanes |= i), cu(n.return, i, s);
  }
  function Pu(n, i, s, d, m) {
    var I = n.memoizedState;
    I === null ? n.memoizedState = { isBackwards: i, rendering: null, renderingStartTime: 0, last: d, tail: s, tailMode: m } : (I.isBackwards = i, I.rendering = null, I.renderingStartTime = 0, I.last = d, I.tail = s, I.tailMode = m);
  }
  function v_(n, i, s) {
    var d = i.pendingProps, m = d.revealOrder, I = d.tail;
    if ($r(n, i, d.children, s), d = Wt.current, (d & 2) !== 0) d = d & 1 | 2, i.flags |= 128;
    else {
      if (n !== null && (n.flags & 128) !== 0) e: for (n = i.child; n !== null; ) {
        if (n.tag === 13) n.memoizedState !== null && I_(n, s, i);
        else if (n.tag === 19) I_(n, s, i);
        else if (n.child !== null) {
          n.child.return = n, n = n.child;
          continue;
        }
        if (n === i) break e;
        for (; n.sibling === null; ) {
          if (n.return === null || n.return === i) break e;
          n = n.return;
        }
        n.sibling.return = n.return, n = n.sibling;
      }
      d &= 1;
    }
    if (kt(Wt, d), (i.mode & 1) === 0) i.memoizedState = null;
    else switch (m) {
      case "forwards":
        for (s = i.child, m = null; s !== null; ) n = s.alternate, n !== null && $2(n) === null && (m = s), s = s.sibling;
        s = m, s === null ? (m = i.child, i.child = null) : (m = s.sibling, s.sibling = null), Pu(i, !1, m, s, I);
        break;
      case "backwards":
        for (s = null, m = i.child, i.child = null; m !== null; ) {
          if (n = m.alternate, n !== null && $2(n) === null) {
            i.child = m;
            break;
          }
          n = m.sibling, m.sibling = s, s = m, m = n;
        }
        Pu(i, !0, s, null, I);
        break;
      case "together":
        Pu(i, !1, null, null, void 0);
        break;
      default:
        i.memoizedState = null;
    }
    return i.child;
  }
  function K2(n, i) {
    (i.mode & 1) === 0 && n !== null && (n.alternate = null, i.alternate = null, i.flags |= 2);
  }
  function gi(n, i, s) {
    if (n !== null && (i.dependencies = n.dependencies), Da |= i.lanes, (s & i.childLanes) === 0) return null;
    if (n !== null && i.child !== n.child) throw Error(t(153));
    if (i.child !== null) {
      for (n = i.child, s = Ki(n, n.pendingProps), i.child = s, s.return = i; n.sibling !== null; ) n = n.sibling, s = s.sibling = Ki(n, n.pendingProps), s.return = i;
      s.sibling = null;
    }
    return i.child;
  }
  function iT(n, i, s) {
    switch (i.tag) {
      case 3:
        E_(i), po();
        break;
      case 5:
        Hm(i);
        break;
      case 1:
        qr(i.type) && b2(i);
        break;
      case 4:
        du(i, i.stateNode.containerInfo);
        break;
      case 10:
        var d = i.type._context, m = i.memoizedProps.value;
        kt(F2, d._currentValue), d._currentValue = m;
        break;
      case 13:
        if (d = i.memoizedState, d !== null)
          return d.dehydrated !== null ? (kt(Wt, Wt.current & 1), i.flags |= 128, null) : (s & i.child.childLanes) !== 0 ? S_(n, i, s) : (kt(Wt, Wt.current & 1), n = gi(n, i, s), n !== null ? n.sibling : null);
        kt(Wt, Wt.current & 1);
        break;
      case 19:
        if (d = (s & i.childLanes) !== 0, (n.flags & 128) !== 0) {
          if (d) return v_(n, i, s);
          i.flags |= 128;
        }
        if (m = i.memoizedState, m !== null && (m.rendering = null, m.tail = null, m.lastEffect = null), kt(Wt, Wt.current), d) break;
        return null;
      case 22:
      case 23:
        return i.lanes = 0, h_(n, i, s);
    }
    return gi(n, i, s);
  }
  var g_, wu, D_, R_;
  g_ = function(n, i) {
    for (var s = i.child; s !== null; ) {
      if (s.tag === 5 || s.tag === 6) n.appendChild(s.stateNode);
      else if (s.tag !== 4 && s.child !== null) {
        s.child.return = s, s = s.child;
        continue;
      }
      if (s === i) break;
      for (; s.sibling === null; ) {
        if (s.return === null || s.return === i) return;
        s = s.return;
      }
      s.sibling.return = s.return, s = s.sibling;
    }
  }, wu = function() {
  }, D_ = function(n, i, s, d) {
    var m = n.memoizedProps;
    if (m !== d) {
      n = i.stateNode, va(ii.current);
      var I = null;
      switch (s) {
        case "input":
          m = Ke(n, m), d = Ke(n, d), I = [];
          break;
        case "select":
          m = K({}, m, { value: void 0 }), d = K({}, d, { value: void 0 }), I = [];
          break;
        case "textarea":
          m = Te(n, m), d = Te(n, d), I = [];
          break;
        default:
          typeof m.onClick != "function" && typeof d.onClick == "function" && (n.onclick = N2);
      }
      bt(s, d);
      var A;
      s = null;
      for (te in m) if (!d.hasOwnProperty(te) && m.hasOwnProperty(te) && m[te] != null) if (te === "style") {
        var b = m[te];
        for (A in b) b.hasOwnProperty(A) && (s || (s = {}), s[A] = "");
      } else te !== "dangerouslySetInnerHTML" && te !== "children" && te !== "suppressContentEditableWarning" && te !== "suppressHydrationWarning" && te !== "autoFocus" && (o.hasOwnProperty(te) ? I || (I = []) : (I = I || []).push(te, null));
      for (te in d) {
        var F = d[te];
        if (b = m != null ? m[te] : void 0, d.hasOwnProperty(te) && F !== b && (F != null || b != null)) if (te === "style") if (b) {
          for (A in b) !b.hasOwnProperty(A) || F && F.hasOwnProperty(A) || (s || (s = {}), s[A] = "");
          for (A in F) F.hasOwnProperty(A) && b[A] !== F[A] && (s || (s = {}), s[A] = F[A]);
        } else s || (I || (I = []), I.push(
          te,
          s
        )), s = F;
        else te === "dangerouslySetInnerHTML" ? (F = F ? F.__html : void 0, b = b ? b.__html : void 0, F != null && b !== F && (I = I || []).push(te, F)) : te === "children" ? typeof F != "string" && typeof F != "number" || (I = I || []).push(te, "" + F) : te !== "suppressContentEditableWarning" && te !== "suppressHydrationWarning" && (o.hasOwnProperty(te) ? (F != null && te === "onScroll" && Ut("scroll", n), I || b === F || (I = [])) : (I = I || []).push(te, F));
      }
      s && (I = I || []).push("style", s);
      var te = I;
      (i.updateQueue = te) && (i.flags |= 4);
    }
  }, R_ = function(n, i, s, d) {
    s !== d && (i.flags |= 4);
  };
  function Ss(n, i) {
    if (!Gt) switch (n.tailMode) {
      case "hidden":
        i = n.tail;
        for (var s = null; i !== null; ) i.alternate !== null && (s = i), i = i.sibling;
        s === null ? n.tail = null : s.sibling = null;
        break;
      case "collapsed":
        s = n.tail;
        for (var d = null; s !== null; ) s.alternate !== null && (d = s), s = s.sibling;
        d === null ? i || n.tail === null ? n.tail = null : n.tail.sibling = null : d.sibling = null;
    }
  }
  function br(n) {
    var i = n.alternate !== null && n.alternate.child === n.child, s = 0, d = 0;
    if (i) for (var m = n.child; m !== null; ) s |= m.lanes | m.childLanes, d |= m.subtreeFlags & 14680064, d |= m.flags & 14680064, m.return = n, m = m.sibling;
    else for (m = n.child; m !== null; ) s |= m.lanes | m.childLanes, d |= m.subtreeFlags, d |= m.flags, m.return = n, m = m.sibling;
    return n.subtreeFlags |= d, n.childLanes = s, i;
  }
  function aT(n, i, s) {
    var d = i.pendingProps;
    switch (ru(i), i.tag) {
      case 2:
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return br(i), null;
      case 1:
        return qr(i.type) && M2(), br(i), null;
      case 3:
        return d = i.stateNode, Eo(), Bt(zr), Bt(Lr), mu(), d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null), (n === null || n.child === null) && (V2(i) ? i.flags |= 4 : n === null || n.memoizedState.isDehydrated && (i.flags & 256) === 0 || (i.flags |= 1024, Hn !== null && (ju(Hn), Hn = null))), wu(n, i), br(i), null;
      case 5:
        pu(i);
        var m = va(hs.current);
        if (s = i.type, n !== null && i.stateNode != null) D_(n, i, s, d, m), n.ref !== i.ref && (i.flags |= 512, i.flags |= 2097152);
        else {
          if (!d) {
            if (i.stateNode === null) throw Error(t(166));
            return br(i), null;
          }
          if (n = va(ii.current), V2(i)) {
            d = i.stateNode, s = i.type;
            var I = i.memoizedProps;
            switch (d[ni] = i, d[cs] = I, n = (i.mode & 1) !== 0, s) {
              case "dialog":
                Ut("cancel", d), Ut("close", d);
                break;
              case "iframe":
              case "object":
              case "embed":
                Ut("load", d);
                break;
              case "video":
              case "audio":
                for (m = 0; m < os.length; m++) Ut(os[m], d);
                break;
              case "source":
                Ut("error", d);
                break;
              case "img":
              case "image":
              case "link":
                Ut(
                  "error",
                  d
                ), Ut("load", d);
                break;
              case "details":
                Ut("toggle", d);
                break;
              case "input":
                ot(d, I), Ut("invalid", d);
                break;
              case "select":
                d._wrapperState = { wasMultiple: !!I.multiple }, Ut("invalid", d);
                break;
              case "textarea":
                Ue(d, I), Ut("invalid", d);
            }
            bt(s, I), m = null;
            for (var A in I) if (I.hasOwnProperty(A)) {
              var b = I[A];
              A === "children" ? typeof b == "string" ? d.textContent !== b && (I.suppressHydrationWarning !== !0 && y2(d.textContent, b, n), m = ["children", b]) : typeof b == "number" && d.textContent !== "" + b && (I.suppressHydrationWarning !== !0 && y2(
                d.textContent,
                b,
                n
              ), m = ["children", "" + b]) : o.hasOwnProperty(A) && b != null && A === "onScroll" && Ut("scroll", d);
            }
            switch (s) {
              case "input":
                ct(d), Je(d, I, !0);
                break;
              case "textarea":
                ct(d), Et(d);
                break;
              case "select":
              case "option":
                break;
              default:
                typeof I.onClick == "function" && (d.onclick = N2);
            }
            d = m, i.updateQueue = d, d !== null && (i.flags |= 4);
          } else {
            A = m.nodeType === 9 ? m : m.ownerDocument, n === "http://www.w3.org/1999/xhtml" && (n = Re(s)), n === "http://www.w3.org/1999/xhtml" ? s === "script" ? (n = A.createElement("div"), n.innerHTML = "<script><\/script>", n = n.removeChild(n.firstChild)) : typeof d.is == "string" ? n = A.createElement(s, { is: d.is }) : (n = A.createElement(s), s === "select" && (A = n, d.multiple ? A.multiple = !0 : d.size && (A.size = d.size))) : n = A.createElementNS(n, s), n[ni] = i, n[cs] = d, g_(n, i, !1, !1), i.stateNode = n;
            e: {
              switch (A = Or(s, d), s) {
                case "dialog":
                  Ut("cancel", n), Ut("close", n), m = d;
                  break;
                case "iframe":
                case "object":
                case "embed":
                  Ut("load", n), m = d;
                  break;
                case "video":
                case "audio":
                  for (m = 0; m < os.length; m++) Ut(os[m], n);
                  m = d;
                  break;
                case "source":
                  Ut("error", n), m = d;
                  break;
                case "img":
                case "image":
                case "link":
                  Ut(
                    "error",
                    n
                  ), Ut("load", n), m = d;
                  break;
                case "details":
                  Ut("toggle", n), m = d;
                  break;
                case "input":
                  ot(n, d), m = Ke(n, d), Ut("invalid", n);
                  break;
                case "option":
                  m = d;
                  break;
                case "select":
                  n._wrapperState = { wasMultiple: !!d.multiple }, m = K({}, d, { value: void 0 }), Ut("invalid", n);
                  break;
                case "textarea":
                  Ue(n, d), m = Te(n, d), Ut("invalid", n);
                  break;
                default:
                  m = d;
              }
              bt(s, m), b = m;
              for (I in b) if (b.hasOwnProperty(I)) {
                var F = b[I];
                I === "style" ? et(n, F) : I === "dangerouslySetInnerHTML" ? (F = F ? F.__html : void 0, F != null && rt(n, F)) : I === "children" ? typeof F == "string" ? (s !== "textarea" || F !== "") && ht(n, F) : typeof F == "number" && ht(n, "" + F) : I !== "suppressContentEditableWarning" && I !== "suppressHydrationWarning" && I !== "autoFocus" && (o.hasOwnProperty(I) ? F != null && I === "onScroll" && Ut("scroll", n) : F != null && D(n, I, F, A));
              }
              switch (s) {
                case "input":
                  ct(n), Je(n, d, !1);
                  break;
                case "textarea":
                  ct(n), Et(n);
                  break;
                case "option":
                  d.value != null && n.setAttribute("value", "" + Se(d.value));
                  break;
                case "select":
                  n.multiple = !!d.multiple, I = d.value, I != null ? de(n, !!d.multiple, I, !1) : d.defaultValue != null && de(
                    n,
                    !!d.multiple,
                    d.defaultValue,
                    !0
                  );
                  break;
                default:
                  typeof m.onClick == "function" && (n.onclick = N2);
              }
              switch (s) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  d = !!d.autoFocus;
                  break e;
                case "img":
                  d = !0;
                  break e;
                default:
                  d = !1;
              }
            }
            d && (i.flags |= 4);
          }
          i.ref !== null && (i.flags |= 512, i.flags |= 2097152);
        }
        return br(i), null;
      case 6:
        if (n && i.stateNode != null) R_(n, i, n.memoizedProps, d);
        else {
          if (typeof d != "string" && i.stateNode === null) throw Error(t(166));
          if (s = va(hs.current), va(ii.current), V2(i)) {
            if (d = i.stateNode, s = i.memoizedProps, d[ni] = i, (I = d.nodeValue !== s) && (n = on, n !== null))
              switch (n.tag) {
                case 3:
                  y2(d.nodeValue, s, (n.mode & 1) !== 0);
                  break;
                case 5:
                  n.memoizedProps.suppressHydrationWarning !== !0 && y2(d.nodeValue, s, (n.mode & 1) !== 0);
              }
            I && (i.flags |= 4);
          } else d = (s.nodeType === 9 ? s : s.ownerDocument).createTextNode(d), d[ni] = i, i.stateNode = d;
        }
        return br(i), null;
      case 13:
        if (Bt(Wt), d = i.memoizedState, n === null || n.memoizedState !== null && n.memoizedState.dehydrated !== null) {
          if (Gt && sn !== null && (i.mode & 1) !== 0 && (i.flags & 128) === 0) Om(), po(), i.flags |= 98560, I = !1;
          else if (I = V2(i), d !== null && d.dehydrated !== null) {
            if (n === null) {
              if (!I) throw Error(t(318));
              if (I = i.memoizedState, I = I !== null ? I.dehydrated : null, !I) throw Error(t(317));
              I[ni] = i;
            } else po(), (i.flags & 128) === 0 && (i.memoizedState = null), i.flags |= 4;
            br(i), I = !1;
          } else Hn !== null && (ju(Hn), Hn = null), I = !0;
          if (!I) return i.flags & 65536 ? i : null;
        }
        return (i.flags & 128) !== 0 ? (i.lanes = s, i) : (d = d !== null, d !== (n !== null && n.memoizedState !== null) && d && (i.child.flags |= 8192, (i.mode & 1) !== 0 && (n === null || (Wt.current & 1) !== 0 ? fr === 0 && (fr = 3) : Wu())), i.updateQueue !== null && (i.flags |= 4), br(i), null);
      case 4:
        return Eo(), wu(n, i), n === null && ss(i.stateNode.containerInfo), br(i), null;
      case 10:
        return lu(i.type._context), br(i), null;
      case 17:
        return qr(i.type) && M2(), br(i), null;
      case 19:
        if (Bt(Wt), I = i.memoizedState, I === null) return br(i), null;
        if (d = (i.flags & 128) !== 0, A = I.rendering, A === null) if (d) Ss(I, !1);
        else {
          if (fr !== 0 || n !== null && (n.flags & 128) !== 0) for (n = i.child; n !== null; ) {
            if (A = $2(n), A !== null) {
              for (i.flags |= 128, Ss(I, !1), d = A.updateQueue, d !== null && (i.updateQueue = d, i.flags |= 4), i.subtreeFlags = 0, d = s, s = i.child; s !== null; ) I = s, n = d, I.flags &= 14680066, A = I.alternate, A === null ? (I.childLanes = 0, I.lanes = n, I.child = null, I.subtreeFlags = 0, I.memoizedProps = null, I.memoizedState = null, I.updateQueue = null, I.dependencies = null, I.stateNode = null) : (I.childLanes = A.childLanes, I.lanes = A.lanes, I.child = A.child, I.subtreeFlags = 0, I.deletions = null, I.memoizedProps = A.memoizedProps, I.memoizedState = A.memoizedState, I.updateQueue = A.updateQueue, I.type = A.type, n = A.dependencies, I.dependencies = n === null ? null : { lanes: n.lanes, firstContext: n.firstContext }), s = s.sibling;
              return kt(Wt, Wt.current & 1 | 2), i.child;
            }
            n = n.sibling;
          }
          I.tail !== null && lt() > vo && (i.flags |= 128, d = !0, Ss(I, !1), i.lanes = 4194304);
        }
        else {
          if (!d) if (n = $2(A), n !== null) {
            if (i.flags |= 128, d = !0, s = n.updateQueue, s !== null && (i.updateQueue = s, i.flags |= 4), Ss(I, !0), I.tail === null && I.tailMode === "hidden" && !A.alternate && !Gt) return br(i), null;
          } else 2 * lt() - I.renderingStartTime > vo && s !== 1073741824 && (i.flags |= 128, d = !0, Ss(I, !1), i.lanes = 4194304);
          I.isBackwards ? (A.sibling = i.child, i.child = A) : (s = I.last, s !== null ? s.sibling = A : i.child = A, I.last = A);
        }
        return I.tail !== null ? (i = I.tail, I.rendering = i, I.tail = i.sibling, I.renderingStartTime = lt(), i.sibling = null, s = Wt.current, kt(Wt, d ? s & 1 | 2 : s & 1), i) : (br(i), null);
      case 22:
      case 23:
        return qu(), d = i.memoizedState !== null, n !== null && n.memoizedState !== null !== d && (i.flags |= 8192), d && (i.mode & 1) !== 0 ? (ln & 1073741824) !== 0 && (br(i), i.subtreeFlags & 6 && (i.flags |= 8192)) : br(i), null;
      case 24:
        return null;
      case 25:
        return null;
    }
    throw Error(t(156, i.tag));
  }
  function oT(n, i) {
    switch (ru(i), i.tag) {
      case 1:
        return qr(i.type) && M2(), n = i.flags, n & 65536 ? (i.flags = n & -65537 | 128, i) : null;
      case 3:
        return Eo(), Bt(zr), Bt(Lr), mu(), n = i.flags, (n & 65536) !== 0 && (n & 128) === 0 ? (i.flags = n & -65537 | 128, i) : null;
      case 5:
        return pu(i), null;
      case 13:
        if (Bt(Wt), n = i.memoizedState, n !== null && n.dehydrated !== null) {
          if (i.alternate === null) throw Error(t(340));
          po();
        }
        return n = i.flags, n & 65536 ? (i.flags = n & -65537 | 128, i) : null;
      case 19:
        return Bt(Wt), null;
      case 4:
        return Eo(), null;
      case 10:
        return lu(i.type._context), null;
      case 22:
      case 23:
        return qu(), null;
      case 24:
        return null;
      default:
        return null;
    }
  }
  var X2 = !1, Pr = !1, sT = typeof WeakSet == "function" ? WeakSet : Set, xe = null;
  function So(n, i) {
    var s = n.ref;
    if (s !== null) if (typeof s == "function") try {
      s(null);
    } catch (d) {
      Jt(n, i, d);
    }
    else s.current = null;
  }
  function Hu(n, i, s) {
    try {
      s();
    } catch (d) {
      Jt(n, i, d);
    }
  }
  var A_ = !1;
  function lT(n, i) {
    if (qc = xt, n = nm(), xc(n)) {
      if ("selectionStart" in n) var s = { start: n.selectionStart, end: n.selectionEnd };
      else e: {
        s = (s = n.ownerDocument) && s.defaultView || window;
        var d = s.getSelection && s.getSelection();
        if (d && d.rangeCount !== 0) {
          s = d.anchorNode;
          var m = d.anchorOffset, I = d.focusNode;
          d = d.focusOffset;
          try {
            s.nodeType, I.nodeType;
          } catch (ve) {
            s = null;
            break e;
          }
          var A = 0, b = -1, F = -1, te = 0, me = 0, Ce = n, he = null;
          t: for (; ; ) {
            for (var He; Ce !== s || m !== 0 && Ce.nodeType !== 3 || (b = A + m), Ce !== I || d !== 0 && Ce.nodeType !== 3 || (F = A + d), Ce.nodeType === 3 && (A += Ce.nodeValue.length), (He = Ce.firstChild) !== null; )
              he = Ce, Ce = He;
            for (; ; ) {
              if (Ce === n) break t;
              if (he === s && ++te === m && (b = A), he === I && ++me === d && (F = A), (He = Ce.nextSibling) !== null) break;
              Ce = he, he = Ce.parentNode;
            }
            Ce = He;
          }
          s = b === -1 || F === -1 ? null : { start: b, end: F };
        } else s = null;
      }
      s = s || { start: 0, end: 0 };
    } else s = null;
    for (Wc = { focusedElem: n, selectionRange: s }, xt = !1, xe = i; xe !== null; ) if (i = xe, n = i.child, (i.subtreeFlags & 1028) !== 0 && n !== null) n.return = i, xe = n;
    else for (; xe !== null; ) {
      i = xe;
      try {
        var Be = i.alternate;
        if ((i.flags & 1024) !== 0) switch (i.tag) {
          case 0:
          case 11:
          case 15:
            break;
          case 1:
            if (Be !== null) {
              var Ge = Be.memoizedProps, ar = Be.memoizedState, W = i.stateNode, x = W.getSnapshotBeforeUpdate(i.elementType === i.type ? Ge : Vn(i.type, Ge), ar);
              W.__reactInternalSnapshotBeforeUpdate = x;
            }
            break;
          case 3:
            var Q = i.stateNode.containerInfo;
            Q.nodeType === 1 ? Q.textContent = "" : Q.nodeType === 9 && Q.documentElement && Q.removeChild(Q.documentElement);
            break;
          case 5:
          case 6:
          case 4:
          case 17:
            break;
          default:
            throw Error(t(163));
        }
      } catch (ve) {
        Jt(i, i.return, ve);
      }
      if (n = i.sibling, n !== null) {
        n.return = i.return, xe = n;
        break;
      }
      xe = i.return;
    }
    return Be = A_, A_ = !1, Be;
  }
  function Is(n, i, s) {
    var d = i.updateQueue;
    if (d = d !== null ? d.lastEffect : null, d !== null) {
      var m = d = d.next;
      do {
        if ((m.tag & n) === n) {
          var I = m.destroy;
          m.destroy = void 0, I !== void 0 && Hu(i, s, I);
        }
        m = m.next;
      } while (m !== d);
    }
  }
  function Q2(n, i) {
    if (i = i.updateQueue, i = i !== null ? i.lastEffect : null, i !== null) {
      var s = i = i.next;
      do {
        if ((s.tag & n) === n) {
          var d = s.create;
          s.destroy = d();
        }
        s = s.next;
      } while (s !== i);
    }
  }
  function Vu(n) {
    var i = n.ref;
    if (i !== null) {
      var s = n.stateNode;
      switch (n.tag) {
        case 5:
          n = s;
          break;
        default:
          n = s;
      }
      typeof i == "function" ? i(n) : i.current = n;
    }
  }
  function T_(n) {
    var i = n.alternate;
    i !== null && (n.alternate = null, T_(i)), n.child = null, n.deletions = null, n.sibling = null, n.tag === 5 && (i = n.stateNode, i !== null && (delete i[ni], delete i[cs], delete i[Qc], delete i[ZA], delete i[jA])), n.stateNode = null, n.return = null, n.dependencies = null, n.memoizedProps = null, n.memoizedState = null, n.pendingProps = null, n.stateNode = null, n.updateQueue = null;
  }
  function O_(n) {
    return n.tag === 5 || n.tag === 3 || n.tag === 4;
  }
  function y_(n) {
    e: for (; ; ) {
      for (; n.sibling === null; ) {
        if (n.return === null || O_(n.return)) return null;
        n = n.return;
      }
      for (n.sibling.return = n.return, n = n.sibling; n.tag !== 5 && n.tag !== 6 && n.tag !== 18; ) {
        if (n.flags & 2 || n.child === null || n.tag === 4) continue e;
        n.child.return = n, n = n.child;
      }
      if (!(n.flags & 2)) return n.stateNode;
    }
  }
  function ku(n, i, s) {
    var d = n.tag;
    if (d === 5 || d === 6) n = n.stateNode, i ? s.nodeType === 8 ? s.parentNode.insertBefore(n, i) : s.insertBefore(n, i) : (s.nodeType === 8 ? (i = s.parentNode, i.insertBefore(n, s)) : (i = s, i.appendChild(n)), s = s._reactRootContainer, s != null || i.onclick !== null || (i.onclick = N2));
    else if (d !== 4 && (n = n.child, n !== null)) for (ku(n, i, s), n = n.sibling; n !== null; ) ku(n, i, s), n = n.sibling;
  }
  function Fu(n, i, s) {
    var d = n.tag;
    if (d === 5 || d === 6) n = n.stateNode, i ? s.insertBefore(n, i) : s.appendChild(n);
    else if (d !== 4 && (n = n.child, n !== null)) for (Fu(n, i, s), n = n.sibling; n !== null; ) Fu(n, i, s), n = n.sibling;
  }
  var Dr = null, kn = !1;
  function ji(n, i, s) {
    for (s = s.child; s !== null; ) N_(n, i, s), s = s.sibling;
  }
  function N_(n, i, s) {
    if (Br && typeof Br.onCommitFiberUnmount == "function") try {
      Br.onCommitFiberUnmount(mi, s);
    } catch (b) {
    }
    switch (s.tag) {
      case 5:
        Pr || So(s, i);
      case 6:
        var d = Dr, m = kn;
        Dr = null, ji(n, i, s), Dr = d, kn = m, Dr !== null && (kn ? (n = Dr, s = s.stateNode, n.nodeType === 8 ? n.parentNode.removeChild(s) : n.removeChild(s)) : Dr.removeChild(s.stateNode));
        break;
      case 18:
        Dr !== null && (kn ? (n = Dr, s = s.stateNode, n.nodeType === 8 ? Xc(n.parentNode, s) : n.nodeType === 1 && Xc(n, s), pe(n)) : Xc(Dr, s.stateNode));
        break;
      case 4:
        d = Dr, m = kn, Dr = s.stateNode.containerInfo, kn = !0, ji(n, i, s), Dr = d, kn = m;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        if (!Pr && (d = s.updateQueue, d !== null && (d = d.lastEffect, d !== null))) {
          m = d = d.next;
          do {
            var I = m, A = I.destroy;
            I = I.tag, A !== void 0 && ((I & 2) !== 0 || (I & 4) !== 0) && Hu(s, i, A), m = m.next;
          } while (m !== d);
        }
        ji(n, i, s);
        break;
      case 1:
        if (!Pr && (So(s, i), d = s.stateNode, typeof d.componentWillUnmount == "function")) try {
          d.props = s.memoizedProps, d.state = s.memoizedState, d.componentWillUnmount();
        } catch (b) {
          Jt(s, i, b);
        }
        ji(n, i, s);
        break;
      case 21:
        ji(n, i, s);
        break;
      case 22:
        s.mode & 1 ? (Pr = (d = Pr) || s.memoizedState !== null, ji(n, i, s), Pr = d) : ji(n, i, s);
        break;
      default:
        ji(n, i, s);
    }
  }
  function L_(n) {
    var i = n.updateQueue;
    if (i !== null) {
      n.updateQueue = null;
      var s = n.stateNode;
      s === null && (s = n.stateNode = new sT()), i.forEach(function(d) {
        var m = ET.bind(null, n, d);
        s.has(d) || (s.add(d), d.then(m, m));
      });
    }
  }
  function Fn(n, i) {
    var s = i.deletions;
    if (s !== null) for (var d = 0; d < s.length; d++) {
      var m = s[d];
      try {
        var I = n, A = i, b = A;
        e: for (; b !== null; ) {
          switch (b.tag) {
            case 5:
              Dr = b.stateNode, kn = !1;
              break e;
            case 3:
              Dr = b.stateNode.containerInfo, kn = !0;
              break e;
            case 4:
              Dr = b.stateNode.containerInfo, kn = !0;
              break e;
          }
          b = b.return;
        }
        if (Dr === null) throw Error(t(160));
        N_(I, A, m), Dr = null, kn = !1;
        var F = m.alternate;
        F !== null && (F.return = null), m.return = null;
      } catch (te) {
        Jt(m, i, te);
      }
    }
    if (i.subtreeFlags & 12854) for (i = i.child; i !== null; ) M_(i, n), i = i.sibling;
  }
  function M_(n, i) {
    var s = n.alternate, d = n.flags;
    switch (n.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        if (Fn(i, n), oi(n), d & 4) {
          try {
            Is(3, n, n.return), Q2(3, n);
          } catch (Ge) {
            Jt(n, n.return, Ge);
          }
          try {
            Is(5, n, n.return);
          } catch (Ge) {
            Jt(n, n.return, Ge);
          }
        }
        break;
      case 1:
        Fn(i, n), oi(n), d & 512 && s !== null && So(s, s.return);
        break;
      case 5:
        if (Fn(i, n), oi(n), d & 512 && s !== null && So(s, s.return), n.flags & 32) {
          var m = n.stateNode;
          try {
            ht(m, "");
          } catch (Ge) {
            Jt(n, n.return, Ge);
          }
        }
        if (d & 4 && (m = n.stateNode, m != null)) {
          var I = n.memoizedProps, A = s !== null ? s.memoizedProps : I, b = n.type, F = n.updateQueue;
          if (n.updateQueue = null, F !== null) try {
            b === "input" && I.type === "radio" && I.name != null && St(m, I), Or(b, A);
            var te = Or(b, I);
            for (A = 0; A < F.length; A += 2) {
              var me = F[A], Ce = F[A + 1];
              me === "style" ? et(m, Ce) : me === "dangerouslySetInnerHTML" ? rt(m, Ce) : me === "children" ? ht(m, Ce) : D(m, me, Ce, te);
            }
            switch (b) {
              case "input":
                dt(m, I);
                break;
              case "textarea":
                Lt(m, I);
                break;
              case "select":
                var he = m._wrapperState.wasMultiple;
                m._wrapperState.wasMultiple = !!I.multiple;
                var He = I.value;
                He != null ? de(m, !!I.multiple, He, !1) : he !== !!I.multiple && (I.defaultValue != null ? de(
                  m,
                  !!I.multiple,
                  I.defaultValue,
                  !0
                ) : de(m, !!I.multiple, I.multiple ? [] : "", !1));
            }
            m[cs] = I;
          } catch (Ge) {
            Jt(n, n.return, Ge);
          }
        }
        break;
      case 6:
        if (Fn(i, n), oi(n), d & 4) {
          if (n.stateNode === null) throw Error(t(162));
          m = n.stateNode, I = n.memoizedProps;
          try {
            m.nodeValue = I;
          } catch (Ge) {
            Jt(n, n.return, Ge);
          }
        }
        break;
      case 3:
        if (Fn(i, n), oi(n), d & 4 && s !== null && s.memoizedState.isDehydrated) try {
          pe(i.containerInfo);
        } catch (Ge) {
          Jt(n, n.return, Ge);
        }
        break;
      case 4:
        Fn(i, n), oi(n);
        break;
      case 13:
        Fn(i, n), oi(n), m = n.child, m.flags & 8192 && (I = m.memoizedState !== null, m.stateNode.isHidden = I, !I || m.alternate !== null && m.alternate.memoizedState !== null || (Bu = lt())), d & 4 && L_(n);
        break;
      case 22:
        if (me = s !== null && s.memoizedState !== null, n.mode & 1 ? (Pr = (te = Pr) || me, Fn(i, n), Pr = te) : Fn(i, n), oi(n), d & 8192) {
          if (te = n.memoizedState !== null, (n.stateNode.isHidden = te) && !me && (n.mode & 1) !== 0) for (xe = n, me = n.child; me !== null; ) {
            for (Ce = xe = me; xe !== null; ) {
              switch (he = xe, He = he.child, he.tag) {
                case 0:
                case 11:
                case 14:
                case 15:
                  Is(4, he, he.return);
                  break;
                case 1:
                  So(he, he.return);
                  var Be = he.stateNode;
                  if (typeof Be.componentWillUnmount == "function") {
                    d = he, s = he.return;
                    try {
                      i = d, Be.props = i.memoizedProps, Be.state = i.memoizedState, Be.componentWillUnmount();
                    } catch (Ge) {
                      Jt(d, s, Ge);
                    }
                  }
                  break;
                case 5:
                  So(he, he.return);
                  break;
                case 22:
                  if (he.memoizedState !== null) {
                    w_(Ce);
                    continue;
                  }
              }
              He !== null ? (He.return = he, xe = He) : w_(Ce);
            }
            me = me.sibling;
          }
          e: for (me = null, Ce = n; ; ) {
            if (Ce.tag === 5) {
              if (me === null) {
                me = Ce;
                try {
                  m = Ce.stateNode, te ? (I = m.style, typeof I.setProperty == "function" ? I.setProperty("display", "none", "important") : I.display = "none") : (b = Ce.stateNode, F = Ce.memoizedProps.style, A = F != null && F.hasOwnProperty("display") ? F.display : null, b.style.display = De("display", A));
                } catch (Ge) {
                  Jt(n, n.return, Ge);
                }
              }
            } else if (Ce.tag === 6) {
              if (me === null) try {
                Ce.stateNode.nodeValue = te ? "" : Ce.memoizedProps;
              } catch (Ge) {
                Jt(n, n.return, Ge);
              }
            } else if ((Ce.tag !== 22 && Ce.tag !== 23 || Ce.memoizedState === null || Ce === n) && Ce.child !== null) {
              Ce.child.return = Ce, Ce = Ce.child;
              continue;
            }
            if (Ce === n) break e;
            for (; Ce.sibling === null; ) {
              if (Ce.return === null || Ce.return === n) break e;
              me === Ce && (me = null), Ce = Ce.return;
            }
            me === Ce && (me = null), Ce.sibling.return = Ce.return, Ce = Ce.sibling;
          }
        }
        break;
      case 19:
        Fn(i, n), oi(n), d & 4 && L_(n);
        break;
      case 21:
        break;
      default:
        Fn(
          i,
          n
        ), oi(n);
    }
  }
  function oi(n) {
    var i = n.flags;
    if (i & 2) {
      try {
        e: {
          for (var s = n.return; s !== null; ) {
            if (O_(s)) {
              var d = s;
              break e;
            }
            s = s.return;
          }
          throw Error(t(160));
        }
        switch (d.tag) {
          case 5:
            var m = d.stateNode;
            d.flags & 32 && (ht(m, ""), d.flags &= -33);
            var I = y_(n);
            Fu(n, I, m);
            break;
          case 3:
          case 4:
            var A = d.stateNode.containerInfo, b = y_(n);
            ku(n, b, A);
            break;
          default:
            throw Error(t(161));
        }
      } catch (F) {
        Jt(n, n.return, F);
      }
      n.flags &= -3;
    }
    i & 4096 && (n.flags &= -4097);
  }
  function cT(n, i, s) {
    xe = n, b_(n);
  }
  function b_(n, i, s) {
    for (var d = (n.mode & 1) !== 0; xe !== null; ) {
      var m = xe, I = m.child;
      if (m.tag === 22 && d) {
        var A = m.memoizedState !== null || X2;
        if (!A) {
          var b = m.alternate, F = b !== null && b.memoizedState !== null || Pr;
          b = X2;
          var te = Pr;
          if (X2 = A, (Pr = F) && !te) for (xe = m; xe !== null; ) A = xe, F = A.child, A.tag === 22 && A.memoizedState !== null ? H_(m) : F !== null ? (F.return = A, xe = F) : H_(m);
          for (; I !== null; ) xe = I, b_(I), I = I.sibling;
          xe = m, X2 = b, Pr = te;
        }
        P_(n);
      } else (m.subtreeFlags & 8772) !== 0 && I !== null ? (I.return = m, xe = I) : P_(n);
    }
  }
  function P_(n) {
    for (; xe !== null; ) {
      var i = xe;
      if ((i.flags & 8772) !== 0) {
        var s = i.alternate;
        try {
          if ((i.flags & 8772) !== 0) switch (i.tag) {
            case 0:
            case 11:
            case 15:
              Pr || Q2(5, i);
              break;
            case 1:
              var d = i.stateNode;
              if (i.flags & 4 && !Pr) if (s === null) d.componentDidMount();
              else {
                var m = i.elementType === i.type ? s.memoizedProps : Vn(i.type, s.memoizedProps);
                d.componentDidUpdate(m, s.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
              }
              var I = i.updateQueue;
              I !== null && wm(i, I, d);
              break;
            case 3:
              var A = i.updateQueue;
              if (A !== null) {
                if (s = null, i.child !== null) switch (i.child.tag) {
                  case 5:
                    s = i.child.stateNode;
                    break;
                  case 1:
                    s = i.child.stateNode;
                }
                wm(i, A, s);
              }
              break;
            case 5:
              var b = i.stateNode;
              if (s === null && i.flags & 4) {
                s = b;
                var F = i.memoizedProps;
                switch (i.type) {
                  case "button":
                  case "input":
                  case "select":
                  case "textarea":
                    F.autoFocus && s.focus();
                    break;
                  case "img":
                    F.src && (s.src = F.src);
                }
              }
              break;
            case 6:
              break;
            case 4:
              break;
            case 12:
              break;
            case 13:
              if (i.memoizedState === null) {
                var te = i.alternate;
                if (te !== null) {
                  var me = te.memoizedState;
                  if (me !== null) {
                    var Ce = me.dehydrated;
                    Ce !== null && pe(Ce);
                  }
                }
              }
              break;
            case 19:
            case 17:
            case 21:
            case 22:
            case 23:
            case 25:
              break;
            default:
              throw Error(t(163));
          }
          Pr || i.flags & 512 && Vu(i);
        } catch (he) {
          Jt(i, i.return, he);
        }
      }
      if (i === n) {
        xe = null;
        break;
      }
      if (s = i.sibling, s !== null) {
        s.return = i.return, xe = s;
        break;
      }
      xe = i.return;
    }
  }
  function w_(n) {
    for (; xe !== null; ) {
      var i = xe;
      if (i === n) {
        xe = null;
        break;
      }
      var s = i.sibling;
      if (s !== null) {
        s.return = i.return, xe = s;
        break;
      }
      xe = i.return;
    }
  }
  function H_(n) {
    for (; xe !== null; ) {
      var i = xe;
      try {
        switch (i.tag) {
          case 0:
          case 11:
          case 15:
            var s = i.return;
            try {
              Q2(4, i);
            } catch (F) {
              Jt(i, s, F);
            }
            break;
          case 1:
            var d = i.stateNode;
            if (typeof d.componentDidMount == "function") {
              var m = i.return;
              try {
                d.componentDidMount();
              } catch (F) {
                Jt(i, m, F);
              }
            }
            var I = i.return;
            try {
              Vu(i);
            } catch (F) {
              Jt(i, I, F);
            }
            break;
          case 5:
            var A = i.return;
            try {
              Vu(i);
            } catch (F) {
              Jt(i, A, F);
            }
        }
      } catch (F) {
        Jt(i, i.return, F);
      }
      if (i === n) {
        xe = null;
        break;
      }
      var b = i.sibling;
      if (b !== null) {
        b.return = i.return, xe = b;
        break;
      }
      xe = i.return;
    }
  }
  var uT = Math.ceil, J2 = T.ReactCurrentDispatcher, xu = T.ReactCurrentOwner, In = T.ReactCurrentBatchConfig, Dt = 0, _r = null, lr = null, Rr = 0, ln = 0, Io = Ui(0), fr = 0, vs = null, Da = 0, el = 0, Uu = 0, gs = null, Yr = null, Bu = 0, vo = 1 / 0, Di = null, tl = !1, $u = null, zi = null, rl = !1, qi = null, nl = 0, Ds = 0, Gu = null, il = -1, al = 0;
  function Gr() {
    return (Dt & 6) !== 0 ? lt() : il !== -1 ? il : il = lt();
  }
  function Wi(n) {
    return (n.mode & 1) === 0 ? 1 : (Dt & 2) !== 0 && Rr !== 0 ? Rr & -Rr : qA.transition !== null ? (al === 0 && (al = u2()), al) : (n = yt, n !== 0 || (n = window.event, n = n === void 0 ? 16 : Qo(n.type)), n);
  }
  function xn(n, i, s, d) {
    if (50 < Ds) throw Ds = 0, Gu = null, Error(t(185));
    da(n, s, d), ((Dt & 2) === 0 || n !== _r) && (n === _r && ((Dt & 2) === 0 && (el |= s), fr === 4 && Yi(n, Rr)), Kr(n, d), s === 1 && Dt === 0 && (i.mode & 1) === 0 && (vo = lt() + 500, P2 && $i()));
  }
  function Kr(n, i) {
    var s = n.callbackNode;
    yc(n, i);
    var d = Ya(n, n === _r ? Rr : 0);
    if (d === 0) s !== null && Qe(s), n.callbackNode = null, n.callbackPriority = 0;
    else if (i = d & -d, n.callbackPriority !== i) {
      if (s != null && Qe(s), i === 1) n.tag === 0 ? zA(k_.bind(null, n)) : gm(k_.bind(null, n)), $A(function() {
        (Dt & 6) === 0 && $i();
      }), s = null;
      else {
        switch (f2(d)) {
          case 1:
            s = hr;
            break;
          case 4:
            s = _e;
            break;
          case 16:
            s = Vt;
            break;
          case 536870912:
            s = ki;
            break;
          default:
            s = Vt;
        }
        s = j_(s, V_.bind(null, n));
      }
      n.callbackPriority = i, n.callbackNode = s;
    }
  }
  function V_(n, i) {
    if (il = -1, al = 0, (Dt & 6) !== 0) throw Error(t(327));
    var s = n.callbackNode;
    if (go() && n.callbackNode !== s) return null;
    var d = Ya(n, n === _r ? Rr : 0);
    if (d === 0) return null;
    if ((d & 30) !== 0 || (d & n.expiredLanes) !== 0 || i) i = ol(n, d);
    else {
      i = d;
      var m = Dt;
      Dt |= 2;
      var I = x_();
      (_r !== n || Rr !== i) && (Di = null, vo = lt() + 500, Aa(n, i));
      do
        try {
          pT();
          break;
        } catch (b) {
          F_(n, b);
        }
      while (!0);
      su(), J2.current = I, Dt = m, lr !== null ? i = 0 : (_r = null, Rr = 0, i = fr);
    }
    if (i !== 0) {
      if (i === 2 && (m = zo(n), m !== 0 && (d = m, i = Zu(n, m))), i === 1) throw s = vs, Aa(n, 0), Yi(n, d), Kr(n, lt()), s;
      if (i === 6) Yi(n, d);
      else {
        if (m = n.current.alternate, (d & 30) === 0 && !fT(m) && (i = ol(n, d), i === 2 && (I = zo(n), I !== 0 && (d = I, i = Zu(n, I))), i === 1)) throw s = vs, Aa(n, 0), Yi(n, d), Kr(n, lt()), s;
        switch (n.finishedWork = m, n.finishedLanes = d, i) {
          case 0:
          case 1:
            throw Error(t(345));
          case 2:
            Ta(n, Yr, Di);
            break;
          case 3:
            if (Yi(n, d), (d & 130023424) === d && (i = Bu + 500 - lt(), 10 < i)) {
              if (Ya(n, 0) !== 0) break;
              if (m = n.suspendedLanes, (m & d) !== d) {
                Gr(), n.pingedLanes |= n.suspendedLanes & m;
                break;
              }
              n.timeoutHandle = Kc(Ta.bind(null, n, Yr, Di), i);
              break;
            }
            Ta(n, Yr, Di);
            break;
          case 4:
            if (Yi(n, d), (d & 4194240) === d) break;
            for (i = n.eventTimes, m = -1; 0 < d; ) {
              var A = 31 - nn(d);
              I = 1 << A, A = i[A], A > m && (m = A), d &= ~I;
            }
            if (d = m, d = lt() - d, d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3e3 > d ? 3e3 : 4320 > d ? 4320 : 1960 * uT(d / 1960)) - d, 10 < d) {
              n.timeoutHandle = Kc(Ta.bind(null, n, Yr, Di), d);
              break;
            }
            Ta(n, Yr, Di);
            break;
          case 5:
            Ta(n, Yr, Di);
            break;
          default:
            throw Error(t(329));
        }
      }
    }
    return Kr(n, lt()), n.callbackNode === s ? V_.bind(null, n) : null;
  }
  function Zu(n, i) {
    var s = gs;
    return n.current.memoizedState.isDehydrated && (Aa(n, i).flags |= 256), n = ol(n, i), n !== 2 && (i = Yr, Yr = s, i !== null && ju(i)), n;
  }
  function ju(n) {
    Yr === null ? Yr = n : Yr.push.apply(Yr, n);
  }
  function fT(n) {
    for (var i = n; ; ) {
      if (i.flags & 16384) {
        var s = i.updateQueue;
        if (s !== null && (s = s.stores, s !== null)) for (var d = 0; d < s.length; d++) {
          var m = s[d], I = m.getSnapshot;
          m = m.value;
          try {
            if (!wn(I(), m)) return !1;
          } catch (A) {
            return !1;
          }
        }
      }
      if (s = i.child, i.subtreeFlags & 16384 && s !== null) s.return = i, i = s;
      else {
        if (i === n) break;
        for (; i.sibling === null; ) {
          if (i.return === null || i.return === n) return !0;
          i = i.return;
        }
        i.sibling.return = i.return, i = i.sibling;
      }
    }
    return !0;
  }
  function Yi(n, i) {
    for (i &= ~Uu, i &= ~el, n.suspendedLanes |= i, n.pingedLanes &= ~i, n = n.expirationTimes; 0 < i; ) {
      var s = 31 - nn(i), d = 1 << s;
      n[s] = -1, i &= ~d;
    }
  }
  function k_(n) {
    if ((Dt & 6) !== 0) throw Error(t(327));
    go();
    var i = Ya(n, 0);
    if ((i & 1) === 0) return Kr(n, lt()), null;
    var s = ol(n, i);
    if (n.tag !== 0 && s === 2) {
      var d = zo(n);
      d !== 0 && (i = d, s = Zu(n, d));
    }
    if (s === 1) throw s = vs, Aa(n, 0), Yi(n, i), Kr(n, lt()), s;
    if (s === 6) throw Error(t(345));
    return n.finishedWork = n.current.alternate, n.finishedLanes = i, Ta(n, Yr, Di), Kr(n, lt()), null;
  }
  function zu(n, i) {
    var s = Dt;
    Dt |= 1;
    try {
      return n(i);
    } finally {
      Dt = s, Dt === 0 && (vo = lt() + 500, P2 && $i());
    }
  }
  function Ra(n) {
    qi !== null && qi.tag === 0 && (Dt & 6) === 0 && go();
    var i = Dt;
    Dt |= 1;
    var s = In.transition, d = yt;
    try {
      if (In.transition = null, yt = 1, n) return n();
    } finally {
      yt = d, In.transition = s, Dt = i, (Dt & 6) === 0 && $i();
    }
  }
  function qu() {
    ln = Io.current, Bt(Io);
  }
  function Aa(n, i) {
    n.finishedWork = null, n.finishedLanes = 0;
    var s = n.timeoutHandle;
    if (s !== -1 && (n.timeoutHandle = -1, BA(s)), lr !== null) for (s = lr.return; s !== null; ) {
      var d = s;
      switch (ru(d), d.tag) {
        case 1:
          d = d.type.childContextTypes, d != null && M2();
          break;
        case 3:
          Eo(), Bt(zr), Bt(Lr), mu();
          break;
        case 5:
          pu(d);
          break;
        case 4:
          Eo();
          break;
        case 13:
          Bt(Wt);
          break;
        case 19:
          Bt(Wt);
          break;
        case 10:
          lu(d.type._context);
          break;
        case 22:
        case 23:
          qu();
      }
      s = s.return;
    }
    if (_r = n, lr = n = Ki(n.current, null), Rr = ln = i, fr = 0, vs = null, Uu = el = Da = 0, Yr = gs = null, Ia !== null) {
      for (i = 0; i < Ia.length; i++) if (s = Ia[i], d = s.interleaved, d !== null) {
        s.interleaved = null;
        var m = d.next, I = s.pending;
        if (I !== null) {
          var A = I.next;
          I.next = m, d.next = A;
        }
        s.pending = d;
      }
      Ia = null;
    }
    return n;
  }
  function F_(n, i) {
    do {
      var s = lr;
      try {
        if (su(), G2.current = q2, Z2) {
          for (var d = Yt.memoizedState; d !== null; ) {
            var m = d.queue;
            m !== null && (m.pending = null), d = d.next;
          }
          Z2 = !1;
        }
        if (ga = 0, mr = ur = Yt = null, ms = !1, _s = 0, xu.current = null, s === null || s.return === null) {
          fr = 1, vs = i, lr = null;
          break;
        }
        e: {
          var I = n, A = s.return, b = s, F = i;
          if (i = Rr, b.flags |= 32768, F !== null && typeof F == "object" && typeof F.then == "function") {
            var te = F, me = b, Ce = me.tag;
            if ((me.mode & 1) === 0 && (Ce === 0 || Ce === 11 || Ce === 15)) {
              var he = me.alternate;
              he ? (me.updateQueue = he.updateQueue, me.memoizedState = he.memoizedState, me.lanes = he.lanes) : (me.updateQueue = null, me.memoizedState = null);
            }
            var He = c_(A);
            if (He !== null) {
              He.flags &= -257, u_(He, A, b, I, i), He.mode & 1 && l_(I, te, i), i = He, F = te;
              var Be = i.updateQueue;
              if (Be === null) {
                var Ge = /* @__PURE__ */ new Set();
                Ge.add(F), i.updateQueue = Ge;
              } else Be.add(F);
              break e;
            } else {
              if ((i & 1) === 0) {
                l_(I, te, i), Wu();
                break e;
              }
              F = Error(t(426));
            }
          } else if (Gt && b.mode & 1) {
            var ar = c_(A);
            if (ar !== null) {
              (ar.flags & 65536) === 0 && (ar.flags |= 256), u_(ar, A, b, I, i), au(Co(F, b));
              break e;
            }
          }
          I = F = Co(F, b), fr !== 4 && (fr = 2), gs === null ? gs = [I] : gs.push(I), I = A;
          do {
            switch (I.tag) {
              case 3:
                I.flags |= 65536, i &= -i, I.lanes |= i;
                var W = o_(I, F, i);
                Pm(I, W);
                break e;
              case 1:
                b = F;
                var x = I.type, Q = I.stateNode;
                if ((I.flags & 128) === 0 && (typeof x.getDerivedStateFromError == "function" || Q !== null && typeof Q.componentDidCatch == "function" && (zi === null || !zi.has(Q)))) {
                  I.flags |= 65536, i &= -i, I.lanes |= i;
                  var ve = s_(I, b, i);
                  Pm(I, ve);
                  break e;
                }
            }
            I = I.return;
          } while (I !== null);
        }
        B_(s);
      } catch (Ze) {
        i = Ze, lr === s && s !== null && (lr = s = s.return);
        continue;
      }
      break;
    } while (!0);
  }
  function x_() {
    var n = J2.current;
    return J2.current = q2, n === null ? q2 : n;
  }
  function Wu() {
    (fr === 0 || fr === 3 || fr === 2) && (fr = 4), _r === null || (Da & 268435455) === 0 && (el & 268435455) === 0 || Yi(_r, Rr);
  }
  function ol(n, i) {
    var s = Dt;
    Dt |= 2;
    var d = x_();
    (_r !== n || Rr !== i) && (Di = null, Aa(n, i));
    do
      try {
        dT();
        break;
      } catch (m) {
        F_(n, m);
      }
    while (!0);
    if (su(), Dt = s, J2.current = d, lr !== null) throw Error(t(261));
    return _r = null, Rr = 0, fr;
  }
  function dT() {
    for (; lr !== null; ) U_(lr);
  }
  function pT() {
    for (; lr !== null && !Fe(); ) U_(lr);
  }
  function U_(n) {
    var i = Z_(n.alternate, n, ln);
    n.memoizedProps = n.pendingProps, i === null ? B_(n) : lr = i, xu.current = null;
  }
  function B_(n) {
    var i = n;
    do {
      var s = i.alternate;
      if (n = i.return, (i.flags & 32768) === 0) {
        if (s = aT(s, i, ln), s !== null) {
          lr = s;
          return;
        }
      } else {
        if (s = oT(s, i), s !== null) {
          s.flags &= 32767, lr = s;
          return;
        }
        if (n !== null) n.flags |= 32768, n.subtreeFlags = 0, n.deletions = null;
        else {
          fr = 6, lr = null;
          return;
        }
      }
      if (i = i.sibling, i !== null) {
        lr = i;
        return;
      }
      lr = i = n;
    } while (i !== null);
    fr === 0 && (fr = 5);
  }
  function Ta(n, i, s) {
    var d = yt, m = In.transition;
    try {
      In.transition = null, yt = 1, hT(n, i, s, d);
    } finally {
      In.transition = m, yt = d;
    }
    return null;
  }
  function hT(n, i, s, d) {
    do
      go();
    while (qi !== null);
    if ((Dt & 6) !== 0) throw Error(t(327));
    s = n.finishedWork;
    var m = n.finishedLanes;
    if (s === null) return null;
    if (n.finishedWork = null, n.finishedLanes = 0, s === n.current) throw Error(t(177));
    n.callbackNode = null, n.callbackPriority = 0;
    var I = s.lanes | s.childLanes;
    if (Nc(n, I), n === _r && (lr = _r = null, Rr = 0), (s.subtreeFlags & 2064) === 0 && (s.flags & 2064) === 0 || rl || (rl = !0, j_(Vt, function() {
      return go(), null;
    })), I = (s.flags & 15990) !== 0, (s.subtreeFlags & 15990) !== 0 || I) {
      I = In.transition, In.transition = null;
      var A = yt;
      yt = 1;
      var b = Dt;
      Dt |= 4, xu.current = null, lT(n, s), M_(s, n), wA(Wc), xt = !!qc, Wc = qc = null, n.current = s, cT(s), Ht(), Dt = b, yt = A, In.transition = I;
    } else n.current = s;
    if (rl && (rl = !1, qi = n, nl = m), I = n.pendingLanes, I === 0 && (zi = null), ua(s.stateNode), Kr(n, lt()), i !== null) for (d = n.onRecoverableError, s = 0; s < i.length; s++) m = i[s], d(m.value, { componentStack: m.stack, digest: m.digest });
    if (tl) throw tl = !1, n = $u, $u = null, n;
    return (nl & 1) !== 0 && n.tag !== 0 && go(), I = n.pendingLanes, (I & 1) !== 0 ? n === Gu ? Ds++ : (Ds = 0, Gu = n) : Ds = 0, $i(), null;
  }
  function go() {
    if (qi !== null) {
      var n = f2(nl), i = In.transition, s = yt;
      try {
        if (In.transition = null, yt = 16 > n ? 16 : n, qi === null) var d = !1;
        else {
          if (n = qi, qi = null, nl = 0, (Dt & 6) !== 0) throw Error(t(331));
          var m = Dt;
          for (Dt |= 4, xe = n.current; xe !== null; ) {
            var I = xe, A = I.child;
            if ((xe.flags & 16) !== 0) {
              var b = I.deletions;
              if (b !== null) {
                for (var F = 0; F < b.length; F++) {
                  var te = b[F];
                  for (xe = te; xe !== null; ) {
                    var me = xe;
                    switch (me.tag) {
                      case 0:
                      case 11:
                      case 15:
                        Is(8, me, I);
                    }
                    var Ce = me.child;
                    if (Ce !== null) Ce.return = me, xe = Ce;
                    else for (; xe !== null; ) {
                      me = xe;
                      var he = me.sibling, He = me.return;
                      if (T_(me), me === te) {
                        xe = null;
                        break;
                      }
                      if (he !== null) {
                        he.return = He, xe = he;
                        break;
                      }
                      xe = He;
                    }
                  }
                }
                var Be = I.alternate;
                if (Be !== null) {
                  var Ge = Be.child;
                  if (Ge !== null) {
                    Be.child = null;
                    do {
                      var ar = Ge.sibling;
                      Ge.sibling = null, Ge = ar;
                    } while (Ge !== null);
                  }
                }
                xe = I;
              }
            }
            if ((I.subtreeFlags & 2064) !== 0 && A !== null) A.return = I, xe = A;
            else e: for (; xe !== null; ) {
              if (I = xe, (I.flags & 2048) !== 0) switch (I.tag) {
                case 0:
                case 11:
                case 15:
                  Is(9, I, I.return);
              }
              var W = I.sibling;
              if (W !== null) {
                W.return = I.return, xe = W;
                break e;
              }
              xe = I.return;
            }
          }
          var x = n.current;
          for (xe = x; xe !== null; ) {
            A = xe;
            var Q = A.child;
            if ((A.subtreeFlags & 2064) !== 0 && Q !== null) Q.return = A, xe = Q;
            else e: for (A = x; xe !== null; ) {
              if (b = xe, (b.flags & 2048) !== 0) try {
                switch (b.tag) {
                  case 0:
                  case 11:
                  case 15:
                    Q2(9, b);
                }
              } catch (Ze) {
                Jt(b, b.return, Ze);
              }
              if (b === A) {
                xe = null;
                break e;
              }
              var ve = b.sibling;
              if (ve !== null) {
                ve.return = b.return, xe = ve;
                break e;
              }
              xe = b.return;
            }
          }
          if (Dt = m, $i(), Br && typeof Br.onPostCommitFiberRoot == "function") try {
            Br.onPostCommitFiberRoot(mi, n);
          } catch (Ze) {
          }
          d = !0;
        }
        return d;
      } finally {
        yt = s, In.transition = i;
      }
    }
    return !1;
  }
  function $_(n, i, s) {
    i = Co(s, i), i = o_(n, i, 1), n = Zi(n, i, 1), i = Gr(), n !== null && (da(n, 1, i), Kr(n, i));
  }
  function Jt(n, i, s) {
    if (n.tag === 3) $_(n, n, s);
    else for (; i !== null; ) {
      if (i.tag === 3) {
        $_(i, n, s);
        break;
      } else if (i.tag === 1) {
        var d = i.stateNode;
        if (typeof i.type.getDerivedStateFromError == "function" || typeof d.componentDidCatch == "function" && (zi === null || !zi.has(d))) {
          n = Co(s, n), n = s_(i, n, 1), i = Zi(i, n, 1), n = Gr(), i !== null && (da(i, 1, n), Kr(i, n));
          break;
        }
      }
      i = i.return;
    }
  }
  function mT(n, i, s) {
    var d = n.pingCache;
    d !== null && d.delete(i), i = Gr(), n.pingedLanes |= n.suspendedLanes & s, _r === n && (Rr & s) === s && (fr === 4 || fr === 3 && (Rr & 130023424) === Rr && 500 > lt() - Bu ? Aa(n, 0) : Uu |= s), Kr(n, i);
  }
  function G_(n, i) {
    i === 0 && ((n.mode & 1) === 0 ? i = 1 : (i = Wa, Wa <<= 1, (Wa & 130023424) === 0 && (Wa = 4194304)));
    var s = Gr();
    n = Ii(n, i), n !== null && (da(n, i, s), Kr(n, s));
  }
  function _T(n) {
    var i = n.memoizedState, s = 0;
    i !== null && (s = i.retryLane), G_(n, s);
  }
  function ET(n, i) {
    var s = 0;
    switch (n.tag) {
      case 13:
        var d = n.stateNode, m = n.memoizedState;
        m !== null && (s = m.retryLane);
        break;
      case 19:
        d = n.stateNode;
        break;
      default:
        throw Error(t(314));
    }
    d !== null && d.delete(i), G_(n, s);
  }
  var Z_;
  Z_ = function(n, i, s) {
    if (n !== null) if (n.memoizedProps !== i.pendingProps || zr.current) Wr = !0;
    else {
      if ((n.lanes & s) === 0 && (i.flags & 128) === 0) return Wr = !1, iT(n, i, s);
      Wr = (n.flags & 131072) !== 0;
    }
    else Wr = !1, Gt && (i.flags & 1048576) !== 0 && Dm(i, H2, i.index);
    switch (i.lanes = 0, i.tag) {
      case 2:
        var d = i.type;
        K2(n, i), n = i.pendingProps;
        var m = co(i, Lr.current);
        _o(i, s), m = Cu(null, i, d, n, m, s);
        var I = Su();
        return i.flags |= 1, typeof m == "object" && m !== null && typeof m.render == "function" && m.$$typeof === void 0 ? (i.tag = 1, i.memoizedState = null, i.updateQueue = null, qr(d) ? (I = !0, b2(i)) : I = !1, i.memoizedState = m.state !== null && m.state !== void 0 ? m.state : null, fu(i), m.updater = W2, i.stateNode = m, m._reactInternals = i, Au(i, d, n, s), i = Nu(null, i, d, !0, I, s)) : (i.tag = 0, Gt && I && tu(i), $r(null, i, m, s), i = i.child), i;
      case 16:
        d = i.elementType;
        e: {
          switch (K2(n, i), n = i.pendingProps, m = d._init, d = m(d._payload), i.type = d, m = i.tag = ST(d), n = Vn(d, n), m) {
            case 0:
              i = yu(null, i, d, n, s);
              break e;
            case 1:
              i = __(null, i, d, n, s);
              break e;
            case 11:
              i = f_(null, i, d, n, s);
              break e;
            case 14:
              i = d_(null, i, d, Vn(d.type, n), s);
              break e;
          }
          throw Error(t(
            306,
            d,
            ""
          ));
        }
        return i;
      case 0:
        return d = i.type, m = i.pendingProps, m = i.elementType === d ? m : Vn(d, m), yu(n, i, d, m, s);
      case 1:
        return d = i.type, m = i.pendingProps, m = i.elementType === d ? m : Vn(d, m), __(n, i, d, m, s);
      case 3:
        e: {
          if (E_(i), n === null) throw Error(t(387));
          d = i.pendingProps, I = i.memoizedState, m = I.element, bm(n, i), B2(i, d, null, s);
          var A = i.memoizedState;
          if (d = A.element, I.isDehydrated) if (I = { element: d, isDehydrated: !1, cache: A.cache, pendingSuspenseBoundaries: A.pendingSuspenseBoundaries, transitions: A.transitions }, i.updateQueue.baseState = I, i.memoizedState = I, i.flags & 256) {
            m = Co(Error(t(423)), i), i = C_(n, i, d, s, m);
            break e;
          } else if (d !== m) {
            m = Co(Error(t(424)), i), i = C_(n, i, d, s, m);
            break e;
          } else for (sn = xi(i.stateNode.containerInfo.firstChild), on = i, Gt = !0, Hn = null, s = Lm(i, null, d, s), i.child = s; s; ) s.flags = s.flags & -3 | 4096, s = s.sibling;
          else {
            if (po(), d === m) {
              i = gi(n, i, s);
              break e;
            }
            $r(n, i, d, s);
          }
          i = i.child;
        }
        return i;
      case 5:
        return Hm(i), n === null && iu(i), d = i.type, m = i.pendingProps, I = n !== null ? n.memoizedProps : null, A = m.children, Yc(d, m) ? A = null : I !== null && Yc(d, I) && (i.flags |= 32), m_(n, i), $r(n, i, A, s), i.child;
      case 6:
        return n === null && iu(i), null;
      case 13:
        return S_(n, i, s);
      case 4:
        return du(i, i.stateNode.containerInfo), d = i.pendingProps, n === null ? i.child = ho(i, null, d, s) : $r(n, i, d, s), i.child;
      case 11:
        return d = i.type, m = i.pendingProps, m = i.elementType === d ? m : Vn(d, m), f_(n, i, d, m, s);
      case 7:
        return $r(n, i, i.pendingProps, s), i.child;
      case 8:
        return $r(n, i, i.pendingProps.children, s), i.child;
      case 12:
        return $r(n, i, i.pendingProps.children, s), i.child;
      case 10:
        e: {
          if (d = i.type._context, m = i.pendingProps, I = i.memoizedProps, A = m.value, kt(F2, d._currentValue), d._currentValue = A, I !== null) if (wn(I.value, A)) {
            if (I.children === m.children && !zr.current) {
              i = gi(n, i, s);
              break e;
            }
          } else for (I = i.child, I !== null && (I.return = i); I !== null; ) {
            var b = I.dependencies;
            if (b !== null) {
              A = I.child;
              for (var F = b.firstContext; F !== null; ) {
                if (F.context === d) {
                  if (I.tag === 1) {
                    F = vi(-1, s & -s), F.tag = 2;
                    var te = I.updateQueue;
                    if (te !== null) {
                      te = te.shared;
                      var me = te.pending;
                      me === null ? F.next = F : (F.next = me.next, me.next = F), te.pending = F;
                    }
                  }
                  I.lanes |= s, F = I.alternate, F !== null && (F.lanes |= s), cu(
                    I.return,
                    s,
                    i
                  ), b.lanes |= s;
                  break;
                }
                F = F.next;
              }
            } else if (I.tag === 10) A = I.type === i.type ? null : I.child;
            else if (I.tag === 18) {
              if (A = I.return, A === null) throw Error(t(341));
              A.lanes |= s, b = A.alternate, b !== null && (b.lanes |= s), cu(A, s, i), A = I.sibling;
            } else A = I.child;
            if (A !== null) A.return = I;
            else for (A = I; A !== null; ) {
              if (A === i) {
                A = null;
                break;
              }
              if (I = A.sibling, I !== null) {
                I.return = A.return, A = I;
                break;
              }
              A = A.return;
            }
            I = A;
          }
          $r(n, i, m.children, s), i = i.child;
        }
        return i;
      case 9:
        return m = i.type, d = i.pendingProps.children, _o(i, s), m = Cn(m), d = d(m), i.flags |= 1, $r(n, i, d, s), i.child;
      case 14:
        return d = i.type, m = Vn(d, i.pendingProps), m = Vn(d.type, m), d_(n, i, d, m, s);
      case 15:
        return p_(n, i, i.type, i.pendingProps, s);
      case 17:
        return d = i.type, m = i.pendingProps, m = i.elementType === d ? m : Vn(d, m), K2(n, i), i.tag = 1, qr(d) ? (n = !0, b2(i)) : n = !1, _o(i, s), i_(i, d, m), Au(i, d, m, s), Nu(null, i, d, !0, n, s);
      case 19:
        return v_(n, i, s);
      case 22:
        return h_(n, i, s);
    }
    throw Error(t(156, i.tag));
  };
  function j_(n, i) {
    return fe(n, i);
  }
  function CT(n, i, s, d) {
    this.tag = n, this.key = s, this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null, this.index = 0, this.ref = null, this.pendingProps = i, this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null, this.mode = d, this.subtreeFlags = this.flags = 0, this.deletions = null, this.childLanes = this.lanes = 0, this.alternate = null;
  }
  function vn(n, i, s, d) {
    return new CT(n, i, s, d);
  }
  function Yu(n) {
    return n = n.prototype, !(!n || !n.isReactComponent);
  }
  function ST(n) {
    if (typeof n == "function") return Yu(n) ? 1 : 0;
    if (n != null) {
      if (n = n.$$typeof, n === B) return 11;
      if (n === ie) return 14;
    }
    return 2;
  }
  function Ki(n, i) {
    var s = n.alternate;
    return s === null ? (s = vn(n.tag, i, n.key, n.mode), s.elementType = n.elementType, s.type = n.type, s.stateNode = n.stateNode, s.alternate = n, n.alternate = s) : (s.pendingProps = i, s.type = n.type, s.flags = 0, s.subtreeFlags = 0, s.deletions = null), s.flags = n.flags & 14680064, s.childLanes = n.childLanes, s.lanes = n.lanes, s.child = n.child, s.memoizedProps = n.memoizedProps, s.memoizedState = n.memoizedState, s.updateQueue = n.updateQueue, i = n.dependencies, s.dependencies = i === null ? null : { lanes: i.lanes, firstContext: i.firstContext }, s.sibling = n.sibling, s.index = n.index, s.ref = n.ref, s;
  }
  function sl(n, i, s, d, m, I) {
    var A = 2;
    if (d = n, typeof n == "function") Yu(n) && (A = 1);
    else if (typeof n == "string") A = 5;
    else e: switch (n) {
      case M:
        return Oa(s.children, m, I, i);
      case k:
        A = 8, m |= 8;
        break;
      case H:
        return n = vn(12, s, i, m | 2), n.elementType = H, n.lanes = I, n;
      case Y:
        return n = vn(13, s, i, m), n.elementType = Y, n.lanes = I, n;
      case j:
        return n = vn(19, s, i, m), n.elementType = j, n.lanes = I, n;
      case le:
        return ll(s, m, I, i);
      default:
        if (typeof n == "object" && n !== null) switch (n.$$typeof) {
          case w:
            A = 10;
            break e;
          case $:
            A = 9;
            break e;
          case B:
            A = 11;
            break e;
          case ie:
            A = 14;
            break e;
          case se:
            A = 16, d = null;
            break e;
        }
        throw Error(t(130, n == null ? n : typeof n, ""));
    }
    return i = vn(A, s, i, m), i.elementType = n, i.type = d, i.lanes = I, i;
  }
  function Oa(n, i, s, d) {
    return n = vn(7, n, d, i), n.lanes = s, n;
  }
  function ll(n, i, s, d) {
    return n = vn(22, n, d, i), n.elementType = le, n.lanes = s, n.stateNode = { isHidden: !1 }, n;
  }
  function Ku(n, i, s) {
    return n = vn(6, n, null, i), n.lanes = s, n;
  }
  function Xu(n, i, s) {
    return i = vn(4, n.children !== null ? n.children : [], n.key, i), i.lanes = s, i.stateNode = { containerInfo: n.containerInfo, pendingChildren: null, implementation: n.implementation }, i;
  }
  function IT(n, i, s, d, m) {
    this.tag = i, this.containerInfo = n, this.finishedWork = this.pingCache = this.current = this.pendingChildren = null, this.timeoutHandle = -1, this.callbackNode = this.pendingContext = this.context = null, this.callbackPriority = 0, this.eventTimes = qo(0), this.expirationTimes = qo(-1), this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0, this.entanglements = qo(0), this.identifierPrefix = d, this.onRecoverableError = m, this.mutableSourceEagerHydrationData = null;
  }
  function Qu(n, i, s, d, m, I, A, b, F) {
    return n = new IT(n, i, s, b, F), i === 1 ? (i = 1, I === !0 && (i |= 8)) : i = 0, I = vn(3, null, null, i), n.current = I, I.stateNode = n, I.memoizedState = { element: d, isDehydrated: s, cache: null, transitions: null, pendingSuspenseBoundaries: null }, fu(I), n;
  }
  function vT(n, i, s) {
    var d = 3 < arguments.length && arguments[3] !== void 0 ? arguments[3] : null;
    return { $$typeof: P, key: d == null ? null : "" + d, children: n, containerInfo: i, implementation: s };
  }
  function z_(n) {
    if (!n) return Bi;
    n = n._reactInternals;
    e: {
      if (mn(n) !== n || n.tag !== 1) throw Error(t(170));
      var i = n;
      do {
        switch (i.tag) {
          case 3:
            i = i.stateNode.context;
            break e;
          case 1:
            if (qr(i.type)) {
              i = i.stateNode.__reactInternalMemoizedMergedChildContext;
              break e;
            }
        }
        i = i.return;
      } while (i !== null);
      throw Error(t(171));
    }
    if (n.tag === 1) {
      var s = n.type;
      if (qr(s)) return Im(n, s, i);
    }
    return i;
  }
  function q_(n, i, s, d, m, I, A, b, F) {
    return n = Qu(s, d, !0, n, m, I, A, b, F), n.context = z_(null), s = n.current, d = Gr(), m = Wi(s), I = vi(d, m), I.callback = i != null ? i : null, Zi(s, I, m), n.current.lanes = m, da(n, m, d), Kr(n, d), n;
  }
  function cl(n, i, s, d) {
    var m = i.current, I = Gr(), A = Wi(m);
    return s = z_(s), i.context === null ? i.context = s : i.pendingContext = s, i = vi(I, A), i.payload = { element: n }, d = d === void 0 ? null : d, d !== null && (i.callback = d), n = Zi(m, i, A), n !== null && (xn(n, m, A, I), U2(n, m, A)), A;
  }
  function ul(n) {
    if (n = n.current, !n.child) return null;
    switch (n.child.tag) {
      case 5:
        return n.child.stateNode;
      default:
        return n.child.stateNode;
    }
  }
  function W_(n, i) {
    if (n = n.memoizedState, n !== null && n.dehydrated !== null) {
      var s = n.retryLane;
      n.retryLane = s !== 0 && s < i ? s : i;
    }
  }
  function Ju(n, i) {
    W_(n, i), (n = n.alternate) && W_(n, i);
  }
  function gT() {
    return null;
  }
  var Y_ = typeof reportError == "function" ? reportError : function(n) {
    console.error(n);
  };
  function e0(n) {
    this._internalRoot = n;
  }
  fl.prototype.render = e0.prototype.render = function(n) {
    var i = this._internalRoot;
    if (i === null) throw Error(t(409));
    cl(n, i, null, null);
  }, fl.prototype.unmount = e0.prototype.unmount = function() {
    var n = this._internalRoot;
    if (n !== null) {
      this._internalRoot = null;
      var i = n.containerInfo;
      Ra(function() {
        cl(null, n, null, null);
      }), i[_i] = null;
    }
  };
  function fl(n) {
    this._internalRoot = n;
  }
  fl.prototype.unstable_scheduleHydration = function(n) {
    if (n) {
      var i = h2();
      n = { blockedOn: null, target: n, priority: i };
      for (var s = 0; s < ri.length && i !== 0 && i < ri[s].priority; s++) ;
      ri.splice(s, 0, n), s === 0 && C2(n);
    }
  };
  function t0(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11);
  }
  function dl(n) {
    return !(!n || n.nodeType !== 1 && n.nodeType !== 9 && n.nodeType !== 11 && (n.nodeType !== 8 || n.nodeValue !== " react-mount-point-unstable "));
  }
  function K_() {
  }
  function DT(n, i, s, d, m) {
    if (m) {
      if (typeof d == "function") {
        var I = d;
        d = function() {
          var te = ul(A);
          I.call(te);
        };
      }
      var A = q_(i, d, n, 0, null, !1, !1, "", K_);
      return n._reactRootContainer = A, n[_i] = A.current, ss(n.nodeType === 8 ? n.parentNode : n), Ra(), A;
    }
    for (; m = n.lastChild; ) n.removeChild(m);
    if (typeof d == "function") {
      var b = d;
      d = function() {
        var te = ul(F);
        b.call(te);
      };
    }
    var F = Qu(n, 0, !1, null, null, !1, !1, "", K_);
    return n._reactRootContainer = F, n[_i] = F.current, ss(n.nodeType === 8 ? n.parentNode : n), Ra(function() {
      cl(i, F, s, d);
    }), F;
  }
  function pl(n, i, s, d, m) {
    var I = s._reactRootContainer;
    if (I) {
      var A = I;
      if (typeof m == "function") {
        var b = m;
        m = function() {
          var F = ul(A);
          b.call(F);
        };
      }
      cl(i, A, n, m);
    } else A = DT(s, i, n, m, d);
    return ul(A);
  }
  d2 = function(n) {
    switch (n.tag) {
      case 3:
        var i = n.stateNode;
        if (i.current.memoizedState.isDehydrated) {
          var s = fa(i.pendingLanes);
          s !== 0 && (Wo(i, s | 1), Kr(i, lt()), (Dt & 6) === 0 && (vo = lt() + 500, $i()));
        }
        break;
      case 13:
        Ra(function() {
          var d = Ii(n, 1);
          if (d !== null) {
            var m = Gr();
            xn(d, n, 1, m);
          }
        }), Ju(n, 1);
    }
  }, Yo = function(n) {
    if (n.tag === 13) {
      var i = Ii(n, 134217728);
      if (i !== null) {
        var s = Gr();
        xn(i, n, 134217728, s);
      }
      Ju(n, 134217728);
    }
  }, p2 = function(n) {
    if (n.tag === 13) {
      var i = Wi(n), s = Ii(n, i);
      if (s !== null) {
        var d = Gr();
        xn(s, n, i, d);
      }
      Ju(n, i);
    }
  }, h2 = function() {
    return yt;
  }, m2 = function(n, i) {
    var s = yt;
    try {
      return yt = n, i();
    } finally {
      yt = s;
    }
  }, ye = function(n, i, s) {
    switch (i) {
      case "input":
        if (dt(n, s), i = s.name, s.type === "radio" && i != null) {
          for (s = n; s.parentNode; ) s = s.parentNode;
          for (s = s.querySelectorAll("input[name=" + JSON.stringify("" + i) + '][type="radio"]'), i = 0; i < s.length; i++) {
            var d = s[i];
            if (d !== n && d.form === n.form) {
              var m = L2(d);
              if (!m) throw Error(t(90));
              Ye(d), dt(d, m);
            }
          }
        }
        break;
      case "textarea":
        Lt(n, s);
        break;
      case "select":
        i = s.value, i != null && de(n, !!s.multiple, i, !1);
    }
  }, wt = zu, Qt = Ra;
  var RT = { usingClientEntryPoint: !1, Events: [us, so, L2, At, Nt, zu] }, Rs = { findFiberByHostInstance: _a, bundleType: 0, version: "18.3.1", rendererPackageName: "react-dom" }, AT = { bundleType: Rs.bundleType, version: Rs.version, rendererPackageName: Rs.rendererPackageName, rendererConfig: Rs.rendererConfig, overrideHookState: null, overrideHookStateDeletePath: null, overrideHookStateRenamePath: null, overrideProps: null, overridePropsDeletePath: null, overridePropsRenamePath: null, setErrorHandler: null, setSuspenseHandler: null, scheduleUpdate: null, currentDispatcherRef: T.ReactCurrentDispatcher, findHostInstanceByFiber: function(n) {
    return n = ne(n), n === null ? null : n.stateNode;
  }, findFiberByHostInstance: Rs.findFiberByHostInstance || gT, findHostInstancesForRefresh: null, scheduleRefresh: null, scheduleRoot: null, setRefreshHandler: null, getCurrentFiber: null, reconcilerVersion: "18.3.1-next-f1338f8080-20240426" };
  if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ != "undefined") {
    var hl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hl.isDisabled && hl.supportsFiber) try {
      mi = hl.inject(AT), Br = hl;
    } catch (n) {
    }
  }
  return Xr.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = RT, Xr.createPortal = function(n, i) {
    var s = 2 < arguments.length && arguments[2] !== void 0 ? arguments[2] : null;
    if (!t0(i)) throw Error(t(200));
    return vT(n, i, null, s);
  }, Xr.createRoot = function(n, i) {
    if (!t0(n)) throw Error(t(299));
    var s = !1, d = "", m = Y_;
    return i != null && (i.unstable_strictMode === !0 && (s = !0), i.identifierPrefix !== void 0 && (d = i.identifierPrefix), i.onRecoverableError !== void 0 && (m = i.onRecoverableError)), i = Qu(n, 1, !1, null, null, s, !1, d, m), n[_i] = i.current, ss(n.nodeType === 8 ? n.parentNode : n), new e0(i);
  }, Xr.findDOMNode = function(n) {
    if (n == null) return null;
    if (n.nodeType === 1) return n;
    var i = n._reactInternals;
    if (i === void 0)
      throw typeof n.render == "function" ? Error(t(188)) : (n = Object.keys(n).join(","), Error(t(268, n)));
    return n = ne(i), n = n === null ? null : n.stateNode, n;
  }, Xr.flushSync = function(n) {
    return Ra(n);
  }, Xr.hydrate = function(n, i, s) {
    if (!dl(i)) throw Error(t(200));
    return pl(null, n, i, !0, s);
  }, Xr.hydrateRoot = function(n, i, s) {
    if (!t0(n)) throw Error(t(405));
    var d = s != null && s.hydratedSources || null, m = !1, I = "", A = Y_;
    if (s != null && (s.unstable_strictMode === !0 && (m = !0), s.identifierPrefix !== void 0 && (I = s.identifierPrefix), s.onRecoverableError !== void 0 && (A = s.onRecoverableError)), i = q_(i, null, n, 1, s != null ? s : null, m, !1, I, A), n[_i] = i.current, ss(n), d) for (n = 0; n < d.length; n++) s = d[n], m = s._getVersion, m = m(s._source), i.mutableSourceEagerHydrationData == null ? i.mutableSourceEagerHydrationData = [s, m] : i.mutableSourceEagerHydrationData.push(
      s,
      m
    );
    return new fl(i);
  }, Xr.render = function(n, i, s) {
    if (!dl(i)) throw Error(t(200));
    return pl(null, n, i, !1, s);
  }, Xr.unmountComponentAtNode = function(n) {
    if (!dl(n)) throw Error(t(40));
    return n._reactRootContainer ? (Ra(function() {
      pl(null, null, n, !1, function() {
        n._reactRootContainer = null, n[_i] = null;
      });
    }), !0) : !1;
  }, Xr.unstable_batchedUpdates = zu, Xr.unstable_renderSubtreeIntoContainer = function(n, i, s, d) {
    if (!dl(s)) throw Error(t(200));
    if (n == null || n._reactInternals === void 0) throw Error(t(38));
    return pl(n, i, s, !1, d);
  }, Xr.version = "18.3.1-next-f1338f8080-20240426", Xr;
}
var a6;
function a8() {
  if (a6) return X3.exports;
  a6 = 1;
  function e() {
    if (!(typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ == "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE != "function"))
      try {
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(e);
      } catch (r) {
        console.error(r);
      }
  }
  return e(), X3.exports = u9(), X3.exports;
}
var o6;
function f9() {
  if (o6) return ml;
  o6 = 1;
  var e = a8();
  return ml.createRoot = e.createRoot, ml.hydrateRoot = e.hydrateRoot, ml;
}
var o8 = f9(), s6 = {}, e1, l6;
function nh() {
  return l6 || (l6 = 1, e1 = typeof ArrayBuffer != "undefined" && typeof DataView != "undefined"), e1;
}
var t1, c6;
function Pi() {
  if (c6) return t1;
  c6 = 1;
  var e = Jg(), r = Wn();
  return t1 = function(t, a, o) {
    return o.get && e(o.get, a, { getter: !0 }), o.set && e(o.set, a, { setter: !0 }), r.f(t, a, o);
  }, t1;
}
var r1, u6;
function ih() {
  if (u6) return r1;
  u6 = 1;
  var e = pi();
  return r1 = function(r, t, a) {
    for (var o in t) e(r, o, t[o], a);
    return r;
  }, r1;
}
var n1, f6;
function Xs() {
  if (f6) return n1;
  f6 = 1;
  var e = xa(), r = TypeError;
  return n1 = function(t, a) {
    if (e(a, t)) return t;
    throw new r("Incorrect invocation");
  }, n1;
}
var i1, d6;
function ah() {
  if (d6) return i1;
  d6 = 1;
  var e = fi(), r = xo(), t = RangeError;
  return i1 = function(a) {
    if (a === void 0) return 0;
    var o = e(a), l = r(o);
    if (o !== l) throw new t("Wrong length or index");
    return l;
  }, i1;
}
var a1, p6;
function d9() {
  return p6 || (p6 = 1, a1 = Math.sign || function(r) {
    var t = +r;
    return t === 0 || t !== t ? t : t < 0 ? -1 : 1;
  }), a1;
}
var o1, h6;
function p9() {
  if (h6) return o1;
  h6 = 1;
  var e = 2220446049250313e-31, r = 1 / e;
  return o1 = function(t) {
    return t + r - r;
  }, o1;
}
var s1, m6;
function h9() {
  if (m6) return s1;
  m6 = 1;
  var e = d9(), r = p9(), t = Math.abs, a = 2220446049250313e-31;
  return s1 = function(o, l, c, f) {
    var p = +o, u = t(p), h = e(p);
    if (u < f) return h * r(u / f / l) * f * l;
    var C = (1 + l / a) * u, E = C - (C - u);
    return E > c || E !== E ? h * (1 / 0) : h * E;
  }, s1;
}
var l1, _6;
function m9() {
  if (_6) return l1;
  _6 = 1;
  var e = h9(), r = 11920928955078125e-23, t = 34028234663852886e22, a = 11754943508222875e-54;
  return l1 = Math.fround || function(l) {
    return e(l, r, t, a);
  }, l1;
}
var c1, E6;
function _9() {
  if (E6) return c1;
  E6 = 1;
  var e = Array, r = Math.abs, t = Math.pow, a = Math.floor, o = Math.log, l = Math.LN2, c = function(p, u, h) {
    var C = e(h), E = h * 8 - u - 1, _ = (1 << E) - 1, S = _ >> 1, v = u === 23 ? t(2, -24) - t(2, -77) : 0, g = p < 0 || p === 0 && 1 / p < 0 ? 1 : 0, O = 0, R, D, T;
    for (p = r(p), p !== p || p === 1 / 0 ? (D = p !== p ? 1 : 0, R = _) : (R = a(o(p) / l), T = t(2, -R), p * T < 1 && (R--, T *= 2), R + S >= 1 ? p += v / T : p += v * t(2, 1 - S), p * T >= 2 && (R++, T /= 2), R + S >= _ ? (D = 0, R = _) : R + S >= 1 ? (D = (p * T - 1) * t(2, u), R += S) : (D = p * t(2, S - 1) * t(2, u), R = 0)); u >= 8; )
      C[O++] = D & 255, D /= 256, u -= 8;
    for (R = R << u | D, E += u; E > 0; )
      C[O++] = R & 255, R /= 256, E -= 8;
    return C[O - 1] |= g * 128, C;
  }, f = function(p, u) {
    var h = p.length, C = h * 8 - u - 1, E = (1 << C) - 1, _ = E >> 1, S = C - 7, v = h - 1, g = p[v--], O = g & 127, R;
    for (g >>= 7; S > 0; )
      O = O * 256 + p[v--], S -= 8;
    for (R = O & (1 << -S) - 1, O >>= -S, S += u; S > 0; )
      R = R * 256 + p[v--], S -= 8;
    if (O === 0)
      O = 1 - _;
    else {
      if (O === E)
        return R ? NaN : g ? -1 / 0 : 1 / 0;
      R += t(2, u), O -= _;
    }
    return (g ? -1 : 1) * R * t(2, O - u);
  };
  return c1 = {
    pack: c,
    unpack: f
  }, c1;
}
var u1, C6;
function s8() {
  if (C6) return u1;
  C6 = 1;
  var e = On(), r = tc(), t = tn();
  return u1 = function(o) {
    for (var l = e(this), c = t(l), f = arguments.length, p = r(f > 1 ? arguments[1] : void 0, c), u = f > 2 ? arguments[2] : void 0, h = u === void 0 ? c : r(u, c); h > p; ) l[p++] = o;
    return l;
  }, u1;
}
var f1, S6;
function oh() {
  if (S6) return f1;
  S6 = 1;
  var e = It(), r = vt(), t = jt(), a = nh(), o = rc(), l = yn(), c = Pi(), f = ih(), p = gt(), u = Xs(), h = fi(), C = xo(), E = ah(), _ = m9(), S = _9(), v = Ys(), g = Bo(), O = s8(), R = oc(), D = th(), T = Jp(), L = Uo(), P = di(), M = o.PROPER, k = o.CONFIGURABLE, H = "ArrayBuffer", w = "DataView", $ = "prototype", B = "Wrong length", Y = "Wrong index", j = P.getterFor(H), ie = P.getterFor(w), se = P.set, le = e[H], U = le, X = U && U[$], K = e[w], y = K && K[$], G = Object.prototype, ce = e.Array, ue = e.RangeError, ee = r(O), ge = r([].reverse), Oe = S.pack, Se = S.unpack, Ne = function(de) {
    return [de & 255];
  }, Le = function(de) {
    return [de & 255, de >> 8 & 255];
  }, ct = function(de) {
    return [de & 255, de >> 8 & 255, de >> 16 & 255, de >> 24 & 255];
  }, Ye = function(de) {
    return de[3] << 24 | de[2] << 16 | de[1] << 8 | de[0];
  }, nt = function(de) {
    return Oe(_(de), 23, 4);
  }, Ke = function(de) {
    return Oe(de, 52, 8);
  }, ot = function(de, Te, Ue) {
    c(de[$], Te, {
      configurable: !0,
      get: function() {
        return Ue(this)[Te];
      }
    });
  }, St = function(de, Te, Ue, Lt) {
    var Et = ie(de), Re = E(Ue), ke = !!Lt;
    if (Re + Te > Et.byteLength) throw new ue(Y);
    var $e = Et.bytes, rt = Re + Et.byteOffset, ht = R($e, rt, rt + Te);
    return ke ? ht : ge(ht);
  }, dt = function(de, Te, Ue, Lt, Et, Re) {
    var ke = ie(de), $e = E(Ue), rt = Lt(+Et), ht = !!Re;
    if ($e + Te > ke.byteLength) throw new ue(Y);
    for (var Ot = ke.bytes, Xe = $e + ke.byteOffset, De = 0; De < Te; De++) Ot[Xe + De] = rt[ht ? De : Te - De - 1];
  };
  if (!a)
    U = function(Te) {
      u(this, X);
      var Ue = E(Te);
      se(this, {
        type: H,
        bytes: ee(ce(Ue), 0),
        byteLength: Ue
      }), t || (this.byteLength = Ue, this.detached = !1);
    }, X = U[$], K = function(Te, Ue, Lt) {
      u(this, y), u(Te, X);
      var Et = j(Te), Re = Et.byteLength, ke = h(Ue);
      if (ke < 0 || ke > Re) throw new ue("Wrong offset");
      if (Lt = Lt === void 0 ? Re - ke : C(Lt), ke + Lt > Re) throw new ue(B);
      se(this, {
        type: w,
        buffer: Te,
        byteLength: Lt,
        byteOffset: ke,
        bytes: Et.bytes
      }), t || (this.buffer = Te, this.byteLength = Lt, this.byteOffset = ke);
    }, y = K[$], t && (ot(U, "byteLength", j), ot(K, "buffer", ie), ot(K, "byteLength", ie), ot(K, "byteOffset", ie)), f(y, {
      getInt8: function(Te) {
        return St(this, 1, Te)[0] << 24 >> 24;
      },
      getUint8: function(Te) {
        return St(this, 1, Te)[0];
      },
      getInt16: function(Te) {
        var Ue = St(this, 2, Te, arguments.length > 1 ? arguments[1] : !1);
        return (Ue[1] << 8 | Ue[0]) << 16 >> 16;
      },
      getUint16: function(Te) {
        var Ue = St(this, 2, Te, arguments.length > 1 ? arguments[1] : !1);
        return Ue[1] << 8 | Ue[0];
      },
      getInt32: function(Te) {
        return Ye(St(this, 4, Te, arguments.length > 1 ? arguments[1] : !1));
      },
      getUint32: function(Te) {
        return Ye(St(this, 4, Te, arguments.length > 1 ? arguments[1] : !1)) >>> 0;
      },
      getFloat32: function(Te) {
        return Se(St(this, 4, Te, arguments.length > 1 ? arguments[1] : !1), 23);
      },
      getFloat64: function(Te) {
        return Se(St(this, 8, Te, arguments.length > 1 ? arguments[1] : !1), 52);
      },
      setInt8: function(Te, Ue) {
        dt(this, 1, Te, Ne, Ue);
      },
      setUint8: function(Te, Ue) {
        dt(this, 1, Te, Ne, Ue);
      },
      setInt16: function(Te, Ue) {
        dt(this, 2, Te, Le, Ue, arguments.length > 2 ? arguments[2] : !1);
      },
      setUint16: function(Te, Ue) {
        dt(this, 2, Te, Le, Ue, arguments.length > 2 ? arguments[2] : !1);
      },
      setInt32: function(Te, Ue) {
        dt(this, 4, Te, ct, Ue, arguments.length > 2 ? arguments[2] : !1);
      },
      setUint32: function(Te, Ue) {
        dt(this, 4, Te, ct, Ue, arguments.length > 2 ? arguments[2] : !1);
      },
      setFloat32: function(Te, Ue) {
        dt(this, 4, Te, nt, Ue, arguments.length > 2 ? arguments[2] : !1);
      },
      setFloat64: function(Te, Ue) {
        dt(this, 8, Te, Ke, Ue, arguments.length > 2 ? arguments[2] : !1);
      }
    });
  else {
    var Je = M && le.name !== H;
    !p(function() {
      le(1);
    }) || !p(function() {
      new le(-1);
    }) || p(function() {
      return new le(), new le(1.5), new le(NaN), le.length !== 1 || Je && !k;
    }) ? (U = function(Te) {
      return u(this, X), D(new le(E(Te)), this, U);
    }, U[$] = X, X.constructor = U, T(U, le)) : Je && k && l(le, "name", H), g && v(y) !== G && g(y, G);
    var je = new K(new U(2)), st = r(y.setInt8);
    je.setInt8(0, 2147483648), je.setInt8(1, 2147483649), (je.getInt8(0) || !je.getInt8(1)) && f(y, {
      setInt8: function(Te, Ue) {
        st(this, Te, Ue << 24 >> 24);
      },
      setUint8: function(Te, Ue) {
        st(this, Te, Ue << 24 >> 24);
      }
    }, { unsafe: !0 });
  }
  return L(U, H), L(K, w), f1 = {
    ArrayBuffer: U,
    DataView: K
  }, f1;
}
var d1, I6;
function l8() {
  if (I6) return d1;
  I6 = 1;
  var e = oa(), r = Pi(), t = cr(), a = jt(), o = t("species");
  return d1 = function(l) {
    var c = e(l);
    a && c && !c[o] && r(c, o, {
      configurable: !0,
      get: function() {
        return this;
      }
    });
  }, d1;
}
var v6;
function E9() {
  if (v6) return s6;
  v6 = 1;
  var e = zt(), r = It(), t = oh(), a = l8(), o = "ArrayBuffer", l = t[o], c = r[o];
  return e({ global: !0, constructor: !0, forced: c !== l }, {
    ArrayBuffer: l
  }), a(o), s6;
}
E9();
var g6 = {}, p1, D6;
function sh() {
  if (D6) return p1;
  D6 = 1;
  var e = aa(), r = vt();
  return p1 = function(t) {
    if (e(t) === "Function") return r(t);
  }, p1;
}
var R6;
function C9() {
  if (R6) return g6;
  R6 = 1;
  var e = zt(), r = sh(), t = gt(), a = oh(), o = or(), l = tc(), c = xo(), f = a.ArrayBuffer, p = a.DataView, u = p.prototype, h = r(f.prototype.slice), C = r(u.getUint8), E = r(u.setUint8), _ = t(function() {
    return !new f(2).slice(1, void 0).byteLength;
  });
  return e({ target: "ArrayBuffer", proto: !0, unsafe: !0, forced: _ }, {
    slice: function(v, g) {
      if (h && g === void 0)
        return h(o(this), v);
      for (var O = o(this).byteLength, R = l(v, O), D = l(g === void 0 ? O : g, O), T = new f(c(D - R)), L = new p(this), P = new p(T), M = 0; R < D; )
        E(P, M++, C(L, R++));
      return T;
    }
  }), g6;
}
C9();
var A6 = {}, h1, T6;
function c8() {
  if (T6) return h1;
  T6 = 1;
  var e = It(), r = eh(), t = aa(), a = e.ArrayBuffer, o = e.TypeError;
  return h1 = a && r(a.prototype, "byteLength", "get") || function(l) {
    if (t(l) !== "ArrayBuffer") throw new o("ArrayBuffer expected");
    return l.byteLength;
  }, h1;
}
var m1, O6;
function u8() {
  if (O6) return m1;
  O6 = 1;
  var e = It(), r = nh(), t = c8(), a = e.DataView;
  return m1 = function(o) {
    if (!r || t(o) !== 0) return !1;
    try {
      return new a(o), !1;
    } catch (l) {
      return !0;
    }
  }, m1;
}
var y6;
function S9() {
  if (y6) return A6;
  y6 = 1;
  var e = jt(), r = Pi(), t = u8(), a = ArrayBuffer.prototype;
  return e && !("detached" in a) && r(a, "detached", {
    configurable: !0,
    get: function() {
      return t(this);
    }
  }), A6;
}
S9();
var N6 = {}, _1, L6;
function I9() {
  if (L6) return _1;
  L6 = 1;
  var e = u8(), r = TypeError;
  return _1 = function(t) {
    if (e(t)) throw new r("ArrayBuffer is detached");
    return t;
  }, _1;
}
var E1, M6;
function f8() {
  if (M6) return E1;
  M6 = 1;
  var e = It(), r = zs(), t = aa(), a = function(o) {
    return r.slice(0, o.length) === o;
  };
  return E1 = function() {
    return a("Bun/") ? "BUN" : a("Cloudflare-Workers") ? "CLOUDFLARE" : a("Deno/") ? "DENO" : a("Node.js/") ? "NODE" : e.Bun && typeof Bun.version == "string" ? "BUN" : e.Deno && typeof Deno.version == "object" ? "DENO" : t(e.process) === "process" ? "NODE" : e.window && e.document ? "BROWSER" : "REST";
  }(), E1;
}
var C1, b6;
function v9() {
  if (b6) return C1;
  b6 = 1;
  var e = f8();
  return C1 = e === "NODE", C1;
}
var S1, P6;
function g9() {
  if (P6) return S1;
  P6 = 1;
  var e = It(), r = v9();
  return S1 = function(t) {
    if (r) {
      try {
        return e.process.getBuiltinModule(t);
      } catch (a) {
      }
      try {
        return Function('return require("' + t + '")')();
      } catch (a) {
      }
    }
  }, S1;
}
var I1, w6;
function d8() {
  if (w6) return I1;
  w6 = 1;
  var e = It(), r = gt(), t = Jl(), a = f8(), o = e.structuredClone;
  return I1 = !!o && !r(function() {
    if (a === "DENO" && t > 92 || a === "NODE" && t > 94 || a === "BROWSER" && t > 97) return !1;
    var l = new ArrayBuffer(8), c = o(l, { transfer: [l] });
    return l.byteLength !== 0 || c.byteLength !== 8;
  }), I1;
}
var v1, H6;
function D9() {
  if (H6) return v1;
  H6 = 1;
  var e = It(), r = g9(), t = d8(), a = e.structuredClone, o = e.ArrayBuffer, l = e.MessageChannel, c = !1, f, p, u, h;
  if (t)
    c = function(C) {
      a(C, { transfer: [C] });
    };
  else if (o) try {
    l || (f = r("worker_threads"), f && (l = f.MessageChannel)), l && (p = new l(), u = new o(2), h = function(C) {
      p.port1.postMessage(null, [C]);
    }, u.byteLength === 2 && (h(u), u.byteLength === 0 && (c = h)));
  } catch (C) {
  }
  return v1 = c, v1;
}
var g1, V6;
function p8() {
  if (V6) return g1;
  V6 = 1;
  var e = It(), r = vt(), t = eh(), a = ah(), o = I9(), l = c8(), c = D9(), f = d8(), p = e.structuredClone, u = e.ArrayBuffer, h = e.DataView, C = Math.min, E = u.prototype, _ = h.prototype, S = r(E.slice), v = t(E, "resizable", "get"), g = t(E, "maxByteLength", "get"), O = r(_.getInt8), R = r(_.setInt8);
  return g1 = (f || c) && function(D, T, L) {
    var P = l(D), M = T === void 0 ? P : a(T), k = !v || !v(D), H;
    if (o(D), f && (D = p(D, { transfer: [D] }), P === M && (L || k)))
      return D;
    if (P >= M && (!L || k))
      H = S(D, 0, M);
    else {
      var w = L && !k && g ? { maxByteLength: g(D) } : void 0;
      H = new u(M, w);
      for (var $ = new h(D), B = new h(H), Y = C(M, P), j = 0; j < Y; j++) R(B, j, O($, j));
    }
    return f || c(D), H;
  }, g1;
}
var k6;
function R9() {
  if (k6) return N6;
  k6 = 1;
  var e = zt(), r = p8();
  return r && e({ target: "ArrayBuffer", proto: !0 }, {
    transfer: function() {
      return r(this, arguments.length ? arguments[0] : void 0, !0);
    }
  }), N6;
}
R9();
var F6 = {}, x6;
function A9() {
  if (x6) return F6;
  x6 = 1;
  var e = zt(), r = p8();
  return r && e({ target: "ArrayBuffer", proto: !0 }, {
    transferToFixedLength: function() {
      return r(this, arguments.length ? arguments[0] : void 0, !1);
    }
  }), F6;
}
A9();
var U6 = {}, _l = { exports: {} }, D1, B6;
function T9() {
  if (B6) return D1;
  B6 = 1;
  var e = cr(), r = e("iterator"), t = !1;
  try {
    var a = 0, o = {
      next: function() {
        return { done: !!a++ };
      },
      return: function() {
        t = !0;
      }
    };
    o[r] = function() {
      return this;
    }, Array.from(o, function() {
      throw 2;
    });
  } catch (l) {
  }
  return D1 = function(l, c) {
    try {
      if (!c && !t) return !1;
    } catch (u) {
      return !1;
    }
    var f = !1;
    try {
      var p = {};
      p[r] = function() {
        return {
          next: function() {
            return { done: f = !0 };
          }
        };
      }, l(p);
    } catch (u) {
    }
    return f;
  }, D1;
}
var R1, $6;
function Ln() {
  if ($6) return R1;
  $6 = 1;
  var e = nh(), r = jt(), t = It(), a = Xt(), o = Vr(), l = kr(), c = sa(), f = Fo(), p = yn(), u = pi(), h = Pi(), C = xa(), E = Ys(), _ = Bo(), S = cr(), v = zp(), g = di(), O = g.enforce, R = g.get, D = t.Int8Array, T = D && D.prototype, L = t.Uint8ClampedArray, P = L && L.prototype, M = D && E(D), k = T && E(T), H = Object.prototype, w = t.TypeError, $ = S("toStringTag"), B = v("TYPED_ARRAY_TAG"), Y = "TypedArrayConstructor", j = e && !!_ && c(t.opera) !== "Opera", ie = !1, se, le, U, X = {
    Int8Array: 1,
    Uint8Array: 1,
    Uint8ClampedArray: 1,
    Int16Array: 2,
    Uint16Array: 2,
    Int32Array: 4,
    Uint32Array: 4,
    Float32Array: 4,
    Float64Array: 8
  }, K = {
    BigInt64Array: 8,
    BigUint64Array: 8
  }, y = function(Ne) {
    if (!o(Ne)) return !1;
    var Le = c(Ne);
    return Le === "DataView" || l(X, Le) || l(K, Le);
  }, G = function(Se) {
    var Ne = E(Se);
    if (o(Ne)) {
      var Le = R(Ne);
      return Le && l(Le, Y) ? Le[Y] : G(Ne);
    }
  }, ce = function(Se) {
    if (!o(Se)) return !1;
    var Ne = c(Se);
    return l(X, Ne) || l(K, Ne);
  }, ue = function(Se) {
    if (ce(Se)) return Se;
    throw new w("Target is not a typed array");
  }, ee = function(Se) {
    if (a(Se) && (!_ || C(M, Se))) return Se;
    throw new w(f(Se) + " is not a typed array constructor");
  }, ge = function(Se, Ne, Le, ct) {
    if (r) {
      if (Le) for (var Ye in X) {
        var nt = t[Ye];
        if (nt && l(nt.prototype, Se)) try {
          delete nt.prototype[Se];
        } catch (Ke) {
          try {
            nt.prototype[Se] = Ne;
          } catch (ot) {
          }
        }
      }
      (!k[Se] || Le) && u(k, Se, Le ? Ne : j && T[Se] || Ne, ct);
    }
  }, Oe = function(Se, Ne, Le) {
    var ct, Ye;
    if (r) {
      if (_) {
        if (Le) {
          for (ct in X)
            if (Ye = t[ct], Ye && l(Ye, Se)) try {
              delete Ye[Se];
            } catch (nt) {
            }
        }
        if (!M[Se] || Le)
          try {
            return u(M, Se, Le ? Ne : j && M[Se] || Ne);
          } catch (nt) {
          }
        else return;
      }
      for (ct in X)
        Ye = t[ct], Ye && (!Ye[Se] || Le) && u(Ye, Se, Ne);
    }
  };
  for (se in X)
    le = t[se], U = le && le.prototype, U ? O(U)[Y] = le : j = !1;
  for (se in K)
    le = t[se], U = le && le.prototype, U && (O(U)[Y] = le);
  if ((!j || !a(M) || M === Function.prototype) && (M = function() {
    throw new w("Incorrect invocation");
  }, j))
    for (se in X)
      t[se] && _(t[se], M);
  if ((!j || !k || k === H) && (k = M.prototype, j))
    for (se in X)
      t[se] && _(t[se].prototype, k);
  if (j && E(P) !== k && _(P, k), r && !l(k, $)) {
    ie = !0, h(k, $, {
      configurable: !0,
      get: function() {
        return o(this) ? this[B] : void 0;
      }
    });
    for (se in X) t[se] && p(t[se], B, se);
  }
  return R1 = {
    NATIVE_ARRAY_BUFFER_VIEWS: j,
    TYPED_ARRAY_TAG: ie && B,
    aTypedArray: ue,
    aTypedArrayConstructor: ee,
    exportTypedArrayMethod: ge,
    exportTypedArrayStaticMethod: Oe,
    getTypedArrayConstructor: G,
    isView: y,
    isTypedArray: ce,
    TypedArray: M,
    TypedArrayPrototype: k
  }, R1;
}
var A1, G6;
function O9() {
  if (G6) return A1;
  G6 = 1;
  var e = It(), r = gt(), t = T9(), a = Ln().NATIVE_ARRAY_BUFFER_VIEWS, o = e.ArrayBuffer, l = e.Int8Array;
  return A1 = !a || !r(function() {
    l(1);
  }) || !r(function() {
    new l(-1);
  }) || !t(function(c) {
    new l(), new l(null), new l(1.5), new l(c);
  }, !0) || r(function() {
    return new l(new o(2), 1, void 0).length !== 1;
  }), A1;
}
var T1, Z6;
function y9() {
  if (Z6) return T1;
  Z6 = 1;
  var e = Vr(), r = Math.floor;
  return T1 = Number.isInteger || function(a) {
    return !e(a) && isFinite(a) && r(a) === a;
  }, T1;
}
var O1, j6;
function N9() {
  if (j6) return O1;
  j6 = 1;
  var e = fi(), r = RangeError;
  return O1 = function(t) {
    var a = e(t);
    if (a < 0) throw new r("The argument can't be less than 0");
    return a;
  }, O1;
}
var y1, z6;
function h8() {
  if (z6) return y1;
  z6 = 1;
  var e = N9(), r = RangeError;
  return y1 = function(t, a) {
    var o = e(t);
    if (o % a) throw new r("Wrong offset");
    return o;
  }, y1;
}
var N1, q6;
function L9() {
  if (q6) return N1;
  q6 = 1;
  var e = Math.round;
  return N1 = function(r) {
    var t = e(r);
    return t < 0 ? 0 : t > 255 ? 255 : t & 255;
  }, N1;
}
var L1, W6;
function $a() {
  if (W6) return L1;
  W6 = 1;
  var e = sh(), r = en(), t = Xl(), a = e(e.bind);
  return L1 = function(o, l) {
    return r(o), l === void 0 ? o : t ? a(o, l) : function() {
      return o.apply(l, arguments);
    };
  }, L1;
}
var M1, Y6;
function lh() {
  if (Y6) return M1;
  Y6 = 1;
  var e = vt(), r = gt(), t = Xt(), a = sa(), o = oa(), l = Qg(), c = function() {
  }, f = o("Reflect", "construct"), p = /^\s*(?:class|function)\b/, u = e(p.exec), h = !p.test(c), C = function(S) {
    if (!t(S)) return !1;
    try {
      return f(c, [], S), !0;
    } catch (v) {
      return !1;
    }
  }, E = function(S) {
    if (!t(S)) return !1;
    switch (a(S)) {
      case "AsyncFunction":
      case "GeneratorFunction":
      case "AsyncGeneratorFunction":
        return !1;
    }
    try {
      return h || !!u(p, l(S));
    } catch (v) {
      return !0;
    }
  };
  return E.sham = !0, M1 = !f || r(function() {
    var _;
    return C(C.call) || !C(Object) || !C(function() {
      _ = !0;
    }) || _;
  }) ? E : C, M1;
}
var b1, K6;
function M9() {
  if (K6) return b1;
  K6 = 1;
  var e = lh(), r = Fo(), t = TypeError;
  return b1 = function(a) {
    if (e(a)) return a;
    throw new t(r(a) + " is not a constructor");
  }, b1;
}
var P1, X6;
function Qs() {
  if (X6) return P1;
  X6 = 1;
  var e = sa(), r = qs(), t = $p(), a = Ws(), o = cr(), l = o("iterator");
  return P1 = function(c) {
    if (!t(c)) return r(c, l) || r(c, "@@iterator") || a[e(c)];
  }, P1;
}
var w1, Q6;
function sc() {
  if (Q6) return w1;
  Q6 = 1;
  var e = Mt(), r = en(), t = or(), a = Fo(), o = Qs(), l = TypeError;
  return w1 = function(c, f) {
    var p = arguments.length < 2 ? o(c) : f;
    if (r(p)) return t(e(p, c));
    throw new l(a(c) + " is not iterable");
  }, w1;
}
var H1, J6;
function ch() {
  if (J6) return H1;
  J6 = 1;
  var e = cr(), r = Ws(), t = e("iterator"), a = Array.prototype;
  return H1 = function(o) {
    return o !== void 0 && (r.Array === o || a[t] === o);
  }, H1;
}
var V1, e7;
function m8() {
  if (e7) return V1;
  e7 = 1;
  var e = sa();
  return V1 = function(r) {
    var t = e(r);
    return t === "BigInt64Array" || t === "BigUint64Array";
  }, V1;
}
var k1, t7;
function uh() {
  if (t7) return k1;
  t7 = 1;
  var e = Wg(), r = TypeError;
  return k1 = function(t) {
    var a = e(t, "number");
    if (typeof a == "number") throw new r("Can't convert number to bigint");
    return BigInt(a);
  }, k1;
}
var F1, r7;
function b9() {
  if (r7) return F1;
  r7 = 1;
  var e = $a(), r = Mt(), t = M9(), a = On(), o = tn(), l = sc(), c = Qs(), f = ch(), p = m8(), u = Ln().aTypedArrayConstructor, h = uh();
  return F1 = function(E) {
    var _ = t(this), S = a(E), v = arguments.length, g = v > 1 ? arguments[1] : void 0, O = g !== void 0, R = c(S), D, T, L, P, M, k, H, w;
    if (R && !f(R))
      for (H = l(S, R), w = H.next, S = []; !(k = r(w, H)).done; )
        S.push(k.value);
    for (O && v > 2 && (g = e(g, arguments[2])), T = o(S), L = new (u(_))(T), P = p(L), D = 0; T > D; D++)
      M = O ? g(S[D], D) : S[D], L[D] = P ? h(M) : +M;
    return L;
  }, F1;
}
var x1, n7;
function P9() {
  if (n7) return x1;
  n7 = 1;
  var e = rh(), r = lh(), t = Vr(), a = cr(), o = a("species"), l = Array;
  return x1 = function(c) {
    var f;
    return e(c) && (f = c.constructor, r(f) && (f === l || e(f.prototype)) ? f = void 0 : t(f) && (f = f[o], f === null && (f = void 0))), f === void 0 ? l : f;
  }, x1;
}
var U1, i7;
function w9() {
  if (i7) return U1;
  i7 = 1;
  var e = P9();
  return U1 = function(r, t) {
    return new (e(r))(t === 0 ? 0 : t);
  }, U1;
}
var B1, a7;
function H9() {
  if (a7) return B1;
  a7 = 1;
  var e = $a(), r = vt(), t = Ql(), a = On(), o = tn(), l = w9(), c = r([].push), f = function(p) {
    var u = p === 1, h = p === 2, C = p === 3, E = p === 4, _ = p === 6, S = p === 7, v = p === 5 || _;
    return function(g, O, R, D) {
      for (var T = a(g), L = t(T), P = o(L), M = e(O, R), k = 0, H = D || l, w = u ? H(g, P) : h || S ? H(g, 0) : void 0, $, B; P > k; k++) if ((v || k in L) && ($ = L[k], B = M($, k, T), p))
        if (u) w[k] = B;
        else if (B) switch (p) {
          case 3:
            return !0;
          // some
          case 5:
            return $;
          // find
          case 6:
            return k;
          // findIndex
          case 2:
            c(w, $);
        }
        else switch (p) {
          case 4:
            return !1;
          // every
          case 7:
            c(w, $);
        }
      return _ ? -1 : C || E ? E : w;
    };
  };
  return B1 = {
    // `Array.prototype.forEach` method
    // https://tc39.es/ecma262/#sec-array.prototype.foreach
    forEach: f(0),
    // `Array.prototype.map` method
    // https://tc39.es/ecma262/#sec-array.prototype.map
    map: f(1),
    // `Array.prototype.filter` method
    // https://tc39.es/ecma262/#sec-array.prototype.filter
    filter: f(2),
    // `Array.prototype.some` method
    // https://tc39.es/ecma262/#sec-array.prototype.some
    some: f(3),
    // `Array.prototype.every` method
    // https://tc39.es/ecma262/#sec-array.prototype.every
    every: f(4),
    // `Array.prototype.find` method
    // https://tc39.es/ecma262/#sec-array.prototype.find
    find: f(5),
    // `Array.prototype.findIndex` method
    // https://tc39.es/ecma262/#sec-array.prototype.findIndex
    findIndex: f(6),
    // `Array.prototype.filterReject` method
    // https://github.com/tc39/proposal-array-filtering
    filterReject: f(7)
  }, B1;
}
var $1, o7;
function _8() {
  if (o7) return $1;
  o7 = 1;
  var e = tn();
  return $1 = function(r, t, a) {
    for (var o = 0, l = arguments.length > 2 ? a : e(t), c = new r(l); l > o; ) c[o] = t[o++];
    return c;
  }, $1;
}
var s7;
function V9() {
  if (s7) return _l.exports;
  s7 = 1;
  var e = zt(), r = It(), t = Mt(), a = jt(), o = O9(), l = Ln(), c = oh(), f = Xs(), p = Ba(), u = yn(), h = y9(), C = xo(), E = ah(), _ = h8(), S = L9(), v = Wp(), g = kr(), O = sa(), R = Vr(), D = ec(), T = Ua(), L = xa(), P = Bo(), M = e8().f, k = b9(), H = H9().forEach, w = l8(), $ = Pi(), B = Wn(), Y = Qp(), j = _8(), ie = di(), se = th(), le = ie.get, U = ie.set, X = ie.enforce, K = B.f, y = Y.f, G = r.RangeError, ce = c.ArrayBuffer, ue = ce.prototype, ee = c.DataView, ge = l.NATIVE_ARRAY_BUFFER_VIEWS, Oe = l.TYPED_ARRAY_TAG, Se = l.TypedArray, Ne = l.TypedArrayPrototype, Le = l.isTypedArray, ct = "BYTES_PER_ELEMENT", Ye = "Wrong length", nt = function(Je, je) {
    $(Je, je, {
      configurable: !0,
      get: function() {
        return le(this)[je];
      }
    });
  }, Ke = function(Je) {
    var je;
    return L(ue, Je) || (je = O(Je)) === "ArrayBuffer" || je === "SharedArrayBuffer";
  }, ot = function(Je, je) {
    return Le(Je) && !D(je) && je in Je && h(+je) && je >= 0;
  }, St = function(je, st) {
    return st = v(st), ot(je, st) ? p(2, je[st]) : y(je, st);
  }, dt = function(je, st, de) {
    return st = v(st), ot(je, st) && R(de) && g(de, "value") && !g(de, "get") && !g(de, "set") && !de.configurable && (!g(de, "writable") || de.writable) && (!g(de, "enumerable") || de.enumerable) ? (je[st] = de.value, je) : K(je, st, de);
  };
  return a ? (ge || (Y.f = St, B.f = dt, nt(Ne, "buffer"), nt(Ne, "byteOffset"), nt(Ne, "byteLength"), nt(Ne, "length")), e({ target: "Object", stat: !0, forced: !ge }, {
    getOwnPropertyDescriptor: St,
    defineProperty: dt
  }), _l.exports = function(Je, je, st) {
    var de = Je.match(/\d+/)[0] / 8, Te = Je + (st ? "Clamped" : "") + "Array", Ue = "get" + Je, Lt = "set" + Je, Et = r[Te], Re = Et, ke = Re && Re.prototype, $e = {}, rt = function(De, et) {
      var Pt = le(De);
      return Pt.view[Ue](et * de + Pt.byteOffset, !0);
    }, ht = function(De, et, Pt) {
      var bt = le(De);
      bt.view[Lt](et * de + bt.byteOffset, st ? S(Pt) : Pt, !0);
    }, Ot = function(De, et) {
      K(De, et, {
        get: function() {
          return rt(this, et);
        },
        set: function(Pt) {
          return ht(this, et, Pt);
        },
        enumerable: !0
      });
    };
    ge ? o && (Re = je(function(De, et, Pt, bt) {
      return f(De, ke), se(function() {
        return R(et) ? Ke(et) ? bt !== void 0 ? new Et(et, _(Pt, de), bt) : Pt !== void 0 ? new Et(et, _(Pt, de)) : new Et(et) : Le(et) ? j(Re, et) : t(k, Re, et) : new Et(E(et));
      }(), De, Re);
    }), P && P(Re, Se), H(M(Et), function(De) {
      De in Re || u(Re, De, Et[De]);
    }), Re.prototype = ke) : (Re = je(function(De, et, Pt, bt) {
      f(De, ke);
      var Or = 0, Ie = 0, Pe, ye, we;
      if (!R(et))
        we = E(et), ye = we * de, Pe = new ce(ye);
      else if (Ke(et)) {
        Pe = et, Ie = _(Pt, de);
        var ze = et.byteLength;
        if (bt === void 0) {
          if (ze % de) throw new G(Ye);
          if (ye = ze - Ie, ye < 0) throw new G(Ye);
        } else if (ye = C(bt) * de, ye + Ie > ze) throw new G(Ye);
        we = ye / de;
      } else return Le(et) ? j(Re, et) : t(k, Re, et);
      for (U(De, {
        buffer: Pe,
        byteOffset: Ie,
        byteLength: ye,
        length: we,
        view: new ee(Pe)
      }); Or < we; ) Ot(De, Or++);
    }), P && P(Re, Se), ke = Re.prototype = T(Ne)), ke.constructor !== Re && u(ke, "constructor", Re), X(ke).TypedArrayConstructor = Re, Oe && u(ke, Oe, Te);
    var Xe = Re !== Et;
    $e[Te] = Re, e({ global: !0, constructor: !0, forced: Xe, sham: !ge }, $e), ct in Re || u(Re, ct, de), ct in ke || u(ke, ct, de), w(Te);
  }) : _l.exports = function() {
  }, _l.exports;
}
var l7;
function k9() {
  if (l7) return U6;
  l7 = 1;
  var e = V9();
  return e("Uint8", function(r) {
    return function(a, o, l) {
      return r(this, a, o, l);
    };
  }, !0), U6;
}
k9();
var c7 = {}, u7;
function F9() {
  if (u7) return c7;
  u7 = 1;
  var e = Ln(), r = tn(), t = fi(), a = e.aTypedArray, o = e.exportTypedArrayMethod;
  return o("at", function(c) {
    var f = a(this), p = r(f), u = t(c), h = u >= 0 ? u : p + u;
    return h < 0 || h >= p ? void 0 : f[h];
  }), c7;
}
F9();
var f7 = {}, d7;
function x9() {
  if (d7) return f7;
  d7 = 1;
  var e = Ln(), r = s8(), t = uh(), a = sa(), o = Mt(), l = vt(), c = gt(), f = e.aTypedArray, p = e.exportTypedArrayMethod, u = l("".slice), h = c(function() {
    var C = 0;
    return new Int8Array(2).fill({ valueOf: function() {
      return C++;
    } }), C !== 1;
  });
  return p("fill", function(E) {
    var _ = arguments.length;
    f(this);
    var S = u(a(this), 0, 3) === "Big" ? t(E) : +E;
    return o(r, this, S, _ > 1 ? arguments[1] : void 0, _ > 2 ? arguments[2] : void 0);
  }, h), f7;
}
x9();
var p7 = {}, G1, h7;
function E8() {
  if (h7) return G1;
  h7 = 1;
  var e = $a(), r = Ql(), t = On(), a = tn(), o = function(l) {
    var c = l === 1;
    return function(f, p, u) {
      for (var h = t(f), C = r(h), E = a(C), _ = e(p, u), S, v; E-- > 0; )
        if (S = C[E], v = _(S, E, h), v) switch (l) {
          case 0:
            return S;
          // findLast
          case 1:
            return E;
        }
      return c ? -1 : void 0;
    };
  };
  return G1 = {
    // `Array.prototype.findLast` method
    // https://github.com/tc39/proposal-array-find-from-last
    findLast: o(0),
    // `Array.prototype.findLastIndex` method
    // https://github.com/tc39/proposal-array-find-from-last
    findLastIndex: o(1)
  }, G1;
}
var m7;
function U9() {
  if (m7) return p7;
  m7 = 1;
  var e = Ln(), r = E8().findLast, t = e.aTypedArray, a = e.exportTypedArrayMethod;
  return a("findLast", function(l) {
    return r(t(this), l, arguments.length > 1 ? arguments[1] : void 0);
  }), p7;
}
U9();
var _7 = {}, E7;
function B9() {
  if (E7) return _7;
  E7 = 1;
  var e = Ln(), r = E8().findLastIndex, t = e.aTypedArray, a = e.exportTypedArrayMethod;
  return a("findLastIndex", function(l) {
    return r(t(this), l, arguments.length > 1 ? arguments[1] : void 0);
  }), _7;
}
B9();
var C7 = {}, S7;
function $9() {
  if (S7) return C7;
  S7 = 1;
  var e = It(), r = Mt(), t = Ln(), a = tn(), o = h8(), l = On(), c = gt(), f = e.RangeError, p = e.Int8Array, u = p && p.prototype, h = u && u.set, C = t.aTypedArray, E = t.exportTypedArrayMethod, _ = !c(function() {
    var v = new Uint8ClampedArray(2);
    return r(h, v, { length: 1, 0: 3 }, 1), v[1] !== 3;
  }), S = _ && t.NATIVE_ARRAY_BUFFER_VIEWS && c(function() {
    var v = new p(2);
    return v.set(1), v.set("2", 1), v[0] !== 0 || v[1] !== 2;
  });
  return E("set", function(g) {
    C(this);
    var O = o(arguments.length > 1 ? arguments[1] : void 0, 1), R = l(g);
    if (_) return r(h, this, R, O);
    var D = this.length, T = a(R), L = 0;
    if (T + O > D) throw new f("Wrong length");
    for (; L < T; ) this[O + L] = R[L++];
  }, !_ || S), C7;
}
$9();
var I7 = {}, Z1, v7;
function fh() {
  if (v7) return Z1;
  v7 = 1;
  var e = oc(), r = Math.floor, t = function(a, o) {
    var l = a.length;
    if (l < 8)
      for (var c = 1, f, p; c < l; ) {
        for (p = c, f = a[c]; p && o(a[p - 1], f) > 0; )
          a[p] = a[--p];
        p !== c++ && (a[p] = f);
      }
    else
      for (var u = r(l / 2), h = t(e(a, 0, u), o), C = t(e(a, u), o), E = h.length, _ = C.length, S = 0, v = 0; S < E || v < _; )
        a[S + v] = S < E && v < _ ? o(h[S], C[v]) <= 0 ? h[S++] : C[v++] : S < E ? h[S++] : C[v++];
    return a;
  };
  return Z1 = t, Z1;
}
var j1, g7;
function C8() {
  if (g7) return j1;
  g7 = 1;
  var e = zs(), r = e.match(/firefox\/(\d+)/i);
  return j1 = !!r && +r[1], j1;
}
var z1, D7;
function S8() {
  if (D7) return z1;
  D7 = 1;
  var e = zs();
  return z1 = /MSIE|Trident/.test(e), z1;
}
var q1, R7;
function I8() {
  if (R7) return q1;
  R7 = 1;
  var e = zs(), r = e.match(/AppleWebKit\/(\d+)\./);
  return q1 = !!r && +r[1], q1;
}
var A7;
function G9() {
  if (A7) return I7;
  A7 = 1;
  var e = It(), r = sh(), t = gt(), a = en(), o = fh(), l = Ln(), c = C8(), f = S8(), p = Jl(), u = I8(), h = l.aTypedArray, C = l.exportTypedArrayMethod, E = e.Uint16Array, _ = E && r(E.prototype.sort), S = !!_ && !(t(function() {
    _(new E(2), null);
  }) && t(function() {
    _(new E(2), {});
  })), v = !!_ && !t(function() {
    if (p) return p < 74;
    if (c) return c < 67;
    if (f) return !0;
    if (u) return u < 602;
    var O = new E(516), R = Array(516), D, T;
    for (D = 0; D < 516; D++)
      T = D % 4, O[D] = 515 - D, R[D] = D - 2 * T + 3;
    for (_(O, function(L, P) {
      return (L / 4 | 0) - (P / 4 | 0);
    }), D = 0; D < 516; D++)
      if (O[D] !== R[D]) return !0;
  }), g = function(O) {
    return function(R, D) {
      return O !== void 0 ? +O(R, D) || 0 : D !== D ? -1 : R !== R ? 1 : R === 0 && D === 0 ? 1 / R > 0 && 1 / D < 0 ? 1 : -1 : R > D;
    };
  };
  return C("sort", function(R) {
    return R !== void 0 && a(R), v ? _(this, R) : o(h(this), g(R));
  }, !v || S), I7;
}
G9();
var T7 = {}, W1, O7;
function Z9() {
  if (O7) return W1;
  O7 = 1;
  var e = tn();
  return W1 = function(r, t) {
    for (var a = e(r), o = new t(a), l = 0; l < a; l++) o[l] = r[a - l - 1];
    return o;
  }, W1;
}
var y7;
function j9() {
  if (y7) return T7;
  y7 = 1;
  var e = Z9(), r = Ln(), t = r.aTypedArray, a = r.exportTypedArrayMethod, o = r.getTypedArrayConstructor;
  return a("toReversed", function() {
    return e(t(this), o(this));
  }), T7;
}
j9();
var N7 = {}, L7;
function z9() {
  if (L7) return N7;
  L7 = 1;
  var e = Ln(), r = vt(), t = en(), a = _8(), o = e.aTypedArray, l = e.getTypedArrayConstructor, c = e.exportTypedArrayMethod, f = r(e.TypedArrayPrototype.sort);
  return c("toSorted", function(u) {
    u !== void 0 && t(u);
    var h = o(this), C = a(l(h), h);
    return f(C, u);
  }), N7;
}
z9();
var M7 = {}, Y1, b7;
function q9() {
  if (b7) return Y1;
  b7 = 1;
  var e = tn(), r = fi(), t = RangeError;
  return Y1 = function(a, o, l, c) {
    var f = e(a), p = r(l), u = p < 0 ? f + p : p;
    if (u >= f || u < 0) throw new t("Incorrect index");
    for (var h = new o(f), C = 0; C < f; C++) h[C] = C === u ? c : a[C];
    return h;
  }, Y1;
}
var P7;
function W9() {
  if (P7) return M7;
  P7 = 1;
  var e = q9(), r = Ln(), t = m8(), a = fi(), o = uh(), l = r.aTypedArray, c = r.getTypedArrayConstructor, f = r.exportTypedArrayMethod, p = function() {
    try {
      new Int8Array(1).with(2, { valueOf: function() {
        throw 8;
      } });
    } catch (h) {
      return h === 8;
    }
  }(), u = p && function() {
    try {
      new Int8Array(1).with(-0.5, 1);
    } catch (h) {
      return !0;
    }
  }();
  return f("with", function(h, C) {
    var E = l(this), _ = a(h), S = t(E) ? o(C) : +C;
    return e(E, c(E), _, S);
  }, !p || u), M7;
}
W9();
var rr = /* @__PURE__ */ ((e) => (e.WASM_ERROR = "WASM_ERROR", e.WASM_LICENSE = "WASM_LICENSE", e.FILE_SIZE = "FILE_SIZE", e.INCORRECT_FILE = "INCORRECT_FILE", e.INCORRECT_SCENARIO = "INCORRECT_SCENARIO", e.MISSING_SCENARIO = "MISSING_SCENARIO", e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.NOT_SUPPORTED = "NOT_SUPPORTED", e.CAMERA_UNKNOWN_ERROR = "CAMERA_UNKNOWN_ERROR", e.CAMERA_PERMISSION_DENIED = "CAMERA_PERMISSION_DENIED", e.NO_CAMERA = "NO_CAMERA", e.INCORRECT_CAMERA_ID = "INCORRECT_CAMERA_ID", e.CONNECTION_ERROR = "CONNECTION_ERROR", e.HTTP_NOT_SUPPORTED = "HTTP_NOT_SUPPORTED", e.INSECURE_PAGE_CONTEXT = "INSECURE_PAGE_CONTEXT", e.BAD_CONFIGURATION = "BAD_CONFIGURATION", e))(rr || {}), pt = /* @__PURE__ */ ((e) => (e.ELEMENT_VISIBLE = "ELEMENT_VISIBLE", e.PRESS_CAMERA_BUTTON = "PRESS_CAMERA_BUTTON", e.PRESS_FILE_BUTTON = "PRESS_FILE_BUTTON", e.PRESS_RETRY_BUTTON = "PRESS_RETRY_BUTTON", e.PRESS_SKIP_BUTTON = "PRESS_SKIP_BUTTON", e.PRESS_CAPTURE_BUTTON = "PRESS_CAPTURE_BUTTON", e.PRESS_CHANGE_CAMERA_BUTTON = "PRESS_CHANGE_CAMERA_BUTTON", e.PRESS_REMOTE_DEVICE_BUTTON = "PRESS_REMOTE_DEVICE_BUTTON", e.PRESS_MIRRORING_BUTTON = "PRESS_MIRRORING_BUTTON", e.NEW_PAGE_AVAILABLE = "NEW_PAGE_AVAILABLE", e.NEW_PAGE_STARTED = "NEW_PAGE_STARTED", e.CLOSE = "CLOSE", e.CAMERA_PROCESS_CLOSED = "CAMERA_PROCESS_CLOSED", e.CAMERA_PROCESS_STARTED = "CAMERA_PROCESS_STARTED", e.VIDEO_STARTED = "VIDEO_STARTED", e.VIDEO_STOPPED = "VIDEO_STOPPED", e.FILE_PROCESS_STARTED = "FILE_PROCESS_STARTED", e.PROCESS_FINISHED = "PROCESS_FINISHED", e.PROCESS_LIVENESS = "PROCESS_LIVENESS", e.SERVICE_INITIALIZED = "SERVICE_INITIALIZED", e.REMOTE_TRANSACTION_UPLOADED = "REMOTE_TRANSACTION_UPLOADED", e.REMOTE_PROCESS_FINISHED = "REMOTE_PROCESS_FINISHED", e))(pt || {}), at = /* @__PURE__ */ ((e) => (e.FINDING = "FINDING", e.PROCESSING = "PROCESSING", e.SUCCESS = "SUCCESS", e.FAILED = "FAILED", e.RESOLUTION = "RESOLUTION", e.GLARE = "GLARE", e.FOCUS = "FOCUS", e.SHAKING = "SHAKING", e.HOLD = "HOLD", e.SERVICE_PREPARING = "SERVICE_PREPARING", e.START_NEXT_PAGE = "START_NEXT_PAGE", e.LIVENESS = "LIVENESS", e.SNAPSHOT = "SNAPSHOT", e.TIMEOUT = "TIMEOUT", e))(at || {}), ia = /* @__PURE__ */ ((e) => (e.auto = "auto", e.captureVideo = "captureVideo", e.captureFrame = "captureFrame", e))(ia || {}), Me = /* @__PURE__ */ ((e) => (e.CHOOSE_INPUT_SOURCE = "CHOOSE_INPUT_SOURCE", e.CAMERA_PROCESSING = "CAMERA_PROCESSING", e.FILE_PROCESSING = "FILE_PROCESSING", e.API_PROCESSING = "API_PROCESSING", e.REMOTE_SCANNER = "REMOTE_SCANNER", e.PROCESSING = "PROCESSING", e.SUCCESS = "SUCCESS", e.DELEGATE_SUCCESS = "DELEGATE_SUCCESS", e.FAILED = "FAILED", e.FILE_SIZE_ERROR = "FILE_SIZE_ERROR", e.WASM_DEFAULT_ERROR = "WASM_DEFAULT_ERROR", e.NOT_SUPPORTED_ERROR = "NOT_SUPPORTED_ERROR", e.WASM_LICENSE_ERROR = "WASM_LICENSE_ERROR", e.INCORRECT_FILE_ERROR = "INCORRECT_FILE_ERROR", e.UNKNOWN_ERROR = "UNKNOWN_ERROR", e.TIMEOUT = "TIMEOUT", e.CAMERA_PERMISSION_DENIED_ERROR = "CAMERA_PERMISSION_DENIED_ERROR", e.HTTP_NOT_SUPPORTED_ERROR = "HTTP_NOT_SUPPORTED_ERROR", e.INSECURE_PAGE_CONTEXT_ERROR = "INSECURE_PAGE_CONTEXT_ERROR", e.NO_CAMERA_ERROR = "NO_CAMERA_ERROR", e.INCORRECT_CAMERA_ID_ERROR = "INCORRECT_CAMERA_ID_ERROR", e.CONFIGURATION_ERROR = "CONFIGURATION_ERROR", e))(Me || {}), Ni = /* @__PURE__ */ ((e) => (e.CHECKING = "CHECKING", e.AVAILABLE = "AVAILABLE", e.NOT_AVAILABLE = "NOT_AVAILABLE", e.ERROR = "ERROR", e))(Ni || {}), fn = /* @__PURE__ */ ((e) => (e.locale = "locale", e.multiple = "multiple", e.copyright = "copyright", e.startScreen = "start-screen", e.internalScenario = "internal-scenario", e.multipageProcessing = "multipage-processing", e.cameraId = "camera-id", e.changeCamera = "change-camera", e.closeButton = "close-button", e.captureButton = "capture-button", e.newLayout = "new-layout", e))(fn || {}), Ti = /* @__PURE__ */ ((e) => (e.locale = "locale", e.multiple = "multiple", e.copyright = "copyright", e.startScreen = "start-screen", e.cameraId = "camera-id", e.changeCamera = "change-camera", e.closeButton = "close-button", e))(Ti || {}), Y9 = /* @__PURE__ */ ((e) => (e.MrzAndLocate = "MrzAndLocate", e.MrzOrLocate = "MrzOrLocate", e.Mrz = "Mrz", e.Locate = "Locate", e.Barcode = "Barcode", e.MrzOrBarcode = "MrzOrBarcode", e.BarcodeAndLocate = "BarcodeAndLocate", e))(Y9 || {}), Rn = /* @__PURE__ */ ((e) => (e[e.prepare = 12e3] = "prepare", e[e.initialize = 12100] = "initialize", e[e.process = 12101] = "process", e[e.processImage = 12104] = "processImage", e[e.startNewPage = 12106] = "startNewPage", e[e.startNewDocument = 12105] = "startNewDocument", e[e.createBackendTransaction = 12125] = "createBackendTransaction", e[e.finalizePackage = 12122] = "finalizePackage", e[e.addDataToPackage = 12121] = "addDataToPackage", e))(Rn || {}), Mo = /* @__PURE__ */ ((e) => (e.line = "line", e.corners = "corners", e))(Mo || {}), v8 = /* @__PURE__ */ ((e) => (e.butt = "butt", e.round = "round", e.square = "square", e))(v8 || {}), hp = /* @__PURE__ */ ((e) => (e[e.ok = 0] = "ok", e[e.unsupportedCommand = 1] = "unsupportedCommand", e[e.badInputData = 2] = "badInputData", e[e.finished = 3] = "finished", e[e.currentlyUnavailable = 4] = "currentlyUnavailable", e[e.badLicense = 5] = "badLicense", e[e.alreadyDone = 6] = "alreadyDone", e))(hp || {}), K9 = /* @__PURE__ */ ((e) => (e.Glares = "glaresCheck", e.Focus = "focusCheck", e.Resolution = "dpiThreshold", e.Perspective = "perspectiveCheck", e.Bounds = "documentPosition", e.Portrait = "portraitCheck", e.Brightness = "brightnessCheck", e))(K9 || {}), $l = /* @__PURE__ */ ((e) => (e[e.STARTED = 0] = "STARTED", e[e.UPLOADED = 1] = "UPLOADED", e[e.PROCESSED = 2] = "PROCESSED", e))($l || {}), Ms = /* @__PURE__ */ ((e) => (e[e.Unknown = 0] = "Unknown", e[e.Horizontal = 1] = "Horizontal", e[e.Vertical = 2] = "Vertical", e[e.LeftBottomRightTop = 4] = "LeftBottomRightTop", e[e.RightBottomLeftTop = 8] = "RightBottomLeftTop", e))(Ms || {}), Ma = /* @__PURE__ */ ((e) => (e.Flip = "flip", e.Tilt = "tilt", e))(Ma || {}), Ir = /* @__PURE__ */ ((e) => (e[e.Unknown = 0] = "Unknown", e[e.PassportSinglePage = 1] = "PassportSinglePage", e[e.PassportTwoPages = 2] = "PassportTwoPages", e[e.IDFront = 3] = "IDFront", e[e.IDFrontMRZ = 4] = "IDFrontMRZ", e[e.IDBack = 5] = "IDBack", e[e.IDBackMrz = 6] = "IDBackMrz", e[e.IDBackBarcode = 7] = "IDBackBarcode", e[e.IDBackBarcodeMRZ = 8] = "IDBackBarcodeMRZ", e[e.BankCardFront = 9] = "BankCardFront", e[e.BankCardBack = 10] = "BankCardBack", e[e.DocumentFront = 11] = "DocumentFront", e[e.DocumentBack = 12] = "DocumentBack", e))(Ir || {}), wl = /* @__PURE__ */ ((e) => (e.BarcodeMRZ = "BarcodeMRZ", e.BoundsLite = "BoundsLite", e))(wl || {});
const X9 = "document-reader", Q9 = "camera-snapshot", w7 = 2.5, J9 = 1, g8 = 25e6, eO = 536870912, tO = 5, rO = 2, dh = 15, nO = 5, iO = "rgba(255, 255, 255, 0.9)", aO = "#A5A5A5", oO = "rgba(30, 130, 76, 0.9)", sO = "#6CE165", H7 = 2, lO = "Capture", D8 = 1500, R8 = 1500, cO = 1500, uO = "ProcMgr.worker.js", fO = 67108870, A8 = {
  FILE_SIZE: "FILE_SIZE_ERROR",
  WASM_ERROR: "WASM_DEFAULT_ERROR",
  NOT_SUPPORTED: "NOT_SUPPORTED_ERROR",
  WASM_LICENSE: "WASM_LICENSE_ERROR",
  INCORRECT_FILE: "INCORRECT_FILE_ERROR",
  CAMERA_PERMISSION_DENIED: "CAMERA_PERMISSION_DENIED_ERROR",
  HTTP_NOT_SUPPORTED: "HTTP_NOT_SUPPORTED_ERROR",
  INSECURE_PAGE_CONTEXT: "INSECURE_PAGE_CONTEXT_ERROR",
  NO_CAMERA: "NO_CAMERA_ERROR",
  INCORRECT_CAMERA_ID: "INCORRECT_CAMERA_ID_ERROR"
  /* INCORRECT_CAMERA_ID_ERROR */
}, ph = {
  SUCCESS: "SUCCESS",
  TIMEOUT: "TIMEOUT",
  FAILED: "FAILED"
  /* FAILED */
}, dO = {
  1: "Command not supported.",
  2: "Bad input data.",
  3: "Command already done.",
  4: "Command can not be processed at this moment, bad initial state.",
  5: "Bad license.",
  6: "The command has already been executed."
}, T8 = {
  iOS: {
    Chrome: 99,
    Firefox: 99,
    Opera: 44,
    Safari: 11,
    Edge: 16,
    Chromium: 57,
    IE: 16,
    "Internet Explorer": 16,
    "Mobile Safari": 11,
    "Samsung Browser": 7
  },
  Android: {
    Chrome: 66,
    Firefox: 61,
    Opera: 44,
    Safari: 11,
    Edge: 16,
    Chromium: 57,
    IE: 16,
    "Internet Explorer": 16,
    "Mobile Safari": 11,
    "Samsung Browser": 7
  },
  desktop: {
    Chrome: 61,
    Firefox: 60,
    Opera: 44,
    Safari: 11,
    Edge: 16,
    Chromium: 57,
    IE: 16,
    "Internet Explorer": 16,
    "Mobile Safari": 11,
    "Samsung Browser": 7
  }
}, pO = {
  processParam: {
    returnUncroppedImage: !0,
    multipageProcessing: !1,
    timeoutFromFirstDetect: 0,
    timeoutFromFirstDocType: 0,
    imageQa: {
      expectedPass: [
        "dpiThreshold",
        "glaresCheck",
        "focusCheck"
        /* Focus */
      ],
      dpiThreshold: 130,
      glaresCheck: !0,
      glaresCheckParams: {
        imgMarginPart: 0.05,
        maxGlaringPart: 0.01
      }
    }
  }
}, hO = {
  processParam: {
    returnUncroppedImage: !0
  }
}, mO = {
  processParam: {
    returnUncroppedImage: !0,
    timeoutFromFirstDetect: 0,
    timeoutFromFirstDocType: 0
  }
}, _O = {
  processParam: {
    returnUncroppedImage: !0
  }
}, EO = ["image/jpeg", "image/jpg", "image/png", "image/gif", "image/bmp"];
var Ha = /* @__PURE__ */ ((e) => (e.UINT = "UINT", e.BASE64 = "BASE64", e.UINT_AND_BASE64 = "UINT_AND_BASE64", e))(Ha || {}), Li = /* @__PURE__ */ ((e) => (e[e.EMPTY = -1] = "EMPTY", e[e.ERROR = 0] = "ERROR", e[e.OK = 1] = "OK", e[e.TIMEOUT = 2] = "TIMEOUT", e))(Li || {}), Ft = /* @__PURE__ */ ((e) => (e.PREPARING = "StreamStatus.PREPARING", e.REQUESTING = "StreamStatus.REQUESTING", e.READY = "StreamStatus.READY", e.PLAY = "StreamStatus.PLAY", e.UNKNOWN_ERROR = "StreamStatus.UNKNOWN_ERROR", e.NOT_SUPPORTED = "StreamStatus.NOT_SUPPORTED", e.HTTP_NOT_SUPPORTED = "StreamStatus.HTTP_NOT_SUPPORTED", e.INSECURE_PAGE_CONTEXT = "StreamStatus.INSECURE_PAGE_CONTEXT", e.PERMISSION_DENIED = "StreamStatus.PERMISSION_DENIED", e.NO_CAMERA = "StreamStatus.NO_CAMERA", e.INCORRECT_CAMERA_ID = "StreamStatus.INCORRECT_CAMERA_ID", e))(Ft || {}), hn = /* @__PURE__ */ ((e) => (e.user = "user", e.environment = "environment", e))(hn || {}), Gl = /* @__PURE__ */ ((e) => (e.contain = "contain", e.cover = "cover", e))(Gl || {}), O8 = /* @__PURE__ */ ((e) => (e[e.HAVE_NOTHING = 0] = "HAVE_NOTHING", e[e.HAVE_METADATA = 1] = "HAVE_METADATA", e[e.HAVE_CURRENT_DATA = 2] = "HAVE_CURRENT_DATA", e[e.HAVE_FUTURE_DATA = 3] = "HAVE_FUTURE_DATA", e[e.HAVE_ENOUGH_DATA = 4] = "HAVE_ENOUGH_DATA", e))(O8 || {}), dn = /* @__PURE__ */ ((e) => (e.stdout = "stdout", e.stderr = "stderr", e.custom = "custom", e.gl = "gl", e.init = "worker-init", e))(dn || {}), Zl = /* @__PURE__ */ ((e) => (e.Rtl = "rtl", e.Ltr = "ltr", e))(Zl || {}), mp = /* @__PURE__ */ ((e) => (e.mirror = "mirror", e.noMirror = "noMirror", e))(mp || {});
const y8 = "NotAllowedError", CO = "en", SO = ["ar", "he"], IO = 1, N8 = 500, vO = 1500, V7 = 1e4, ui = {
  VGA: {
    width: 640,
    height: 480
  },
  HD: {
    width: 1280,
    height: 720
  },
  FULL_HD: {
    width: 1920,
    height: 1080
  },
  SQUARE: {
    width: 720,
    height: 720
  }
}, gO = ["rear", "back", "rück", "arrière", "trasera", "trás", "traseira", "posteriore", "posterior", "后面", "後面", "背面", "后置", "後置", "背置", "задней", "الخلفية", "خلفية", "후", "arka", "achterzijde", "หลัง", "baksidan", "bagside", "sau", "bak", "tylny", "takakamera", "belakang", "אחורית", "πίσω", "spate", "hátsó", "zadní", "darrere", "zadná", "задня", "задна", "birou", "артқы", "stražnja", "belakang", "बैक"], L8 = {
  "StreamStatus.UNKNOWN_ERROR": "CAMERA_UNKNOWN_ERROR",
  "StreamStatus.PERMISSION_DENIED": "CAMERA_PERMISSION_DENIED",
  "StreamStatus.NO_CAMERA": "NO_CAMERA",
  "StreamStatus.INCORRECT_CAMERA_ID": "INCORRECT_CAMERA_ID",
  "StreamStatus.NOT_SUPPORTED": "NOT_SUPPORTED",
  "StreamStatus.HTTP_NOT_SUPPORTED": "HTTP_NOT_SUPPORTED",
  "StreamStatus.INSECURE_PAGE_CONTEXT": "INSECURE_PAGE_CONTEXT"
  /* INSECURE_PAGE_CONTEXT */
}, M8 = "rgl-uid";
var k7 = {}, K1, F7;
function DO() {
  if (F7) return K1;
  F7 = 1;
  var e = jt(), r = rh(), t = TypeError, a = Object.getOwnPropertyDescriptor, o = e && !function() {
    if (this !== void 0) return !0;
    try {
      Object.defineProperty([], "length", { writable: !1 }).length = 1;
    } catch (l) {
      return l instanceof TypeError;
    }
  }();
  return K1 = o ? function(l, c) {
    if (r(l) && !a(l, "length").writable)
      throw new t("Cannot set read only .length");
    return l.length = c;
  } : function(l, c) {
    return l.length = c;
  }, K1;
}
var X1, x7;
function RO() {
  if (x7) return X1;
  x7 = 1;
  var e = TypeError, r = 9007199254740991;
  return X1 = function(t) {
    if (t > r) throw e("Maximum allowed index exceeded");
    return t;
  }, X1;
}
var U7;
function AO() {
  if (U7) return k7;
  U7 = 1;
  var e = zt(), r = On(), t = tn(), a = DO(), o = RO(), l = gt(), c = l(function() {
    return [].push.call({ length: 4294967296 }, 1) !== 4294967297;
  }), f = function() {
    try {
      Object.defineProperty([], "length", { writable: !1 }).push();
    } catch (u) {
      return u instanceof TypeError;
    }
  }, p = c || !f();
  return e({ target: "Array", proto: !0, arity: 1, forced: p }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    push: function(h) {
      var C = r(this), E = t(C), _ = arguments.length;
      o(E + _);
      for (var S = 0; S < _; S++)
        C[E] = arguments[S], E++;
      return a(C, E), E;
    }
  }), k7;
}
AO();
var B7 = {}, Q1, $7;
function b8() {
  if ($7) return Q1;
  $7 = 1;
  var e = jt(), r = Wn(), t = Ba();
  return Q1 = function(a, o, l) {
    e ? r.f(a, o, t(0, l)) : a[o] = l;
  }, Q1;
}
var G7;
function TO() {
  if (G7) return B7;
  G7 = 1;
  var e = zt(), r = It(), t = Xs(), a = or(), o = Xt(), l = Ys(), c = Pi(), f = b8(), p = gt(), u = kr(), h = cr(), C = nc().IteratorPrototype, E = jt(), _ = bi(), S = "constructor", v = "Iterator", g = h("toStringTag"), O = TypeError, R = r[v], D = _ || !o(R) || R.prototype !== C || !p(function() {
    R({});
  }), T = function() {
    if (t(this, C), l(this) === C) throw new O("Abstract class Iterator not directly constructable");
  }, L = function(P, M) {
    E ? c(C, P, {
      configurable: !0,
      get: function() {
        return M;
      },
      set: function(k) {
        if (a(this), this === C) throw new O("You can't redefine this property");
        u(this, P) ? this[P] = k : f(this, P, k);
      }
    }) : C[P] = M;
  };
  return u(C, g) || L(g, v), (D || !u(C, S) || C[S] === Object) && L(S, T), T.prototype = C, e({ global: !0, constructor: !0, forced: D }, {
    Iterator: T
  }), B7;
}
TO();
var Z7 = {}, J1, j7;
function Ga() {
  return j7 || (j7 = 1, J1 = function(e) {
    return {
      iterator: e,
      next: e.next,
      done: !1
    };
  }), J1;
}
var ef, z7;
function Yn() {
  if (z7) return ef;
  z7 = 1;
  var e = Mt(), r = or(), t = qs();
  return ef = function(a, o, l) {
    var c, f;
    r(a);
    try {
      if (c = t(a, "return"), !c) {
        if (o === "throw") throw l;
        return l;
      }
      c = e(c, a);
    } catch (p) {
      f = !0, c = p;
    }
    if (o === "throw") throw l;
    if (f) throw c;
    return r(c), l;
  }, ef;
}
var tf, q7;
function OO() {
  if (q7) return tf;
  q7 = 1;
  var e = Yn();
  return tf = function(r, t, a) {
    for (var o = r.length - 1; o >= 0; o--)
      if (r[o] !== void 0)
        try {
          a = e(r[o].iterator, t, a);
        } catch (l) {
          t = "throw", a = l;
        }
    if (t === "throw") throw a;
    return a;
  }, tf;
}
var rf, W7;
function P8() {
  if (W7) return rf;
  W7 = 1;
  var e = Mt(), r = Ua(), t = yn(), a = ih(), o = cr(), l = di(), c = qs(), f = nc().IteratorPrototype, p = ic(), u = Yn(), h = OO(), C = o("toStringTag"), E = "IteratorHelper", _ = "WrapForValidIterator", S = "normal", v = "throw", g = l.set, O = function(T) {
    var L = l.getterFor(T ? _ : E);
    return a(r(f), {
      next: function() {
        var M = L(this);
        if (T) return M.nextHandler();
        if (M.done) return p(void 0, !0);
        try {
          var k = M.nextHandler();
          return M.returnHandlerResult ? k : p(k, M.done);
        } catch (H) {
          throw M.done = !0, H;
        }
      },
      return: function() {
        var P = L(this), M = P.iterator;
        if (P.done = !0, T) {
          var k = c(M, "return");
          return k ? e(k, M) : p(void 0, !0);
        }
        if (P.inner) try {
          u(P.inner.iterator, S);
        } catch (H) {
          return u(M, v, H);
        }
        if (P.openIters) try {
          h(P.openIters, S);
        } catch (H) {
          return u(M, v, H);
        }
        return M && u(M, S), p(void 0, !0);
      }
    });
  }, R = O(!0), D = O(!1);
  return t(D, C, "Iterator Helper"), rf = function(T, L, P) {
    var M = function(H, w) {
      w ? (w.iterator = H.iterator, w.next = H.next) : w = H, w.type = L ? _ : E, w.returnHandlerResult = !!P, w.nextHandler = T, w.counter = 0, w.done = !1, g(this, w);
    };
    return M.prototype = L ? R : D, M;
  }, rf;
}
var nf, Y7;
function hh() {
  if (Y7) return nf;
  Y7 = 1;
  var e = or(), r = Yn();
  return nf = function(t, a, o, l) {
    try {
      return l ? a(e(o)[0], o[1]) : a(o);
    } catch (c) {
      r(t, "throw", c);
    }
  }, nf;
}
var af, K7;
function w8() {
  return K7 || (K7 = 1, af = function(e, r) {
    var t = typeof Iterator == "function" && Iterator.prototype[e];
    if (t) try {
      t.call({ next: null }, r).next();
    } catch (a) {
      return !0;
    }
  }), af;
}
var of, X7;
function Za() {
  if (X7) return of;
  X7 = 1;
  var e = It();
  return of = function(r, t) {
    var a = e.Iterator, o = a && a.prototype, l = o && o[r], c = !1;
    if (l) try {
      l.call({
        next: function() {
          return { done: !0 };
        },
        return: function() {
          c = !0;
        }
      }, -1);
    } catch (f) {
      f instanceof t || (c = !1);
    }
    if (!c) return l;
  }, of;
}
var Q7;
function yO() {
  if (Q7) return Z7;
  Q7 = 1;
  var e = zt(), r = Mt(), t = en(), a = or(), o = Ga(), l = P8(), c = hh(), f = bi(), p = Yn(), u = w8(), h = Za(), C = !f && !u("filter", function() {
  }), E = !f && !C && h("filter", TypeError), _ = f || C || E, S = l(function() {
    for (var v = this.iterator, g = this.predicate, O = this.next, R, D, T; ; ) {
      if (R = a(r(O, v)), D = this.done = !!R.done, D) return;
      if (T = R.value, c(v, g, [T, this.counter++], !0)) return T;
    }
  });
  return e({ target: "Iterator", proto: !0, real: !0, forced: _ }, {
    filter: function(g) {
      a(this);
      try {
        t(g);
      } catch (O) {
        p(this, "throw", O);
      }
      return E ? r(E, this, g) : new S(o(this), {
        predicate: g
      });
    }
  }), Z7;
}
yO();
var J7 = {}, sf, eC;
function Js() {
  if (eC) return sf;
  eC = 1;
  var e = $a(), r = Mt(), t = or(), a = Fo(), o = ch(), l = tn(), c = xa(), f = sc(), p = Qs(), u = Yn(), h = TypeError, C = function(_, S) {
    this.stopped = _, this.result = S;
  }, E = C.prototype;
  return sf = function(_, S, v) {
    var g = v && v.that, O = !!(v && v.AS_ENTRIES), R = !!(v && v.IS_RECORD), D = !!(v && v.IS_ITERATOR), T = !!(v && v.INTERRUPTED), L = e(S, g), P, M, k, H, w, $, B, Y = function(ie) {
      return P && u(P, "normal"), new C(!0, ie);
    }, j = function(ie) {
      return O ? (t(ie), T ? L(ie[0], ie[1], Y) : L(ie[0], ie[1])) : T ? L(ie, Y) : L(ie);
    };
    if (R)
      P = _.iterator;
    else if (D)
      P = _;
    else {
      if (M = p(_), !M) throw new h(a(_) + " is not iterable");
      if (o(M)) {
        for (k = 0, H = l(_); H > k; k++)
          if (w = j(_[k]), w && c(E, w)) return w;
        return new C(!1);
      }
      P = f(_, M);
    }
    for ($ = R ? _.next : P.next; !(B = r($, P)).done; ) {
      try {
        w = j(B.value);
      } catch (ie) {
        u(P, "throw", ie);
      }
      if (typeof w == "object" && w && c(E, w)) return w;
    }
    return new C(!1);
  }, sf;
}
var tC;
function NO() {
  if (tC) return J7;
  tC = 1;
  var e = zt(), r = Mt(), t = Js(), a = en(), o = or(), l = Ga(), c = Yn(), f = Za(), p = f("forEach", TypeError);
  return e({ target: "Iterator", proto: !0, real: !0, forced: p }, {
    forEach: function(h) {
      o(this);
      try {
        a(h);
      } catch (_) {
        c(this, "throw", _);
      }
      if (p) return r(p, this, h);
      var C = l(this), E = 0;
      t(C, function(_) {
        h(_, E++);
      }, { IS_RECORD: !0 });
    }
  }), J7;
}
NO();
var rC = {}, lf, nC;
function LO() {
  if (nC) return lf;
  nC = 1;
  var e = Fo(), r = TypeError;
  return lf = function(t, a) {
    if (!delete t[a]) throw new r("Cannot delete property " + e(a) + " of " + e(t));
  }, lf;
}
var cf, iC;
function MO() {
  if (iC) return cf;
  iC = 1;
  var e = gt();
  return cf = function(r, t) {
    var a = [][r];
    return !!a && e(function() {
      a.call(null, t || function() {
        return 1;
      }, 1);
    });
  }, cf;
}
var aC;
function bO() {
  if (aC) return rC;
  aC = 1;
  var e = zt(), r = vt(), t = en(), a = On(), o = tn(), l = LO(), c = Nn(), f = gt(), p = fh(), u = MO(), h = C8(), C = S8(), E = Jl(), _ = I8(), S = [], v = r(S.sort), g = r(S.push), O = f(function() {
    S.sort(void 0);
  }), R = f(function() {
    S.sort(null);
  }), D = u("sort"), T = !f(function() {
    if (E) return E < 70;
    if (!(h && h > 3)) {
      if (C) return !0;
      if (_) return _ < 603;
      var M = "", k, H, w, $;
      for (k = 65; k < 76; k++) {
        switch (H = String.fromCharCode(k), k) {
          case 66:
          case 69:
          case 70:
          case 72:
            w = 3;
            break;
          case 68:
          case 71:
            w = 4;
            break;
          default:
            w = 2;
        }
        for ($ = 0; $ < 47; $++)
          S.push({ k: H + $, v: w });
      }
      for (S.sort(function(B, Y) {
        return Y.v - B.v;
      }), $ = 0; $ < S.length; $++)
        H = S[$].k.charAt(0), M.charAt(M.length - 1) !== H && (M += H);
      return M !== "DGBEFHACIJK";
    }
  }), L = O || !R || !D || !T, P = function(M) {
    return function(k, H) {
      return H === void 0 ? -1 : k === void 0 ? 1 : M !== void 0 ? +M(k, H) || 0 : c(k) > c(H) ? 1 : -1;
    };
  };
  return e({ target: "Array", proto: !0, forced: L }, {
    sort: function(k) {
      k !== void 0 && t(k);
      var H = a(this);
      if (T) return k === void 0 ? v(H) : v(H, k);
      var w = [], $ = o(H), B, Y;
      for (Y = 0; Y < $; Y++)
        Y in H && g(w, H[Y]);
      for (p(w, P(k)), B = o(w), Y = 0; Y < B; ) H[Y] = w[Y++];
      for (; Y < $; ) l(H, Y++);
      return H;
    }
  }), rC;
}
bO();
var oC = {}, sC;
function PO() {
  if (sC) return oC;
  sC = 1;
  var e = zt(), r = Mt(), t = Js(), a = en(), o = or(), l = Ga(), c = Yn(), f = Za(), p = f("every", TypeError);
  return e({ target: "Iterator", proto: !0, real: !0, forced: p }, {
    every: function(h) {
      o(this);
      try {
        a(h);
      } catch (_) {
        c(this, "throw", _);
      }
      if (p) return r(p, this, h);
      var C = l(this), E = 0;
      return !t(C, function(_, S) {
        if (!h(_, E++)) return S();
      }, { IS_RECORD: !0, INTERRUPTED: !0 }).stopped;
    }
  }), oC;
}
PO();
var lC = {}, cC;
function wO() {
  if (cC) return lC;
  cC = 1;
  var e = zt(), r = Mt(), t = en(), a = or(), o = Ga(), l = P8(), c = hh(), f = Yn(), p = w8(), u = Za(), h = bi(), C = !h && !p("map", function() {
  }), E = !h && !C && u("map", TypeError), _ = h || C || E, S = l(function() {
    var v = this.iterator, g = a(r(this.next, v)), O = this.done = !!g.done;
    if (!O) return c(v, this.mapper, [g.value, this.counter++], !0);
  });
  return e({ target: "Iterator", proto: !0, real: !0, forced: _ }, {
    map: function(g) {
      a(this);
      try {
        t(g);
      } catch (O) {
        f(this, "throw", O);
      }
      return E ? r(E, this, g) : new S(o(this), {
        mapper: g
      });
    }
  }), lC;
}
wO();
var uC = {}, fC;
function HO() {
  if (fC) return uC;
  fC = 1;
  var e = zt(), r = Mt(), t = Js(), a = en(), o = or(), l = Ga(), c = Yn(), f = Za(), p = f("some", TypeError);
  return e({ target: "Iterator", proto: !0, real: !0, forced: p }, {
    some: function(h) {
      o(this);
      try {
        a(h);
      } catch (_) {
        c(this, "throw", _);
      }
      if (p) return r(p, this, h);
      var C = l(this), E = 0;
      return t(C, function(_, S) {
        if (h(_, E++)) return S();
      }, { IS_RECORD: !0, INTERRUPTED: !0 }).stopped;
    }
  }), uC;
}
HO();
var dC = {}, uf, pC;
function H8() {
  if (pC) return uf;
  pC = 1;
  var e = or();
  return uf = function() {
    var r = e(this), t = "";
    return r.hasIndices && (t += "d"), r.global && (t += "g"), r.ignoreCase && (t += "i"), r.multiline && (t += "m"), r.dotAll && (t += "s"), r.unicode && (t += "u"), r.unicodeSets && (t += "v"), r.sticky && (t += "y"), t;
  }, uf;
}
var ff, hC;
function VO() {
  if (hC) return ff;
  hC = 1;
  var e = gt(), r = It(), t = r.RegExp, a = e(function() {
    var c = t("a", "y");
    return c.lastIndex = 2, c.exec("abcd") !== null;
  }), o = a || e(function() {
    return !t("a", "y").sticky;
  }), l = a || e(function() {
    var c = t("^r", "gy");
    return c.lastIndex = 2, c.exec("str") !== null;
  });
  return ff = {
    BROKEN_CARET: l,
    MISSED_STICKY: o,
    UNSUPPORTED_Y: a
  }, ff;
}
var df, mC;
function kO() {
  if (mC) return df;
  mC = 1;
  var e = gt(), r = It(), t = r.RegExp;
  return df = e(function() {
    var a = t(".", "s");
    return !(a.dotAll && a.test(`
`) && a.flags === "s");
  }), df;
}
var pf, _C;
function FO() {
  if (_C) return pf;
  _C = 1;
  var e = gt(), r = It(), t = r.RegExp;
  return pf = e(function() {
    var a = t("(?<a>b)", "g");
    return a.exec("b").groups.a !== "b" || "b".replace(a, "$<a>c") !== "bc";
  }), pf;
}
var hf, EC;
function mh() {
  if (EC) return hf;
  EC = 1;
  var e = Mt(), r = vt(), t = Nn(), a = H8(), o = VO(), l = jp(), c = Ua(), f = di().get, p = kO(), u = FO(), h = l("native-string-replace", String.prototype.replace), C = RegExp.prototype.exec, E = C, _ = r("".charAt), S = r("".indexOf), v = r("".replace), g = r("".slice), O = function() {
    var L = /a/, P = /b*/g;
    return e(C, L, "a"), e(C, P, "a"), L.lastIndex !== 0 || P.lastIndex !== 0;
  }(), R = o.BROKEN_CARET, D = /()??/.exec("")[1] !== void 0, T = O || D || R || p || u;
  return T && (E = function(P) {
    var M = this, k = f(M), H = t(P), w = k.raw, $, B, Y, j, ie, se, le;
    if (w)
      return w.lastIndex = M.lastIndex, $ = e(E, w, H), M.lastIndex = w.lastIndex, $;
    var U = k.groups, X = R && M.sticky, K = e(a, M), y = M.source, G = 0, ce = H;
    if (X && (K = v(K, "y", ""), S(K, "g") === -1 && (K += "g"), ce = g(H, M.lastIndex), M.lastIndex > 0 && (!M.multiline || M.multiline && _(H, M.lastIndex - 1) !== `
`) && (y = "(?: " + y + ")", ce = " " + ce, G++), B = new RegExp("^(?:" + y + ")", K)), D && (B = new RegExp("^" + y + "$(?!\\s)", K)), O && (Y = M.lastIndex), j = e(C, X ? B : M, ce), X ? j ? (j.input = g(j.input, G), j[0] = g(j[0], G), j.index = M.lastIndex, M.lastIndex += j[0].length) : M.lastIndex = 0 : O && j && (M.lastIndex = M.global ? j.index + j[0].length : Y), D && j && j.length > 1 && e(h, j[0], B, function() {
      for (ie = 1; ie < arguments.length - 2; ie++)
        arguments[ie] === void 0 && (j[ie] = void 0);
    }), j && U)
      for (j.groups = se = c(null), ie = 0; ie < U.length; ie++)
        le = U[ie], se[le[0]] = j[le[1]];
    return j;
  }), hf = E, hf;
}
var CC;
function V8() {
  if (CC) return dC;
  CC = 1;
  var e = zt(), r = mh();
  return e({ target: "RegExp", proto: !0, forced: /./.exec !== r }, {
    exec: r
  }), dC;
}
V8();
var SC = {}, mf, IC;
function xO() {
  if (IC) return mf;
  IC = 1, V8();
  var e = Mt(), r = pi(), t = mh(), a = gt(), o = cr(), l = yn(), c = o("species"), f = RegExp.prototype;
  return mf = function(p, u, h, C) {
    var E = o(p), _ = !a(function() {
      var O = {};
      return O[E] = function() {
        return 7;
      }, ""[p](O) !== 7;
    }), S = _ && !a(function() {
      var O = !1, R = /a/;
      return p === "split" && (R = {}, R.constructor = {}, R.constructor[c] = function() {
        return R;
      }, R.flags = "", R[E] = /./[E]), R.exec = function() {
        return O = !0, null;
      }, R[E](""), !O;
    });
    if (!_ || !S || h) {
      var v = /./[E], g = u(E, ""[p], function(O, R, D, T, L) {
        var P = R.exec;
        return P === t || P === f.exec ? _ && !L ? { done: !0, value: e(v, R, D, T) } : { done: !0, value: e(O, D, R, T) } : { done: !1 };
      });
      r(String.prototype, p, g[0]), r(f, E, g[1]);
    }
    C && l(f[E], "sham", !0);
  }, mf;
}
var _f, vC;
function _h() {
  if (vC) return _f;
  vC = 1;
  var e = vt(), r = fi(), t = Nn(), a = ko(), o = e("".charAt), l = e("".charCodeAt), c = e("".slice), f = function(p) {
    return function(u, h) {
      var C = t(a(u)), E = r(h), _ = C.length, S, v;
      return E < 0 || E >= _ ? p ? "" : void 0 : (S = l(C, E), S < 55296 || S > 56319 || E + 1 === _ || (v = l(C, E + 1)) < 56320 || v > 57343 ? p ? o(C, E) : S : p ? c(C, E, E + 2) : (S - 55296 << 10) + (v - 56320) + 65536);
    };
  };
  return _f = {
    // `String.prototype.codePointAt` method
    // https://tc39.es/ecma262/#sec-string.prototype.codepointat
    codeAt: f(!1),
    // `String.prototype.at` method
    // https://github.com/mathiasbynens/String.prototype.at
    charAt: f(!0)
  }, _f;
}
var Ef, gC;
function UO() {
  if (gC) return Ef;
  gC = 1;
  var e = _h().charAt;
  return Ef = function(r, t, a) {
    return t + (a ? e(r, t).length : 1);
  }, Ef;
}
var Cf, DC;
function BO() {
  if (DC) return Cf;
  DC = 1;
  var e = vt(), r = On(), t = Math.floor, a = e("".charAt), o = e("".replace), l = e("".slice), c = /\$([$&'`]|\d{1,2}|<[^>]*>)/g, f = /\$([$&'`]|\d{1,2})/g;
  return Cf = function(p, u, h, C, E, _) {
    var S = h + p.length, v = C.length, g = f;
    return E !== void 0 && (E = r(E), g = c), o(_, g, function(O, R) {
      var D;
      switch (a(R, 0)) {
        case "$":
          return "$";
        case "&":
          return p;
        case "`":
          return l(u, 0, h);
        case "'":
          return l(u, S);
        case "<":
          D = E[l(R, 1, -1)];
          break;
        default:
          var T = +R;
          if (T === 0) return O;
          if (T > v) {
            var L = t(T / 10);
            return L === 0 ? O : L <= v ? C[L - 1] === void 0 ? a(R, 1) : C[L - 1] + a(R, 1) : O;
          }
          D = C[T - 1];
      }
      return D === void 0 ? "" : D;
    });
  }, Cf;
}
var Sf, RC;
function $O() {
  if (RC) return Sf;
  RC = 1;
  var e = It(), r = gt(), t = e.RegExp, a = !r(function() {
    var o = !0;
    try {
      t(".", "d");
    } catch (E) {
      o = !1;
    }
    var l = {}, c = "", f = o ? "dgimsy" : "gimsy", p = function(E, _) {
      Object.defineProperty(l, E, { get: function() {
        return c += _, !0;
      } });
    }, u = {
      dotAll: "s",
      global: "g",
      ignoreCase: "i",
      multiline: "m",
      sticky: "y"
    };
    o && (u.hasIndices = "d");
    for (var h in u) p(h, u[h]);
    var C = Object.getOwnPropertyDescriptor(t.prototype, "flags").get.call(l);
    return C !== f || c !== f;
  });
  return Sf = { correct: a }, Sf;
}
var If, AC;
function GO() {
  if (AC) return If;
  AC = 1;
  var e = Mt(), r = kr(), t = xa(), a = $O(), o = H8(), l = RegExp.prototype;
  return If = a.correct ? function(c) {
    return c.flags;
  } : function(c) {
    return !a.correct && t(l, c) && !r(c, "flags") ? e(o, c) : c.flags;
  }, If;
}
var vf, TC;
function ZO() {
  if (TC) return vf;
  TC = 1;
  var e = Mt(), r = or(), t = Xt(), a = aa(), o = mh(), l = TypeError;
  return vf = function(c, f) {
    var p = c.exec;
    if (t(p)) {
      var u = e(p, c, f);
      return u !== null && r(u), u;
    }
    if (a(c) === "RegExp") return e(o, c, f);
    throw new l("RegExp#exec called on incompatible receiver");
  }, vf;
}
var OC;
function jO() {
  if (OC) return SC;
  OC = 1;
  var e = ac(), r = Mt(), t = vt(), a = xO(), o = gt(), l = or(), c = Xt(), f = Vr(), p = fi(), u = xo(), h = Nn(), C = ko(), E = UO(), _ = qs(), S = BO(), v = GO(), g = ZO(), O = cr(), R = O("replace"), D = Math.max, T = Math.min, L = t([].concat), P = t([].push), M = t("".indexOf), k = t("".slice), H = function(Y) {
    return Y === void 0 ? Y : String(Y);
  }, w = function() {
    return "a".replace(/./, "$0") === "$0";
  }(), $ = function() {
    return /./[R] ? /./[R]("a", "$0") === "" : !1;
  }(), B = !o(function() {
    var Y = /./;
    return Y.exec = function() {
      var j = [];
      return j.groups = { a: "7" }, j;
    }, "".replace(Y, "$<a>") !== "7";
  });
  return a("replace", function(Y, j, ie) {
    var se = $ ? "$" : "$0";
    return [
      // `String.prototype.replace` method
      // https://tc39.es/ecma262/#sec-string.prototype.replace
      function(U, X) {
        var K = C(this), y = f(U) ? _(U, R) : void 0;
        return y ? r(y, U, K, X) : r(j, h(K), U, X);
      },
      // `RegExp.prototype[@@replace]` method
      // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
      function(le, U) {
        var X = l(this), K = h(le);
        if (typeof U == "string" && M(U, se) === -1 && M(U, "$<") === -1) {
          var y = ie(j, X, K, U);
          if (y.done) return y.value;
        }
        var G = c(U);
        G || (U = h(U));
        var ce = h(v(X)), ue = M(ce, "g") !== -1, ee;
        ue && (ee = M(ce, "u") !== -1, X.lastIndex = 0);
        for (var ge = [], Oe; Oe = g(X, K), !(Oe === null || (P(ge, Oe), !ue)); ) {
          var Se = h(Oe[0]);
          Se === "" && (X.lastIndex = E(K, u(X.lastIndex), ee));
        }
        for (var Ne = "", Le = 0, ct = 0; ct < ge.length; ct++) {
          Oe = ge[ct];
          for (var Ye = h(Oe[0]), nt = D(T(p(Oe.index), K.length), 0), Ke = [], ot, St = 1; St < Oe.length; St++) P(Ke, H(Oe[St]));
          var dt = Oe.groups;
          if (G) {
            var Je = L([Ye], Ke, nt, K);
            dt !== void 0 && P(Je, dt), ot = h(e(U, void 0, Je));
          } else
            ot = S(Ye, K, nt, Ke, dt, U);
          nt >= Le && (Ne += k(K, Le, nt) + ot, Le = nt + Ye.length);
        }
        return Ne + k(K, Le);
      }
    ];
  }, !B || !w || $), SC;
}
jO();
var yC = {}, NC = {}, LC = {}, MC;
function zO() {
  if (MC) return LC;
  MC = 1;
  var e = _h().charAt, r = Nn(), t = di(), a = n8(), o = ic(), l = "String Iterator", c = t.set, f = t.getterFor(l);
  return a(String, "String", function(p) {
    c(this, {
      type: l,
      string: r(p),
      index: 0
    });
  }, function() {
    var u = f(this), h = u.string, C = u.index, E;
    return C >= h.length ? o(void 0, !0) : (E = e(h, C), u.index += E.length, o(E, !1));
  }), LC;
}
var gf, bC;
function k8() {
  if (bC) return gf;
  bC = 1;
  var e = gt(), r = cr(), t = jt(), a = bi(), o = r("iterator");
  return gf = !e(function() {
    var l = new URL("b?a=1&b=2&c=3", "https://a"), c = l.searchParams, f = new URLSearchParams("a=1&a=2&b=3"), p = "";
    return l.pathname = "c%20d", c.forEach(function(u, h) {
      c.delete("b"), p += h + u;
    }), f.delete("a", 2), f.delete("b", void 0), a && (!l.toJSON || !f.has("a", 1) || f.has("a", 2) || !f.has("a", void 0) || f.has("b")) || !c.size && (a || !t) || !c.sort || l.href !== "https://a/c%20d?a=1&c=3" || c.get("c") !== "3" || String(new URLSearchParams("?a=1")) !== "a=1" || !c[o] || new URL("https://a@b").username !== "a" || new URLSearchParams(new URLSearchParams("a=b")).get("a") !== "b" || new URL("https://тест").host !== "xn--e1aybc" || new URL("https://a#б").hash !== "#%D0%B1" || p !== "a1c3" || new URL("https://x", void 0).host !== "x";
  }), gf;
}
var Df, PC;
function qO() {
  if (PC) return Df;
  PC = 1;
  var e = jt(), r = vt(), t = Mt(), a = gt(), o = Kg(), l = t8(), c = Xg(), f = On(), p = Ql(), u = Object.assign, h = Object.defineProperty, C = r([].concat);
  return Df = !u || a(function() {
    if (e && u({ b: 1 }, u(h({}, "a", {
      enumerable: !0,
      get: function() {
        h(this, "b", {
          value: 3,
          enumerable: !1
        });
      }
    }), { b: 2 })).b !== 1) return !0;
    var E = {}, _ = {}, S = Symbol("assign detection"), v = "abcdefghijklmnopqrst";
    return E[S] = 7, v.split("").forEach(function(g) {
      _[g] = g;
    }), u({}, E)[S] !== 7 || o(u({}, _)).join("") !== v;
  }) ? function(_, S) {
    for (var v = f(_), g = arguments.length, O = 1, R = l.f, D = c.f; g > O; )
      for (var T = p(arguments[O++]), L = R ? C(o(T), R(T)) : o(T), P = L.length, M = 0, k; P > M; )
        k = L[M++], (!e || t(D, T, k)) && (v[k] = T[k]);
    return v;
  } : u, Df;
}
var Rf, wC;
function WO() {
  if (wC) return Rf;
  wC = 1;
  var e = $a(), r = Mt(), t = On(), a = hh(), o = ch(), l = lh(), c = tn(), f = b8(), p = sc(), u = Qs(), h = Array;
  return Rf = function(E) {
    var _ = t(E), S = l(this), v = arguments.length, g = v > 1 ? arguments[1] : void 0, O = g !== void 0;
    O && (g = e(g, v > 2 ? arguments[2] : void 0));
    var R = u(_), D = 0, T, L, P, M, k, H;
    if (R && !(this === h && o(R)))
      for (L = S ? new this() : [], M = p(_, R), k = M.next; !(P = r(k, M)).done; D++)
        H = O ? a(M, g, [P.value, D], !0) : P.value, f(L, D, H);
    else
      for (T = c(_), L = S ? new this(T) : h(T); T > D; D++)
        H = O ? g(_[D], D) : _[D], f(L, D, H);
    return L.length = D, L;
  }, Rf;
}
var Af, HC;
function YO() {
  if (HC) return Af;
  HC = 1;
  var e = vt(), r = 2147483647, t = 36, a = 1, o = 26, l = 38, c = 700, f = 72, p = 128, u = "-", h = /[^\0-\u007E]/, C = /[.\u3002\uFF0E\uFF61]/g, E = "Overflow: input needs wider integers to process", _ = t - a, S = RangeError, v = e(C.exec), g = Math.floor, O = String.fromCharCode, R = e("".charCodeAt), D = e([].join), T = e([].push), L = e("".replace), P = e("".split), M = e("".toLowerCase), k = function(B) {
    for (var Y = [], j = 0, ie = B.length; j < ie; ) {
      var se = R(B, j++);
      if (se >= 55296 && se <= 56319 && j < ie) {
        var le = R(B, j++);
        (le & 64512) === 56320 ? T(Y, ((se & 1023) << 10) + (le & 1023) + 65536) : (T(Y, se), j--);
      } else
        T(Y, se);
    }
    return Y;
  }, H = function(B) {
    return B + 22 + 75 * (B < 26);
  }, w = function(B, Y, j) {
    var ie = 0;
    for (B = j ? g(B / c) : B >> 1, B += g(B / Y); B > _ * o >> 1; )
      B = g(B / _), ie += t;
    return g(ie + (_ + 1) * B / (B + l));
  }, $ = function(B) {
    var Y = [];
    B = k(B);
    var j = B.length, ie = p, se = 0, le = f, U, X;
    for (U = 0; U < B.length; U++)
      X = B[U], X < 128 && T(Y, O(X));
    var K = Y.length, y = K;
    for (K && T(Y, u); y < j; ) {
      var G = r;
      for (U = 0; U < B.length; U++)
        X = B[U], X >= ie && X < G && (G = X);
      var ce = y + 1;
      if (G - ie > g((r - se) / ce))
        throw new S(E);
      for (se += (G - ie) * ce, ie = G, U = 0; U < B.length; U++) {
        if (X = B[U], X < ie && ++se > r)
          throw new S(E);
        if (X === ie) {
          for (var ue = se, ee = t; ; ) {
            var ge = ee <= le ? a : ee >= le + o ? o : ee - le;
            if (ue < ge) break;
            var Oe = ue - ge, Se = t - ge;
            T(Y, O(H(ge + Oe % Se))), ue = g(Oe / Se), ee += t;
          }
          T(Y, O(H(ue))), le = w(se, ce, y === K), se = 0, y++;
        }
      }
      se++, ie++;
    }
    return D(Y, "");
  };
  return Af = function(B) {
    var Y = [], j = P(L(M(B), C, "."), "."), ie, se;
    for (ie = 0; ie < j.length; ie++)
      se = j[ie], T(Y, v(h, se) ? "xn--" + $(se) : se);
    return D(Y, ".");
  }, Af;
}
var Tf, VC;
function lc() {
  if (VC) return Tf;
  VC = 1;
  var e = TypeError;
  return Tf = function(r, t) {
    if (r < t) throw new e("Not enough arguments");
    return r;
  }, Tf;
}
var kC = {}, FC;
function KO() {
  if (FC) return kC;
  FC = 1;
  var e = zt(), r = vt(), t = tc(), a = RangeError, o = String.fromCharCode, l = String.fromCodePoint, c = r([].join), f = !!l && l.length !== 1;
  return e({ target: "String", stat: !0, arity: 1, forced: f }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    fromCodePoint: function(u) {
      for (var h = [], C = arguments.length, E = 0, _; C > E; ) {
        if (_ = +arguments[E++], t(_, 1114111) !== _) throw new a(_ + " is not a valid code point");
        h[E] = _ < 65536 ? o(_) : o(((_ -= 65536) >> 10) + 55296, _ % 1024 + 56320);
      }
      return c(h, "");
    }
  }), kC;
}
var Of, xC;
function XO() {
  if (xC) return Of;
  xC = 1;
  var e = It(), r = jt(), t = Object.getOwnPropertyDescriptor;
  return Of = function(a) {
    if (!r) return e[a];
    var o = t(e, a);
    return o && o.value;
  }, Of;
}
var yf, UC;
function F8() {
  if (UC) return yf;
  UC = 1, i8(), KO();
  var e = zt(), r = It(), t = XO(), a = oa(), o = Mt(), l = vt(), c = jt(), f = k8(), p = pi(), u = Pi(), h = ih(), C = Uo(), E = r8(), _ = di(), S = Xs(), v = Xt(), g = kr(), O = $a(), R = sa(), D = or(), T = Vr(), L = Nn(), P = Ua(), M = Ba(), k = sc(), H = Qs(), w = ic(), $ = lc(), B = cr(), Y = fh(), j = B("iterator"), ie = "URLSearchParams", se = ie + "Iterator", le = _.set, U = _.getterFor(ie), X = _.getterFor(se), K = t("fetch"), y = t("Request"), G = t("Headers"), ce = y && y.prototype, ue = G && G.prototype, ee = r.TypeError, ge = r.encodeURIComponent, Oe = String.fromCharCode, Se = a("String", "fromCodePoint"), Ne = parseInt, Le = l("".charAt), ct = l([].join), Ye = l([].push), nt = l("".replace), Ke = l([].shift), ot = l([].splice), St = l("".split), dt = l("".slice), Je = l(/./.exec), je = /\+/g, st = "�", de = /^[0-9a-f]+$/i, Te = function(Ie, Pe) {
    var ye = dt(Ie, Pe, Pe + 2);
    return Je(de, ye) ? Ne(ye, 16) : NaN;
  }, Ue = function(Ie) {
    for (var Pe = 0, ye = 128; ye > 0 && (Ie & ye) !== 0; ye >>= 1)
      Pe++;
    return Pe;
  }, Lt = function(Ie) {
    var Pe = null;
    switch (Ie.length) {
      case 1:
        Pe = Ie[0];
        break;
      case 2:
        Pe = (Ie[0] & 31) << 6 | Ie[1] & 63;
        break;
      case 3:
        Pe = (Ie[0] & 15) << 12 | (Ie[1] & 63) << 6 | Ie[2] & 63;
        break;
      case 4:
        Pe = (Ie[0] & 7) << 18 | (Ie[1] & 63) << 12 | (Ie[2] & 63) << 6 | Ie[3] & 63;
        break;
    }
    return Pe > 1114111 ? null : Pe;
  }, Et = function(Ie) {
    Ie = nt(Ie, je, " ");
    for (var Pe = Ie.length, ye = "", we = 0; we < Pe; ) {
      var ze = Le(Ie, we);
      if (ze === "%") {
        if (Le(Ie, we + 1) === "%" || we + 3 > Pe) {
          ye += "%", we++;
          continue;
        }
        var ut = Te(Ie, we + 1);
        if (ut !== ut) {
          ye += ze, we++;
          continue;
        }
        we += 2;
        var At = Ue(ut);
        if (At === 0)
          ze = Oe(ut);
        else {
          if (At === 1 || At > 4) {
            ye += st, we++;
            continue;
          }
          for (var Nt = [ut], wt = 1; wt < At && (we++, !(we + 3 > Pe || Le(Ie, we) !== "%")); ) {
            var Qt = Te(Ie, we + 1);
            if (Qt !== Qt) {
              we += 3;
              break;
            }
            if (Qt > 191 || Qt < 128) break;
            Ye(Nt, Qt), we += 2, wt++;
          }
          if (Nt.length !== At) {
            ye += st;
            continue;
          }
          var vr = Lt(Nt);
          vr === null ? ye += st : ze = Se(vr);
        }
      }
      ye += ze, we++;
    }
    return ye;
  }, Re = /[!'()~]|%20/g, ke = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+"
  }, $e = function(Ie) {
    return ke[Ie];
  }, rt = function(Ie) {
    return nt(ge(Ie), Re, $e);
  }, ht = E(function(Pe, ye) {
    le(this, {
      type: se,
      target: U(Pe).entries,
      index: 0,
      kind: ye
    });
  }, ie, function() {
    var Pe = X(this), ye = Pe.target, we = Pe.index++;
    if (!ye || we >= ye.length)
      return Pe.target = null, w(void 0, !0);
    var ze = ye[we];
    switch (Pe.kind) {
      case "keys":
        return w(ze.key, !1);
      case "values":
        return w(ze.value, !1);
    }
    return w([ze.key, ze.value], !1);
  }, !0), Ot = function(Ie) {
    this.entries = [], this.url = null, Ie !== void 0 && (T(Ie) ? this.parseObject(Ie) : this.parseQuery(typeof Ie == "string" ? Le(Ie, 0) === "?" ? dt(Ie, 1) : Ie : L(Ie)));
  };
  Ot.prototype = {
    type: ie,
    bindURL: function(Ie) {
      this.url = Ie, this.update();
    },
    parseObject: function(Ie) {
      var Pe = this.entries, ye = H(Ie), we, ze, ut, At, Nt, wt, Qt;
      if (ye)
        for (we = k(Ie, ye), ze = we.next; !(ut = o(ze, we)).done; ) {
          if (At = k(D(ut.value)), Nt = At.next, (wt = o(Nt, At)).done || (Qt = o(Nt, At)).done || !o(Nt, At).done) throw new ee("Expected sequence with length 2");
          Ye(Pe, { key: L(wt.value), value: L(Qt.value) });
        }
      else for (var vr in Ie) g(Ie, vr) && Ye(Pe, { key: vr, value: L(Ie[vr]) });
    },
    parseQuery: function(Ie) {
      if (Ie)
        for (var Pe = this.entries, ye = St(Ie, "&"), we = 0, ze, ut; we < ye.length; )
          ze = ye[we++], ze.length && (ut = St(ze, "="), Ye(Pe, {
            key: Et(Ke(ut)),
            value: Et(ct(ut, "="))
          }));
    },
    serialize: function() {
      for (var Ie = this.entries, Pe = [], ye = 0, we; ye < Ie.length; )
        we = Ie[ye++], Ye(Pe, rt(we.key) + "=" + rt(we.value));
      return ct(Pe, "&");
    },
    update: function() {
      this.entries.length = 0, this.parseQuery(this.url.query);
    },
    updateURL: function() {
      this.url && this.url.update();
    }
  };
  var Xe = function() {
    S(this, De);
    var Pe = arguments.length > 0 ? arguments[0] : void 0, ye = le(this, new Ot(Pe));
    c || (this.size = ye.entries.length);
  }, De = Xe.prototype;
  if (h(De, {
    // `URLSearchParams.prototype.append` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-append
    append: function(Pe, ye) {
      var we = U(this);
      $(arguments.length, 2), Ye(we.entries, { key: L(Pe), value: L(ye) }), c || this.length++, we.updateURL();
    },
    // `URLSearchParams.prototype.delete` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-delete
    delete: function(Ie) {
      for (var Pe = U(this), ye = $(arguments.length, 1), we = Pe.entries, ze = L(Ie), ut = ye < 2 ? void 0 : arguments[1], At = ut === void 0 ? ut : L(ut), Nt = 0; Nt < we.length; ) {
        var wt = we[Nt];
        if (wt.key === ze && (At === void 0 || wt.value === At)) {
          if (ot(we, Nt, 1), At !== void 0) break;
        } else Nt++;
      }
      c || (this.size = we.length), Pe.updateURL();
    },
    // `URLSearchParams.prototype.get` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-get
    get: function(Pe) {
      var ye = U(this).entries;
      $(arguments.length, 1);
      for (var we = L(Pe), ze = 0; ze < ye.length; ze++)
        if (ye[ze].key === we) return ye[ze].value;
      return null;
    },
    // `URLSearchParams.prototype.getAll` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-getall
    getAll: function(Pe) {
      var ye = U(this).entries;
      $(arguments.length, 1);
      for (var we = L(Pe), ze = [], ut = 0; ut < ye.length; ut++)
        ye[ut].key === we && Ye(ze, ye[ut].value);
      return ze;
    },
    // `URLSearchParams.prototype.has` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-has
    has: function(Pe) {
      for (var ye = U(this).entries, we = $(arguments.length, 1), ze = L(Pe), ut = we < 2 ? void 0 : arguments[1], At = ut === void 0 ? ut : L(ut), Nt = 0; Nt < ye.length; ) {
        var wt = ye[Nt++];
        if (wt.key === ze && (At === void 0 || wt.value === At)) return !0;
      }
      return !1;
    },
    // `URLSearchParams.prototype.set` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-set
    set: function(Pe, ye) {
      var we = U(this);
      $(arguments.length, 1);
      for (var ze = we.entries, ut = !1, At = L(Pe), Nt = L(ye), wt = 0, Qt; wt < ze.length; wt++)
        Qt = ze[wt], Qt.key === At && (ut ? ot(ze, wt--, 1) : (ut = !0, Qt.value = Nt));
      ut || Ye(ze, { key: At, value: Nt }), c || (this.size = ze.length), we.updateURL();
    },
    // `URLSearchParams.prototype.sort` method
    // https://url.spec.whatwg.org/#dom-urlsearchparams-sort
    sort: function() {
      var Pe = U(this);
      Y(Pe.entries, function(ye, we) {
        return ye.key > we.key ? 1 : -1;
      }), Pe.updateURL();
    },
    // `URLSearchParams.prototype.forEach` method
    forEach: function(Pe) {
      for (var ye = U(this).entries, we = O(Pe, arguments.length > 1 ? arguments[1] : void 0), ze = 0, ut; ze < ye.length; )
        ut = ye[ze++], we(ut.value, ut.key, this);
    },
    // `URLSearchParams.prototype.keys` method
    keys: function() {
      return new ht(this, "keys");
    },
    // `URLSearchParams.prototype.values` method
    values: function() {
      return new ht(this, "values");
    },
    // `URLSearchParams.prototype.entries` method
    entries: function() {
      return new ht(this, "entries");
    }
  }, { enumerable: !0 }), p(De, j, De.entries, { name: "entries" }), p(De, "toString", function() {
    return U(this).serialize();
  }, { enumerable: !0 }), c && u(De, "size", {
    get: function() {
      return U(this).entries.length;
    },
    configurable: !0,
    enumerable: !0
  }), C(Xe, ie), e({ global: !0, constructor: !0, forced: !f }, {
    URLSearchParams: Xe
  }), !f && v(G)) {
    var et = l(ue.has), Pt = l(ue.set), bt = function(Ie) {
      if (T(Ie)) {
        var Pe = Ie.body, ye;
        if (R(Pe) === ie)
          return ye = Ie.headers ? new G(Ie.headers) : new G(), et(ye, "content-type") || Pt(ye, "content-type", "application/x-www-form-urlencoded;charset=UTF-8"), P(Ie, {
            body: M(0, L(Pe)),
            headers: M(0, ye)
          });
      }
      return Ie;
    };
    if (v(K) && e({ global: !0, enumerable: !0, dontCallGetSet: !0, forced: !0 }, {
      fetch: function(Pe) {
        return K(Pe, arguments.length > 1 ? bt(arguments[1]) : {});
      }
    }), v(y)) {
      var Or = function(Pe) {
        return S(this, ce), new y(Pe, arguments.length > 1 ? bt(arguments[1]) : {});
      };
      ce.constructor = Or, Or.prototype = ce, e({ global: !0, constructor: !0, dontCallGetSet: !0, forced: !0 }, {
        Request: Or
      });
    }
  }
  return yf = {
    URLSearchParams: Xe,
    getState: U
  }, yf;
}
var BC;
function QO() {
  if (BC) return NC;
  BC = 1, zO();
  var e = zt(), r = jt(), t = k8(), a = It(), o = $a(), l = vt(), c = pi(), f = Pi(), p = Xs(), u = kr(), h = qO(), C = WO(), E = oc(), _ = _h().codeAt, S = YO(), v = Nn(), g = Uo(), O = lc(), R = F8(), D = di(), T = D.set, L = D.getterFor("URL"), P = R.URLSearchParams, M = R.getState, k = a.URL, H = a.TypeError, w = a.parseInt, $ = Math.floor, B = Math.pow, Y = l("".charAt), j = l(/./.exec), ie = l([].join), se = l(1.1.toString), le = l([].pop), U = l([].push), X = l("".replace), K = l([].shift), y = l("".split), G = l("".slice), ce = l("".toLowerCase), ue = l([].unshift), ee = "Invalid authority", ge = "Invalid scheme", Oe = "Invalid host", Se = "Invalid port", Ne = /[a-z]/i, Le = /[\d+-.a-z]/i, ct = /\d/, Ye = /^0x/i, nt = /^[0-7]+$/, Ke = /^\d+$/, ot = /^[\da-f]+$/i, St = /[\0\t\n\r #%/:<>?@[\\\]^|]/, dt = /[\0\t\n\r #/:<>?@[\\\]^|]/, Je = /^[\u0000-\u0020]+/, je = /(^|[^\u0000-\u0020])[\u0000-\u0020]+$/, st = /[\t\n\r]/g, de, Te = function(J) {
    var Ee = y(J, "."), ne, z, fe, Qe, Fe, Ht, lt;
    if (Ee.length && Ee[Ee.length - 1] === "" && Ee.length--, ne = Ee.length, ne > 4) return J;
    for (z = [], fe = 0; fe < ne; fe++) {
      if (Qe = Ee[fe], Qe === "") return J;
      if (Fe = 10, Qe.length > 1 && Y(Qe, 0) === "0" && (Fe = j(Ye, Qe) ? 16 : 8, Qe = G(Qe, Fe === 8 ? 1 : 2)), Qe === "")
        Ht = 0;
      else {
        if (!j(Fe === 10 ? Ke : Fe === 8 ? nt : ot, Qe)) return J;
        Ht = w(Qe, Fe);
      }
      U(z, Ht);
    }
    for (fe = 0; fe < ne; fe++)
      if (Ht = z[fe], fe === ne - 1) {
        if (Ht >= B(256, 5 - ne)) return null;
      } else if (Ht > 255) return null;
    for (lt = le(z), fe = 0; fe < z.length; fe++)
      lt += z[fe] * B(256, 3 - fe);
    return lt;
  }, Ue = function(J) {
    var Ee = [0, 0, 0, 0, 0, 0, 0, 0], ne = 0, z = null, fe = 0, Qe, Fe, Ht, lt, ir, hr, _e, Vt = function() {
      return Y(J, fe);
    };
    if (Vt() === ":") {
      if (Y(J, 1) !== ":") return;
      fe += 2, ne++, z = ne;
    }
    for (; Vt(); ) {
      if (ne === 8) return;
      if (Vt() === ":") {
        if (z !== null) return;
        fe++, ne++, z = ne;
        continue;
      }
      for (Qe = Fe = 0; Fe < 4 && j(ot, Vt()); )
        Qe = Qe * 16 + w(Vt(), 16), fe++, Fe++;
      if (Vt() === ".") {
        if (Fe === 0 || (fe -= Fe, ne > 6)) return;
        for (Ht = 0; Vt(); ) {
          if (lt = null, Ht > 0)
            if (Vt() === "." && Ht < 4) fe++;
            else return;
          if (!j(ct, Vt())) return;
          for (; j(ct, Vt()); ) {
            if (ir = w(Vt(), 10), lt === null) lt = ir;
            else {
              if (lt === 0) return;
              lt = lt * 10 + ir;
            }
            if (lt > 255) return;
            fe++;
          }
          Ee[ne] = Ee[ne] * 256 + lt, Ht++, (Ht === 2 || Ht === 4) && ne++;
        }
        if (Ht !== 4) return;
        break;
      } else if (Vt() === ":") {
        if (fe++, !Vt()) return;
      } else if (Vt()) return;
      Ee[ne++] = Qe;
    }
    if (z !== null)
      for (hr = ne - z, ne = 7; ne !== 0 && hr > 0; )
        _e = Ee[ne], Ee[ne--] = Ee[z + hr - 1], Ee[z + --hr] = _e;
    else if (ne !== 8) return;
    return Ee;
  }, Lt = function(J) {
    for (var Ee = null, ne = 1, z = null, fe = 0, Qe = 0; Qe < 8; Qe++)
      J[Qe] !== 0 ? (fe > ne && (Ee = z, ne = fe), z = null, fe = 0) : (z === null && (z = Qe), ++fe);
    return fe > ne ? z : Ee;
  }, Et = function(J) {
    var Ee, ne, z, fe;
    if (typeof J == "number") {
      for (Ee = [], ne = 0; ne < 4; ne++)
        ue(Ee, J % 256), J = $(J / 256);
      return ie(Ee, ".");
    }
    if (typeof J == "object") {
      for (Ee = "", z = Lt(J), ne = 0; ne < 8; ne++)
        fe && J[ne] === 0 || (fe && (fe = !1), z === ne ? (Ee += ne ? ":" : "::", fe = !0) : (Ee += se(J[ne], 16), ne < 7 && (Ee += ":")));
      return "[" + Ee + "]";
    }
    return J;
  }, Re = {}, ke = h({}, Re, {
    " ": 1,
    '"': 1,
    "<": 1,
    ">": 1,
    "`": 1
  }), $e = h({}, ke, {
    "#": 1,
    "?": 1,
    "{": 1,
    "}": 1
  }), rt = h({}, $e, {
    "/": 1,
    ":": 1,
    ";": 1,
    "=": 1,
    "@": 1,
    "[": 1,
    "\\": 1,
    "]": 1,
    "^": 1,
    "|": 1
  }), ht = function(J, Ee) {
    var ne = _(J, 0);
    return ne > 32 && ne < 127 && !u(Ee, J) ? J : encodeURIComponent(J);
  }, Ot = {
    ftp: 21,
    file: null,
    http: 80,
    https: 443,
    ws: 80,
    wss: 443
  }, Xe = function(J, Ee) {
    var ne;
    return J.length === 2 && j(Ne, Y(J, 0)) && ((ne = Y(J, 1)) === ":" || !Ee && ne === "|");
  }, De = function(J) {
    var Ee;
    return J.length > 1 && Xe(G(J, 0, 2)) && (J.length === 2 || (Ee = Y(J, 2)) === "/" || Ee === "\\" || Ee === "?" || Ee === "#");
  }, et = function(J) {
    return J === "." || ce(J) === "%2e";
  }, Pt = function(J) {
    return J = ce(J), J === ".." || J === "%2e." || J === ".%2e" || J === "%2e%2e";
  }, bt = {}, Or = {}, Ie = {}, Pe = {}, ye = {}, we = {}, ze = {}, ut = {}, At = {}, Nt = {}, wt = {}, Qt = {}, vr = {}, hi = {}, Fr = {}, Xn = {}, qt = {}, xr = {}, Mn = {}, Ur = {}, gr = {}, Qn = function(J, Ee, ne) {
    var z = v(J), fe, Qe, Fe;
    if (Ee) {
      if (Qe = this.parse(z), Qe) throw new H(Qe);
      this.searchParams = null;
    } else {
      if (ne !== void 0 && (fe = new Qn(ne, !0)), Qe = this.parse(z, null, fe), Qe) throw new H(Qe);
      Fe = M(new P()), Fe.bindURL(this), this.searchParams = Fe;
    }
  };
  Qn.prototype = {
    type: "URL",
    // https://url.spec.whatwg.org/#url-parsing
    // eslint-disable-next-line max-statements -- TODO
    parse: function(J, Ee, ne) {
      var z = this, fe = Ee || bt, Qe = 0, Fe = "", Ht = !1, lt = !1, ir = !1, hr, _e, Vt, rn;
      for (J = v(J), Ee || (z.scheme = "", z.username = "", z.password = "", z.host = null, z.port = null, z.path = [], z.query = null, z.fragment = null, z.cannotBeABaseURL = !1, J = X(J, Je, ""), J = X(J, je, "$1")), J = X(J, st, ""), hr = C(J); Qe <= hr.length; ) {
        switch (_e = hr[Qe], fe) {
          case bt:
            if (_e && j(Ne, _e))
              Fe += ce(_e), fe = Or;
            else {
              if (Ee)
                return ge;
              fe = Ie;
              continue;
            }
            break;
          case Or:
            if (_e && (j(Le, _e) || _e === "+" || _e === "-" || _e === "."))
              Fe += ce(_e);
            else if (_e === ":") {
              if (Ee && (z.isSpecial() !== u(Ot, Fe) || Fe === "file" && (z.includesCredentials() || z.port !== null) || z.scheme === "file" && !z.host)) return;
              if (z.scheme = Fe, Ee) {
                z.isSpecial() && Ot[z.scheme] === z.port && (z.port = null);
                return;
              }
              Fe = "", z.scheme === "file" ? fe = hi : z.isSpecial() && ne && ne.scheme === z.scheme ? fe = Pe : z.isSpecial() ? fe = ut : hr[Qe + 1] === "/" ? (fe = ye, Qe++) : (z.cannotBeABaseURL = !0, U(z.path, ""), fe = Mn);
            } else {
              if (Ee)
                return ge;
              Fe = "", fe = Ie, Qe = 0;
              continue;
            }
            break;
          case Ie:
            if (!ne || ne.cannotBeABaseURL && _e !== "#") return ge;
            if (ne.cannotBeABaseURL && _e === "#") {
              z.scheme = ne.scheme, z.path = E(ne.path), z.query = ne.query, z.fragment = "", z.cannotBeABaseURL = !0, fe = gr;
              break;
            }
            fe = ne.scheme === "file" ? hi : we;
            continue;
          case Pe:
            if (_e === "/" && hr[Qe + 1] === "/")
              fe = At, Qe++;
            else {
              fe = we;
              continue;
            }
            break;
          case ye:
            if (_e === "/") {
              fe = Nt;
              break;
            } else {
              fe = xr;
              continue;
            }
          case we:
            if (z.scheme = ne.scheme, _e === de)
              z.username = ne.username, z.password = ne.password, z.host = ne.host, z.port = ne.port, z.path = E(ne.path), z.query = ne.query;
            else if (_e === "/" || _e === "\\" && z.isSpecial())
              fe = ze;
            else if (_e === "?")
              z.username = ne.username, z.password = ne.password, z.host = ne.host, z.port = ne.port, z.path = E(ne.path), z.query = "", fe = Ur;
            else if (_e === "#")
              z.username = ne.username, z.password = ne.password, z.host = ne.host, z.port = ne.port, z.path = E(ne.path), z.query = ne.query, z.fragment = "", fe = gr;
            else {
              z.username = ne.username, z.password = ne.password, z.host = ne.host, z.port = ne.port, z.path = E(ne.path), z.path.length--, fe = xr;
              continue;
            }
            break;
          case ze:
            if (z.isSpecial() && (_e === "/" || _e === "\\"))
              fe = At;
            else if (_e === "/")
              fe = Nt;
            else {
              z.username = ne.username, z.password = ne.password, z.host = ne.host, z.port = ne.port, fe = xr;
              continue;
            }
            break;
          case ut:
            if (fe = At, _e !== "/" || Y(Fe, Qe + 1) !== "/") continue;
            Qe++;
            break;
          case At:
            if (_e !== "/" && _e !== "\\") {
              fe = Nt;
              continue;
            }
            break;
          case Nt:
            if (_e === "@") {
              Ht && (Fe = "%40" + Fe), Ht = !0, Vt = C(Fe);
              for (var ki = 0; ki < Vt.length; ki++) {
                var mi = Vt[ki];
                if (mi === ":" && !ir) {
                  ir = !0;
                  continue;
                }
                var Br = ht(mi, rt);
                ir ? z.password += Br : z.username += Br;
              }
              Fe = "";
            } else if (_e === de || _e === "/" || _e === "?" || _e === "#" || _e === "\\" && z.isSpecial()) {
              if (Ht && Fe === "") return ee;
              Qe -= C(Fe).length + 1, Fe = "", fe = wt;
            } else Fe += _e;
            break;
          case wt:
          case Qt:
            if (Ee && z.scheme === "file") {
              fe = Xn;
              continue;
            } else if (_e === ":" && !lt) {
              if (Fe === "") return Oe;
              if (rn = z.parseHost(Fe), rn) return rn;
              if (Fe = "", fe = vr, Ee === Qt) return;
            } else if (_e === de || _e === "/" || _e === "?" || _e === "#" || _e === "\\" && z.isSpecial()) {
              if (z.isSpecial() && Fe === "") return Oe;
              if (Ee && Fe === "" && (z.includesCredentials() || z.port !== null)) return;
              if (rn = z.parseHost(Fe), rn) return rn;
              if (Fe = "", fe = qt, Ee) return;
              continue;
            } else
              _e === "[" ? lt = !0 : _e === "]" && (lt = !1), Fe += _e;
            break;
          case vr:
            if (j(ct, _e))
              Fe += _e;
            else if (_e === de || _e === "/" || _e === "?" || _e === "#" || _e === "\\" && z.isSpecial() || Ee) {
              if (Fe !== "") {
                var ua = w(Fe, 10);
                if (ua > 65535) return Se;
                z.port = z.isSpecial() && ua === Ot[z.scheme] ? null : ua, Fe = "";
              }
              if (Ee) return;
              fe = qt;
              continue;
            } else return Se;
            break;
          case hi:
            if (z.scheme = "file", _e === "/" || _e === "\\") fe = Fr;
            else if (ne && ne.scheme === "file")
              switch (_e) {
                case de:
                  z.host = ne.host, z.path = E(ne.path), z.query = ne.query;
                  break;
                case "?":
                  z.host = ne.host, z.path = E(ne.path), z.query = "", fe = Ur;
                  break;
                case "#":
                  z.host = ne.host, z.path = E(ne.path), z.query = ne.query, z.fragment = "", fe = gr;
                  break;
                default:
                  De(ie(E(hr, Qe), "")) || (z.host = ne.host, z.path = E(ne.path), z.shortenPath()), fe = xr;
                  continue;
              }
            else {
              fe = xr;
              continue;
            }
            break;
          case Fr:
            if (_e === "/" || _e === "\\") {
              fe = Xn;
              break;
            }
            ne && ne.scheme === "file" && !De(ie(E(hr, Qe), "")) && (Xe(ne.path[0], !0) ? U(z.path, ne.path[0]) : z.host = ne.host), fe = xr;
            continue;
          case Xn:
            if (_e === de || _e === "/" || _e === "\\" || _e === "?" || _e === "#") {
              if (!Ee && Xe(Fe))
                fe = xr;
              else if (Fe === "") {
                if (z.host = "", Ee) return;
                fe = qt;
              } else {
                if (rn = z.parseHost(Fe), rn) return rn;
                if (z.host === "localhost" && (z.host = ""), Ee) return;
                Fe = "", fe = qt;
              }
              continue;
            } else Fe += _e;
            break;
          case qt:
            if (z.isSpecial()) {
              if (fe = xr, _e !== "/" && _e !== "\\") continue;
            } else if (!Ee && _e === "?")
              z.query = "", fe = Ur;
            else if (!Ee && _e === "#")
              z.fragment = "", fe = gr;
            else if (_e !== de && (fe = xr, _e !== "/"))
              continue;
            break;
          case xr:
            if (_e === de || _e === "/" || _e === "\\" && z.isSpecial() || !Ee && (_e === "?" || _e === "#")) {
              if (Pt(Fe) ? (z.shortenPath(), _e !== "/" && !(_e === "\\" && z.isSpecial()) && U(z.path, "")) : et(Fe) ? _e !== "/" && !(_e === "\\" && z.isSpecial()) && U(z.path, "") : (z.scheme === "file" && !z.path.length && Xe(Fe) && (z.host && (z.host = ""), Fe = Y(Fe, 0) + ":"), U(z.path, Fe)), Fe = "", z.scheme === "file" && (_e === de || _e === "?" || _e === "#"))
                for (; z.path.length > 1 && z.path[0] === ""; )
                  K(z.path);
              _e === "?" ? (z.query = "", fe = Ur) : _e === "#" && (z.fragment = "", fe = gr);
            } else
              Fe += ht(_e, $e);
            break;
          case Mn:
            _e === "?" ? (z.query = "", fe = Ur) : _e === "#" ? (z.fragment = "", fe = gr) : _e !== de && (z.path[0] += ht(_e, Re));
            break;
          case Ur:
            !Ee && _e === "#" ? (z.fragment = "", fe = gr) : _e !== de && (_e === "'" && z.isSpecial() ? z.query += "%27" : _e === "#" ? z.query += "%23" : z.query += ht(_e, Re));
            break;
          case gr:
            _e !== de && (z.fragment += ht(_e, ke));
            break;
        }
        Qe++;
      }
    },
    // https://url.spec.whatwg.org/#host-parsing
    parseHost: function(J) {
      var Ee, ne, z;
      if (Y(J, 0) === "[") {
        if (Y(J, J.length - 1) !== "]" || (Ee = Ue(G(J, 1, -1)), !Ee)) return Oe;
        this.host = Ee;
      } else if (this.isSpecial()) {
        if (J = S(J), j(St, J) || (Ee = Te(J), Ee === null)) return Oe;
        this.host = Ee;
      } else {
        if (j(dt, J)) return Oe;
        for (Ee = "", ne = C(J), z = 0; z < ne.length; z++)
          Ee += ht(ne[z], Re);
        this.host = Ee;
      }
    },
    // https://url.spec.whatwg.org/#cannot-have-a-username-password-port
    cannotHaveUsernamePasswordPort: function() {
      return !this.host || this.cannotBeABaseURL || this.scheme === "file";
    },
    // https://url.spec.whatwg.org/#include-credentials
    includesCredentials: function() {
      return this.username !== "" || this.password !== "";
    },
    // https://url.spec.whatwg.org/#is-special
    isSpecial: function() {
      return u(Ot, this.scheme);
    },
    // https://url.spec.whatwg.org/#shorten-a-urls-path
    shortenPath: function() {
      var J = this.path, Ee = J.length;
      Ee && (this.scheme !== "file" || Ee !== 1 || !Xe(J[0], !0)) && J.length--;
    },
    // https://url.spec.whatwg.org/#concept-url-serializer
    serialize: function() {
      var J = this, Ee = J.scheme, ne = J.username, z = J.password, fe = J.host, Qe = J.port, Fe = J.path, Ht = J.query, lt = J.fragment, ir = Ee + ":";
      return fe !== null ? (ir += "//", J.includesCredentials() && (ir += ne + (z ? ":" + z : "") + "@"), ir += Et(fe), Qe !== null && (ir += ":" + Qe)) : Ee === "file" && (ir += "//"), ir += J.cannotBeABaseURL ? Fe[0] : Fe.length ? "/" + ie(Fe, "/") : "", Ht !== null && (ir += "?" + Ht), lt !== null && (ir += "#" + lt), ir;
    },
    // https://url.spec.whatwg.org/#dom-url-href
    setHref: function(J) {
      var Ee = this.parse(J);
      if (Ee) throw new H(Ee);
      this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-origin
    getOrigin: function() {
      var J = this.scheme, Ee = this.port;
      if (J === "blob") try {
        return new bn(J.path[0]).origin;
      } catch (ne) {
        return "null";
      }
      return J === "file" || !this.isSpecial() ? "null" : J + "://" + Et(this.host) + (Ee !== null ? ":" + Ee : "");
    },
    // https://url.spec.whatwg.org/#dom-url-protocol
    getProtocol: function() {
      return this.scheme + ":";
    },
    setProtocol: function(J) {
      this.parse(v(J) + ":", bt);
    },
    // https://url.spec.whatwg.org/#dom-url-username
    getUsername: function() {
      return this.username;
    },
    setUsername: function(J) {
      var Ee = C(v(J));
      if (!this.cannotHaveUsernamePasswordPort()) {
        this.username = "";
        for (var ne = 0; ne < Ee.length; ne++)
          this.username += ht(Ee[ne], rt);
      }
    },
    // https://url.spec.whatwg.org/#dom-url-password
    getPassword: function() {
      return this.password;
    },
    setPassword: function(J) {
      var Ee = C(v(J));
      if (!this.cannotHaveUsernamePasswordPort()) {
        this.password = "";
        for (var ne = 0; ne < Ee.length; ne++)
          this.password += ht(Ee[ne], rt);
      }
    },
    // https://url.spec.whatwg.org/#dom-url-host
    getHost: function() {
      var J = this.host, Ee = this.port;
      return J === null ? "" : Ee === null ? Et(J) : Et(J) + ":" + Ee;
    },
    setHost: function(J) {
      this.cannotBeABaseURL || this.parse(J, wt);
    },
    // https://url.spec.whatwg.org/#dom-url-hostname
    getHostname: function() {
      var J = this.host;
      return J === null ? "" : Et(J);
    },
    setHostname: function(J) {
      this.cannotBeABaseURL || this.parse(J, Qt);
    },
    // https://url.spec.whatwg.org/#dom-url-port
    getPort: function() {
      var J = this.port;
      return J === null ? "" : v(J);
    },
    setPort: function(J) {
      this.cannotHaveUsernamePasswordPort() || (J = v(J), J === "" ? this.port = null : this.parse(J, vr));
    },
    // https://url.spec.whatwg.org/#dom-url-pathname
    getPathname: function() {
      var J = this.path;
      return this.cannotBeABaseURL ? J[0] : J.length ? "/" + ie(J, "/") : "";
    },
    setPathname: function(J) {
      this.cannotBeABaseURL || (this.path = [], this.parse(J, qt));
    },
    // https://url.spec.whatwg.org/#dom-url-search
    getSearch: function() {
      var J = this.query;
      return J ? "?" + J : "";
    },
    setSearch: function(J) {
      J = v(J), J === "" ? this.query = null : (Y(J, 0) === "?" && (J = G(J, 1)), this.query = "", this.parse(J, Ur)), this.searchParams.update();
    },
    // https://url.spec.whatwg.org/#dom-url-searchparams
    getSearchParams: function() {
      return this.searchParams.facade;
    },
    // https://url.spec.whatwg.org/#dom-url-hash
    getHash: function() {
      var J = this.fragment;
      return J ? "#" + J : "";
    },
    setHash: function(J) {
      if (J = v(J), J === "") {
        this.fragment = null;
        return;
      }
      Y(J, 0) === "#" && (J = G(J, 1)), this.fragment = "", this.parse(J, gr);
    },
    update: function() {
      this.query = this.searchParams.serialize() || null;
    }
  };
  var bn = function(Ee) {
    var ne = p(this, sr), z = O(arguments.length, 1) > 1 ? arguments[1] : void 0, fe = T(ne, new Qn(Ee, !1, z));
    r || (ne.href = fe.serialize(), ne.origin = fe.getOrigin(), ne.protocol = fe.getProtocol(), ne.username = fe.getUsername(), ne.password = fe.getPassword(), ne.host = fe.getHost(), ne.hostname = fe.getHostname(), ne.port = fe.getPort(), ne.pathname = fe.getPathname(), ne.search = fe.getSearch(), ne.searchParams = fe.getSearchParams(), ne.hash = fe.getHash());
  }, sr = bn.prototype, yr = function(J, Ee) {
    return {
      get: function() {
        return L(this)[J]();
      },
      set: Ee && function(ne) {
        return L(this)[Ee](ne);
      },
      configurable: !0,
      enumerable: !0
    };
  };
  if (r && (f(sr, "href", yr("serialize", "setHref")), f(sr, "origin", yr("getOrigin")), f(sr, "protocol", yr("getProtocol", "setProtocol")), f(sr, "username", yr("getUsername", "setUsername")), f(sr, "password", yr("getPassword", "setPassword")), f(sr, "host", yr("getHost", "setHost")), f(sr, "hostname", yr("getHostname", "setHostname")), f(sr, "port", yr("getPort", "setPort")), f(sr, "pathname", yr("getPathname", "setPathname")), f(sr, "search", yr("getSearch", "setSearch")), f(sr, "searchParams", yr("getSearchParams")), f(sr, "hash", yr("getHash", "setHash"))), c(sr, "toJSON", function() {
    return L(this).serialize();
  }, { enumerable: !0 }), c(sr, "toString", function() {
    return L(this).serialize();
  }, { enumerable: !0 }), k) {
    var mn = k.createObjectURL, ca = k.revokeObjectURL;
    mn && c(bn, "createObjectURL", o(mn, k)), ca && c(bn, "revokeObjectURL", o(ca, k));
  }
  return g(bn, "URL"), e({ global: !0, constructor: !0, forced: !t, sham: !r }, {
    URL: bn
  }), NC;
}
var $C;
function JO() {
  return $C || ($C = 1, QO()), yC;
}
JO();
var GC = {}, ZC;
function ey() {
  if (ZC) return GC;
  ZC = 1;
  var e = zt(), r = Mt();
  return e({ target: "URL", proto: !0, enumerable: !0 }, {
    toJSON: function() {
      return r(URL.prototype.toString, this);
    }
  }), GC;
}
ey();
var jC = {}, zC;
function ty() {
  return zC || (zC = 1, F8()), jC;
}
ty();
var qC = {}, WC;
function ry() {
  if (WC) return qC;
  WC = 1;
  var e = pi(), r = vt(), t = Nn(), a = lc(), o = URLSearchParams, l = o.prototype, c = r(l.append), f = r(l.delete), p = r(l.forEach), u = r([].push), h = new o("a=1&a=2&b=3");
  return h.delete("a", 1), h.delete("b", void 0), h + "" != "a=2" && e(l, "delete", function(C) {
    var E = arguments.length, _ = E < 2 ? void 0 : arguments[1];
    if (E && _ === void 0) return f(this, C);
    var S = [];
    p(this, function(P, M) {
      u(S, { key: M, value: P });
    }), a(E, 1);
    for (var v = t(C), g = t(_), O = 0, R = 0, D = !1, T = S.length, L; O < T; )
      L = S[O++], D || L.key === v ? (D = !0, f(this, L.key)) : R++;
    for (; R < T; )
      L = S[R++], L.key === v && L.value === g || c(this, L.key, L.value);
  }, { enumerable: !0, unsafe: !0 }), qC;
}
ry();
var YC = {}, KC;
function ny() {
  if (KC) return YC;
  KC = 1;
  var e = pi(), r = vt(), t = Nn(), a = lc(), o = URLSearchParams, l = o.prototype, c = r(l.getAll), f = r(l.has), p = new o("a=1");
  return (p.has("a", 2) || !p.has("a", void 0)) && e(l, "has", function(h) {
    var C = arguments.length, E = C < 2 ? void 0 : arguments[1];
    if (C && E === void 0) return f(this, h);
    var _ = c(this, h);
    a(C, 1);
    for (var S = t(E), v = 0; v < _.length; )
      if (_[v++] === S) return !0;
    return !1;
  }, { enumerable: !0, unsafe: !0 }), YC;
}
ny();
var XC = {}, QC;
function iy() {
  if (QC) return XC;
  QC = 1;
  var e = jt(), r = vt(), t = Pi(), a = URLSearchParams.prototype, o = r(a.forEach);
  return e && !("size" in a) && t(a, "size", {
    get: function() {
      var c = 0;
      return o(this, function() {
        c++;
      }), c;
    },
    configurable: !0,
    enumerable: !0
  }), XC;
}
iy();
function El(e, r, t) {
  return (r = ay(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function ay(e) {
  var r = oy(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function oy(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class JC {
  constructor(r, t) {
    El(this, "deviceId", void 0), El(this, "facing", void 0), El(this, "groupId", void 0), El(this, "label", void 0), this.deviceId = r.deviceId, this.facing = t, this.groupId = r.groupId, this.label = r.label;
  }
}
var Ve = {}, bs = { exports: {} }, sy = bs.exports, eS;
function ly() {
  return eS || (eS = 1, function(e, r) {
    (function(t, a) {
      var o = "1.0.40", l = "", c = "?", f = "function", p = "undefined", u = "object", h = "string", C = "major", E = "model", _ = "name", S = "type", v = "vendor", g = "version", O = "architecture", R = "console", D = "mobile", T = "tablet", L = "smarttv", P = "wearable", M = "embedded", k = 500, H = "Amazon", w = "Apple", $ = "ASUS", B = "BlackBerry", Y = "Browser", j = "Chrome", ie = "Edge", se = "Firefox", le = "Google", U = "Huawei", X = "LG", K = "Microsoft", y = "Motorola", G = "Opera", ce = "Samsung", ue = "Sharp", ee = "Sony", ge = "Xiaomi", Oe = "Zebra", Se = "Facebook", Ne = "Chromium OS", Le = "Mac OS", ct = " Browser", Ye = function(Re, ke) {
        var $e = {};
        for (var rt in Re)
          ke[rt] && ke[rt].length % 2 === 0 ? $e[rt] = ke[rt].concat(Re[rt]) : $e[rt] = Re[rt];
        return $e;
      }, nt = function(Re) {
        for (var ke = {}, $e = 0; $e < Re.length; $e++)
          ke[Re[$e].toUpperCase()] = Re[$e];
        return ke;
      }, Ke = function(Re, ke) {
        return typeof Re === h ? ot(ke).indexOf(ot(Re)) !== -1 : !1;
      }, ot = function(Re) {
        return Re.toLowerCase();
      }, St = function(Re) {
        return typeof Re === h ? Re.replace(/[^\d\.]/g, l).split(".")[0] : a;
      }, dt = function(Re, ke) {
        if (typeof Re === h)
          return Re = Re.replace(/^\s\s*/, l), typeof ke === p ? Re : Re.substring(0, k);
      }, Je = function(Re, ke) {
        for (var $e = 0, rt, ht, Ot, Xe, De, et; $e < ke.length && !De; ) {
          var Pt = ke[$e], bt = ke[$e + 1];
          for (rt = ht = 0; rt < Pt.length && !De && Pt[rt]; )
            if (De = Pt[rt++].exec(Re), De)
              for (Ot = 0; Ot < bt.length; Ot++)
                et = De[++ht], Xe = bt[Ot], typeof Xe === u && Xe.length > 0 ? Xe.length === 2 ? typeof Xe[1] == f ? this[Xe[0]] = Xe[1].call(this, et) : this[Xe[0]] = Xe[1] : Xe.length === 3 ? typeof Xe[1] === f && !(Xe[1].exec && Xe[1].test) ? this[Xe[0]] = et ? Xe[1].call(this, et, Xe[2]) : a : this[Xe[0]] = et ? et.replace(Xe[1], Xe[2]) : a : Xe.length === 4 && (this[Xe[0]] = et ? Xe[3].call(this, et.replace(Xe[1], Xe[2])) : a) : this[Xe] = et || a;
          $e += 2;
        }
      }, je = function(Re, ke) {
        for (var $e in ke)
          if (typeof ke[$e] === u && ke[$e].length > 0) {
            for (var rt = 0; rt < ke[$e].length; rt++)
              if (Ke(ke[$e][rt], Re))
                return $e === c ? a : $e;
          } else if (Ke(ke[$e], Re))
            return $e === c ? a : $e;
        return ke.hasOwnProperty("*") ? ke["*"] : Re;
      }, st = { "1.0": "/8", 1.2: "/1", 1.3: "/3", "2.0": "/412", "2.0.2": "/416", "2.0.3": "/417", "2.0.4": "/419", "?": "/" }, de = { ME: "4.90", "NT 3.11": "NT3.51", "NT 4.0": "NT4.0", 2e3: "NT 5.0", XP: ["NT 5.1", "NT 5.2"], Vista: "NT 6.0", 7: "NT 6.1", 8: "NT 6.2", 8.1: "NT 6.3", 10: ["NT 6.4", "NT 10.0"], RT: "ARM" }, Te = { browser: [[/\b(?:crmo|crios)\/([\w\.]+)/i], [g, [_, "Chrome"]], [/edg(?:e|ios|a)?\/([\w\.]+)/i], [g, [_, "Edge"]], [/(opera mini)\/([-\w\.]+)/i, /(opera [mobiletab]{3,6})\b.+version\/([-\w\.]+)/i, /(opera)(?:.+version\/|[\/ ]+)([\w\.]+)/i], [_, g], [/opios[\/ ]+([\w\.]+)/i], [g, [_, G + " Mini"]], [/\bop(?:rg)?x\/([\w\.]+)/i], [g, [_, G + " GX"]], [/\bopr\/([\w\.]+)/i], [g, [_, G]], [/\bb[ai]*d(?:uhd|[ub]*[aekoprswx]{5,6})[\/ ]?([\w\.]+)/i], [g, [_, "Baidu"]], [/\b(?:mxbrowser|mxios|myie2)\/?([-\w\.]*)\b/i], [g, [_, "Maxthon"]], [/(kindle)\/([\w\.]+)/i, /(lunascape|maxthon|netfront|jasmine|blazer|sleipnir)[\/ ]?([\w\.]*)/i, /(avant|iemobile|slim(?:browser|boat|jet))[\/ ]?([\d\.]*)/i, /(?:ms|\()(ie) ([\w\.]+)/i, /(flock|rockmelt|midori|epiphany|silk|skyfire|ovibrowser|bolt|iron|vivaldi|iridium|phantomjs|bowser|qupzilla|falkon|rekonq|puffin|brave|whale(?!.+naver)|qqbrowserlite|duckduckgo|klar|helio|(?=comodo_)?dragon)\/([-\w\.]+)/i, /(heytap|ovi|115)browser\/([\d\.]+)/i, /(weibo)__([\d\.]+)/i], [_, g], [/quark(?:pc)?\/([-\w\.]+)/i], [g, [_, "Quark"]], [/\bddg\/([\w\.]+)/i], [g, [_, "DuckDuckGo"]], [/(?:\buc? ?browser|(?:juc.+)ucweb)[\/ ]?([\w\.]+)/i], [g, [_, "UC" + Y]], [/microm.+\bqbcore\/([\w\.]+)/i, /\bqbcore\/([\w\.]+).+microm/i, /micromessenger\/([\w\.]+)/i], [g, [_, "WeChat"]], [/konqueror\/([\w\.]+)/i], [g, [_, "Konqueror"]], [/trident.+rv[: ]([\w\.]{1,9})\b.+like gecko/i], [g, [_, "IE"]], [/ya(?:search)?browser\/([\w\.]+)/i], [g, [_, "Yandex"]], [/slbrowser\/([\w\.]+)/i], [g, [_, "Smart Lenovo " + Y]], [/(avast|avg)\/([\w\.]+)/i], [[_, /(.+)/, "$1 Secure " + Y], g], [/\bfocus\/([\w\.]+)/i], [g, [_, se + " Focus"]], [/\bopt\/([\w\.]+)/i], [g, [_, G + " Touch"]], [/coc_coc\w+\/([\w\.]+)/i], [g, [_, "Coc Coc"]], [/dolfin\/([\w\.]+)/i], [g, [_, "Dolphin"]], [/coast\/([\w\.]+)/i], [g, [_, G + " Coast"]], [/miuibrowser\/([\w\.]+)/i], [g, [_, "MIUI" + ct]], [/fxios\/([\w\.-]+)/i], [g, [_, se]], [/\bqihoobrowser\/?([\w\.]*)/i], [g, [_, "360"]], [/\b(qq)\/([\w\.]+)/i], [[_, /(.+)/, "$1Browser"], g], [/(oculus|sailfish|huawei|vivo|pico)browser\/([\w\.]+)/i], [[_, /(.+)/, "$1" + ct], g], [/samsungbrowser\/([\w\.]+)/i], [g, [_, ce + " Internet"]], [/metasr[\/ ]?([\d\.]+)/i], [g, [_, "Sogou Explorer"]], [/(sogou)mo\w+\/([\d\.]+)/i], [[_, "Sogou Mobile"], g], [/(electron)\/([\w\.]+) safari/i, /(tesla)(?: qtcarbrowser|\/(20\d\d\.[-\w\.]+))/i, /m?(qqbrowser|2345(?=browser|chrome|explorer))\w*[\/ ]?v?([\w\.]+)/i], [_, g], [/(lbbrowser|rekonq)/i, /\[(linkedin)app\]/i], [_], [/ome\/([\w\.]+) \w* ?(iron) saf/i, /ome\/([\w\.]+).+qihu (360)[es]e/i], [g, _], [/((?:fban\/fbios|fb_iab\/fb4a)(?!.+fbav)|;fbav\/([\w\.]+);)/i], [[_, Se], g], [/(Klarna)\/([\w\.]+)/i, /(kakao(?:talk|story))[\/ ]([\w\.]+)/i, /(naver)\(.*?(\d+\.[\w\.]+).*\)/i, /safari (line)\/([\w\.]+)/i, /\b(line)\/([\w\.]+)\/iab/i, /(alipay)client\/([\w\.]+)/i, /(twitter)(?:and| f.+e\/([\w\.]+))/i, /(chromium|instagram|snapchat)[\/ ]([-\w\.]+)/i], [_, g], [/\bgsa\/([\w\.]+) .*safari\//i], [g, [_, "GSA"]], [/musical_ly(?:.+app_?version\/|_)([\w\.]+)/i], [g, [_, "TikTok"]], [/headlesschrome(?:\/([\w\.]+)| )/i], [g, [_, j + " Headless"]], [/ wv\).+(chrome)\/([\w\.]+)/i], [[_, j + " WebView"], g], [/droid.+ version\/([\w\.]+)\b.+(?:mobile safari|safari)/i], [g, [_, "Android " + Y]], [/(chrome|omniweb|arora|[tizenoka]{5} ?browser)\/v?([\w\.]+)/i], [_, g], [/version\/([\w\.\,]+) .*mobile\/\w+ (safari)/i], [g, [_, "Mobile Safari"]], [/version\/([\w(\.|\,)]+) .*(mobile ?safari|safari)/i], [g, _], [/webkit.+?(mobile ?safari|safari)(\/[\w\.]+)/i], [_, [g, je, st]], [/(webkit|khtml)\/([\w\.]+)/i], [_, g], [/(navigator|netscape\d?)\/([-\w\.]+)/i], [[_, "Netscape"], g], [/(wolvic|librewolf)\/([\w\.]+)/i], [_, g], [/mobile vr; rv:([\w\.]+)\).+firefox/i], [g, [_, se + " Reality"]], [/ekiohf.+(flow)\/([\w\.]+)/i, /(swiftfox)/i, /(icedragon|iceweasel|camino|chimera|fennec|maemo browser|minimo|conkeror)[\/ ]?([\w\.\+]+)/i, /(seamonkey|k-meleon|icecat|iceape|firebird|phoenix|palemoon|basilisk|waterfox)\/([-\w\.]+)$/i, /(firefox)\/([\w\.]+)/i, /(mozilla)\/([\w\.]+) .+rv\:.+gecko\/\d+/i, /(polaris|lynx|dillo|icab|doris|amaya|w3m|netsurf|obigo|mosaic|(?:go|ice|up)[\. ]?browser)[-\/ ]?v?([\w\.]+)/i, /(links) \(([\w\.]+)/i], [_, [g, /_/g, "."]], [/(cobalt)\/([\w\.]+)/i], [_, [g, /master.|lts./, ""]]], cpu: [[/(?:(amd|x(?:(?:86|64)[-_])?|wow|win)64)[;\)]/i], [[O, "amd64"]], [/(ia32(?=;))/i], [[O, ot]], [/((?:i[346]|x)86)[;\)]/i], [[O, "ia32"]], [/\b(aarch64|arm(v?8e?l?|_?64))\b/i], [[O, "arm64"]], [/\b(arm(?:v[67])?ht?n?[fl]p?)\b/i], [[O, "armhf"]], [/windows (ce|mobile); ppc;/i], [[O, "arm"]], [/((?:ppc|powerpc)(?:64)?)(?: mac|;|\))/i], [[O, /ower/, l, ot]], [/(sun4\w)[;\)]/i], [[O, "sparc"]], [/((?:avr32|ia64(?=;))|68k(?=\))|\barm(?=v(?:[1-7]|[5-7]1)l?|;|eabi)|(?=atmel )avr|(?:irix|mips|sparc)(?:64)?\b|pa-risc)/i], [[O, ot]]], device: [[/\b(sch-i[89]0\d|shw-m380s|sm-[ptx]\w{2,4}|gt-[pn]\d{2,4}|sgh-t8[56]9|nexus 10)/i], [E, [v, ce], [S, T]], [/\b((?:s[cgp]h|gt|sm)-(?![lr])\w+|sc[g-]?[\d]+a?|galaxy nexus)/i, /samsung[- ]((?!sm-[lr])[-\w]+)/i, /sec-(sgh\w+)/i], [E, [v, ce], [S, D]], [/(?:\/|\()(ip(?:hone|od)[\w, ]*)(?:\/|;)/i], [E, [v, w], [S, D]], [/\((ipad);[-\w\),; ]+apple/i, /applecoremedia\/[\w\.]+ \((ipad)/i, /\b(ipad)\d\d?,\d\d?[;\]].+ios/i], [E, [v, w], [S, T]], [/(macintosh);/i], [E, [v, w]], [/\b(sh-?[altvz]?\d\d[a-ekm]?)/i], [E, [v, ue], [S, D]], [/(?:honor)([-\w ]+)[;\)]/i], [E, [v, "Honor"], [S, D]], [/\b((?:ag[rs][23]?|bah2?|sht?|btv)-a?[lw]\d{2})\b(?!.+d\/s)/i], [E, [v, U], [S, T]], [/(?:huawei)([-\w ]+)[;\)]/i, /\b(nexus 6p|\w{2,4}e?-[atu]?[ln][\dx][012359c][adn]?)\b(?!.+d\/s)/i], [E, [v, U], [S, D]], [/\b(poco[\w ]+|m2\d{3}j\d\d[a-z]{2})(?: bui|\))/i, /\b; (\w+) build\/hm\1/i, /\b(hm[-_ ]?note?[_ ]?(?:\d\w)?) bui/i, /\b(redmi[\-_ ]?(?:note|k)?[\w_ ]+)(?: bui|\))/i, /oid[^\)]+; (m?[12][0-389][01]\w{3,6}[c-y])( bui|; wv|\))/i, /\b(mi[-_ ]?(?:a\d|one|one[_ ]plus|note lte|max|cc)?[_ ]?(?:\d?\w?)[_ ]?(?:plus|se|lite|pro)?)(?: bui|\))/i], [[E, /_/g, " "], [v, ge], [S, D]], [/oid[^\)]+; (2\d{4}(283|rpbf)[cgl])( bui|\))/i, /\b(mi[-_ ]?(?:pad)(?:[\w_ ]+))(?: bui|\))/i], [[E, /_/g, " "], [v, ge], [S, T]], [/; (\w+) bui.+ oppo/i, /\b(cph[12]\d{3}|p(?:af|c[al]|d\w|e[ar])[mt]\d0|x9007|a101op)\b/i], [E, [v, "OPPO"], [S, D]], [/\b(opd2\d{3}a?) bui/i], [E, [v, "OPPO"], [S, T]], [/vivo (\w+)(?: bui|\))/i, /\b(v[12]\d{3}\w?[at])(?: bui|;)/i], [E, [v, "Vivo"], [S, D]], [/\b(rmx[1-3]\d{3})(?: bui|;|\))/i], [E, [v, "Realme"], [S, D]], [/\b(milestone|droid(?:[2-4x]| (?:bionic|x2|pro|razr))?:?( 4g)?)\b[\w ]+build\//i, /\bmot(?:orola)?[- ](\w*)/i, /((?:moto[\w\(\) ]+|xt\d{3,4}|nexus 6)(?= bui|\)))/i], [E, [v, y], [S, D]], [/\b(mz60\d|xoom[2 ]{0,2}) build\//i], [E, [v, y], [S, T]], [/((?=lg)?[vl]k\-?\d{3}) bui| 3\.[-\w; ]{10}lg?-([06cv9]{3,4})/i], [E, [v, X], [S, T]], [/(lm(?:-?f100[nv]?|-[\w\.]+)(?= bui|\))|nexus [45])/i, /\blg[-e;\/ ]+((?!browser|netcast|android tv)\w+)/i, /\blg-?([\d\w]+) bui/i], [E, [v, X], [S, D]], [/(ideatab[-\w ]+)/i, /lenovo ?(s[56]000[-\w]+|tab(?:[\w ]+)|yt[-\d\w]{6}|tb[-\d\w]{6})/i], [E, [v, "Lenovo"], [S, T]], [/(?:maemo|nokia).*(n900|lumia \d+)/i, /nokia[-_ ]?([-\w\.]*)/i], [[E, /_/g, " "], [v, "Nokia"], [S, D]], [/(pixel c)\b/i], [E, [v, le], [S, T]], [/droid.+; (pixel[\daxl ]{0,6})(?: bui|\))/i], [E, [v, le], [S, D]], [/droid.+; (a?\d[0-2]{2}so|[c-g]\d{4}|so[-gl]\w+|xq-a\w[4-7][12])(?= bui|\).+chrome\/(?![1-6]{0,1}\d\.))/i], [E, [v, ee], [S, D]], [/sony tablet [ps]/i, /\b(?:sony)?sgp\w+(?: bui|\))/i], [[E, "Xperia Tablet"], [v, ee], [S, T]], [/ (kb2005|in20[12]5|be20[12][59])\b/i, /(?:one)?(?:plus)? (a\d0\d\d)(?: b|\))/i], [E, [v, "OnePlus"], [S, D]], [/(alexa)webm/i, /(kf[a-z]{2}wi|aeo(?!bc)\w\w)( bui|\))/i, /(kf[a-z]+)( bui|\)).+silk\//i], [E, [v, H], [S, T]], [/((?:sd|kf)[0349hijorstuw]+)( bui|\)).+silk\//i], [[E, /(.+)/g, "Fire Phone $1"], [v, H], [S, D]], [/(playbook);[-\w\),; ]+(rim)/i], [E, v, [S, T]], [/\b((?:bb[a-f]|st[hv])100-\d)/i, /\(bb10; (\w+)/i], [E, [v, B], [S, D]], [/(?:\b|asus_)(transfo[prime ]{4,10} \w+|eeepc|slider \w+|nexus 7|padfone|p00[cj])/i], [E, [v, $], [S, T]], [/ (z[bes]6[027][012][km][ls]|zenfone \d\w?)\b/i], [E, [v, $], [S, D]], [/(nexus 9)/i], [E, [v, "HTC"], [S, T]], [/(htc)[-;_ ]{1,2}([\w ]+(?=\)| bui)|\w+)/i, /(zte)[- ]([\w ]+?)(?: bui|\/|\))/i, /(alcatel|geeksphone|nexian|panasonic(?!(?:;|\.))|sony(?!-bra))[-_ ]?([-\w]*)/i], [v, [E, /_/g, " "], [S, D]], [/droid [\w\.]+; ((?:8[14]9[16]|9(?:0(?:48|60|8[01])|1(?:3[27]|66)|2(?:6[69]|9[56])|466))[gqswx])\w*(\)| bui)/i], [E, [v, "TCL"], [S, T]], [/(itel) ((\w+))/i], [[v, ot], E, [S, je, { tablet: ["p10001l", "w7001"], "*": "mobile" }]], [/droid.+; ([ab][1-7]-?[0178a]\d\d?)/i], [E, [v, "Acer"], [S, T]], [/droid.+; (m[1-5] note) bui/i, /\bmz-([-\w]{2,})/i], [E, [v, "Meizu"], [S, D]], [/; ((?:power )?armor(?:[\w ]{0,8}))(?: bui|\))/i], [E, [v, "Ulefone"], [S, D]], [/; (energy ?\w+)(?: bui|\))/i, /; energizer ([\w ]+)(?: bui|\))/i], [E, [v, "Energizer"], [S, D]], [/; cat (b35);/i, /; (b15q?|s22 flip|s48c|s62 pro)(?: bui|\))/i], [E, [v, "Cat"], [S, D]], [/((?:new )?andromax[\w- ]+)(?: bui|\))/i], [E, [v, "Smartfren"], [S, D]], [/droid.+; (a(?:015|06[35]|142p?))/i], [E, [v, "Nothing"], [S, D]], [/(blackberry|benq|palm(?=\-)|sonyericsson|acer|asus|dell|meizu|motorola|polytron|infinix|tecno|micromax|advan)[-_ ]?([-\w]*)/i, /; (imo) ((?!tab)[\w ]+?)(?: bui|\))/i, /(hp) ([\w ]+\w)/i, /(asus)-?(\w+)/i, /(microsoft); (lumia[\w ]+)/i, /(lenovo)[-_ ]?([-\w]+)/i, /(jolla)/i, /(oppo) ?([\w ]+) bui/i], [v, E, [S, D]], [/(imo) (tab \w+)/i, /(kobo)\s(ereader|touch)/i, /(archos) (gamepad2?)/i, /(hp).+(touchpad(?!.+tablet)|tablet)/i, /(kindle)\/([\w\.]+)/i, /(nook)[\w ]+build\/(\w+)/i, /(dell) (strea[kpr\d ]*[\dko])/i, /(le[- ]+pan)[- ]+(\w{1,9}) bui/i, /(trinity)[- ]*(t\d{3}) bui/i, /(gigaset)[- ]+(q\w{1,9}) bui/i, /(vodafone) ([\w ]+)(?:\)| bui)/i], [v, E, [S, T]], [/(surface duo)/i], [E, [v, K], [S, T]], [/droid [\d\.]+; (fp\du?)(?: b|\))/i], [E, [v, "Fairphone"], [S, D]], [/(u304aa)/i], [E, [v, "AT&T"], [S, D]], [/\bsie-(\w*)/i], [E, [v, "Siemens"], [S, D]], [/\b(rct\w+) b/i], [E, [v, "RCA"], [S, T]], [/\b(venue[\d ]{2,7}) b/i], [E, [v, "Dell"], [S, T]], [/\b(q(?:mv|ta)\w+) b/i], [E, [v, "Verizon"], [S, T]], [/\b(?:barnes[& ]+noble |bn[rt])([\w\+ ]*) b/i], [E, [v, "Barnes & Noble"], [S, T]], [/\b(tm\d{3}\w+) b/i], [E, [v, "NuVision"], [S, T]], [/\b(k88) b/i], [E, [v, "ZTE"], [S, T]], [/\b(nx\d{3}j) b/i], [E, [v, "ZTE"], [S, D]], [/\b(gen\d{3}) b.+49h/i], [E, [v, "Swiss"], [S, D]], [/\b(zur\d{3}) b/i], [E, [v, "Swiss"], [S, T]], [/\b((zeki)?tb.*\b) b/i], [E, [v, "Zeki"], [S, T]], [/\b([yr]\d{2}) b/i, /\b(dragon[- ]+touch |dt)(\w{5}) b/i], [[v, "Dragon Touch"], E, [S, T]], [/\b(ns-?\w{0,9}) b/i], [E, [v, "Insignia"], [S, T]], [/\b((nxa|next)-?\w{0,9}) b/i], [E, [v, "NextBook"], [S, T]], [/\b(xtreme\_)?(v(1[045]|2[015]|[3469]0|7[05])) b/i], [[v, "Voice"], E, [S, D]], [/\b(lvtel\-)?(v1[12]) b/i], [[v, "LvTel"], E, [S, D]], [/\b(ph-1) /i], [E, [v, "Essential"], [S, D]], [/\b(v(100md|700na|7011|917g).*\b) b/i], [E, [v, "Envizen"], [S, T]], [/\b(trio[-\w\. ]+) b/i], [E, [v, "MachSpeed"], [S, T]], [/\btu_(1491) b/i], [E, [v, "Rotor"], [S, T]], [/(shield[\w ]+) b/i], [E, [v, "Nvidia"], [S, T]], [/(sprint) (\w+)/i], [v, E, [S, D]], [/(kin\.[onetw]{3})/i], [[E, /\./g, " "], [v, K], [S, D]], [/droid.+; (cc6666?|et5[16]|mc[239][23]x?|vc8[03]x?)\)/i], [E, [v, Oe], [S, T]], [/droid.+; (ec30|ps20|tc[2-8]\d[kx])\)/i], [E, [v, Oe], [S, D]], [/smart-tv.+(samsung)/i], [v, [S, L]], [/hbbtv.+maple;(\d+)/i], [[E, /^/, "SmartTV"], [v, ce], [S, L]], [/(nux; netcast.+smarttv|lg (netcast\.tv-201\d|android tv))/i], [[v, X], [S, L]], [/(apple) ?tv/i], [v, [E, w + " TV"], [S, L]], [/crkey/i], [[E, j + "cast"], [v, le], [S, L]], [/droid.+aft(\w+)( bui|\))/i], [E, [v, H], [S, L]], [/\(dtv[\);].+(aquos)/i, /(aquos-tv[\w ]+)\)/i], [E, [v, ue], [S, L]], [/(bravia[\w ]+)( bui|\))/i], [E, [v, ee], [S, L]], [/(mitv-\w{5}) bui/i], [E, [v, ge], [S, L]], [/Hbbtv.*(technisat) (.*);/i], [v, E, [S, L]], [/\b(roku)[\dx]*[\)\/]((?:dvp-)?[\d\.]*)/i, /hbbtv\/\d+\.\d+\.\d+ +\([\w\+ ]*; *([\w\d][^;]*);([^;]*)/i], [[v, dt], [E, dt], [S, L]], [/\b(android tv|smart[- ]?tv|opera tv|tv; rv:)\b/i], [[S, L]], [/(ouya)/i, /(nintendo) ([wids3utch]+)/i], [v, E, [S, R]], [/droid.+; (shield) bui/i], [E, [v, "Nvidia"], [S, R]], [/(playstation [345portablevi]+)/i], [E, [v, ee], [S, R]], [/\b(xbox(?: one)?(?!; xbox))[\); ]/i], [E, [v, K], [S, R]], [/\b(sm-[lr]\d\d[05][fnuw]?s?)\b/i], [E, [v, ce], [S, P]], [/((pebble))app/i], [v, E, [S, P]], [/(watch)(?: ?os[,\/]|\d,\d\/)[\d\.]+/i], [E, [v, w], [S, P]], [/droid.+; (glass) \d/i], [E, [v, le], [S, P]], [/droid.+; (wt63?0{2,3})\)/i], [E, [v, Oe], [S, P]], [/droid.+; (glass) \d/i], [E, [v, le], [S, P]], [/(pico) (4|neo3(?: link|pro)?)/i], [v, E, [S, P]], [/; (quest( \d| pro)?)/i], [E, [v, Se], [S, P]], [/(tesla)(?: qtcarbrowser|\/[-\w\.]+)/i], [v, [S, M]], [/(aeobc)\b/i], [E, [v, H], [S, M]], [/droid .+?; ([^;]+?)(?: bui|; wv\)|\) applew).+? mobile safari/i], [E, [S, D]], [/droid .+?; ([^;]+?)(?: bui|\) applew).+?(?! mobile) safari/i], [E, [S, T]], [/\b((tablet|tab)[;\/]|focus\/\d(?!.+mobile))/i], [[S, T]], [/(phone|mobile(?:[;\/]| [ \w\/\.]*safari)|pda(?=.+windows ce))/i], [[S, D]], [/(android[-\w\. ]{0,9});.+buil/i], [E, [v, "Generic"]]], engine: [[/windows.+ edge\/([\w\.]+)/i], [g, [_, ie + "HTML"]], [/(arkweb)\/([\w\.]+)/i], [_, g], [/webkit\/537\.36.+chrome\/(?!27)([\w\.]+)/i], [g, [_, "Blink"]], [/(presto)\/([\w\.]+)/i, /(webkit|trident|netfront|netsurf|amaya|lynx|w3m|goanna|servo)\/([\w\.]+)/i, /ekioh(flow)\/([\w\.]+)/i, /(khtml|tasman|links)[\/ ]\(?([\w\.]+)/i, /(icab)[\/ ]([23]\.[\d\.]+)/i, /\b(libweb)/i], [_, g], [/rv\:([\w\.]{1,9})\b.+(gecko)/i], [g, _]], os: [[/microsoft (windows) (vista|xp)/i], [_, g], [/(windows (?:phone(?: os)?|mobile))[\/ ]?([\d\.\w ]*)/i], [_, [g, je, de]], [/windows nt 6\.2; (arm)/i, /windows[\/ ]?([ntce\d\. ]+\w)(?!.+xbox)/i, /(?:win(?=3|9|n)|win 9x )([nt\d\.]+)/i], [[g, je, de], [_, "Windows"]], [/ip[honead]{2,4}\b(?:.*os ([\w]+) like mac|; opera)/i, /(?:ios;fbsv\/|iphone.+ios[\/ ])([\d\.]+)/i, /cfnetwork\/.+darwin/i], [[g, /_/g, "."], [_, "iOS"]], [/(mac os x) ?([\w\. ]*)/i, /(macintosh|mac_powerpc\b)(?!.+haiku)/i], [[_, Le], [g, /_/g, "."]], [/droid ([\w\.]+)\b.+(android[- ]x86|harmonyos)/i], [g, _], [/(android|webos|qnx|bada|rim tablet os|maemo|meego|sailfish|openharmony)[-\/ ]?([\w\.]*)/i, /(blackberry)\w*\/([\w\.]*)/i, /(tizen|kaios)[\/ ]([\w\.]+)/i, /\((series40);/i], [_, g], [/\(bb(10);/i], [g, [_, B]], [/(?:symbian ?os|symbos|s60(?=;)|series60)[-\/ ]?([\w\.]*)/i], [g, [_, "Symbian"]], [/mozilla\/[\d\.]+ \((?:mobile|tablet|tv|mobile; [\w ]+); rv:.+ gecko\/([\w\.]+)/i], [g, [_, se + " OS"]], [/web0s;.+rt(tv)/i, /\b(?:hp)?wos(?:browser)?\/([\w\.]+)/i], [g, [_, "webOS"]], [/watch(?: ?os[,\/]|\d,\d\/)([\d\.]+)/i], [g, [_, "watchOS"]], [/crkey\/([\d\.]+)/i], [g, [_, j + "cast"]], [/(cros) [\w]+(?:\)| ([\w\.]+)\b)/i], [[_, Ne], g], [/panasonic;(viera)/i, /(netrange)mmh/i, /(nettv)\/(\d+\.[\w\.]+)/i, /(nintendo|playstation) ([wids345portablevuch]+)/i, /(xbox); +xbox ([^\);]+)/i, /\b(joli|palm)\b ?(?:os)?\/?([\w\.]*)/i, /(mint)[\/\(\) ]?(\w*)/i, /(mageia|vectorlinux)[; ]/i, /([kxln]?ubuntu|debian|suse|opensuse|gentoo|arch(?= linux)|slackware|fedora|mandriva|centos|pclinuxos|red ?hat|zenwalk|linpus|raspbian|plan 9|minix|risc os|contiki|deepin|manjaro|elementary os|sabayon|linspire)(?: gnu\/linux)?(?: enterprise)?(?:[- ]linux)?(?:-gnu)?[-\/ ]?(?!chrom|package)([-\w\.]*)/i, /(hurd|linux) ?([\w\.]*)/i, /(gnu) ?([\w\.]*)/i, /\b([-frentopcghs]{0,5}bsd|dragonfly)[\/ ]?(?!amd|[ix346]{1,2}86)([\w\.]*)/i, /(haiku) (\w+)/i], [_, g], [/(sunos) ?([\w\.\d]*)/i], [[_, "Solaris"], g], [/((?:open)?solaris)[-\/ ]?([\w\.]*)/i, /(aix) ((\d)(?=\.|\)| )[\w\.])*/i, /\b(beos|os\/2|amigaos|morphos|openvms|fuchsia|hp-ux|serenityos)/i, /(unix) ?([\w\.]*)/i], [_, g]] }, Ue = function(Re, ke) {
        if (typeof Re === u && (ke = Re, Re = a), !(this instanceof Ue))
          return new Ue(Re, ke).getResult();
        var $e = typeof t !== p && t.navigator ? t.navigator : a, rt = Re || ($e && $e.userAgent ? $e.userAgent : l), ht = $e && $e.userAgentData ? $e.userAgentData : a, Ot = ke ? Ye(Te, ke) : Te, Xe = $e && $e.userAgent == rt;
        return this.getBrowser = function() {
          var De = {};
          return De[_] = a, De[g] = a, Je.call(De, rt, Ot.browser), De[C] = St(De[g]), Xe && $e && $e.brave && typeof $e.brave.isBrave == f && (De[_] = "Brave"), De;
        }, this.getCPU = function() {
          var De = {};
          return De[O] = a, Je.call(De, rt, Ot.cpu), De;
        }, this.getDevice = function() {
          var De = {};
          return De[v] = a, De[E] = a, De[S] = a, Je.call(De, rt, Ot.device), Xe && !De[S] && ht && ht.mobile && (De[S] = D), Xe && De[E] == "Macintosh" && $e && typeof $e.standalone !== p && $e.maxTouchPoints && $e.maxTouchPoints > 2 && (De[E] = "iPad", De[S] = T), De;
        }, this.getEngine = function() {
          var De = {};
          return De[_] = a, De[g] = a, Je.call(De, rt, Ot.engine), De;
        }, this.getOS = function() {
          var De = {};
          return De[_] = a, De[g] = a, Je.call(De, rt, Ot.os), Xe && !De[_] && ht && ht.platform && ht.platform != "Unknown" && (De[_] = ht.platform.replace(/chrome os/i, Ne).replace(/macos/i, Le)), De;
        }, this.getResult = function() {
          return { ua: this.getUA(), browser: this.getBrowser(), engine: this.getEngine(), os: this.getOS(), device: this.getDevice(), cpu: this.getCPU() };
        }, this.getUA = function() {
          return rt;
        }, this.setUA = function(De) {
          return rt = typeof De === h && De.length > k ? dt(De, k) : De, this;
        }, this.setUA(rt), this;
      };
      Ue.VERSION = o, Ue.BROWSER = nt([_, g, C]), Ue.CPU = nt([O]), Ue.DEVICE = nt([E, v, S, R, D, L, T, P, M]), Ue.ENGINE = Ue.OS = nt([_, g]), e.exports && (r = e.exports = Ue), r.UAParser = Ue;
      var Lt = typeof t !== p && (t.jQuery || t.Zepto);
      if (Lt && !Lt.ua) {
        var Et = new Ue();
        Lt.ua = Et.getResult(), Lt.ua.get = function() {
          return Et.getUA();
        }, Lt.ua.set = function(Re) {
          Et.setUA(Re);
          var ke = Et.getResult();
          for (var $e in ke)
            Lt.ua[$e] = ke[$e];
        };
      }
    })(typeof window == "object" ? window : sy);
  }(bs, bs.exports)), bs.exports;
}
var tS;
function cy() {
  if (tS) return Ve;
  tS = 1, Object.defineProperty(Ve, "__esModule", { value: !0 });
  function e(q) {
    return q && typeof q == "object" && "default" in q ? q.default : q;
  }
  var r = Ks(), t = e(r), a = ly(), o = new a(), l = o.getBrowser(), c = o.getCPU(), f = o.getDevice(), p = o.getEngine(), u = o.getOS(), h = o.getUA(), C = function(N) {
    return o.setUA(N);
  }, E = function(N) {
    if (!N) {
      console.error("No userAgent string was provided");
      return;
    }
    var V = new a(N);
    return {
      UA: V,
      browser: V.getBrowser(),
      cpu: V.getCPU(),
      device: V.getDevice(),
      engine: V.getEngine(),
      os: V.getOS(),
      ua: V.getUA(),
      setUserAgent: function(pe) {
        return V.setUA(pe);
      }
    };
  }, _ = /* @__PURE__ */ Object.freeze({
    ClientUAInstance: o,
    browser: l,
    cpu: c,
    device: f,
    engine: p,
    os: u,
    ua: h,
    setUa: C,
    parseUserAgent: E
  });
  function S(q, N) {
    var V = Object.keys(q);
    if (Object.getOwnPropertySymbols) {
      var ae = Object.getOwnPropertySymbols(q);
      N && (ae = ae.filter(function(pe) {
        return Object.getOwnPropertyDescriptor(q, pe).enumerable;
      })), V.push.apply(V, ae);
    }
    return V;
  }
  function v(q) {
    for (var N = 1; N < arguments.length; N++) {
      var V = arguments[N] != null ? arguments[N] : {};
      N % 2 ? S(Object(V), !0).forEach(function(ae) {
        T(q, ae, V[ae]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(q, Object.getOwnPropertyDescriptors(V)) : S(Object(V)).forEach(function(ae) {
        Object.defineProperty(q, ae, Object.getOwnPropertyDescriptor(V, ae));
      });
    }
    return q;
  }
  function g(q) {
    "@babel/helpers - typeof";
    return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? g = function(N) {
      return typeof N;
    } : g = function(N) {
      return N && typeof Symbol == "function" && N.constructor === Symbol && N !== Symbol.prototype ? "symbol" : typeof N;
    }, g(q);
  }
  function O(q, N) {
    if (!(q instanceof N))
      throw new TypeError("Cannot call a class as a function");
  }
  function R(q, N) {
    for (var V = 0; V < N.length; V++) {
      var ae = N[V];
      ae.enumerable = ae.enumerable || !1, ae.configurable = !0, "value" in ae && (ae.writable = !0), Object.defineProperty(q, ae.key, ae);
    }
  }
  function D(q, N, V) {
    return N && R(q.prototype, N), q;
  }
  function T(q, N, V) {
    return N in q ? Object.defineProperty(q, N, {
      value: V,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : q[N] = V, q;
  }
  function L() {
    return L = Object.assign || function(q) {
      for (var N = 1; N < arguments.length; N++) {
        var V = arguments[N];
        for (var ae in V)
          Object.prototype.hasOwnProperty.call(V, ae) && (q[ae] = V[ae]);
      }
      return q;
    }, L.apply(this, arguments);
  }
  function P(q, N) {
    if (typeof N != "function" && N !== null)
      throw new TypeError("Super expression must either be null or a function");
    q.prototype = Object.create(N && N.prototype, {
      constructor: {
        value: q,
        writable: !0,
        configurable: !0
      }
    }), N && k(q, N);
  }
  function M(q) {
    return M = Object.setPrototypeOf ? Object.getPrototypeOf : function(V) {
      return V.__proto__ || Object.getPrototypeOf(V);
    }, M(q);
  }
  function k(q, N) {
    return k = Object.setPrototypeOf || function(ae, pe) {
      return ae.__proto__ = pe, ae;
    }, k(q, N);
  }
  function H(q, N) {
    if (q == null) return {};
    var V = {}, ae = Object.keys(q), pe, it;
    for (it = 0; it < ae.length; it++)
      pe = ae[it], !(N.indexOf(pe) >= 0) && (V[pe] = q[pe]);
    return V;
  }
  function w(q, N) {
    if (q == null) return {};
    var V = H(q, N), ae, pe;
    if (Object.getOwnPropertySymbols) {
      var it = Object.getOwnPropertySymbols(q);
      for (pe = 0; pe < it.length; pe++)
        ae = it[pe], !(N.indexOf(ae) >= 0) && Object.prototype.propertyIsEnumerable.call(q, ae) && (V[ae] = q[ae]);
    }
    return V;
  }
  function $(q) {
    if (q === void 0)
      throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return q;
  }
  function B(q, N) {
    if (N && (typeof N == "object" || typeof N == "function"))
      return N;
    if (N !== void 0)
      throw new TypeError("Derived constructors may only return object or undefined");
    return $(q);
  }
  function Y(q, N) {
    return j(q) || ie(q, N) || se(q, N) || U();
  }
  function j(q) {
    if (Array.isArray(q)) return q;
  }
  function ie(q, N) {
    var V = q == null ? null : typeof Symbol != "undefined" && q[Symbol.iterator] || q["@@iterator"];
    if (V != null) {
      var ae = [], pe = !0, it = !1, xt, Nr;
      try {
        for (V = V.call(q); !(pe = (xt = V.next()).done) && (ae.push(xt.value), !(N && ae.length === N)); pe = !0)
          ;
      } catch (Xa) {
        it = !0, Nr = Xa;
      } finally {
        try {
          !pe && V.return != null && V.return();
        } finally {
          if (it) throw Nr;
        }
      }
      return ae;
    }
  }
  function se(q, N) {
    if (q) {
      if (typeof q == "string") return le(q, N);
      var V = Object.prototype.toString.call(q).slice(8, -1);
      if (V === "Object" && q.constructor && (V = q.constructor.name), V === "Map" || V === "Set") return Array.from(q);
      if (V === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(V)) return le(q, N);
    }
  }
  function le(q, N) {
    (N == null || N > q.length) && (N = q.length);
    for (var V = 0, ae = new Array(N); V < N; V++) ae[V] = q[V];
    return ae;
  }
  function U() {
    throw new TypeError(`Invalid attempt to destructure non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
  }
  var X = {
    Mobile: "mobile",
    Tablet: "tablet",
    SmartTv: "smarttv",
    Console: "console",
    Wearable: "wearable",
    Embedded: "embedded",
    Browser: void 0
  }, K = {
    Chrome: "Chrome",
    Firefox: "Firefox",
    Opera: "Opera",
    Yandex: "Yandex",
    Safari: "Safari",
    InternetExplorer: "Internet Explorer",
    Edge: "Edge",
    Chromium: "Chromium",
    Ie: "IE",
    MobileSafari: "Mobile Safari",
    EdgeChromium: "Edge Chromium",
    MIUI: "MIUI Browser",
    SamsungBrowser: "Samsung Browser"
  }, y = {
    IOS: "iOS",
    Android: "Android",
    WindowsPhone: "Windows Phone",
    Windows: "Windows",
    MAC_OS: "Mac OS"
  }, G = {
    isMobile: !1,
    isTablet: !1,
    isBrowser: !1,
    isSmartTV: !1,
    isConsole: !1,
    isWearable: !1
  }, ce = function(N) {
    switch (N) {
      case X.Mobile:
        return {
          isMobile: !0
        };
      case X.Tablet:
        return {
          isTablet: !0
        };
      case X.SmartTv:
        return {
          isSmartTV: !0
        };
      case X.Console:
        return {
          isConsole: !0
        };
      case X.Wearable:
        return {
          isWearable: !0
        };
      case X.Browser:
        return {
          isBrowser: !0
        };
      case X.Embedded:
        return {
          isEmbedded: !0
        };
      default:
        return G;
    }
  }, ue = function(N) {
    return C(N);
  }, ee = function(N) {
    var V = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "none";
    return N || V;
  }, ge = function() {
    return typeof window != "undefined" && (window.navigator || navigator) ? window.navigator || navigator : !1;
  }, Oe = function(N) {
    var V = ge();
    return V && V.platform && (V.platform.indexOf(N) !== -1 || V.platform === "MacIntel" && V.maxTouchPoints > 1 && !window.MSStream);
  }, Se = function(N, V, ae, pe, it) {
    return {
      isBrowser: N,
      browserMajorVersion: ee(V.major),
      browserFullVersion: ee(V.version),
      browserName: ee(V.name),
      engineName: ee(ae.name),
      engineVersion: ee(ae.version),
      osName: ee(pe.name),
      osVersion: ee(pe.version),
      userAgent: ee(it)
    };
  }, Ne = function(N, V, ae, pe) {
    return v({}, N, {
      vendor: ee(V.vendor),
      model: ee(V.model),
      os: ee(ae.name),
      osVersion: ee(ae.version),
      ua: ee(pe)
    });
  }, Le = function(N, V, ae, pe) {
    return {
      isSmartTV: N,
      engineName: ee(V.name),
      engineVersion: ee(V.version),
      osName: ee(ae.name),
      osVersion: ee(ae.version),
      userAgent: ee(pe)
    };
  }, ct = function(N, V, ae, pe) {
    return {
      isConsole: N,
      engineName: ee(V.name),
      engineVersion: ee(V.version),
      osName: ee(ae.name),
      osVersion: ee(ae.version),
      userAgent: ee(pe)
    };
  }, Ye = function(N, V, ae, pe) {
    return {
      isWearable: N,
      engineName: ee(V.name),
      engineVersion: ee(V.version),
      osName: ee(ae.name),
      osVersion: ee(ae.version),
      userAgent: ee(pe)
    };
  }, nt = function(N, V, ae, pe, it) {
    return {
      isEmbedded: N,
      vendor: ee(V.vendor),
      model: ee(V.model),
      engineName: ee(ae.name),
      engineVersion: ee(ae.version),
      osName: ee(pe.name),
      osVersion: ee(pe.version),
      userAgent: ee(it)
    };
  };
  function Ke(q) {
    var N = q ? E(q) : _, V = N.device, ae = N.browser, pe = N.engine, it = N.os, xt = N.ua, Nr = ce(V.type), Xa = Nr.isBrowser, Xo = Nr.isMobile, Qa = Nr.isTablet, Ja = Nr.isSmartTV, Qo = Nr.isConsole, Pn = Nr.isWearable, eo = Nr.isEmbedded;
    if (Xa)
      return Se(Xa, ae, pe, it, xt);
    if (Ja)
      return Le(Ja, pe, it, xt);
    if (Qo)
      return ct(Qo, pe, it, xt);
    if (Xo || Qa)
      return Ne(Nr, V, it, xt);
    if (Pn)
      return Ye(Pn, pe, it, xt);
    if (eo)
      return nt(eo, V, pe, it, xt);
  }
  var ot = function(N) {
    var V = N.type;
    return V === X.Mobile;
  }, St = function(N) {
    var V = N.type;
    return V === X.Tablet;
  }, dt = function(N) {
    var V = N.type;
    return V === X.Mobile || V === X.Tablet;
  }, Je = function(N) {
    var V = N.type;
    return V === X.SmartTv;
  }, je = function(N) {
    var V = N.type;
    return V === X.Browser;
  }, st = function(N) {
    var V = N.type;
    return V === X.Wearable;
  }, de = function(N) {
    var V = N.type;
    return V === X.Console;
  }, Te = function(N) {
    var V = N.type;
    return V === X.Embedded;
  }, Ue = function(N) {
    var V = N.vendor;
    return ee(V);
  }, Lt = function(N) {
    var V = N.model;
    return ee(V);
  }, Et = function(N) {
    var V = N.type;
    return ee(V, "browser");
  }, Re = function(N) {
    var V = N.name;
    return V === y.Android;
  }, ke = function(N) {
    var V = N.name;
    return V === y.Windows;
  }, $e = function(N) {
    var V = N.name;
    return V === y.MAC_OS;
  }, rt = function(N) {
    var V = N.name;
    return V === y.WindowsPhone;
  }, ht = function(N) {
    var V = N.name;
    return V === y.IOS;
  }, Ot = function(N) {
    var V = N.version;
    return ee(V);
  }, Xe = function(N) {
    var V = N.name;
    return ee(V);
  }, De = function(N) {
    var V = N.name;
    return V === K.Chrome;
  }, et = function(N) {
    var V = N.name;
    return V === K.Firefox;
  }, Pt = function(N) {
    var V = N.name;
    return V === K.Chromium;
  }, bt = function(N) {
    var V = N.name;
    return V === K.Edge;
  }, Or = function(N) {
    var V = N.name;
    return V === K.Yandex;
  }, Ie = function(N) {
    var V = N.name;
    return V === K.Safari || V === K.MobileSafari;
  }, Pe = function(N) {
    var V = N.name;
    return V === K.MobileSafari;
  }, ye = function(N) {
    var V = N.name;
    return V === K.Opera;
  }, we = function(N) {
    var V = N.name;
    return V === K.InternetExplorer || V === K.Ie;
  }, ze = function(N) {
    var V = N.name;
    return V === K.MIUI;
  }, ut = function(N) {
    var V = N.name;
    return V === K.SamsungBrowser;
  }, At = function(N) {
    var V = N.version;
    return ee(V);
  }, Nt = function(N) {
    var V = N.major;
    return ee(V);
  }, wt = function(N) {
    var V = N.name;
    return ee(V);
  }, Qt = function(N) {
    var V = N.name;
    return ee(V);
  }, vr = function(N) {
    var V = N.version;
    return ee(V);
  }, hi = function() {
    var N = ge(), V = N && N.userAgent && N.userAgent.toLowerCase();
    return typeof V == "string" ? /electron/.test(V) : !1;
  }, Fr = function(N) {
    return typeof N == "string" && N.indexOf("Edg/") !== -1;
  }, Xn = function() {
    var N = ge();
    return N && (/iPad|iPhone|iPod/.test(N.platform) || N.platform === "MacIntel" && N.maxTouchPoints > 1) && !window.MSStream;
  }, qt = function() {
    return Oe("iPad");
  }, xr = function() {
    return Oe("iPhone");
  }, Mn = function() {
    return Oe("iPod");
  }, Ur = function(N) {
    return ee(N);
  };
  function gr(q) {
    var N = q || _, V = N.device, ae = N.browser, pe = N.os, it = N.engine, xt = N.ua;
    return {
      isSmartTV: Je(V),
      isConsole: de(V),
      isWearable: st(V),
      isEmbedded: Te(V),
      isMobileSafari: Pe(ae) || qt(),
      isChromium: Pt(ae),
      isMobile: dt(V) || qt(),
      isMobileOnly: ot(V),
      isTablet: St(V) || qt(),
      isBrowser: je(V),
      isDesktop: je(V),
      isAndroid: Re(pe),
      isWinPhone: rt(pe),
      isIOS: ht(pe) || qt(),
      isChrome: De(ae),
      isFirefox: et(ae),
      isSafari: Ie(ae),
      isOpera: ye(ae),
      isIE: we(ae),
      osVersion: Ot(pe),
      osName: Xe(pe),
      fullBrowserVersion: At(ae),
      browserVersion: Nt(ae),
      browserName: wt(ae),
      mobileVendor: Ue(V),
      mobileModel: Lt(V),
      engineName: Qt(it),
      engineVersion: vr(it),
      getUA: Ur(xt),
      isEdge: bt(ae) || Fr(xt),
      isYandex: Or(ae),
      deviceType: Et(V),
      isIOS13: Xn(),
      isIPad13: qt(),
      isIPhone13: xr(),
      isIPod13: Mn(),
      isElectron: hi(),
      isEdgeChromium: Fr(xt),
      isLegacyEdge: bt(ae) && !Fr(xt),
      isWindows: ke(pe),
      isMacOs: $e(pe),
      isMIUI: ze(ae),
      isSamsungBrowser: ut(ae)
    };
  }
  var Qn = Je(f), bn = de(f), sr = st(f), yr = Te(f), mn = Pe(l) || qt(), ca = Pt(l), J = dt(f) || qt(), Ee = ot(f), ne = St(f) || qt(), z = je(f), fe = je(f), Qe = Re(u), Fe = rt(u), Ht = ht(u) || qt(), lt = De(l), ir = et(l), hr = Ie(l), _e = ye(l), Vt = we(l), rn = Ot(u), ki = Xe(u), mi = At(l), Br = Nt(l), ua = wt(l), nn = Ue(f), Rc = Lt(f), Ac = Qt(p), Tc = vr(p), qa = Ur(h), Wa = bt(l) || Fr(h), fa = Or(l), Ya = Et(f), Oc = Xn(), yc = qt(), zo = xr(), u2 = Mn(), qo = hi(), da = Fr(h), Nc = bt(l) && !Fr(h), Wo = ke(u), yt = $e(u), f2 = ze(l), d2 = ut(l), Yo = function(N) {
    if (!N || typeof N != "string") {
      console.error("No valid user agent string was provided");
      return;
    }
    var V = E(N), ae = V.device, pe = V.browser, it = V.os, xt = V.engine, Nr = V.ua;
    return gr({
      device: ae,
      browser: pe,
      os: it,
      engine: xt,
      ua: Nr
    });
  }, p2 = function(N) {
    var V = N.renderWithFragment, ae = N.children, pe = w(N, ["renderWithFragment", "children"]);
    return Qe ? V ? t.createElement(r.Fragment, null, ae) : t.createElement("div", pe, ae) : null;
  }, h2 = function(N) {
    var V = N.renderWithFragment, ae = N.children, pe = w(N, ["renderWithFragment", "children"]);
    return z ? V ? t.createElement(r.Fragment, null, ae) : t.createElement("div", pe, ae) : null;
  }, m2 = function(N) {
    var V = N.renderWithFragment, ae = N.children, pe = w(N, ["renderWithFragment", "children"]);
    return Vt ? V ? t.createElement(r.Fragment, null, ae) : t.createElement("div", pe, ae) : null;
  }, Ko = function(N) {
    var V = N.renderWithFragment, ae = N.children, pe = w(N, ["renderWithFragment", "children"]);
    return Ht ? V ? t.createElement(r.Fragment, null, ae) : t.createElement("div", pe, ae) : null;
  }, Ka = function(N) {
    var V = N.renderWithFragment, ae = N.children, pe = w(N, ["renderWithFragment", "children"]);
    return J ? V ? t.createElement(r.Fragment, null, ae) : t.createElement("div", pe, ae) : null;
  }, Jn = function(N) {
    var V = N.renderWithFragment, ae = N.children, pe = w(N, ["renderWithFragment", "children"]);
    return ne ? V ? t.createElement(r.Fragment, null, ae) : t.createElement("div", pe, ae) : null;
  }, ei = function(N) {
    var V = N.renderWithFragment, ae = N.children, pe = w(N, ["renderWithFragment", "children"]);
    return Fe ? V ? t.createElement(r.Fragment, null, ae) : t.createElement("div", pe, ae) : null;
  }, ti = function(N) {
    var V = N.renderWithFragment, ae = N.children;
    N.viewClassName, N.style;
    var pe = w(N, ["renderWithFragment", "children", "viewClassName", "style"]);
    return Ee ? V ? t.createElement(r.Fragment, null, ae) : t.createElement("div", pe, ae) : null;
  }, pa = function(N) {
    var V = N.renderWithFragment, ae = N.children, pe = w(N, ["renderWithFragment", "children"]);
    return Qn ? V ? t.createElement(r.Fragment, null, ae) : t.createElement("div", pe, ae) : null;
  }, ha = function(N) {
    var V = N.renderWithFragment, ae = N.children, pe = w(N, ["renderWithFragment", "children"]);
    return bn ? V ? t.createElement(r.Fragment, null, ae) : t.createElement("div", pe, ae) : null;
  }, ri = function(N) {
    var V = N.renderWithFragment, ae = N.children, pe = w(N, ["renderWithFragment", "children"]);
    return sr ? V ? t.createElement(r.Fragment, null, ae) : t.createElement("div", pe, ae) : null;
  }, Lc = function(N) {
    var V = N.renderWithFragment, ae = N.children;
    N.viewClassName, N.style;
    var pe = N.condition, it = w(N, ["renderWithFragment", "children", "viewClassName", "style", "condition"]);
    return pe ? V ? t.createElement(r.Fragment, null, ae) : t.createElement("div", it, ae) : null;
  };
  function _2(q) {
    return /* @__PURE__ */ function(N) {
      P(V, N);
      function V(ae) {
        var pe;
        return O(this, V), pe = B(this, M(V).call(this, ae)), pe.isEventListenerAdded = !1, pe.handleOrientationChange = pe.handleOrientationChange.bind($(pe)), pe.onOrientationChange = pe.onOrientationChange.bind($(pe)), pe.onPageLoad = pe.onPageLoad.bind($(pe)), pe.state = {
          isLandscape: !1,
          isPortrait: !1
        }, pe;
      }
      return D(V, [{
        key: "handleOrientationChange",
        value: function() {
          this.isEventListenerAdded || (this.isEventListenerAdded = !0);
          var pe = window.innerWidth > window.innerHeight ? 90 : 0;
          this.setState({
            isPortrait: pe === 0,
            isLandscape: pe === 90
          });
        }
      }, {
        key: "onOrientationChange",
        value: function() {
          this.handleOrientationChange();
        }
      }, {
        key: "onPageLoad",
        value: function() {
          this.handleOrientationChange();
        }
      }, {
        key: "componentDidMount",
        value: function() {
          (typeof window == "undefined" ? "undefined" : g(window)) !== void 0 && J && (this.isEventListenerAdded ? window.removeEventListener("load", this.onPageLoad, !1) : (this.handleOrientationChange(), window.addEventListener("load", this.onPageLoad, !1)), window.addEventListener("resize", this.onOrientationChange, !1));
        }
      }, {
        key: "componentWillUnmount",
        value: function() {
          window.removeEventListener("resize", this.onOrientationChange, !1);
        }
      }, {
        key: "render",
        value: function() {
          return t.createElement(q, L({}, this.props, {
            isLandscape: this.state.isLandscape,
            isPortrait: this.state.isPortrait
          }));
        }
      }]), V;
    }(t.Component);
  }
  function ma() {
    var q = r.useState(function() {
      var it = window.innerWidth > window.innerHeight ? 90 : 0;
      return {
        isPortrait: it === 0,
        isLandscape: it === 90,
        orientation: it === 0 ? "portrait" : "landscape"
      };
    }), N = Y(q, 2), V = N[0], ae = N[1], pe = r.useCallback(function() {
      var it = window.innerWidth > window.innerHeight ? 90 : 0, xt = {
        isPortrait: it === 0,
        isLandscape: it === 90,
        orientation: it === 0 ? "portrait" : "landscape"
      };
      V.orientation !== xt.orientation && ae(xt);
    }, [V.orientation]);
    return r.useEffect(function() {
      return (typeof window == "undefined" ? "undefined" : g(window)) !== void 0 && J && (pe(), window.addEventListener("load", pe, !1), window.addEventListener("resize", pe, !1)), function() {
        window.removeEventListener("resize", pe, !1), window.removeEventListener("load", pe, !1);
      };
    }, [pe]), V;
  }
  function E2(q) {
    var N = q || window.navigator.userAgent;
    return E(N);
  }
  function C2(q) {
    var N = q || window.navigator.userAgent, V = E2(N), ae = gr(V);
    return [ae, V];
  }
  return Ve.AndroidView = p2, Ve.BrowserTypes = K, Ve.BrowserView = h2, Ve.ConsoleView = ha, Ve.CustomView = Lc, Ve.IEView = m2, Ve.IOSView = Ko, Ve.MobileOnlyView = ti, Ve.MobileView = Ka, Ve.OsTypes = y, Ve.SmartTVView = pa, Ve.TabletView = Jn, Ve.WearableView = ri, Ve.WinPhoneView = ei, Ve.browserName = ua, Ve.browserVersion = Br, Ve.deviceDetect = Ke, Ve.deviceType = Ya, Ve.engineName = Ac, Ve.engineVersion = Tc, Ve.fullBrowserVersion = mi, Ve.getSelectorsByUserAgent = Yo, Ve.getUA = qa, Ve.isAndroid = Qe, Ve.isBrowser = z, Ve.isChrome = lt, Ve.isChromium = ca, Ve.isConsole = bn, Ve.isDesktop = fe, Ve.isEdge = Wa, Ve.isEdgeChromium = da, Ve.isElectron = qo, Ve.isEmbedded = yr, Ve.isFirefox = ir, Ve.isIE = Vt, Ve.isIOS = Ht, Ve.isIOS13 = Oc, Ve.isIPad13 = yc, Ve.isIPhone13 = zo, Ve.isIPod13 = u2, Ve.isLegacyEdge = Nc, Ve.isMIUI = f2, Ve.isMacOs = yt, Ve.isMobile = J, Ve.isMobileOnly = Ee, Ve.isMobileSafari = mn, Ve.isOpera = _e, Ve.isSafari = hr, Ve.isSamsungBrowser = d2, Ve.isSmartTV = Qn, Ve.isTablet = ne, Ve.isWearable = sr, Ve.isWinPhone = Fe, Ve.isWindows = Wo, Ve.isYandex = fa, Ve.mobileModel = Rc, Ve.mobileVendor = nn, Ve.osName = ki, Ve.osVersion = rn, Ve.parseUserAgent = E, Ve.setUserAgent = ue, Ve.useDeviceData = E2, Ve.useDeviceSelectors = C2, Ve.useMobileOrientation = ma, Ve.withOrientationChange = _2, Ve;
}
var Kt = cy();
const Tr = [];
for (let e = 0; e < 256; ++e)
  Tr.push((e + 256).toString(16).slice(1));
function uy(e, r = 0) {
  return (Tr[e[r + 0]] + Tr[e[r + 1]] + Tr[e[r + 2]] + Tr[e[r + 3]] + "-" + Tr[e[r + 4]] + Tr[e[r + 5]] + "-" + Tr[e[r + 6]] + Tr[e[r + 7]] + "-" + Tr[e[r + 8]] + Tr[e[r + 9]] + "-" + Tr[e[r + 10]] + Tr[e[r + 11]] + Tr[e[r + 12]] + Tr[e[r + 13]] + Tr[e[r + 14]] + Tr[e[r + 15]]).toLowerCase();
}
let Nf;
const fy = new Uint8Array(16);
function dy() {
  if (!Nf) {
    if (typeof crypto == "undefined" || !crypto.getRandomValues)
      throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
    Nf = crypto.getRandomValues.bind(crypto);
  }
  return Nf(fy);
}
const py = typeof crypto != "undefined" && crypto.randomUUID && crypto.randomUUID.bind(crypto), rS = { randomUUID: py };
function hy(e, r, t) {
  var o, l, c;
  e = e || {};
  const a = (c = (l = e.random) != null ? l : (o = e.rng) == null ? void 0 : o.call(e)) != null ? c : dy();
  if (a.length < 16)
    throw new Error("Random bytes length must be >= 16");
  return a[6] = a[6] & 15 | 64, a[8] = a[8] & 63 | 128, uy(a);
}
function _p(e, r, t) {
  return rS.randomUUID && !e ? rS.randomUUID() : hy(e);
}
const x8 = (e) => {
  switch (e) {
    case "":
    case "true":
      return !0;
    case "false":
      return !1;
    case null:
    default:
      return;
  }
};
function U8() {
  for (var e = arguments.length, r = new Array(e), t = 0; t < e; t++)
    r[t] = arguments[t];
  const a = [...r];
  return a.length === 0 ? function(o) {
    return o;
  } : a.length === 1 ? a[0] : a.reduce(function(o, l) {
    return function() {
      return o(l(...arguments));
    };
  });
}
function nS(e, r, t, a, o, l, c, f, p) {
  const u = e / r, h = t / a, E = (p === Gl.contain ? h < u : h > u) ? e / t : r / a, _ = (e / E - t) / 2, S = (r / E - a) / 2, v = Math.round(o / E), g = Math.round(l / E), O = Math.round(c / E - _), R = Math.round(t - (O + v)), D = Math.round(f / E - S);
  return {
    width: v,
    height: g,
    left: O,
    right: R,
    top: D
  };
}
function B8(e, r) {
  return new CustomEvent(e, {
    bubbles: !0,
    composed: !0,
    detail: r
  });
}
function $8() {
  return Ae(this, null, function* () {
    const r = (yield navigator.mediaDevices.enumerateDevices()).filter((a) => a.kind === "videoinput"), t = r.every((a) => a.label !== "");
    return {
      videoDevices: r,
      isCameraAllowed: t
    };
  });
}
function my(e, r) {
  const t = e.toLowerCase();
  return r.some((a) => t.includes(a));
}
function G8(e) {
  return Ae(this, null, function* () {
    const r = {
      frontCameras: [],
      backCameras: []
    };
    let t = e.videoDevices;
    if (!e.isCameraAllowed) {
      const a = yield navigator.mediaDevices.getUserMedia({
        video: !0,
        audio: !1
      });
      t = (yield navigator.mediaDevices.enumerateDevices()).filter((l) => l.kind === "videoinput"), a.getTracks().forEach((l) => l.stop());
    }
    for (const a of t)
      my(a.label, gO) ? r.backCameras.push(new JC(a, hn.environment)) : r.frontCameras.push(new JC(a, hn.user));
    return r;
  });
}
function Z8(e, r, t) {
  const a = [...r.frontCameras, ...r.backCameras];
  if (!a.length)
    return {
      deviceId: "",
      facing: void 0,
      groupId: "",
      label: ""
    };
  if (t)
    return a.find((l) => l.deviceId === t) || {
      deviceId: "",
      facing: void 0,
      groupId: "",
      label: ""
    };
  if (e === hn.environment && r.backCameras.length) {
    const l = r.backCameras.map((c) => {
      const f = /\b([0-9]+)MP?\b/i, p = c.label.match(f);
      return p !== null ? parseInt(p[1], 10) : NaN;
    });
    if (l.every((c) => !isNaN(c))) {
      const c = l.lastIndexOf(Math.max(...l));
      return r.backCameras[c];
    } else
      return Kt.isIOS ? {
        deviceId: "",
        facing: hn.environment,
        groupId: "",
        label: ""
      } : r.backCameras.sort((c, f) => c.label.localeCompare(f.label))[0];
  } else
    return {
      deviceId: "",
      facing: hn.user,
      groupId: "",
      label: ""
    };
}
const Ep = (e) => {
  e.getTracks().forEach((r) => r.stop());
};
function j8(e, r, t) {
  return Ae(this, null, function* () {
    const a = {
      status: Ft.PREPARING,
      stream: null,
      camera: {
        deviceId: "",
        facing: void 0,
        groupId: "",
        label: ""
      }
    };
    if (navigator.mediaDevices) {
      if (!r.deviceId && !r.facing)
        return t ? (a.status = Ft.INCORRECT_CAMERA_ID, a) : (a.status = Ft.NO_CAMERA, a);
      const o = {
        height: {
          ideal: e.height > V7 ? ui.FULL_HD.height : e.height
        },
        width: {
          ideal: e.width > V7 ? ui.FULL_HD.width : e.width
        },
        frameRate: {
          ideal: 30
        }
      };
      r.deviceId ? o.deviceId = {
        exact: r.deviceId
      } : o.facingMode = {
        ideal: r.facing
      };
      const l = yield navigator.mediaDevices.getUserMedia({
        video: o,
        audio: !1
      }), c = l.getVideoTracks()[0], {
        deviceId: f,
        groupId: p,
        facingMode: u
      } = c.getSettings(), h = {
        deviceId: f || r.deviceId,
        label: c.label || r.label,
        groupId: p || r.groupId,
        facing: u || r.facing
      };
      return {
        status: Ft.READY,
        stream: l,
        camera: h
      };
    } else
      return a.status = Ft.NOT_SUPPORTED, a;
  });
}
function cc(e, r) {
  const t = {
    imageData: [],
    raw: "",
    mimeType: ""
  }, {
    videoHeight: a,
    videoWidth: o,
    readyState: l
  } = e;
  if (a && o && l === O8.HAVE_ENOUGH_DATA) {
    const c = document.createElement("canvas");
    c.width = o, c.height = a;
    const f = c.getContext("2d", {
      willReadFrequently: !0
    });
    if (f == null || f.drawImage(e, 0, 0), r !== Ha.UINT) {
      const p = "image/jpeg";
      t.raw = c.toDataURL(p, 0.8).replace("data:".concat(p, ";base64,"), ""), t.mimeType = p;
    }
    if (r !== Ha.BASE64) {
      const p = f == null ? void 0 : f.getImageData(0, 0, o, a);
      p && (t.imageData = [p]);
    }
  }
  return t;
}
function Eh(e, r) {
  const t = [...e.frontCameras, ...e.backCameras], o = (t.findIndex((l) => l.deviceId === r) + 1) % t.length;
  return t[o].deviceId;
}
function Zr(e, r) {
  const t = (o) => o !== null && typeof o == "object" && !Array.isArray(o), a = Object.assign({}, e);
  if (t(e) && t(r))
    for (const o of Object.keys(r)) {
      const l = e[o], c = r[o];
      t(c) ? l === void 0 ? a[o] = c : a[o] = Zr(l, c) : a[o] = c;
    }
  return a;
}
function z8(e) {
  return Ae(this, null, function* () {
    return new Promise((r) => setTimeout(r, e));
  });
}
const q8 = (e) => {
  let r;
  try {
    var t;
    r = (t = window.localStorage.getItem(e)) !== null && t !== void 0 ? t : _p(), window.localStorage.setItem(e, r);
  } catch (a) {
    r = _p();
  }
  return r;
}, _y = () => ["localhost", "127.0.0.1", "", "::1"].includes(window.location.hostname), Ey = () => !_y() && window.location.protocol === "http:", Cy = () => {
  if (typeof window == "undefined") return "SERVER_SIDE_RENDERING";
  if (!document.referrer) return window.location.origin;
  try {
    return new URL(document.referrer).origin;
  } catch (e) {
    return window.location.origin;
  }
}, W8 = (e, r, t, a, o) => {
  const l = e.map((f) => ({
    cameraID: f.deviceId,
    label: f.label,
    groupId: f.groupId,
    facing: f.facing === hn.user ? "front" : "back"
  }));
  return {
    platform: "Web",
    osVersion: "".concat(Kt.osVersion),
    sdkVersion: t,
    hostAppId: Cy(),
    serviceUrl: a,
    userID: q8(M8),
    deviceModel: "".concat(Kt.osName, "/").concat(Kt.osVersion, " ").concat(Kt.browserName, "/").concat(Kt.fullBrowserVersion),
    hostAppVersion: "".concat(Kt.browserName, "/").concat(Kt.fullBrowserVersion),
    currentCameraInfo: {
      cameraID: r
    },
    cameraState: l
  };
};
var oe = Ks();
const _t = /* @__PURE__ */ Zs(oe);
function Os(e, r, t) {
  return (r = Sy(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Sy(e) {
  var r = Iy(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function Iy(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class vy {
  constructor() {
    Os(this, "_levels", []), Os(this, "_transports", []), Os(this, "_logs", []), Os(this, "_prevTime", 0), Os(this, "logListener", null);
    try {
      if (!window.localStorage) return;
      const r = window.localStorage.getItem("logger");
      if (!r) return;
      const [t, a] = r.split(">");
      this._levels = t.split(","), a && (this._transports = a.split(","));
    } catch (r) {
      return;
    }
  }
  create(r, t) {
    return (a) => {
      if (!this._levels.includes(r) && !this._levels.includes("all") && !this.logListener) return;
      const o = Date.now();
      let l = 0;
      if (this._prevTime && (l = o - this._prevTime), this._prevTime = o, this.logListener && this.logListener("".concat(r, ": ").concat(a, " +").concat(l, "ms")), this._transports.includes("console")) {
        const c = (t == null ? void 0 : t.color) || "blue";
        console.log("%c%s: %c%s %c+%dms", "color: ".concat(c, ";"), r, "", a, "color: ".concat(c, ";"), l);
      }
      this._transports.includes("file") && this._logs.push("".concat(r, ": ").concat(a, " +").concat(l, "ms"));
    };
  }
  saveLogs() {
    if (!this._logs.length) return;
    const r = this._logs.join(`
`), t = new Blob([r], {
      type: "text/plain"
    }), a = window.URL.createObjectURL(t), o = document.createElement("a");
    o.download = "log.txt", o.href = a, o.click(), window.URL.revokeObjectURL(a), this._logs = [];
  }
}
const jr = new vy();
function iS(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    r && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function gn(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? iS(Object(t), !0).forEach(function(a) {
      gy(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : iS(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function gy(e, r, t) {
  return (r = Dy(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Dy(e) {
  var r = Ry(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function Ry(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const Na = jr.create("main");
function Ay() {
  let e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : hn.environment, r = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ui.VGA, t = arguments.length > 2 ? arguments[2] : void 0;
  const [{
    status: a,
    stream: o,
    camera: l
  }, c] = oe.useState({
    status: Ft.PREPARING,
    stream: null,
    camera: {
      deviceId: "",
      facing: void 0,
      groupId: "",
      label: ""
    }
  }), [f, p] = oe.useState(null), [u, h] = oe.useState(null), C = oe.useRef(""), E = oe.useCallback(() => {
    c((_) => gn(gn({}, _), {}, {
      status: Ft.PLAY
    }));
  }, []);
  return oe.useEffect(() => {
    let _ = !0;
    return $8().then((S) => {
      Na("Video devices: ".concat(JSON.stringify(S))), _ && (Na(S.isCameraAllowed ? "Preparing the camera" : "Requesting the camera"), c((v) => gn(gn({}, v), {}, {
        status: S.isCameraAllowed ? Ft.PREPARING : Ft.REQUESTING
      })), p(S));
    }).catch((S) => {
      Na("Error in receiving media devices: ".concat(S)), _ && c((v) => gn(gn({}, v), {}, {
        status: Ey() ? Ft.HTTP_NOT_SUPPORTED : window.isSecureContext ? Ft.NOT_SUPPORTED : Ft.INSECURE_PAGE_CONTEXT
      }));
    }), () => {
      _ = !1;
    };
  }, []), oe.useEffect(() => {
    let _ = !0;
    if (!(!f || u))
      return G8(f).then((S) => {
        Na("Sorted cameras: ".concat(JSON.stringify(S))), _ && h(S);
      }).catch((S) => {
        if (Na("Error sorting cameras: ".concat(S)), !!_) {
          if (S instanceof Error && S.name === y8)
            return c((v) => gn(gn({}, v), {}, {
              status: Ft.PERMISSION_DENIED
            }));
          c((v) => gn(gn({}, v), {}, {
            status: Ft.UNKNOWN_ERROR
          }));
        }
      }), () => {
        _ = !1;
      };
  }, [f]), oe.useEffect(() => {
    let _ = !0;
    const S = a === Ft.PREPARING || a === Ft.REQUESTING;
    return !u || !S ? void 0 : (Ae(null, null, function* () {
      try {
        const g = Kt.isFirefox ? N8 : 0;
        yield z8(g);
        const O = Z8(e, u, t), R = yield j8(r, O, t);
        if (Na("Selected camera: ".concat(JSON.stringify(O))), _)
          C.current = R.camera.deviceId, c(R);
        else {
          if (!R.stream) return;
          Ep(R.stream);
        }
      } catch (g) {
        if (Na("Get video error: ".concat(g)), !_) return;
        c((O) => gn(gn({}, O), {}, {
          status: Ft.UNKNOWN_ERROR
        }));
      }
    }), () => {
      _ = !1;
    });
  }, [u, e, t, a, r.width, r.height]), oe.useEffect(() => () => {
    o && Ep(o);
  }, [o]), oe.useEffect(() => {
    if (!t || !C.current) return;
    const _ = t !== C.current;
    a !== Ft.PLAY || !_ || c({
      status: Ft.PREPARING,
      stream: null,
      camera: {
        deviceId: "",
        facing: void 0,
        groupId: "",
        label: ""
      }
    });
  }, [t, a]), {
    status: a,
    stream: o,
    camera: l,
    sortedDevices: u,
    onPlay: E
  };
}
const Ty = "_container_1mtmn_1", Oy = "_video_1mtmn_7", aS = {
  container: Ty,
  video: Oy
};
function Un(e, r, t) {
  return (r = yy(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function yy(e) {
  var r = Ny(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function Ny(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const Ro = jr.create("main");
class Ly {
  constructor() {
    Un(this, "chunks", []), Un(this, "recorder", null), Un(
      this,
      "mimeType",
      "video/webm"
      /* WEBM */
    ), Un(this, "record", null), Un(this, "delayTimeout", null), Un(this, "durationTimeout", null), Un(this, "isRecording", !1), Un(this, "debug", !1), Un(this, "delay", 0), Un(this, "bitrate", 12e5), Un(this, "duration", void 0);
  }
  init(r) {
    if (!("MediaRecorder" in window)) {
      Ro("MediaRecorder is missing");
      return;
    }
    this.mimeType = MediaRecorder.isTypeSupported(
      "video/webm"
      /* WEBM */
    ) ? "video/webm" : "video/mp4;codecs=avc1", this.recorder = new MediaRecorder(r, {
      mimeType: this.mimeType,
      videoBitsPerSecond: this.bitrate
    }), this.recorder.addEventListener("dataavailable", this.setChunk.bind(this)), this.recorder.addEventListener("error", this.errorHandle.bind(this)), this.delay ? this.delayTimeout = setTimeout(() => {
      this.delayTimeout = null, this.startRecording();
    }, this.delay) : this.startRecording(), this.duration && (this.durationTimeout = setTimeout(() => Ae(this, null, function* () {
      this.durationTimeout = null, this.record = yield this.getRecord();
    }), this.delay + this.duration)), Ro("MediaRecorder initialized: { duration: ".concat(this.duration, ", delay: ").concat(this.delay, ", mimeType: ").concat(this.mimeType, " }"));
  }
  startRecording() {
    this.recorder && (this.recorder.start(), this.isRecording = !0, Ro("Recording has started"));
  }
  clearTimeouts() {
    this.delayTimeout && clearTimeout(this.delayTimeout), this.durationTimeout && clearTimeout(this.durationTimeout);
  }
  getRecord() {
    return Ae(this, null, function* () {
      if (this.record) {
        const r = this.record;
        return this.record = null, r;
      }
      return !this.recorder || this.recorder.state === "inactive" ? null : (this.stopRecord(), new Promise((r) => {
        if (!this.recorder)
          return r(null);
        this.recorder.onstop = () => Ae(this, null, function* () {
          const t = yield this.getVideoData();
          Ro("Video record resolved"), r(t);
        });
      }));
    });
  }
  stopRecord() {
    var r, t, a;
    if (!this.recorder || this.recorder.state === "inactive") {
      this.clearTimeouts();
      return;
    }
    (r = this.recorder) === null || r === void 0 || r.stop(), (t = this.recorder) === null || t === void 0 || t.removeEventListener("dataavailable", this.setChunk), (a = this.recorder) === null || a === void 0 || a.removeEventListener("error", this.errorHandle), this.clearTimeouts(), this.isRecording = !1, Ro("Recording stopped");
  }
  errorHandle(r) {
    Ro("Stream recorder service error: ".concat(JSON.stringify(r)));
  }
  setChunk(r) {
    this.chunks.push(r.data);
  }
  getVideoData() {
    return Ae(this, null, function* () {
      const r = new Blob(this.chunks, {
        type: this.mimeType
      });
      if (this.debug) {
        const t = document.createElement("a"), a = URL.createObjectURL(r);
        t.href = a, t.download = "video", t.click(), URL.revokeObjectURL(a);
      }
      return new Promise((t) => {
        t({
          data: r,
          mimeType: r.type
        });
      });
    });
  }
}
const Y8 = oe.forwardRef(function(r, t) {
  let {
    onVideoStatusChange: a,
    onVideoSizeChange: o,
    mode: l,
    resolution: c,
    onFailStatus: f,
    cameraId: p,
    onRecordService: u,
    videoRecord: h,
    onVideoStarted: C,
    onVideoStopped: E,
    onMirroringChange: _,
    mirrorType: S = mp.mirror
  } = r;
  const {
    status: v,
    stream: g,
    camera: O,
    sortedDevices: R,
    onPlay: D
  } = Ay(l, c, p), [T, L] = oe.useState(!1), P = oe.useRef(null), M = oe.useRef(null), k = oe.useRef(null), H = () => {
    D(), C == null || C();
  };
  return oe.useEffect(() => {
    L(O.facing === hn.user && S === mp.mirror);
  }, [O.facing, S]), oe.useEffect(() => {
    _ == null || _(T);
  }, [T]), oe.useImperativeHandle(t, () => ({
    changeMirror: () => {
      L((w) => !w);
    }
  })), oe.useEffect(() => {
    const w = M.current, $ = k.current, B = () => {
      !w || !$ || o == null || o({
        videoElement: w,
        videoParams: {
          width: w.videoWidth,
          height: w.videoHeight
        },
        videoContainerParams: {
          width: $.clientWidth,
          height: $.clientHeight
        }
      });
    };
    return w && (window.addEventListener("resize", B), w.addEventListener("resize", B)), () => {
      var Y;
      w && (window.removeEventListener("resize", B), w.removeEventListener("resize", B)), (Y = P.current) === null || Y === void 0 || Y.stopRecord();
    };
  }, []), oe.useEffect(() => {
    const w = M.current;
    if (v === Ft.READY && w && g && (w.srcObject = g, Kt.isIOS ? setTimeout(() => w.play(), vO) : w.play(), h)) {
      if (P.current) {
        var j;
        (j = P.current) === null || j === void 0 || j.stopRecord();
      } else {
        const se = new Ly();
        if (typeof h != "boolean") {
          var B, Y;
          se.delay = (B = h.delay) !== null && B !== void 0 ? B : se.delay, se.duration = h.duration, se.bitrate = (Y = h.bitrate) !== null && Y !== void 0 ? Y : se.bitrate, se.debug = !!h.debug;
        }
        P.current = se, u == null || u(se);
      }
      P.current.init(g);
    }
    const ie = L8[v];
    f && ie && f(ie), a({
      videoStatus: v,
      camera: O,
      sortedDevices: R
    });
  }, [v, O, g, R, h]), /* @__PURE__ */ Z.jsx("div", { part: "webcamera-container", ref: k, className: aS.container, children: /* @__PURE__ */ Z.jsx("video", { part: "webcamera-video", onAbort: E, onLoadedData: H, className: aS.video, style: {
    transform: "scaleX(".concat(T ? -1 : 1, ")")
  }, ref: M, playsInline: !0, disablePictureInPicture: !0 }) });
});
function My(e) {
  switch (e) {
    case at.SHAKING:
      return {
        icon: "processing-error-icon",
        title: "keepDeviceStill"
      };
    case at.FINDING:
      return {
        icon: "search-icon",
        title: "placeDocumentIntoFrame"
      };
    case at.SNAPSHOT:
      return {
        icon: "square-icon",
        title: "positionDocumentCenter"
      };
    case at.FOCUS:
      return {
        icon: "processing-error-icon",
        title: "noFocus"
      };
    case at.RESOLUTION:
      return {
        icon: "processing-error-icon",
        title: "moveCloser"
      };
    case at.GLARE:
      return {
        icon: "processing-error-icon",
        title: "glaresOnDocument"
      };
    case at.HOLD:
      return {
        icon: "processing-error-icon",
        title: "holdDocumentStraight"
      };
    case at.START_NEXT_PAGE:
      return {
        icon: "search-icon",
        title: "flipTheDocument"
      };
    case at.LIVENESS:
      return {
        icon: "search-icon",
        title: "tiltTheDocument"
      };
    default:
      return {
        icon: null,
        title: null
      };
  }
}
const by = "_svg_68emc_1", Py = {
  svg: by
}, wy = jr.create("main"), K8 = oe.createContext({
  onEvent: () => wy('Function "onEvent" not defined.')
}), nr = () => oe.useContext(K8);
function Hy(e) {
  let {
    maskParams: r,
    borderColor: t,
    strokeWidth: a,
    adjustment: o
  } = e;
  const {
    cameraFrameShapeType: l = Mo.line,
    cameraFrameLineCap: c = v8.butt,
    cameraFrameLineLength: f = nO,
    cameraFrameCornerRadius: p = dh
  } = nr(), [u, h] = oe.useState(null);
  return oe.useLayoutEffect(() => {
    if (l !== Mo.corners) return;
    const C = r.width / 100 * f, E = p + a / 2 + o, _ = a / 2, S = r.left + r.width - C - E + _ + o, v = r.top - _ - o, g = r.left + r.width + _ + o, O = r.top + r.height - C - E + _ + o, R = r.left + C + E - _ - o, D = r.top + r.height + _ + o, T = r.left - _ - o, L = r.top + C + E - _ - o;
    h({
      topRight: {
        x: S,
        y: v
      },
      bottomRight: {
        x: g,
        y: O
      },
      bottomLeft: {
        x: R,
        y: D
      },
      topLeft: {
        x: T,
        y: L
      },
      pathWidth: C,
      radius: E
    });
  }, [l, r, f, p, o, a]), u ? /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
    /* @__PURE__ */ Z.jsx("path", { d: "M".concat(u.topRight.x, ",").concat(u.topRight.y, " h").concat(u.pathWidth, " a").concat(u.radius, ",").concat(u.radius, " 0 0 1 ").concat(u.radius, ",").concat(u.radius, " v").concat(u.pathWidth), fill: "none", stroke: t, strokeWidth: a, strokeLinecap: c, part: "frame-top-right-corner" }),
    /* @__PURE__ */ Z.jsx("path", { d: "M".concat(u.bottomRight.x, ",").concat(u.bottomRight.y, " v").concat(u.pathWidth, " a").concat(u.radius, ",").concat(u.radius, " 0 0 1 ").concat(-u.radius, ",").concat(u.radius, " h-").concat(u.pathWidth), fill: "none", stroke: t, strokeWidth: a, strokeLinecap: c, part: "frame-bottom-right-corner" }),
    /* @__PURE__ */ Z.jsx("path", { d: "M".concat(u.bottomLeft.x, ",").concat(u.bottomLeft.y, " h-").concat(u.pathWidth, " a").concat(u.radius, ",").concat(u.radius, " 0 0 1 ").concat(-u.radius, ",").concat(-u.radius, " v-").concat(u.pathWidth), fill: "none", stroke: t, strokeWidth: a, strokeLinecap: c, part: "frame-bottom-left-corner" }),
    /* @__PURE__ */ Z.jsx("path", { d: "M".concat(u.topLeft.x, ",").concat(u.topLeft.y, " v-").concat(u.pathWidth, " a").concat(u.radius, ",").concat(-u.radius, " 0 0 1 ").concat(u.radius, ",").concat(-u.radius, " h").concat(u.pathWidth), fill: "none", stroke: t, strokeWidth: a, strokeLinecap: c, part: "frame-top-left-corner" })
  ] }) : null;
}
function Vy(e) {
  let {
    maskParams: r,
    strokeWidth: t,
    adjustment: a,
    borderColor: o
  } = e;
  const {
    cameraFrameCornerRadius: l = dh
  } = nr(), c = r.left - t / 2 - a, f = r.top - t / 2 - a, p = l + t / 2 + a, u = r.width + t + a * 2, h = r.height + t + a * 2;
  return /* @__PURE__ */ Z.jsx("rect", { x: c, y: f, rx: p, ry: p, width: u, height: h, fill: "none", stroke: o, strokeWidth: t, part: "frame-line" });
}
function ky(e) {
  let {
    layoutParams: r,
    maskParams: t,
    isDocumentAvailable: a
  } = e;
  const {
    cameraFrameShapeType: o = Mo.line,
    cameraFrameCornerRadius: l = dh,
    cameraFrameActiveColor: c,
    cameraFrameDefaultColor: f,
    newLayout: p
  } = nr(), u = a ? c != null ? c : p ? sO : oO : f != null ? f : p ? aO : iO, h = p ? a ? 0 : H7 : 0, C = t.stroke || 0, E = p && a ? C + H7 : C;
  return /* @__PURE__ */ Z.jsxs("svg", { part: "frame", className: Py.svg, xmlns: "http://www.w3.org/2000/svg", preserveAspectRatio: "xMidYMid slice", viewBox: "0 0 ".concat(r.width, " ").concat(r.height), role: "img", "aria-label": "Document frame", children: [
    /* @__PURE__ */ Z.jsx("defs", { children: /* @__PURE__ */ Z.jsxs("mask", { id: "bgClip", children: [
      /* @__PURE__ */ Z.jsx("rect", { x: "0", y: "0", width: r.width, height: r.height, fill: "#fff", part: "frame-mask-background" }),
      /* @__PURE__ */ Z.jsx("rect", { x: t.left, y: t.top, rx: l, ry: l, width: t.width, height: t.height, stroke: "black", part: "frame-mask-background-clip" })
    ] }) }),
    /* @__PURE__ */ Z.jsx("rect", { mask: "url(#bgClip)", x: "0", y: "0", width: r.width, height: r.height, part: "frame-external-background" }),
    o === Mo.line && /* @__PURE__ */ Z.jsx(Vy, { maskParams: t, borderColor: u, strokeWidth: E, adjustment: h }),
    o === Mo.corners && /* @__PURE__ */ Z.jsx(Hy, { maskParams: t, borderColor: u, strokeWidth: E, adjustment: h })
  ] });
}
function Cp() {
  return Cp = Object.assign ? Object.assign.bind() : function(e) {
    for (var r = 1; r < arguments.length; r++) {
      var t = arguments[r];
      for (var a in t) ({}).hasOwnProperty.call(t, a) && (e[a] = t[a]);
    }
    return e;
  }, Cp.apply(null, arguments);
}
function X8(e, r) {
  if (e == null) return {};
  var t = {};
  for (var a in e) if ({}.hasOwnProperty.call(e, a)) {
    if (r.indexOf(a) !== -1) continue;
    t[a] = e[a];
  }
  return t;
}
function Sp(e, r) {
  return Sp = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, a) {
    return t.__proto__ = a, t;
  }, Sp(e, r);
}
function Ch(e, r) {
  e.prototype = Object.create(r.prototype), e.prototype.constructor = e, Sp(e, r);
}
function Fy(e, r) {
  return e.classList ? !!r && e.classList.contains(r) : (" " + (e.className.baseVal || e.className) + " ").indexOf(" " + r + " ") !== -1;
}
function xy(e, r) {
  e.classList ? e.classList.add(r) : Fy(e, r) || (typeof e.className == "string" ? e.className = e.className + " " + r : e.setAttribute("class", (e.className && e.className.baseVal || "") + " " + r));
}
function oS(e, r) {
  return e.replace(new RegExp("(^|\\s)" + r + "(?:\\s|$)", "g"), "$1").replace(/\s+/g, " ").replace(/^\s*|\s*$/g, "");
}
function Uy(e, r) {
  e.classList ? e.classList.remove(r) : typeof e.className == "string" ? e.className = oS(e.className, r) : e.setAttribute("class", oS(e.className && e.className.baseVal || "", r));
}
var By = a8();
const Cl = /* @__PURE__ */ Zs(By), sS = {
  disabled: !1
}, Sh = _t.createContext(null);
var Q8 = function(r) {
  return r.scrollTop;
}, Ps = "unmounted", La = "exited", An = "entering", ci = "entered", xs = "exiting", wi = /* @__PURE__ */ function(e) {
  Ch(r, e);
  function r(a, o) {
    var l;
    l = e.call(this, a, o) || this;
    var c = o, f = c && !c.isMounting ? a.enter : a.appear, p;
    return l.appearStatus = null, a.in ? f ? (p = La, l.appearStatus = An) : p = ci : a.unmountOnExit || a.mountOnEnter ? p = Ps : p = La, l.state = {
      status: p
    }, l.nextCallback = null, l;
  }
  r.getDerivedStateFromProps = function(o, l) {
    var c = o.in;
    return c && l.status === Ps ? {
      status: La
    } : null;
  };
  var t = r.prototype;
  return t.componentDidMount = function() {
    this.updateStatus(!0, this.appearStatus);
  }, t.componentDidUpdate = function(o) {
    var l = null;
    if (o !== this.props) {
      var c = this.state.status;
      this.props.in ? c !== An && c !== ci && (l = An) : (c === An || c === ci) && (l = xs);
    }
    this.updateStatus(!1, l);
  }, t.componentWillUnmount = function() {
    this.cancelNextCallback();
  }, t.getTimeouts = function() {
    var o = this.props.timeout, l, c, f;
    return l = c = f = o, o != null && typeof o != "number" && (l = o.exit, c = o.enter, f = o.appear !== void 0 ? o.appear : c), {
      exit: l,
      enter: c,
      appear: f
    };
  }, t.updateStatus = function(o, l) {
    if (o === void 0 && (o = !1), l !== null)
      if (this.cancelNextCallback(), l === An) {
        if (this.props.unmountOnExit || this.props.mountOnEnter) {
          var c = this.props.nodeRef ? this.props.nodeRef.current : Cl.findDOMNode(this);
          c && Q8(c);
        }
        this.performEnter(o);
      } else
        this.performExit();
    else this.props.unmountOnExit && this.state.status === La && this.setState({
      status: Ps
    });
  }, t.performEnter = function(o) {
    var l = this, c = this.props.enter, f = this.context ? this.context.isMounting : o, p = this.props.nodeRef ? [f] : [Cl.findDOMNode(this), f], u = p[0], h = p[1], C = this.getTimeouts(), E = f ? C.appear : C.enter;
    if (!o && !c || sS.disabled) {
      this.safeSetState({
        status: ci
      }, function() {
        l.props.onEntered(u);
      });
      return;
    }
    this.props.onEnter(u, h), this.safeSetState({
      status: An
    }, function() {
      l.props.onEntering(u, h), l.onTransitionEnd(E, function() {
        l.safeSetState({
          status: ci
        }, function() {
          l.props.onEntered(u, h);
        });
      });
    });
  }, t.performExit = function() {
    var o = this, l = this.props.exit, c = this.getTimeouts(), f = this.props.nodeRef ? void 0 : Cl.findDOMNode(this);
    if (!l || sS.disabled) {
      this.safeSetState({
        status: La
      }, function() {
        o.props.onExited(f);
      });
      return;
    }
    this.props.onExit(f), this.safeSetState({
      status: xs
    }, function() {
      o.props.onExiting(f), o.onTransitionEnd(c.exit, function() {
        o.safeSetState({
          status: La
        }, function() {
          o.props.onExited(f);
        });
      });
    });
  }, t.cancelNextCallback = function() {
    this.nextCallback !== null && (this.nextCallback.cancel(), this.nextCallback = null);
  }, t.safeSetState = function(o, l) {
    l = this.setNextCallback(l), this.setState(o, l);
  }, t.setNextCallback = function(o) {
    var l = this, c = !0;
    return this.nextCallback = function(f) {
      c && (c = !1, l.nextCallback = null, o(f));
    }, this.nextCallback.cancel = function() {
      c = !1;
    }, this.nextCallback;
  }, t.onTransitionEnd = function(o, l) {
    this.setNextCallback(l);
    var c = this.props.nodeRef ? this.props.nodeRef.current : Cl.findDOMNode(this), f = o == null && !this.props.addEndListener;
    if (!c || f) {
      setTimeout(this.nextCallback, 0);
      return;
    }
    if (this.props.addEndListener) {
      var p = this.props.nodeRef ? [this.nextCallback] : [c, this.nextCallback], u = p[0], h = p[1];
      this.props.addEndListener(u, h);
    }
    o != null && setTimeout(this.nextCallback, o);
  }, t.render = function() {
    var o = this.state.status;
    if (o === Ps)
      return null;
    var l = this.props, c = l.children;
    l.in, l.mountOnEnter, l.unmountOnExit, l.appear, l.enter, l.exit, l.timeout, l.addEndListener, l.onEnter, l.onEntering, l.onEntered, l.onExit, l.onExiting, l.onExited, l.nodeRef;
    var f = X8(l, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);
    return (
      // allows for nested Transitions
      /* @__PURE__ */ _t.createElement(Sh.Provider, {
        value: null
      }, typeof c == "function" ? c(o, f) : _t.cloneElement(_t.Children.only(c), f))
    );
  }, r;
}(_t.Component);
wi.contextType = Sh;
wi.propTypes = {};
function Ao() {
}
wi.defaultProps = {
  in: !1,
  mountOnEnter: !1,
  unmountOnExit: !1,
  appear: !1,
  enter: !0,
  exit: !0,
  onEnter: Ao,
  onEntering: Ao,
  onEntered: Ao,
  onExit: Ao,
  onExiting: Ao,
  onExited: Ao
};
wi.UNMOUNTED = Ps;
wi.EXITED = La;
wi.ENTERING = An;
wi.ENTERED = ci;
wi.EXITING = xs;
var $y = function(r, t) {
  return r && t && t.split(" ").forEach(function(a) {
    return xy(r, a);
  });
}, Lf = function(r, t) {
  return r && t && t.split(" ").forEach(function(a) {
    return Uy(r, a);
  });
}, jl = /* @__PURE__ */ function(e) {
  Ch(r, e);
  function r() {
    for (var a, o = arguments.length, l = new Array(o), c = 0; c < o; c++)
      l[c] = arguments[c];
    return a = e.call.apply(e, [this].concat(l)) || this, a.appliedClasses = {
      appear: {},
      enter: {},
      exit: {}
    }, a.onEnter = function(f, p) {
      var u = a.resolveArguments(f, p), h = u[0], C = u[1];
      a.removeClasses(h, "exit"), a.addClass(h, C ? "appear" : "enter", "base"), a.props.onEnter && a.props.onEnter(f, p);
    }, a.onEntering = function(f, p) {
      var u = a.resolveArguments(f, p), h = u[0], C = u[1], E = C ? "appear" : "enter";
      a.addClass(h, E, "active"), a.props.onEntering && a.props.onEntering(f, p);
    }, a.onEntered = function(f, p) {
      var u = a.resolveArguments(f, p), h = u[0], C = u[1], E = C ? "appear" : "enter";
      a.removeClasses(h, E), a.addClass(h, E, "done"), a.props.onEntered && a.props.onEntered(f, p);
    }, a.onExit = function(f) {
      var p = a.resolveArguments(f), u = p[0];
      a.removeClasses(u, "appear"), a.removeClasses(u, "enter"), a.addClass(u, "exit", "base"), a.props.onExit && a.props.onExit(f);
    }, a.onExiting = function(f) {
      var p = a.resolveArguments(f), u = p[0];
      a.addClass(u, "exit", "active"), a.props.onExiting && a.props.onExiting(f);
    }, a.onExited = function(f) {
      var p = a.resolveArguments(f), u = p[0];
      a.removeClasses(u, "exit"), a.addClass(u, "exit", "done"), a.props.onExited && a.props.onExited(f);
    }, a.resolveArguments = function(f, p) {
      return a.props.nodeRef ? [a.props.nodeRef.current, f] : [f, p];
    }, a.getClassNames = function(f) {
      var p = a.props.classNames, u = typeof p == "string", h = u && p ? p + "-" : "", C = u ? "" + h + f : p[f], E = u ? C + "-active" : p[f + "Active"], _ = u ? C + "-done" : p[f + "Done"];
      return {
        baseClassName: C,
        activeClassName: E,
        doneClassName: _
      };
    }, a;
  }
  var t = r.prototype;
  return t.addClass = function(o, l, c) {
    var f = this.getClassNames(l)[c + "ClassName"], p = this.getClassNames("enter"), u = p.doneClassName;
    l === "appear" && c === "done" && u && (f += " " + u), c === "active" && o && Q8(o), f && (this.appliedClasses[l][c] = f, $y(o, f));
  }, t.removeClasses = function(o, l) {
    var c = this.appliedClasses[l], f = c.base, p = c.active, u = c.done;
    this.appliedClasses[l] = {}, f && Lf(o, f), p && Lf(o, p), u && Lf(o, u);
  }, t.render = function() {
    var o = this.props;
    o.classNames;
    var l = X8(o, ["classNames"]);
    return /* @__PURE__ */ _t.createElement(wi, Cp({}, l, {
      onEnter: this.onEnter,
      onEntered: this.onEntered,
      onEntering: this.onEntering,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }));
  }, r;
}(_t.Component);
jl.defaultProps = {
  classNames: ""
};
jl.propTypes = {};
var Sl, Il;
function Gy(e, r) {
  return !(e === r || _t.isValidElement(e) && _t.isValidElement(r) && e.key != null && e.key === r.key);
}
var Po = {
  out: "out-in",
  in: "in-out"
}, zl = function(r, t, a) {
  return function() {
    var o;
    r.props[t] && (o = r.props)[t].apply(o, arguments), a();
  };
}, Zy = (Sl = {}, Sl[Po.out] = function(e) {
  var r = e.current, t = e.changeState;
  return _t.cloneElement(r, {
    in: !1,
    onExited: zl(r, "onExited", function() {
      t(An, null);
    })
  });
}, Sl[Po.in] = function(e) {
  var r = e.current, t = e.changeState, a = e.children;
  return [r, _t.cloneElement(a, {
    in: !0,
    onEntered: zl(a, "onEntered", function() {
      t(An);
    })
  })];
}, Sl), jy = (Il = {}, Il[Po.out] = function(e) {
  var r = e.children, t = e.changeState;
  return _t.cloneElement(r, {
    in: !0,
    onEntered: zl(r, "onEntered", function() {
      t(ci, _t.cloneElement(r, {
        in: !0
      }));
    })
  });
}, Il[Po.in] = function(e) {
  var r = e.current, t = e.children, a = e.changeState;
  return [_t.cloneElement(r, {
    in: !1,
    onExited: zl(r, "onExited", function() {
      a(ci, _t.cloneElement(t, {
        in: !0
      }));
    })
  }), _t.cloneElement(t, {
    in: !0
  })];
}, Il), Ih = /* @__PURE__ */ function(e) {
  Ch(r, e);
  function r() {
    for (var a, o = arguments.length, l = new Array(o), c = 0; c < o; c++)
      l[c] = arguments[c];
    return a = e.call.apply(e, [this].concat(l)) || this, a.state = {
      status: ci,
      current: null
    }, a.appeared = !1, a.changeState = function(f, p) {
      p === void 0 && (p = a.state.current), a.setState({
        status: f,
        current: p
      });
    }, a;
  }
  var t = r.prototype;
  return t.componentDidMount = function() {
    this.appeared = !0;
  }, r.getDerivedStateFromProps = function(o, l) {
    return o.children == null ? {
      current: null
    } : l.status === An && o.mode === Po.in ? {
      status: An
    } : l.current && Gy(l.current, o.children) ? {
      status: xs
    } : {
      current: _t.cloneElement(o.children, {
        in: !0
      })
    };
  }, t.render = function() {
    var o = this.props, l = o.children, c = o.mode, f = this.state, p = f.status, u = f.current, h = {
      children: l,
      current: u,
      changeState: this.changeState,
      status: p
    }, C;
    switch (p) {
      case An:
        C = jy[c](h);
        break;
      case xs:
        C = Zy[c](h);
        break;
      case ci:
        C = u;
    }
    return /* @__PURE__ */ _t.createElement(Sh.Provider, {
      value: {
        isMounting: !this.appeared
      }
    }, C);
  }, r;
}(_t.Component);
Ih.propTypes = {};
Ih.defaultProps = {
  mode: Po.out
};
const zy = "_message_1r2jg_10", qy = "_icon_1r2jg_42", Wy = "_title_1r2jg_105", Yy = "_copyright_1r2jg_112", Ar = {
  "hint-container": "_hint-container_1r2jg_1",
  "tips-frameless": "_tips-frameless_1r2jg_10",
  message: zy,
  "fade-enter": "_fade-enter_1r2jg_14",
  "fade-enter-active": "_fade-enter-active_1r2jg_18",
  "fade-exit": "_fade-exit_1r2jg_23",
  "fade-exit-active": "_fade-exit-active_1r2jg_27",
  "message-container": "_message-container_1r2jg_32",
  icon: qy,
  "processing-error-icon": "_processing-error-icon_1r2jg_58",
  "search-icon": "_search-icon_1r2jg_64",
  "square-icon": "_square-icon_1r2jg_70",
  "message-background": "_message-background_1r2jg_86",
  title: Wy,
  copyright: Yy
};
var ws = { exports: {} }, Ky = ws.exports, lS;
function Xy() {
  return lS || (lS = 1, function(e, r) {
    (function(t, a) {
      a(r, Ks());
    })(Ky, function(t, a) {
      var o = "default" in a ? a.default : a;
      function l(S) {
        return (l = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(v) {
          return typeof v;
        } : function(v) {
          return v && typeof Symbol == "function" && v.constructor === Symbol && v !== Symbol.prototype ? "symbol" : typeof v;
        })(S);
      }
      var c = {}, f = "[LOCALIZE-REACT]: There are no translations for specified locale", p = "[LOCALIZE-REACT] Looks like template is being used, but no value passed for ", u = /{{([^{]+[^}])}}/g;
      function h(S, v) {
        if (!v || Object.keys(v).length === 0) return S;
        var g, O, R, D = S.match(u);
        return D && D.length !== 0 ? (g = D, O = v, R = Object.keys(O), g.map(function(T) {
          var L = Array.prototype.slice.call(T, 2, -2).join(""), P = R.find(function(M) {
            return M === L;
          });
          return P ? [T, O[P]] : (console.warn(p, T), [T, T]);
        })).reduce(function(T, L) {
          var P = new RegExp(L[0], "gi");
          return T.replace(P, L[1]);
        }, S) : S;
      }
      var C = o.createContext(), E = C.Consumer;
      function _() {
        return a.useContext(C);
      }
      t.LocalizationConsumer = E, t.LocalizationContext = C, t.LocalizationProvider = function(S) {
        var v = S.children, g = S.disableCache, O = S.locale, R = S.translations, D = R === void 0 ? {} : R, T = function(H, w) {
          if (!H) return null;
          if (l(w[H]) === "object") return H;
          var $ = H.toLowerCase().replace(/-/g, "_");
          if (l(w[$]) === "object") return $;
          var B = $.split("_")[0];
          return l(w[B]) === "object" ? B : (console.warn(f, H), H);
        }(O, D), L = T ? D[T] : D;
        function P(H, w, $) {
          if (!L || !H) return $ || H;
          var B = typeof $ == "string" ? $ : H, Y = L[H];
          if (typeof Y == "string") return w ? h(Y, w) : Y;
          var j = H.split(".");
          if (j.length === 1) return h(B, w);
          for (var ie = L[j[0]], se = 1; se < j.length; se++) ie = ie && ie[j[se]];
          return h(typeof ie == "string" ? ie : B, w);
        }
        a.useEffect(function() {
          c = {};
        }, [O, D]);
        var M, k = g ? P : (M = P, function(H, w, $) {
          var B = 2 < arguments.length && $ !== void 0 ? $ : "", Y = w ? JSON.stringify(w, null, "") + H + B : H + B;
          if (c[Y]) return c[Y];
          var j = M(H, w, B);
          return c[Y] = j;
        });
        return o.createElement(C.Provider, { value: { locale: O, translate: k, translations: D } }, v);
      }, t.Message = function(S) {
        var v = S.defaultMessage, g = S.descriptor, O = S.values;
        return (0, _().translate)(g, O, v);
      }, t.useLocalize = _, Object.defineProperty(t, "__esModule", { value: !0 });
    });
  }(ws, ws.exports)), ws.exports;
}
var Hi = Xy();
const Qy = "_copyright_aog6z_1", Jy = "_vertical_aog6z_16", eN = "_horizontal_aog6z_20", Mf = {
  copyright: Qy,
  vertical: Jy,
  horizontal: eN
}, tN = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='11'%20height='34'%20viewBox='0%200%2011%2034'%20fill='none'%3e%3cpath%20d='M5.36228%2028.5166C4.94009%2027.825%204.10415%2027.3361%203.18464%2027.3361C1.43981%2027.3361%200.300049%2028.7141%200.300049%2030.4461C0.300049%2032.1781%201.44018%2033.5%203.41003%2033.5L4.88769%2033.5L4.88769%2032.2323L3.40966%2032.2323C2.22775%2032.2323%201.56625%2031.4301%201.56625%2030.445C1.56625%2029.4599%202.24168%2028.7566%203.18464%2028.7566C4.1276%2028.7566%204.88732%2029.5163%204.88732%2030.5014L4.88732%2032.2323L8.09588%2032.2323L8.09588%2030.9658L6.01316%2030.9658L6.01316%2030.4732C6.01316%2029.2349%206.97005%2028.4187%208.09588%2028.3905L8.09588%2027.0679C6.98177%2027.0913%205.8574%2027.6245%205.36228%2028.5155'%20fill='%23BD7DFF'/%3e%3cpath%20d='M2.52335%201.69626L3.32558%201.69626C2.8191%202.03416%202.48267%202.62529%202.48267%203.46931C2.48267%205.01733%203.72101%206.17139%205.31119%206.17139C6.88706%206.17139%208.1397%205.01733%208.1397%203.46931C8.1397%202.66744%207.8161%202.09023%207.32355%201.69626L8.09756%201.69626L8.09756%200.500056L2.52335%200.500057L2.52335%201.69626ZM6.92811%203.32857C6.92811%204.22939%206.22446%204.8766%205.30972%204.8766C4.39498%204.8766%203.69133%204.22939%203.69133%203.32857C3.69133%202.42776%204.39498%201.76662%205.30972%201.76662C6.22446%201.76662%206.92811%202.42629%206.92811%203.32857Z'%20fill='%23BD7DFF'/%3e%3cpath%20d='M5.40815%2010.2242C6.50577%2010.2242%206.91403%2010.7871%206.91403%2011.5047C6.91403%2012.2223%206.50577%2012.7852%205.40815%2012.7852L2.52319%2012.7852L2.52319%2014.0518L5.35171%2014.0518C7.20942%2014.0518%208.13698%2013.0949%208.13698%2011.5047C8.13698%209.91453%207.20832%208.95764%205.35171%208.95764L2.52319%208.95764L2.52319%2010.2242L5.40815%2010.2242Z'%20fill='%23BD7DFF'/%3e%3cpath%20d='M2.4812%2023.9448C2.4812%2025.5072%203.76169%2026.7173%205.32401%2026.7173C6.88633%2026.7173%208.13824%2025.5079%208.13824%2023.9027C8.13824%2022.9319%207.80071%2022.2282%207.19564%2021.651L6.37948%2022.3407C6.71702%2022.7208%206.95633%2023.199%206.95633%2023.8745C6.95633%2024.5499%206.61843%2025.1832%205.88656%2025.3793L5.88656%2021.2149C5.66505%2021.1645%205.43828%2021.1409%205.21114%2021.1445C3.63526%2021.1445%202.4812%2022.3829%202.4812%2023.9448ZM4.88753%2025.4507C4.15456%2025.2818%203.66348%2024.6628%203.66348%2023.8748C3.66348%2023.0869%204.14174%2022.5522%204.88753%2022.3972L4.88753%2025.4507Z'%20fill='%23BD7DFF'/%3e%3cpath%20d='M0.356201%206.84671L0.356201%208.11328L8.09596%208.11328L8.09596%206.84671L0.356201%206.84671Z'%20fill='%23BD7DFF'/%3e%3cpath%20d='M3.32558%2016.0923C2.84695%2016.3737%202.48267%2017.0209%202.48267%2017.8653C2.48267%2019.343%203.72101%2020.5674%205.31119%2020.5674C6.88706%2020.5674%208.09646%2019.343%208.09646%2017.8653C8.09646%2017.0631%207.85714%2016.5566%207.36349%2016.1626L7.87034%2016.1626C8.96796%2016.1626%209.36193%2016.9366%209.36193%2017.6824C9.36193%2018.4282%208.99544%2019.0194%208.19394%2019.1319L8.19394%2020.3702C9.60124%2020.3138%2010.5028%2019.1883%2010.5028%2017.6824C10.5028%2016.1765%209.64448%2014.8972%207.78678%2014.8972L2.52335%2014.8972L2.52335%2016.0923L3.32558%2016.0923ZM6.88596%2017.7246C6.88596%2018.6254%206.22446%2019.2726%205.31009%2019.2726C4.39571%2019.2726%203.6917%2018.6254%203.6917%2017.7246C3.6917%2016.8238%204.39534%2016.1626%205.31009%2016.1626C6.22483%2016.1626%206.88596%2016.8241%206.88596%2017.7246Z'%20fill='%23BD7DFF'/%3e%3c/svg%3e", rN = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='33'%20height='11'%20viewBox='0%200%2033%2011'%20fill='none'%3e%3cpath%20d='M4.98344%205.36204C5.67499%204.93985%206.16388%204.1039%206.16388%203.18439C6.16388%201.43957%204.78591%200.299805%203.05391%200.299805C1.3219%200.299805%200%201.43993%200%203.40978V4.88744H1.26767V3.40942C1.26767%202.22751%202.0699%201.566%203.055%201.566C4.04011%201.566%204.74339%202.24143%204.74339%203.18439C4.74339%204.12736%203.98367%204.88708%202.99857%204.88708H1.26767V8.09564H2.53423V6.01291H3.02679C4.26513%206.01291%205.08129%206.9698%205.10951%208.09564H6.43215C6.40869%206.98153%205.87546%205.85716%204.98454%205.36204'%20fill='%23BD7DFF'/%3e%3cpath%20d='M31.8037%202.5231V3.32533C31.4658%202.81885%2030.8747%202.48242%2030.0307%202.48242C28.4827%202.48242%2027.3286%203.72077%2027.3286%205.31094C27.3286%206.88682%2028.4827%208.13946%2030.0307%208.13946C30.8326%208.13946%2031.4098%207.81585%2031.8037%207.3233V8.09731H32.9999V2.5231H31.8037ZM30.1714%206.92787C29.2706%206.92787%2028.6234%206.22422%2028.6234%205.30947C28.6234%204.39473%2029.2706%203.69108%2030.1714%203.69108C31.0722%203.69108%2031.7334%204.39473%2031.7334%205.30947C31.7334%206.22422%2031.0737%206.92787%2030.1714%206.92787Z'%20fill='%23BD7DFF'/%3e%3cpath%20d='M23.2758%205.40839C23.2758%206.50601%2022.7129%206.91427%2021.9953%206.91427C21.2777%206.91427%2020.7148%206.50601%2020.7148%205.40839V2.52344H19.4482V5.35196C19.4482%207.20966%2020.4051%208.13723%2021.9953%208.13723C23.5855%208.13723%2024.5424%207.20856%2024.5424%205.35196V2.52344H23.2758V5.40839Z'%20fill='%23BD7DFF'/%3e%3cpath%20d='M9.55541%202.48047C7.99309%202.48047%206.78296%203.76096%206.78296%205.32328C6.78296%206.8856%207.99235%208.13751%209.59755%208.13751C10.5684%208.13751%2011.272%207.79997%2011.8492%207.19491L11.1595%206.37875C10.7795%206.71628%2010.3012%206.9556%209.62577%206.9556C8.95034%206.9556%208.31706%206.6177%208.12099%205.88583H12.2853C12.3358%205.66432%2012.3594%205.43755%2012.3557%205.2104C12.3557%203.63452%2011.1174%202.48047%209.55541%202.48047ZM8.04953%204.8868C8.21847%204.15383%208.83746%203.66274%209.6254%203.66274C10.4133%203.66274%2010.948%204.14101%2011.1031%204.8868H8.04953Z'%20fill='%23BD7DFF'/%3e%3cpath%20d='M26.6533%200.356445H25.3867V8.09621H26.6533V0.356445Z'%20fill='%23BD7DFF'/%3e%3cpath%20d='M17.4077%203.32533C17.1263%202.84671%2016.4791%202.48242%2015.6347%202.48242C14.157%202.48242%2012.9326%203.72077%2012.9326%205.31094C12.9326%206.88682%2014.157%208.09621%2015.6347%208.09621C16.4369%208.09621%2016.9434%207.8569%2017.3374%207.36325V7.87009C17.3374%208.96771%2016.5634%209.36168%2015.8176%209.36168C15.0718%209.36168%2014.4806%208.9952%2014.3681%208.1937H13.1298C13.1862%209.601%2014.3117%2010.5025%2015.8176%2010.5025C17.3235%2010.5025%2018.6028%209.64424%2018.6028%207.78654V2.5231H17.4077V3.32533ZM15.7754%206.88572C14.8746%206.88572%2014.2274%206.22422%2014.2274%205.30984C14.2274%204.39547%2014.8746%203.69145%2015.7754%203.69145C16.6762%203.69145%2017.3374%204.3951%2017.3374%205.30984C17.3374%206.22458%2016.6759%206.88572%2015.7754%206.88572Z'%20fill='%23BD7DFF'/%3e%3c/svg%3e";
function vh(e) {
  let {
    className: r,
    vertical: t
  } = e;
  const {
    copyright: a = !0
  } = nr();
  return a ? /* @__PURE__ */ Z.jsxs("div", { part: "container-copyright", className: "".concat(Mf.copyright, " ").concat(r != null ? r : "", " ").concat(t ? Mf.vertical : Mf.horizontal), children: [
    /* @__PURE__ */ Z.jsx("span", { "data-e2e": "powered-by", children: "Powered by" }),
    /* @__PURE__ */ Z.jsx("img", { src: t ? tN : rN, alt: "regula-logo" })
  ] }) : null;
}
function Ip(e) {
  switch (e) {
    case Ir.Unknown:
      return "id-front-icon";
    case Ir.PassportSinglePage:
      return "passport-single-icon";
    case Ir.PassportTwoPages:
      return "passport-both-pages-icon";
    case Ir.IDFront:
      return "id-front-icon";
    case Ir.IDFrontMRZ:
      return "id-mrz-front-icon";
    case Ir.IDBack:
      return "id-back-icon";
    case Ir.IDBackMrz:
      return "id-mrz-back-icon";
    case Ir.IDBackBarcode:
      return "id-barcode-back-icon";
    case Ir.IDBackBarcodeMRZ:
      return "id-mrz-barcode-back-icon";
    case Ir.BankCardFront:
      return "bank-card-front-icon";
    case Ir.BankCardBack:
      return "bank-card-back-icon";
    case Ir.DocumentFront:
      return "document-front-icon";
    case Ir.DocumentBack:
      return "document-back-icon";
    default:
      return "id-front-icon";
  }
}
function nN(e) {
  switch (e) {
    case Ms.Horizontal:
      return "horizontal";
    case Ms.Vertical:
      return "vertical";
    case Ms.LeftBottomRightTop:
      return "left-bottom-right-top";
    case Ms.RightBottomLeftTop:
      return "right-bottom-left-top";
    default:
      return "";
  }
}
const iN = "_announcer_1qj2e_1", aN = {
  announcer: iN
};
function Us(e) {
  let {
    text: r,
    timeout: t = 100
  } = e;
  const [a, o] = oe.useState("");
  return oe.useEffect(() => {
    if (!r) return;
    o("");
    const l = setTimeout(() => {
      o(r);
    }, t);
    return () => {
      clearTimeout(l);
    };
  }, [r, t]), /* @__PURE__ */ Z.jsx("div", { role: "status", "aria-live": "assertive", className: aN.announcer, children: a });
}
var bf, cS;
function oN() {
  if (cS) return bf;
  cS = 1;
  function e(r) {
    return r && r.length ? r[0] : void 0;
  }
  return bf = e, bf;
}
var Pf, uS;
function sN() {
  return uS || (uS = 1, Pf = oN()), Pf;
}
var lN = sN();
const wo = /* @__PURE__ */ Zs(lN), cN = "_tilt_5ot88_1", uN = "_vertical_5ot88_19", fN = "_horizontal_5ot88_23", wf = {
  tilt: cN,
  vertical: uN,
  horizontal: fN,
  "left-bottom-right-top": "_left-bottom-right-top_5ot88_27",
  "right-bottom-left-top": "_right-bottom-left-top_5ot88_31",
  "id-front-icon": "_id-front-icon_5ot88_35",
  "passport-single-icon": "_passport-single-icon_5ot88_39",
  "passport-both-pages-icon": "_passport-both-pages-icon_5ot88_43",
  "id-mrz-front-icon": "_id-mrz-front-icon_5ot88_47",
  "id-back-icon": "_id-back-icon_5ot88_51",
  "id-mrz-back-icon": "_id-mrz-back-icon_5ot88_55",
  "id-barcode-back-icon": "_id-barcode-back-icon_5ot88_59",
  "id-mrz-barcode-back-icon": "_id-mrz-barcode-back-icon_5ot88_63",
  "bank-card-front-icon": "_bank-card-front-icon_5ot88_67",
  "bank-card-back-icon": "_bank-card-back-icon_5ot88_71",
  "document-front-icon": "_document-front-icon_5ot88_75",
  "document-back-icon": "_document-back-icon_5ot88_79"
}, dN = oe.forwardRef(function(r, t) {
  var a, o;
  let {
    animation: l
  } = r;
  const c = Ip((a = wo(l.image)) !== null && a !== void 0 ? a : Ir.IDFront);
  return /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
    /* @__PURE__ */ Z.jsx(Us, { text: "Tilt the document" }),
    /* @__PURE__ */ Z.jsx("div", { part: "hint-holo-".concat(c), className: "".concat(wf.tilt, " ").concat(wf[nN(l.tiltType)], " ").concat((o = wf[c]) !== null && o !== void 0 ? o : ""), ref: t, role: "img", "aria-label": "Document tilt animation" })
  ] });
}), pN = "_flip_1nryz_1", hN = "_front_1nryz_10", mN = "_back_1nryz_11", _N = "_slide_1nryz_22", Ji = {
  flip: pN,
  "one-side": "_one-side_1nryz_2",
  front: hN,
  back: mN,
  slide: _N,
  "flip-front": "_flip-front_1nryz_1",
  "flip-back": "_flip-back_1nryz_1",
  "id-front-icon": "_id-front-icon_1nryz_51",
  "passport-single-icon": "_passport-single-icon_1nryz_55",
  "passport-both-pages-icon": "_passport-both-pages-icon_1nryz_59",
  "id-mrz-front-icon": "_id-mrz-front-icon_1nryz_63",
  "id-back-icon": "_id-back-icon_1nryz_67",
  "id-mrz-back-icon": "_id-mrz-back-icon_1nryz_71",
  "id-barcode-back-icon": "_id-barcode-back-icon_1nryz_75",
  "id-mrz-barcode-back-icon": "_id-mrz-barcode-back-icon_1nryz_79",
  "bank-card-front-icon": "_bank-card-front-icon_1nryz_83",
  "bank-card-back-icon": "_bank-card-back-icon_1nryz_87",
  "document-front-icon": "_document-front-icon_1nryz_91",
  "document-back-icon": "_document-back-icon_1nryz_95"
}, EN = oe.forwardRef(function(r, t) {
  var a, o, l, c, f;
  let {
    animation: p
  } = r;
  const {
    nextPageAnimationStartDelay: u = R8
  } = nr(), h = p.image.length === 1, C = h && wo(p.image) === Ir.PassportTwoPages, E = Ip((a = wo(p.image)) !== null && a !== void 0 ? a : Ir.DocumentFront), _ = {
    "--animation-delay": u + "ms",
    "--animation-duration": D8 + "ms"
  };
  if (h) {
    var S;
    return /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
      /* @__PURE__ */ Z.jsx(Us, { text: "Slide the document" }),
      /* @__PURE__ */ Z.jsx("div", { ref: t, className: "".concat(Ji["one-side"], " ").concat(C ? Ji.slide : "", " ").concat((S = Ji[E]) !== null && S !== void 0 ? S : ""), style: _, role: "img", "aria-label": "Document slide animation" })
    ] });
  }
  const v = Ip((o = (l = p.image) === null || l === void 0 ? void 0 : l[1]) !== null && o !== void 0 ? o : Ir.DocumentBack);
  return /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
    /* @__PURE__ */ Z.jsx(Us, { text: "Flip the document" }),
    /* @__PURE__ */ Z.jsxs("div", { ref: t, className: Ji.flip, style: _, role: "img", "aria-label": "Document flip animation", part: "hint-next-page-icon", children: [
      /* @__PURE__ */ Z.jsx("div", { part: "hint-next-page-front-".concat(E), className: "".concat(Ji.front, " ").concat((c = Ji[E]) !== null && c !== void 0 ? c : "") }),
      /* @__PURE__ */ Z.jsx("div", { part: "hint-next-page-back-".concat(v), className: "".concat(Ji.back, " ").concat((f = Ji[v]) !== null && f !== void 0 ? f : "") })
    ] })
  ] });
}), fS = oe.forwardRef(function(r, t) {
  let {
    animation: a
  } = r;
  const [o, l] = oe.useState(null);
  oe.useLayoutEffect(() => {
    a && l(a.type);
  }, [a]);
  const c = (a == null ? void 0 : a.type) || o;
  return c === Ma.Tilt && (a == null ? void 0 : a.type) === Ma.Tilt ? /* @__PURE__ */ Z.jsx(dN, { animation: a, ref: t }) : c === Ma.Flip && (a == null ? void 0 : a.type) === Ma.Flip ? /* @__PURE__ */ Z.jsx(EN, { animation: a, ref: t }) : null;
});
function CN(e) {
  var r;
  let {
    layoutParams: t,
    icon: a,
    title: o,
    maskParams: l,
    animation: c,
    videoSize: f,
    controlsSizes: p,
    isLandscape: u
  } = e;
  const {
    statusIcon: h = !0,
    statusPositionMultiplier: C,
    activityIndicatorPortraitPositionMultiplier: E,
    activityIndicatorLandscapePositionMultiplier: _,
    newLayout: S
  } = nr(), v = oe.useRef(null), g = oe.useRef(null), O = oe.useRef(null), R = oe.useRef(null), D = oe.useRef(null), T = u && l == null, L = "".concat(Ar["hint-container"], " ").concat(T ? Ar["tips-frameless"] : ""), {
    translate: P
  } = Hi.useLocalize(), M = {
    classNames: {
      enter: Ar["fade-enter"],
      enterActive: Ar["fade-enter-active"],
      exit: Ar["fade-exit"],
      exitActive: Ar["fade-exit-active"]
    },
    timeout: 300
  };
  return oe.useLayoutEffect(() => {
    var k, H;
    const w = g.current;
    if (!w || !f) return;
    const $ = u && p ? p.main : 0;
    w.style.width = "".concat(l ? l.width : f.width - $, "px"), w.style.height = "".concat(l ? l.height : f.height, "px"), w.style.top = "".concat(l ? l.top : 0, "px"), w.style.left = "".concat(l ? l.left : $, "px");
    const B = C !== void 0, Y = E !== void 0 || _ !== void 0, j = ((k = l == null ? void 0 : l.height) !== null && k !== void 0 ? k : f.height) / 2 + ((H = l == null ? void 0 : l.top) !== null && H !== void 0 ? H : 0), ie = (X, K, y) => {
      X.style.setProperty(K, "".concat(y, "px"));
    };
    if (S && D.current && t) {
      var se, le, U;
      const G = ((se = p == null ? void 0 : p.main) !== null && se !== void 0 ? se : 0) + ((le = p == null ? void 0 : p.top) !== null && le !== void 0 ? le : 0) + ((U = l == null ? void 0 : l.height) !== null && U !== void 0 ? U : 0) + D.current.clientHeight + 6 > t.height ? w.clientHeight / 2 - 6 * 3 - D.current.clientHeight : w.clientHeight / 2 + 6 * 3, ce = w.clientHeight / 2 - D.current.clientHeight - 6;
      ie(w, "--message-top", u ? ce : G);
    }
    if (B && D.current) {
      const K = ((S && t ? t.height : f.height) - D.current.clientHeight) / 2 * C - j;
      ie(w, "--message-top", K);
    }
    if (Y && R.current) {
      const X = R.current.clientHeight, y = f.width > f.height ? _ : E;
      if (y !== void 0) {
        const G = (f.height - X) / 2 * y - j;
        ie(w, "--indicator-top", G);
      }
    }
  }, [C, l, f, p, E, _, S, u, t]), /* @__PURE__ */ Z.jsx("div", { part: "hint-container", ref: g, className: L, children: S ? /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
    /* @__PURE__ */ Z.jsx(jl, Qi(be({ in: !!c, nodeRef: v, unmountOnExit: !0 }, M), { children: /* @__PURE__ */ Z.jsx(fS, { animation: c, ref: v }) })),
    /* @__PURE__ */ Z.jsx("div", { part: "hint-status-message-container", className: Ar["message-container"], children: !!o && /* @__PURE__ */ Z.jsx("div", { part: "hint-status-message", ref: D, className: Ar.message, children: /* @__PURE__ */ Z.jsx("div", { part: "hint-status-message-background", className: Ar["message-background"], children: /* @__PURE__ */ Z.jsx("p", { role: "status", "aria-live": "assertive", part: "hint-status-message-title", className: Ar.title, children: P(o) }) }) }) })
  ] }) : /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
    /* @__PURE__ */ Z.jsx(vh, { className: Ar.copyright }),
    /* @__PURE__ */ Z.jsx(Ih, { children: /* @__PURE__ */ Z.jsx(jl, Qi(be({ nodeRef: c ? v : O }, M), { children: c ? /* @__PURE__ */ Z.jsx(fS, { animation: c, ref: v }) : /* @__PURE__ */ Z.jsxs("div", { part: "hint-status-message-container", ref: O, className: Ar["message-container"], children: [
      h && !!a && /* @__PURE__ */ Z.jsx("div", { role: "img", "aria-label": "Status icon", part: "hint-status-".concat(a), ref: R, className: "".concat(Ar.icon, " ").concat((r = Ar[a]) !== null && r !== void 0 ? r : "") }),
      !!o && /* @__PURE__ */ Z.jsx("div", { part: "hint-status-message", ref: D, className: Ar.message, children: /* @__PURE__ */ Z.jsx("div", { part: "hint-status-message-background", className: Ar["message-background"], children: /* @__PURE__ */ Z.jsx("p", { role: "status", "aria-live": "assertive", part: "hint-status-message-title", className: Ar.title, children: P(o) }) }) })
    ] }) }), c ? "document-animation" : "message-container") })
  ] }) });
}
const SN = "_copyright_1df3q_108", Cr = {
  "top-functional-buttons": "_top-functional-buttons_1df3q_1",
  "bottom-functional-buttons": "_bottom-functional-buttons_1df3q_2",
  "left-functional-buttons": "_left-functional-buttons_1df3q_3",
  "main-functional-buttons": "_main-functional-buttons_1df3q_15",
  "mirror-button": "_mirror-button_1df3q_76",
  "change-camera-button": "_change-camera-button_1df3q_77",
  "process-button": "_process-button_1df3q_99",
  "snapshot-button": "_snapshot-button_1df3q_100",
  copyright: SN,
  "skip-button": "_skip-button_1df3q_112",
  "controls-container": "_controls-container_1df3q_160",
  "process-close-button": "_process-close-button_1df3q_168",
  "mirror-back-button": "_mirror-back-button_1df3q_226",
  "mirror-front-button": "_mirror-front-button_1df3q_232"
};
function IN(e) {
  let {
    mirroring: r,
    isSkipButtonVisible: t,
    isChangeCameraAvailable: a,
    isLandscape: o,
    onClose: l,
    onChangeCamera: c,
    onChangeMirroring: f,
    captureButton: p = !0,
    facing: u,
    onSnapshotProcess: h,
    onCameraSnapshot: C,
    onSkip: E,
    onControlsSizes: _
  } = e;
  const {
    closeButton: S = !0,
    skipButton: v = !0,
    mirrorButton: g = !1,
    copyright: O = !0,
    changeCameraButton: R,
    captureButtonDelay: D,
    newLayout: T
  } = nr(), {
    translate: L
  } = Hi.useLocalize(), [P, M] = oe.useState(D === void 0), k = oe.useRef(null), H = oe.useRef(null), w = oe.useRef(null), $ = oe.useRef(null), B = h && p && P, Y = t && v, j = u !== hn.environment && g, ie = a && R, se = S, le = O, U = B || C || Y, X = j || ie, K = B || C || j || ie || le;
  return oe.useEffect(() => {
    var y, G, ce, ue, ee, ge;
    const Oe = ((y = k.current) === null || y === void 0 ? void 0 : y.offsetWidth) || 0, Se = ((G = H.current) === null || G === void 0 ? void 0 : G.offsetWidth) || 0, Ne = ((ce = w.current) === null || ce === void 0 ? void 0 : ce.offsetWidth) || 0, Le = ((ue = $.current) === null || ue === void 0 ? void 0 : ue.offsetWidth) || 0, ct = ((ee = $.current) === null || ee === void 0 ? void 0 : ee.offsetHeight) || 0, Ye = ((ge = k.current) === null || ge === void 0 ? void 0 : ge.offsetHeight) || 0, nt = o ? Math.max(Oe, Se, Ne, Le) : ct;
    _({
      top: Ye,
      main: nt
    });
  }, [se, U, X, K, le, o]), oe.useEffect(() => {
    if (typeof D != "number") return;
    const y = setTimeout(() => {
      M(!0);
    }, D * 1e3);
    return () => {
      clearTimeout(y);
    };
  }, [D]), !se && !U && !X && !O ? null : /* @__PURE__ */ Z.jsxs("div", { part: "controls-container", className: Cr["controls-container"], children: [
    se && /* @__PURE__ */ Z.jsx("div", { part: "controls-top-buttons", className: Cr["top-functional-buttons"], ref: k, children: S && /* @__PURE__ */ Z.jsx("button", { part: "controls-process-close-button", className: Cr["process-close-button"], onClick: l, "aria-label": "Close processing" }) }),
    U && !T && /* @__PURE__ */ Z.jsxs("div", { part: "controls-left-buttons", className: Cr["left-functional-buttons"], ref: H, children: [
      (B || C) && /* @__PURE__ */ Z.jsx("button", { part: B ? "controls-process-button" : "controls-snapshot-button", className: B ? Cr["process-button"] : Cr["snapshot-button"], onClick: B ? h : C, "aria-label": B ? "Process the frame" : "Take a snapshot" }),
      Y && /* @__PURE__ */ Z.jsx("button", { "aria-label": "Skip the page", part: "controls-skip-button", className: Cr["skip-button"], onClick: E })
    ] }),
    X && !T && /* @__PURE__ */ Z.jsxs("div", { part: "controls-bottom-buttons", className: Cr["bottom-functional-buttons"], ref: w, children: [
      ie && /* @__PURE__ */ Z.jsx("button", { part: "controls-change-camera-button", className: Cr["change-camera-button"], onClick: c, "aria-label": "Change the camera" }),
      j && /* @__PURE__ */ Z.jsx("button", { part: "controls-mirror-button", className: r ? Cr["mirror-back-button"] : Cr["mirror-front-button"], onClick: f, "aria-label": "Flip horizontally" })
    ] }),
    K && T && /* @__PURE__ */ Z.jsxs("div", { part: "controls-main-buttons", className: Cr["main-functional-buttons"], ref: $, children: [
      ie && /* @__PURE__ */ Z.jsx("button", { part: "controls-change-camera-button", "aria-label": "Change the camera", className: Cr["change-camera-button"], onClick: c }),
      Y && /* @__PURE__ */ Z.jsx("button", { part: "controls-skip-button", "aria-label": "Skip the page", className: Cr["skip-button"], onClick: E, children: L("skip") }),
      (B || C) && /* @__PURE__ */ Z.jsx("button", { part: B ? "controls-process-button" : "controls-snapshot-button", "aria-label": B ? "Process the frame" : "Take a snapshot", className: B ? Cr["process-button"] : Cr["snapshot-button"], onClick: B ? h : C }),
      j && /* @__PURE__ */ Z.jsx("button", { part: "controls-mirror-button", "aria-label": "Flip horizontally", className: Cr["mirror-button"], onClick: f }),
      /* @__PURE__ */ Z.jsx(vh, { vertical: o, className: Cr.copyright })
    ] })
  ] });
}
const vN = "_spinner_1vpw0_1", gN = "_message_1vpw0_51", Hf = {
  spinner: vN,
  "process-message": "_process-message_1vpw0_41",
  message: gN
};
function e2(e) {
  let {
    title: r
  } = e;
  const {
    translate: t
  } = Hi.useLocalize();
  return /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
    /* @__PURE__ */ Z.jsx(Us, { text: r || t("pleaseWait") }),
    /* @__PURE__ */ Z.jsxs("div", { part: "processing-container", className: Hf["process-message"], children: [
      /* @__PURE__ */ Z.jsx("div", { role: "img", "aria-label": "Spinner", part: "spinner-container", className: Hf.spinner, children: /* @__PURE__ */ Z.jsx("div", { part: "spinner-circle" }) }),
      /* @__PURE__ */ Z.jsx("span", { part: "processing-message", className: Hf.message, children: r || t("pleaseWait") })
    ] })
  ] });
}
const DN = "_window_1m5c9_14", RN = "_header_1m5c9_36", AN = "_footer_1m5c9_57", vl = {
  window: DN,
  header: RN,
  footer: AN,
  "close-button": "_close-button_1m5c9_63"
};
function gh(e) {
  let {
    onClose: r,
    children: t,
    direction: a,
    showHeaderAndFooter: o = !0,
    className: l
  } = e;
  const {
    closeButton: c = !0
  } = nr();
  return /* @__PURE__ */ Z.jsxs("div", { part: "container", className: "".concat(vl.window, " ").concat(l != null ? l : ""), "data-direction": a, children: [
    o && /* @__PURE__ */ Z.jsx("div", { part: "container-header", className: vl.header, children: c && /* @__PURE__ */ Z.jsx("button", { part: "container-close-button", className: vl["close-button"], "data-e2e": "cross", onClick: r, "aria-label": "Close document reader component" }) }),
    t,
    o && /* @__PURE__ */ Z.jsx("div", { part: "container-footer", className: vl.footer, children: /* @__PURE__ */ Z.jsx(vh, {}) })
  ] });
}
const TN = "_container_zfhdf_1", ON = "_layout_zfhdf_2", yN = "_loader_zfhdf_25", Vf = {
  container: TN,
  layout: ON,
  loader: yN
};
function J8(e) {
  let {
    direction: r,
    status: t,
    children: a,
    mirroring: o,
    onChangeMirroring: l,
    onChangeCamera: c,
    videoStatusParams: f,
    videoElementParams: p,
    onProcessClose: u,
    onClose: h,
    onSnapshotProcess: C,
    onCameraSnapshot: E,
    onSkip: _,
    frameParams: S,
    captureButton: v,
    animation: g,
    onControlsWidth: O
  } = e;
  const {
    cameraFrameBorderWidth: R,
    cameraFrame: D = !0,
    newLayout: T,
    cameraFrameVerticalPositionMultiplier: L,
    cameraFrameHorizontalPositionMultiplier: P
  } = nr(), M = oe.useRef(null), [k, H] = oe.useState(!1), [w, $] = oe.useState(null), [B, Y] = oe.useState(null), [j, ie] = oe.useState(null), se = !!(f.sortedDevices && f.sortedDevices.frontCameras.length + f.sortedDevices.backCameras.length > IO), le = t === at.HOLD || t === at.FOCUS || t === at.RESOLUTION || t === at.PROCESSING || t === at.GLARE, U = t !== at.SERVICE_PREPARING, X = f.videoStatus === Ft.PLAY, {
    icon: K,
    title: y
  } = My(t), G = p.videoParams.width > p.videoParams.height, ce = T ? p.videoContainerParams : B;
  return oe.useEffect(() => {
    t === at.START_NEXT_PAGE && H(!0);
  }, [t]), oe.useLayoutEffect(() => {
    const ue = M.current;
    if (!X || !ue || !U) return;
    const ee = nS(p.videoParams.width, p.videoParams.height, p.videoContainerParams.width, p.videoContainerParams.height, p.videoParams.width, p.videoParams.height, 0, 0, Gl.contain);
    if (T || (ue.style.width = "".concat(ee.width, "px"), ue.style.height = "".concat(ee.height, "px"), ue.style.top = "".concat(ee.top, "px"), ue.style.left = "".concat(ee.left, "px"), ue.style.right = "".concat(ee.right, "px")), Y(ee), !S || !ee) return $(null);
    const ge = S.frameRight - S.frameLeft, Oe = S.frameBottom - S.frameTop;
    if (!(ee.width && ee.height) || !(ge && Oe) || !p.videoElement) return;
    const Le = nS(p.videoParams.width, p.videoParams.height, ee.width, ee.height, ge, Oe, S.frameLeft, S.frameTop, Gl.contain), ct = R != null ? R : T ? rO : tO;
    let Ye = o ? ee.width - (Le.left + Le.width) : Le.left, nt = o ? ee.width - (Le.right + Le.width) : Le.right, Ke = Le.width, ot = Le.height, St = Le.top;
    if (T && j)
      if (G) {
        const Je = p.videoContainerParams.width - j.main, je = r === Zl.Rtl ? j.main : 0;
        let st = ee.width;
        if (Le.width > Je - 20) {
          Ke = Je - 20, ot = Math.round(Ke * (Le.height / Le.width));
          const Ue = Ke / Le.width;
          st = ee.width * Ue;
        }
        const de = (Je - Ke) / 2 * ((P != null ? P : 1) - 1);
        St = j.top, St = (p.videoContainerParams.height - ot) / 2, Ye = (Je - Ke) / 2 + de + je, nt = p.videoContainerParams.width - (Ye + Ke);
        const Te = Math.round(Ye - (st - Ke) / 2);
        p.videoElement.style.width = "".concat(st, "px"), p.videoElement.style.left = "".concat(Te, "px");
      } else {
        const dt = p.videoContainerParams.height - j.top - j.main;
        let Je = ee.height;
        if (Le.height > dt) {
          const de = dt / Le.height;
          Je = ee.height * de, ot = dt, Ke = Math.round(ot * (Le.width / Le.height));
        }
        const je = (dt - ot) / 2 * (L != null ? L : 0);
        St = j.top + je, Ye = (p.videoContainerParams.width - Ke) / 2, nt = Ye;
        const st = Math.round(St - (Je - ot) / 2);
        p.videoElement.style.height = "".concat(Je, "px"), p.videoElement.style.top = "".concat(st, "px");
      }
    $({
      width: Ke,
      height: ot,
      top: St,
      left: Ye,
      right: nt,
      stroke: ct
    });
  }, [p, X, U, T, G, S, o, R, L, P, j, r]), oe.useLayoutEffect(() => {
    if (!B || !O || !j || !G || T) return;
    const ue = B.width / p.videoParams.width, ee = j.main > 0 ? j.main / ue : 0;
    O(ee);
  }, [B, j, p.videoParams.width, T]), /* @__PURE__ */ Z.jsxs("div", { part: "layout-container", className: Vf.container, "data-layout": T ? "new" : "old", "data-orientation": G ? "landscape" : "portrait", children: [
    a,
    X && /* @__PURE__ */ Z.jsxs("div", { part: "layout", ref: M, className: Vf.layout, children: [
      D && w && ce && /* @__PURE__ */ Z.jsx(ky, { layoutParams: ce, maskParams: w, isDocumentAvailable: le }),
      /* @__PURE__ */ Z.jsx(CN, { layoutParams: ce, title: y, icon: K, maskParams: w, videoSize: B, controlsSizes: j, isLandscape: G, animation: g }),
      /* @__PURE__ */ Z.jsx(IN, { mirroring: o, captureButton: v, facing: f.camera.facing, isLandscape: G, isSkipButtonVisible: k, isChangeCameraAvailable: se, onClose: u, onChangeCamera: c, onChangeMirroring: l, onSnapshotProcess: C, onCameraSnapshot: E, onSkip: _, onControlsSizes: ie })
    ] }),
    t === at.SERVICE_PREPARING && /* @__PURE__ */ Z.jsx(gh, { onClose: h, className: Vf.loader, children: /* @__PURE__ */ Z.jsx(e2, {}) })
  ] });
}
var dS = {}, kf, pS;
function eD() {
  return pS || (pS = 1, kf = `	
\v\f\r                　\u2028\u2029\uFEFF`), kf;
}
var Ff, hS;
function NN() {
  if (hS) return Ff;
  hS = 1;
  var e = vt(), r = ko(), t = Nn(), a = eD(), o = e("".replace), l = RegExp("^[" + a + "]+"), c = RegExp("(^|[^" + a + "])[" + a + "]+$"), f = function(p) {
    return function(u) {
      var h = t(r(u));
      return p & 1 && (h = o(h, l, "")), p & 2 && (h = o(h, c, "$1")), h;
    };
  };
  return Ff = {
    // `String.prototype.{ trimLeft, trimStart }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimstart
    start: f(1),
    // `String.prototype.{ trimRight, trimEnd }` methods
    // https://tc39.es/ecma262/#sec-string.prototype.trimend
    end: f(2),
    // `String.prototype.trim` method
    // https://tc39.es/ecma262/#sec-string.prototype.trim
    trim: f(3)
  }, Ff;
}
var xf, mS;
function LN() {
  if (mS) return xf;
  mS = 1;
  var e = rc().PROPER, r = gt(), t = eD(), a = "​᠎";
  return xf = function(o) {
    return r(function() {
      return !!t[o]() || a[o]() !== a || e && t[o].name !== o;
    });
  }, xf;
}
var _S;
function MN() {
  if (_S) return dS;
  _S = 1;
  var e = zt(), r = NN().trim, t = LN();
  return e({ target: "String", proto: !0, forced: t("trim") }, {
    trim: function() {
      return r(this);
    }
  }), dS;
}
MN();
var ES = {}, CS;
function bN() {
  if (CS) return ES;
  CS = 1;
  var e = zt(), r = Mt(), t = Js(), a = en(), o = or(), l = Ga(), c = Yn(), f = Za(), p = f("find", TypeError);
  return e({ target: "Iterator", proto: !0, real: !0, forced: p }, {
    find: function(h) {
      o(this);
      try {
        a(h);
      } catch (_) {
        c(this, "throw", _);
      }
      if (p) return r(p, this, h);
      var C = l(this), E = 0;
      return t(C, function(_, S) {
        if (h(_, E++)) return S(_);
      }, { IS_RECORD: !0, INTERRUPTED: !0 }).result;
    }
  }), ES;
}
bN();
function PN(e) {
  let {
    videoSize: r,
    mirroring: t,
    controlsWidth: a,
    cameraFrameOffsetWidth: o,
    landscapeAspectRatio: l,
    portraitAspectRatio: c,
    cameraFrameVerticalPositionMultiplier: f,
    cameraFrameHorizontalPositionMultiplier: p,
    newLayout: u
  } = e;
  const h = r.width > r.height, C = h && !u ? a : 0, _ = (h ? r.height : r.width) / 100 * (h ? o != null ? o : w7 : o != null ? o : u ? w7 : 1), S = (r.width - (h ? C : 0)) / r.height, v = h ? l : c;
  let g, O, R, D;
  if (h) {
    S > v ? (O = r.height - _ * 2, g = O * v, R = ((!!u === t ? C : 0) + (r.width - C - g) / 2) * (u ? 1 : p != null ? p : 1), D = _) : (g = r.width - C - _ * 2, O = g / v, R = (!!u === t ? C : 0) + _, D = (r.height - O) / 2);
    const T = (r.width - g) / 2;
    T > C + _ && !u && (S > v && p !== void 0 || (R = T));
  } else
    S < v ? (g = r.width - _ * 2, O = g / v, R = _, D = (r.height - O) / 2 * (u ? 1 : f != null ? f : 1)) : (O = r.height - _ * 2, g = O * v, R = (r.width - g) / 2, D = _);
  return {
    height: Math.round(O),
    width: Math.round(g),
    left: Math.round(R),
    top: Math.round(D)
  };
}
function wN(e) {
  let {
    videoSize: r,
    mirroring: t,
    controlsWidth: a,
    scenario: o,
    scenarioParams: l
  } = e;
  const {
    cameraFramePortraitAspectRatio: c,
    cameraFrameLandscapeAspectRatio: f,
    cameraFrameOffsetWidth: p,
    cameraFrameVerticalPositionMultiplier: u,
    cameraFrameHorizontalPositionMultiplier: h,
    cameraFrame: C = !0,
    newLayout: E
  } = nr(), [_, S] = oe.useState(null);
  return oe.useEffect(() => {
    if (!C)
      return S(null);
    const v = !!r.width, g = !!r.height;
    if (!(v && g && (l == null ? void 0 : l.length)) || !o) return;
    const D = l.find((Y) => Y.name === o), T = window.RegulaDocumentSDK.recognizerProcessParam.processParam.doublePageSpread, L = T ? D == null ? void 0 : D.frameKWHDoublePageSpreadLandscape : D == null ? void 0 : D.frameKWHLandscape, P = T ? D == null ? void 0 : D.frameKWHDoublePageSpreadPortrait : D == null ? void 0 : D.frameKWHPortrait;
    if (!L || !P) return;
    const M = f != null ? f : Number(L), k = c != null ? c : Number(P), {
      width: H,
      height: w,
      top: $,
      left: B
    } = PN({
      videoSize: r,
      mirroring: t,
      controlsWidth: a,
      cameraFrameOffsetWidth: p,
      landscapeAspectRatio: M,
      portraitAspectRatio: k,
      cameraFrameVerticalPositionMultiplier: u,
      cameraFrameHorizontalPositionMultiplier: h,
      newLayout: E
    });
    S({
      frameBottom: $ + w,
      frameLeft: B,
      frameRight: B + H,
      frameTop: $
    });
  }, [C, o, r, l, t, a, c, f, p, u, h, E]), _;
}
function SS(e, r, t) {
  return (r = HN(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function HN(e) {
  var r = VN(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function VN(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class $t {
  constructor(r) {
    let t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null;
    SS(this, "type", void 0), SS(this, "details", void 0), this.type = r, this.details = t;
  }
}
function tD(e, r) {
  return function() {
    return e.apply(r, arguments);
  };
}
const { toString: kN } = Object.prototype, { getPrototypeOf: Dh } = Object, { iterator: uc, toStringTag: rD } = Symbol, fc = /* @__PURE__ */ ((e) => (r) => {
  const t = kN.call(r);
  return e[t] || (e[t] = t.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Kn = (e) => (e = e.toLowerCase(), (r) => fc(r) === e), dc = (e) => (r) => typeof r === e, { isArray: $o } = Array, Ho = dc("undefined");
function t2(e) {
  return e !== null && !Ho(e) && e.constructor !== null && !Ho(e.constructor) && Qr(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const nD = Kn("ArrayBuffer");
function FN(e) {
  let r;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? r = ArrayBuffer.isView(e) : r = e && e.buffer && nD(e.buffer), r;
}
const xN = dc("string"), Qr = dc("function"), iD = dc("number"), r2 = (e) => e !== null && typeof e == "object", UN = (e) => e === !0 || e === !1, Hl = (e) => {
  if (fc(e) !== "object")
    return !1;
  const r = Dh(e);
  return (r === null || r === Object.prototype || Object.getPrototypeOf(r) === null) && !(rD in e) && !(uc in e);
}, BN = (e) => {
  if (!r2(e) || t2(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch (r) {
    return !1;
  }
}, $N = Kn("Date"), GN = Kn("File"), ZN = Kn("Blob"), jN = Kn("FileList"), zN = (e) => r2(e) && Qr(e.pipe), qN = (e) => {
  let r;
  return e && (typeof FormData == "function" && e instanceof FormData || Qr(e.append) && ((r = fc(e)) === "formdata" || // detect form-data instance
  r === "object" && Qr(e.toString) && e.toString() === "[object FormData]"));
}, WN = Kn("URLSearchParams"), [YN, KN, XN, QN] = ["ReadableStream", "Request", "Response", "Headers"].map(Kn), JN = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function n2(e, r, { allOwnKeys: t = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let a, o;
  if (typeof e != "object" && (e = [e]), $o(e))
    for (a = 0, o = e.length; a < o; a++)
      r.call(null, e[a], a, e);
  else {
    if (t2(e))
      return;
    const l = t ? Object.getOwnPropertyNames(e) : Object.keys(e), c = l.length;
    let f;
    for (a = 0; a < c; a++)
      f = l[a], r.call(null, e[f], f, e);
  }
}
function aD(e, r) {
  if (t2(e))
    return null;
  r = r.toLowerCase();
  const t = Object.keys(e);
  let a = t.length, o;
  for (; a-- > 0; )
    if (o = t[a], r === o.toLowerCase())
      return o;
  return null;
}
const ba = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, oD = (e) => !Ho(e) && e !== ba;
function vp() {
  const { caseless: e, skipUndefined: r } = oD(this) && this || {}, t = {}, a = (o, l) => {
    const c = e && aD(t, l) || l;
    Hl(t[c]) && Hl(o) ? t[c] = vp(t[c], o) : Hl(o) ? t[c] = vp({}, o) : $o(o) ? t[c] = o.slice() : (!r || !Ho(o)) && (t[c] = o);
  };
  for (let o = 0, l = arguments.length; o < l; o++)
    arguments[o] && n2(arguments[o], a);
  return t;
}
const eL = (e, r, t, { allOwnKeys: a } = {}) => (n2(r, (o, l) => {
  t && Qr(o) ? e[l] = tD(o, t) : e[l] = o;
}, { allOwnKeys: a }), e), tL = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), rL = (e, r, t, a) => {
  e.prototype = Object.create(r.prototype, a), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: r.prototype
  }), t && Object.assign(e.prototype, t);
}, nL = (e, r, t, a) => {
  let o, l, c;
  const f = {};
  if (r = r || {}, e == null) return r;
  do {
    for (o = Object.getOwnPropertyNames(e), l = o.length; l-- > 0; )
      c = o[l], (!a || a(c, e, r)) && !f[c] && (r[c] = e[c], f[c] = !0);
    e = t !== !1 && Dh(e);
  } while (e && (!t || t(e, r)) && e !== Object.prototype);
  return r;
}, iL = (e, r, t) => {
  e = String(e), (t === void 0 || t > e.length) && (t = e.length), t -= r.length;
  const a = e.indexOf(r, t);
  return a !== -1 && a === t;
}, aL = (e) => {
  if (!e) return null;
  if ($o(e)) return e;
  let r = e.length;
  if (!iD(r)) return null;
  const t = new Array(r);
  for (; r-- > 0; )
    t[r] = e[r];
  return t;
}, oL = /* @__PURE__ */ ((e) => (r) => e && r instanceof e)(typeof Uint8Array < "u" && Dh(Uint8Array)), sL = (e, r) => {
  const t = (e && e[uc]).call(e);
  let a;
  for (; (a = t.next()) && !a.done; ) {
    const o = a.value;
    r.call(e, o[0], o[1]);
  }
}, lL = (e, r) => {
  let t;
  const a = [];
  for (; (t = e.exec(r)) !== null; )
    a.push(t);
  return a;
}, cL = Kn("HTMLFormElement"), uL = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, t, a) {
    return t.toUpperCase() + a;
  }
), IS = (({ hasOwnProperty: e }) => (r, t) => e.call(r, t))(Object.prototype), fL = Kn("RegExp"), sD = (e, r) => {
  const t = Object.getOwnPropertyDescriptors(e), a = {};
  n2(t, (o, l) => {
    let c;
    (c = r(o, l, e)) !== !1 && (a[l] = c || o);
  }), Object.defineProperties(e, a);
}, dL = (e) => {
  sD(e, (r, t) => {
    if (Qr(e) && ["arguments", "caller", "callee"].indexOf(t) !== -1)
      return !1;
    const a = e[t];
    if (Qr(a)) {
      if (r.enumerable = !1, "writable" in r) {
        r.writable = !1;
        return;
      }
      r.set || (r.set = () => {
        throw Error("Can not rewrite read-only method '" + t + "'");
      });
    }
  });
}, pL = (e, r) => {
  const t = {}, a = (o) => {
    o.forEach((l) => {
      t[l] = !0;
    });
  };
  return $o(e) ? a(e) : a(String(e).split(r)), t;
}, hL = () => {
}, mL = (e, r) => e != null && Number.isFinite(e = +e) ? e : r;
function _L(e) {
  return !!(e && Qr(e.append) && e[rD] === "FormData" && e[uc]);
}
const EL = (e) => {
  const r = new Array(10), t = (a, o) => {
    if (r2(a)) {
      if (r.indexOf(a) >= 0)
        return;
      if (t2(a))
        return a;
      if (!("toJSON" in a)) {
        r[o] = a;
        const l = $o(a) ? [] : {};
        return n2(a, (c, f) => {
          const p = t(c, o + 1);
          !Ho(p) && (l[f] = p);
        }), r[o] = void 0, l;
      }
    }
    return a;
  };
  return t(e, 0);
}, CL = Kn("AsyncFunction"), SL = (e) => e && (r2(e) || Qr(e)) && Qr(e.then) && Qr(e.catch), lD = ((e, r) => e ? setImmediate : r ? ((t, a) => (ba.addEventListener("message", ({ source: o, data: l }) => {
  o === ba && l === t && a.length && a.shift()();
}, !1), (o) => {
  a.push(o), ba.postMessage(t, "*");
}))(`axios@${Math.random()}`, []) : (t) => setTimeout(t))(
  typeof setImmediate == "function",
  Qr(ba.postMessage)
), IL = typeof queueMicrotask < "u" ? queueMicrotask.bind(ba) : typeof process < "u" && process.nextTick || lD, vL = (e) => e != null && Qr(e[uc]), re = {
  isArray: $o,
  isArrayBuffer: nD,
  isBuffer: t2,
  isFormData: qN,
  isArrayBufferView: FN,
  isString: xN,
  isNumber: iD,
  isBoolean: UN,
  isObject: r2,
  isPlainObject: Hl,
  isEmptyObject: BN,
  isReadableStream: YN,
  isRequest: KN,
  isResponse: XN,
  isHeaders: QN,
  isUndefined: Ho,
  isDate: $N,
  isFile: GN,
  isBlob: ZN,
  isRegExp: fL,
  isFunction: Qr,
  isStream: zN,
  isURLSearchParams: WN,
  isTypedArray: oL,
  isFileList: jN,
  forEach: n2,
  merge: vp,
  extend: eL,
  trim: JN,
  stripBOM: tL,
  inherits: rL,
  toFlatObject: nL,
  kindOf: fc,
  kindOfTest: Kn,
  endsWith: iL,
  toArray: aL,
  forEachEntry: sL,
  matchAll: lL,
  isHTMLForm: cL,
  hasOwnProperty: IS,
  hasOwnProp: IS,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: sD,
  freezeMethods: dL,
  toObjectSet: pL,
  toCamelCase: uL,
  noop: hL,
  toFiniteNumber: mL,
  findKey: aD,
  global: ba,
  isContextDefined: oD,
  isSpecCompliantForm: _L,
  toJSONObject: EL,
  isAsyncFn: CL,
  isThenable: SL,
  setImmediate: lD,
  asap: IL,
  isIterable: vL
};
function ft(e, r, t, a, o) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", r && (this.code = r), t && (this.config = t), a && (this.request = a), o && (this.response = o, this.status = o.status ? o.status : null);
}
re.inherits(ft, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: re.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const cD = ft.prototype, uD = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  uD[e] = { value: e };
});
Object.defineProperties(ft, uD);
Object.defineProperty(cD, "isAxiosError", { value: !0 });
ft.from = (e, r, t, a, o, l) => {
  const c = Object.create(cD);
  re.toFlatObject(e, c, function(u) {
    return u !== Error.prototype;
  }, (u) => u !== "isAxiosError");
  const f = e && e.message ? e.message : "Error", p = r == null && e ? e.code : r;
  return ft.call(c, f, p, t, a, o), e && c.cause == null && Object.defineProperty(c, "cause", { value: e, configurable: !0 }), c.name = e && e.name || "Error", l && Object.assign(c, l), c;
};
const gL = null;
function gp(e) {
  return re.isPlainObject(e) || re.isArray(e);
}
function fD(e) {
  return re.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function vS(e, r, t) {
  return e ? e.concat(r).map(function(a, o) {
    return a = fD(a), !t && o ? "[" + a + "]" : a;
  }).join(t ? "." : "") : r;
}
function DL(e) {
  return re.isArray(e) && !e.some(gp);
}
const RL = re.toFlatObject(re, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function pc(e, r, t) {
  if (!re.isObject(e))
    throw new TypeError("target must be an object");
  r = r || new FormData(), t = re.toFlatObject(t, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(_, S) {
    return !re.isUndefined(S[_]);
  });
  const a = t.metaTokens, o = t.visitor || u, l = t.dots, c = t.indexes, f = (t.Blob || typeof Blob < "u" && Blob) && re.isSpecCompliantForm(r);
  if (!re.isFunction(o))
    throw new TypeError("visitor must be a function");
  function p(_) {
    if (_ === null) return "";
    if (re.isDate(_))
      return _.toISOString();
    if (re.isBoolean(_))
      return _.toString();
    if (!f && re.isBlob(_))
      throw new ft("Blob is not supported. Use a Buffer instead.");
    return re.isArrayBuffer(_) || re.isTypedArray(_) ? f && typeof Blob == "function" ? new Blob([_]) : Buffer.from(_) : _;
  }
  function u(_, S, v) {
    let g = _;
    if (_ && !v && typeof _ == "object") {
      if (re.endsWith(S, "{}"))
        S = a ? S : S.slice(0, -2), _ = JSON.stringify(_);
      else if (re.isArray(_) && DL(_) || (re.isFileList(_) || re.endsWith(S, "[]")) && (g = re.toArray(_)))
        return S = fD(S), g.forEach(function(O, R) {
          !(re.isUndefined(O) || O === null) && r.append(
            // eslint-disable-next-line no-nested-ternary
            c === !0 ? vS([S], R, l) : c === null ? S : S + "[]",
            p(O)
          );
        }), !1;
    }
    return gp(_) ? !0 : (r.append(vS(v, S, l), p(_)), !1);
  }
  const h = [], C = Object.assign(RL, {
    defaultVisitor: u,
    convertValue: p,
    isVisitable: gp
  });
  function E(_, S) {
    if (!re.isUndefined(_)) {
      if (h.indexOf(_) !== -1)
        throw Error("Circular reference detected in " + S.join("."));
      h.push(_), re.forEach(_, function(v, g) {
        (!(re.isUndefined(v) || v === null) && o.call(
          r,
          v,
          re.isString(g) ? g.trim() : g,
          S,
          C
        )) === !0 && E(v, S ? S.concat(g) : [g]);
      }), h.pop();
    }
  }
  if (!re.isObject(e))
    throw new TypeError("data must be an object");
  return E(e), r;
}
function gS(e) {
  const r = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(t) {
    return r[t];
  });
}
function Rh(e, r) {
  this._pairs = [], e && pc(e, this, r);
}
const dD = Rh.prototype;
dD.append = function(e, r) {
  this._pairs.push([e, r]);
};
dD.toString = function(e) {
  const r = e ? function(t) {
    return e.call(this, t, gS);
  } : gS;
  return this._pairs.map(function(t) {
    return r(t[0]) + "=" + r(t[1]);
  }, "").join("&");
};
function AL(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function pD(e, r, t) {
  if (!r)
    return e;
  const a = t && t.encode || AL;
  re.isFunction(t) && (t = {
    serialize: t
  });
  const o = t && t.serialize;
  let l;
  if (o ? l = o(r, t) : l = re.isURLSearchParams(r) ? r.toString() : new Rh(r, t).toString(a), l) {
    const c = e.indexOf("#");
    c !== -1 && (e = e.slice(0, c)), e += (e.indexOf("?") === -1 ? "?" : "&") + l;
  }
  return e;
}
class DS {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(r, t, a) {
    return this.handlers.push({
      fulfilled: r,
      rejected: t,
      synchronous: a ? a.synchronous : !1,
      runWhen: a ? a.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(r) {
    this.handlers[r] && (this.handlers[r] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(r) {
    re.forEach(this.handlers, function(t) {
      t !== null && r(t);
    });
  }
}
const hD = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, TL = typeof URLSearchParams < "u" ? URLSearchParams : Rh, OL = typeof FormData < "u" ? FormData : null, yL = typeof Blob < "u" ? Blob : null, NL = {
  isBrowser: !0,
  classes: {
    URLSearchParams: TL,
    FormData: OL,
    Blob: yL
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, Ah = typeof window < "u" && typeof document < "u", Dp = typeof navigator == "object" && navigator || void 0, LL = Ah && (!Dp || ["ReactNative", "NativeScript", "NS"].indexOf(Dp.product) < 0), ML = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", bL = Ah && window.location.href || "http://localhost", PL = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: Ah,
  hasStandardBrowserEnv: LL,
  hasStandardBrowserWebWorkerEnv: ML,
  navigator: Dp,
  origin: bL
}, Symbol.toStringTag, { value: "Module" })), Hr = be(be({}, PL), NL);
function wL(e, r) {
  return pc(e, new Hr.classes.URLSearchParams(), be({
    visitor: function(t, a, o, l) {
      return Hr.isNode && re.isBuffer(t) ? (this.append(a, t.toString("base64")), !1) : l.defaultVisitor.apply(this, arguments);
    }
  }, r));
}
function HL(e) {
  return re.matchAll(/\w+|\[(\w*)]/g, e).map((r) => r[0] === "[]" ? "" : r[1] || r[0]);
}
function VL(e) {
  const r = {}, t = Object.keys(e);
  let a;
  const o = t.length;
  let l;
  for (a = 0; a < o; a++)
    l = t[a], r[l] = e[l];
  return r;
}
function mD(e) {
  function r(t, a, o, l) {
    let c = t[l++];
    if (c === "__proto__") return !0;
    const f = Number.isFinite(+c), p = l >= t.length;
    return c = !c && re.isArray(o) ? o.length : c, p ? (re.hasOwnProp(o, c) ? o[c] = [o[c], a] : o[c] = a, !f) : ((!o[c] || !re.isObject(o[c])) && (o[c] = []), r(t, a, o[c], l) && re.isArray(o[c]) && (o[c] = VL(o[c])), !f);
  }
  if (re.isFormData(e) && re.isFunction(e.entries)) {
    const t = {};
    return re.forEachEntry(e, (a, o) => {
      r(HL(a), o, t, 0);
    }), t;
  }
  return null;
}
function kL(e, r, t) {
  if (re.isString(e))
    try {
      return (r || JSON.parse)(e), re.trim(e);
    } catch (a) {
      if (a.name !== "SyntaxError")
        throw a;
    }
  return (t || JSON.stringify)(e);
}
const i2 = {
  transitional: hD,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, r) {
    const t = r.getContentType() || "", a = t.indexOf("application/json") > -1, o = re.isObject(e);
    if (o && re.isHTMLForm(e) && (e = new FormData(e)), re.isFormData(e))
      return a ? JSON.stringify(mD(e)) : e;
    if (re.isArrayBuffer(e) || re.isBuffer(e) || re.isStream(e) || re.isFile(e) || re.isBlob(e) || re.isReadableStream(e))
      return e;
    if (re.isArrayBufferView(e))
      return e.buffer;
    if (re.isURLSearchParams(e))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let l;
    if (o) {
      if (t.indexOf("application/x-www-form-urlencoded") > -1)
        return wL(e, this.formSerializer).toString();
      if ((l = re.isFileList(e)) || t.indexOf("multipart/form-data") > -1) {
        const c = this.env && this.env.FormData;
        return pc(
          l ? { "files[]": e } : e,
          c && new c(),
          this.formSerializer
        );
      }
    }
    return o || a ? (r.setContentType("application/json", !1), kL(e)) : e;
  }],
  transformResponse: [function(e) {
    const r = this.transitional || i2.transitional, t = r && r.forcedJSONParsing, a = this.responseType === "json";
    if (re.isResponse(e) || re.isReadableStream(e))
      return e;
    if (e && re.isString(e) && (t && !this.responseType || a)) {
      const o = !(r && r.silentJSONParsing) && a;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (l) {
        if (o)
          throw l.name === "SyntaxError" ? ft.from(l, ft.ERR_BAD_RESPONSE, this, null, this.response) : l;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Hr.classes.FormData,
    Blob: Hr.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
re.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  i2.headers[e] = {};
});
const FL = re.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), xL = (e) => {
  const r = {};
  let t, a, o;
  return e && e.split(`
`).forEach(function(l) {
    o = l.indexOf(":"), t = l.substring(0, o).trim().toLowerCase(), a = l.substring(o + 1).trim(), !(!t || r[t] && FL[t]) && (t === "set-cookie" ? r[t] ? r[t].push(a) : r[t] = [a] : r[t] = r[t] ? r[t] + ", " + a : a);
  }), r;
}, RS = Symbol("internals");
function ys(e) {
  return e && String(e).trim().toLowerCase();
}
function Vl(e) {
  return e === !1 || e == null ? e : re.isArray(e) ? e.map(Vl) : String(e);
}
function UL(e) {
  const r = /* @__PURE__ */ Object.create(null), t = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let a;
  for (; a = t.exec(e); )
    r[a[1]] = a[2];
  return r;
}
const BL = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Uf(e, r, t, a, o) {
  if (re.isFunction(a))
    return a.call(this, r, t);
  if (o && (r = t), !!re.isString(r)) {
    if (re.isString(a))
      return r.indexOf(a) !== -1;
    if (re.isRegExp(a))
      return a.test(r);
  }
}
function $L(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (r, t, a) => t.toUpperCase() + a);
}
function GL(e, r) {
  const t = re.toCamelCase(" " + r);
  ["get", "set", "has"].forEach((a) => {
    Object.defineProperty(e, a + t, {
      value: function(o, l, c) {
        return this[a].call(this, r, o, l, c);
      },
      configurable: !0
    });
  });
}
let Jr = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, r, t) {
    const a = this;
    function o(c, f, p) {
      const u = ys(f);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const h = re.findKey(a, u);
      (!h || a[h] === void 0 || p === !0 || p === void 0 && a[h] !== !1) && (a[h || f] = Vl(c));
    }
    const l = (c, f) => re.forEach(c, (p, u) => o(p, u, f));
    if (re.isPlainObject(e) || e instanceof this.constructor)
      l(e, r);
    else if (re.isString(e) && (e = e.trim()) && !BL(e))
      l(xL(e), r);
    else if (re.isObject(e) && re.isIterable(e)) {
      let c = {}, f, p;
      for (const u of e) {
        if (!re.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        c[p = u[0]] = (f = c[p]) ? re.isArray(f) ? [...f, u[1]] : [f, u[1]] : u[1];
      }
      l(c, r);
    } else
      e != null && o(r, e, t);
    return this;
  }
  get(e, r) {
    if (e = ys(e), e) {
      const t = re.findKey(this, e);
      if (t) {
        const a = this[t];
        if (!r)
          return a;
        if (r === !0)
          return UL(a);
        if (re.isFunction(r))
          return r.call(this, a, t);
        if (re.isRegExp(r))
          return r.exec(a);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, r) {
    if (e = ys(e), e) {
      const t = re.findKey(this, e);
      return !!(t && this[t] !== void 0 && (!r || Uf(this, this[t], t, r)));
    }
    return !1;
  }
  delete(e, r) {
    const t = this;
    let a = !1;
    function o(l) {
      if (l = ys(l), l) {
        const c = re.findKey(t, l);
        c && (!r || Uf(t, t[c], c, r)) && (delete t[c], a = !0);
      }
    }
    return re.isArray(e) ? e.forEach(o) : o(e), a;
  }
  clear(e) {
    const r = Object.keys(this);
    let t = r.length, a = !1;
    for (; t--; ) {
      const o = r[t];
      (!e || Uf(this, this[o], o, e, !0)) && (delete this[o], a = !0);
    }
    return a;
  }
  normalize(e) {
    const r = this, t = {};
    return re.forEach(this, (a, o) => {
      const l = re.findKey(t, o);
      if (l) {
        r[l] = Vl(a), delete r[o];
        return;
      }
      const c = e ? $L(o) : String(o).trim();
      c !== o && delete r[o], r[c] = Vl(a), t[c] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const r = /* @__PURE__ */ Object.create(null);
    return re.forEach(this, (t, a) => {
      t != null && t !== !1 && (r[a] = e && re.isArray(t) ? t.join(", ") : t);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, r]) => e + ": " + r).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...r) {
    const t = new this(e);
    return r.forEach((a) => t.set(a)), t;
  }
  static accessor(e) {
    const r = (this[RS] = this[RS] = {
      accessors: {}
    }).accessors, t = this.prototype;
    function a(o) {
      const l = ys(o);
      r[l] || (GL(t, o), r[l] = !0);
    }
    return re.isArray(e) ? e.forEach(a) : a(e), this;
  }
};
Jr.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
re.reduceDescriptors(Jr.prototype, ({ value: e }, r) => {
  let t = r[0].toUpperCase() + r.slice(1);
  return {
    get: () => e,
    set(a) {
      this[t] = a;
    }
  };
});
re.freezeMethods(Jr);
function Bf(e, r) {
  const t = this || i2, a = r || t, o = Jr.from(a.headers);
  let l = a.data;
  return re.forEach(e, function(c) {
    l = c.call(t, l, o.normalize(), r ? r.status : void 0);
  }), o.normalize(), l;
}
function _D(e) {
  return !!(e && e.__CANCEL__);
}
function Go(e, r, t) {
  ft.call(this, e != null ? e : "canceled", ft.ERR_CANCELED, r, t), this.name = "CanceledError";
}
re.inherits(Go, ft, {
  __CANCEL__: !0
});
function ED(e, r, t) {
  const a = t.config.validateStatus;
  !t.status || !a || a(t.status) ? e(t) : r(new ft(
    "Request failed with status code " + t.status,
    [ft.ERR_BAD_REQUEST, ft.ERR_BAD_RESPONSE][Math.floor(t.status / 100) - 4],
    t.config,
    t.request,
    t
  ));
}
function ZL(e) {
  const r = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return r && r[1] || "";
}
function jL(e, r) {
  e = e || 10;
  const t = new Array(e), a = new Array(e);
  let o = 0, l = 0, c;
  return r = r !== void 0 ? r : 1e3, function(f) {
    const p = Date.now(), u = a[l];
    c || (c = p), t[o] = f, a[o] = p;
    let h = l, C = 0;
    for (; h !== o; )
      C += t[h++], h = h % e;
    if (o = (o + 1) % e, o === l && (l = (l + 1) % e), p - c < r)
      return;
    const E = u && p - u;
    return E ? Math.round(C * 1e3 / E) : void 0;
  };
}
function zL(e, r) {
  let t = 0, a = 1e3 / r, o, l;
  const c = (f, p = Date.now()) => {
    t = p, o = null, l && (clearTimeout(l), l = null), e(...f);
  };
  return [(...f) => {
    const p = Date.now(), u = p - t;
    u >= a ? c(f, p) : (o = f, l || (l = setTimeout(() => {
      l = null, c(o);
    }, a - u)));
  }, () => o && c(o)];
}
const ql = (e, r, t = 3) => {
  let a = 0;
  const o = jL(50, 250);
  return zL((l) => {
    const c = l.loaded, f = l.lengthComputable ? l.total : void 0, p = c - a, u = o(p), h = c <= f;
    a = c;
    const C = {
      loaded: c,
      total: f,
      progress: f ? c / f : void 0,
      bytes: p,
      rate: u || void 0,
      estimated: u && f && h ? (f - c) / u : void 0,
      event: l,
      lengthComputable: f != null,
      [r ? "download" : "upload"]: !0
    };
    e(C);
  }, t);
}, AS = (e, r) => {
  const t = e != null;
  return [(a) => r[0]({
    lengthComputable: t,
    total: e,
    loaded: a
  }), r[1]];
}, TS = (e) => (...r) => re.asap(() => e(...r)), qL = Hr.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, r) => (t) => (t = new URL(t, Hr.origin), e.protocol === t.protocol && e.host === t.host && (r || e.port === t.port)))(
  new URL(Hr.origin),
  Hr.navigator && /(msie|trident)/i.test(Hr.navigator.userAgent)
) : () => !0, WL = Hr.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, r, t, a, o, l) {
      const c = [e + "=" + encodeURIComponent(r)];
      re.isNumber(t) && c.push("expires=" + new Date(t).toGMTString()), re.isString(a) && c.push("path=" + a), re.isString(o) && c.push("domain=" + o), l === !0 && c.push("secure"), document.cookie = c.join("; ");
    },
    read(e) {
      const r = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return r ? decodeURIComponent(r[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function YL(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function KL(e, r) {
  return r ? e.replace(/\/?\/$/, "") + "/" + r.replace(/^\/+/, "") : e;
}
function CD(e, r, t) {
  let a = !YL(r);
  return e && (a || t == !1) ? KL(e, r) : r;
}
const OS = (e) => e instanceof Jr ? be({}, e) : e;
function Va(e, r) {
  r = r || {};
  const t = {};
  function a(u, h, C, E) {
    return re.isPlainObject(u) && re.isPlainObject(h) ? re.merge.call({ caseless: E }, u, h) : re.isPlainObject(h) ? re.merge({}, h) : re.isArray(h) ? h.slice() : h;
  }
  function o(u, h, C, E) {
    if (re.isUndefined(h)) {
      if (!re.isUndefined(u))
        return a(void 0, u, C, E);
    } else return a(u, h, C, E);
  }
  function l(u, h) {
    if (!re.isUndefined(h))
      return a(void 0, h);
  }
  function c(u, h) {
    if (re.isUndefined(h)) {
      if (!re.isUndefined(u))
        return a(void 0, u);
    } else return a(void 0, h);
  }
  function f(u, h, C) {
    if (C in r)
      return a(u, h);
    if (C in e)
      return a(void 0, u);
  }
  const p = {
    url: l,
    method: l,
    data: l,
    baseURL: c,
    transformRequest: c,
    transformResponse: c,
    paramsSerializer: c,
    timeout: c,
    timeoutMessage: c,
    withCredentials: c,
    withXSRFToken: c,
    adapter: c,
    responseType: c,
    xsrfCookieName: c,
    xsrfHeaderName: c,
    onUploadProgress: c,
    onDownloadProgress: c,
    decompress: c,
    maxContentLength: c,
    maxBodyLength: c,
    beforeRedirect: c,
    transport: c,
    httpAgent: c,
    httpsAgent: c,
    cancelToken: c,
    socketPath: c,
    responseEncoding: c,
    validateStatus: f,
    headers: (u, h, C) => o(OS(u), OS(h), C, !0)
  };
  return re.forEach(Object.keys(be(be({}, e), r)), function(u) {
    const h = p[u] || o, C = h(e[u], r[u], u);
    re.isUndefined(C) && h !== f || (t[u] = C);
  }), t;
}
const SD = (e) => {
  const r = Va({}, e);
  let { data: t, withXSRFToken: a, xsrfHeaderName: o, xsrfCookieName: l, headers: c, auth: f } = r;
  if (r.headers = c = Jr.from(c), r.url = pD(CD(r.baseURL, r.url, r.allowAbsoluteUrls), e.params, e.paramsSerializer), f && c.set(
    "Authorization",
    "Basic " + btoa((f.username || "") + ":" + (f.password ? unescape(encodeURIComponent(f.password)) : ""))
  ), re.isFormData(t)) {
    if (Hr.hasStandardBrowserEnv || Hr.hasStandardBrowserWebWorkerEnv)
      c.setContentType(void 0);
    else if (re.isFunction(t.getHeaders)) {
      const p = t.getHeaders(), u = ["content-type", "content-length"];
      Object.entries(p).forEach(([h, C]) => {
        u.includes(h.toLowerCase()) && c.set(h, C);
      });
    }
  }
  if (Hr.hasStandardBrowserEnv && (a && re.isFunction(a) && (a = a(r)), a || a !== !1 && qL(r.url))) {
    const p = o && l && WL.read(l);
    p && c.set(o, p);
  }
  return r;
}, XL = typeof XMLHttpRequest < "u", QL = XL && function(e) {
  return new Promise(function(r, t) {
    const a = SD(e);
    let o = a.data;
    const l = Jr.from(a.headers).normalize();
    let { responseType: c, onUploadProgress: f, onDownloadProgress: p } = a, u, h, C, E, _;
    function S() {
      E && E(), _ && _(), a.cancelToken && a.cancelToken.unsubscribe(u), a.signal && a.signal.removeEventListener("abort", u);
    }
    let v = new XMLHttpRequest();
    v.open(a.method.toUpperCase(), a.url, !0), v.timeout = a.timeout;
    function g() {
      if (!v)
        return;
      const R = Jr.from(
        "getAllResponseHeaders" in v && v.getAllResponseHeaders()
      ), D = {
        data: !c || c === "text" || c === "json" ? v.responseText : v.response,
        status: v.status,
        statusText: v.statusText,
        headers: R,
        config: e,
        request: v
      };
      ED(function(T) {
        r(T), S();
      }, function(T) {
        t(T), S();
      }, D), v = null;
    }
    "onloadend" in v ? v.onloadend = g : v.onreadystatechange = function() {
      !v || v.readyState !== 4 || v.status === 0 && !(v.responseURL && v.responseURL.indexOf("file:") === 0) || setTimeout(g);
    }, v.onabort = function() {
      v && (t(new ft("Request aborted", ft.ECONNABORTED, e, v)), v = null);
    }, v.onerror = function(R) {
      const D = R && R.message ? R.message : "Network Error", T = new ft(D, ft.ERR_NETWORK, e, v);
      T.event = R || null, t(T), v = null;
    }, v.ontimeout = function() {
      let R = a.timeout ? "timeout of " + a.timeout + "ms exceeded" : "timeout exceeded";
      const D = a.transitional || hD;
      a.timeoutErrorMessage && (R = a.timeoutErrorMessage), t(new ft(
        R,
        D.clarifyTimeoutError ? ft.ETIMEDOUT : ft.ECONNABORTED,
        e,
        v
      )), v = null;
    }, o === void 0 && l.setContentType(null), "setRequestHeader" in v && re.forEach(l.toJSON(), function(R, D) {
      v.setRequestHeader(D, R);
    }), re.isUndefined(a.withCredentials) || (v.withCredentials = !!a.withCredentials), c && c !== "json" && (v.responseType = a.responseType), p && ([C, _] = ql(p, !0), v.addEventListener("progress", C)), f && v.upload && ([h, E] = ql(f), v.upload.addEventListener("progress", h), v.upload.addEventListener("loadend", E)), (a.cancelToken || a.signal) && (u = (R) => {
      v && (t(!R || R.type ? new Go(null, e, v) : R), v.abort(), v = null);
    }, a.cancelToken && a.cancelToken.subscribe(u), a.signal && (a.signal.aborted ? u() : a.signal.addEventListener("abort", u)));
    const O = ZL(a.url);
    if (O && Hr.protocols.indexOf(O) === -1) {
      t(new ft("Unsupported protocol " + O + ":", ft.ERR_BAD_REQUEST, e));
      return;
    }
    v.send(o || null);
  });
}, JL = (e, r) => {
  const { length: t } = e = e ? e.filter(Boolean) : [];
  if (r || t) {
    let a = new AbortController(), o;
    const l = function(u) {
      if (!o) {
        o = !0, f();
        const h = u instanceof Error ? u : this.reason;
        a.abort(h instanceof ft ? h : new Go(h instanceof Error ? h.message : h));
      }
    };
    let c = r && setTimeout(() => {
      c = null, l(new ft(`timeout ${r} of ms exceeded`, ft.ETIMEDOUT));
    }, r);
    const f = () => {
      e && (c && clearTimeout(c), c = null, e.forEach((u) => {
        u.unsubscribe ? u.unsubscribe(l) : u.removeEventListener("abort", l);
      }), e = null);
    };
    e.forEach((u) => u.addEventListener("abort", l));
    const { signal: p } = a;
    return p.unsubscribe = () => re.asap(f), p;
  }
}, eM = function* (e, r) {
  let t = e.byteLength;
  if (t < r) {
    yield e;
    return;
  }
  let a = 0, o;
  for (; a < t; )
    o = a + r, yield e.slice(a, o), a = o;
}, tM = function(e, r) {
  return r0(this, null, function* () {
    try {
      for (var t = J_(rM(e)), a, o, l; a = !(o = yield new ya(t.next())).done; a = !1) {
        const c = o.value;
        yield* n0(eM(c, r));
      }
    } catch (o) {
      l = [o];
    } finally {
      try {
        a && (o = t.return) && (yield new ya(o.call(t)));
      } finally {
        if (l)
          throw l[0];
      }
    }
  });
}, rM = function(e) {
  return r0(this, null, function* () {
    if (e[Symbol.asyncIterator]) {
      yield* n0(e);
      return;
    }
    const r = e.getReader();
    try {
      for (; ; ) {
        const { done: t, value: a } = yield new ya(r.read());
        if (t)
          break;
        yield a;
      }
    } finally {
      yield new ya(r.cancel());
    }
  });
}, yS = (e, r, t, a) => {
  const o = tM(e, r);
  let l = 0, c, f = (u) => {
    c || (c = !0, a && a(u));
  };
  return new ReadableStream({
    pull(u) {
      return Ae(this, null, function* () {
        try {
          const { done: h, value: C } = yield o.next();
          if (h) {
            f(), u.close();
            return;
          }
          let E = C.byteLength;
          if (t) {
            let _ = l += E;
            t(_);
          }
          u.enqueue(new Uint8Array(C));
        } catch (h) {
          throw f(h), h;
        }
      });
    },
    cancel(u) {
      return f(u), o.return();
    }
  }, {
    highWaterMark: 2
  });
}, NS = 64 * 1024, { isFunction: gl } = re, nM = (({ Request: e, Response: r }) => ({
  Request: e,
  Response: r
}))(re.global), {
  ReadableStream: LS,
  TextEncoder: MS
} = re.global, bS = (e, ...r) => {
  try {
    return !!e(...r);
  } catch (t) {
    return !1;
  }
}, iM = (e) => {
  e = re.merge.call({
    skipUndefined: !0
  }, nM, e);
  const { fetch: r, Request: t, Response: a } = e, o = r ? gl(r) : typeof fetch == "function", l = gl(t), c = gl(a);
  if (!o)
    return !1;
  const f = o && gl(LS), p = o && (typeof MS == "function" ? /* @__PURE__ */ ((S) => (v) => S.encode(v))(new MS()) : (S) => Ae(null, null, function* () {
    return new Uint8Array(yield new t(S).arrayBuffer());
  })), u = l && f && bS(() => {
    let S = !1;
    const v = new t(Hr.origin, {
      body: new LS(),
      method: "POST",
      get duplex() {
        return S = !0, "half";
      }
    }).headers.has("Content-Type");
    return S && !v;
  }), h = c && f && bS(() => re.isReadableStream(new a("").body)), C = {
    stream: h && ((S) => S.body)
  };
  o && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((S) => {
    !C[S] && (C[S] = (v, g) => {
      let O = v && v[S];
      if (O)
        return O.call(v);
      throw new ft(`Response type '${S}' is not supported`, ft.ERR_NOT_SUPPORT, g);
    });
  });
  const E = (S) => Ae(null, null, function* () {
    if (S == null)
      return 0;
    if (re.isBlob(S))
      return S.size;
    if (re.isSpecCompliantForm(S))
      return (yield new t(Hr.origin, {
        method: "POST",
        body: S
      }).arrayBuffer()).byteLength;
    if (re.isArrayBufferView(S) || re.isArrayBuffer(S))
      return S.byteLength;
    if (re.isURLSearchParams(S) && (S = S + ""), re.isString(S))
      return (yield p(S)).byteLength;
  }), _ = (S, v) => Ae(null, null, function* () {
    const g = re.toFiniteNumber(S.getContentLength());
    return g != null ? g : E(v);
  });
  return (S) => Ae(null, null, function* () {
    let {
      url: v,
      method: g,
      data: O,
      signal: R,
      cancelToken: D,
      timeout: T,
      onDownloadProgress: L,
      onUploadProgress: P,
      responseType: M,
      headers: k,
      withCredentials: H = "same-origin",
      fetchOptions: w
    } = SD(S), $ = r || fetch;
    M = M ? (M + "").toLowerCase() : "text";
    let B = JL([R, D && D.toAbortSignal()], T), Y = null;
    const j = B && B.unsubscribe && (() => {
      B.unsubscribe();
    });
    let ie;
    try {
      if (P && u && g !== "get" && g !== "head" && (ie = yield _(k, O)) !== 0) {
        let y = new t(v, {
          method: "POST",
          body: O,
          duplex: "half"
        }), G;
        if (re.isFormData(O) && (G = y.headers.get("content-type")) && k.setContentType(G), y.body) {
          const [ce, ue] = AS(
            ie,
            ql(TS(P))
          );
          O = yS(y.body, NS, ce, ue);
        }
      }
      re.isString(H) || (H = H ? "include" : "omit");
      const se = l && "credentials" in t.prototype, le = Qi(be({}, w), {
        signal: B,
        method: g.toUpperCase(),
        headers: k.normalize().toJSON(),
        body: O,
        duplex: "half",
        credentials: se ? H : void 0
      });
      Y = l && new t(v, le);
      let U = yield l ? $(Y, w) : $(v, le);
      const X = h && (M === "stream" || M === "response");
      if (h && (L || X && j)) {
        const y = {};
        ["status", "statusText", "headers"].forEach((ee) => {
          y[ee] = U[ee];
        });
        const G = re.toFiniteNumber(U.headers.get("content-length")), [ce, ue] = L && AS(
          G,
          ql(TS(L), !0)
        ) || [];
        U = new a(
          yS(U.body, NS, ce, () => {
            ue && ue(), j && j();
          }),
          y
        );
      }
      M = M || "text";
      let K = yield C[re.findKey(C, M) || "text"](U, S);
      return !X && j && j(), yield new Promise((y, G) => {
        ED(y, G, {
          data: K,
          headers: Jr.from(U.headers),
          status: U.status,
          statusText: U.statusText,
          config: S,
          request: Y
        });
      });
    } catch (se) {
      throw j && j(), se && se.name === "TypeError" && /Load failed|fetch/i.test(se.message) ? Object.assign(
        new ft("Network Error", ft.ERR_NETWORK, S, Y),
        {
          cause: se.cause || se
        }
      ) : ft.from(se, se && se.code, S, Y);
    }
  });
}, aM = /* @__PURE__ */ new Map(), ID = (e) => {
  let r = e ? e.env : {};
  const { fetch: t, Request: a, Response: o } = r, l = [
    a,
    o,
    t
  ];
  let c = l.length, f = c, p, u, h = aM;
  for (; f--; )
    p = l[f], u = h.get(p), u === void 0 && h.set(p, u = f ? /* @__PURE__ */ new Map() : iM(r)), h = u;
  return u;
};
ID();
const Rp = {
  http: gL,
  xhr: QL,
  fetch: {
    get: ID
  }
};
re.forEach(Rp, (e, r) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: r });
    } catch (t) {
    }
    Object.defineProperty(e, "adapterName", { value: r });
  }
});
const PS = (e) => `- ${e}`, oM = (e) => re.isFunction(e) || e === null || e === !1, vD = {
  getAdapter: (e, r) => {
    e = re.isArray(e) ? e : [e];
    const { length: t } = e;
    let a, o;
    const l = {};
    for (let c = 0; c < t; c++) {
      a = e[c];
      let f;
      if (o = a, !oM(a) && (o = Rp[(f = String(a)).toLowerCase()], o === void 0))
        throw new ft(`Unknown adapter '${f}'`);
      if (o && (re.isFunction(o) || (o = o.get(r))))
        break;
      l[f || "#" + c] = o;
    }
    if (!o) {
      const c = Object.entries(l).map(
        ([p, u]) => `adapter ${p} ` + (u === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let f = t ? c.length > 1 ? `since :
` + c.map(PS).join(`
`) : " " + PS(c[0]) : "as no adapter specified";
      throw new ft(
        "There is no suitable adapter to dispatch the request " + f,
        "ERR_NOT_SUPPORT"
      );
    }
    return o;
  },
  adapters: Rp
};
function $f(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new Go(null, e);
}
function wS(e) {
  return $f(e), e.headers = Jr.from(e.headers), e.data = Bf.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), vD.getAdapter(e.adapter || i2.adapter, e)(e).then(function(r) {
    return $f(e), r.data = Bf.call(
      e,
      e.transformResponse,
      r
    ), r.headers = Jr.from(r.headers), r;
  }, function(r) {
    return _D(r) || ($f(e), r && r.response && (r.response.data = Bf.call(
      e,
      e.transformResponse,
      r.response
    ), r.response.headers = Jr.from(r.response.headers))), Promise.reject(r);
  });
}
const gD = "1.12.2", hc = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, r) => {
  hc[e] = function(t) {
    return typeof t === e || "a" + (r < 1 ? "n " : " ") + e;
  };
});
const HS = {};
hc.transitional = function(e, r, t) {
  function a(o, l) {
    return "[Axios v" + gD + "] Transitional option '" + o + "'" + l + (t ? ". " + t : "");
  }
  return (o, l, c) => {
    if (e === !1)
      throw new ft(
        a(l, " has been removed" + (r ? " in " + r : "")),
        ft.ERR_DEPRECATED
      );
    return r && !HS[l] && (HS[l] = !0, console.warn(
      a(
        l,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(o, l, c) : !0;
  };
};
hc.spelling = function(e) {
  return (r, t) => (console.warn(`${t} is likely a misspelling of ${e}`), !0);
};
function sM(e, r, t) {
  if (typeof e != "object")
    throw new ft("options must be an object", ft.ERR_BAD_OPTION_VALUE);
  const a = Object.keys(e);
  let o = a.length;
  for (; o-- > 0; ) {
    const l = a[o], c = r[l];
    if (c) {
      const f = e[l], p = f === void 0 || c(f, l, e);
      if (p !== !0)
        throw new ft("option " + l + " must be " + p, ft.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (t !== !0)
      throw new ft("Unknown option " + l, ft.ERR_BAD_OPTION);
  }
}
const kl = {
  assertOptions: sM,
  validators: hc
}, si = kl.validators;
let Pa = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new DS(),
      response: new DS()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  request(e, r) {
    return Ae(this, null, function* () {
      try {
        return yield this._request(e, r);
      } catch (t) {
        if (t instanceof Error) {
          let a = {};
          Error.captureStackTrace ? Error.captureStackTrace(a) : a = new Error();
          const o = a.stack ? a.stack.replace(/^.+\n/, "") : "";
          try {
            t.stack ? o && !String(t.stack).endsWith(o.replace(/^.+\n.+\n/, "")) && (t.stack += `
` + o) : t.stack = o;
          } catch (l) {
          }
        }
        throw t;
      }
    });
  }
  _request(e, r) {
    typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = Va(this.defaults, r);
    const { transitional: t, paramsSerializer: a, headers: o } = r;
    t !== void 0 && kl.assertOptions(t, {
      silentJSONParsing: si.transitional(si.boolean),
      forcedJSONParsing: si.transitional(si.boolean),
      clarifyTimeoutError: si.transitional(si.boolean)
    }, !1), a != null && (re.isFunction(a) ? r.paramsSerializer = {
      serialize: a
    } : kl.assertOptions(a, {
      encode: si.function,
      serialize: si.function
    }, !0)), r.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? r.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : r.allowAbsoluteUrls = !0), kl.assertOptions(r, {
      baseUrl: si.spelling("baseURL"),
      withXsrfToken: si.spelling("withXSRFToken")
    }, !0), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let l = o && re.merge(
      o.common,
      o[r.method]
    );
    o && re.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (_) => {
        delete o[_];
      }
    ), r.headers = Jr.concat(l, o);
    const c = [];
    let f = !0;
    this.interceptors.request.forEach(function(_) {
      typeof _.runWhen == "function" && _.runWhen(r) === !1 || (f = f && _.synchronous, c.unshift(_.fulfilled, _.rejected));
    });
    const p = [];
    this.interceptors.response.forEach(function(_) {
      p.push(_.fulfilled, _.rejected);
    });
    let u, h = 0, C;
    if (!f) {
      const _ = [wS.bind(this), void 0];
      for (_.unshift(...c), _.push(...p), C = _.length, u = Promise.resolve(r); h < C; )
        u = u.then(_[h++], _[h++]);
      return u;
    }
    C = c.length;
    let E = r;
    for (; h < C; ) {
      const _ = c[h++], S = c[h++];
      try {
        E = _(E);
      } catch (v) {
        S.call(this, v);
        break;
      }
    }
    try {
      u = wS.call(this, E);
    } catch (_) {
      return Promise.reject(_);
    }
    for (h = 0, C = p.length; h < C; )
      u = u.then(p[h++], p[h++]);
    return u;
  }
  getUri(e) {
    e = Va(this.defaults, e);
    const r = CD(e.baseURL, e.url, e.allowAbsoluteUrls);
    return pD(r, e.params, e.paramsSerializer);
  }
};
re.forEach(["delete", "get", "head", "options"], function(e) {
  Pa.prototype[e] = function(r, t) {
    return this.request(Va(t || {}, {
      method: e,
      url: r,
      data: (t || {}).data
    }));
  };
});
re.forEach(["post", "put", "patch"], function(e) {
  function r(t) {
    return function(a, o, l) {
      return this.request(Va(l || {}, {
        method: e,
        headers: t ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: o
      }));
    };
  }
  Pa.prototype[e] = r(), Pa.prototype[e + "Form"] = r(!0);
});
let lM = class DD {
  constructor(r) {
    if (typeof r != "function")
      throw new TypeError("executor must be a function.");
    let t;
    this.promise = new Promise(function(o) {
      t = o;
    });
    const a = this;
    this.promise.then((o) => {
      if (!a._listeners) return;
      let l = a._listeners.length;
      for (; l-- > 0; )
        a._listeners[l](o);
      a._listeners = null;
    }), this.promise.then = (o) => {
      let l;
      const c = new Promise((f) => {
        a.subscribe(f), l = f;
      }).then(o);
      return c.cancel = function() {
        a.unsubscribe(l);
      }, c;
    }, r(function(o, l, c) {
      a.reason || (a.reason = new Go(o, l, c), t(a.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(r) {
    if (this.reason) {
      r(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(r) : this._listeners = [r];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(r) {
    if (!this._listeners)
      return;
    const t = this._listeners.indexOf(r);
    t !== -1 && this._listeners.splice(t, 1);
  }
  toAbortSignal() {
    const r = new AbortController(), t = (a) => {
      r.abort(a);
    };
    return this.subscribe(t), r.signal.unsubscribe = () => this.unsubscribe(t), r.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let r;
    return {
      token: new DD(function(t) {
        r = t;
      }),
      cancel: r
    };
  }
};
function cM(e) {
  return function(r) {
    return e.apply(null, r);
  };
}
function uM(e) {
  return re.isObject(e) && e.isAxiosError === !0;
}
const Ap = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Ap).forEach(([e, r]) => {
  Ap[r] = e;
});
function RD(e) {
  const r = new Pa(e), t = tD(Pa.prototype.request, r);
  return re.extend(t, Pa.prototype, r, { allOwnKeys: !0 }), re.extend(t, r, null, { allOwnKeys: !0 }), t.create = function(a) {
    return RD(Va(e, a));
  }, t;
}
const Rt = RD(i2);
Rt.Axios = Pa;
Rt.CanceledError = Go;
Rt.CancelToken = lM;
Rt.isCancel = _D;
Rt.VERSION = gD;
Rt.toFormData = pc;
Rt.AxiosError = ft;
Rt.Cancel = Rt.CanceledError;
Rt.all = function(e) {
  return Promise.all(e);
};
Rt.spread = cM;
Rt.isAxiosError = uM;
Rt.mergeConfig = Va;
Rt.AxiosHeaders = Jr;
Rt.formToJSON = (e) => mD(re.isHTMLForm(e) ? new FormData(e) : e);
Rt.getAdapter = vD.getAdapter;
Rt.HttpStatusCode = Ap;
Rt.default = Rt;
const {
  Axios: d1e,
  AxiosError: p1e,
  CanceledError: h1e,
  isCancel: m1e,
  CancelToken: _1e,
  VERSION: E1e,
  all: C1e,
  Cancel: S1e,
  isAxiosError: I1e,
  spread: v1e,
  toFormData: g1e,
  AxiosHeaders: D1e,
  HttpStatusCode: R1e,
  formToJSON: A1e,
  getAdapter: T1e,
  mergeConfig: O1e
} = Rt, pn = "https://api.regulaforensics.com".replace(/\/+$/, "");
class mc {
  constructor(r, t = pn, a = Rt) {
    var o;
    this.basePath = t, this.axios = a, r && (this.configuration = r, this.basePath = (o = r.basePath) != null ? o : t);
  }
}
class fM extends Error {
  constructor(r, t) {
    super(t), this.field = r, this.name = "RequiredError";
  }
}
const Bn = {}, $n = "https://example.com", Oi = function(e, r, t) {
  if (t == null)
    throw new fM(r, `Required parameter ${r} was null or undefined when calling ${e}.`);
};
function Tp(e, r, t = "") {
  r != null && (typeof r == "object" ? Array.isArray(r) ? r.forEach((a) => Tp(e, a, t)) : Object.keys(r).forEach(
    (a) => Tp(e, r[a], `${t}${t !== "" ? "." : ""}${a}`)
  ) : e.has(t) ? e.append(t, r) : e.set(t, r));
}
const Gn = function(e, ...r) {
  const t = new URLSearchParams(e.search);
  Tp(t, r), e.search = t.toString();
}, AD = function(e, r, t) {
  const a = typeof e != "string";
  return (a && t && t.isJsonMime ? t.isJsonMime(r.headers["Content-Type"]) : a) ? JSON.stringify(e !== void 0 ? e : {}) : e || "";
}, Zn = function(e) {
  return e.pathname + e.search + e.hash;
}, jn = function(e, r, t, a) {
  return (o = r, l = t) => {
    var f;
    const c = Qi(be({}, e.options), { url: (o.defaults.baseURL ? "" : (f = a == null ? void 0 : a.basePath) != null ? f : l) + e.url });
    return o.request(c);
  };
}, dM = function(e) {
  return {
    /**
     * 
     * @summary Server health check
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthz: (a, ...o) => Ae(null, [a, ...o], function* (r, t = {}) {
      const l = "/api/healthz", c = new URL(l, $n);
      let f;
      e && (f = e.baseOptions);
      const p = be(be({ method: "GET" }, f), t), u = {}, h = {};
      r != null && (u["X-RequestID"] = String(r)), Gn(c, h);
      let C = f && f.headers ? f.headers : {};
      return p.headers = be(be(be({}, u), C), t.headers), {
        url: Zn(c),
        options: p
      };
    }),
    /**
     * 
     * @summary Server health check
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    ping: (a, ...o) => Ae(null, [a, ...o], function* (r, t = {}) {
      const l = "/api/ping", c = new URL(l, $n);
      let f;
      e && (f = e.baseOptions);
      const p = be(be({ method: "GET" }, f), t), u = {}, h = {};
      r != null && (u["X-RequestID"] = String(r)), Gn(c, h);
      let C = f && f.headers ? f.headers : {};
      return p.headers = be(be(be({}, u), C), t.headers), {
        url: Zn(c),
        options: p
      };
    }),
    /**
     * 
     * @summary License health check
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    readyz: (a, ...o) => Ae(null, [a, ...o], function* (r, t = {}) {
      const l = "/api/readyz", c = new URL(l, $n);
      let f;
      e && (f = e.baseOptions);
      const p = be(be({ method: "GET" }, f), t), u = {}, h = {};
      r != null && (u["X-RequestID"] = String(r)), Gn(c, h);
      let C = f && f.headers ? f.headers : {};
      return p.headers = be(be(be({}, u), C), t.headers), {
        url: Zn(c),
        options: p
      };
    })
  };
}, Gf = function(e) {
  const r = dM(e);
  return {
    /**
     * 
     * @summary Server health check
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    healthz(a, o) {
      return Ae(this, null, function* () {
        var p, u, h;
        const l = yield r.healthz(a, o), c = (p = e == null ? void 0 : e.serverIndex) != null ? p : 0, f = (h = (u = Bn["HealthcheckApi.healthz"]) == null ? void 0 : u[c]) == null ? void 0 : h.url;
        return (C, E) => jn(l, Rt, pn, e)(C, f || E);
      });
    },
    /**
     * 
     * @summary Server health check
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     */
    ping(a, o) {
      return Ae(this, null, function* () {
        var p, u, h;
        const l = yield r.ping(a, o), c = (p = e == null ? void 0 : e.serverIndex) != null ? p : 0, f = (h = (u = Bn["HealthcheckApi.ping"]) == null ? void 0 : u[c]) == null ? void 0 : h.url;
        return (C, E) => jn(l, Rt, pn, e)(C, f || E);
      });
    },
    /**
     * 
     * @summary License health check
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    readyz(a, o) {
      return Ae(this, null, function* () {
        var p, u, h;
        const l = yield r.readyz(a, o), c = (p = e == null ? void 0 : e.serverIndex) != null ? p : 0, f = (h = (u = Bn["HealthcheckApi.readyz"]) == null ? void 0 : u[c]) == null ? void 0 : h.url;
        return (C, E) => jn(l, Rt, pn, e)(C, f || E);
      });
    }
  };
};
class pM extends mc {
  /**
   * 
   * @summary Server health check
   * @param {string} [xRequestID] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HealthcheckApi
   */
  healthz(r, t) {
    return Gf(this.configuration).healthz(r, t).then((a) => a(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Server health check
   * @param {string} [xRequestID] 
   * @param {*} [options] Override http request option.
   * @deprecated
   * @throws {RequiredError}
   * @memberof HealthcheckApi
   */
  ping(r, t) {
    return Gf(this.configuration).ping(r, t).then((a) => a(this.axios, this.basePath));
  }
  /**
   * 
   * @summary License health check
   * @param {string} [xRequestID] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof HealthcheckApi
   */
  readyz(r, t) {
    return Gf(this.configuration).readyz(r, t).then((a) => a(this.axios, this.basePath));
  }
}
const hM = function(e) {
  return {
    /**
     * 
     * @summary Process list of documents images and return extracted data
     * @param {ProcessRequest} processRequest 
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcess: (o, l, ...c) => Ae(null, [o, l, ...c], function* (r, t, a = {}) {
      Oi("apiProcess", "processRequest", r);
      const f = "/api/process", p = new URL(f, $n);
      let u;
      e && (u = e.baseOptions);
      const h = be(be({ method: "POST" }, u), a), C = {}, E = {};
      C["Content-Type"] = "application/json", t != null && (C["X-RequestID"] = String(t)), Gn(p, E);
      let _ = u && u.headers ? u.headers : {};
      return h.headers = be(be(be({}, C), _), a.headers), h.data = AD(r, h, e), {
        url: Zn(p),
        options: h
      };
    })
  };
}, mM = function(e) {
  const r = hM(e);
  return {
    /**
     * 
     * @summary Process list of documents images and return extracted data
     * @param {ProcessRequest} processRequest 
     * @param {string} [xRequestID] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiProcess(a, o, l) {
      return Ae(this, null, function* () {
        var u, h, C;
        const c = yield r.apiProcess(a, o, l), f = (u = e == null ? void 0 : e.serverIndex) != null ? u : 0, p = (C = (h = Bn["ProcessApi.apiProcess"]) == null ? void 0 : h[f]) == null ? void 0 : C.url;
        return (E, _) => jn(c, Rt, pn, e)(E, p || _);
      });
    }
  };
};
class _M extends mc {
  /**
   * 
   * @summary Process list of documents images and return extracted data
   * @param {ProcessRequest} processRequest 
   * @param {string} [xRequestID] 
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ProcessApi
   */
  apiProcess(r, t, a) {
    return mM(this.configuration).apiProcess(r, t, a).then((o) => o(this.axios, this.basePath));
  }
}
const EM = function(e) {
  return {
    /**
     * 
     * @summary Delete Reprocess transactions by tag
     * @param {string} tagId Tag id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TagTagIdDelete: (a, ...o) => Ae(null, [a, ...o], function* (r, t = {}) {
      Oi("apiV2TagTagIdDelete", "tagId", r);
      const l = "/api/v2/tag/{tagId}".replace("{tagId}", encodeURIComponent(String(r))), c = new URL(l, $n);
      let f;
      e && (f = e.baseOptions);
      const p = be(be({ method: "DELETE" }, f), t), u = {};
      Gn(c, {});
      let h = f && f.headers ? f.headers : {};
      return p.headers = be(be(be({}, u), h), t.headers), {
        url: Zn(c),
        options: p
      };
    }),
    /**
     * 
     * @summary Get transactions by tag
     * @param {string} tagId Tag id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TagTagIdTransactionsGet: (a, ...o) => Ae(null, [a, ...o], function* (r, t = {}) {
      Oi("apiV2TagTagIdTransactionsGet", "tagId", r);
      const l = "/api/v2/tag/{tagId}/transactions".replace("{tagId}", encodeURIComponent(String(r))), c = new URL(l, $n);
      let f;
      e && (f = e.baseOptions);
      const p = be(be({ method: "GET" }, f), t), u = {};
      Gn(c, {});
      let h = f && f.headers ? f.headers : {};
      return p.headers = be(be(be({}, u), h), t.headers), {
        url: Zn(c),
        options: p
      };
    }),
    /**
     * 
     * @summary Get Reprocess transaction file
     * @param {string} transactionId Transaction id
     * @param {string} name File name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdFileGet: (o, l, ...c) => Ae(null, [o, l, ...c], function* (r, t, a = {}) {
      Oi("apiV2TransactionTransactionIdFileGet", "transactionId", r), Oi("apiV2TransactionTransactionIdFileGet", "name", t);
      const f = "/api/v2/transaction/{transactionId}/file".replace("{transactionId}", encodeURIComponent(String(r))), p = new URL(f, $n);
      let u;
      e && (u = e.baseOptions);
      const h = be(be({ method: "GET" }, u), a), C = {}, E = {};
      t !== void 0 && (E.name = t), Gn(p, E);
      let _ = u && u.headers ? u.headers : {};
      return h.headers = be(be(be({}, C), _), a.headers), {
        url: Zn(p),
        options: h
      };
    }),
    /**
     * 
     * @summary Get Reprocess transaction data
     * @param {string} transactionId Transaction id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdGet: (a, ...o) => Ae(null, [a, ...o], function* (r, t = {}) {
      Oi("apiV2TransactionTransactionIdGet", "transactionId", r);
      const l = "/api/v2/transaction/{transactionId}".replace("{transactionId}", encodeURIComponent(String(r))), c = new URL(l, $n);
      let f;
      e && (f = e.baseOptions);
      const p = be(be({ method: "GET" }, f), t), u = {};
      Gn(c, {});
      let h = f && f.headers ? f.headers : {};
      return p.headers = be(be(be({}, u), h), t.headers), {
        url: Zn(c),
        options: p
      };
    }),
    /**
     * 
     * @summary Reprocess
     * @param {string} transactionId Transaction id
     * @param {TransactionProcessRequest} transactionProcessRequest 
     * @param {boolean} [useCache] Get processed values from storage in case transaction has already processed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdProcessPost: (l, c, f, ...p) => Ae(null, [l, c, f, ...p], function* (r, t, a, o = {}) {
      Oi("apiV2TransactionTransactionIdProcessPost", "transactionId", r), Oi("apiV2TransactionTransactionIdProcessPost", "transactionProcessRequest", t);
      const u = "/api/v2/transaction/{transactionId}/process".replace("{transactionId}", encodeURIComponent(String(r))), h = new URL(u, $n);
      let C;
      e && (C = e.baseOptions);
      const E = be(be({ method: "POST" }, C), o), _ = {}, S = {};
      a !== void 0 && (S.useCache = a), _["Content-Type"] = "application/json", Gn(h, S);
      let v = C && C.headers ? C.headers : {};
      return E.headers = be(be(be({}, _), v), o.headers), E.data = AD(t, E, e), {
        url: Zn(h),
        options: E
      };
    }),
    /**
     * 
     * @summary Get Reprocess transaction result
     * @param {string} transactionId Transaction id
     * @param {boolean} [withImages] With base64 images or url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdResultsGet: (o, l, ...c) => Ae(null, [o, l, ...c], function* (r, t, a = {}) {
      Oi("apiV2TransactionTransactionIdResultsGet", "transactionId", r);
      const f = "/api/v2/transaction/{transactionId}/results".replace("{transactionId}", encodeURIComponent(String(r))), p = new URL(f, $n);
      let u;
      e && (u = e.baseOptions);
      const h = be(be({ method: "GET" }, u), a), C = {}, E = {};
      t !== void 0 && (E.withImages = t), Gn(p, E);
      let _ = u && u.headers ? u.headers : {};
      return h.headers = be(be(be({}, C), _), a.headers), {
        url: Zn(p),
        options: h
      };
    })
  };
}, To = function(e) {
  const r = EM(e);
  return {
    /**
     * 
     * @summary Delete Reprocess transactions by tag
     * @param {string} tagId Tag id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TagTagIdDelete(a, o) {
      return Ae(this, null, function* () {
        var p, u, h;
        const l = yield r.apiV2TagTagIdDelete(a, o), c = (p = e == null ? void 0 : e.serverIndex) != null ? p : 0, f = (h = (u = Bn["TransactionApi.apiV2TagTagIdDelete"]) == null ? void 0 : u[c]) == null ? void 0 : h.url;
        return (C, E) => jn(l, Rt, pn, e)(C, f || E);
      });
    },
    /**
     * 
     * @summary Get transactions by tag
     * @param {string} tagId Tag id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TagTagIdTransactionsGet(a, o) {
      return Ae(this, null, function* () {
        var p, u, h;
        const l = yield r.apiV2TagTagIdTransactionsGet(a, o), c = (p = e == null ? void 0 : e.serverIndex) != null ? p : 0, f = (h = (u = Bn["TransactionApi.apiV2TagTagIdTransactionsGet"]) == null ? void 0 : u[c]) == null ? void 0 : h.url;
        return (C, E) => jn(l, Rt, pn, e)(C, f || E);
      });
    },
    /**
     * 
     * @summary Get Reprocess transaction file
     * @param {string} transactionId Transaction id
     * @param {string} name File name
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdFileGet(a, o, l) {
      return Ae(this, null, function* () {
        var u, h, C;
        const c = yield r.apiV2TransactionTransactionIdFileGet(a, o, l), f = (u = e == null ? void 0 : e.serverIndex) != null ? u : 0, p = (C = (h = Bn["TransactionApi.apiV2TransactionTransactionIdFileGet"]) == null ? void 0 : h[f]) == null ? void 0 : C.url;
        return (E, _) => jn(c, Rt, pn, e)(E, p || _);
      });
    },
    /**
     * 
     * @summary Get Reprocess transaction data
     * @param {string} transactionId Transaction id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdGet(a, o) {
      return Ae(this, null, function* () {
        var p, u, h;
        const l = yield r.apiV2TransactionTransactionIdGet(a, o), c = (p = e == null ? void 0 : e.serverIndex) != null ? p : 0, f = (h = (u = Bn["TransactionApi.apiV2TransactionTransactionIdGet"]) == null ? void 0 : u[c]) == null ? void 0 : h.url;
        return (C, E) => jn(l, Rt, pn, e)(C, f || E);
      });
    },
    /**
     * 
     * @summary Reprocess
     * @param {string} transactionId Transaction id
     * @param {TransactionProcessRequest} transactionProcessRequest 
     * @param {boolean} [useCache] Get processed values from storage in case transaction has already processed.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdProcessPost(a, o, l, c) {
      return Ae(this, null, function* () {
        var h, C, E;
        const f = yield r.apiV2TransactionTransactionIdProcessPost(a, o, l, c), p = (h = e == null ? void 0 : e.serverIndex) != null ? h : 0, u = (E = (C = Bn["TransactionApi.apiV2TransactionTransactionIdProcessPost"]) == null ? void 0 : C[p]) == null ? void 0 : E.url;
        return (_, S) => jn(f, Rt, pn, e)(_, u || S);
      });
    },
    /**
     * 
     * @summary Get Reprocess transaction result
     * @param {string} transactionId Transaction id
     * @param {boolean} [withImages] With base64 images or url
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    apiV2TransactionTransactionIdResultsGet(a, o, l) {
      return Ae(this, null, function* () {
        var u, h, C;
        const c = yield r.apiV2TransactionTransactionIdResultsGet(a, o, l), f = (u = e == null ? void 0 : e.serverIndex) != null ? u : 0, p = (C = (h = Bn["TransactionApi.apiV2TransactionTransactionIdResultsGet"]) == null ? void 0 : h[f]) == null ? void 0 : C.url;
        return (E, _) => jn(c, Rt, pn, e)(E, p || _);
      });
    }
  };
};
class CM extends mc {
  /**
   * 
   * @summary Delete Reprocess transactions by tag
   * @param {string} tagId Tag id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  apiV2TagTagIdDelete(r, t) {
    return To(this.configuration).apiV2TagTagIdDelete(r, t).then((a) => a(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get transactions by tag
   * @param {string} tagId Tag id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  apiV2TagTagIdTransactionsGet(r, t) {
    return To(this.configuration).apiV2TagTagIdTransactionsGet(r, t).then((a) => a(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get Reprocess transaction file
   * @param {string} transactionId Transaction id
   * @param {string} name File name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  apiV2TransactionTransactionIdFileGet(r, t, a) {
    return To(this.configuration).apiV2TransactionTransactionIdFileGet(r, t, a).then((o) => o(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get Reprocess transaction data
   * @param {string} transactionId Transaction id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  apiV2TransactionTransactionIdGet(r, t) {
    return To(this.configuration).apiV2TransactionTransactionIdGet(r, t).then((a) => a(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Reprocess
   * @param {string} transactionId Transaction id
   * @param {TransactionProcessRequest} transactionProcessRequest 
   * @param {boolean} [useCache] Get processed values from storage in case transaction has already processed.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  apiV2TransactionTransactionIdProcessPost(r, t, a, o) {
    return To(this.configuration).apiV2TransactionTransactionIdProcessPost(r, t, a, o).then((l) => l(this.axios, this.basePath));
  }
  /**
   * 
   * @summary Get Reprocess transaction result
   * @param {string} transactionId Transaction id
   * @param {boolean} [withImages] With base64 images or url
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof TransactionApi
   */
  apiV2TransactionTransactionIdResultsGet(r, t, a) {
    return To(this.configuration).apiV2TransactionTransactionIdResultsGet(r, t, a).then((o) => o(this.axios, this.basePath));
  }
}
const SM = function(e) {
  return {
    /**
     * 
     * @summary Returns the list of documents stored in the database that the Web Service API is running with.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    doclist: (...t) => Ae(null, [...t], function* (r = {}) {
      const a = "/api/doclist", o = new URL(a, $n);
      let l;
      e && (l = e.baseOptions);
      const c = be(be({ method: "GET" }, l), r), f = {};
      Gn(o, {});
      let p = l && l.headers ? l.headers : {};
      return c.headers = be(be(be({}, f), p), r.headers), {
        url: Zn(o),
        options: c
      };
    })
  };
}, IM = function(e) {
  const r = SM(e);
  return {
    /**
     * 
     * @summary Returns the list of documents stored in the database that the Web Service API is running with.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    doclist(a) {
      return Ae(this, null, function* () {
        var f, p, u;
        const o = yield r.doclist(a), l = (f = e == null ? void 0 : e.serverIndex) != null ? f : 0, c = (u = (p = Bn["ResourcesApi.doclist"]) == null ? void 0 : p[l]) == null ? void 0 : u.url;
        return (h, C) => jn(o, Rt, pn, e)(h, c || C);
      });
    }
  };
};
class vM extends mc {
  /**
   * 
   * @summary Returns the list of documents stored in the database that the Web Service API is running with.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ResourcesApi
   */
  doclist(r) {
    return IM(this.configuration).doclist(r).then((t) => t(this.axios, this.basePath));
  }
}
var dr = /* @__PURE__ */ ((e) => (e[e.UV_LUMINESCENCE = 1] = "UV_LUMINESCENCE", e[e.IR_B900 = 2] = "IR_B900", e[e.IMAGE_PATTERN = 4] = "IMAGE_PATTERN", e[e.AXIAL_PROTECTION = 8] = "AXIAL_PROTECTION", e[e.UV_FIBERS = 16] = "UV_FIBERS", e[e.IR_VISIBILITY = 32] = "IR_VISIBILITY", e[e.OCR_SECURITY_TEXT = 64] = "OCR_SECURITY_TEXT", e[e.IPI = 128] = "IPI", e[e.PHOTO_EMBED_TYPE = 512] = "PHOTO_EMBED_TYPE", e[e.OVI = 1024] = "OVI", e[e.HOLOGRAMS = 4096] = "HOLOGRAMS", e[e.PHOTO_AREA = 8192] = "PHOTO_AREA", e[e.PORTRAIT_COMPARISON = 32768] = "PORTRAIT_COMPARISON", e[e.BARCODE_FORMAT_CHECK = 65536] = "BARCODE_FORMAT_CHECK", e[e.KINEGRAM = 131072] = "KINEGRAM", e[e.LETTER_SCREEN = 262144] = "LETTER_SCREEN", e[e.HOLOGRAM_DETECTION = 524288] = "HOLOGRAM_DETECTION", e[e.FINGERPRINT_COMPARISON = 1048576] = "FINGERPRINT_COMPARISON", e[e.LIVENESS = 2097152] = "LIVENESS", e[e.EXTENDED_OCR_CHECK = 4194304] = "EXTENDED_OCR_CHECK", e[e.EXTENDED_MRZ_CHECK = 8388608] = "EXTENDED_MRZ_CHECK", e[e.ENCRYPTED_IPI = 16777216] = "ENCRYPTED_IPI", e))(dr || {}), gM = /* @__PURE__ */ ((e) => (e[e.TEXT = 0] = "TEXT", e[e.BYTE = 1] = "BYTE", e[e.NUM = 2] = "NUM", e[e.SHIFT = 3] = "SHIFT", e[e.ALL = 4] = "ALL", e))(gM || {}), DM = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.CODE128 = 1] = "CODE128", e[e.CODE39 = 2] = "CODE39", e[e.EAN8 = 3] = "EAN8", e[e.ITF = 4] = "ITF", e[e.PDF417 = 5] = "PDF417", e[e.STF = 6] = "STF", e[e.MTF = 7] = "MTF", e[e.IATA = 8] = "IATA", e[e.CODABAR = 9] = "CODABAR", e[e.UPCA = 10] = "UPCA", e[e.CODE93 = 11] = "CODE93", e[e.UPCE = 12] = "UPCE", e[e.EAN13 = 13] = "EAN13", e[e.QRCODE = 14] = "QRCODE", e[e.AZTEC = 15] = "AZTEC", e[e.DATAMATRIX = 16] = "DATAMATRIX", e[e.ALL_1D = 17] = "ALL_1D", e[e.CODE11 = 18] = "CODE11", e[e.JABCODE = 19] = "JABCODE", e))(DM || {}), RM = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.PASS = 1] = "PASS", e[e.INVALID_INPUT_DATA = 2] = "INVALID_INPUT_DATA", e[e.INTERNAL_ERROR = 3] = "INTERNAL_ERROR", e[e.EXCEPTION_IN_MODULE = 4] = "EXCEPTION_IN_MODULE", e[e.UNCERTAIN_VERIFICATION = 5] = "UNCERTAIN_VERIFICATION", e[e.NECESSARY_IMAGE_NOT_FOUND = 7] = "NECESSARY_IMAGE_NOT_FOUND", e[e.PHOTO_SIDES_NOT_FOUND = 8] = "PHOTO_SIDES_NOT_FOUND", e[e.INVALID_CHECKSUM = 10] = "INVALID_CHECKSUM", e[e.SYNTAX_ERROR = 11] = "SYNTAX_ERROR", e[e.LOGIC_ERROR = 12] = "LOGIC_ERROR", e[e.SOURCES_COMPARISON_ERROR = 13] = "SOURCES_COMPARISON_ERROR", e[e.FIELDS_COMPARISON_LOGIC_ERROR = 14] = "FIELDS_COMPARISON_LOGIC_ERROR", e[e.INVALID_FIELD_FORMAT = 15] = "INVALID_FIELD_FORMAT", e[e.TRUE_LUMINESCENCE_ERROR = 20] = "TRUE_LUMINESCENCE_ERROR", e[e.FALSE_LUMINESCENCE_ERROR = 21] = "FALSE_LUMINESCENCE_ERROR", e[e.FIXED_PATTERN_ERROR = 22] = "FIXED_PATTERN_ERROR", e[e.LOW_CONTRAST_IN_IR_LIGHT = 23] = "LOW_CONTRAST_IN_IR_LIGHT", e[e.INCORRECT_BACKGROUND_LIGHT = 24] = "INCORRECT_BACKGROUND_LIGHT", e[e.BACKGROUND_COMPARISON_ERROR = 25] = "BACKGROUND_COMPARISON_ERROR", e[e.INCORRECT_TEXT_COLOR = 26] = "INCORRECT_TEXT_COLOR", e[e.PHOTO_FALSE_LUMINESCENCE = 27] = "PHOTO_FALSE_LUMINESCENCE", e[e.TOO_MUCH_SHIFT = 28] = "TOO_MUCH_SHIFT", e[e.CONTACT_CHIP_TYPE_MISMATCH = 29] = "CONTACT_CHIP_TYPE_MISMATCH", e[e.FIBERS_NOT_FOUND = 30] = "FIBERS_NOT_FOUND", e[e.TOO_MANY_OBJECTS = 31] = "TOO_MANY_OBJECTS", e[e.SPECKS_IN_UV = 33] = "SPECKS_IN_UV", e[e.TOO_LOW_RESOLUTION = 34] = "TOO_LOW_RESOLUTION", e[e.INVISIBLE_ELEMENT_PRESENT = 40] = "INVISIBLE_ELEMENT_PRESENT", e[e.VISIBLE_ELEMENT_ABSENT = 41] = "VISIBLE_ELEMENT_ABSENT", e[e.ELEMENT_SHOULD_BE_COLORED = 42] = "ELEMENT_SHOULD_BE_COLORED", e[e.ELEMENT_SHOULD_BE_GRAYSCALE = 43] = "ELEMENT_SHOULD_BE_GRAYSCALE", e[e.PHOTO_WHITE_IR_DONT_MATCH = 44] = "PHOTO_WHITE_IR_DONT_MATCH", e[e.UV_DULL_PAPER_MRZ = 50] = "UV_DULL_PAPER_MRZ", e[e.FALSE_LUMINESCENCE_IN_MRZ = 51] = "FALSE_LUMINESCENCE_IN_MRZ", e[e.UV_DULL_PAPER_PHOTO = 52] = "UV_DULL_PAPER_PHOTO", e[e.UV_DULL_PAPER_BLANK = 53] = "UV_DULL_PAPER_BLANK", e[e.UV_DULL_PAPER_ERROR = 54] = "UV_DULL_PAPER_ERROR", e[e.FALSE_LUMINESCENCE_IN_BLANK = 55] = "FALSE_LUMINESCENCE_IN_BLANK", e[e.BAD_AREA_IN_AXIAL = 60] = "BAD_AREA_IN_AXIAL", e[e.FALSE_IPI_PARAMETERS = 65] = "FALSE_IPI_PARAMETERS", e[e.ENCRYPTED_IPI_NOT_FOUND = 66] = "ENCRYPTED_IPI_NOT_FOUND", e[e.ENCRYPTED_IPI_DATA_DONT_MATCH = 67] = "ENCRYPTED_IPI_DATA_DONT_MATCH", e[e.FIELD_POS_CORRECTOR_HIGHLIGHT_IR = 80] = "FIELD_POS_CORRECTOR_HIGHLIGHT_IR", e[e.FIELD_POS_CORRECTOR_GLARES_IN_PHOTO_AREA = 81] = "FIELD_POS_CORRECTOR_GLARES_IN_PHOTO_AREA", e[e.FIELD_POS_CORRECTOR_PHOTO_REPLACED = 82] = "FIELD_POS_CORRECTOR_PHOTO_REPLACED", e[e.FIELD_POS_CORRECTOR_LANDMARKS_CHECK_ERROR = 83] = "FIELD_POS_CORRECTOR_LANDMARKS_CHECK_ERROR", e[e.FIELD_POS_CORRECTOR_FACE_PRESENCE_CHECK_ERROR = 84] = "FIELD_POS_CORRECTOR_FACE_PRESENCE_CHECK_ERROR", e[e.FIELD_POS_CORRECTOR_FACE_ABSENCE_CHECK_ERROR = 85] = "FIELD_POS_CORRECTOR_FACE_ABSENCE_CHECK_ERROR", e[e.FIELD_POS_CORRECTOR_INCORRECT_HEAD_POSITION = 86] = "FIELD_POS_CORRECTOR_INCORRECT_HEAD_POSITION", e[e.FIELD_POS_CORRECTOR_AGE_CHECK_ERROR = 87] = "FIELD_POS_CORRECTOR_AGE_CHECK_ERROR", e[e.FIELD_POS_CORRECTOR_SEX_CHECK_ERROR = 88] = "FIELD_POS_CORRECTOR_SEX_CHECK_ERROR", e[e.OVI_IR_INVISIBLE = 90] = "OVI_IR_INVISIBLE", e[e.OVI_INSUFFICIENT_AREA = 91] = "OVI_INSUFFICIENT_AREA", e[e.OVI_COLOR_INVARIABLE = 92] = "OVI_COLOR_INVARIABLE", e[e.OVI_BAD_COLOR_FRONT = 93] = "OVI_BAD_COLOR_FRONT", e[e.OVI_BAD_COLOR_SIDE = 94] = "OVI_BAD_COLOR_SIDE", e[e.OVI_WIDE_COLOR_SPREAD = 95] = "OVI_WIDE_COLOR_SPREAD", e[e.OVI_BAD_COLOR_PERCENT = 96] = "OVI_BAD_COLOR_PERCENT", e[e.HOLOGRAM_ELEMENT_ABSENT = 100] = "HOLOGRAM_ELEMENT_ABSENT", e[e.HOLOGRAM_SIDE_TOP_IMAGES_ABSENT = 101] = "HOLOGRAM_SIDE_TOP_IMAGES_ABSENT", e[e.HOLOGRAM_ELEMENT_PRESENT = 102] = "HOLOGRAM_ELEMENT_PRESENT", e[e.HOLOGRAM_FRAMES_IS_ABSENT = 103] = "HOLOGRAM_FRAMES_IS_ABSENT", e[e.HOLOGRAM_HOLO_FIELD_IS_ABSENT = 104] = "HOLOGRAM_HOLO_FIELD_IS_ABSENT", e[e.PHOTO_PATTERN_INTERRUPTED = 110] = "PHOTO_PATTERN_INTERRUPTED", e[e.PHOTO_PATTERN_SHIFTED = 111] = "PHOTO_PATTERN_SHIFTED", e[e.PHOTO_PATTERN_DIFFERENT_COLORS = 112] = "PHOTO_PATTERN_DIFFERENT_COLORS", e[e.PHOTO_PATTERN_IR_VISIBLE = 113] = "PHOTO_PATTERN_IR_VISIBLE", e[e.PHOTO_PATTERN_NOT_INTERSECT = 114] = "PHOTO_PATTERN_NOT_INTERSECT", e[e.PHOTO_SIZE_IS_WRONG = 115] = "PHOTO_SIZE_IS_WRONG", e[e.PHOTO_PATTERN_INVALID_COLOR = 116] = "PHOTO_PATTERN_INVALID_COLOR", e[e.PHOTO_PATTERN_SHIFTED_VERT = 117] = "PHOTO_PATTERN_SHIFTED_VERT", e[e.PHOTO_PATTERN_PATTERN_NOT_FOUND = 118] = "PHOTO_PATTERN_PATTERN_NOT_FOUND", e[e.PHOTO_PATTERN_DIFFERENT_LINES_THICKNESS = 119] = "PHOTO_PATTERN_DIFFERENT_LINES_THICKNESS", e[e.PHOTO_IS_NOT_RECTANGLE = 120] = "PHOTO_IS_NOT_RECTANGLE", e[e.PHOTO_CORNERS_IS_WRONG = 121] = "PHOTO_CORNERS_IS_WRONG", e[e.DOCUMENT_IS_CANCELLING = 122] = "DOCUMENT_IS_CANCELLING", e[e.TEXT_COLOR_SHOULD_BE_BLUE = 130] = "TEXT_COLOR_SHOULD_BE_BLUE", e[e.TEXT_COLOR_SHOULD_BE_GREEN = 131] = "TEXT_COLOR_SHOULD_BE_GREEN", e[e.TEXT_COLOR_SHOULD_BE_RED = 132] = "TEXT_COLOR_SHOULD_BE_RED", e[e.TEXT_SHOULD_BE_BLACK = 133] = "TEXT_SHOULD_BE_BLACK", e[e.TEXT_IS_ABSENT = 134] = "TEXT_IS_ABSENT", e[e.BARCODE_WAS_READ_WITH_ERRORS = 140] = "BARCODE_WAS_READ_WITH_ERRORS", e[e.BARCODE_DATA_FORMAT_ERROR = 141] = "BARCODE_DATA_FORMAT_ERROR", e[e.BARCODE_SIZE_PARAMS_ERROR = 142] = "BARCODE_SIZE_PARAMS_ERROR", e[e.NOT_ALL_BARCODES_READ = 143] = "NOT_ALL_BARCODES_READ", e[e.GLARES_IN_BARCODE_AREA = 144] = "GLARES_IN_BARCODE_AREA", e[e.NO_CERTIFICATE_FOR_DIGITAL_SIGNATURE_CHECK = 145] = "NO_CERTIFICATE_FOR_DIGITAL_SIGNATURE_CHECK", e[e.PORTRAIT_COMPARISON_PORTRAITS_DIFFER = 150] = "PORTRAIT_COMPARISON_PORTRAITS_DIFFER", e[e.PORTRAIT_COMPARISON_NO_SERVICE_REPLY = 151] = "PORTRAIT_COMPARISON_NO_SERVICE_REPLY", e[e.PORTRAIT_COMPARISON_SERVICE_ERROR = 152] = "PORTRAIT_COMPARISON_SERVICE_ERROR", e[e.PORTRAIT_COMPARISON_NOT_ENOUGH_IMAGES = 153] = "PORTRAIT_COMPARISON_NOT_ENOUGH_IMAGES", e[e.PORTRAIT_COMPARISON_NO_LIVE_PHOTO = 154] = "PORTRAIT_COMPARISON_NO_LIVE_PHOTO", e[e.PORTRAIT_COMPARISON_NO_SERVICE_LICENSE = 155] = "PORTRAIT_COMPARISON_NO_SERVICE_LICENSE", e[e.PORTRAIT_COMPARISON_NO_PORTRAIT_DETECTED = 156] = "PORTRAIT_COMPARISON_NO_PORTRAIT_DETECTED", e[e.MOBILE_IMAGES_UNSUITABLE_LIGHT_CONDITIONS = 160] = "MOBILE_IMAGES_UNSUITABLE_LIGHT_CONDITIONS", e[e.MOBILE_IMAGES_WHITE_UV_NO_DIFFERENCE = 161] = "MOBILE_IMAGES_WHITE_UV_NO_DIFFERENCE", e[e.FINGERPRINTS_COMPARISON_MISMATCH = 170] = "FINGERPRINTS_COMPARISON_MISMATCH", e[e.HOLO_PHOTO_FACE_NOT_DETECTED = 180] = "HOLO_PHOTO_FACE_NOT_DETECTED", e[e.HOLO_PHOTO_FACE_COMPARISON_FAILED = 181] = "HOLO_PHOTO_FACE_COMPARISON_FAILED", e[e.HOLO_PHOTO_GLARE_IN_CENTER_ABSENT = 182] = "HOLO_PHOTO_GLARE_IN_CENTER_ABSENT", e[e.HOLO_PHOTO_HOLO_ELEMENT_SHAPE_ERROR = 183] = "HOLO_PHOTO_HOLO_ELEMENT_SHAPE_ERROR", e[e.HOLO_PHOTO_ALGORITHMS_STEPS_ERROR = 184] = "HOLO_PHOTO_ALGORITHMS_STEPS_ERROR", e[e.HOLO_PHOTO_HOLO_AREAS_NOT_LOADED = 185] = "HOLO_PHOTO_HOLO_AREAS_NOT_LOADED", e[e.HOLO_PHOTO_FINISHED_BY_TIMEOUT = 186] = "HOLO_PHOTO_FINISHED_BY_TIMEOUT", e[e.HOLO_PHOTO_DOCUMENT_OUTSIDE_FRAME = 187] = "HOLO_PHOTO_DOCUMENT_OUTSIDE_FRAME", e[e.LIVENESS_DEPTH_CHECK_FAILED = 190] = "LIVENESS_DEPTH_CHECK_FAILED", e[e.MRZ_QUALITY_WRONG_SYMBOL_POSITION = 200] = "MRZ_QUALITY_WRONG_SYMBOL_POSITION", e[e.MRZ_QUALITY_WRONG_BACKGROUND = 201] = "MRZ_QUALITY_WRONG_BACKGROUND", e[e.MRZ_QUALITY_WRONG_MRZ_WIDTH = 202] = "MRZ_QUALITY_WRONG_MRZ_WIDTH", e[e.MRZ_QUALITY_WRONG_MRZ_HEIGHT = 203] = "MRZ_QUALITY_WRONG_MRZ_HEIGHT", e[e.MRZ_QUALITY_WRONG_LINE_POSITION = 204] = "MRZ_QUALITY_WRONG_LINE_POSITION", e[e.MRZ_QUALITY_WRONG_FONT_TYPE = 205] = "MRZ_QUALITY_WRONG_FONT_TYPE", e[e.OCR_QUALITY_TEXT_POSITION = 220] = "OCR_QUALITY_TEXT_POSITION", e[e.OCR_QUALITY_INVALID_FONT = 221] = "OCR_QUALITY_INVALID_FONT", e[e.OCR_QUALITY_INVALID_BACKGROUND = 222] = "OCR_QUALITY_INVALID_BACKGROUND", e[e.LASINK_INVALID_LINES_FREQUENCY = 230] = "LASINK_INVALID_LINES_FREQUENCY", e[e.DOC_LIVENESS_DOCUMENT_NOT_LIVE = 238] = "DOC_LIVENESS_DOCUMENT_NOT_LIVE", e[e.DOC_LIVENESS_BLACK_AND_WHITE_COPY_DETECTED = 239] = "DOC_LIVENESS_BLACK_AND_WHITE_COPY_DETECTED", e[e.DOC_LIVENESS_ELECTRONIC_DEVICE_DETECTED = 240] = "DOC_LIVENESS_ELECTRONIC_DEVICE_DETECTED", e[e.DOC_LIVENESS_INVALID_BARCODE_BACKGROUND = 241] = "DOC_LIVENESS_INVALID_BARCODE_BACKGROUND", e[e.CHD_ICAO_IDB_BASE32_ERROR = 243] = "CHD_ICAO_IDB_BASE32_ERROR", e[e.CHD_ICAO_IDB_ZIPPED_ERROR = 244] = "CHD_ICAO_IDB_ZIPPED_ERROR", e[e.CHD_ICAO_IDB_MESSAGE_ZONE_EMPTY = 245] = "CHD_ICAO_IDB_MESSAGE_ZONE_EMPTY", e[e.CHD_ICAO_IDB_SIGNATURE_MUST_BE_PRESENT = 246] = "CHD_ICAO_IDB_SIGNATURE_MUST_BE_PRESENT", e[e.CHD_ICAO_IDB_SIGNATURE_MUST_NOT_BE_PRESENT = 247] = "CHD_ICAO_IDB_SIGNATURE_MUST_NOT_BE_PRESENT", e[e.CHD_ICAO_IDB_CERTIFICATE_MUST_NOT_BE_PRESENT = 248] = "CHD_ICAO_IDB_CERTIFICATE_MUST_NOT_BE_PRESENT", e[e.CHD_INCORRECT_OBJECT_COLOR = 250] = "CHD_INCORRECT_OBJECT_COLOR", e))(RM || {}), Mi = /* @__PURE__ */ ((e) => (e[e.ERROR = 0] = "ERROR", e[e.OK = 1] = "OK", e[e.WAS_NOT_DONE = 2] = "WAS_NOT_DONE", e))(Mi || {}), AM = /* @__PURE__ */ ((e) => (e[e.NOT_CRITICAL = 0] = "NOT_CRITICAL", e[e.CRITICAL = 1] = "CRITICAL", e))(AM || {}), TM = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = -1] = "UNKNOWN", e[e.ID1 = 0] = "ID1", e[e.ID2 = 1] = "ID2", e[e.ID3 = 2] = "ID3", e[e.NON = 3] = "NON", e[e.A4 = 4] = "A4", e[e.ID3_X2 = 5] = "ID3_X2", e[e.ID1_90 = 10] = "ID1_90", e[e.ID1_180 = 11] = "ID1_180", e[e.ID1_270 = 12] = "ID1_270", e[e.ID2_180 = 13] = "ID2_180", e[e.ID3_180 = 14] = "ID3_180", e[e.CUSTOM = 1e3] = "CUSTOM", e[e.FLEXIBLE = 1002] = "FLEXIBLE", e))(TM || {}), OM = /* @__PURE__ */ ((e) => (e[e.NOT_DEFINED = 0] = "NOT_DEFINED", e[e.PASSPORT = 11] = "PASSPORT", e[e.IDENTITY_CARD = 12] = "IDENTITY_CARD", e[e.DIPLOMATIC_PASSPORT = 13] = "DIPLOMATIC_PASSPORT", e[e.SERVICE_PASSPORT = 14] = "SERVICE_PASSPORT", e[e.SEAMANS_IDENTITY_DOCUMENT = 15] = "SEAMANS_IDENTITY_DOCUMENT", e[e.IDENTITY_CARD_FOR_RESIDENCE = 16] = "IDENTITY_CARD_FOR_RESIDENCE", e[e.TRAVEL_DOCUMENT = 17] = "TRAVEL_DOCUMENT", e[e.NATIONAL_IDENTITY_CARD = 20] = "NATIONAL_IDENTITY_CARD", e[e.SOCIAL_IDENTITY_CARD = 21] = "SOCIAL_IDENTITY_CARD", e[e.ALIENS_IDENTITY_CARD = 22] = "ALIENS_IDENTITY_CARD", e[e.PRIVILEGED_IDENTITY_CARD = 23] = "PRIVILEGED_IDENTITY_CARD", e[e.RESIDENCE_PERMIT_IDENTITY_CARD = 24] = "RESIDENCE_PERMIT_IDENTITY_CARD", e[e.ORIGIN_CARD = 25] = "ORIGIN_CARD", e[e.EMERGENCY_PASSPORT = 26] = "EMERGENCY_PASSPORT", e[e.ALIENS_PASSPORT = 27] = "ALIENS_PASSPORT", e[e.ALTERNATIVE_IDENTITY_CARD = 28] = "ALTERNATIVE_IDENTITY_CARD", e[e.VISA_ID2 = 29] = "VISA_ID2", e[e.VISA_ID3 = 30] = "VISA_ID3", e[e.AUTHORIZATION_CARD = 32] = "AUTHORIZATION_CARD", e[e.BEGINNER_PERMIT = 33] = "BEGINNER_PERMIT", e[e.BORDER_CROSSING_CARD = 34] = "BORDER_CROSSING_CARD", e[e.CHAUFFEUR_LICENSE = 35] = "CHAUFFEUR_LICENSE", e[e.CHAUFFEUR_LICENSE_UNDER_18 = 36] = "CHAUFFEUR_LICENSE_UNDER_18", e[e.CHAUFFEUR_LICENSE_UNDER_21 = 37] = "CHAUFFEUR_LICENSE_UNDER_21", e[e.COMMERCIAL_DRIVING_LICENSE = 38] = "COMMERCIAL_DRIVING_LICENSE", e[e.COMMERCIAL_DRIVING_LICENSE_INSTRUCTIONAL_PERMIT = 39] = "COMMERCIAL_DRIVING_LICENSE_INSTRUCTIONAL_PERMIT", e[e.COMMERCIAL_DRIVING_LICENSE_UNDER_18 = 40] = "COMMERCIAL_DRIVING_LICENSE_UNDER_18", e[e.COMMERCIAL_DRIVING_LICENSE_UNDER_21 = 41] = "COMMERCIAL_DRIVING_LICENSE_UNDER_21", e[e.COMMERCIAL_INSTRUCTION_PERMIT = 42] = "COMMERCIAL_INSTRUCTION_PERMIT", e[e.COMMERCIAL_NEW_PERMIT = 43] = "COMMERCIAL_NEW_PERMIT", e[e.CONCEALED_CARRY_LICENSE = 44] = "CONCEALED_CARRY_LICENSE", e[e.CONCEALED_FIREARM_PERMIT = 45] = "CONCEALED_FIREARM_PERMIT", e[e.CONDITIONAL_DRIVING_LICENSE = 46] = "CONDITIONAL_DRIVING_LICENSE", e[e.DEPARTMENT_OF_VETERANS_AFFAIRS_IDENTITY_CARD = 47] = "DEPARTMENT_OF_VETERANS_AFFAIRS_IDENTITY_CARD", e[e.DIPLOMATIC_DRIVING_LICENSE = 48] = "DIPLOMATIC_DRIVING_LICENSE", e[e.DRIVING_LICENSE = 49] = "DRIVING_LICENSE", e[e.DRIVING_LICENSE_INSTRUCTIONAL_PERMIT = 50] = "DRIVING_LICENSE_INSTRUCTIONAL_PERMIT", e[e.DRIVING_LICENSE_INSTRUCTIONAL_PERMIT_UNDER_18 = 51] = "DRIVING_LICENSE_INSTRUCTIONAL_PERMIT_UNDER_18", e[e.DRIVING_LICENSE_INSTRUCTIONAL_PERMIT_UNDER_21 = 52] = "DRIVING_LICENSE_INSTRUCTIONAL_PERMIT_UNDER_21", e[e.DRIVING_LICENSE_LEARNERS_PERMIT = 53] = "DRIVING_LICENSE_LEARNERS_PERMIT", e[e.DRIVING_LICENSE_LEARNERS_PERMIT_UNDER_18 = 54] = "DRIVING_LICENSE_LEARNERS_PERMIT_UNDER_18", e[e.DRIVING_LICENSE_LEARNERS_PERMIT_UNDER_21 = 55] = "DRIVING_LICENSE_LEARNERS_PERMIT_UNDER_21", e[e.DRIVING_LICENSE_NOVICE = 56] = "DRIVING_LICENSE_NOVICE", e[e.DRIVING_LICENSE_NOVICE_UNDER_18 = 57] = "DRIVING_LICENSE_NOVICE_UNDER_18", e[e.DRIVING_LICENSE_NOVICE_UNDER_21 = 58] = "DRIVING_LICENSE_NOVICE_UNDER_21", e[e.DRIVING_LICENSE_REGISTERED_OFFENDER = 59] = "DRIVING_LICENSE_REGISTERED_OFFENDER", e[e.DRIVING_LICENSE_RESTRICTED_UNDER_18 = 60] = "DRIVING_LICENSE_RESTRICTED_UNDER_18", e[e.DRIVING_LICENSE_RESTRICTED_UNDER_21 = 61] = "DRIVING_LICENSE_RESTRICTED_UNDER_21", e[e.DRIVING_LICENSE_TEMPORARY_VISITOR = 62] = "DRIVING_LICENSE_TEMPORARY_VISITOR", e[e.DRIVING_LICENSE_TEMPORARY_VISITOR_UNDER_18 = 63] = "DRIVING_LICENSE_TEMPORARY_VISITOR_UNDER_18", e[e.DRIVING_LICENSE_TEMPORARY_VISITOR_UNDER_21 = 64] = "DRIVING_LICENSE_TEMPORARY_VISITOR_UNDER_21", e[e.DRIVING_LICENSE_UNDER_18 = 65] = "DRIVING_LICENSE_UNDER_18", e[e.DRIVING_LICENSE_UNDER_21 = 66] = "DRIVING_LICENSE_UNDER_21", e[e.EMPLOYMENT_DRIVING_PERMIT = 67] = "EMPLOYMENT_DRIVING_PERMIT", e[e.ENHANCED_CHAUFFEUR_LICENSE = 68] = "ENHANCED_CHAUFFEUR_LICENSE", e[e.ENHANCED_CHAUFFEUR_LICENSE_UNDER_18 = 69] = "ENHANCED_CHAUFFEUR_LICENSE_UNDER_18", e[e.ENHANCED_CHAUFFEUR_LICENSE_UNDER_21 = 70] = "ENHANCED_CHAUFFEUR_LICENSE_UNDER_21", e[e.ENHANCED_COMMERCIAL_DRIVING_LICENSE = 71] = "ENHANCED_COMMERCIAL_DRIVING_LICENSE", e[e.ENHANCED_DRIVING_LICENSE = 72] = "ENHANCED_DRIVING_LICENSE", e[e.ENHANCED_DRIVING_LICENSE_UNDER_18 = 73] = "ENHANCED_DRIVING_LICENSE_UNDER_18", e[e.ENHANCED_DRIVING_LICENSE_UNDER_21 = 74] = "ENHANCED_DRIVING_LICENSE_UNDER_21", e[e.ENHANCED_IDENTITY_CARD = 75] = "ENHANCED_IDENTITY_CARD", e[e.ENHANCED_IDENTITY_CARD_UNDER_18 = 76] = "ENHANCED_IDENTITY_CARD_UNDER_18", e[e.ENHANCED_IDENTITY_CARD_UNDER_21 = 77] = "ENHANCED_IDENTITY_CARD_UNDER_21", e[e.ENHANCED_OPERATORS_LICENSE = 78] = "ENHANCED_OPERATORS_LICENSE", e[e.FIREARMS_PERMIT = 79] = "FIREARMS_PERMIT", e[e.FULL_PROVISIONAL_LICENSE = 80] = "FULL_PROVISIONAL_LICENSE", e[e.FULL_PROVISIONAL_LICENSE_UNDER_18 = 81] = "FULL_PROVISIONAL_LICENSE_UNDER_18", e[e.FULL_PROVISIONAL_LICENSE_UNDER_21 = 82] = "FULL_PROVISIONAL_LICENSE_UNDER_21", e[e.GENEVA_CONVENTIONS_IDENTITY_CARD = 83] = "GENEVA_CONVENTIONS_IDENTITY_CARD", e[e.GRADUATED_DRIVING_LICENSE_UNDER_18 = 84] = "GRADUATED_DRIVING_LICENSE_UNDER_18", e[e.GRADUATED_DRIVING_LICENSE_UNDER_21 = 85] = "GRADUATED_DRIVING_LICENSE_UNDER_21", e[e.GRADUATED_INSTRUCTION_PERMIT_UNDER_18 = 86] = "GRADUATED_INSTRUCTION_PERMIT_UNDER_18", e[e.GRADUATED_INSTRUCTION_PERMIT_UNDER_21 = 87] = "GRADUATED_INSTRUCTION_PERMIT_UNDER_21", e[e.GRADUATED_LICENSE_UNDER_18 = 88] = "GRADUATED_LICENSE_UNDER_18", e[e.GRADUATED_LICENSE_UNDER_21 = 89] = "GRADUATED_LICENSE_UNDER_21", e[e.HANDGUN_CARRY_PERMIT = 90] = "HANDGUN_CARRY_PERMIT", e[e.IDENTITY_AND_PRIVILEGE_CARD = 91] = "IDENTITY_AND_PRIVILEGE_CARD", e[e.IDENTITY_CARD_MOBILITY_IMPAIRED = 92] = "IDENTITY_CARD_MOBILITY_IMPAIRED", e[e.IDENTITY_CARD_REGISTERED_OFFENDER = 93] = "IDENTITY_CARD_REGISTERED_OFFENDER", e[e.IDENTITY_CARD_TEMPORARY_VISITOR = 94] = "IDENTITY_CARD_TEMPORARY_VISITOR", e[e.IDENTITY_CARD_TEMPORARY_VISITOR_UNDER_18 = 95] = "IDENTITY_CARD_TEMPORARY_VISITOR_UNDER_18", e[e.IDENTITY_CARD_TEMPORARY_VISITOR_UNDER_21 = 96] = "IDENTITY_CARD_TEMPORARY_VISITOR_UNDER_21", e[e.IDENTITY_CARD_UNDER_18 = 97] = "IDENTITY_CARD_UNDER_18", e[e.IDENTITY_CARD_UNDER_21 = 98] = "IDENTITY_CARD_UNDER_21", e[e.OTHER = 99] = "OTHER", e[e.IGNITION_INTERLOCK_PERMIT = 100] = "IGNITION_INTERLOCK_PERMIT", e[e.IMMIGRANT_VISA = 101] = "IMMIGRANT_VISA", e[e.INSTRUCTION_PERMIT = 102] = "INSTRUCTION_PERMIT", e[e.INSTRUCTION_PERMIT_UNDER_18 = 103] = "INSTRUCTION_PERMIT_UNDER_18", e[e.INSTRUCTION_PERMIT_UNDER_21 = 104] = "INSTRUCTION_PERMIT_UNDER_21", e[e.INTERIM_DRIVING_LICENSE = 105] = "INTERIM_DRIVING_LICENSE", e[e.INTERIM_IDENTITY_CARD = 106] = "INTERIM_IDENTITY_CARD", e[e.INTERMEDIATE_DRIVING_LICENSE = 107] = "INTERMEDIATE_DRIVING_LICENSE", e[e.INTERMEDIATE_DRIVING_LICENSE_UNDER_18 = 108] = "INTERMEDIATE_DRIVING_LICENSE_UNDER_18", e[e.INTERMEDIATE_DRIVING_LICENSE_UNDER_21 = 109] = "INTERMEDIATE_DRIVING_LICENSE_UNDER_21", e[e.JUNIOR_DRIVING_LICENSE = 110] = "JUNIOR_DRIVING_LICENSE", e[e.LEARNER_INSTRUCTIONAL_PERMIT = 111] = "LEARNER_INSTRUCTIONAL_PERMIT", e[e.LEARNER_LICENSE = 112] = "LEARNER_LICENSE", e[e.LEARNER_LICENSE_UNDER_18 = 113] = "LEARNER_LICENSE_UNDER_18", e[e.LEARNER_LICENSE_UNDER_21 = 114] = "LEARNER_LICENSE_UNDER_21", e[e.LEARNER_PERMIT = 115] = "LEARNER_PERMIT", e[e.LEARNER_PERMIT_UNDER_18 = 116] = "LEARNER_PERMIT_UNDER_18", e[e.LEARNER_PERMIT_UNDER_21 = 117] = "LEARNER_PERMIT_UNDER_21", e[e.LIMITED_LICENSE = 118] = "LIMITED_LICENSE", e[e.LIMITED_PERMIT = 119] = "LIMITED_PERMIT", e[e.LIMITED_TERM_DRIVING_LICENSE = 120] = "LIMITED_TERM_DRIVING_LICENSE", e[e.LIMITED_TERM_IDENTITY_CARD = 121] = "LIMITED_TERM_IDENTITY_CARD", e[e.LIQUOR_IDENTITY_CARD = 122] = "LIQUOR_IDENTITY_CARD", e[e.NEW_PERMIT = 123] = "NEW_PERMIT", e[e.NEW_PERMIT_UNDER_18 = 124] = "NEW_PERMIT_UNDER_18", e[e.NEW_PERMIT_UNDER_21 = 125] = "NEW_PERMIT_UNDER_21", e[e.NON_US_CITIZEN_DRIVING_LICENSE = 126] = "NON_US_CITIZEN_DRIVING_LICENSE", e[e.OCCUPATIONAL_DRIVING_LICENSE = 127] = "OCCUPATIONAL_DRIVING_LICENSE", e[e.ONEIDA_TRIBE_OF_INDIANS_IDENTITY_CARD = 128] = "ONEIDA_TRIBE_OF_INDIANS_IDENTITY_CARD", e[e.OPERATOR_LICENSE = 129] = "OPERATOR_LICENSE", e[e.OPERATOR_LICENSE_UNDER_18 = 130] = "OPERATOR_LICENSE_UNDER_18", e[e.OPERATOR_LICENSE_UNDER_21 = 131] = "OPERATOR_LICENSE_UNDER_21", e[e.PERMANENT_DRIVING_LICENSE = 132] = "PERMANENT_DRIVING_LICENSE", e[e.PERMIT_TO_REENTER = 133] = "PERMIT_TO_REENTER", e[e.PROBATIONARY_AUTO_LICENSE = 134] = "PROBATIONARY_AUTO_LICENSE", e[e.PROBATIONARY_DRIVING_LICENSE_UNDER_18 = 135] = "PROBATIONARY_DRIVING_LICENSE_UNDER_18", e[e.PROBATIONARY_DRIVING_LICENSE_UNDER_21 = 136] = "PROBATIONARY_DRIVING_LICENSE_UNDER_21", e[e.PROBATIONARY_VEHICLE_SALES_PERSON_LICENSE = 137] = "PROBATIONARY_VEHICLE_SALES_PERSON_LICENSE", e[e.PROVISIONAL_DRIVING_LICENSE = 138] = "PROVISIONAL_DRIVING_LICENSE", e[e.PROVISIONAL_DRIVING_LICENSE_UNDER_18 = 139] = "PROVISIONAL_DRIVING_LICENSE_UNDER_18", e[e.PROVISIONAL_DRIVING_LICENSE_UNDER_21 = 140] = "PROVISIONAL_DRIVING_LICENSE_UNDER_21", e[e.PROVISIONAL_LICENSE = 141] = "PROVISIONAL_LICENSE", e[e.PROVISIONAL_LICENSE_UNDER_18 = 142] = "PROVISIONAL_LICENSE_UNDER_18", e[e.PROVISIONAL_LICENSE_UNDER_21 = 143] = "PROVISIONAL_LICENSE_UNDER_21", e[e.PUBLIC_PASSENGER_CHAUFFEUR_LICENSE = 144] = "PUBLIC_PASSENGER_CHAUFFEUR_LICENSE", e[e.RACING_AND_GAMING_COMISSION_CARD = 145] = "RACING_AND_GAMING_COMISSION_CARD", e[e.REFUGEE_TRAVEL_DOCUMENT = 146] = "REFUGEE_TRAVEL_DOCUMENT", e[e.RENEWAL_PERMIT = 147] = "RENEWAL_PERMIT", e[e.RESTRICTED_COMMERCIAL_DRIVER_LICENSE = 148] = "RESTRICTED_COMMERCIAL_DRIVER_LICENSE", e[e.RESTRICTED_DRIVER_LICENSE = 149] = "RESTRICTED_DRIVER_LICENSE", e[e.RESTRICTED_PERMIT = 150] = "RESTRICTED_PERMIT", e[e.SEASONAL_PERMIT = 151] = "SEASONAL_PERMIT", e[e.SEASONAL_RESIDENT_IDENTITY_CARD = 152] = "SEASONAL_RESIDENT_IDENTITY_CARD", e[e.SEASONAL_CITIZEN_IDENTITY_CARD = 153] = "SEASONAL_CITIZEN_IDENTITY_CARD", e[e.SEX_OFFENDER = 154] = "SEX_OFFENDER", e[e.SOCIAL_SECURITY_CARD = 155] = "SOCIAL_SECURITY_CARD", e[e.TEMPORARY_DRIVING_LICENSE = 156] = "TEMPORARY_DRIVING_LICENSE", e[e.TEMPORARY_DRIVING_LICENSE_UNDER_18 = 157] = "TEMPORARY_DRIVING_LICENSE_UNDER_18", e[e.TEMPORARY_DRIVING_LICENSE_UNDER_21 = 158] = "TEMPORARY_DRIVING_LICENSE_UNDER_21", e[e.TEMPORARY_IDENTITY_CARD = 159] = "TEMPORARY_IDENTITY_CARD", e[e.TEMPORARY_INSTRUCTION_PERMIT_IDENTITY_CARD = 160] = "TEMPORARY_INSTRUCTION_PERMIT_IDENTITY_CARD", e[e.TEMPORARY_INSTRUCTION_PERMIT_IDENTITY_CARD_UNDER_18 = 161] = "TEMPORARY_INSTRUCTION_PERMIT_IDENTITY_CARD_UNDER_18", e[e.TEMPORARY_INSTRUCTION_PERMIT_IDENTITY_CARD_UNDER_21 = 162] = "TEMPORARY_INSTRUCTION_PERMIT_IDENTITY_CARD_UNDER_21", e[e.TEMPORARY_VISITOR_DRIVING_LICENSE = 163] = "TEMPORARY_VISITOR_DRIVING_LICENSE", e[e.TEMPORARY_VISITOR_DRIVING_LICENSE_UNDER_18 = 164] = "TEMPORARY_VISITOR_DRIVING_LICENSE_UNDER_18", e[e.TEMPORARY_VISITOR_DRIVING_LICENSE_UNDER_21 = 165] = "TEMPORARY_VISITOR_DRIVING_LICENSE_UNDER_21", e[e.UNIFORMED_SERVICES_IDENTITY_CARD = 166] = "UNIFORMED_SERVICES_IDENTITY_CARD", e[e.VEHICLE_SALES_PERSON_LICENSE = 167] = "VEHICLE_SALES_PERSON_LICENSE", e[e.WORKER_IDENTIFICATION_CREDENTIAL = 168] = "WORKER_IDENTIFICATION_CREDENTIAL", e[e.COMMERCIAL_DRIVING_LICENSE_NOVICE = 169] = "COMMERCIAL_DRIVING_LICENSE_NOVICE", e[e.COMMERCIAL_DRIVING_LICENSE_NOVICE_UNDER_18 = 170] = "COMMERCIAL_DRIVING_LICENSE_NOVICE_UNDER_18", e[e.COMMERCIAL_DRIVING_LICENSE_NOVICE_UNDER_21 = 171] = "COMMERCIAL_DRIVING_LICENSE_NOVICE_UNDER_21", e[e.PASSPORT_CARD = 172] = "PASSPORT_CARD", e[e.PASSPORT_RESIDENT_CARD = 173] = "PASSPORT_RESIDENT_CARD", e[e.PERSONAL_IDENTIFICATION_VERIFICATION = 174] = "PERSONAL_IDENTIFICATION_VERIFICATION", e[e.TEMPORARY_OPERATOR_LICENSE = 175] = "TEMPORARY_OPERATOR_LICENSE", e[e.DRIVING_LICENSE_UNDER_19 = 176] = "DRIVING_LICENSE_UNDER_19", e[e.IDENTITY_CARD_UNDER_19 = 177] = "IDENTITY_CARD_UNDER_19", e[e.VISA = 178] = "VISA", e[e.TEMPORARY_PASSPORT = 179] = "TEMPORARY_PASSPORT", e[e.VOTING_CARD = 180] = "VOTING_CARD", e[e.HEALTH_CARD = 181] = "HEALTH_CARD", e[e.CERTIFICATE_OF_CITIZENSHIP = 182] = "CERTIFICATE_OF_CITIZENSHIP", e[e.ADDRESS_CARD = 183] = "ADDRESS_CARD", e[e.AIRPORT_IMMIGRATION_CARD = 184] = "AIRPORT_IMMIGRATION_CARD", e[e.ALIEN_REGISTRATION_CARD = 185] = "ALIEN_REGISTRATION_CARD", e[e.APEH_CARD = 186] = "APEH_CARD", e[e.COUPON_TO_DRIVING_LICENSE = 187] = "COUPON_TO_DRIVING_LICENSE", e[e.CREW_MEMBER_CERTIFICATE = 188] = "CREW_MEMBER_CERTIFICATE", e[e.DOCUMENT_FOR_RETURN = 189] = "DOCUMENT_FOR_RETURN", e[e.E_CARD = 190] = "E_CARD", e[e.EMPLOYMENT_CARD = 191] = "EMPLOYMENT_CARD", e[e.HKSAR_IMMIGRATION_FORM = 192] = "HKSAR_IMMIGRATION_FORM", e[e.IMMIGRANT_CARD = 193] = "IMMIGRANT_CARD", e[e.LABOUR_CARD = 194] = "LABOUR_CARD", e[e.LAISSEZ_PASSER = 195] = "LAISSEZ_PASSER", e[e.LAWYER_IDENTITY_CERTIFICATE = 196] = "LAWYER_IDENTITY_CERTIFICATE", e[e.LICENSE_CARD = 197] = "LICENSE_CARD", e[e.PASSPORT_STATELESS = 198] = "PASSPORT_STATELESS", e[e.PASSPORT_CHILD = 199] = "PASSPORT_CHILD", e[e.PASSPORT_CONSULAR = 200] = "PASSPORT_CONSULAR", e[e.PASSPORT_DIPLOMATIC_SERVICE = 201] = "PASSPORT_DIPLOMATIC_SERVICE", e[e.PASSPORT_OFFICIAL = 202] = "PASSPORT_OFFICIAL", e[e.PASSPORT_PROVISIONAL = 203] = "PASSPORT_PROVISIONAL", e[e.PASSPORT_SPECIAL = 204] = "PASSPORT_SPECIAL", e[e.PERMISSION_TO_THE_LOCAL_BORDER_TRAFFIC = 205] = "PERMISSION_TO_THE_LOCAL_BORDER_TRAFFIC", e[e.REGISTRATION_CERTIFICATE = 206] = "REGISTRATION_CERTIFICATE", e[e.SEDESOL_CARD = 207] = "SEDESOL_CARD", e[e.SOCIAL_CARD = 208] = "SOCIAL_CARD", e[e.TB_CARD = 209] = "TB_CARD", e[e.VEHICLE_PASSPORT = 210] = "VEHICLE_PASSPORT", e[e.W_DOCUMENT = 211] = "W_DOCUMENT", e[e.DIPLOMATIC_IDENTITY_CARD = 212] = "DIPLOMATIC_IDENTITY_CARD", e[e.CONSULAR_IDENTITY_CARD = 213] = "CONSULAR_IDENTITY_CARD", e[e.INCOME_TAX_CARD = 214] = "INCOME_TAX_CARD", e[e.RESIDENCE_PERMIT = 215] = "RESIDENCE_PERMIT", e[e.DOCUMENT_OF_IDENTITY = 216] = "DOCUMENT_OF_IDENTITY", e[e.BORDER_CROSSING_PERMIT = 217] = "BORDER_CROSSING_PERMIT", e[e.PASSPORT_LIMITED_VALIDITY = 218] = "PASSPORT_LIMITED_VALIDITY", e[e.SIM_CARD = 219] = "SIM_CARD", e[e.TAX_CARD = 220] = "TAX_CARD", e[e.COMPANY_CARD = 221] = "COMPANY_CARD", e[e.DOMESTIC_PASSPORT = 222] = "DOMESTIC_PASSPORT", e[e.IDENTITY_CERTIFICATE = 223] = "IDENTITY_CERTIFICATE", e[e.RESIDENT_ID_CARD = 224] = "RESIDENT_ID_CARD", e[e.ARMED_FORCES_IDENTITY_CARD = 225] = "ARMED_FORCES_IDENTITY_CARD", e[e.PROFESSIONAL_CARD = 226] = "PROFESSIONAL_CARD", e[e.REGISTRATION_STAMP = 227] = "REGISTRATION_STAMP", e[e.DRIVER_CARD = 228] = "DRIVER_CARD", e[e.DRIVER_TRAINING_CERTIFICATE = 229] = "DRIVER_TRAINING_CERTIFICATE", e[e.QUALIFICATION_DRIVING_LICENSE = 230] = "QUALIFICATION_DRIVING_LICENSE", e[e.MEMBERSHIP_CARD = 231] = "MEMBERSHIP_CARD", e[e.PUBLIC_VEHICLE_DRIVER_AUTHORITY_CARD = 232] = "PUBLIC_VEHICLE_DRIVER_AUTHORITY_CARD", e[e.MARINE_LICENSE = 233] = "MARINE_LICENSE", e[e.TEMPORARY_LEARNER_LICENSE = 234] = "TEMPORARY_LEARNER_LICENSE", e[e.TEMPORARY_COMMERCIAL_DRIVING_LICENSE = 235] = "TEMPORARY_COMMERCIAL_DRIVING_LICENSE", e[e.INTERIM_INSTRUCTIONAL_PERMIT = 236] = "INTERIM_INSTRUCTIONAL_PERMIT", e[e.CERTIFICATE_OF_COMPETENCY = 237] = "CERTIFICATE_OF_COMPETENCY", e[e.CERTIFICATE_OF_PROFICIENCY = 238] = "CERTIFICATE_OF_PROFICIENCY", e[e.TRADE_LICENSE = 239] = "TRADE_LICENSE", e[e.PASSPORT_PAGE = 240] = "PASSPORT_PAGE", e[e.INVOICE = 241] = "INVOICE", e[e.PASSENGER_LOCATOR_FORM = 242] = "PASSENGER_LOCATOR_FORM", e))(OM || {}), yM = /* @__PURE__ */ ((e) => (e[e.OK = 0] = "OK", e[e.UNKNOWN = 15] = "UNKNOWN", e[e.NEED_MORE_IMAGES = 29] = "NEED_MORE_IMAGES", e))(yM || {}), NM = /* @__PURE__ */ ((e) => (e[e.PORTRAIT = 201] = "PORTRAIT", e[e.FINGERPRINT = 202] = "FINGERPRINT", e[e.EYE = 203] = "EYE", e[e.SIGNATURE = 204] = "SIGNATURE", e[e.BAR_CODE = 205] = "BAR_CODE", e[e.PROOF_OF_CITIZENSHIP = 206] = "PROOF_OF_CITIZENSHIP", e[e.DOCUMENT_FRONT = 207] = "DOCUMENT_FRONT", e[e.DOCUMENT_REAR = 208] = "DOCUMENT_REAR", e[e.COLOR_DYNAMIC = 209] = "COLOR_DYNAMIC", e[e.GHOST_PORTRAIT = 210] = "GHOST_PORTRAIT", e[e.STAMP = 211] = "STAMP", e[e.PORTRAIT_OF_CHILD = 212] = "PORTRAIT_OF_CHILD", e[e.CONTACT_CHIP = 213] = "CONTACT_CHIP", e[e.OTHER = 250] = "OTHER", e[e.FINGER_LEFT_THUMB = 300] = "FINGER_LEFT_THUMB", e[e.FINGER_LEFT_INDEX = 301] = "FINGER_LEFT_INDEX", e[e.FINGER_LEFT_MIDDLE = 302] = "FINGER_LEFT_MIDDLE", e[e.FINGER_LEFT_RING = 303] = "FINGER_LEFT_RING", e[e.FINGER_LEFT_LITTLE = 304] = "FINGER_LEFT_LITTLE", e[e.FINGER_RIGHT_THUMB = 305] = "FINGER_RIGHT_THUMB", e[e.FINGER_RIGHT_INDEX = 306] = "FINGER_RIGHT_INDEX", e[e.FINGER_RIGHT_MIDDLE = 307] = "FINGER_RIGHT_MIDDLE", e[e.FINGER_RIGHT_RING = 308] = "FINGER_RIGHT_RING", e[e.FINGER_RIGHT_LITTLE = 309] = "FINGER_RIGHT_LITTLE", e[e.FINGER_RIGHT_FOUR_FINGERS = 313] = "FINGER_RIGHT_FOUR_FINGERS", e[e.FINGER_LEFT_FOUR_FINGERS = 314] = "FINGER_LEFT_FOUR_FINGERS", e[e.FINGER_TWO_THUMBS = 315] = "FINGER_TWO_THUMBS", e))(NM || {}), Fl = /* @__PURE__ */ ((e) => (e[e.ImageGlares = 0] = "ImageGlares", e[e.ImageFocus = 1] = "ImageFocus", e[e.ImageResolution = 2] = "ImageResolution", e[e.ImageColorness = 3] = "ImageColorness", e[e.Perspective = 4] = "Perspective", e[e.Bounds = 5] = "Bounds", e[e.Portrait = 7] = "Portrait", e[e.Handwritten = 8] = "Handwritten", e[e.Brightness = 9] = "Brightness", e[e.Occlusion = 10] = "Occlusion", e))(Fl || {}), LM = /* @__PURE__ */ ((e) => (e.UNKNOWN = "bct_unknown", e.CODE128 = "bct_Code128", e.CODE39 = "bct_Code39", e.EAN8 = "bct_EAN8", e.ITF = "bct_ITF", e.PDF417 = "bct_PDF417", e.STF = "bct_STF", e.MTF = "bct_MTF", e.IATA = "bct_IATA", e.CODABAR = "bct_CODABAR", e.UPCA = "bct_UPCA", e.CODE93 = "bct_CODE93", e.UPCE = "bct_UPCE", e.EAN13 = "bct_EAN13", e.QRCODE = "bct_QRCODE", e.AZTEC = "bct_AZTEC", e.DATAMATRIX = "bct_DATAMATRIX", e.ALL_1D = "bct_ALL_1D", e.CODE11 = "bct_Code11", e.JABCODE = "bct_JABCODE", e))(LM || {}), MM = /* @__PURE__ */ ((e) => (e.Glares = "glaresCheck", e.Focus = "focusCheck", e.Resolution = "dpiThreshold", e.Colorness = "colornessCheck", e.Perspective = "perspectiveCheck", e.Bounds = "documentPosition", e.Portrait = "portraitCheck", e.Brightness = "brightnessCheck", e.Occlusion = "occlusionCheck", e))(MM || {}), Op = /* @__PURE__ */ ((e) => (e[e.LATIN = 0] = "LATIN", e[e.AFRIKAANS = 1078] = "AFRIKAANS", e[e.ALBANIAN = 1052] = "ALBANIAN", e[e.ARABIC_ALGERIA = 5121] = "ARABIC_ALGERIA", e[e.ARABIC_BAHRAIN = 15361] = "ARABIC_BAHRAIN", e[e.ARABIC_EGYPT = 3073] = "ARABIC_EGYPT", e[e.ARABIC_IRAQ = 2049] = "ARABIC_IRAQ", e[e.ARABIC_JORDAN = 11265] = "ARABIC_JORDAN", e[e.ARABIC_KUWAIT = 13313] = "ARABIC_KUWAIT", e[e.ARABIC_LEBANON = 12289] = "ARABIC_LEBANON", e[e.ARABIC_LIBYA = 4097] = "ARABIC_LIBYA", e[e.ARABIC_MOROCCO = 6145] = "ARABIC_MOROCCO", e[e.ARABIC_OMAN = 8193] = "ARABIC_OMAN", e[e.ARABIC_QATAR = 16385] = "ARABIC_QATAR", e[e.ARABIC_SAUDI_ARABIA = 1025] = "ARABIC_SAUDI_ARABIA", e[e.ARABIC_SYRIA = 10241] = "ARABIC_SYRIA", e[e.ARABIC_TUNISIA = 7169] = "ARABIC_TUNISIA", e[e.ARABIC_UAE = 14337] = "ARABIC_UAE", e[e.ARABIC_YEMEN = 9217] = "ARABIC_YEMEN", e[e.ARABIC_ARMENIAN = 1067] = "ARABIC_ARMENIAN", e[e.AZERI_CYRILIC = 2092] = "AZERI_CYRILIC", e[e.AZERI_LATIN = 1068] = "AZERI_LATIN", e[e.BASQUE = 1069] = "BASQUE", e[e.BELARUSIAN = 1059] = "BELARUSIAN", e[e.BULGARIAN = 1026] = "BULGARIAN", e[e.BURMESE = 1109] = "BURMESE", e[e.CATALAN = 1027] = "CATALAN", e[e.CHINESE_HONGKONG_SAR = 3076] = "CHINESE_HONGKONG_SAR", e[e.CHINESE_MACAO_SAR = 5124] = "CHINESE_MACAO_SAR", e[e.CHINESE = 2052] = "CHINESE", e[e.CHINESE_SINGAPORE = 4100] = "CHINESE_SINGAPORE", e[e.CHINESE_TAIWAN = 1028] = "CHINESE_TAIWAN", e[e.CROATIAN = 1050] = "CROATIAN", e[e.CZECH = 1029] = "CZECH", e[e.DANISH = 1030] = "DANISH", e[e.DIVEHI = 1125] = "DIVEHI", e[e.DUTCH_BELGIUM = 2067] = "DUTCH_BELGIUM", e[e.DUTCH_NETHERLANDS = 1043] = "DUTCH_NETHERLANDS", e[e.ENGLISH_AUSTRALIA = 3081] = "ENGLISH_AUSTRALIA", e[e.ENGLISH_BELIZE = 10249] = "ENGLISH_BELIZE", e[e.ENGLISH_CANADA = 4105] = "ENGLISH_CANADA", e[e.ENGLISH_CARRIBEAN = 9225] = "ENGLISH_CARRIBEAN", e[e.ENGLISH_IRELAND = 6153] = "ENGLISH_IRELAND", e[e.ENGLISH_JAMAICA = 8201] = "ENGLISH_JAMAICA", e[e.ENGLISH_NEW_ZEALAND = 5129] = "ENGLISH_NEW_ZEALAND", e[e.ENGLISH_PHILIPPINES = 13321] = "ENGLISH_PHILIPPINES", e[e.ENGLISH_SOUTH_AFRICA = 7177] = "ENGLISH_SOUTH_AFRICA", e[e.ENGLISH_TRINIDAD = 11273] = "ENGLISH_TRINIDAD", e[e.ENGLISH_UK = 2057] = "ENGLISH_UK", e[e.ENGLISH_US = 1033] = "ENGLISH_US", e[e.ENGLISH_ZIMBABWE = 12297] = "ENGLISH_ZIMBABWE", e[e.ESTONIAN = 1061] = "ESTONIAN", e[e.FAROESE = 1080] = "FAROESE", e[e.FARSI = 1065] = "FARSI", e[e.FINNISH = 1035] = "FINNISH", e[e.FRENCH_BELGIUM = 2060] = "FRENCH_BELGIUM", e[e.FRENCH_CANADA = 3084] = "FRENCH_CANADA", e[e.FRENCH_FRANCE = 1036] = "FRENCH_FRANCE", e[e.FRENCH_LUXEMBOURG = 5132] = "FRENCH_LUXEMBOURG", e[e.FRENCH_MONACO = 6156] = "FRENCH_MONACO", e[e.FRENCH_SWITZERLAND = 4108] = "FRENCH_SWITZERLAND", e[e.FYRO_MACEDONIAN = 1071] = "FYRO_MACEDONIAN", e[e.GALICIAN = 1110] = "GALICIAN", e[e.GEORGIAN = 1079] = "GEORGIAN", e[e.GERMAN_AUSTRIA = 3079] = "GERMAN_AUSTRIA", e[e.GERMAN_GERMANY = 1031] = "GERMAN_GERMANY", e[e.GERMAN_LIECHTENSTEIN = 5127] = "GERMAN_LIECHTENSTEIN", e[e.GERMAN_LUXEMBOURG = 4103] = "GERMAN_LUXEMBOURG", e[e.GERMAN_SWITZERLAND = 2055] = "GERMAN_SWITZERLAND", e[e.GREEK = 1032] = "GREEK", e[e.GUJARATI = 1095] = "GUJARATI", e[e.HEBREW = 1037] = "HEBREW", e[e.HINDI_INDIA = 1081] = "HINDI_INDIA", e[e.HUNGARIAN = 1038] = "HUNGARIAN", e[e.ICELANDIC = 1039] = "ICELANDIC", e[e.INDONESIAN = 1057] = "INDONESIAN", e[e.ITALIAN_ITALY = 1040] = "ITALIAN_ITALY", e[e.ITALIAN_SWITZERLAND = 2064] = "ITALIAN_SWITZERLAND", e[e.JAPANESE = 1041] = "JAPANESE", e[e.KANNADA = 1099] = "KANNADA", e[e.KAZAKH = 1087] = "KAZAKH", e[e.KHMER = 1107] = "KHMER", e[e.KONKANI = 1111] = "KONKANI", e[e.KOREAN = 1042] = "KOREAN", e[e.KYRGYZ_CYRILICK = 1088] = "KYRGYZ_CYRILICK", e[e.LATVIAN = 1062] = "LATVIAN", e[e.LITHUANIAN = 1063] = "LITHUANIAN", e[e.MALAY_MALAYSIA = 1086] = "MALAY_MALAYSIA", e[e.MALAY_BRUNEI_DARUSSALAM = 2110] = "MALAY_BRUNEI_DARUSSALAM", e[e.MALTESE = 1082] = "MALTESE", e[e.MARATHI = 1102] = "MARATHI", e[e.MONGOLIAN_CYRILIC = 1104] = "MONGOLIAN_CYRILIC", e[e.NORWEGIAN_BOKMAL = 1044] = "NORWEGIAN_BOKMAL", e[e.NORWEGIAN_NYORSK = 2068] = "NORWEGIAN_NYORSK", e[e.POLISH = 1045] = "POLISH", e[e.PORTUGUESE_BRAZIL = 1046] = "PORTUGUESE_BRAZIL", e[e.PORTUGUESE_PORTUGAL = 2070] = "PORTUGUESE_PORTUGAL", e[e.PUNJABI = 1094] = "PUNJABI", e[e.RHAETO_ROMANIC = 1047] = "RHAETO_ROMANIC", e[e.ROMANIAN = 1048] = "ROMANIAN", e[e.RUSSIAN = 1049] = "RUSSIAN", e[e.SANSKRIT = 1103] = "SANSKRIT", e[e.SERBIAN_CYRILIC = 3098] = "SERBIAN_CYRILIC", e[e.SERBIAN_LATIN = 2074] = "SERBIAN_LATIN", e[e.SINHALA = 1115] = "SINHALA", e[e.SLOVAK = 1051] = "SLOVAK", e[e.SLOVENIAN = 1060] = "SLOVENIAN", e[e.SPANISH_ARGENTINA = 11274] = "SPANISH_ARGENTINA", e[e.SPANISH_BOLIVIA = 16394] = "SPANISH_BOLIVIA", e[e.SPANISH_CHILE = 13322] = "SPANISH_CHILE", e[e.SPANICH_COLOMBIA = 9226] = "SPANICH_COLOMBIA", e[e.SPANISH_COSTA_RICA = 5130] = "SPANISH_COSTA_RICA", e[e.SPANISH_DOMINICAN_REPUBLIC = 7178] = "SPANISH_DOMINICAN_REPUBLIC", e[e.SPANISH_ECUADOR = 12298] = "SPANISH_ECUADOR", e[e.SPANISH_EL_SALVADOR = 17418] = "SPANISH_EL_SALVADOR", e[e.SPANISH_GUATEMALA = 4106] = "SPANISH_GUATEMALA", e[e.SPANISH_HONDURAS = 18442] = "SPANISH_HONDURAS", e[e.SPANISH_MEXICO = 2058] = "SPANISH_MEXICO", e[e.SPANISH_NICARAGUA = 19466] = "SPANISH_NICARAGUA", e[e.SPANISH_PANAMA = 6154] = "SPANISH_PANAMA", e[e.SPANISH_PARAGUAY = 15370] = "SPANISH_PARAGUAY", e[e.SPANISH_PERU = 10250] = "SPANISH_PERU", e[e.SPANISH_PUERTO_RICO = 20490] = "SPANISH_PUERTO_RICO", e[e.SPANISH_TRADITIONAL_SORT = 1034] = "SPANISH_TRADITIONAL_SORT", e[e.SPANISH_INTERNATIONAL_SORT = 3082] = "SPANISH_INTERNATIONAL_SORT", e[e.SPANISH_URUGUAY = 14346] = "SPANISH_URUGUAY", e[e.SPANISH_VENEZUELA = 8202] = "SPANISH_VENEZUELA", e[e.SWAHILI = 1089] = "SWAHILI", e[e.SWEDISH = 1053] = "SWEDISH", e[e.SWEDISH_FINLAND = 2077] = "SWEDISH_FINLAND", e[e.SYRIAC = 1114] = "SYRIAC", e[e.TAMIL = 1097] = "TAMIL", e[e.TATAR = 1092] = "TATAR", e[e.TELUGU = 1098] = "TELUGU", e[e.THAI_THAILAND = 1054] = "THAI_THAILAND", e[e.TURKISH = 1055] = "TURKISH", e[e.TAJIK_CYRILLIC = 1064] = "TAJIK_CYRILLIC", e[e.TURKMEN = 1090] = "TURKMEN", e[e.UKRAINIAN = 1058] = "UKRAINIAN", e[e.URDU = 1056] = "URDU", e[e.UZBEK_CYRILIC = 2115] = "UZBEK_CYRILIC", e[e.UZBEK_LATIN = 1091] = "UZBEK_LATIN", e[e.VIETNAMESE = 1066] = "VIETNAMESE", e[e.CTC_SIMPLIFIED = 50001] = "CTC_SIMPLIFIED", e[e.CTC_TRADITIONAL = 50002] = "CTC_TRADITIONAL", e[e.BENGALI_BANGLADESH = 2117] = "BENGALI_BANGLADESH", e[e.BENGALI_INDIA = 1093] = "BENGALI_INDIA", e[e.ASSAMESE = 1101] = "ASSAMESE", e[e.ORIYA = 1096] = "ORIYA", e[e.MALAYALAM = 1100] = "MALAYALAM", e[e.LAO = 1108] = "LAO", e[e.SINDHI_INDIA = 1113] = "SINDHI_INDIA", e[e.AMHARIC = 1118] = "AMHARIC", e[e.KASHMIRI = 1120] = "KASHMIRI", e[e.NEPALI = 1121] = "NEPALI", e[e.PASHTO = 1123] = "PASHTO", e[e.SINDHI = 2137] = "SINDHI", e[e.ARABIC = 4096] = "ARABIC", e[e.BANK_CARD_NUMBER = 1e4] = "BANK_CARD_NUMBER", e[e.BANK_CARD_EXPIRY_DATE = 10001] = "BANK_CARD_EXPIRY_DATE", e[e.BANK_CARD_NAME = 10002] = "BANK_CARD_NAME", e[e.BANK_CARD = 10003] = "BANK_CARD", e[e.BANK_CARD_CVV2 = 10004] = "BANK_CARD_CVV2", e[e.ABKHAZIAN = 10011] = "ABKHAZIAN", e[e.KARAKALPAK = 10012] = "KARAKALPAK", e[e.URDU_DETECTION = 10560] = "URDU_DETECTION", e))(Op || {}), yp = /* @__PURE__ */ ((e) => (e[e.OFF = 0] = "OFF", e[e.WHITE_TOP = 2] = "WHITE_TOP", e[e.WHITE_SIDE = 4] = "WHITE_SIDE", e[e.WHITE = 6] = "WHITE", e[e.IR = 24] = "IR", e[e.UV = 128] = "UV", e[e.AXIAL_WHITE = 3072] = "AXIAL_WHITE", e))(yp || {}), bM = /* @__PURE__ */ ((e) => (e.FATAL_ERROR = "FatalError", e.ERROR = "Error", e.WARNING = "Warning", e.INFO = "Info", e.DEBUG = "Debug", e))(bM || {}), PM = /* @__PURE__ */ ((e) => (e.IDL = "1x30", e.ID1 = "3x30", e.ID2 = "2x36", e.ID3 = "2x44", e.CAN = "1x6", e.ID1_2_30 = "2x30", e))(PM || {}), wM = /* @__PURE__ */ ((e) => (e[e.METRIC = 0] = "METRIC", e[e.IMPERIAL = 1] = "IMPERIAL", e))(wM || {}), HM = /* @__PURE__ */ ((e) => (e[e.eMDM_Default = 0] = "eMDM_Default", e[e.eMDM_ResizeBinarizeWindow = 1] = "eMDM_ResizeBinarizeWindow", e[e.eMDM_BlurBeforeBinarization = 2] = "eMDM_BlurBeforeBinarization", e))(HM || {}), VM = /* @__PURE__ */ ((e) => (e[e.errLDS_Ok = 1] = "errLDS_Ok", e[e.errLDS_ASN_IncorrectData = 2147483649] = "errLDS_ASN_IncorrectData", e[e.errLDS_ASN_NotEnoughData = 2147483650] = "errLDS_ASN_NotEnoughData", e[e.errLDS_ASN_Contents_UnexpectedData = 2147483651] = "errLDS_ASN_Contents_UnexpectedData", e[e.errLDS_ASN_SignedData_IncorrectData = 2147483656] = "errLDS_ASN_SignedData_IncorrectData", e[e.errLDS_ASN_SignedData_EncapContents_IncorrectData = 2147483657] = "errLDS_ASN_SignedData_EncapContents_IncorrectData", e[e.errLDS_ASN_SignedData_Version_IncorrectData = 2147483658] = "errLDS_ASN_SignedData_Version_IncorrectData", e[e.errLDS_ASN_SignedData_DigestAlgorithms_IncorrectData = 2147483665] = "errLDS_ASN_SignedData_DigestAlgorithms_IncorrectData", e[e.errLDS_ASN_LDSObject_IncorrectData = 2147483667] = "errLDS_ASN_LDSObject_IncorrectData", e[e.errLDS_ASN_LDSObject_Version_IncorrectData = 2147483668] = "errLDS_ASN_LDSObject_Version_IncorrectData", e[e.errLDS_ASN_LDSObject_DigestAlgorithm_IncorrectData = 2147483669] = "errLDS_ASN_LDSObject_DigestAlgorithm_IncorrectData", e[e.errLDS_ASN_LDSObject_DGHashes_IncorrectData = 2147483670] = "errLDS_ASN_LDSObject_DGHashes_IncorrectData", e[e.errLDS_ASN_LDSObject_VersionInfo_IncorrectData = 2147483666] = "errLDS_ASN_LDSObject_VersionInfo_IncorrectData", e[e.errLDS_ASN_Certificate_IncorrectData = 2147483671] = "errLDS_ASN_Certificate_IncorrectData", e[e.errLDS_ASN_Certificate_Version_IncorrectData = 2147483672] = "errLDS_ASN_Certificate_Version_IncorrectData", e[e.errLDS_ASN_Certificate_SN_IncorrectData = 2147483673] = "errLDS_ASN_Certificate_SN_IncorrectData", e[e.errLDS_ASN_Certificate_Signature_IncorrectData = 2147483674] = "errLDS_ASN_Certificate_Signature_IncorrectData", e[e.errLDS_ASN_Certificate_Issuer_IncorrectData = 2147483675] = "errLDS_ASN_Certificate_Issuer_IncorrectData", e[e.errLDS_ASN_Certificate_Validity_IncorrectData = 2147483676] = "errLDS_ASN_Certificate_Validity_IncorrectData", e[e.errLDS_ASN_Certificate_Subject_IncorrectData = 2147483677] = "errLDS_ASN_Certificate_Subject_IncorrectData", e[e.errLDS_ASN_Certificate_SubjectPK_IncorrectData = 2147483678] = "errLDS_ASN_Certificate_SubjectPK_IncorrectData", e[e.errLDS_ASN_Certificate_Extensions_IncorrectData = 2147483679] = "errLDS_ASN_Certificate_Extensions_IncorrectData", e[e.errLDS_ASN_SignerInfo_IncorrectData = 2147483680] = "errLDS_ASN_SignerInfo_IncorrectData", e[e.errLDS_ASN_SignerInfo_Version_IncorrectData = 2147483681] = "errLDS_ASN_SignerInfo_Version_IncorrectData", e[e.errLDS_ASN_SignerInfo_SID_IncorrectData = 2147483682] = "errLDS_ASN_SignerInfo_SID_IncorrectData", e[e.errLDS_ASN_SignerInfo_DigestAlg_IncorrectData = 2147483683] = "errLDS_ASN_SignerInfo_DigestAlg_IncorrectData", e[e.errLDS_ASN_SignerInfo_SignedAttrs_IncorrectData = 2147483684] = "errLDS_ASN_SignerInfo_SignedAttrs_IncorrectData", e[e.errLDS_ASN_SignerInfo_SignAlg_IncorrectData = 2147483685] = "errLDS_ASN_SignerInfo_SignAlg_IncorrectData", e[e.errLDS_ASN_SignerInfo_Signature_IncorrectData = 2147483686] = "errLDS_ASN_SignerInfo_Signature_IncorrectData", e[e.errLDS_ASN_SignerInfo_UnsignedAttrs_IncorrectData = 2147483687] = "errLDS_ASN_SignerInfo_UnsignedAttrs_IncorrectData", e[e.errLDS_ASN_DTC_SignerInfo_IncorrectData = 2147483712] = "errLDS_ASN_DTC_SignerInfo_IncorrectData", e[e.errLDS_ASN_DTC_SignerInfo_Certificate_IncorrectData = 2147483713] = "errLDS_ASN_DTC_SignerInfo_Certificate_IncorrectData", e[e.errLDS_ASN_DTC_SignerInfo_DigestAlg_IncorrectData = 2147483714] = "errLDS_ASN_DTC_SignerInfo_DigestAlg_IncorrectData", e[e.errLDS_ASN_DTC_SignerInfo_SignedAttrs_IncorrectData = 2147483715] = "errLDS_ASN_DTC_SignerInfo_SignedAttrs_IncorrectData", e[e.errLDS_ASN_DTC_SignerInfo_SignAlg_IncorrectData = 2147483716] = "errLDS_ASN_DTC_SignerInfo_SignAlg_IncorrectData", e[e.errLDS_ASN_DTC_SignerInfo_Signature_IncorrectData = 2147483717] = "errLDS_ASN_DTC_SignerInfo_Signature_IncorrectData", e[e.errLDS_ASN_DTC_SecurityInfo_IncorrectData = 2147483718] = "errLDS_ASN_DTC_SecurityInfo_IncorrectData", e[e.errLDS_ASN_DTC_ContentInfo_IncorrectData = 2147483719] = "errLDS_ASN_DTC_ContentInfo_IncorrectData", e[e.errLDS_ICAO_LDSObject_UnsupportedDigestAlgorithm = 2147483696] = "errLDS_ICAO_LDSObject_UnsupportedDigestAlgorithm", e[e.errLDS_ICAO_SignedData_SignerInfos_Empty = 2147483697] = "errLDS_ICAO_SignedData_SignerInfos_Empty", e[e.errLDS_ICAO_SignerInfo_UnsupportedDigestAlgorithm = 2147483698] = "errLDS_ICAO_SignerInfo_UnsupportedDigestAlgorithm", e[e.errLDS_ICAO_SignerInfo_UnsupportedSignatureAlgorithm = 2147483699] = "errLDS_ICAO_SignerInfo_UnsupportedSignatureAlgorithm", e[e.errLDS_ICAO_SignerInfo_MessageDigestError = 2147483700] = "errLDS_ICAO_SignerInfo_MessageDigestError", e[e.errLDS_ICAO_SignerInfo_SignedAttrs_Missed = 2147483702] = "errLDS_ICAO_SignerInfo_SignedAttrs_Missed", e[e.errLDS_Auth_SignerInfo_CantFindCertificate = 2147483701] = "errLDS_Auth_SignerInfo_CantFindCertificate", e[e.errLDS_Auth_Error = 2147483728] = "errLDS_Auth_Error", e[e.errLDS_Auth_UnsupportedSignatureAlgorithm = 2147483729] = "errLDS_Auth_UnsupportedSignatureAlgorithm", e[e.errLDS_Auth_UnsupportedPublicKeyAlgorithm = 2147483730] = "errLDS_Auth_UnsupportedPublicKeyAlgorithm", e[e.errLDS_Auth_MessedAlgorithms = 2147483731] = "errLDS_Auth_MessedAlgorithms", e[e.errLDS_Auth_PublicKeyDataInvalid = 2147483732] = "errLDS_Auth_PublicKeyDataInvalid", e[e.errLDS_Auth_AlgorithmParametersDataInvalid = 2147483733] = "errLDS_Auth_AlgorithmParametersDataInvalid", e[e.errLDS_Auth_SignatureDataInvalid = 2147483734] = "errLDS_Auth_SignatureDataInvalid", e[e.errLDS_Auth_UnsupportedDigestAlgorithm = 2147483735] = "errLDS_Auth_UnsupportedDigestAlgorithm", e[e.errLDS_Auth_SignatureDataIncorrect = 2147483736] = "errLDS_Auth_SignatureDataIncorrect", e[e.errLDS_Auth_AlgorithmParametersNotDefined = 2147483737] = "errLDS_Auth_AlgorithmParametersNotDefined", e[e.errLDS_Auth_SignatureCheckFailed = 2147483738] = "errLDS_Auth_SignatureCheckFailed", e[e.errLDS_DG_WrongTag = 2147483760] = "errLDS_DG_WrongTag", e[e.errLDS_DG_Contents_UnexpectedData = 2147483761] = "errLDS_DG_Contents_UnexpectedData", e[e.errLDS_BAP_SymmetricCypher_CantInitialize = 2164260881] = "errLDS_BAP_SymmetricCypher_CantInitialize", e[e.errLDS_PACE_Info_NotAvailable = 2164260896] = "errLDS_PACE_Info_NotAvailable", e[e.errLDS_PACE_SymmetricCypher_CantInitialize = 2164260897] = "errLDS_PACE_SymmetricCypher_CantInitialize", e[e.errLDS_PACE_KeyAgreement_CantInitialize = 2164260898] = "errLDS_PACE_KeyAgreement_CantInitialize", e[e.errLDS_PACE_EphemeralKeys_CantCreate = 2164260899] = "errLDS_PACE_EphemeralKeys_CantCreate", e[e.errLDS_PACE_Mapping_CantDecodeNonce = 2164260900] = "errLDS_PACE_Mapping_CantDecodeNonce", e[e.errLDS_PACE_SharedSecret_CantCreate = 2164260901] = "errLDS_PACE_SharedSecret_CantCreate", e[e.errLDS_PACE_DomainParams_UnsupportedFormat = 2164260902] = "errLDS_PACE_DomainParams_UnsupportedFormat", e[e.errLDS_PACE_EphemeralKeys_Incorrect = 2164260903] = "errLDS_PACE_EphemeralKeys_Incorrect", e[e.errLDS_PACE_Mapping_EphemeralKeys_Incorrect = 2164260904] = "errLDS_PACE_Mapping_EphemeralKeys_Incorrect", e[e.errLDS_PACE_Mapping_CantPerform = 2164260905] = "errLDS_PACE_Mapping_CantPerform", e[e.errLDS_PACE_NonMatchingAuthTokens = 2164260906] = "errLDS_PACE_NonMatchingAuthTokens", e[e.errLDS_PACE_CAM_Data_Incorrect = 2164260907] = "errLDS_PACE_CAM_Data_Incorrect", e[e.errLDS_PACE_CAM_Data_CantVerify = 2164260908] = "errLDS_PACE_CAM_Data_CantVerify", e[e.errLDS_PACE_CAM_Data_NonMatching = 2164260909] = "errLDS_PACE_CAM_Data_NonMatching", e[e.errLDS_PACE_IM_Scheme_Incorrect = 2164260910] = "errLDS_PACE_IM_Scheme_Incorrect", e[e.errLDS_PACE_IM_RandomMapping_Failed = 2164260911] = "errLDS_PACE_IM_RandomMapping_Failed", e[e.errLDS_CA_CantFindPublicKey = 2164260912] = "errLDS_CA_CantFindPublicKey", e[e.errLDS_CA_CantFindInfo = 2164260913] = "errLDS_CA_CantFindInfo", e[e.errLDS_CA_IncorrectVersion = 2164260914] = "errLDS_CA_IncorrectVersion", e[e.errLDS_CA_CantFindDomainParameters = 2164260915] = "errLDS_CA_CantFindDomainParameters", e[e.errLDS_CA_KeyAgreement_CantInitialize = 2164260916] = "errLDS_CA_KeyAgreement_CantInitialize", e[e.errLDS_CA_PublicKey_UnsupportedAlgorithm = 2164260917] = "errLDS_CA_PublicKey_UnsupportedAlgorithm", e[e.errLDS_CA_EphemeralKeys_CantCreate = 2164260918] = "errLDS_CA_EphemeralKeys_CantCreate", e[e.errLDS_CA_SharedSecret_CantCreate = 2164260919] = "errLDS_CA_SharedSecret_CantCreate", e[e.errLDS_CA_NonMatchingAuthTokens = 2164260920] = "errLDS_CA_NonMatchingAuthTokens", e[e.errLDS_TA_IncorrectVersion = 2164260928] = "errLDS_TA_IncorrectVersion", e[e.errLDS_TA_CantBuildCertificateChain = 2164260929] = "errLDS_TA_CantBuildCertificateChain", e[e.errLDS_TA_CantFindISPrivateKey = 2164260930] = "errLDS_TA_CantFindISPrivateKey", e[e.errLDS_TA_PublicKey_UnsupportedAlgorithm = 2164260931] = "errLDS_TA_PublicKey_UnsupportedAlgorithm", e[e.errLDS_TA_SignatureBuildingError = 2164260932] = "errLDS_TA_SignatureBuildingError", e[e.errLDS_TA_InvalidKeyAlgorithmParameters = 2164260933] = "errLDS_TA_InvalidKeyAlgorithmParameters", e[e.errLDS_AA_PublicKey_UnsupportedAlgorithm = 2164260944] = "errLDS_AA_PublicKey_UnsupportedAlgorithm", e[e.errLDS_AA_PublicKey_IncorrectData = 2164260945] = "errLDS_AA_PublicKey_IncorrectData", e[e.errLDS_AA_PublicKey_IncorrectParameters = 2164260946] = "errLDS_AA_PublicKey_IncorrectParameters", e[e.errLDS_AA_PublicKey_UndefinedParameters = 2164260947] = "errLDS_AA_PublicKey_UndefinedParameters", e[e.errLDS_AA_Signature_IncorrectData = 2164260948] = "errLDS_AA_Signature_IncorrectData", e[e.errLDS_AA_UnsupportedRecoveryScheme = 2164260949] = "errLDS_AA_UnsupportedRecoveryScheme", e[e.errLDS_AA_IncorrectTrailer = 2164260950] = "errLDS_AA_IncorrectTrailer", e[e.errLDS_AA_UnsupportedDigestAlgorithm = 2164260951] = "errLDS_AA_UnsupportedDigestAlgorithm", e[e.errLDS_RI_SectorKey_CantFind = 2164260976] = "errLDS_RI_SectorKey_CantFind", e[e.errLDS_RI_SectorKey_IncorrectData = 2164260977] = "errLDS_RI_SectorKey_IncorrectData", e[e.errLDS_RI_SectorKey_IncompleteData = 2164260978] = "errLDS_RI_SectorKey_IncompleteData", e[e.errLDS_CV_Certificate_MissingMandatoryData_PK = 2164260960] = "errLDS_CV_Certificate_MissingMandatoryData_PK", e[e.errLDS_CV_Certificate_PublicKey_Unsupported = 2164260962] = "errLDS_CV_Certificate_PublicKey_Unsupported", e[e.errLDS_CV_Certificate_CHAT_UnsupportedTerminalType = 2164260963] = "errLDS_CV_Certificate_CHAT_UnsupportedTerminalType", e[e.errLDS_CV_Certificate_PrivateKey_Unsupported = 2164260964] = "errLDS_CV_Certificate_PrivateKey_Unsupported", e[e.errLDS_CV_Certificate_PrivateKey_InvalidParams = 2164260965] = "errLDS_CV_Certificate_PrivateKey_InvalidParams", e[e.errLDS_CV_Certificate_IncorrectData = 2164261216] = "errLDS_CV_Certificate_IncorrectData", e[e.errLDS_CV_Certificate_CPI_IncorrectData = 2164261217] = "errLDS_CV_Certificate_CPI_IncorrectData", e[e.errLDS_CV_Certificate_CAR_IncorrectData = 2164261218] = "errLDS_CV_Certificate_CAR_IncorrectData", e[e.errLDS_CV_Certificate_PublicKey_IncorrectData = 2164261219] = "errLDS_CV_Certificate_PublicKey_IncorrectData", e[e.errLDS_CV_Certificate_CHR_IncorrectData = 2164261220] = "errLDS_CV_Certificate_CHR_IncorrectData", e[e.errLDS_CV_Certificate_CHAT_IncorrectData = 2164261221] = "errLDS_CV_Certificate_CHAT_IncorrectData", e[e.errLDS_CV_Certificate_ValidFrom_IncorrectData = 2164261222] = "errLDS_CV_Certificate_ValidFrom_IncorrectData", e[e.errLDS_CV_Certificate_ValidTo_IncorrectData = 2164261223] = "errLDS_CV_Certificate_ValidTo_IncorrectData", e[e.errLDS_CV_Certificate_Extensions_IncorrectData = 2164261224] = "errLDS_CV_Certificate_Extensions_IncorrectData", e[e.errLDS_CV_Certificate_PrivateKey_IncorrectData = 2164261225] = "errLDS_CV_Certificate_PrivateKey_IncorrectData", e[e.errLDS_CV_Certificate_PrivateKey_Missing = 2164261226] = "errLDS_CV_Certificate_PrivateKey_Missing", e[e.errLDS_VDS_UnsupportedVersion = 2164261376] = "errLDS_VDS_UnsupportedVersion", e[e.errLDS_VDS_Issuing_Country_Size = 2164261377] = "errLDS_VDS_Issuing_Country_Size", e[e.errLDS_VDS_Issuing_Country_IncorrectData = 2164261378] = "errLDS_VDS_Issuing_Country_IncorrectData", e[e.errLDS_VDS_Signer_Certificate_Size = 2164261379] = "errLDS_VDS_Signer_Certificate_Size", e[e.errLDS_VDS_Signer_Certificate_Data = 2164261380] = "errLDS_VDS_Signer_Certificate_Data", e[e.errLDS_VDS_Signature_IncorrectData = 2164261381] = "errLDS_VDS_Signature_IncorrectData", e[e.errLDS_VDS_NC_IncorrectData = 2164261632] = "errLDS_VDS_NC_IncorrectData", e[e.errLDS_VDS_NC_MissingOrIncorrect_Data = 2164261633] = "errLDS_VDS_NC_MissingOrIncorrect_Data", e[e.errLDS_VDS_NC_MissingOrIncorrect_Header = 2164261634] = "errLDS_VDS_NC_MissingOrIncorrect_Header", e[e.errLDS_VDS_NC_MissingOrIncorrect_Type = 2164261635] = "errLDS_VDS_NC_MissingOrIncorrect_Type", e[e.errLDS_VDS_NC_MissingOrIncorrect_Version = 2164261636] = "errLDS_VDS_NC_MissingOrIncorrect_Version", e[e.errLDS_VDS_NC_MissingOrIncorrect_IssuingCountry = 2164261637] = "errLDS_VDS_NC_MissingOrIncorrect_IssuingCountry", e[e.errLDS_VDS_NC_MissingOrIncorrect_Message = 2164261638] = "errLDS_VDS_NC_MissingOrIncorrect_Message", e[e.errLDS_VDS_NC_MissingOrIncorrect_Signature = 2164261639] = "errLDS_VDS_NC_MissingOrIncorrect_Signature", e[e.errLDS_VDS_NC_MissingOrIncorrect_SigAlgorithm = 2164261640] = "errLDS_VDS_NC_MissingOrIncorrect_SigAlgorithm", e[e.errLDS_VDS_NC_MissingOrIncorrect_Certificate = 2164261641] = "errLDS_VDS_NC_MissingOrIncorrect_Certificate", e[e.errLDS_VDS_NC_MissingOrIncorrect_SigValue = 2164261642] = "errLDS_VDS_NC_MissingOrIncorrect_SigValue", e))(VM || {}), kM = /* @__PURE__ */ ((e) => (e[e.ntfLDS_ASN_Certificate_IncorrectVersion = 2415919105] = "ntfLDS_ASN_Certificate_IncorrectVersion", e[e.ntfLDS_ASN_Certificate_NonMatchingSignatureAlgorithm = 2415919106] = "ntfLDS_ASN_Certificate_NonMatchingSignatureAlgorithm", e[e.ntfLDS_ASN_Certificate_IncorrectTimeCoding = 2415919107] = "ntfLDS_ASN_Certificate_IncorrectTimeCoding", e[e.ntfLDS_ASN_Certificate_IncorrectUseOfGeneralizedTime = 2415919108] = "ntfLDS_ASN_Certificate_IncorrectUseOfGeneralizedTime", e[e.ntfLDS_ASN_Certificate_EmptyIssuer = 2415919109] = "ntfLDS_ASN_Certificate_EmptyIssuer", e[e.ntfLDS_ASN_Certificate_EmptySubject = 2415919110] = "ntfLDS_ASN_Certificate_EmptySubject", e[e.ntfLDS_ASN_Certificate_UnsupportedCriticalExtension = 2415919112] = "ntfLDS_ASN_Certificate_UnsupportedCriticalExtension", e[e.ntfLDS_ASN_Certificate_ForcedDefaultCSCARole = 2415919118] = "ntfLDS_ASN_Certificate_ForcedDefaultCSCARole", e[e.ntfLDS_ASN_Certificate_ForcedDefaultDSRole = 2415919119] = "ntfLDS_ASN_Certificate_ForcedDefaultDSRole", e[e.ntfLDS_ASN_Certificate_IncorrectIssuerSubjectDS = 2415919120] = "ntfLDS_ASN_Certificate_IncorrectIssuerSubjectDS", e[e.ntfLDS_ASN_Certificate_DuplicatingExtensions = 2415919127] = "ntfLDS_ASN_Certificate_DuplicatingExtensions", e[e.ntfLDS_ICAO_Certificate_Version_Missed = 2415919616] = "ntfLDS_ICAO_Certificate_Version_Missed", e[e.ntfLDS_ICAO_Certificate_Version_Incorrect = 2415919617] = "ntfLDS_ICAO_Certificate_Version_Incorrect", e[e.ntfLDS_ICAO_Certificate_Issuer_Country_Missed = 2415919618] = "ntfLDS_ICAO_Certificate_Issuer_Country_Missed", e[e.ntfLDS_ICAO_Certificate_Issuer_CommonName_Missed = 2415919619] = "ntfLDS_ICAO_Certificate_Issuer_CommonName_Missed", e[e.ntfLDS_ICAO_Certificate_Issuer_CountryNonCompliant = 2415919620] = "ntfLDS_ICAO_Certificate_Issuer_CountryNonCompliant", e[e.ntfLDS_ICAO_Certificate_Subject_Country_Missed = 2415919621] = "ntfLDS_ICAO_Certificate_Subject_Country_Missed", e[e.ntfLDS_ICAO_Certificate_Subject_CommonName_Missed = 2415919622] = "ntfLDS_ICAO_Certificate_Subject_CommonName_Missed", e[e.ntfLDS_ICAO_Certificate_Subject_CountryNonCompliant = 2415919623] = "ntfLDS_ICAO_Certificate_Subject_CountryNonCompliant", e[e.ntfLDS_ICAO_Certificate_UsingNonCompliantData = 2415919624] = "ntfLDS_ICAO_Certificate_UsingNonCompliantData", e[e.ntfLDS_ICAO_Certificate_UnsupportedSignatureAlgorithm = 2415919625] = "ntfLDS_ICAO_Certificate_UnsupportedSignatureAlgorithm", e[e.ntfLDS_ICAO_Certificate_UnsupportedPublicKeyAlgorithm = 2415919626] = "ntfLDS_ICAO_Certificate_UnsupportedPublicKeyAlgorithm", e[e.ntfLDS_ICAO_Certificate_MissedExtensions = 2415919627] = "ntfLDS_ICAO_Certificate_MissedExtensions", e[e.ntfLDS_ICAO_Certificate_Validity = 2415919628] = "ntfLDS_ICAO_Certificate_Validity", e[e.ntfLDS_ICAO_Certificate_Ext_UsingNonCompliantData = 2415919629] = "ntfLDS_ICAO_Certificate_Ext_UsingNonCompliantData", e[e.ntfLDS_ICAO_Certificate_Ext_KeyUsage_Missed = 2415919630] = "ntfLDS_ICAO_Certificate_Ext_KeyUsage_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_KeyUsage_NotCritical = 2415919631] = "ntfLDS_ICAO_Certificate_Ext_KeyUsage_NotCritical", e[e.ntfLDS_ICAO_Certificate_Ext_KeyUsage_IncorrectData = 2415919632] = "ntfLDS_ICAO_Certificate_Ext_KeyUsage_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_BasicC_Missed = 2415919633] = "ntfLDS_ICAO_Certificate_Ext_BasicC_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_BasicC_IncorrectUsage1 = 2415919634] = "ntfLDS_ICAO_Certificate_Ext_BasicC_IncorrectUsage1", e[e.ntfLDS_ICAO_Certificate_Ext_BasicC_IncorrectUsage2 = 2415919635] = "ntfLDS_ICAO_Certificate_Ext_BasicC_IncorrectUsage2", e[e.ntfLDS_ICAO_Certificate_Ext_BasicC_NotCritical = 2415919636] = "ntfLDS_ICAO_Certificate_Ext_BasicC_NotCritical", e[e.ntfLDS_ICAO_Certificate_Ext_BasicC_IncorrectData = 2415919637] = "ntfLDS_ICAO_Certificate_Ext_BasicC_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_BasicC_PathLenC_Missed = 2415919638] = "ntfLDS_ICAO_Certificate_Ext_BasicC_PathLenC_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_BasicC_PathLenC_Incorrect = 2415919639] = "ntfLDS_ICAO_Certificate_Ext_BasicC_PathLenC_Incorrect", e[e.ntfLDS_ICAO_Certificate_Ext_ExtKeyUsage_NotCritical = 2415919640] = "ntfLDS_ICAO_Certificate_Ext_ExtKeyUsage_NotCritical", e[e.ntfLDS_ICAO_Certificate_Ext_ExtKeyUsage_IncorrectUsage = 2415919641] = "ntfLDS_ICAO_Certificate_Ext_ExtKeyUsage_IncorrectUsage", e[e.ntfLDS_ICAO_Certificate_Ext_ExtKeyUsage_IncorrectData = 2415919642] = "ntfLDS_ICAO_Certificate_Ext_ExtKeyUsage_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_AuthKeyID_Missed = 2415919643] = "ntfLDS_ICAO_Certificate_Ext_AuthKeyID_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_AuthKeyID_IncorrectData = 2415919644] = "ntfLDS_ICAO_Certificate_Ext_AuthKeyID_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_AuthKeyID_KeyID_Missed = 2415919645] = "ntfLDS_ICAO_Certificate_Ext_AuthKeyID_KeyID_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectKeyID_Missed = 2415919646] = "ntfLDS_ICAO_Certificate_Ext_SubjectKeyID_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectKeyID_IncorrectData = 2415919647] = "ntfLDS_ICAO_Certificate_Ext_SubjectKeyID_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_PrivateKeyUP_Missed = 2415919648] = "ntfLDS_ICAO_Certificate_Ext_PrivateKeyUP_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_PrivateKeyUP_IncorrectData = 2415919649] = "ntfLDS_ICAO_Certificate_Ext_PrivateKeyUP_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_PrivateKeyUP_Empty = 2415919650] = "ntfLDS_ICAO_Certificate_Ext_PrivateKeyUP_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_Missed = 2415919651] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_IncorrectData = 2415919652] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_Empty = 2415919653] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_NonCompliant = 2415919654] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_Critical = 2415919656] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_Critical", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_DN_Empty = 2415919657] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_DN_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_DN_Incorrect = 2415919658] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_DN_Incorrect", e[e.ntfLDS_ICAO_Certificate_Ext_SubjectAltName_DN_NonCompliant = 2415919659] = "ntfLDS_ICAO_Certificate_Ext_SubjectAltName_DN_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_Missed = 2415919660] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_IncorrectData = 2415919661] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_Empty = 2415919662] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_NonCompliant = 2415919663] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_Critical = 2415919665] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_Critical", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_DN_Empty = 2415919666] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_DN_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_DN_Incorrect = 2415919667] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_DN_Incorrect", e[e.ntfLDS_ICAO_Certificate_Ext_IssuerAltName_DN_NonCompliant = 2415919668] = "ntfLDS_ICAO_Certificate_Ext_IssuerAltName_DN_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Ext_DocTypeList_Missed = 2415919669] = "ntfLDS_ICAO_Certificate_Ext_DocTypeList_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_DocTypeList_IncorrectData = 2415919670] = "ntfLDS_ICAO_Certificate_Ext_DocTypeList_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_DocTypeList_Version = 2415919671] = "ntfLDS_ICAO_Certificate_Ext_DocTypeList_Version", e[e.ntfLDS_ICAO_Certificate_Ext_DocTypeList_DocTypes = 2415919672] = "ntfLDS_ICAO_Certificate_Ext_DocTypeList_DocTypes", e[e.ntfLDS_ICAO_Certificate_Ext_DocTypeList_DocTypes_Empty = 2415919673] = "ntfLDS_ICAO_Certificate_Ext_DocTypeList_DocTypes_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_CertPolicies_IncorrectData = 2415919674] = "ntfLDS_ICAO_Certificate_Ext_CertPolicies_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_CertPolicies_Empty = 2415919675] = "ntfLDS_ICAO_Certificate_Ext_CertPolicies_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_CertPolicies_PolicyID_Missed = 2415919676] = "ntfLDS_ICAO_Certificate_Ext_CertPolicies_PolicyID_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_Missed = 2415919677] = "ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_Missed", e[e.ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_IncorrectData = 2415919678] = "ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_Empty = 2415919679] = "ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_Empty", e[e.ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_PointMissed = 2415919680] = "ntfLDS_ICAO_Certificate_Ext_CRLDistPoint_PointMissed", e[e.ntfLDS_ICAO_Certificate_SN_NonCompliant = 2415919681] = "ntfLDS_ICAO_Certificate_SN_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Issuer_SN_NonCompliant = 2415919682] = "ntfLDS_ICAO_Certificate_Issuer_SN_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Subject_SN_NonCompliant = 2415919683] = "ntfLDS_ICAO_Certificate_Subject_SN_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Issuer_AttributeNonCompliant = 2415919684] = "ntfLDS_ICAO_Certificate_Issuer_AttributeNonCompliant", e[e.ntfLDS_ICAO_Certificate_Subject_AttributeNonCompliant = 2415919685] = "ntfLDS_ICAO_Certificate_Subject_AttributeNonCompliant", e[e.ntfLDS_ICAO_Certificate_IssuerSubject_Country_NonMatching = 2415919686] = "ntfLDS_ICAO_Certificate_IssuerSubject_Country_NonMatching", e[e.ntfLDS_ICAO_Certificate_Ext_CSCA_AltNames_NonMatching = 2415919687] = "ntfLDS_ICAO_Certificate_Ext_CSCA_AltNames_NonMatching", e[e.ntfLDS_ICAO_Certificate_Ext_NameChange_IncorrectData = 2415919688] = "ntfLDS_ICAO_Certificate_Ext_NameChange_IncorrectData", e[e.ntfLDS_ICAO_Certificate_Ext_NameChange_NonCompliant = 2415919689] = "ntfLDS_ICAO_Certificate_Ext_NameChange_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Ext_NameChange_Critical = 2415919690] = "ntfLDS_ICAO_Certificate_Ext_NameChange_Critical", e[e.ntfLDS_ICAO_Certificate_Ext_DocTypeList_NonCompliant = 2415919691] = "ntfLDS_ICAO_Certificate_Ext_DocTypeList_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Ext_DocTypeList_Critical = 2415919692] = "ntfLDS_ICAO_Certificate_Ext_DocTypeList_Critical", e[e.ntfLDS_ICAO_Certificate_Ext_Optional_Critical = 2415919693] = "ntfLDS_ICAO_Certificate_Ext_Optional_Critical", e[e.ntfLDS_ICAO_Certificate_Subject_NonCompliant = 2415919694] = "ntfLDS_ICAO_Certificate_Subject_NonCompliant", e[e.ntfLDS_ICAO_Certificate_Subject_CommonNameNonCompliant = 2415919695] = "ntfLDS_ICAO_Certificate_Subject_CommonNameNonCompliant", e[e.ntfLDS_ICAO_Certificate_Chain_Country_NonMatching = 2415919696] = "ntfLDS_ICAO_Certificate_Chain_Country_NonMatching", e[e.ntfLDS_ICAO_Certificate_VisualMrz_Country_NonMatching = 2415919697] = "ntfLDS_ICAO_Certificate_VisualMrz_Country_NonMatching", e[e.ntfLDS_ICAO_Certificate_MRZ_Country_NonMatching = 2415919698] = "ntfLDS_ICAO_Certificate_MRZ_Country_NonMatching", e[e.ntfLDS_ICAO_Certificate_Issuer_CountryNonUpperCase = 2415919699] = "ntfLDS_ICAO_Certificate_Issuer_CountryNonUpperCase", e[e.ntfLDS_ICAO_Certificate_Subject_CountryNonUpperCase = 2415919700] = "ntfLDS_ICAO_Certificate_Subject_CountryNonUpperCase", e[e.ntfLDS_ICAO_COM_LDS_Version_Incorrect = 2415919136] = "ntfLDS_ICAO_COM_LDS_Version_Incorrect", e[e.ntfLDS_ICAO_COM_LDS_Version_Missing = 2415919137] = "ntfLDS_ICAO_COM_LDS_Version_Missing", e[e.ntfLDS_ICAO_COM_Unicode_Version_Incorrect = 2415919138] = "ntfLDS_ICAO_COM_Unicode_Version_Incorrect", e[e.ntfLDS_ICAO_COM_Unicode_Version_Missing = 2415919139] = "ntfLDS_ICAO_COM_Unicode_Version_Missing", e[e.ntfLDS_ICAO_COM_DGPM_Incorrect = 2415919140] = "ntfLDS_ICAO_COM_DGPM_Incorrect", e[e.ntfLDS_ICAO_COM_DGPM_Missing = 2415919141] = "ntfLDS_ICAO_COM_DGPM_Missing", e[e.ntfLDS_ICAO_COM_DGPM_Unexpected = 2415919142] = "ntfLDS_ICAO_COM_DGPM_Unexpected", e[e.ntfLDS_ICAO_Application_LDSVersion_Unsupported = 2415919152] = "ntfLDS_ICAO_Application_LDSVersion_Unsupported", e[e.ntfLDS_ICAO_Application_UnicodeVersion_Unsupported = 2415919153] = "ntfLDS_ICAO_Application_UnicodeVersion_Unsupported", e[e.ntfLDS_ICAO_Application_LDSVersion_Inconsistent = 2415919154] = "ntfLDS_ICAO_Application_LDSVersion_Inconsistent", e[e.ntfLDS_ICAO_Application_UnicodeVersion_Inconsistent = 2415919155] = "ntfLDS_ICAO_Application_UnicodeVersion_Inconsistent", e[e.ntfLDS_ASN_SignedData_OID_Incorrect = 2415919360] = "ntfLDS_ASN_SignedData_OID_Incorrect", e[e.ntfLDS_ASN_SignedData_Version_Incorrect = 2415919520] = "ntfLDS_ASN_SignedData_Version_Incorrect", e[e.ntfLDS_ASN_SignedData_ContentOID_Incorrect = 2415919521] = "ntfLDS_ASN_SignedData_ContentOID_Incorrect", e[e.ntfLDS_ICAO_SignedData_Version_Incorrect = 2415919361] = "ntfLDS_ICAO_SignedData_Version_Incorrect", e[e.ntfLDS_ICAO_SignedData_DigestAlgorithms_Empty = 2415919362] = "ntfLDS_ICAO_SignedData_DigestAlgorithms_Empty", e[e.ntfLDS_ICAO_SignedData_DigestAlgorithms_Unsupported = 2415919363] = "ntfLDS_ICAO_SignedData_DigestAlgorithms_Unsupported", e[e.ntfLDS_ICAO_SignedData_SignerInfos_MultipleEntries = 2415919369] = "ntfLDS_ICAO_SignedData_SignerInfos_MultipleEntries", e[e.ntfLDS_ICAO_SignedData_Certificates_Missed = 2415919536] = "ntfLDS_ICAO_SignedData_Certificates_Missed", e[e.ntfLDS_ICAO_SignedData_Certificates_Empty = 2415919537] = "ntfLDS_ICAO_SignedData_Certificates_Empty", e[e.ntfLDS_ICAO_SignedData_CRLs_IncorrectUsage = 2415919538] = "ntfLDS_ICAO_SignedData_CRLs_IncorrectUsage", e[e.ntfLDS_ICAO_LDSObject_IncorrectContentOID = 2415919364] = "ntfLDS_ICAO_LDSObject_IncorrectContentOID", e[e.ntfLDS_ICAO_LDSObject_DGNumber_Incorrect = 2415919365] = "ntfLDS_ICAO_LDSObject_DGNumber_Incorrect", e[e.ntfLDS_ICAO_LDSObject_DGHash_Missing = 2415919366] = "ntfLDS_ICAO_LDSObject_DGHash_Missing", e[e.ntfLDS_ICAO_LDSObject_DGHash_Extra = 2415919367] = "ntfLDS_ICAO_LDSObject_DGHash_Extra", e[e.ntfLDS_ICAO_LDSObject_Version_Incorrect = 2415919368] = "ntfLDS_ICAO_LDSObject_Version_Incorrect", e[e.ntfLDS_ICAO_MasterList_Version_Incorrect = 2415919552] = "ntfLDS_ICAO_MasterList_Version_Incorrect", e[e.ntfLDS_ICAO_DeviationList_Version_Incorrect = 2415919560] = "ntfLDS_ICAO_DeviationList_Version_Incorrect", e[e.ntfLDS_BSI_DefectList_Version_Incorrect = 2415919568] = "ntfLDS_BSI_DefectList_Version_Incorrect", e[e.ntfLDS_BSI_BlackList_Version_Incorrect = 2415919576] = "ntfLDS_BSI_BlackList_Version_Incorrect", e[e.ntfLDS_ASN_SignerInfo_Version_Incorrect = 2415919370] = "ntfLDS_ASN_SignerInfo_Version_Incorrect", e[e.ntfLDS_ASN_SignerInfo_SID_IncorrectChoice = 2415919371] = "ntfLDS_ASN_SignerInfo_SID_IncorrectChoice", e[e.ntfLDS_ASN_SignerInfo_SID_DigestAlgorithmNotListed = 2415919372] = "ntfLDS_ASN_SignerInfo_SID_DigestAlgorithmNotListed", e[e.ntfLDS_ASN_SignerInfo_MessageDigestAttr_Missing = 2415919373] = "ntfLDS_ASN_SignerInfo_MessageDigestAttr_Missing", e[e.ntfLDS_ASN_SignerInfo_MessageDigestAttr_Data = 2415919374] = "ntfLDS_ASN_SignerInfo_MessageDigestAttr_Data", e[e.ntfLDS_ASN_SignerInfo_MessageDigestAttr_Value = 2415919375] = "ntfLDS_ASN_SignerInfo_MessageDigestAttr_Value", e[e.ntfLDS_ASN_SignerInfo_ContentTypeAttr_Missing = 2415919376] = "ntfLDS_ASN_SignerInfo_ContentTypeAttr_Missing", e[e.ntfLDS_ASN_SignerInfo_ContentTypeAttr_Data = 2415919377] = "ntfLDS_ASN_SignerInfo_ContentTypeAttr_Data", e[e.ntfLDS_ASN_SignerInfo_ContentTypeAttr_Value = 2415919378] = "ntfLDS_ASN_SignerInfo_ContentTypeAttr_Value", e[e.ntfLDS_ASN_SignerInfo_SigningTimeAttr_Missing = 2415919387] = "ntfLDS_ASN_SignerInfo_SigningTimeAttr_Missing", e[e.ntfLDS_ASN_SignerInfo_SigningTimeAttr_Data = 2415919388] = "ntfLDS_ASN_SignerInfo_SigningTimeAttr_Data", e[e.ntfLDS_ASN_SignerInfo_SigningTimeAttr_Value = 2415919389] = "ntfLDS_ASN_SignerInfo_SigningTimeAttr_Value", e[e.ntfLDS_ASN_SignerInfo_ListContentDescriptionAttr_Missing = 2415919390] = "ntfLDS_ASN_SignerInfo_ListContentDescriptionAttr_Missing", e[e.ntfLDS_ASN_SignerInfo_ListContentDescriptionAttr_Data = 2415919391] = "ntfLDS_ASN_SignerInfo_ListContentDescriptionAttr_Data", e[e.ntfLDS_Auth_SignerInfo_Certificate_Validity = 2415919381] = "ntfLDS_Auth_SignerInfo_Certificate_Validity", e[e.ntfLDS_Auth_SignerInfo_Certificate_RootIsNotTrusted = 2415919382] = "ntfLDS_Auth_SignerInfo_Certificate_RootIsNotTrusted", e[e.ntfLDS_Auth_SignerInfo_Certificate_CantFindCSCA = 2415919383] = "ntfLDS_Auth_SignerInfo_Certificate_CantFindCSCA", e[e.ntfLDS_Auth_SignerInfo_Certificate_Revoked = 2415919384] = "ntfLDS_Auth_SignerInfo_Certificate_Revoked", e[e.ntfLDS_Auth_SignerInfo_Certificate_SignatureInvalid = 2415919385] = "ntfLDS_Auth_SignerInfo_Certificate_SignatureInvalid", e[e.ntfLDS_UnsupportedImageFormat = 2415919386] = "ntfLDS_UnsupportedImageFormat", e[e.ntfLDS_MRZ_DocumentType_Unknown = 139272] = "ntfLDS_MRZ_DocumentType_Unknown", e[e.ntfLDS_MRZ_IssuingState_SyntaxError = 139273] = "ntfLDS_MRZ_IssuingState_SyntaxError", e[e.ntfLDS_MRZ_Name_IsVoid = 139274] = "ntfLDS_MRZ_Name_IsVoid", e[e.ntfLDS_MRZ_Number_IncorrectChecksum = 139277] = "ntfLDS_MRZ_Number_IncorrectChecksum", e[e.ntfLDS_MRZ_Nationality_SyntaxError = 139278] = "ntfLDS_MRZ_Nationality_SyntaxError", e[e.ntfLDS_MRZ_DOB_SyntaxError = 139279] = "ntfLDS_MRZ_DOB_SyntaxError", e[e.ntfLDS_MRZ_DOB_Error = 139280] = "ntfLDS_MRZ_DOB_Error", e[e.ntfLDS_MRZ_DOB_IncorrectChecksum = 139281] = "ntfLDS_MRZ_DOB_IncorrectChecksum", e[e.ntfLDS_MRZ_Sex_Incorrect = 139282] = "ntfLDS_MRZ_Sex_Incorrect", e[e.ntfLDS_MRZ_DOE_SyntaxError = 139283] = "ntfLDS_MRZ_DOE_SyntaxError", e[e.ntfLDS_MRZ_DOE_Error = 139284] = "ntfLDS_MRZ_DOE_Error", e[e.ntfLDS_MRZ_DOE_IncorrectChecksum = 139285] = "ntfLDS_MRZ_DOE_IncorrectChecksum", e[e.ntfLDS_MRZ_OptionalData_IncorrectChecksum = 139286] = "ntfLDS_MRZ_OptionalData_IncorrectChecksum", e[e.ntfLDS_MRZ_IncorrectChecksum = 139287] = "ntfLDS_MRZ_IncorrectChecksum", e[e.ntfLDS_MRZ_Incorrect = 139288] = "ntfLDS_MRZ_Incorrect", e[e.ntfLDS_MRZ_CountryCode_VisualMrz_NonMatching = 139289] = "ntfLDS_MRZ_CountryCode_VisualMrz_NonMatching", e[e.ntfLDS_Biometrics_FormatOwner_Missing = 2415984640] = "ntfLDS_Biometrics_FormatOwner_Missing", e[e.ntfLDS_Biometrics_FormatOwner_Incorrect = 2416050176] = "ntfLDS_Biometrics_FormatOwner_Incorrect", e[e.ntfLDS_Biometrics_FormatType_Missing = 2416115712] = "ntfLDS_Biometrics_FormatType_Missing", e[e.ntfLDS_Biometrics_FormatType_Incorrect = 2416181248] = "ntfLDS_Biometrics_FormatType_Incorrect", e[e.ntfLDS_Biometrics_Type_Incorrect = 2416246784] = "ntfLDS_Biometrics_Type_Incorrect", e[e.ntfLDS_Biometrics_SubType_Missing = 2416312320] = "ntfLDS_Biometrics_SubType_Missing", e[e.ntfLDS_Biometrics_SubType_Incorrect = 2416377856] = "ntfLDS_Biometrics_SubType_Incorrect", e[e.ntfLDS_Biometrics_BDB_Image_Missing = 2416443392] = "ntfLDS_Biometrics_BDB_Image_Missing", e[e.ntfLDS_Biometrics_BDB_FormatID_Incorrect = 2416508928] = "ntfLDS_Biometrics_BDB_FormatID_Incorrect", e[e.ntfLDS_Biometrics_BDB_Version_Incorrect = 2416574464] = "ntfLDS_Biometrics_BDB_Version_Incorrect", e[e.ntfLDS_Biometrics_BDB_DataLength_Incorrect = 241664e4] = "ntfLDS_Biometrics_BDB_DataLength_Incorrect", e[e.ntfLDS_Biometrics_BDB_Data_Incorrect = 2416705536] = "ntfLDS_Biometrics_BDB_Data_Incorrect", e[e.ntfLDS_Biometrics_BDB_Data_Gender = 2416967680] = "ntfLDS_Biometrics_BDB_Data_Gender", e[e.ntfLDS_Biometrics_BDB_Data_EyeColor = 2417033216] = "ntfLDS_Biometrics_BDB_Data_EyeColor", e[e.ntfLDS_Biometrics_BDB_Data_HairColor = 2417098752] = "ntfLDS_Biometrics_BDB_Data_HairColor", e[e.ntfLDS_Biometrics_BDB_Data_PoseAngle_Yaw = 2417164288] = "ntfLDS_Biometrics_BDB_Data_PoseAngle_Yaw", e[e.ntfLDS_Biometrics_BDB_Data_PoseAngle_Pitch = 2417229824] = "ntfLDS_Biometrics_BDB_Data_PoseAngle_Pitch", e[e.ntfLDS_Biometrics_BDB_Data_PoseAngle_Roll = 2417295360] = "ntfLDS_Biometrics_BDB_Data_PoseAngle_Roll", e[e.ntfLDS_Biometrics_BDB_Data_PoseAngleU_Yaw = 2417360896] = "ntfLDS_Biometrics_BDB_Data_PoseAngleU_Yaw", e[e.ntfLDS_Biometrics_BDB_Data_PoseAngleU_Pitch = 2417426432] = "ntfLDS_Biometrics_BDB_Data_PoseAngleU_Pitch", e[e.ntfLDS_Biometrics_BDB_Data_PoseAngleU_Roll = 2417491968] = "ntfLDS_Biometrics_BDB_Data_PoseAngleU_Roll", e[e.ntfLDS_Biometrics_BDB_Data_FaceImageType = 2417557504] = "ntfLDS_Biometrics_BDB_Data_FaceImageType", e[e.ntfLDS_Biometrics_BDB_Data_ImageDataType = 2417623040] = "ntfLDS_Biometrics_BDB_Data_ImageDataType", e[e.ntfLDS_Biometrics_RB_Data_Incorrect = 2449539072] = "ntfLDS_Biometrics_RB_Data_Incorrect", e[e.ntfLDS_Biometrics_RB_Item_Incorrect = 2449604608] = "ntfLDS_Biometrics_RB_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Item_Missing = 2449670144] = "ntfLDS_Biometrics_RB_Item_Missing", e[e.ntfLDS_Biometrics_RB_Item_Unexpected = 2449735680] = "ntfLDS_Biometrics_RB_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_RID_Incorrect = 2449801232] = "ntfLDS_Biometrics_RB_RID_Incorrect", e[e.ntfLDS_Biometrics_RB_ImageR_Incorrect = 2449801248] = "ntfLDS_Biometrics_RB_ImageR_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Item_Incorrect = 2449801264] = "ntfLDS_Biometrics_RB_Image_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Item_Missing = 2449801265] = "ntfLDS_Biometrics_RB_Image_Item_Missing", e[e.ntfLDS_Biometrics_RB_Image_Item_Unexpected = 2449801266] = "ntfLDS_Biometrics_RB_Image_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Image_Info_Item_Incorrect = 2449801280] = "ntfLDS_Biometrics_RB_Image_Info_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_Item_Missing = 2449801281] = "ntfLDS_Biometrics_RB_Image_Info_Item_Missing", e[e.ntfLDS_Biometrics_RB_Image_Info_Item_Unexpected = 2449801282] = "ntfLDS_Biometrics_RB_Image_Info_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Image_Info_Format_Incorrect = 2449801283] = "ntfLDS_Biometrics_RB_Image_Info_Format_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_Format_Unsupported = 2449801284] = "ntfLDS_Biometrics_RB_Image_Info_Format_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_Kind_Incorrect = 2449801285] = "ntfLDS_Biometrics_RB_Image_Info_Kind_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_Kind_Unsupported = 2449801286] = "ntfLDS_Biometrics_RB_Image_Info_Kind_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_PostAPB_Incorrect = 2449801287] = "ntfLDS_Biometrics_RB_Image_Info_PostAPB_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_LossyTA_Incorrect = 2449801288] = "ntfLDS_Biometrics_RB_Image_Info_LossyTA_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_LossyTA_Unsupported = 2449801289] = "ntfLDS_Biometrics_RB_Image_Info_LossyTA_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_Cam2Subj_Unsupported = 2449801290] = "ntfLDS_Biometrics_RB_Image_Info_Cam2Subj_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_SensDiag_Unsupported = 2449801291] = "ntfLDS_Biometrics_RB_Image_Info_SensDiag_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_LensF_Unsupported = 2449801292] = "ntfLDS_Biometrics_RB_Image_Info_LensF_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_ImSize_Incorrect = 2449801293] = "ntfLDS_Biometrics_RB_Image_Info_ImSize_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_ImSize_Unsupported = 2449801294] = "ntfLDS_Biometrics_RB_Image_Info_ImSize_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_ImMeas_Incorrect = 2449801295] = "ntfLDS_Biometrics_RB_Image_Info_ImMeas_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_Color_Incorrect = 2449801296] = "ntfLDS_Biometrics_RB_Image_Info_Color_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Info_Color_Unsupported = 2449801297] = "ntfLDS_Biometrics_RB_Image_Info_Color_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Info_ColorMap_Incorrect = 2449801298] = "ntfLDS_Biometrics_RB_Image_Info_ColorMap_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Capt_Item_Incorrect = 2449801312] = "ntfLDS_Biometrics_RB_Image_Capt_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Capt_Item_Unexpected = 2449801313] = "ntfLDS_Biometrics_RB_Image_Capt_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Image_Capt_Spectral_Unsupported = 2449801314] = "ntfLDS_Biometrics_RB_Image_Capt_Spectral_Unsupported", e[e.ntfLDS_Biometrics_RB_Image_Capt_TechCode_Incorrect = 2449801315] = "ntfLDS_Biometrics_RB_Image_Capt_TechCode_Incorrect", e[e.ntfLDS_Biometrics_RB_Image_Capt_TechCode_Unsupported = 2449801316] = "ntfLDS_Biometrics_RB_Image_Capt_TechCode_Unsupported", e[e.ntfLDS_Biometrics_RB_Date_Item_Incorrect = 2449801328] = "ntfLDS_Biometrics_RB_Date_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Date_Item_Missing = 2449801329] = "ntfLDS_Biometrics_RB_Date_Item_Missing", e[e.ntfLDS_Biometrics_RB_Date_Item_Unexpected = 2449801330] = "ntfLDS_Biometrics_RB_Date_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Date_Incorrect = 2449801331] = "ntfLDS_Biometrics_RB_Date_Incorrect", e[e.ntfLDS_Biometrics_RB_Quality_Item_Incorrect = 2449801344] = "ntfLDS_Biometrics_RB_Quality_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Quality_Item_Missing = 2449801345] = "ntfLDS_Biometrics_RB_Quality_Item_Missing", e[e.ntfLDS_Biometrics_RB_Quality_Item_Unexpected = 2449801346] = "ntfLDS_Biometrics_RB_Quality_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Quality_AlgID_Item_Incorrect = 2449801347] = "ntfLDS_Biometrics_RB_Quality_AlgID_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Quality_SoE_Item_Incorrect = 2449801348] = "ntfLDS_Biometrics_RB_Quality_SoE_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Quality_Score_Item_Incorrect = 2449801349] = "ntfLDS_Biometrics_RB_Quality_Score_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Quality_Error_Item_Incorrect = 2449801350] = "ntfLDS_Biometrics_RB_Quality_Error_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Quality_Error_Item_Unsupported = 2449801351] = "ntfLDS_Biometrics_RB_Quality_Error_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_PAD_Item_Incorrect = 2449801360] = "ntfLDS_Biometrics_RB_PAD_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Item_Unexpected = 2449801361] = "ntfLDS_Biometrics_RB_PAD_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_PAD_Decision_Item_Incorrect = 2449801362] = "ntfLDS_Biometrics_RB_PAD_Decision_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Decision_Item_Unsupported = 2449801363] = "ntfLDS_Biometrics_RB_PAD_Decision_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_PAD_Score_Item_Incorrect = 2449801364] = "ntfLDS_Biometrics_RB_PAD_Score_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Score_RegID_Item_Incorrect = 2449801365] = "ntfLDS_Biometrics_RB_PAD_Score_RegID_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_SoE_Item_Incorrect = 2449801366] = "ntfLDS_Biometrics_RB_PAD_SoE_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_SoE_Score_Item_Incorrect = 2449801367] = "ntfLDS_Biometrics_RB_PAD_SoE_Score_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_SoE_Error_Item_Incorrect = 2449801368] = "ntfLDS_Biometrics_RB_PAD_SoE_Error_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_SoE_Error_Item_Unsupported = 2449801369] = "ntfLDS_Biometrics_RB_PAD_SoE_Error_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_PAD_ExtData_Item_Incorrect = 2449801370] = "ntfLDS_Biometrics_RB_PAD_ExtData_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_ExtData_Type_Item_Incorrect = 2449801371] = "ntfLDS_Biometrics_RB_PAD_ExtData_Type_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Context_Item_Incorrect = 2449801372] = "ntfLDS_Biometrics_RB_PAD_Context_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Context_Item_Unsupported = 2449801373] = "ntfLDS_Biometrics_RB_PAD_Context_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_PAD_SLevel_Item_Incorrect = 2449801374] = "ntfLDS_Biometrics_RB_PAD_SLevel_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_SLevel_Item_Unsupported = 2449801375] = "ntfLDS_Biometrics_RB_PAD_SLevel_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_PAD_RiskLevel_Item_Incorrect = 2449801376] = "ntfLDS_Biometrics_RB_PAD_RiskLevel_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Criteria_Item_Incorrect = 2449801377] = "ntfLDS_Biometrics_RB_PAD_Criteria_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Criteria_Item_Unsupported = 2449801378] = "ntfLDS_Biometrics_RB_PAD_Criteria_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_PAD_Date_Item_Incorrect = 2449801379] = "ntfLDS_Biometrics_RB_PAD_Date_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_PAD_Date_Item_Missing = 2449801380] = "ntfLDS_Biometrics_RB_PAD_Date_Item_Missing", e[e.ntfLDS_Biometrics_RB_PAD_Date_Item_Unexpected = 2449801381] = "ntfLDS_Biometrics_RB_PAD_Date_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_PAD_Date_Incorrect = 2449801382] = "ntfLDS_Biometrics_RB_PAD_Date_Incorrect", e[e.ntfLDS_Biometrics_RB_SessionID_Incorrect = 2449801392] = "ntfLDS_Biometrics_RB_SessionID_Incorrect", e[e.ntfLDS_Biometrics_RB_Derived_Incorrect = 2449801408] = "ntfLDS_Biometrics_RB_Derived_Incorrect", e[e.ntfLDS_Biometrics_RB_Device_Incorrect = 2449801424] = "ntfLDS_Biometrics_RB_Device_Incorrect", e[e.ntfLDS_Biometrics_RB_Device_Item_Unexpected = 2449801425] = "ntfLDS_Biometrics_RB_Device_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Device_ModelID_Item_Incorrect = 2449801426] = "ntfLDS_Biometrics_RB_Device_ModelID_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Device_CertID_Item_Incorrect = 2449801427] = "ntfLDS_Biometrics_RB_Device_CertID_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Item_Incorrect = 2449801440] = "ntfLDS_Biometrics_RB_Metadata_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Item_Unexpected = 2449801441] = "ntfLDS_Biometrics_RB_Metadata_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Metadata_Gender_Item_Incorrect = 2449801442] = "ntfLDS_Biometrics_RB_Metadata_Gender_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Gender_Item_Unsupported = 2449801443] = "ntfLDS_Biometrics_RB_Metadata_Gender_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_Metadata_Eye_Item_Incorrect = 2449801444] = "ntfLDS_Biometrics_RB_Metadata_Eye_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Eye_Item_Unsupported = 2449801445] = "ntfLDS_Biometrics_RB_Metadata_Eye_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_Metadata_Hair_Item_Incorrect = 2449801446] = "ntfLDS_Biometrics_RB_Metadata_Hair_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Hair_Item_Unsupported = 2449801447] = "ntfLDS_Biometrics_RB_Metadata_Hair_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_Metadata_Height_Item_Incorrect = 2449801448] = "ntfLDS_Biometrics_RB_Metadata_Height_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Props_Item_Incorrect = 2449801449] = "ntfLDS_Biometrics_RB_Metadata_Props_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Props_Item_Unexpected = 2449801450] = "ntfLDS_Biometrics_RB_Metadata_Props_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Metadata_Express_Item_Incorrect = 2449801451] = "ntfLDS_Biometrics_RB_Metadata_Express_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Express_Item_Unexpected = 2449801452] = "ntfLDS_Biometrics_RB_Metadata_Express_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_Metadata_Pose_Item_Incorrect = 2449801453] = "ntfLDS_Biometrics_RB_Metadata_Pose_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_Metadata_Pose_Item_Unexpected = 2449801454] = "ntfLDS_Biometrics_RB_Metadata_Pose_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_LandMark_Item_Incorrect = 2449801456] = "ntfLDS_Biometrics_RB_LandMark_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_LandMark_Item_Missing = 2449801457] = "ntfLDS_Biometrics_RB_LandMark_Item_Missing", e[e.ntfLDS_Biometrics_RB_LandMark_Item_Unexpected = 2449801458] = "ntfLDS_Biometrics_RB_LandMark_Item_Unexpected", e[e.ntfLDS_Biometrics_RB_LandMark_Kind_Item_Incorrect = 2449801459] = "ntfLDS_Biometrics_RB_LandMark_Kind_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_LandMark_Mpeg4_Item_Incorrect = 2449801460] = "ntfLDS_Biometrics_RB_LandMark_Mpeg4_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_LandMark_Mpeg4_Item_Unsupported = 2449801461] = "ntfLDS_Biometrics_RB_LandMark_Mpeg4_Item_Unsupported", e[e.ntfLDS_Biometrics_RB_LandMark_AntrL_Item_Incorrect = 2449801462] = "ntfLDS_Biometrics_RB_LandMark_AntrL_Item_Incorrect", e[e.ntfLDS_Biometrics_RB_LandMark_Coord_Item_Incorrect = 2449801463] = "ntfLDS_Biometrics_RB_LandMark_Coord_Item_Incorrect", e[e.ntfLDS_DTC_ContentInfo_Version_Incorrect = 2415919872] = "ntfLDS_DTC_ContentInfo_Version_Incorrect", e[e.ntfLDS_SI_PACE_Info_UnsupportedStdParameters = 2432696320] = "ntfLDS_SI_PACE_Info_UnsupportedStdParameters", e[e.ntfLDS_SI_PACE_Info_DeprecatedVersion = 2432696321] = "ntfLDS_SI_PACE_Info_DeprecatedVersion", e[e.ntfLDS_SI_PACE_DomainParams_UsingStdRef = 2432696322] = "ntfLDS_SI_PACE_DomainParams_UsingStdRef", e[e.ntfLDS_SI_PACE_DomainParams_UnsupportedAlgorithm = 2432696323] = "ntfLDS_SI_PACE_DomainParams_UnsupportedAlgorithm", e[e.ntfLDS_SI_CA_Info_IncorrectVersion = 2432696324] = "ntfLDS_SI_CA_Info_IncorrectVersion", e[e.ntfLDS_SI_CA_PublicKey_UnsupportedAlgorithm = 2432696325] = "ntfLDS_SI_CA_PublicKey_UnsupportedAlgorithm", e[e.ntfLDS_SI_CA_DomainParams_UnsupportedAlgorithm = 2432696326] = "ntfLDS_SI_CA_DomainParams_UnsupportedAlgorithm", e[e.ntfLDS_SI_TA_Info_IncorrectVersion = 2432696327] = "ntfLDS_SI_TA_Info_IncorrectVersion", e[e.ntfLDS_SI_TA_Info_FileIDForVersion2 = 2432696328] = "ntfLDS_SI_TA_Info_FileIDForVersion2", e[e.ntfLDS_SI_eIDSecurity_UnsupportedDigestAlgorithm = 2432696329] = "ntfLDS_SI_eIDSecurity_UnsupportedDigestAlgorithm", e[e.ntfLDS_SI_RI_Info_IncorrectVersion = 2432696330] = "ntfLDS_SI_RI_Info_IncorrectVersion", e[e.ntfLDS_SI_RI_DomainParams_UnsupportedAlgorithm = 2432696331] = "ntfLDS_SI_RI_DomainParams_UnsupportedAlgorithm", e[e.ntfLDS_SI_AA_Info_IncorrectVersion = 2432696332] = "ntfLDS_SI_AA_Info_IncorrectVersion", e[e.ntfLDS_SI_AA_Info_UnsupportedAlgorithm = 2432696333] = "ntfLDS_SI_AA_Info_UnsupportedAlgorithm", e[e.ntfLDS_SI_AA_Info_InconsistentAlgorithmReference = 2432696334] = "ntfLDS_SI_AA_Info_InconsistentAlgorithmReference", e[e.ntfLDS_SI_Storage_PACE_Info_NotAvailable = 2432696576] = "ntfLDS_SI_Storage_PACE_Info_NotAvailable", e[e.ntfLDS_SI_Storage_PACE_Info_NoStdParameters = 2432696577] = "ntfLDS_SI_Storage_PACE_Info_NoStdParameters", e[e.ntfLDS_SI_Storage_PACE_Info_NoMatchingDomainParams = 2432696578] = "ntfLDS_SI_Storage_PACE_Info_NoMatchingDomainParams", e[e.ntfLDS_SI_Storage_CA_Info_NotAvailable = 2432696579] = "ntfLDS_SI_Storage_CA_Info_NotAvailable", e[e.ntfLDS_SI_Storage_CA_DomainParams_NoRequiredOption = 2432696580] = "ntfLDS_SI_Storage_CA_DomainParams_NoRequiredOption", e[e.ntfLDS_SI_Storage_CA_DomainParams_NotAvailable = 2432696581] = "ntfLDS_SI_Storage_CA_DomainParams_NotAvailable", e[e.ntfLDS_SI_Storage_CA_AnonymousInfos = 2432696582] = "ntfLDS_SI_Storage_CA_AnonymousInfos", e[e.ntfLDS_SI_Storage_CA_Info_NoMatchingDomainParams = 2432696583] = "ntfLDS_SI_Storage_CA_Info_NoMatchingDomainParams", e[e.ntfLDS_SI_Storage_CA_Info_NoMatchingPublicKey = 2432696584] = "ntfLDS_SI_Storage_CA_Info_NoMatchingPublicKey", e[e.ntfLDS_SI_Storage_CA_IncorrectInfosQuantity = 2432696585] = "ntfLDS_SI_Storage_CA_IncorrectInfosQuantity", e[e.ntfLDS_SI_Storage_TA_Info_NotAvailable = 2432696586] = "ntfLDS_SI_Storage_TA_Info_NotAvailable", e[e.ntfLDS_SI_Storage_CardInfoLocator_MultipleEntries = 2432696587] = "ntfLDS_SI_Storage_CardInfoLocator_MultipleEntries", e[e.ntfLDS_SI_Storage_eIDSecurityInfo_MultipleEntries = 2432696588] = "ntfLDS_SI_Storage_eIDSecurityInfo_MultipleEntries", e[e.ntfLDS_SI_Storage_PrivilegedTI_MultipleEntries = 2432696589] = "ntfLDS_SI_Storage_PrivilegedTI_MultipleEntries", e[e.ntfLDS_SI_Storage_PrivilegedTI_IncorrectUsage = 2432696590] = "ntfLDS_SI_Storage_PrivilegedTI_IncorrectUsage", e[e.ntfLDS_SI_Storage_RI_DomainParams_MultipleEntries = 2432696591] = "ntfLDS_SI_Storage_RI_DomainParams_MultipleEntries", e[e.ntfLDS_SI_Storage_PACEInfos_NonConsistant = 2432696592] = "ntfLDS_SI_Storage_PACEInfos_NonConsistant", e[e.ntfLDS_CVCertificate_Profile_IncorrectVersion = 2432696833] = "ntfLDS_CVCertificate_Profile_IncorrectVersion", e[e.ntfLDS_CVCertificate_Validity = 2432696834] = "ntfLDS_CVCertificate_Validity", e[e.ntfLDS_CVCertificate_NonCVCADomainParameters = 2432696835] = "ntfLDS_CVCertificate_NonCVCADomainParameters", e[e.ntfLDS_CV_Certificate_PrivateKey_IncorrectVersion = 2432696836] = "ntfLDS_CV_Certificate_PrivateKey_IncorrectVersion", e[e.ntfLDS_TA_PACEStaticBindingUsed = 2432697088] = "ntfLDS_TA_PACEStaticBindingUsed", e[e.ntfLDS_Auth_MLSignerInfo_Certificate_Validity = 2449473813] = "ntfLDS_Auth_MLSignerInfo_Certificate_Validity", e[e.ntfLDS_Auth_MLSignerInfo_Certificate_RootIsNotTrusted = 2449473814] = "ntfLDS_Auth_MLSignerInfo_Certificate_RootIsNotTrusted", e[e.ntfLDS_Auth_MLSignerInfo_Certificate_CantFindCSCA = 2449473815] = "ntfLDS_Auth_MLSignerInfo_Certificate_CantFindCSCA", e[e.ntfLDS_Auth_MLSignerInfo_Certificate_Revoked = 2449473816] = "ntfLDS_Auth_MLSignerInfo_Certificate_Revoked", e[e.ntfLDS_Auth_MLSignerInfo_Certificate_SignatureInvalid = 2449473817] = "ntfLDS_Auth_MLSignerInfo_Certificate_SignatureInvalid", e))(kM || {}), Wl = /* @__PURE__ */ ((e) => (e[e.NOT_FINISHED = 0] = "NOT_FINISHED", e[e.FINISHED = 1] = "FINISHED", e[e.TIMEOUT = 2] = "TIMEOUT", e))(Wl || {}), FM = /* @__PURE__ */ ((e) => (e[e.RFID_Error_NoError = 1] = "RFID_Error_NoError", e[e.RFID_Error_AlreadyDone = 2] = "RFID_Error_AlreadyDone", e[e.RFID_Error_Failed = 4294967295] = "RFID_Error_Failed", e[e.RFID_Error_NoChipDetected = 2147549185] = "RFID_Error_NoChipDetected", e[e.RFID_Error_NotAvailable = 2147549186] = "RFID_Error_NotAvailable", e[e.RFID_Error_InvalidParameter = 2147549188] = "RFID_Error_InvalidParameter", e[e.RFID_Error_NotInitialized = 2147549189] = "RFID_Error_NotInitialized", e[e.RFID_Error_NotEnoughMemory = 2147549190] = "RFID_Error_NotEnoughMemory", e[e.RFID_Error_NotEnoughData = 2147549191] = "RFID_Error_NotEnoughData", e[e.RFID_Error_InvalidDirectory = 2147549192] = "RFID_Error_InvalidDirectory", e[e.RFID_Error_UnknownCommand = 2147549193] = "RFID_Error_UnknownCommand", e[e.RFID_Error_FileIOError = 2147549194] = "RFID_Error_FileIOError", e[e.RFID_Error_Busy = 2147549195] = "RFID_Error_Busy", e[e.RFID_Error_OldFirmware = 2147549196] = "RFID_Error_OldFirmware", e[e.RFID_Error_PCSC_Failed = 2147614720] = "RFID_Error_PCSC_Failed", e[e.RFID_Error_PCSC_ReaderNotAvailable = 2147614721] = "RFID_Error_PCSC_ReaderNotAvailable", e[e.RFID_Error_PCSC_CantConnectCard = 2147614722] = "RFID_Error_PCSC_CantConnectCard", e[e.RFID_Error_PCSC_CardIsNotConnected = 2147614723] = "RFID_Error_PCSC_CardIsNotConnected", e[e.RFID_Error_PCSC_OperationCancelled = 2147614724] = "RFID_Error_PCSC_OperationCancelled", e[e.RFID_Error_PCSC_CardIsBusy = 2147614725] = "RFID_Error_PCSC_CardIsBusy", e[e.RFID_Error_PCSC_FailedSCard = 2147614726] = "RFID_Error_PCSC_FailedSCard", e[e.RFID_Error_PCSC_ExtLe_Failed = 2147614736] = "RFID_Error_PCSC_ExtLe_Failed", e[e.RFID_LAYER6_SECURITY_MANAGER = 2248146944] = "RFID_LAYER6_SECURITY_MANAGER", e[e.RFID_LAYER6_APP_SELECTION_FAILURE = 2248146945] = "RFID_LAYER6_APP_SELECTION_FAILURE", e[e.RFID_LAYER6_MUTUAL_AUTH_MAC_FAIL = 2248147200] = "RFID_LAYER6_MUTUAL_AUTH_MAC_FAIL", e[e.RFID_LAYER6_MUTUAL_AUTH_ENC_FAIL = 2248147201] = "RFID_LAYER6_MUTUAL_AUTH_ENC_FAIL", e[e.RFID_LAYER6_MUTUAL_AUTH_FAILURE = 2248147202] = "RFID_LAYER6_MUTUAL_AUTH_FAILURE", e[e.RFID_LAYER6_MUTUAL_AUTH_FAILURE_DATA = 2248147203] = "RFID_LAYER6_MUTUAL_AUTH_FAILURE_DATA", e[e.RFID_LAYER6_SM_DO8E_MISSING = 2248147456] = "RFID_LAYER6_SM_DO8E_MISSING", e[e.RFID_LAYER6_SM_DO87_MISSING = 2248147457] = "RFID_LAYER6_SM_DO87_MISSING", e[e.RFID_LAYER6_SM_DO99_MISSING = 2248147458] = "RFID_LAYER6_SM_DO99_MISSING", e[e.RFID_LAYER6_SM_MAC_INCORRECT = 2248147459] = "RFID_LAYER6_SM_MAC_INCORRECT", e[e.RFID_LAYER6_SM_DO87_INCORRECT = 2248147460] = "RFID_LAYER6_SM_DO87_INCORRECT", e[e.RFID_LAYER6_NON_TLV_RESPONSE_DATA = 2248147712] = "RFID_LAYER6_NON_TLV_RESPONSE_DATA", e[e.RFID_LAYER6_WRONG_RND_ICC_LENGTH = 2248147713] = "RFID_LAYER6_WRONG_RND_ICC_LENGTH", e[e.RFID_LAYER6_INT_AUTH_FAILURE = 2248147714] = "RFID_LAYER6_INT_AUTH_FAILURE", e[e.RFID_LAYER6_MSE_SET_KAT_FAILURE = 2248147715] = "RFID_LAYER6_MSE_SET_KAT_FAILURE", e[e.RFID_LAYER6_MSE_SET_DST_FAILURE = 2248147716] = "RFID_LAYER6_MSE_SET_DST_FAILURE", e[e.RFID_LAYER6_PSO_CERTIFICATE_FAILURE = 2248147717] = "RFID_LAYER6_PSO_CERTIFICATE_FAILURE", e[e.RFID_LAYER6_MSE_SET_AT_FAILURE = 2248147718] = "RFID_LAYER6_MSE_SET_AT_FAILURE", e[e.RFID_LAYER6_GET_CHALLENGE_FAILURE = 2248147719] = "RFID_LAYER6_GET_CHALLENGE_FAILURE", e[e.RFID_LAYER6_EXT_AUTH_FAILURE = 2248147720] = "RFID_LAYER6_EXT_AUTH_FAILURE", e[e.RFID_LAYER6_GENERAL_AUTH_FAILURE = 2248147721] = "RFID_LAYER6_GENERAL_AUTH_FAILURE", e[e.RFID_LAYER6_FILE_NOT_FOUND = 2147510914] = "RFID_LAYER6_FILE_NOT_FOUND", e[e.RFID_LAYER6_FILE_EOF1 = 2147508866] = "RFID_LAYER6_FILE_EOF1", e[e.RFID_LAYER6_FILE_EOF2 = 2147511040] = "RFID_LAYER6_FILE_EOF2", e[e.RFID_LAYER6_WRONG_LENGTH = 2147510016] = "RFID_LAYER6_WRONG_LENGTH", e[e.RFID_LAYER6_INCORRECT_PARAMS = 2147510912] = "RFID_LAYER6_INCORRECT_PARAMS", e[e.RFID_LAYER6_NO_REFERENCE_DATA = 2147510920] = "RFID_LAYER6_NO_REFERENCE_DATA", e[e.RFID_LAYER6_PWD_SUSPENDED = 2147509185] = "RFID_LAYER6_PWD_SUSPENDED", e[e.RFID_LAYER6_PWD_BLOCKED = 2147509184] = "RFID_LAYER6_PWD_BLOCKED", e[e.RFID_LAYER6_PWD_DEACTIVATED = 2147508867] = "RFID_LAYER6_PWD_DEACTIVATED", e[e.RFID_LAYER6_PWD_BLOCKED_2 = 2147510659] = "RFID_LAYER6_PWD_BLOCKED_2", e[e.RFID_LAYER6_PWD_DEACTIVATED_2 = 2147510660] = "RFID_LAYER6_PWD_DEACTIVATED_2", e[e.RFID_LAYER6_PWD_SUSPENDED_2 = 2147510661] = "RFID_LAYER6_PWD_SUSPENDED_2", e[e.RFID_LAYER6_PWD_FAILED = 2148557760] = "RFID_LAYER6_PWD_FAILED", e[e.RFID_Error_NotPerformed = 2197815296] = "RFID_Error_NotPerformed", e[e.RFID_Error_Session_IsClosed = 2197815297] = "RFID_Error_Session_IsClosed", e[e.RFID_Error_Session_Terminal_UnsupportedOperation = 2197815298] = "RFID_Error_Session_Terminal_UnsupportedOperation", e[e.RFID_Error_Session_TerminalType_Unknown = 2197815312] = "RFID_Error_Session_TerminalType_Unknown", e[e.RFID_Error_Session_TerminalType_BadCertificate = 2197815313] = "RFID_Error_Session_TerminalType_BadCertificate", e[e.RFID_Error_Session_TerminalType_NotSet = 2197815314] = "RFID_Error_Session_TerminalType_NotSet", e[e.RFID_Error_Session_ProcedureType_Unknown = 2197815315] = "RFID_Error_Session_ProcedureType_Unknown", e[e.RFID_Error_Session_ProcedureType_Unsupported = 2197815316] = "RFID_Error_Session_ProcedureType_Unsupported", e[e.RFID_Error_Session_ProcedureType_NotSet = 2197815317] = "RFID_Error_Session_ProcedureType_NotSet", e[e.RFID_Error_Session_AccessKey_UnknownType = 2197815318] = "RFID_Error_Session_AccessKey_UnknownType", e[e.RFID_Error_Session_AccessKey_UnsupportedSMType = 2197815319] = "RFID_Error_Session_AccessKey_UnsupportedSMType", e[e.RFID_Error_Session_AccessKey_IncorrectSMType = 2197815320] = "RFID_Error_Session_AccessKey_IncorrectSMType", e[e.RFID_Error_Session_AccessKey_Restricted = 2197815321] = "RFID_Error_Session_AccessKey_Restricted", e[e.RFID_Error_Session_AccessKey_IncorrectData = 2197815322] = "RFID_Error_Session_AccessKey_IncorrectData", e[e.RFID_Error_Session_AccessKey_NotSet = 2197815323] = "RFID_Error_Session_AccessKey_NotSet", e[e.RFID_Error_Session_PwdManagement_NotAuthorized = 2197815324] = "RFID_Error_Session_PwdManagement_NotAuthorized", e[e.RFID_Error_Session_AccessControl_UnknownType = 2197815328] = "RFID_Error_Session_AccessControl_UnknownType", e[e.RFID_Error_Session_AccessControl_RequiresSM = 2197815329] = "RFID_Error_Session_AccessControl_RequiresSM", e[e.RFID_Error_Session_AccessControl_RequiresPACE = 2197815330] = "RFID_Error_Session_AccessControl_RequiresPACE", e[e.RFID_Error_Session_AccessControl_RequiresCAKeys = 2197815331] = "RFID_Error_Session_AccessControl_RequiresCAKeys", e[e.RFID_Error_Session_AccessControl_RequiresTA = 2197815332] = "RFID_Error_Session_AccessControl_RequiresTA", e[e.RFID_Error_Session_AccessControl_RequiresCA = 2197815333] = "RFID_Error_Session_AccessControl_RequiresCA", e[e.RFID_Error_Session_AccessControl_IncorrectOptionCA = 2197815334] = "RFID_Error_Session_AccessControl_IncorrectOptionCA", e[e.RFID_Error_Session_AccessControl_CA_Failed = 2197815335] = "RFID_Error_Session_AccessControl_CA_Failed", e[e.RFID_Error_Session_AccessControl_TA_Failed = 2197815336] = "RFID_Error_Session_AccessControl_TA_Failed", e[e.RFID_Error_Session_AccessControl_AA_Failed = 2197815337] = "RFID_Error_Session_AccessControl_AA_Failed", e[e.RFID_Error_Session_AccessControl_RI_Failed = 2197815338] = "RFID_Error_Session_AccessControl_RI_Failed", e[e.RFID_Error_Session_PA_SignatureCheckFailed = 2197815344] = "RFID_Error_Session_PA_SignatureCheckFailed", e[e.RFID_Error_Session_PA_HashCheckFailed = 2197815345] = "RFID_Error_Session_PA_HashCheckFailed", e[e.RFID_Error_Session_InvalidAuxData_DateOfExpiry = 2197815360] = "RFID_Error_Session_InvalidAuxData_DateOfExpiry", e[e.RFID_Error_Session_InvalidAuxData_DateOfBirth = 2197815361] = "RFID_Error_Session_InvalidAuxData_DateOfBirth", e[e.RFID_Error_Session_InvalidAuxData_CommunityID = 2197815362] = "RFID_Error_Session_InvalidAuxData_CommunityID", e[e.RFID_Error_Session_eSign_RequiresAppSelection = 2197815376] = "RFID_Error_Session_eSign_RequiresAppSelection", e[e.RFID_Error_Session_eSign_PIN_NotSet = 2197815377] = "RFID_Error_Session_eSign_PIN_NotSet", e[e.RFID_Error_Session_eSign_PIN_NotVerified = 2197815378] = "RFID_Error_Session_eSign_PIN_NotVerified", e[e.RFID_Error_Session_IncorrectData = 2197815392] = "RFID_Error_Session_IncorrectData", e[e.RFID_Error_Session_File_NotEnoughData = 2197880832] = "RFID_Error_Session_File_NotEnoughData", e[e.RFID_Error_Session_File_IncorrectData = 2197946368] = "RFID_Error_Session_File_IncorrectData", e[e.RFID_Error_Session_File_UnexpectedData = 2198011904] = "RFID_Error_Session_File_UnexpectedData", e[e.RFID_Error_Session_File_Contents_UnexpectedData = 2198077440] = "RFID_Error_Session_File_Contents_UnexpectedData", e[e.RFID_Error_Session_File_WrongTag = 2198142976] = "RFID_Error_Session_File_WrongTag", e[e.RFID_Error_Session_File_CantUseData = 2198208512] = "RFID_Error_Session_File_CantUseData", e[e.RFID_Error_Session_File_CantReadData = 2198274048] = "RFID_Error_Session_File_CantReadData", e[e.RFID_Error_Session_File_AccessDenied = 2198339584] = "RFID_Error_Session_File_AccessDenied", e[e.RFID_Error_Layer34_NoError = 2214592512] = "RFID_Error_Layer34_NoError", e[e.RFID_Error_Layer34_TimeOut = 2214658048] = "RFID_Error_Layer34_TimeOut", e[e.RFID_Error_Layer34_Collision = 2214723584] = "RFID_Error_Layer34_Collision", e[e.RFID_Error_Layer34_CRC = 2214789120] = "RFID_Error_Layer34_CRC", e[e.RFID_Error_Layer34_DataIntegrity = 2214854656] = "RFID_Error_Layer34_DataIntegrity", e[e.RFID_Error_Layer34_DataLength = 2214920192] = "RFID_Error_Layer34_DataLength", e[e.RFID_Error_Layer34_RFU = 2214985728] = "RFID_Error_Layer34_RFU", e[e.RFID_Error_Layer34_Collision_TooMany = 2215051264] = "RFID_Error_Layer34_Collision_TooMany", e[e.RFID_Error_Layer34_ProtocolB = 2215116800] = "RFID_Error_Layer34_ProtocolB", e[e.RFID_Error_Layer34_DataContents = 2215182336] = "RFID_Error_Layer34_DataContents", e[e.RFID_Error_Layer34_Protocol = 2215247872] = "RFID_Error_Layer34_Protocol", e[e.RFID_Error_Layer34_GlobalTimeOut = 2215313408] = "RFID_Error_Layer34_GlobalTimeOut", e[e.RFID_Error_Layer34_MIFARE_Auth = 2215378944] = "RFID_Error_Layer34_MIFARE_Auth", e[e.RFID_Error_Layer34_SAM_Error = 2215444480] = "RFID_Error_Layer34_SAM_Error", e[e.RFID_Error_Layer34_SAM_Collision = 2215510016] = "RFID_Error_Layer34_SAM_Collision", e[e.RFID_Error_Layer34_SAM_Acknowledge = 2215575552] = "RFID_Error_Layer34_SAM_Acknowledge", e))(FM || {}), xM = /* @__PURE__ */ ((e) => (e[e.CERTIFICATE_PA = 0] = "CERTIFICATE_PA", e[e.CERTIFICATE_TA = 1] = "CERTIFICATE_TA", e[e.LDIF = 2] = "LDIF", e[e.CRL = 3] = "CRL", e[e.ML = 4] = "ML", e[e.DEFL = 5] = "DEFL", e[e.DEVL = 6] = "DEVL", e[e.BL = 7] = "BL", e[e.LDIF_TA = 8] = "LDIF_TA", e[e.ML_TA = 9] = "ML_TA", e))(xM || {}), Tn = /* @__PURE__ */ ((e) => (e[e.DOCUMENT_IMAGE = 1] = "DOCUMENT_IMAGE", e[e.MRZ_TEXT = 3] = "MRZ_TEXT", e[e.BARCODES = 5] = "BARCODES", e[e.VISUAL_GRAPHICS = 6] = "VISUAL_GRAPHICS", e[e.MRZ_TEST_QUALITY = 7] = "MRZ_TEST_QUALITY", e[e.DOCUMENT_TYPE_CANDIDATES = 8] = "DOCUMENT_TYPE_CANDIDATES", e[e.DOCUMENT_TYPE = 9] = "DOCUMENT_TYPE", e[e.LEXICAL_ANALYSIS = 15] = "LEXICAL_ANALYSIS", e[e.RAW_UNCROPPED_IMAGE = 16] = "RAW_UNCROPPED_IMAGE", e[e.VISUAL_TEXT = 17] = "VISUAL_TEXT", e[e.BARCODE_TEXT = 18] = "BARCODE_TEXT", e[e.BARCODE_GRAPHICS = 19] = "BARCODE_GRAPHICS", e[e.AUTHENTICITY = 20] = "AUTHENTICITY", e[e.MAGNETIC_STRIPE_TEXT_DATA = 26] = "MAGNETIC_STRIPE_TEXT_DATA", e[e.IMAGE_QUALITY = 30] = "IMAGE_QUALITY", e[e.LIVE_PORTRAIT = 32] = "LIVE_PORTRAIT", e[e.STATUS = 33] = "STATUS", e[e.PORTRAIT_COMPARISON = 34] = "PORTRAIT_COMPARISON", e[e.EXT_PORTRAIT = 35] = "EXT_PORTRAIT", e[e.TEXT = 36] = "TEXT", e[e.IMAGES = 37] = "IMAGES", e[e.FINGERPRINTS = 38] = "FINGERPRINTS", e[e.FINGERPRINT_COMPARISON = 39] = "FINGERPRINT_COMPARISON", e[e.ENCRYPTED_RCL = 49] = "ENCRYPTED_RCL", e[e.LICENSE = 50] = "LICENSE", e[e.MRZ_POSITION = 61] = "MRZ_POSITION", e[e.BARCODE_POSITION = 62] = "BARCODE_POSITION", e[e.DOCUMENT_POSITION = 85] = "DOCUMENT_POSITION", e[e.MRZ_DETECTOR = 87] = "MRZ_DETECTOR", e[e.FACE_DETECTION = 97] = "FACE_DETECTION", e[e.RFID_RAW_DATA = 101] = "RFID_RAW_DATA", e[e.RFID_TEXT = 102] = "RFID_TEXT", e[e.RFID_GRAPHICS = 103] = "RFID_GRAPHICS", e[e.RFID_BINARY_DATA = 104] = "RFID_BINARY_DATA", e[e.RFID_ORIGINAL_GRAPHICS = 105] = "RFID_ORIGINAL_GRAPHICS", e[e.DTC_VC = 109] = "DTC_VC", e))(Tn || {}), UM = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.MIFARE_1K = 1] = "MIFARE_1K", e[e.MIFARE_4K = 2] = "MIFARE_4K", e[e.MIFARE_ULTRALIGHT = 3] = "MIFARE_ULTRALIGHT", e[e.MIFARE_DES_FIRE = 4] = "MIFARE_DES_FIRE", e[e.MIFARE_PROX = 5] = "MIFARE_PROX", e))(UM || {}), BM = /* @__PURE__ */ ((e) => (e[e.UNDEFINED = 0] = "UNDEFINED", e[e.BAC = 1] = "BAC", e[e.PACE = 2] = "PACE", e[e.CA = 3] = "CA", e[e.TA = 4] = "TA", e[e.AA = 5] = "AA", e[e.RI = 6] = "RI", e[e.CARD_INFO = 10] = "CARD_INFO", e[e.DTC_INFO = 11] = "DTC_INFO", e))(BM || {}), $M = /* @__PURE__ */ ((e) => (e[e.ROOT_FILES = 0] = "ROOT_FILES", e[e.E_PASSPORT = 1] = "E_PASSPORT", e[e.E_ID = 2] = "E_ID", e[e.E_SIGN = 3] = "E_SIGN", e[e.E_DL = 4] = "E_DL", e[e.LDS2_TravelRecords = 5] = "LDS2_TravelRecords", e[e.LDS2_VisaRecords = 6] = "LDS2_VisaRecords", e[e.LDS2_AddBiometrics = 7] = "LDS2_AddBiometrics", e[e.eDTC_PC = 8] = "eDTC_PC", e))($M || {}), GM = /* @__PURE__ */ ((e) => (e[e.UNDEFINED = 0] = "UNDEFINED", e[e.STANDARD = 1] = "STANDARD", e[e.ADVANCED = 2] = "ADVANCED", e[e.GENERAL = 3] = "GENERAL", e))(GM || {}), ZM = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.RFBR_106 = 1] = "RFBR_106", e[e.RFBR_212 = 2] = "RFBR_212", e[e.RFBR_424 = 4] = "RFBR_424", e[e.RFBR_848 = 8] = "RFBR_848", e[e.RFBR_1695 = 16] = "RFBR_1695", e[e.RFBR_3390 = 32] = "RFBR_3390", e[e.RFBR_6780 = 64] = "RFBR_6780", e))(ZM || {}), jM = /* @__PURE__ */ ((e) => (e[e.UNDEFINED = 0] = "UNDEFINED", e[e.PKD = 1] = "PKD", e[e.SECURITY_OBJECT = 2] = "SECURITY_OBJECT", e[e.USER_DEFINED = 3] = "USER_DEFINED", e[e.MASTER_LIST_PKD = 4] = "MASTER_LIST_PKD", e[e.MASTER_LIST_SO = 5] = "MASTER_LIST_SO", e[e.DEFECT_LIST_SO = 6] = "DEFECT_LIST_SO", e[e.DEVIATION_LIST_SO = 7] = "DEVIATION_LIST_SO", e[e.BLACK_LIST_SO = 8] = "BLACK_LIST_SO", e))(jM || {}), zM = /* @__PURE__ */ ((e) => (e[e.UNDEFINED = 0] = "UNDEFINED", e[e.CSCA = 1] = "CSCA", e[e.CSCA_LINK = 2] = "CSCA_LINK", e[e.DS = 3] = "DS", e[e.MLS = 4] = "MLS", e[e.DEV_LS = 5] = "DEV_LS", e[e.DEF_LS = 6] = "DEF_LS", e[e.BLS = 7] = "BLS", e[e.LDS2 = 8] = "LDS2", e[e.BCS = 9] = "BCS", e[e.BCS_NC = 10] = "BCS_NC", e[e.DTCS = 11] = "DTCS", e))(zM || {}), qM = /* @__PURE__ */ ((e) => (e[e.UNSPECIFIED = 0] = "UNSPECIFIED", e[e.PASSPORT_DG1 = 1] = "PASSPORT_DG1", e[e.PASSPORT_DG2 = 2] = "PASSPORT_DG2", e[e.PASSPORT_DG3 = 3] = "PASSPORT_DG3", e[e.PASSPORT_DG4 = 4] = "PASSPORT_DG4", e[e.PASSPORT_DG5 = 5] = "PASSPORT_DG5", e[e.PASSPORT_DG6 = 6] = "PASSPORT_DG6", e[e.PASSPORT_DG7 = 7] = "PASSPORT_DG7", e[e.PASSPORT_DG8 = 8] = "PASSPORT_DG8", e[e.PASSPORT_DG9 = 9] = "PASSPORT_DG9", e[e.PASSPORT_DG10 = 10] = "PASSPORT_DG10", e[e.PASSPORT_DG11 = 11] = "PASSPORT_DG11", e[e.PASSPORT_DG12 = 12] = "PASSPORT_DG12", e[e.PASSPORT_DG13 = 13] = "PASSPORT_DG13", e[e.PASSPORT_DG14 = 14] = "PASSPORT_DG14", e[e.PASSPORT_DG15 = 15] = "PASSPORT_DG15", e[e.PASSPORT_DG16 = 16] = "PASSPORT_DG16", e[e.PASSPORT_DG17 = 17] = "PASSPORT_DG17", e[e.PASSPORT_DG18 = 18] = "PASSPORT_DG18", e[e.PASSPORT_DG19 = 19] = "PASSPORT_DG19", e[e.PASSPORT_DG20 = 20] = "PASSPORT_DG20", e[e.PASSPORT_SOD = 21] = "PASSPORT_SOD", e[e.PASSPORT_CVCA = 22] = "PASSPORT_CVCA", e[e.PASSPORT_COM = 23] = "PASSPORT_COM", e[e.DTC_DG17 = 57] = "DTC_DG17", e[e.DTC_DG18 = 58] = "DTC_DG18", e[e.DTC_DG22 = 62] = "DTC_DG22", e[e.DTC_DG23 = 63] = "DTC_DG23", e[e.DTC_DG24 = 64] = "DTC_DG24", e[e.ID_DG1 = 101] = "ID_DG1", e[e.ID_DG2 = 102] = "ID_DG2", e[e.ID_DG3 = 103] = "ID_DG3", e[e.ID_DG4 = 104] = "ID_DG4", e[e.ID_DG5 = 105] = "ID_DG5", e[e.ID_DG6 = 106] = "ID_DG6", e[e.ID_DG7 = 107] = "ID_DG7", e[e.ID_DG8 = 108] = "ID_DG8", e[e.ID_DG9 = 109] = "ID_DG9", e[e.ID_DG10 = 110] = "ID_DG10", e[e.ID_DG11 = 111] = "ID_DG11", e[e.ID_DG12 = 112] = "ID_DG12", e[e.ID_DG13 = 113] = "ID_DG13", e[e.ID_DG14 = 114] = "ID_DG14", e[e.ID_DG15 = 115] = "ID_DG15", e[e.ID_DG16 = 116] = "ID_DG16", e[e.ID_DG17 = 117] = "ID_DG17", e[e.ID_DG18 = 118] = "ID_DG18", e[e.ID_DG19 = 119] = "ID_DG19", e[e.ID_DG20 = 120] = "ID_DG20", e[e.ID_DG21 = 121] = "ID_DG21", e[e.DL_COM = 150] = "DL_COM", e[e.DL_DG1 = 151] = "DL_DG1", e[e.DL_DG2 = 152] = "DL_DG2", e[e.DL_DG3 = 153] = "DL_DG3", e[e.DL_DG4 = 154] = "DL_DG4", e[e.DL_DG5 = 155] = "DL_DG5", e[e.DL_DG6 = 156] = "DL_DG6", e[e.DL_DG7 = 157] = "DL_DG7", e[e.DL_DG8 = 158] = "DL_DG8", e[e.DL_DG9 = 159] = "DL_DG9", e[e.DL_DG10 = 160] = "DL_DG10", e[e.DL_DG11 = 161] = "DL_DG11", e[e.DL_DG12 = 162] = "DL_DG12", e[e.DL_DG13 = 163] = "DL_DG13", e[e.DL_DG14 = 164] = "DL_DG14", e[e.DL_SOD = 165] = "DL_SOD", e[e.DL_CE = 166] = "DL_CE", e[e.DL_CVCA = 167] = "DL_CVCA", e[e.PACE_CARD_ACCESS = 200] = "PACE_CARD_ACCESS", e[e.PACE_CARD_SECURITY = 201] = "PACE_CARD_SECURITY", e[e.PACE_CHIP_SECURITY = 202] = "PACE_CHIP_SECURITY", e[e.MIFARE_DATA = 300] = "MIFARE_DATA", e[e.MIFARE_VALIDITY = 301] = "MIFARE_VALIDITY", e[e.AUTHENTICITY_V2 = 302] = "AUTHENTICITY_V2", e[e.ATR = 400] = "ATR", e[e.DIR = 401] = "DIR", e[e.E_SIGN_PK = 500] = "E_SIGN_PK", e[e.E_SIGN_SIGNED_DATA = 501] = "E_SIGN_SIGNED_DATA", e[e.CERTIFICATE = 600] = "CERTIFICATE", e[e.MASTER_LIST = 601] = "MASTER_LIST", e[e.DEFECT_LIST = 602] = "DEFECT_LIST", e[e.DEVIATION_LIST = 603] = "DEVIATION_LIST", e[e.BLACK_LIST = 604] = "BLACK_LIST", e[e.APP_DIRECTORY = 700] = "APP_DIRECTORY", e[e.SESSION = 701] = "SESSION", e[e.LOG_DATA = 702] = "LOG_DATA", e[e.CHIP_PROPERTIES = 703] = "CHIP_PROPERTIES", e[e.DTC_INFO = 704] = "DTC_INFO", e[e.POST_CA_RESPONSE = 710] = "POST_CA_RESPONSE", e[e.POST_CA_PUBLIC_KEY = 711] = "POST_CA_PUBLIC_KEY", e[e.POST_CA_INFO = 712] = "POST_CA_INFO", e[e.POST_CA_D_PARAMS = 713] = "POST_CA_D_PARAMS", e[e.POST_CA_CHECK_PK = 714] = "POST_CA_CHECK_PK", e[e.POST_CA_CHECK_SK = 715] = "POST_CA_CHECK_SK", e[e.SAM_DATA = 800] = "SAM_DATA", e[e.SAM_DATA_MAX = 832] = "SAM_DATA_MAX", e[e.VDS = 900] = "VDS", e[e.VDS_NC = 901] = "VDS_NC", e[e.DS = 902] = "DS", e[e.USER_DEFINED = 1e3] = "USER_DEFINED", e))(qM || {}), WM = /* @__PURE__ */ ((e) => (e[e.NONE = 0] = "NONE", e[e.MAIN_PAGE = 1] = "MAIN_PAGE", e[e.BACK_PAGE = 2] = "BACK_PAGE", e))(WM || {}), YM = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.MRZ = 1] = "MRZ", e[e.CAN = 2] = "CAN", e[e.PIN = 3] = "PIN", e[e.PUK = 4] = "PUK", e[e.PIN_E_SIGN = 5] = "PIN_E_SIGN", e[e.SAI = 6] = "SAI", e[e.MRZ_HASH = 7] = "MRZ_HASH", e))(YM || {}), KM = /* @__PURE__ */ ((e) => (e[e.UNDEFINED = 0] = "UNDEFINED", e[e.INSPECTION_SYSTEM = 1] = "INSPECTION_SYSTEM", e[e.AUTHENTICATION_TERMINAL = 2] = "AUTHENTICATION_TERMINAL", e[e.SIGNATURE_TERMINAL = 3] = "SIGNATURE_TERMINAL", e[e.UNAUTHENTICATED_TERMINAL = 4] = "UNAUTHENTICATED_TERMINAL", e))(KM || {}), XM = /* @__PURE__ */ ((e) => (e[e.UNKNOWN = 0] = "UNKNOWN", e[e.A = 1] = "A", e[e.B = 2] = "B", e))(XM || {}), TD = /* @__PURE__ */ ((e) => (e.MRZ = "Mrz", e.BARCODE = "Barcode", e.LOCATE = "Locate", e.OCR = "Ocr", e.DOCTYPE = "DocType", e.MRZ_OR_BARCODE = "MrzOrBarcode", e.MRZ_OR_LOCATE = "MrzOrLocate", e.MRZ_AND_LOCATE = "MrzAndLocate", e.BARCODE_AND_LOCATE = "BarcodeAndLocate", e.MRZ_OR_OCR = "MrzOrOcr", e.MRZ_OR_BARCODE_OR_OCR = "MrzOrBarcodeOrOcr", e.LOCATE_VISUAL_AND_MRZ_OR_OCR = "LocateVisual_And_MrzOrOcr", e.FULL_PROCESS = "FullProcess", e.FULL_AUTH = "FullAuth", e.RUS_STAMP = "RusStamp", e.OCR_FREE = "OcrFree", e.CREDIT_CARD = "CreditCard", e.CAPTURE = "Capture", e.DTC = "DTC", e.RFID = "RFID", e))(TD || {}), QM = /* @__PURE__ */ ((e) => (e[e.BLANK = 0] = "BLANK", e[e.FILL = 1] = "FILL", e[e.PHOTO = 2] = "PHOTO", e[e.MRZ = 3] = "MRZ", e[e.FALSE_LUMINESCENCE = 4] = "FALSE_LUMINESCENCE", e[e.HOLO_SIMPLE = 5] = "HOLO_SIMPLE", e[e.HOLO_VERIFY_STATIC = 6] = "HOLO_VERIFY_STATIC", e[e.HOLO_VERIFY_MULTI_STATIC = 7] = "HOLO_VERIFY_MULTI_STATIC", e[e.HOLO_VERIFY_DYNAMIC = 8] = "HOLO_VERIFY_DYNAMIC", e[e.PATTERN_NOT_INTERRUPTED = 9] = "PATTERN_NOT_INTERRUPTED", e[e.PATTERN_NOT_SHIFTED = 10] = "PATTERN_NOT_SHIFTED", e[e.PATTERN_SAME_COLORS = 11] = "PATTERN_SAME_COLORS", e[e.PATTERN_IR_INVISIBLE = 12] = "PATTERN_IR_INVISIBLE", e[e.PHOTO_SIZE_CHECK = 13] = "PHOTO_SIZE_CHECK", e[e.PORTRAIT_COMPARISON_VS_GHOST = 14] = "PORTRAIT_COMPARISON_VS_GHOST", e[e.PORTRAIT_COMPARISON_VS_RFID = 15] = "PORTRAIT_COMPARISON_VS_RFID", e[e.PORTRAIT_COMPARISON_VS_VISUAL = 16] = "PORTRAIT_COMPARISON_VS_VISUAL", e[e.BARCODE = 17] = "BARCODE", e[e.PATTERN_DIFFERENT_LINES_THICKNESS = 18] = "PATTERN_DIFFERENT_LINES_THICKNESS", e[e.PORTRAIT_COMPARISON_VS_CAMERA = 19] = "PORTRAIT_COMPARISON_VS_CAMERA", e[e.PORTRAIT_COMPARISON_RFID_VS_CAMERA = 20] = "PORTRAIT_COMPARISON_RFID_VS_CAMERA", e[e.GHOST_PHOTO = 21] = "GHOST_PHOTO", e[e.CLEAR_GHOST_PHOTO = 22] = "CLEAR_GHOST_PHOTO", e[e.INVISIBLE_OBJECT = 23] = "INVISIBLE_OBJECT", e[e.LOW_CONTRAST_OBJECT = 24] = "LOW_CONTRAST_OBJECT", e[e.PHOTO_COLOR = 25] = "PHOTO_COLOR", e[e.PHOTO_SHAPE = 26] = "PHOTO_SHAPE", e[e.PHOTO_CORNERS = 27] = "PHOTO_CORNERS", e[e.OCR = 28] = "OCR", e[e.PORTRAIT_COMPARISON_EXT_VS_VISUAL = 29] = "PORTRAIT_COMPARISON_EXT_VS_VISUAL", e[e.PORTRAIT_COMPARISON_EXT_VS_RFID = 30] = "PORTRAIT_COMPARISON_EXT_VS_RFID", e[e.PORTRAIT_COMPARISON_EXT_VS_CAMERA = 31] = "PORTRAIT_COMPARISON_EXT_VS_CAMERA", e[e.LIVENESS_DEPTH = 32] = "LIVENESS_DEPTH", e[e.MICRO_TEXT = 33] = "MICRO_TEXT", e[e.FLUORESCENT_OBJECT = 34] = "FLUORESCENT_OBJECT", e[e.LANDMARK_CHECK = 35] = "LANDMARK_CHECK", e[e.FACE_PRESENCE = 36] = "FACE_PRESENCE", e[e.FACE_ABSENCE = 38] = "FACE_ABSENCE", e[e.LIVENESS_SCREEN_CAPTURE = 39] = "LIVENESS_SCREEN_CAPTURE", e[e.LIVENESS_ELECTRONIC_DEVICE = 40] = "LIVENESS_ELECTRONIC_DEVICE", e[e.LIVENESS_OVI = 41] = "LIVENESS_OVI", e[e.BARCODE_SIZE_CHECK = 42] = "BARCODE_SIZE_CHECK", e[e.LASINK = 43] = "LASINK", e[e.LIVENESS_MLI = 44] = "LIVENESS_MLI", e[e.LIVENESS_BARCODE_BACKGROUND = 45] = "LIVENESS_BARCODE_BACKGROUND", e[e.PORTRAIT_COMPARISON_VS_BARCODE = 46] = "PORTRAIT_COMPARISON_VS_BARCODE", e[e.PORTRAIT_COMPARISON_RFID_VS_BARCODE = 47] = "PORTRAIT_COMPARISON_RFID_VS_BARCODE", e[e.PORTRAIT_COMPARISON_EXT_VS_BARCODE = 48] = "PORTRAIT_COMPARISON_EXT_VS_BARCODE", e[e.PORTRAIT_COMPARISON_BARCODE_VS_CAMERA = 49] = "PORTRAIT_COMPARISON_BARCODE_VS_CAMERA", e[e.CHECK_DIGITAL_SIGNATURE = 50] = "CHECK_DIGITAL_SIGNATURE", e[e.CONTACT_CHIP_CLASSIFICATION = 51] = "CONTACT_CHIP_CLASSIFICATION", e[e.HEAD_POSITION_CHECK = 52] = "HEAD_POSITION_CHECK", e[e.LIVENESS_BLACK_AND_WHITE_COPY_CHECK = 53] = "LIVENESS_BLACK_AND_WHITE_COPY_CHECK", e[e.LIVENESS_DYNAPRINT = 54] = "LIVENESS_DYNAPRINT", e[e.LIVENESS_GEOMETRY_CHECK = 55] = "LIVENESS_GEOMETRY_CHECK", e[e.AGE_CHECK = 56] = "AGE_CHECK", e[e.SEX_CHECK = 57] = "SEX_CHECK", e))(QM || {}), xl = /* @__PURE__ */ ((e) => (e.MRZ = "MRZ", e.VISUAL = "VISUAL", e.BARCODE = "BARCODE", e.RFID = "RFID", e.MAGNETIC = "MAGNETIC", e.EXTERNAL = "EXTERNAL", e.LIVE = "LIVE", e.FINGERPRINT = "FINGERPRINT", e))(xl || {}), JM = /* @__PURE__ */ ((e) => (e[e.DOCUMENT_CLASS_CODE = 0] = "DOCUMENT_CLASS_CODE", e[e.ISSUING_STATE_CODE = 1] = "ISSUING_STATE_CODE", e[e.DOCUMENT_NUMBER = 2] = "DOCUMENT_NUMBER", e[e.DATE_OF_EXPIRY = 3] = "DATE_OF_EXPIRY", e[e.DATE_OF_ISSUE = 4] = "DATE_OF_ISSUE", e[e.DATE_OF_BIRTH = 5] = "DATE_OF_BIRTH", e[e.PLACE_OF_BIRTH = 6] = "PLACE_OF_BIRTH", e[e.PERSONAL_NUMBER = 7] = "PERSONAL_NUMBER", e[e.SURNAME = 8] = "SURNAME", e[e.GIVEN_NAMES = 9] = "GIVEN_NAMES", e[e.MOTHERS_NAME = 10] = "MOTHERS_NAME", e[e.NATIONALITY = 11] = "NATIONALITY", e[e.SEX = 12] = "SEX", e[e.HEIGHT = 13] = "HEIGHT", e[e.WEIGHT = 14] = "WEIGHT", e[e.EYES_COLOR = 15] = "EYES_COLOR", e[e.HAIR_COLOR = 16] = "HAIR_COLOR", e[e.ADDRESS = 17] = "ADDRESS", e[e.DONOR = 18] = "DONOR", e[e.SOCIAL_SECURITY_NUMBER = 19] = "SOCIAL_SECURITY_NUMBER", e[e.DL_CLASS = 20] = "DL_CLASS", e[e.DL_ENDORSED = 21] = "DL_ENDORSED", e[e.DL_RESTRICTION_CODE = 22] = "DL_RESTRICTION_CODE", e[e.DL_UNDER_21_DATE = 23] = "DL_UNDER_21_DATE", e[e.AUTHORITY = 24] = "AUTHORITY", e[e.SURNAME_AND_GIVEN_NAMES = 25] = "SURNAME_AND_GIVEN_NAMES", e[e.NATIONALITY_CODE = 26] = "NATIONALITY_CODE", e[e.PASSPORT_NUMBER = 27] = "PASSPORT_NUMBER", e[e.INVITATION_NUMBER = 28] = "INVITATION_NUMBER", e[e.VISA_ID = 29] = "VISA_ID", e[e.VISA_CLASS = 30] = "VISA_CLASS", e[e.VISA_SUBCLASS = 31] = "VISA_SUBCLASS", e[e.MRZ_TYPE = 35] = "MRZ_TYPE", e[e.OPTIONAL_DATA = 36] = "OPTIONAL_DATA", e[e.DOCUMENT_CLASS_NAME = 37] = "DOCUMENT_CLASS_NAME", e[e.ISSUING_STATE_NAME = 38] = "ISSUING_STATE_NAME", e[e.PLACE_OF_ISSUE = 39] = "PLACE_OF_ISSUE", e[e.DOCUMENT_NUMBER_CHECKSUM = 40] = "DOCUMENT_NUMBER_CHECKSUM", e[e.DATE_OF_BIRTH_CHECKSUM = 41] = "DATE_OF_BIRTH_CHECKSUM", e[e.DATE_OF_EXPIRY_CHECKSUM = 42] = "DATE_OF_EXPIRY_CHECKSUM", e[e.PERSONAL_NUMBER_CHECKSUM = 43] = "PERSONAL_NUMBER_CHECKSUM", e[e.FINAL_CHECKSUM = 44] = "FINAL_CHECKSUM", e[e.PASSPORT_NUMBER_CHECKSUM = 45] = "PASSPORT_NUMBER_CHECKSUM", e[e.INVITATION_NUMBER_CHECKSUM = 46] = "INVITATION_NUMBER_CHECKSUM", e[e.VISA_ID_CHECKSUM = 47] = "VISA_ID_CHECKSUM", e[e.SURNAME_AND_GIVEN_NAMES_CHECKSUM = 48] = "SURNAME_AND_GIVEN_NAMES_CHECKSUM", e[e.VISA_VALID_UNTIL_CHECKSUM = 49] = "VISA_VALID_UNTIL_CHECKSUM", e[e.OTHER = 50] = "OTHER", e[e.MRZ_STRINGS = 51] = "MRZ_STRINGS", e[e.NAME_SUFFIX = 52] = "NAME_SUFFIX", e[e.NAME_PREFIX = 53] = "NAME_PREFIX", e[e.DATE_OF_ISSUE_CHECKSUM = 54] = "DATE_OF_ISSUE_CHECKSUM", e[e.DATE_OF_ISSUE_CHECK_DIGIT = 55] = "DATE_OF_ISSUE_CHECK_DIGIT", e[e.DOCUMENT_SERIES = 56] = "DOCUMENT_SERIES", e[e.REG_CERT_REG_NUMBER = 57] = "REG_CERT_REG_NUMBER", e[e.REG_CERT_CAR_MODEL = 58] = "REG_CERT_CAR_MODEL", e[e.REG_CERT_CAR_COLOR = 59] = "REG_CERT_CAR_COLOR", e[e.REG_CERT_BODY_NUMBER = 60] = "REG_CERT_BODY_NUMBER", e[e.REG_CERT_CAR_TYPE = 61] = "REG_CERT_CAR_TYPE", e[e.REG_CERT_MAX_WEIGHT = 62] = "REG_CERT_MAX_WEIGHT", e[e.REG_CERT_WEIGHT = 63] = "REG_CERT_WEIGHT", e[e.ADDRESS_AREA = 64] = "ADDRESS_AREA", e[e.ADDRESS_STATE = 65] = "ADDRESS_STATE", e[e.ADDRESS_BUILDING = 66] = "ADDRESS_BUILDING", e[e.ADDRESS_HOUSE = 67] = "ADDRESS_HOUSE", e[e.ADDRESS_FLAT = 68] = "ADDRESS_FLAT", e[e.PLACE_OF_REGISTRATION = 69] = "PLACE_OF_REGISTRATION", e[e.DATE_OF_REGISTRATION = 70] = "DATE_OF_REGISTRATION", e[e.RESIDENT_FROM = 71] = "RESIDENT_FROM", e[e.RESIDENT_UNTIL = 72] = "RESIDENT_UNTIL", e[e.AUTHORITY_CODE = 73] = "AUTHORITY_CODE", e[e.PLACE_OF_BIRTH_AREA = 74] = "PLACE_OF_BIRTH_AREA", e[e.PLACE_OF_BIRTH_STATE_CODE = 75] = "PLACE_OF_BIRTH_STATE_CODE", e[e.ADDRESS_STREET = 76] = "ADDRESS_STREET", e[e.ADDRESS_CITY = 77] = "ADDRESS_CITY", e[e.ADDRESS_JURISDICTION_CODE = 78] = "ADDRESS_JURISDICTION_CODE", e[e.ADDRESS_POSTAL_CODE = 79] = "ADDRESS_POSTAL_CODE", e[e.DOCUMENT_NUMBER_CHECK_DIGIT = 80] = "DOCUMENT_NUMBER_CHECK_DIGIT", e[e.DATE_OF_BIRTH_CHECK_DIGIT = 81] = "DATE_OF_BIRTH_CHECK_DIGIT", e[e.DATE_OF_EXPIRY_CHECK_DIGIT = 82] = "DATE_OF_EXPIRY_CHECK_DIGIT", e[e.PERSONAL_NUMBER_CHECK_DIGIT = 83] = "PERSONAL_NUMBER_CHECK_DIGIT", e[e.FINAL_CHECK_DIGIT = 84] = "FINAL_CHECK_DIGIT", e[e.PASSPORT_NUMBER_CHECK_DIGIT = 85] = "PASSPORT_NUMBER_CHECK_DIGIT", e[e.INVITATION_NUMBER_CHECK_DIGIT = 86] = "INVITATION_NUMBER_CHECK_DIGIT", e[e.VISA_ID_CHECK_DIGIT = 87] = "VISA_ID_CHECK_DIGIT", e[e.SURNAME_AND_GIVEN_NAMES_CHECK_DIGIT = 88] = "SURNAME_AND_GIVEN_NAMES_CHECK_DIGIT", e[e.VISA_VALID_UNTIL_CHECK_DIGIT = 89] = "VISA_VALID_UNTIL_CHECK_DIGIT", e[e.PERMIT_DL_CLASS = 90] = "PERMIT_DL_CLASS", e[e.PERMIT_DATE_OF_EXPIRY = 91] = "PERMIT_DATE_OF_EXPIRY", e[e.PERMIT_IDENTIFIER = 92] = "PERMIT_IDENTIFIER", e[e.PERMIT_DATE_OF_ISSUE = 93] = "PERMIT_DATE_OF_ISSUE", e[e.PERMIT_RESTRICTION_CODE = 94] = "PERMIT_RESTRICTION_CODE", e[e.PERMIT_ENDORSED = 95] = "PERMIT_ENDORSED", e[e.ISSUE_TIMESTAMP = 96] = "ISSUE_TIMESTAMP", e[e.NUMBER_OF_DUPLICATES = 97] = "NUMBER_OF_DUPLICATES", e[e.MEDICAL_INDICATOR_CODES = 98] = "MEDICAL_INDICATOR_CODES", e[e.NON_RESIDENT_INDICATOR = 99] = "NON_RESIDENT_INDICATOR", e[e.VISA_TYPE = 100] = "VISA_TYPE", e[e.VISA_VALID_FROM = 101] = "VISA_VALID_FROM", e[e.VISA_VALID_UNTIL = 102] = "VISA_VALID_UNTIL", e[e.DURATION_OF_STAY = 103] = "DURATION_OF_STAY", e[e.NUMBER_OF_ENTRIES = 104] = "NUMBER_OF_ENTRIES", e[e.DAY = 105] = "DAY", e[e.MONTH = 106] = "MONTH", e[e.YEAR = 107] = "YEAR", e[e.UNIQUE_CUSTOMER_IDENTIFIER = 108] = "UNIQUE_CUSTOMER_IDENTIFIER", e[e.COMMERCIAL_VEHICLE_CODES = 109] = "COMMERCIAL_VEHICLE_CODES", e[e.AKA_DATE_OF_BIRTH = 110] = "AKA_DATE_OF_BIRTH", e[e.AKA_SOCIAL_SECURITY_NUMBER = 111] = "AKA_SOCIAL_SECURITY_NUMBER", e[e.AKA_SURNAME = 112] = "AKA_SURNAME", e[e.AKA_GIVEN_NAMES = 113] = "AKA_GIVEN_NAMES", e[e.AKA_NAME_SUFFIX = 114] = "AKA_NAME_SUFFIX", e[e.AKA_NAME_PREFIX = 115] = "AKA_NAME_PREFIX", e[e.MAILING_ADDRESS_STREET = 116] = "MAILING_ADDRESS_STREET", e[e.MAILING_ADDRESS_CITY = 117] = "MAILING_ADDRESS_CITY", e[e.MAILING_ADDRESS_JURISDICTION_CODE = 118] = "MAILING_ADDRESS_JURISDICTION_CODE", e[e.MAILING_ADDRESS_POSTAL_CODE = 119] = "MAILING_ADDRESS_POSTAL_CODE", e[e.AUDIT_INFORMATION = 120] = "AUDIT_INFORMATION", e[e.INVENTORY_NUMBER = 121] = "INVENTORY_NUMBER", e[e.RACE_ETHNICITY = 122] = "RACE_ETHNICITY", e[e.JURISDICTION_VEHICLE_CLASS = 123] = "JURISDICTION_VEHICLE_CLASS", e[e.JURISDICTION_ENDORSEMENT_CODE = 124] = "JURISDICTION_ENDORSEMENT_CODE", e[e.JURISDICTION_RESTRICTION_CODE = 125] = "JURISDICTION_RESTRICTION_CODE", e[e.FAMILY_NAME = 126] = "FAMILY_NAME", e[e.GIVEN_NAMES_RUS = 127] = "GIVEN_NAMES_RUS", e[e.VISA_ID_RUS = 128] = "VISA_ID_RUS", e[e.FATHERS_NAME = 129] = "FATHERS_NAME", e[e.FATHERS_NAME_RUS = 130] = "FATHERS_NAME_RUS", e[e.SURNAME_AND_GIVEN_NAMES_RUS = 131] = "SURNAME_AND_GIVEN_NAMES_RUS", e[e.PLACE_OF_BIRTH_RUS = 132] = "PLACE_OF_BIRTH_RUS", e[e.AUTHORITY_RUS = 133] = "AUTHORITY_RUS", e[e.ISSUING_STATE_CODE_NUMERIC = 134] = "ISSUING_STATE_CODE_NUMERIC", e[e.NATIONALITY_CODE_NUMERIC = 135] = "NATIONALITY_CODE_NUMERIC", e[e.ENGINE_POWER = 136] = "ENGINE_POWER", e[e.ENGINE_VOLUME = 137] = "ENGINE_VOLUME", e[e.CHASSIS_NUMBER = 138] = "CHASSIS_NUMBER", e[e.ENGINE_NUMBER = 139] = "ENGINE_NUMBER", e[e.ENGINE_MODEL = 140] = "ENGINE_MODEL", e[e.VEHICLE_CATEGORY = 141] = "VEHICLE_CATEGORY", e[e.IDENTITY_CARD_NUMBER = 142] = "IDENTITY_CARD_NUMBER", e[e.CONTROL_NUMBER = 143] = "CONTROL_NUMBER", e[e.PARENTS_GIVEN_NAMES = 144] = "PARENTS_GIVEN_NAMES", e[e.SECOND_SURNAME = 145] = "SECOND_SURNAME", e[e.MIDDLE_NAME = 146] = "MIDDLE_NAME", e[e.REG_CERT_VIN = 147] = "REG_CERT_VIN", e[e.REG_CERT_VIN_CHECK_DIGIT = 148] = "REG_CERT_VIN_CHECK_DIGIT", e[e.REG_CERT_VIN_CHECKSUM = 149] = "REG_CERT_VIN_CHECKSUM", e[e.LINE_1_CHECK_DIGIT = 150] = "LINE_1_CHECK_DIGIT", e[e.LINE_2_CHECK_DIGIT = 151] = "LINE_2_CHECK_DIGIT", e[e.LINE_3_CHECK_DIGIT = 152] = "LINE_3_CHECK_DIGIT", e[e.LINE_1_CHECKSUM = 153] = "LINE_1_CHECKSUM", e[e.LINE_2_CHECKSUM = 154] = "LINE_2_CHECKSUM", e[e.LINE_3_CHECKSUM = 155] = "LINE_3_CHECKSUM", e[e.REG_CERT_REG_NUMBER_CHECK_DIGIT = 156] = "REG_CERT_REG_NUMBER_CHECK_DIGIT", e[e.REG_CERT_REG_NUMBER_CHECKSUM = 157] = "REG_CERT_REG_NUMBER_CHECKSUM", e[e.REG_CERT_VEHICLE_ITS_CODE = 158] = "REG_CERT_VEHICLE_ITS_CODE", e[e.CARD_ACCESS_NUMBER = 159] = "CARD_ACCESS_NUMBER", e[e.MARITAL_STATUS = 160] = "MARITAL_STATUS", e[e.COMPANY_NAME = 161] = "COMPANY_NAME", e[e.SPECIAL_NOTES = 162] = "SPECIAL_NOTES", e[e.SURNAME_OF_SPOUSE = 163] = "SURNAME_OF_SPOUSE", e[e.TRACKING_NUMBER = 164] = "TRACKING_NUMBER", e[e.BOOKLET_NUMBER = 165] = "BOOKLET_NUMBER", e[e.CHILDREN = 166] = "CHILDREN", e[e.COPY = 167] = "COPY", e[e.SERIAL_NUMBER = 168] = "SERIAL_NUMBER", e[e.DOSSIER_NUMBER = 169] = "DOSSIER_NUMBER", e[e.AKA_SURNAME_AND_GIVEN_NAMES = 170] = "AKA_SURNAME_AND_GIVEN_NAMES", e[e.TERRITORIAL_VALIDITY = 171] = "TERRITORIAL_VALIDITY", e[e.MRZ_STRINGS_WITH_CORRECT_CHECK_SUMS = 172] = "MRZ_STRINGS_WITH_CORRECT_CHECK_SUMS", e[e.DL_CDL_RESTRICTION_CODE = 173] = "DL_CDL_RESTRICTION_CODE", e[e.DL_UNDER_18_DATE = 174] = "DL_UNDER_18_DATE", e[e.DL_RECORD_CREATED = 175] = "DL_RECORD_CREATED", e[e.DL_DUPLICATE_DATE = 176] = "DL_DUPLICATE_DATE", e[e.DL_ISSUE_TYPE = 177] = "DL_ISSUE_TYPE", e[e.MILITARY_BOOK_NUMBER = 178] = "MILITARY_BOOK_NUMBER", e[e.DESTINATION = 179] = "DESTINATION", e[e.BLOOD_GROUP = 180] = "BLOOD_GROUP", e[e.SEQUENCE_NUMBER = 181] = "SEQUENCE_NUMBER", e[e.REG_CERT_BODY_TYPE = 182] = "REG_CERT_BODY_TYPE", e[e.REG_CERT_CAR_MARK = 183] = "REG_CERT_CAR_MARK", e[e.TRANSACTION_NUMBER = 184] = "TRANSACTION_NUMBER", e[e.AGE = 185] = "AGE", e[e.FOLIO_NUMBER = 186] = "FOLIO_NUMBER", e[e.VOTER_KEY = 187] = "VOTER_KEY", e[e.ADDRESS_MUNICIPALITY = 188] = "ADDRESS_MUNICIPALITY", e[e.ADDRESS_LOCATION = 189] = "ADDRESS_LOCATION", e[e.SECTION = 190] = "SECTION", e[e.OCR_NUMBER = 191] = "OCR_NUMBER", e[e.FEDERAL_ELECTIONS = 192] = "FEDERAL_ELECTIONS", e[e.REFERENCE_NUMBER = 193] = "REFERENCE_NUMBER", e[e.OPTIONAL_DATA_CHECKSUM = 194] = "OPTIONAL_DATA_CHECKSUM", e[e.OPTIONAL_DATA_CHECK_DIGIT = 195] = "OPTIONAL_DATA_CHECK_DIGIT", e[e.VISA_NUMBER = 196] = "VISA_NUMBER", e[e.VISA_NUMBER_CHECKSUM = 197] = "VISA_NUMBER_CHECKSUM", e[e.VISA_NUMBER_CHECK_DIGIT = 198] = "VISA_NUMBER_CHECK_DIGIT", e[e.VOTER = 199] = "VOTER", e[e.PREVIOUS_TYPE = 200] = "PREVIOUS_TYPE", e[e.FIELD_FROM_MRZ = 220] = "FIELD_FROM_MRZ", e[e.CURRENT_DATE = 221] = "CURRENT_DATE", e[e.STATUS_DATE_OF_EXPIRY = 251] = "STATUS_DATE_OF_EXPIRY", e[e.BANKNOTE_NUMBER = 252] = "BANKNOTE_NUMBER", e[e.CSC_CODE = 253] = "CSC_CODE", e[e.ARTISTIC_NAME = 254] = "ARTISTIC_NAME", e[e.ACADEMIC_TITLE = 255] = "ACADEMIC_TITLE", e[e.ADDRESS_COUNTRY = 256] = "ADDRESS_COUNTRY", e[e.ADDRESS_ZIP_CODE = 257] = "ADDRESS_ZIP_CODE", e[e.E_ID_RESIDENCE_PERMIT_1 = 258] = "E_ID_RESIDENCE_PERMIT_1", e[e.E_ID_RESIDENCE_PERMIT_2 = 259] = "E_ID_RESIDENCE_PERMIT_2", e[e.E_ID_PLACE_OF_BIRTH_STREET = 260] = "E_ID_PLACE_OF_BIRTH_STREET", e[e.E_ID_PLACE_OF_BIRTH_CITY = 261] = "E_ID_PLACE_OF_BIRTH_CITY", e[e.E_ID_PLACE_OF_BIRTH_STATE = 262] = "E_ID_PLACE_OF_BIRTH_STATE", e[e.E_ID_PLACE_OF_BIRTH_COUNTRY = 263] = "E_ID_PLACE_OF_BIRTH_COUNTRY", e[e.E_ID_PLACE_OF_BIRTH_ZIP_CODE = 264] = "E_ID_PLACE_OF_BIRTH_ZIP_CODE", e[e.CDL_CLASS = 265] = "CDL_CLASS", e[e.DL_UNDER_19_DATE = 266] = "DL_UNDER_19_DATE", e[e.WEIGHT_POUNDS = 267] = "WEIGHT_POUNDS", e[e.LIMITED_DURATION_DOCUMENT_INDICATOR = 268] = "LIMITED_DURATION_DOCUMENT_INDICATOR", e[e.ENDORSEMENT_EXPIRATION_DATE = 269] = "ENDORSEMENT_EXPIRATION_DATE", e[e.REVISION_DATE = 270] = "REVISION_DATE", e[e.COMPLIANCE_TYPE = 271] = "COMPLIANCE_TYPE", e[e.FAMILY_NAME_TRUNCATION = 272] = "FAMILY_NAME_TRUNCATION", e[e.FIRST_NAME_TRUNCATION = 273] = "FIRST_NAME_TRUNCATION", e[e.MIDDLE_NAME_TRUNCATION = 274] = "MIDDLE_NAME_TRUNCATION", e[e.EXAM_DATE = 275] = "EXAM_DATE", e[e.ORGANIZATION = 276] = "ORGANIZATION", e[e.DEPARTMENT = 277] = "DEPARTMENT", e[e.PAY_GRADE = 278] = "PAY_GRADE", e[e.RANK = 279] = "RANK", e[e.BENEFITS_NUMBER = 280] = "BENEFITS_NUMBER", e[e.SPONSOR_SERVICE = 281] = "SPONSOR_SERVICE", e[e.SPONSOR_STATUS = 282] = "SPONSOR_STATUS", e[e.SPONSOR = 283] = "SPONSOR", e[e.RELATIONSHIP = 284] = "RELATIONSHIP", e[e.USCIS = 285] = "USCIS", e[e.CATEGORY = 286] = "CATEGORY", e[e.CONDITIONS = 287] = "CONDITIONS", e[e.IDENTIFIER = 288] = "IDENTIFIER", e[e.CONFIGURATION = 289] = "CONFIGURATION", e[e.DISCRETIONARY_DATA = 290] = "DISCRETIONARY_DATA", e[e.LINE_1_OPTIONAL_DATA = 291] = "LINE_1_OPTIONAL_DATA", e[e.LINE_2_OPTIONAL_DATA = 292] = "LINE_2_OPTIONAL_DATA", e[e.LINE_3_OPTIONAL_DATA = 293] = "LINE_3_OPTIONAL_DATA", e[e.EQV_CODE = 294] = "EQV_CODE", e[e.ALT_CODE = 295] = "ALT_CODE", e[e.BINARY_CODE = 296] = "BINARY_CODE", e[e.PSEUDO_CODE = 297] = "PSEUDO_CODE", e[e.FEE = 298] = "FEE", e[e.STAMP_NUMBER = 299] = "STAMP_NUMBER", e[e.SBH_SECURITY_OPTIONS = 300] = "SBH_SECURITY_OPTIONS", e[e.SBH_INTEGRITY_OPTIONS = 301] = "SBH_INTEGRITY_OPTIONS", e[e.DATE_OF_CREATION = 302] = "DATE_OF_CREATION", e[e.VALIDITY_PERIOD = 303] = "VALIDITY_PERIOD", e[e.PATRON_HEADER_VERSION = 304] = "PATRON_HEADER_VERSION", e[e.BDB_TYPE = 305] = "BDB_TYPE", e[e.BIOMETRIC_TYPE = 306] = "BIOMETRIC_TYPE", e[e.BIOMETRIC_SUBTYPE = 307] = "BIOMETRIC_SUBTYPE", e[e.BIOMETRIC_PRODUCT_ID = 308] = "BIOMETRIC_PRODUCT_ID", e[e.BIOMETRIC_FORMAT_OWNER = 309] = "BIOMETRIC_FORMAT_OWNER", e[e.BIOMETRIC_FORMAT_TYPE = 310] = "BIOMETRIC_FORMAT_TYPE", e[e.PHONE = 311] = "PHONE", e[e.PROFESSION = 312] = "PROFESSION", e[e.TITLE = 313] = "TITLE", e[e.PERSONAL_SUMMARY = 314] = "PERSONAL_SUMMARY", e[e.OTHER_VALID_ID = 315] = "OTHER_VALID_ID", e[e.CUSTODY_INFO = 316] = "CUSTODY_INFO", e[e.OTHER_NAME = 317] = "OTHER_NAME", e[e.OBSERVATIONS = 318] = "OBSERVATIONS", e[e.TAX = 319] = "TAX", e[e.DATE_OF_PERSONALIZATION = 320] = "DATE_OF_PERSONALIZATION", e[e.PERSONALIZATION_SN = 321] = "PERSONALIZATION_SN", e[e.OTHER_PERSON_NAME = 322] = "OTHER_PERSON_NAME", e[e.PERSON_TO_NOTIFY_DATE_OF_RECORD = 323] = "PERSON_TO_NOTIFY_DATE_OF_RECORD", e[e.PERSON_TO_NOTIFY_NAME = 324] = "PERSON_TO_NOTIFY_NAME", e[e.PERSON_TO_NOTIFY_PHONE = 325] = "PERSON_TO_NOTIFY_PHONE", e[e.PERSON_TO_NOTIFY_ADDRESS = 326] = "PERSON_TO_NOTIFY_ADDRESS", e[e.DS_CERTIFICATE_ISSUER = 327] = "DS_CERTIFICATE_ISSUER", e[e.DS_CERTIFICATE_SUBJECT = 328] = "DS_CERTIFICATE_SUBJECT", e[e.DS_CERTIFICATE_VALID_FROM = 329] = "DS_CERTIFICATE_VALID_FROM", e[e.DS_CERTIFICATE_VALID_TO = 330] = "DS_CERTIFICATE_VALID_TO", e[e.VRC_DATA_OBJECT_ENTRY = 331] = "VRC_DATA_OBJECT_ENTRY", e[e.TYPE_APPROVAL_NUMBER = 332] = "TYPE_APPROVAL_NUMBER", e[e.ADMINISTRATIVE_NUMBER = 333] = "ADMINISTRATIVE_NUMBER", e[e.DOCUMENT_DISCRIMINATOR = 334] = "DOCUMENT_DISCRIMINATOR", e[e.DATA_DISCRIMINATOR = 335] = "DATA_DISCRIMINATOR", e[e.ISO_ISSUER_ID_NUMBER = 336] = "ISO_ISSUER_ID_NUMBER", e[e.DTC_VERSION = 337] = "DTC_VERSION", e[e.DTC_ID = 338] = "DTC_ID", e[e.DTC_DATE_OF_EXPIRY = 339] = "DTC_DATE_OF_EXPIRY", e[e.GNIB_NUMBER = 340] = "GNIB_NUMBER", e[e.DEPT_NUMBER = 341] = "DEPT_NUMBER", e[e.TELEX_CODE = 342] = "TELEX_CODE", e[e.ALLERGIES = 343] = "ALLERGIES", e[e.SP_CODE = 344] = "SP_CODE", e[e.COURT_CODE = 345] = "COURT_CODE", e[e.CTY = 346] = "CTY", e[e.SPONSOR_SSN = 347] = "SPONSOR_SSN", e[e.DOD_NUMBER = 348] = "DOD_NUMBER", e[e.MC_NOVICE_DATE = 349] = "MC_NOVICE_DATE", e[e.DUF_NUMBER = 350] = "DUF_NUMBER", e[e.AGY = 351] = "AGY", e[e.PNR_CODE = 352] = "PNR_CODE", e[e.FROM_AIRPORT_CODE = 353] = "FROM_AIRPORT_CODE", e[e.TO_AIRPORT_CODE = 354] = "TO_AIRPORT_CODE", e[e.FLIGHT_NUMBER = 355] = "FLIGHT_NUMBER", e[e.DATE_OF_FLIGHT = 356] = "DATE_OF_FLIGHT", e[e.SEAT_NUMBER = 357] = "SEAT_NUMBER", e[e.DATE_OF_ISSUE_BOARDING_PASS = 358] = "DATE_OF_ISSUE_BOARDING_PASS", e[e.CCW_UNTIL = 359] = "CCW_UNTIL", e[e.REFERENCE_NUMBER_CHECKSUM = 360] = "REFERENCE_NUMBER_CHECKSUM", e[e.REFERENCE_NUMBER_CHECK_DIGIT = 361] = "REFERENCE_NUMBER_CHECK_DIGIT", e[e.ROOM_NUMBER = 362] = "ROOM_NUMBER", e[e.RELIGION = 363] = "RELIGION", e[e.REMAINDER_TERM = 364] = "REMAINDER_TERM", e[e.ELECTRONIC_TICKET_INDICATOR = 365] = "ELECTRONIC_TICKET_INDICATOR", e[e.COMPARTMENT_CODE = 366] = "COMPARTMENT_CODE", e[e.CHECK_IN_SEQUENCE_NUMBER = 367] = "CHECK_IN_SEQUENCE_NUMBER", e[e.AIRLINE_DESIGNATOR_OF_BOARDING_PASS_ISSUER = 368] = "AIRLINE_DESIGNATOR_OF_BOARDING_PASS_ISSUER", e[e.AIRLINE_NUMERIC_CODE = 369] = "AIRLINE_NUMERIC_CODE", e[e.TICKET_NUMBER = 370] = "TICKET_NUMBER", e[e.FREQUENT_FLYER_AIRLINE_DESIGNATOR = 371] = "FREQUENT_FLYER_AIRLINE_DESIGNATOR", e[e.FREQUENT_FLYER_NUMBER = 372] = "FREQUENT_FLYER_NUMBER", e[e.FREE_BAGGAGE_ALLOWANCE = 373] = "FREE_BAGGAGE_ALLOWANCE", e[e.PDF417_CODEC = 374] = "PDF417_CODEC", e[e.IDENTITY_CARD_NUMBER_CHECKSUM = 375] = "IDENTITY_CARD_NUMBER_CHECKSUM", e[e.IDENTITY_CARD_NUMBER_CHECK_DIGIT = 376] = "IDENTITY_CARD_NUMBER_CHECK_DIGIT", e[e.VETERAN = 377] = "VETERAN", e[e.DL_CLASS_CODE_A1_FROM = 378] = "DL_CLASS_CODE_A1_FROM", e[e.DL_CLASS_CODE_A1_TO = 379] = "DL_CLASS_CODE_A1_TO", e[e.DL_CLASS_CODE_A1_NOTES = 380] = "DL_CLASS_CODE_A1_NOTES", e[e.DL_CLASS_CODE_A_FROM = 381] = "DL_CLASS_CODE_A_FROM", e[e.DL_CLASS_CODE_A_TO = 382] = "DL_CLASS_CODE_A_TO", e[e.DL_CLASS_CODE_A_NOTES = 383] = "DL_CLASS_CODE_A_NOTES", e[e.DL_CLASS_CODE_B_FROM = 384] = "DL_CLASS_CODE_B_FROM", e[e.DL_CLASS_CODE_B_TO = 385] = "DL_CLASS_CODE_B_TO", e[e.DL_CLASS_CODE_B_NOTES = 386] = "DL_CLASS_CODE_B_NOTES", e[e.DL_CLASS_CODE_C1_FROM = 387] = "DL_CLASS_CODE_C1_FROM", e[e.DL_CLASS_CODE_C1_TO = 388] = "DL_CLASS_CODE_C1_TO", e[e.DL_CLASS_CODE_C1_NOTES = 389] = "DL_CLASS_CODE_C1_NOTES", e[e.DL_CLASS_CODE_C_FROM = 390] = "DL_CLASS_CODE_C_FROM", e[e.DL_CLASS_CODE_C_TO = 391] = "DL_CLASS_CODE_C_TO", e[e.DL_CLASS_CODE_C_NOTES = 392] = "DL_CLASS_CODE_C_NOTES", e[e.DL_CLASS_CODE_D1_FROM = 393] = "DL_CLASS_CODE_D1_FROM", e[e.DL_CLASS_CODE_D1_TO = 394] = "DL_CLASS_CODE_D1_TO", e[e.DL_CLASS_CODE_D1_NOTES = 395] = "DL_CLASS_CODE_D1_NOTES", e[e.DL_CLASS_CODE_D_FROM = 396] = "DL_CLASS_CODE_D_FROM", e[e.DL_CLASS_CODE_D_TO = 397] = "DL_CLASS_CODE_D_TO", e[e.DL_CLASS_CODE_D_NOTES = 398] = "DL_CLASS_CODE_D_NOTES", e[e.DL_CLASS_CODE_BE_FROM = 399] = "DL_CLASS_CODE_BE_FROM", e[e.DL_CLASS_CODE_BE_TO = 400] = "DL_CLASS_CODE_BE_TO", e[e.DL_CLASS_CODE_BE_NOTES = 401] = "DL_CLASS_CODE_BE_NOTES", e[e.DL_CLASS_CODE_C1E_FROM = 402] = "DL_CLASS_CODE_C1E_FROM", e[e.DL_CLASS_CODE_C1E_TO = 403] = "DL_CLASS_CODE_C1E_TO", e[e.DL_CLASS_CODE_C1E_NOTES = 404] = "DL_CLASS_CODE_C1E_NOTES", e[e.DL_CLASS_CODE_CE_FROM = 405] = "DL_CLASS_CODE_CE_FROM", e[e.DL_CLASS_CODE_CE_TO = 406] = "DL_CLASS_CODE_CE_TO", e[e.DL_CLASS_CODE_CE_NOTES = 407] = "DL_CLASS_CODE_CE_NOTES", e[e.DL_CLASS_CODE_D1E_FROM = 408] = "DL_CLASS_CODE_D1E_FROM", e[e.DL_CLASS_CODE_D1E_TO = 409] = "DL_CLASS_CODE_D1E_TO", e[e.DL_CLASS_CODE_D1E_NOTES = 410] = "DL_CLASS_CODE_D1E_NOTES", e[e.DL_CLASS_CODE_DE_FROM = 411] = "DL_CLASS_CODE_DE_FROM", e[e.DL_CLASS_CODE_DE_TO = 412] = "DL_CLASS_CODE_DE_TO", e[e.DL_CLASS_CODE_DE_NOTES = 413] = "DL_CLASS_CODE_DE_NOTES", e[e.DL_CLASS_CODE_M_FROM = 414] = "DL_CLASS_CODE_M_FROM", e[e.DL_CLASS_CODE_M_TO = 415] = "DL_CLASS_CODE_M_TO", e[e.DL_CLASS_CODE_M_NOTES = 416] = "DL_CLASS_CODE_M_NOTES", e[e.DL_CLASS_CODE_L_FROM = 417] = "DL_CLASS_CODE_L_FROM", e[e.DL_CLASS_CODE_L_TO = 418] = "DL_CLASS_CODE_L_TO", e[e.DL_CLASS_CODE_L_NOTES = 419] = "DL_CLASS_CODE_L_NOTES", e[e.DL_CLASS_CODE_T_FROM = 420] = "DL_CLASS_CODE_T_FROM", e[e.DL_CLASS_CODE_T_TO = 421] = "DL_CLASS_CODE_T_TO", e[e.DL_CLASS_CODE_T_NOTES = 422] = "DL_CLASS_CODE_T_NOTES", e[e.DL_CLASS_CODE_AM_FROM = 423] = "DL_CLASS_CODE_AM_FROM", e[e.DL_CLASS_CODE_AM_TO = 424] = "DL_CLASS_CODE_AM_TO", e[e.DL_CLASS_CODE_AM_NOTES = 425] = "DL_CLASS_CODE_AM_NOTES", e[e.DL_CLASS_CODE_A2_FROM = 426] = "DL_CLASS_CODE_A2_FROM", e[e.DL_CLASS_CODE_A2_TO = 427] = "DL_CLASS_CODE_A2_TO", e[e.DL_CLASS_CODE_A2_NOTES = 428] = "DL_CLASS_CODE_A2_NOTES", e[e.DL_CLASS_CODE_B1_FROM = 429] = "DL_CLASS_CODE_B1_FROM", e[e.DL_CLASS_CODE_B1_TO = 430] = "DL_CLASS_CODE_B1_TO", e[e.DL_CLASS_CODE_B1_NOTES = 431] = "DL_CLASS_CODE_B1_NOTES", e[e.SURNAME_AT_BIRTH = 432] = "SURNAME_AT_BIRTH", e[e.CIVIL_STATUS = 433] = "CIVIL_STATUS", e[e.NUMBER_OF_SEATS = 434] = "NUMBER_OF_SEATS", e[e.NUMBER_OF_STANDING_PLACES = 435] = "NUMBER_OF_STANDING_PLACES", e[e.MAX_SPEED = 436] = "MAX_SPEED", e[e.FUEL_TYPE = 437] = "FUEL_TYPE", e[e.EC_ENVIRONMENTAL_TYPE = 438] = "EC_ENVIRONMENTAL_TYPE", e[e.POWER_WEIGHT_RATIO = 439] = "POWER_WEIGHT_RATIO", e[e.MAX_MASS_OF_TRAILER_BRAKED = 440] = "MAX_MASS_OF_TRAILER_BRAKED", e[e.MAX_MASS_OF_TRAILER_UNBRAKED = 441] = "MAX_MASS_OF_TRAILER_UNBRAKED", e[e.TRANSMISSION_TYPE = 442] = "TRANSMISSION_TYPE", e[e.TRAILER_HITCH = 443] = "TRAILER_HITCH", e[e.ACCOMPANIED_BY = 444] = "ACCOMPANIED_BY", e[e.POLICE_DISTRICT = 445] = "POLICE_DISTRICT", e[e.FIRST_ISSUE_DATE = 446] = "FIRST_ISSUE_DATE", e[e.PAYLOAD_CAPACITY = 447] = "PAYLOAD_CAPACITY", e[e.NUMBER_OF_AXLES = 448] = "NUMBER_OF_AXLES", e[e.PERMISSIBLE_AXLE_LOAD = 449] = "PERMISSIBLE_AXLE_LOAD", e[e.PRECINCT = 450] = "PRECINCT", e[e.INVITED_BY = 451] = "INVITED_BY", e[e.PURPOSE_OF_ENTRY = 452] = "PURPOSE_OF_ENTRY", e[e.SKIN_COLOR = 453] = "SKIN_COLOR", e[e.COMPLEXION = 454] = "COMPLEXION", e[e.AIRPORT_FROM = 455] = "AIRPORT_FROM", e[e.AIRPORT_TO = 456] = "AIRPORT_TO", e[e.AIRLINE_NAME = 457] = "AIRLINE_NAME", e[e.AIRLINE_NAME_FREQUENT_FLYER = 458] = "AIRLINE_NAME_FREQUENT_FLYER", e[e.LICENSE_NUMBER = 459] = "LICENSE_NUMBER", e[e.IN_TANKS = 460] = "IN_TANKS", e[e.EXCEPT_IN_TANKS = 461] = "EXCEPT_IN_TANKS", e[e.FAST_TRACK = 462] = "FAST_TRACK", e[e.OWNER = 463] = "OWNER", e[e.MRZ_STRINGS_ICAO_RFID = 464] = "MRZ_STRINGS_ICAO_RFID", e[e.NUMBER_OF_CARD_ISSUANCE = 465] = "NUMBER_OF_CARD_ISSUANCE", e[e.NUMBER_OF_CARD_ISSUANCE_CHECKSUM = 466] = "NUMBER_OF_CARD_ISSUANCE_CHECKSUM", e[e.NUMBER_OF_CARD_ISSUANCE_CHECK_DIGIT = 467] = "NUMBER_OF_CARD_ISSUANCE_CHECK_DIGIT", e[e.CENTURY_DATE_OF_BIRTH = 468] = "CENTURY_DATE_OF_BIRTH", e[e.DL_CLASS_CODE_A3_FROM = 469] = "DL_CLASS_CODE_A3_FROM", e[e.DL_CLASS_CODE_A3_TO = 470] = "DL_CLASS_CODE_A3_TO", e[e.DL_CLASS_CODE_A3_NOTES = 471] = "DL_CLASS_CODE_A3_NOTES", e[e.DL_CLASS_CODE_C2_FROM = 472] = "DL_CLASS_CODE_C2_FROM", e[e.DL_CLASS_CODE_C2_TO = 473] = "DL_CLASS_CODE_C2_TO", e[e.DL_CLASS_CODE_C2_NOTES = 474] = "DL_CLASS_CODE_C2_NOTES", e[e.DL_CLASS_CODE_B2_FROM = 475] = "DL_CLASS_CODE_B2_FROM", e[e.DL_CLASS_CODE_B2_TO = 476] = "DL_CLASS_CODE_B2_TO", e[e.DL_CLASS_CODE_B2_NOTES = 477] = "DL_CLASS_CODE_B2_NOTES", e[e.DL_CLASS_CODE_D2_FROM = 478] = "DL_CLASS_CODE_D2_FROM", e[e.DL_CLASS_CODE_D2_TO = 479] = "DL_CLASS_CODE_D2_TO", e[e.DL_CLASS_CODE_D2_NOTES = 480] = "DL_CLASS_CODE_D2_NOTES", e[e.DL_CLASS_CODE_B2E_FROM = 481] = "DL_CLASS_CODE_B2E_FROM", e[e.DL_CLASS_CODE_B2E_TO = 482] = "DL_CLASS_CODE_B2E_TO", e[e.DL_CLASS_CODE_B2E_NOTES = 483] = "DL_CLASS_CODE_B2E_NOTES", e[e.DL_CLASS_CODE_G_FROM = 484] = "DL_CLASS_CODE_G_FROM", e[e.DL_CLASS_CODE_G_TO = 485] = "DL_CLASS_CODE_G_TO", e[e.DL_CLASS_CODE_G_NOTES = 486] = "DL_CLASS_CODE_G_NOTES", e[e.DL_CLASS_CODE_J_FROM = 487] = "DL_CLASS_CODE_J_FROM", e[e.DL_CLASS_CODE_J_TO = 488] = "DL_CLASS_CODE_J_TO", e[e.DL_CLASS_CODE_J_NOTES = 489] = "DL_CLASS_CODE_J_NOTES", e[e.DL_CLASS_CODE_LC_FROM = 490] = "DL_CLASS_CODE_LC_FROM", e[e.DL_CLASS_CODE_LC_TO = 491] = "DL_CLASS_CODE_LC_TO", e[e.DL_CLASS_CODE_LC_NOTES = 492] = "DL_CLASS_CODE_LC_NOTES", e[e.BANK_CARD_NUMBER = 493] = "BANK_CARD_NUMBER", e[e.BANK_CARD_VALID_THRU = 494] = "BANK_CARD_VALID_THRU", e[e.TAX_NUMBER = 495] = "TAX_NUMBER", e[e.HEALTH_NUMBER = 496] = "HEALTH_NUMBER", e[e.GRANDFATHER_NAME = 497] = "GRANDFATHER_NAME", e[e.SELECTEE_INDICATOR = 498] = "SELECTEE_INDICATOR", e[e.MOTHER_SURNAME = 499] = "MOTHER_SURNAME", e[e.MOTHER_GIVEN_NAME = 500] = "MOTHER_GIVEN_NAME", e[e.FATHER_SURNAME = 501] = "FATHER_SURNAME", e[e.FATHER_GIVEN_NAME = 502] = "FATHER_GIVEN_NAME", e[e.MOTHER_DATE_OF_BIRTH = 503] = "MOTHER_DATE_OF_BIRTH", e[e.FATHER_DATE_OF_BIRTH = 504] = "FATHER_DATE_OF_BIRTH", e[e.MOTHER_PERSONAL_NUMBER = 505] = "MOTHER_PERSONAL_NUMBER", e[e.FATHER_PERSONAL_NUMBER = 506] = "FATHER_PERSONAL_NUMBER", e[e.MOTHER_PLACE_OF_BIRTH = 507] = "MOTHER_PLACE_OF_BIRTH", e[e.FATHER_PLACE_OF_BIRTH = 508] = "FATHER_PLACE_OF_BIRTH", e[e.MOTHER_COUNTRY_OF_BIRTH = 509] = "MOTHER_COUNTRY_OF_BIRTH", e[e.FATHER_COUNTRY_OF_BIRTH = 510] = "FATHER_COUNTRY_OF_BIRTH", e[e.DATE_FIRST_RENEWAL = 511] = "DATE_FIRST_RENEWAL", e[e.DATE_SECOND_RENEWAL = 512] = "DATE_SECOND_RENEWAL", e[e.PLACE_OF_EXAMINATION = 513] = "PLACE_OF_EXAMINATION", e[e.APPLICATION_NUMBER = 514] = "APPLICATION_NUMBER", e[e.VOUCHER_NUMBER = 515] = "VOUCHER_NUMBER", e[e.AUTHORIZATION_NUMBER = 516] = "AUTHORIZATION_NUMBER", e[e.FACULTY = 517] = "FACULTY", e[e.FORM_OF_EDUCATION = 518] = "FORM_OF_EDUCATION", e[e.DNI_NUMBER = 519] = "DNI_NUMBER", e[e.RETIREMENT_NUMBER = 520] = "RETIREMENT_NUMBER", e[e.PROFESSIONAL_ID_NUMBER = 521] = "PROFESSIONAL_ID_NUMBER", e[e.AGE_AT_ISSUE = 522] = "AGE_AT_ISSUE", e[e.YEARS_SINCE_ISSUE = 523] = "YEARS_SINCE_ISSUE", e[e.DL_CLASS_CODE_BTP_FROM = 524] = "DL_CLASS_CODE_BTP_FROM", e[e.DL_CLASS_CODE_BTP_NOTES = 525] = "DL_CLASS_CODE_BTP_NOTES", e[e.DL_CLASS_CODE_BTP_TO = 526] = "DL_CLASS_CODE_BTP_TO", e[e.DL_CLASS_CODE_C3_FROM = 527] = "DL_CLASS_CODE_C3_FROM", e[e.DL_CLASS_CODE_C3_NOTES = 528] = "DL_CLASS_CODE_C3_NOTES", e[e.DL_CLASS_CODE_C3_TO = 529] = "DL_CLASS_CODE_C3_TO", e[e.DL_CLASS_CODE_E_FROM = 530] = "DL_CLASS_CODE_E_FROM", e[e.DL_CLASS_CODE_E_NOTES = 531] = "DL_CLASS_CODE_E_NOTES", e[e.DL_CLASS_CODE_E_TO = 532] = "DL_CLASS_CODE_E_TO", e[e.DL_CLASS_CODE_F_FROM = 533] = "DL_CLASS_CODE_F_FROM", e[e.DL_CLASS_CODE_F_NOTES = 534] = "DL_CLASS_CODE_F_NOTES", e[e.DL_CLASS_CODE_F_TO = 535] = "DL_CLASS_CODE_F_TO", e[e.DL_CLASS_CODE_FA_FROM = 536] = "DL_CLASS_CODE_FA_FROM", e[e.DL_CLASS_CODE_FA_NOTES = 537] = "DL_CLASS_CODE_FA_NOTES", e[e.DL_CLASS_CODE_FA_TO = 538] = "DL_CLASS_CODE_FA_TO", e[e.DL_CLASS_CODE_FA1_FROM = 539] = "DL_CLASS_CODE_FA1_FROM", e[e.DL_CLASS_CODE_FA1_NOTES = 540] = "DL_CLASS_CODE_FA1_NOTES", e[e.DL_CLASS_CODE_FA1_TO = 541] = "DL_CLASS_CODE_FA1_TO", e[e.DL_CLASS_CODE_FB_FROM = 542] = "DL_CLASS_CODE_FB_FROM", e[e.DL_CLASS_CODE_FB_NOTES = 543] = "DL_CLASS_CODE_FB_NOTES", e[e.DL_CLASS_CODE_FB_TO = 544] = "DL_CLASS_CODE_FB_TO", e[e.DL_CLASS_CODE_G1_FROM = 545] = "DL_CLASS_CODE_G1_FROM", e[e.DL_CLASS_CODE_G1_NOTES = 546] = "DL_CLASS_CODE_G1_NOTES", e[e.DL_CLASS_CODE_G1_TO = 547] = "DL_CLASS_CODE_G1_TO", e[e.DL_CLASS_CODE_H_FROM = 548] = "DL_CLASS_CODE_H_FROM", e[e.DL_CLASS_CODE_H_NOTES = 549] = "DL_CLASS_CODE_H_NOTES", e[e.DL_CLASS_CODE_H_TO = 550] = "DL_CLASS_CODE_H_TO", e[e.DL_CLASS_CODE_I_FROM = 551] = "DL_CLASS_CODE_I_FROM", e[e.DL_CLASS_CODE_I_NOTES = 552] = "DL_CLASS_CODE_I_NOTES", e[e.DL_CLASS_CODE_I_TO = 553] = "DL_CLASS_CODE_I_TO", e[e.DL_CLASS_CODE_K_FROM = 554] = "DL_CLASS_CODE_K_FROM", e[e.DL_CLASS_CODE_K_NOTES = 555] = "DL_CLASS_CODE_K_NOTES", e[e.DL_CLASS_CODE_K_TO = 556] = "DL_CLASS_CODE_K_TO", e[e.DL_CLASS_CODE_LK_FROM = 557] = "DL_CLASS_CODE_LK_FROM", e[e.DL_CLASS_CODE_LK_NOTES = 558] = "DL_CLASS_CODE_LK_NOTES", e[e.DL_CLASS_CODE_LK_TO = 559] = "DL_CLASS_CODE_LK_TO", e[e.DL_CLASS_CODE_N_FROM = 560] = "DL_CLASS_CODE_N_FROM", e[e.DL_CLASS_CODE_N_NOTES = 561] = "DL_CLASS_CODE_N_NOTES", e[e.DL_CLASS_CODE_N_TO = 562] = "DL_CLASS_CODE_N_TO", e[e.DL_CLASS_CODE_S_FROM = 563] = "DL_CLASS_CODE_S_FROM", e[e.DL_CLASS_CODE_S_NOTES = 564] = "DL_CLASS_CODE_S_NOTES", e[e.DL_CLASS_CODE_S_TO = 565] = "DL_CLASS_CODE_S_TO", e[e.DL_CLASS_CODE_TB_FROM = 566] = "DL_CLASS_CODE_TB_FROM", e[e.DL_CLASS_CODE_TB_NOTES = 567] = "DL_CLASS_CODE_TB_NOTES", e[e.DL_CLASS_CODE_TB_TO = 568] = "DL_CLASS_CODE_TB_TO", e[e.DL_CLASS_CODE_TM_FROM = 569] = "DL_CLASS_CODE_TM_FROM", e[e.DL_CLASS_CODE_TM_NOTES = 570] = "DL_CLASS_CODE_TM_NOTES", e[e.DL_CLASS_CODE_TM_TO = 571] = "DL_CLASS_CODE_TM_TO", e[e.DL_CLASS_CODE_TR_FROM = 572] = "DL_CLASS_CODE_TR_FROM", e[e.DL_CLASS_CODE_TR_NOTES = 573] = "DL_CLASS_CODE_TR_NOTES", e[e.DL_CLASS_CODE_TR_TO = 574] = "DL_CLASS_CODE_TR_TO", e[e.DL_CLASS_CODE_TV_FROM = 575] = "DL_CLASS_CODE_TV_FROM", e[e.DL_CLASS_CODE_TV_NOTES = 576] = "DL_CLASS_CODE_TV_NOTES", e[e.DL_CLASS_CODE_TV_TO = 577] = "DL_CLASS_CODE_TV_TO", e[e.DL_CLASS_CODE_V_FROM = 578] = "DL_CLASS_CODE_V_FROM", e[e.DL_CLASS_CODE_V_NOTES = 579] = "DL_CLASS_CODE_V_NOTES", e[e.DL_CLASS_CODE_V_TO = 580] = "DL_CLASS_CODE_V_TO", e[e.DL_CLASS_CODE_W_FROM = 581] = "DL_CLASS_CODE_W_FROM", e[e.DL_CLASS_CODE_W_NOTES = 582] = "DL_CLASS_CODE_W_NOTES", e[e.DL_CLASS_CODE_W_TO = 583] = "DL_CLASS_CODE_W_TO", e[e.URL = 584] = "URL", e[e.CALIBER = 585] = "CALIBER", e[e.MODEL = 586] = "MODEL", e[e.MAKE = 587] = "MAKE", e[e.NUMBER_OF_CYLINDERS = 588] = "NUMBER_OF_CYLINDERS", e[e.SURNAME_OF_HUSBAND_AFTER_REGISTRATION = 589] = "SURNAME_OF_HUSBAND_AFTER_REGISTRATION", e[e.SURNAME_OF_WIFE_AFTER_REGISTRATION = 590] = "SURNAME_OF_WIFE_AFTER_REGISTRATION", e[e.DATE_OF_BIRTH_OF_WIFE = 591] = "DATE_OF_BIRTH_OF_WIFE", e[e.DATE_OF_BIRTH_OF_HUSBAND = 592] = "DATE_OF_BIRTH_OF_HUSBAND", e[e.CITIZENSHIP_OF_FIRST_PERSON = 593] = "CITIZENSHIP_OF_FIRST_PERSON", e[e.CITIZENSHIP_OF_SECOND_PERSON = 594] = "CITIZENSHIP_OF_SECOND_PERSON", e[e.CVV = 595] = "CVV", e[e.DATE_OF_INSURANCE_EXPIRY = 596] = "DATE_OF_INSURANCE_EXPIRY", e[e.MORTGAGE_BY = 597] = "MORTGAGE_BY", e[e.OLD_DOCUMENT_NUMBER = 598] = "OLD_DOCUMENT_NUMBER", e[e.OLD_DATE_OF_ISSUE = 599] = "OLD_DATE_OF_ISSUE", e[e.OLD_PLACE_OF_ISSUE = 600] = "OLD_PLACE_OF_ISSUE", e[e.DL_CLASS_CODE_LR_FROM = 601] = "DL_CLASS_CODE_LR_FROM", e[e.DL_CLASS_CODE_LR_TO = 602] = "DL_CLASS_CODE_LR_TO", e[e.DL_CLASS_CODE_LR_NOTES = 603] = "DL_CLASS_CODE_LR_NOTES", e[e.DL_CLASS_CODE_MR_FROM = 604] = "DL_CLASS_CODE_MR_FROM", e[e.DL_CLASS_CODE_MR_TO = 605] = "DL_CLASS_CODE_MR_TO", e[e.DL_CLASS_CODE_MR_NOTES = 606] = "DL_CLASS_CODE_MR_NOTES", e[e.DL_CLASS_CODE_HR_FROM = 607] = "DL_CLASS_CODE_HR_FROM", e[e.DL_CLASS_CODE_HR_TO = 608] = "DL_CLASS_CODE_HR_TO", e[e.DL_CLASS_CODE_HR_NOTES = 609] = "DL_CLASS_CODE_HR_NOTES", e[e.DL_CLASS_CODE_HC_FROM = 610] = "DL_CLASS_CODE_HC_FROM", e[e.DL_CLASS_CODE_HC_TO = 611] = "DL_CLASS_CODE_HC_TO", e[e.DL_CLASS_CODE_HC_NOTES = 612] = "DL_CLASS_CODE_HC_NOTES", e[e.DL_CLASS_CODE_MC_FROM = 613] = "DL_CLASS_CODE_MC_FROM", e[e.DL_CLASS_CODE_MC_TO = 614] = "DL_CLASS_CODE_MC_TO", e[e.DL_CLASS_CODE_MC_NOTES = 615] = "DL_CLASS_CODE_MC_NOTES", e[e.DL_CLASS_CODE_RE_FROM = 616] = "DL_CLASS_CODE_RE_FROM", e[e.DL_CLASS_CODE_RE_TO = 617] = "DL_CLASS_CODE_RE_TO", e[e.DL_CLASS_CODE_RE_NOTES = 618] = "DL_CLASS_CODE_RE_NOTES", e[e.DL_CLASS_CODE_R_FROM = 619] = "DL_CLASS_CODE_R_FROM", e[e.DL_CLASS_CODE_R_TO = 620] = "DL_CLASS_CODE_R_TO", e[e.DL_CLASS_CODE_R_NOTES = 621] = "DL_CLASS_CODE_R_NOTES", e[e.DL_CLASS_CODE_CA_FROM = 622] = "DL_CLASS_CODE_CA_FROM", e[e.DL_CLASS_CODE_CA_TO = 623] = "DL_CLASS_CODE_CA_TO", e[e.DL_CLASS_CODE_CA_NOTES = 624] = "DL_CLASS_CODE_CA_NOTES", e[e.CITIZENSHIP_STATUS = 625] = "CITIZENSHIP_STATUS", e[e.MILITARY_SERVICE_FROM = 626] = "MILITARY_SERVICE_FROM", e[e.MILITARY_SERVICE_TO = 627] = "MILITARY_SERVICE_TO", e[e.DL_CLASS_CODE_NT_FROM = 628] = "DL_CLASS_CODE_NT_FROM", e[e.DL_CLASS_CODE_NT_TO = 629] = "DL_CLASS_CODE_NT_TO", e[e.DL_CLASS_CODE_NT_NOTES = 630] = "DL_CLASS_CODE_NT_NOTES", e[e.DL_CLASS_CODE_TN_FROM = 631] = "DL_CLASS_CODE_TN_FROM", e[e.DL_CLASS_CODE_TN_TO = 632] = "DL_CLASS_CODE_TN_TO", e[e.DL_CLASS_CODE_TN_NOTES = 633] = "DL_CLASS_CODE_TN_NOTES", e[e.DL_CLASS_CODE_D3_FROM = 634] = "DL_CLASS_CODE_D3_FROM", e[e.DL_CLASS_CODE_D3_TO = 635] = "DL_CLASS_CODE_D3_TO", e[e.DL_CLASS_CODE_D3_NOTES = 636] = "DL_CLASS_CODE_D3_NOTES", e[e.ALT_DATE_OF_EXPIRY = 637] = "ALT_DATE_OF_EXPIRY", e[e.DL_CLASS_CODE_CD_FROM = 638] = "DL_CLASS_CODE_CD_FROM", e[e.DL_CLASS_CODE_CD_TO = 639] = "DL_CLASS_CODE_CD_TO", e[e.DL_CLASS_CODE_CD_NOTES = 640] = "DL_CLASS_CODE_CD_NOTES", e[e.ISSUER_IDENTIFICATION_NUMBER = 641] = "ISSUER_IDENTIFICATION_NUMBER", e[e.PAYMENT_PERIOD_FROM = 642] = "PAYMENT_PERIOD_FROM", e[e.PAYMENT_PERIOD_TO = 643] = "PAYMENT_PERIOD_TO", e[e.VACCINATION_CERTIFICATE_IDENTIFIER = 644] = "VACCINATION_CERTIFICATE_IDENTIFIER", e[e.FIRST_NAME = 645] = "FIRST_NAME", e[e.DATE_OF_ARRIVAL = 646] = "DATE_OF_ARRIVAL", e[e.SECOND_NAME = 647] = "SECOND_NAME", e[e.THIRD_NAME = 648] = "THIRD_NAME", e[e.FOURTH_NAME = 649] = "FOURTH_NAME", e[e.LAST_NAME = 650] = "LAST_NAME", e[e.DL_CLASS_CODE_RM_FROM = 651] = "DL_CLASS_CODE_RM_FROM", e[e.DL_CLASS_CODE_RM_NOTES = 652] = "DL_CLASS_CODE_RM_NOTES", e[e.DL_CLASS_CODE_RM_TO = 653] = "DL_CLASS_CODE_RM_TO", e[e.DL_CLASS_CODE_PW_FROM = 654] = "DL_CLASS_CODE_PW_FROM", e[e.DL_CLASS_CODE_PW_NOTES = 655] = "DL_CLASS_CODE_PW_NOTES", e[e.DL_CLASS_CODE_PW_TO = 656] = "DL_CLASS_CODE_PW_TO", e[e.DL_CLASS_CODE_EB_FROM = 657] = "DL_CLASS_CODE_EB_FROM", e[e.DL_CLASS_CODE_EB_NOTES = 658] = "DL_CLASS_CODE_EB_NOTES", e[e.DL_CLASS_CODE_EB_TO = 659] = "DL_CLASS_CODE_EB_TO", e[e.DL_CLASS_CODE_EC_FROM = 660] = "DL_CLASS_CODE_EC_FROM", e[e.DL_CLASS_CODE_EC_NOTES = 661] = "DL_CLASS_CODE_EC_NOTES", e[e.DL_CLASS_CODE_EC_TO = 662] = "DL_CLASS_CODE_EC_TO", e[e.DL_CLASS_CODE_EC1_FROM = 663] = "DL_CLASS_CODE_EC1_FROM", e[e.DL_CLASS_CODE_EC1_NOTES = 664] = "DL_CLASS_CODE_EC1_NOTES", e[e.DL_CLASS_CODE_EC1_TO = 665] = "DL_CLASS_CODE_EC1_TO", e[e.PLACE_OF_BIRTH_CITY = 666] = "PLACE_OF_BIRTH_CITY", e[e.YEAR_OF_BIRTH = 667] = "YEAR_OF_BIRTH", e[e.YEAR_OF_EXPIRY = 668] = "YEAR_OF_EXPIRY", e[e.GRANDFATHER_NAME_MATERNAL = 669] = "GRANDFATHER_NAME_MATERNAL", e[e.FIRST_SURNAME = 670] = "FIRST_SURNAME", e[e.MONTH_OF_BIRTH = 671] = "MONTH_OF_BIRTH", e[e.ADDRESS_FLOOR_NUMBER = 672] = "ADDRESS_FLOOR_NUMBER", e[e.ADDRESS_ENTRANCE = 673] = "ADDRESS_ENTRANCE", e[e.ADDRESS_BLOCK_NUMBER = 674] = "ADDRESS_BLOCK_NUMBER", e[e.ADDRESS_STREET_NUMBER = 675] = "ADDRESS_STREET_NUMBER", e[e.ADDRESS_STREET_TYPE = 676] = "ADDRESS_STREET_TYPE", e[e.ADDRESS_CITY_SECTOR = 677] = "ADDRESS_CITY_SECTOR", e[e.ADDRESS_COUNTY_TYPE = 678] = "ADDRESS_COUNTY_TYPE", e[e.ADDRESS_CITY_TYPE = 679] = "ADDRESS_CITY_TYPE", e[e.ADDRESS_BUILDING_TYPE = 680] = "ADDRESS_BUILDING_TYPE", e[e.DATE_OF_RETIREMENT = 681] = "DATE_OF_RETIREMENT", e[e.DOCUMENT_STATUS = 682] = "DOCUMENT_STATUS", e[e.SIGNATURE = 683] = "SIGNATURE", e[e.FT_UNIQUE_CERTIFICATE_IDENTIFIER = 684] = "FT_UNIQUE_CERTIFICATE_IDENTIFIER", e[e.FT_EMAIL = 685] = "FT_EMAIL", e[e.FT_DATE_OF_SPECIMEN_COLLECTION = 686] = "FT_DATE_OF_SPECIMEN_COLLECTION", e[e.FT_TYPE_OF_TESTING = 687] = "FT_TYPE_OF_TESTING", e[e.FT_RESULT_OF_TESTING = 688] = "FT_RESULT_OF_TESTING", e[e.FT_METHOD_OF_TESTING = 689] = "FT_METHOD_OF_TESTING", e[e.FT_DIGITAL_TRAVEL_AUTHORIZATION_NUMBER = 690] = "FT_DIGITAL_TRAVEL_AUTHORIZATION_NUMBER", e[e.FT_DATE_OF_FIRST_POSITIVE_TEST_RESULT = 691] = "FT_DATE_OF_FIRST_POSITIVE_TEST_RESULT", e[e.EF_CARD_ACCESS = 692] = "EF_CARD_ACCESS", e[e.SHORT_FLIGHT_NUMBER = 693] = "SHORT_FLIGHT_NUMBER", e[e.AIRLINE_CODE = 694] = "AIRLINE_CODE", e[e.FT_MVC_AGENCY = 695] = "FT_MVC_AGENCY", e[e.FT_ISSUING_STATE_CODE_ALPHA2 = 696] = "FT_ISSUING_STATE_CODE_ALPHA2", e[e.FT_NATIONALITY_CODE_ALPHA2 = 697] = "FT_NATIONALITY_CODE_ALPHA2", e[e.FT_FIRST_ISSUE_DATE_CHECK_DIGIT = 698] = "FT_FIRST_ISSUE_DATE_CHECK_DIGIT", e[e.FT_FIRST_ISSUE_DATE_CHECKSUM = 699] = "FT_FIRST_ISSUE_DATE_CHECKSUM", e))(JM || {}), eb = /* @__PURE__ */ ((e) => (e[e.NO_CHANGE = 0] = "NO_CHANGE", e[e.UPPERCASE = 1] = "UPPERCASE", e[e.LOWERCASE = 2] = "LOWERCASE", e[e.CAPITAL = 3] = "CAPITAL", e))(eb || {}), tb = /* @__PURE__ */ ((e) => (e[e.DISABLED = 0] = "DISABLED", e[e.VERIFIED = 1] = "VERIFIED", e[e.NOT_VERIFIED = 2] = "NOT_VERIFIED", e[e.COMPARE_MATCH = 3] = "COMPARE_MATCH", e[e.COMPARE_NOT_MATCH = 4] = "COMPARE_NOT_MATCH", e))(tb || {}), rb = /* @__PURE__ */ ((e) => (e[e.INVISIBLE = 0] = "INVISIBLE", e[e.VISIBLE = 1] = "VISIBLE", e[e.COLORED = 2] = "COLORED", e[e.GRAYSCALE = 4] = "GRAYSCALE", e[e.WHITE_IR_MATCHING = 8] = "WHITE_IR_MATCHING", e))(rb || {});
const nb = {
  0: "Latin",
  1078: "Afrikaans",
  1052: "Albanian",
  5121: "Arabic (Algeria)",
  15361: "Arabic (Bahrain)",
  3073: "Arabic (Egypt)",
  2049: "Arabic (Iraq)",
  11265: "Arabic (Jordan)",
  13313: "Arabic (Kuwait)",
  12289: "Arabic (Lebanon)",
  4097: "Arabic (Libya)",
  6145: "Arabic (Morocco)",
  8193: "Arabic (Oman)",
  16385: "Arabic (Qatar)",
  1025: "Arabic (Saudi Arabia)",
  10241: "Arabic (Syria)",
  7169: "Arabic (Tunisia)",
  14337: "Arabic (U.A.E.)",
  9217: "Arabic (Yemen)",
  1067: "Arabic Armenian",
  2092: "Azeri (Cyrillic)",
  1068: "Azeri (Latin)",
  1069: "Basque",
  1059: "Belarusian",
  1026: "Bulgarian",
  1027: "Catalan",
  3076: "Chinese (HongKong S.A.R.)",
  5124: "Chinese (Macao S.A.R.)",
  2052: "Chinese",
  4100: "Chinese (Singapore)",
  1028: "Chinese (Taiwan)",
  1050: "Croatian",
  1029: "Czech",
  1030: "Danish",
  1125: "Divehi",
  2067: "Dutch (Belgium)",
  1043: "Dutch (Netherlands)",
  3081: "English (Australia)",
  10249: "English (Belize)",
  4105: "English (Canada)",
  9225: "English (Caribbean)",
  6153: "English (Ireland)",
  8201: "English (Jamaica)",
  5129: "English (New Zealand)",
  13321: "English (Philippines)",
  7177: "English (South Africa)",
  11273: "English (Trinidad)",
  2057: "English (United Kingdom)",
  1033: "English (United States)",
  12297: "English (Zimbabwe)",
  1061: "Estonian",
  1080: "Faroese",
  1065: "Farsi",
  1035: "Finnish",
  2060: "French (Belgium)",
  3084: "French (Canada)",
  1036: "French (France)",
  5132: "French (Luxembourg)",
  6156: "French (Monaco)",
  4108: "French (Switzerland)",
  1071: "FYRO Macedonian",
  1110: "Galician",
  1079: "Georgian",
  3079: "German (Austria)",
  1031: "German (Germany)",
  5127: "German (Liechtenstein)",
  4103: "German (Luxembourg)",
  2055: "German (Switzerland)",
  1032: "Greek",
  1095: "Gujarati",
  1037: "Hebrew",
  1081: "Hindi (India)",
  1038: "Hungarian",
  1039: "Icelandic",
  1057: "Indonesian",
  1040: "Italian (Italy)",
  2064: "Italian (Switzerland)",
  1041: "Japanese",
  1099: "Kannada",
  1087: "Kazakh",
  1111: "Konkani",
  1042: "Korean",
  1088: "Kyrgyz (Cyrillic)",
  1062: "Latvian",
  1063: "Lithuanian",
  2110: "Malay (Brunei Darussalam)",
  1102: "Marathi",
  1086: "Malay (Malaysia)",
  1104: "Mongolian (Cyrillic)",
  1044: "Norwegian (Bokmal)",
  2068: "Norwegian (Nynorsk)",
  1045: "Polish",
  1046: "Portuguese (Brazil)",
  2070: "Portuguese (Portugal)",
  1094: "Punjabi",
  1047: "Rhaeto-Romanic",
  1048: "Romanian",
  1049: "Russian",
  1103: "Sanskrit",
  3098: "Serbian (Cyrillic)",
  2074: "Serbian (Latin)",
  1051: "Slovak",
  1060: "Slovenian",
  11274: "Spanish (Argentina)",
  16394: "Spanish (Bolivia)",
  13322: "Spanish (Chile)",
  9226: "Spanish (Colombia)",
  5130: "Spanish (Costa Rica)",
  7178: "Spanish (Dominican Republic)",
  12298: "Spanish (Ecuador)",
  17418: "Spanish (El Salvador)",
  4106: "Spanish (Guatemala)",
  18442: "Spanish (Honduras)",
  3082: "Spanish (International Sort)",
  2058: "Spanish (Mexico)",
  19466: "Spanish (Nicaragua)",
  6154: "Spanish (Panama)",
  15370: "Spanish (Paraguay)",
  10250: "Spanish (Peru)",
  20490: "Spanish (Puerto Rico)",
  1034: "Spanish (Traditional Sort)",
  14346: "Spanish (Uruguay)",
  8202: "Spanish (Venezuela)",
  1089: "Swahili",
  1053: "Swedish",
  2077: "Swedish (Finland)",
  1114: "Syriac",
  1097: "Tamil",
  1092: "Tatar",
  1098: "Telugu",
  1054: "Thai (Thailand)",
  1055: "Turkish",
  1058: "Ukrainian",
  1056: "Urdu",
  2115: "Uzbek (Cyrillic)",
  1091: "Uzbek (Latin)",
  1066: "Vietnamese",
  1064: "Tajik (Cyrillic)",
  1090: "Turkmen",
  50001: "CTC Simplified",
  50002: "CTC Traditional",
  9999: "Custom"
};
class ib {
  constructor(r) {
    this.fieldType = r.fieldType, this.fieldName = r.fieldName, this.lcid = r.lcid, this.status = r.status, this.validityStatus = r.validityStatus, this.comparisonStatus = r.comparisonStatus, this.value = r.value, this.valueList = r.valueList, this.validityList = r.validityList, this.comparisonList = r.comparisonList, this.lcidName = r.lcidName;
  }
  /**
   * This method returns value of the text field. Value encoded in UTF8.
   * Fields value obtained in the following order:
   * - if MRZ value is present, it will be taken
   * - if no MRZ, but RFID value is present, it will be taken
   * - if no MRZ, no RFID, but Barcode value is present, it will be taken
   * - if no MRZ, no RFID, no Barcode, but Visual OCR value is present, it will be taken
   *
   * @param source See {@code Source}
   * @param original Each value formatted according to input params and server settings.
   * To get original representation, set this flag to true. Date example:
   *  - original visual value - "3 January 2009"
   *  - formatted value - "03.01.2009"
   */
  getValue(r, t = !1) {
    if (!r)
      return this.value;
    const a = this.getValueBySource(r);
    return t ? a == null ? void 0 : a.originalValue : a == null ? void 0 : a.value;
  }
  /**
   * Returns validity check of all values for given source.
   * @param source See {@code Source}
   */
  sourceValidity(r) {
    for (const t of this.validityList)
      if (t.source === r)
        return t.status;
    return Mi.WAS_NOT_DONE;
  }
  /**
   * Returns value matching result for different sources.
   */
  crossSourceComparison(r, t) {
    for (const a of this.comparisonList)
      if (a.sourceLeft === r && a.sourceRight === t || a.sourceLeft === t && a.sourceRight === r)
        return a.status;
    return Mi.WAS_NOT_DONE;
  }
  getLCIDName() {
    if (this.lcid)
      return nb[this.lcid] || String(this.lcid);
  }
  getValueBySource(r) {
    for (const t of this.valueList)
      if (t.source == r)
        return t;
  }
}
class ab {
  constructor(r) {
    this.status = r.status, this.validityStatus = r.validityStatus, this.comparisonStatus = r.comparisonStatus, this.dateFormat = r.dateFormat, this.availableSourceList = r.availableSourceList, this.fieldList = r.fieldList.map((t) => new ib(t));
  }
  getField(r, t) {
    let a;
    for (const o of this.fieldList)
      if (o.fieldType == r) {
        if (t != null && o.lcid == t || t == null && o.lcid == Op.LATIN)
          return o;
        t == null && a == null && (a = o);
      }
    return a;
  }
  getFieldByName(r, t) {
    let a;
    for (const o of this.fieldList)
      if (o.fieldName == r) {
        if (t != null && o.lcid == t || t == null && o.lcid == Op.LATIN)
          return o;
        t == null && a == null && (a = o);
      }
    return a;
  }
  getFieldValue(r, t) {
    var a;
    return (a = this.getField(r, t)) == null ? void 0 : a.getValue();
  }
  getFieldValueByName(r, t) {
    var a;
    return (a = this.getFieldByName(r, t)) == null ? void 0 : a.getValue();
  }
}
var No = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/", Hs = typeof Uint8Array > "u" ? [] : new Uint8Array(256);
for (var Dl = 0; Dl < No.length; Dl++)
  Hs[No.charCodeAt(Dl)] = Dl;
var ob = function(e) {
  var r = new Uint8Array(e), t, a = r.length, o = "";
  for (t = 0; t < a; t += 3)
    o += No[r[t] >> 2], o += No[(r[t] & 3) << 4 | r[t + 1] >> 4], o += No[(r[t + 1] & 15) << 2 | r[t + 2] >> 6], o += No[r[t + 2] & 63];
  return a % 3 === 2 ? o = o.substring(0, o.length - 1) + "=" : a % 3 === 1 && (o = o.substring(0, o.length - 2) + "=="), o;
}, OD = function(e) {
  var r = e.length * 0.75, t = e.length, a, o = 0, l, c, f, p;
  e[e.length - 1] === "=" && (r--, e[e.length - 2] === "=" && r--);
  var u = new ArrayBuffer(r), h = new Uint8Array(u);
  for (a = 0; a < t; a += 4)
    l = Hs[e.charCodeAt(a)], c = Hs[e.charCodeAt(a + 1)], f = Hs[e.charCodeAt(a + 2)], p = Hs[e.charCodeAt(a + 3)], h[o++] = l << 2 | c >> 4, h[o++] = (c & 15) << 4 | f >> 2, h[o++] = (f & 3) << 6 | p & 63;
  return u;
};
class sb {
  constructor(r) {
    this.availableSourceList = r.availableSourceList, this.fieldList = r.fieldList.map((t) => new lb(t)), this.fieldCount = r.fieldCount, this.availableSourceCount = r.availableSourceCount;
  }
  getField(r) {
    for (const t of this.fieldList)
      if (t.fieldType == r)
        return t;
  }
  getFields(r) {
    return this.fieldList.filter((t) => t.fieldType == r);
  }
}
class lb {
  constructor(r) {
    this.fieldName = r.fieldName, this.fieldType = r.fieldType, this.valueList = r.valueList, this.valueCount = r.valueCount;
  }
  getValue(r, t = !1) {
    const a = r ? this.getValueBySource(r) : this.getValueBySource(xl.RFID) || this.getValueBySource(xl.VISUAL) || this.getValueBySource(xl.BARCODE);
    if (!a) return;
    const o = t && a.originalValue ? a.originalValue : a.value;
    return o ? cb(o) : void 0;
  }
  getValueBySource(r) {
    for (const t of this.valueList)
      if (t.source == r)
        return t;
  }
}
function cb(e) {
  return OD(e);
}
class ub {
  constructor(r) {
    this.List = r.List, this.Result = r.Result, this.Type = r.Type;
  }
}
class fb {
  constructor(r) {
    this.List = r.List, this.Result = r.Result, this.Type = r.Type;
  }
  checksByElement(r) {
    const t = [];
    for (const a of this.List)
      a.ElementType === r && t.push(a);
    return t;
  }
}
class db {
  constructor(r) {
    this.List = r.List, this.Result = r.Result, this.Type = r.Type;
  }
}
class pb {
  constructor(r) {
    this.List = r.List, this.Result = r.Result, this.Type = r.Type;
  }
}
class hb {
  constructor(r) {
    this.List = r.List, this.Result = r.Result, this.Type = r.Type;
  }
  checksByElement(r) {
    const t = [];
    for (const a of this.List)
      a.ElementType === r && t.push(a);
    return t;
  }
}
class VS {
  constructor(r, t) {
    this.List = r.List, this.page_idx = t, this.Count = r.Count;
  }
  uvLuminescenceChecks() {
    return this.securityFeatureOrUndefined(dr.UV_LUMINESCENCE);
  }
  irB900Checks() {
    return this.securityFeatureOrUndefined(dr.IR_B900);
  }
  imagePatternChecks() {
    return this.identOrUndefined(dr.IMAGE_PATTERN);
  }
  axialProtectionChecks() {
    return this.securityFeatureOrUndefined(dr.AXIAL_PROTECTION);
  }
  uvFiberChecks() {
    return this.fiberOrUndefined(dr.UV_FIBERS);
  }
  irVisibilityChecks() {
    return this.identOrUndefined(dr.IR_VISIBILITY);
  }
  ocrSecurityTextChecks() {
    return this.ocrSecurityTextOrUndefined(dr.OCR_SECURITY_TEXT);
  }
  ipiChecks() {
    return this.imageIdentOrUndefined(dr.IPI);
  }
  embedImageChecks() {
    return this.securityFeatureOrUndefined(dr.PHOTO_EMBED_TYPE);
  }
  hologramsChecks() {
    return this.securityFeatureOrUndefined(dr.HOLOGRAMS);
  }
  imageAreaChecks() {
    return this.securityFeatureOrUndefined(dr.PHOTO_AREA);
  }
  portraitComparisonChecks() {
    return this.identOrUndefined(dr.PORTRAIT_COMPARISON);
  }
  barcodeFormatCheckChecks() {
    return this.securityFeatureOrUndefined(dr.BARCODE_FORMAT_CHECK);
  }
  kinegramChecks() {
    return this.identOrUndefined(dr.KINEGRAM);
  }
  letterScreenChecks() {
    return this.identOrUndefined(dr.LETTER_SCREEN);
  }
  hologramDetectionChecks() {
    return this.identOrUndefined(dr.HOLOGRAM_DETECTION);
  }
  mrzChecks() {
    return this.securityFeatureOrUndefined(dr.EXTENDED_MRZ_CHECK);
  }
  livenessChecks() {
    return this.identOrUndefined(dr.LIVENESS);
  }
  resultByType(r) {
    for (const t of this.List)
      if (t.Type == r)
        return t;
  }
  fiberOrUndefined(r) {
    const t = this.resultByType(r);
    if (t)
      return new ub(t);
  }
  identOrUndefined(r) {
    const t = this.resultByType(r);
    if (t)
      return new fb(t);
  }
  imageIdentOrUndefined(r) {
    const t = this.resultByType(r);
    if (t)
      return new db(t);
  }
  ocrSecurityTextOrUndefined(r) {
    const t = this.resultByType(r);
    if (t)
      return new pb(t);
  }
  securityFeatureOrUndefined(r) {
    const t = this.resultByType(r);
    if (t)
      return new hb(t);
  }
}
function Zo(e) {
  let r = e.length;
  for (; --r >= 0; )
    e[r] = 0;
}
const mb = 3, _b = 258, yD = 29, Eb = 256, Cb = Eb + 1 + yD, ND = 30, Sb = 512, Ib = new Array((Cb + 2) * 2);
Zo(Ib);
const vb = new Array(ND * 2);
Zo(vb);
const gb = new Array(Sb);
Zo(gb);
const Db = new Array(_b - mb + 1);
Zo(Db);
const Rb = new Array(yD);
Zo(Rb);
const Ab = new Array(ND);
Zo(Ab);
const Tb = (e, r, t, a) => {
  let o = e & 65535 | 0, l = e >>> 16 & 65535 | 0, c = 0;
  for (; t !== 0; ) {
    c = t > 2e3 ? 2e3 : t, t -= c;
    do
      o = o + r[a++] | 0, l = l + o | 0;
    while (--c);
    o %= 65521, l %= 65521;
  }
  return o | l << 16 | 0;
};
var Np = Tb;
const Ob = () => {
  let e, r = [];
  for (var t = 0; t < 256; t++) {
    e = t;
    for (var a = 0; a < 8; a++)
      e = e & 1 ? 3988292384 ^ e >>> 1 : e >>> 1;
    r[t] = e;
  }
  return r;
}, yb = new Uint32Array(Ob()), Nb = (e, r, t, a) => {
  const o = yb, l = a + t;
  e ^= -1;
  for (let c = a; c < l; c++)
    e = e >>> 8 ^ o[(e ^ r[c]) & 255];
  return e ^ -1;
};
var li = Nb, Lp = {
  2: "need dictionary",
  /* Z_NEED_DICT       2  */
  1: "stream end",
  /* Z_STREAM_END      1  */
  0: "",
  /* Z_OK              0  */
  "-1": "file error",
  /* Z_ERRNO         (-1) */
  "-2": "stream error",
  /* Z_STREAM_ERROR  (-2) */
  "-3": "data error",
  /* Z_DATA_ERROR    (-3) */
  "-4": "insufficient memory",
  /* Z_MEM_ERROR     (-4) */
  "-5": "buffer error",
  /* Z_BUF_ERROR     (-5) */
  "-6": "incompatible version"
  /* Z_VERSION_ERROR (-6) */
}, LD = {
  /* Allowed flush values; see deflate() and inflate() below for details */
  Z_NO_FLUSH: 0,
  Z_FINISH: 4,
  Z_BLOCK: 5,
  Z_TREES: 6,
  /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */
  Z_OK: 0,
  Z_STREAM_END: 1,
  Z_NEED_DICT: 2,
  Z_STREAM_ERROR: -2,
  Z_DATA_ERROR: -3,
  Z_MEM_ERROR: -4,
  Z_BUF_ERROR: -5,
  /* The deflate compression method */
  Z_DEFLATED: 8
  //Z_NULL:                 null // Use -1 or null inline, depending on var type
};
const Lb = (e, r) => Object.prototype.hasOwnProperty.call(e, r);
var Mb = function(e) {
  const r = Array.prototype.slice.call(arguments, 1);
  for (; r.length; ) {
    const t = r.shift();
    if (t) {
      if (typeof t != "object")
        throw new TypeError(t + "must be non-object");
      for (const a in t)
        Lb(t, a) && (e[a] = t[a]);
    }
  }
  return e;
}, bb = (e) => {
  let r = 0;
  for (let a = 0, o = e.length; a < o; a++)
    r += e[a].length;
  const t = new Uint8Array(r);
  for (let a = 0, o = 0, l = e.length; a < l; a++) {
    let c = e[a];
    t.set(c, o), o += c.length;
  }
  return t;
}, MD = {
  assign: Mb,
  flattenChunks: bb
};
let bD = !0;
try {
  String.fromCharCode.apply(null, new Uint8Array(1));
} catch (e) {
  bD = !1;
}
const Bs = new Uint8Array(256);
for (let e = 0; e < 256; e++)
  Bs[e] = e >= 252 ? 6 : e >= 248 ? 5 : e >= 240 ? 4 : e >= 224 ? 3 : e >= 192 ? 2 : 1;
Bs[254] = Bs[254] = 1;
var Pb = (e) => {
  if (typeof TextEncoder == "function" && TextEncoder.prototype.encode)
    return new TextEncoder().encode(e);
  let r, t, a, o, l, c = e.length, f = 0;
  for (o = 0; o < c; o++)
    t = e.charCodeAt(o), (t & 64512) === 55296 && o + 1 < c && (a = e.charCodeAt(o + 1), (a & 64512) === 56320 && (t = 65536 + (t - 55296 << 10) + (a - 56320), o++)), f += t < 128 ? 1 : t < 2048 ? 2 : t < 65536 ? 3 : 4;
  for (r = new Uint8Array(f), l = 0, o = 0; l < f; o++)
    t = e.charCodeAt(o), (t & 64512) === 55296 && o + 1 < c && (a = e.charCodeAt(o + 1), (a & 64512) === 56320 && (t = 65536 + (t - 55296 << 10) + (a - 56320), o++)), t < 128 ? r[l++] = t : t < 2048 ? (r[l++] = 192 | t >>> 6, r[l++] = 128 | t & 63) : t < 65536 ? (r[l++] = 224 | t >>> 12, r[l++] = 128 | t >>> 6 & 63, r[l++] = 128 | t & 63) : (r[l++] = 240 | t >>> 18, r[l++] = 128 | t >>> 12 & 63, r[l++] = 128 | t >>> 6 & 63, r[l++] = 128 | t & 63);
  return r;
};
const wb = (e, r) => {
  if (r < 65534 && e.subarray && bD)
    return String.fromCharCode.apply(null, e.length === r ? e : e.subarray(0, r));
  let t = "";
  for (let a = 0; a < r; a++)
    t += String.fromCharCode(e[a]);
  return t;
};
var Hb = (e, r) => {
  const t = r || e.length;
  if (typeof TextDecoder == "function" && TextDecoder.prototype.decode)
    return new TextDecoder().decode(e.subarray(0, r));
  let a, o;
  const l = new Array(t * 2);
  for (o = 0, a = 0; a < t; ) {
    let c = e[a++];
    if (c < 128) {
      l[o++] = c;
      continue;
    }
    let f = Bs[c];
    if (f > 4) {
      l[o++] = 65533, a += f - 1;
      continue;
    }
    for (c &= f === 2 ? 31 : f === 3 ? 15 : 7; f > 1 && a < t; )
      c = c << 6 | e[a++] & 63, f--;
    if (f > 1) {
      l[o++] = 65533;
      continue;
    }
    c < 65536 ? l[o++] = c : (c -= 65536, l[o++] = 55296 | c >> 10 & 1023, l[o++] = 56320 | c & 1023);
  }
  return wb(l, o);
}, Vb = (e, r) => {
  r = r || e.length, r > e.length && (r = e.length);
  let t = r - 1;
  for (; t >= 0 && (e[t] & 192) === 128; )
    t--;
  return t < 0 || t === 0 ? r : t + Bs[e[t]] > r ? t : r;
}, Mp = {
  string2buf: Pb,
  buf2string: Hb,
  utf8border: Vb
};
function kb() {
  this.input = null, this.next_in = 0, this.avail_in = 0, this.total_in = 0, this.output = null, this.next_out = 0, this.avail_out = 0, this.total_out = 0, this.msg = "", this.state = null, this.data_type = 2, this.adler = 0;
}
var Fb = kb;
const Rl = 16209, xb = 16191;
var Ub = function(e, r) {
  let t, a, o, l, c, f, p, u, h, C, E, _, S, v, g, O, R, D, T, L, P, M, k, H;
  const w = e.state;
  t = e.next_in, k = e.input, a = t + (e.avail_in - 5), o = e.next_out, H = e.output, l = o - (r - e.avail_out), c = o + (e.avail_out - 257), f = w.dmax, p = w.wsize, u = w.whave, h = w.wnext, C = w.window, E = w.hold, _ = w.bits, S = w.lencode, v = w.distcode, g = (1 << w.lenbits) - 1, O = (1 << w.distbits) - 1;
  e:
    do {
      _ < 15 && (E += k[t++] << _, _ += 8, E += k[t++] << _, _ += 8), R = S[E & g];
      t:
        for (; ; ) {
          if (D = R >>> 24, E >>>= D, _ -= D, D = R >>> 16 & 255, D === 0)
            H[o++] = R & 65535;
          else if (D & 16) {
            T = R & 65535, D &= 15, D && (_ < D && (E += k[t++] << _, _ += 8), T += E & (1 << D) - 1, E >>>= D, _ -= D), _ < 15 && (E += k[t++] << _, _ += 8, E += k[t++] << _, _ += 8), R = v[E & O];
            r:
              for (; ; ) {
                if (D = R >>> 24, E >>>= D, _ -= D, D = R >>> 16 & 255, D & 16) {
                  if (L = R & 65535, D &= 15, _ < D && (E += k[t++] << _, _ += 8, _ < D && (E += k[t++] << _, _ += 8)), L += E & (1 << D) - 1, L > f) {
                    e.msg = "invalid distance too far back", w.mode = Rl;
                    break e;
                  }
                  if (E >>>= D, _ -= D, D = o - l, L > D) {
                    if (D = L - D, D > u && w.sane) {
                      e.msg = "invalid distance too far back", w.mode = Rl;
                      break e;
                    }
                    if (P = 0, M = C, h === 0) {
                      if (P += p - D, D < T) {
                        T -= D;
                        do
                          H[o++] = C[P++];
                        while (--D);
                        P = o - L, M = H;
                      }
                    } else if (h < D) {
                      if (P += p + h - D, D -= h, D < T) {
                        T -= D;
                        do
                          H[o++] = C[P++];
                        while (--D);
                        if (P = 0, h < T) {
                          D = h, T -= D;
                          do
                            H[o++] = C[P++];
                          while (--D);
                          P = o - L, M = H;
                        }
                      }
                    } else if (P += h - D, D < T) {
                      T -= D;
                      do
                        H[o++] = C[P++];
                      while (--D);
                      P = o - L, M = H;
                    }
                    for (; T > 2; )
                      H[o++] = M[P++], H[o++] = M[P++], H[o++] = M[P++], T -= 3;
                    T && (H[o++] = M[P++], T > 1 && (H[o++] = M[P++]));
                  } else {
                    P = o - L;
                    do
                      H[o++] = H[P++], H[o++] = H[P++], H[o++] = H[P++], T -= 3;
                    while (T > 2);
                    T && (H[o++] = H[P++], T > 1 && (H[o++] = H[P++]));
                  }
                } else if ((D & 64) === 0) {
                  R = v[(R & 65535) + (E & (1 << D) - 1)];
                  continue r;
                } else {
                  e.msg = "invalid distance code", w.mode = Rl;
                  break e;
                }
                break;
              }
          } else if ((D & 64) === 0) {
            R = S[(R & 65535) + (E & (1 << D) - 1)];
            continue t;
          } else if (D & 32) {
            w.mode = xb;
            break e;
          } else {
            e.msg = "invalid literal/length code", w.mode = Rl;
            break e;
          }
          break;
        }
    } while (t < a && o < c);
  T = _ >> 3, t -= T, _ -= T << 3, E &= (1 << _) - 1, e.next_in = t, e.next_out = o, e.avail_in = t < a ? 5 + (a - t) : 5 - (t - a), e.avail_out = o < c ? 257 + (c - o) : 257 - (o - c), w.hold = E, w.bits = _;
};
const Oo = 15, kS = 852, FS = 592, xS = 0, Zf = 1, US = 2, Bb = new Uint16Array([
  /* Length codes 257..285 base */
  3,
  4,
  5,
  6,
  7,
  8,
  9,
  10,
  11,
  13,
  15,
  17,
  19,
  23,
  27,
  31,
  35,
  43,
  51,
  59,
  67,
  83,
  99,
  115,
  131,
  163,
  195,
  227,
  258,
  0,
  0
]), $b = new Uint8Array([
  /* Length codes 257..285 extra */
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  16,
  17,
  17,
  17,
  17,
  18,
  18,
  18,
  18,
  19,
  19,
  19,
  19,
  20,
  20,
  20,
  20,
  21,
  21,
  21,
  21,
  16,
  72,
  78
]), Gb = new Uint16Array([
  /* Distance codes 0..29 base */
  1,
  2,
  3,
  4,
  5,
  7,
  9,
  13,
  17,
  25,
  33,
  49,
  65,
  97,
  129,
  193,
  257,
  385,
  513,
  769,
  1025,
  1537,
  2049,
  3073,
  4097,
  6145,
  8193,
  12289,
  16385,
  24577,
  0,
  0
]), Zb = new Uint8Array([
  /* Distance codes 0..29 extra */
  16,
  16,
  16,
  16,
  17,
  17,
  18,
  18,
  19,
  19,
  20,
  20,
  21,
  21,
  22,
  22,
  23,
  23,
  24,
  24,
  25,
  25,
  26,
  26,
  27,
  27,
  28,
  28,
  29,
  29,
  64,
  64
]), jb = (e, r, t, a, o, l, c, f) => {
  const p = f.bits;
  let u = 0, h = 0, C = 0, E = 0, _ = 0, S = 0, v = 0, g = 0, O = 0, R = 0, D, T, L, P, M, k = null, H;
  const w = new Uint16Array(Oo + 1), $ = new Uint16Array(Oo + 1);
  let B = null, Y, j, ie;
  for (u = 0; u <= Oo; u++)
    w[u] = 0;
  for (h = 0; h < a; h++)
    w[r[t + h]]++;
  for (_ = p, E = Oo; E >= 1 && w[E] === 0; E--)
    ;
  if (_ > E && (_ = E), E === 0)
    return o[l++] = 1 << 24 | 64 << 16 | 0, o[l++] = 1 << 24 | 64 << 16 | 0, f.bits = 1, 0;
  for (C = 1; C < E && w[C] === 0; C++)
    ;
  for (_ < C && (_ = C), g = 1, u = 1; u <= Oo; u++)
    if (g <<= 1, g -= w[u], g < 0)
      return -1;
  if (g > 0 && (e === xS || E !== 1))
    return -1;
  for ($[1] = 0, u = 1; u < Oo; u++)
    $[u + 1] = $[u] + w[u];
  for (h = 0; h < a; h++)
    r[t + h] !== 0 && (c[$[r[t + h]]++] = h);
  if (e === xS ? (k = B = c, H = 20) : e === Zf ? (k = Bb, B = $b, H = 257) : (k = Gb, B = Zb, H = 0), R = 0, h = 0, u = C, M = l, S = _, v = 0, L = -1, O = 1 << _, P = O - 1, e === Zf && O > kS || e === US && O > FS)
    return 1;
  for (; ; ) {
    Y = u - v, c[h] + 1 < H ? (j = 0, ie = c[h]) : c[h] >= H ? (j = B[c[h] - H], ie = k[c[h] - H]) : (j = 96, ie = 0), D = 1 << u - v, T = 1 << S, C = T;
    do
      T -= D, o[M + (R >> v) + T] = Y << 24 | j << 16 | ie | 0;
    while (T !== 0);
    for (D = 1 << u - 1; R & D; )
      D >>= 1;
    if (D !== 0 ? (R &= D - 1, R += D) : R = 0, h++, --w[u] === 0) {
      if (u === E)
        break;
      u = r[t + c[h]];
    }
    if (u > _ && (R & P) !== L) {
      for (v === 0 && (v = _), M += C, S = u - v, g = 1 << S; S + v < E && (g -= w[S + v], !(g <= 0)); )
        S++, g <<= 1;
      if (O += 1 << S, e === Zf && O > kS || e === US && O > FS)
        return 1;
      L = R & P, o[L] = _ << 24 | S << 16 | M - l | 0;
    }
  }
  return R !== 0 && (o[M + R] = u - v << 24 | 64 << 16 | 0), f.bits = _, 0;
};
var Fs = jb;
const zb = 0, PD = 1, wD = 2, {
  Z_FINISH: BS,
  Z_BLOCK: qb,
  Z_TREES: Al,
  Z_OK: ka,
  Z_STREAM_END: Wb,
  Z_NEED_DICT: Yb,
  Z_STREAM_ERROR: zn,
  Z_DATA_ERROR: HD,
  Z_MEM_ERROR: VD,
  Z_BUF_ERROR: Kb,
  Z_DEFLATED: $S
} = LD, _c = 16180, GS = 16181, ZS = 16182, jS = 16183, zS = 16184, qS = 16185, WS = 16186, YS = 16187, KS = 16188, XS = 16189, Yl = 16190, Ri = 16191, jf = 16192, QS = 16193, zf = 16194, JS = 16195, eI = 16196, tI = 16197, rI = 16198, Tl = 16199, Ol = 16200, nI = 16201, iI = 16202, aI = 16203, oI = 16204, sI = 16205, qf = 16206, lI = 16207, cI = 16208, Zt = 16209, kD = 16210, FD = 16211, Xb = 852, Qb = 592, Jb = 15, eP = Jb, uI = (e) => (e >>> 24 & 255) + (e >>> 8 & 65280) + ((e & 65280) << 8) + ((e & 255) << 24);
function tP() {
  this.strm = null, this.mode = 0, this.last = !1, this.wrap = 0, this.havedict = !1, this.flags = 0, this.dmax = 0, this.check = 0, this.total = 0, this.head = null, this.wbits = 0, this.wsize = 0, this.whave = 0, this.wnext = 0, this.window = null, this.hold = 0, this.bits = 0, this.length = 0, this.offset = 0, this.extra = 0, this.lencode = null, this.distcode = null, this.lenbits = 0, this.distbits = 0, this.ncode = 0, this.nlen = 0, this.ndist = 0, this.have = 0, this.next = null, this.lens = new Uint16Array(320), this.work = new Uint16Array(288), this.lendyn = null, this.distdyn = null, this.sane = 0, this.back = 0, this.was = 0;
}
const ja = (e) => {
  if (!e)
    return 1;
  const r = e.state;
  return !r || r.strm !== e || r.mode < _c || r.mode > FD ? 1 : 0;
}, xD = (e) => {
  if (ja(e))
    return zn;
  const r = e.state;
  return e.total_in = e.total_out = r.total = 0, e.msg = "", r.wrap && (e.adler = r.wrap & 1), r.mode = _c, r.last = 0, r.havedict = 0, r.flags = -1, r.dmax = 32768, r.head = null, r.hold = 0, r.bits = 0, r.lencode = r.lendyn = new Int32Array(Xb), r.distcode = r.distdyn = new Int32Array(Qb), r.sane = 1, r.back = -1, ka;
}, UD = (e) => {
  if (ja(e))
    return zn;
  const r = e.state;
  return r.wsize = 0, r.whave = 0, r.wnext = 0, xD(e);
}, BD = (e, r) => {
  let t;
  if (ja(e))
    return zn;
  const a = e.state;
  return r < 0 ? (t = 0, r = -r) : (t = (r >> 4) + 5, r < 48 && (r &= 15)), r && (r < 8 || r > 15) ? zn : (a.window !== null && a.wbits !== r && (a.window = null), a.wrap = t, a.wbits = r, UD(e));
}, $D = (e, r) => {
  if (!e)
    return zn;
  const t = new tP();
  e.state = t, t.strm = e, t.window = null, t.mode = _c;
  const a = BD(e, r);
  return a !== ka && (e.state = null), a;
}, rP = (e) => $D(e, eP);
let fI = !0, Wf, Yf;
const nP = (e) => {
  if (fI) {
    Wf = new Int32Array(512), Yf = new Int32Array(32);
    let r = 0;
    for (; r < 144; )
      e.lens[r++] = 8;
    for (; r < 256; )
      e.lens[r++] = 9;
    for (; r < 280; )
      e.lens[r++] = 7;
    for (; r < 288; )
      e.lens[r++] = 8;
    for (Fs(PD, e.lens, 0, 288, Wf, 0, e.work, { bits: 9 }), r = 0; r < 32; )
      e.lens[r++] = 5;
    Fs(wD, e.lens, 0, 32, Yf, 0, e.work, { bits: 5 }), fI = !1;
  }
  e.lencode = Wf, e.lenbits = 9, e.distcode = Yf, e.distbits = 5;
}, GD = (e, r, t, a) => {
  let o;
  const l = e.state;
  return l.window === null && (l.wsize = 1 << l.wbits, l.wnext = 0, l.whave = 0, l.window = new Uint8Array(l.wsize)), a >= l.wsize ? (l.window.set(r.subarray(t - l.wsize, t), 0), l.wnext = 0, l.whave = l.wsize) : (o = l.wsize - l.wnext, o > a && (o = a), l.window.set(r.subarray(t - a, t - a + o), l.wnext), a -= o, a ? (l.window.set(r.subarray(t - a, t), 0), l.wnext = a, l.whave = l.wsize) : (l.wnext += o, l.wnext === l.wsize && (l.wnext = 0), l.whave < l.wsize && (l.whave += o))), 0;
}, iP = (e, r) => {
  let t, a, o, l, c, f, p, u, h, C, E, _, S, v, g = 0, O, R, D, T, L, P, M, k;
  const H = new Uint8Array(4);
  let w, $;
  const B = (
    /* permutation of code lengths */
    new Uint8Array([16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15])
  );
  if (ja(e) || !e.output || !e.input && e.avail_in !== 0)
    return zn;
  t = e.state, t.mode === Ri && (t.mode = jf), c = e.next_out, o = e.output, p = e.avail_out, l = e.next_in, a = e.input, f = e.avail_in, u = t.hold, h = t.bits, C = f, E = p, k = ka;
  e:
    for (; ; )
      switch (t.mode) {
        case _c:
          if (t.wrap === 0) {
            t.mode = jf;
            break;
          }
          for (; h < 16; ) {
            if (f === 0)
              break e;
            f--, u += a[l++] << h, h += 8;
          }
          if (t.wrap & 2 && u === 35615) {
            t.wbits === 0 && (t.wbits = 15), t.check = 0, H[0] = u & 255, H[1] = u >>> 8 & 255, t.check = li(t.check, H, 2, 0), u = 0, h = 0, t.mode = GS;
            break;
          }
          if (t.head && (t.head.done = !1), !(t.wrap & 1) || /* check if zlib header allowed */
          (((u & 255) << 8) + (u >> 8)) % 31) {
            e.msg = "incorrect header check", t.mode = Zt;
            break;
          }
          if ((u & 15) !== $S) {
            e.msg = "unknown compression method", t.mode = Zt;
            break;
          }
          if (u >>>= 4, h -= 4, M = (u & 15) + 8, t.wbits === 0 && (t.wbits = M), M > 15 || M > t.wbits) {
            e.msg = "invalid window size", t.mode = Zt;
            break;
          }
          t.dmax = 1 << t.wbits, t.flags = 0, e.adler = t.check = 1, t.mode = u & 512 ? XS : Ri, u = 0, h = 0;
          break;
        case GS:
          for (; h < 16; ) {
            if (f === 0)
              break e;
            f--, u += a[l++] << h, h += 8;
          }
          if (t.flags = u, (t.flags & 255) !== $S) {
            e.msg = "unknown compression method", t.mode = Zt;
            break;
          }
          if (t.flags & 57344) {
            e.msg = "unknown header flags set", t.mode = Zt;
            break;
          }
          t.head && (t.head.text = u >> 8 & 1), t.flags & 512 && t.wrap & 4 && (H[0] = u & 255, H[1] = u >>> 8 & 255, t.check = li(t.check, H, 2, 0)), u = 0, h = 0, t.mode = ZS;
        /* falls through */
        case ZS:
          for (; h < 32; ) {
            if (f === 0)
              break e;
            f--, u += a[l++] << h, h += 8;
          }
          t.head && (t.head.time = u), t.flags & 512 && t.wrap & 4 && (H[0] = u & 255, H[1] = u >>> 8 & 255, H[2] = u >>> 16 & 255, H[3] = u >>> 24 & 255, t.check = li(t.check, H, 4, 0)), u = 0, h = 0, t.mode = jS;
        /* falls through */
        case jS:
          for (; h < 16; ) {
            if (f === 0)
              break e;
            f--, u += a[l++] << h, h += 8;
          }
          t.head && (t.head.xflags = u & 255, t.head.os = u >> 8), t.flags & 512 && t.wrap & 4 && (H[0] = u & 255, H[1] = u >>> 8 & 255, t.check = li(t.check, H, 2, 0)), u = 0, h = 0, t.mode = zS;
        /* falls through */
        case zS:
          if (t.flags & 1024) {
            for (; h < 16; ) {
              if (f === 0)
                break e;
              f--, u += a[l++] << h, h += 8;
            }
            t.length = u, t.head && (t.head.extra_len = u), t.flags & 512 && t.wrap & 4 && (H[0] = u & 255, H[1] = u >>> 8 & 255, t.check = li(t.check, H, 2, 0)), u = 0, h = 0;
          } else t.head && (t.head.extra = null);
          t.mode = qS;
        /* falls through */
        case qS:
          if (t.flags & 1024 && (_ = t.length, _ > f && (_ = f), _ && (t.head && (M = t.head.extra_len - t.length, t.head.extra || (t.head.extra = new Uint8Array(t.head.extra_len)), t.head.extra.set(
            a.subarray(
              l,
              // extra field is limited to 65536 bytes
              // - no need for additional size check
              l + _
            ),
            /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
            M
          )), t.flags & 512 && t.wrap & 4 && (t.check = li(t.check, a, _, l)), f -= _, l += _, t.length -= _), t.length))
            break e;
          t.length = 0, t.mode = WS;
        /* falls through */
        case WS:
          if (t.flags & 2048) {
            if (f === 0)
              break e;
            _ = 0;
            do
              M = a[l + _++], t.head && M && t.length < 65536 && (t.head.name += String.fromCharCode(M));
            while (M && _ < f);
            if (t.flags & 512 && t.wrap & 4 && (t.check = li(t.check, a, _, l)), f -= _, l += _, M)
              break e;
          } else t.head && (t.head.name = null);
          t.length = 0, t.mode = YS;
        /* falls through */
        case YS:
          if (t.flags & 4096) {
            if (f === 0)
              break e;
            _ = 0;
            do
              M = a[l + _++], t.head && M && t.length < 65536 && (t.head.comment += String.fromCharCode(M));
            while (M && _ < f);
            if (t.flags & 512 && t.wrap & 4 && (t.check = li(t.check, a, _, l)), f -= _, l += _, M)
              break e;
          } else t.head && (t.head.comment = null);
          t.mode = KS;
        /* falls through */
        case KS:
          if (t.flags & 512) {
            for (; h < 16; ) {
              if (f === 0)
                break e;
              f--, u += a[l++] << h, h += 8;
            }
            if (t.wrap & 4 && u !== (t.check & 65535)) {
              e.msg = "header crc mismatch", t.mode = Zt;
              break;
            }
            u = 0, h = 0;
          }
          t.head && (t.head.hcrc = t.flags >> 9 & 1, t.head.done = !0), e.adler = t.check = 0, t.mode = Ri;
          break;
        case XS:
          for (; h < 32; ) {
            if (f === 0)
              break e;
            f--, u += a[l++] << h, h += 8;
          }
          e.adler = t.check = uI(u), u = 0, h = 0, t.mode = Yl;
        /* falls through */
        case Yl:
          if (t.havedict === 0)
            return e.next_out = c, e.avail_out = p, e.next_in = l, e.avail_in = f, t.hold = u, t.bits = h, Yb;
          e.adler = t.check = 1, t.mode = Ri;
        /* falls through */
        case Ri:
          if (r === qb || r === Al)
            break e;
        /* falls through */
        case jf:
          if (t.last) {
            u >>>= h & 7, h -= h & 7, t.mode = qf;
            break;
          }
          for (; h < 3; ) {
            if (f === 0)
              break e;
            f--, u += a[l++] << h, h += 8;
          }
          switch (t.last = u & 1, u >>>= 1, h -= 1, u & 3) {
            case 0:
              t.mode = QS;
              break;
            case 1:
              if (nP(t), t.mode = Tl, r === Al) {
                u >>>= 2, h -= 2;
                break e;
              }
              break;
            case 2:
              t.mode = eI;
              break;
            case 3:
              e.msg = "invalid block type", t.mode = Zt;
          }
          u >>>= 2, h -= 2;
          break;
        case QS:
          for (u >>>= h & 7, h -= h & 7; h < 32; ) {
            if (f === 0)
              break e;
            f--, u += a[l++] << h, h += 8;
          }
          if ((u & 65535) !== (u >>> 16 ^ 65535)) {
            e.msg = "invalid stored block lengths", t.mode = Zt;
            break;
          }
          if (t.length = u & 65535, u = 0, h = 0, t.mode = zf, r === Al)
            break e;
        /* falls through */
        case zf:
          t.mode = JS;
        /* falls through */
        case JS:
          if (_ = t.length, _) {
            if (_ > f && (_ = f), _ > p && (_ = p), _ === 0)
              break e;
            o.set(a.subarray(l, l + _), c), f -= _, l += _, p -= _, c += _, t.length -= _;
            break;
          }
          t.mode = Ri;
          break;
        case eI:
          for (; h < 14; ) {
            if (f === 0)
              break e;
            f--, u += a[l++] << h, h += 8;
          }
          if (t.nlen = (u & 31) + 257, u >>>= 5, h -= 5, t.ndist = (u & 31) + 1, u >>>= 5, h -= 5, t.ncode = (u & 15) + 4, u >>>= 4, h -= 4, t.nlen > 286 || t.ndist > 30) {
            e.msg = "too many length or distance symbols", t.mode = Zt;
            break;
          }
          t.have = 0, t.mode = tI;
        /* falls through */
        case tI:
          for (; t.have < t.ncode; ) {
            for (; h < 3; ) {
              if (f === 0)
                break e;
              f--, u += a[l++] << h, h += 8;
            }
            t.lens[B[t.have++]] = u & 7, u >>>= 3, h -= 3;
          }
          for (; t.have < 19; )
            t.lens[B[t.have++]] = 0;
          if (t.lencode = t.lendyn, t.lenbits = 7, w = { bits: t.lenbits }, k = Fs(zb, t.lens, 0, 19, t.lencode, 0, t.work, w), t.lenbits = w.bits, k) {
            e.msg = "invalid code lengths set", t.mode = Zt;
            break;
          }
          t.have = 0, t.mode = rI;
        /* falls through */
        case rI:
          for (; t.have < t.nlen + t.ndist; ) {
            for (; g = t.lencode[u & (1 << t.lenbits) - 1], O = g >>> 24, R = g >>> 16 & 255, D = g & 65535, !(O <= h); ) {
              if (f === 0)
                break e;
              f--, u += a[l++] << h, h += 8;
            }
            if (D < 16)
              u >>>= O, h -= O, t.lens[t.have++] = D;
            else {
              if (D === 16) {
                for ($ = O + 2; h < $; ) {
                  if (f === 0)
                    break e;
                  f--, u += a[l++] << h, h += 8;
                }
                if (u >>>= O, h -= O, t.have === 0) {
                  e.msg = "invalid bit length repeat", t.mode = Zt;
                  break;
                }
                M = t.lens[t.have - 1], _ = 3 + (u & 3), u >>>= 2, h -= 2;
              } else if (D === 17) {
                for ($ = O + 3; h < $; ) {
                  if (f === 0)
                    break e;
                  f--, u += a[l++] << h, h += 8;
                }
                u >>>= O, h -= O, M = 0, _ = 3 + (u & 7), u >>>= 3, h -= 3;
              } else {
                for ($ = O + 7; h < $; ) {
                  if (f === 0)
                    break e;
                  f--, u += a[l++] << h, h += 8;
                }
                u >>>= O, h -= O, M = 0, _ = 11 + (u & 127), u >>>= 7, h -= 7;
              }
              if (t.have + _ > t.nlen + t.ndist) {
                e.msg = "invalid bit length repeat", t.mode = Zt;
                break;
              }
              for (; _--; )
                t.lens[t.have++] = M;
            }
          }
          if (t.mode === Zt)
            break;
          if (t.lens[256] === 0) {
            e.msg = "invalid code -- missing end-of-block", t.mode = Zt;
            break;
          }
          if (t.lenbits = 9, w = { bits: t.lenbits }, k = Fs(PD, t.lens, 0, t.nlen, t.lencode, 0, t.work, w), t.lenbits = w.bits, k) {
            e.msg = "invalid literal/lengths set", t.mode = Zt;
            break;
          }
          if (t.distbits = 6, t.distcode = t.distdyn, w = { bits: t.distbits }, k = Fs(wD, t.lens, t.nlen, t.ndist, t.distcode, 0, t.work, w), t.distbits = w.bits, k) {
            e.msg = "invalid distances set", t.mode = Zt;
            break;
          }
          if (t.mode = Tl, r === Al)
            break e;
        /* falls through */
        case Tl:
          t.mode = Ol;
        /* falls through */
        case Ol:
          if (f >= 6 && p >= 258) {
            e.next_out = c, e.avail_out = p, e.next_in = l, e.avail_in = f, t.hold = u, t.bits = h, Ub(e, E), c = e.next_out, o = e.output, p = e.avail_out, l = e.next_in, a = e.input, f = e.avail_in, u = t.hold, h = t.bits, t.mode === Ri && (t.back = -1);
            break;
          }
          for (t.back = 0; g = t.lencode[u & (1 << t.lenbits) - 1], O = g >>> 24, R = g >>> 16 & 255, D = g & 65535, !(O <= h); ) {
            if (f === 0)
              break e;
            f--, u += a[l++] << h, h += 8;
          }
          if (R && (R & 240) === 0) {
            for (T = O, L = R, P = D; g = t.lencode[P + ((u & (1 << T + L) - 1) >> T)], O = g >>> 24, R = g >>> 16 & 255, D = g & 65535, !(T + O <= h); ) {
              if (f === 0)
                break e;
              f--, u += a[l++] << h, h += 8;
            }
            u >>>= T, h -= T, t.back += T;
          }
          if (u >>>= O, h -= O, t.back += O, t.length = D, R === 0) {
            t.mode = sI;
            break;
          }
          if (R & 32) {
            t.back = -1, t.mode = Ri;
            break;
          }
          if (R & 64) {
            e.msg = "invalid literal/length code", t.mode = Zt;
            break;
          }
          t.extra = R & 15, t.mode = nI;
        /* falls through */
        case nI:
          if (t.extra) {
            for ($ = t.extra; h < $; ) {
              if (f === 0)
                break e;
              f--, u += a[l++] << h, h += 8;
            }
            t.length += u & (1 << t.extra) - 1, u >>>= t.extra, h -= t.extra, t.back += t.extra;
          }
          t.was = t.length, t.mode = iI;
        /* falls through */
        case iI:
          for (; g = t.distcode[u & (1 << t.distbits) - 1], O = g >>> 24, R = g >>> 16 & 255, D = g & 65535, !(O <= h); ) {
            if (f === 0)
              break e;
            f--, u += a[l++] << h, h += 8;
          }
          if ((R & 240) === 0) {
            for (T = O, L = R, P = D; g = t.distcode[P + ((u & (1 << T + L) - 1) >> T)], O = g >>> 24, R = g >>> 16 & 255, D = g & 65535, !(T + O <= h); ) {
              if (f === 0)
                break e;
              f--, u += a[l++] << h, h += 8;
            }
            u >>>= T, h -= T, t.back += T;
          }
          if (u >>>= O, h -= O, t.back += O, R & 64) {
            e.msg = "invalid distance code", t.mode = Zt;
            break;
          }
          t.offset = D, t.extra = R & 15, t.mode = aI;
        /* falls through */
        case aI:
          if (t.extra) {
            for ($ = t.extra; h < $; ) {
              if (f === 0)
                break e;
              f--, u += a[l++] << h, h += 8;
            }
            t.offset += u & (1 << t.extra) - 1, u >>>= t.extra, h -= t.extra, t.back += t.extra;
          }
          if (t.offset > t.dmax) {
            e.msg = "invalid distance too far back", t.mode = Zt;
            break;
          }
          t.mode = oI;
        /* falls through */
        case oI:
          if (p === 0)
            break e;
          if (_ = E - p, t.offset > _) {
            if (_ = t.offset - _, _ > t.whave && t.sane) {
              e.msg = "invalid distance too far back", t.mode = Zt;
              break;
            }
            _ > t.wnext ? (_ -= t.wnext, S = t.wsize - _) : S = t.wnext - _, _ > t.length && (_ = t.length), v = t.window;
          } else
            v = o, S = c - t.offset, _ = t.length;
          _ > p && (_ = p), p -= _, t.length -= _;
          do
            o[c++] = v[S++];
          while (--_);
          t.length === 0 && (t.mode = Ol);
          break;
        case sI:
          if (p === 0)
            break e;
          o[c++] = t.length, p--, t.mode = Ol;
          break;
        case qf:
          if (t.wrap) {
            for (; h < 32; ) {
              if (f === 0)
                break e;
              f--, u |= a[l++] << h, h += 8;
            }
            if (E -= p, e.total_out += E, t.total += E, t.wrap & 4 && E && (e.adler = t.check = /*UPDATE_CHECK(state.check, put - _out, _out);*/
            t.flags ? li(t.check, o, E, c - E) : Np(t.check, o, E, c - E)), E = p, t.wrap & 4 && (t.flags ? u : uI(u)) !== t.check) {
              e.msg = "incorrect data check", t.mode = Zt;
              break;
            }
            u = 0, h = 0;
          }
          t.mode = lI;
        /* falls through */
        case lI:
          if (t.wrap && t.flags) {
            for (; h < 32; ) {
              if (f === 0)
                break e;
              f--, u += a[l++] << h, h += 8;
            }
            if (t.wrap & 4 && u !== (t.total & 4294967295)) {
              e.msg = "incorrect length check", t.mode = Zt;
              break;
            }
            u = 0, h = 0;
          }
          t.mode = cI;
        /* falls through */
        case cI:
          k = Wb;
          break e;
        case Zt:
          k = HD;
          break e;
        case kD:
          return VD;
        case FD:
        /* falls through */
        default:
          return zn;
      }
  return e.next_out = c, e.avail_out = p, e.next_in = l, e.avail_in = f, t.hold = u, t.bits = h, (t.wsize || E !== e.avail_out && t.mode < Zt && (t.mode < qf || r !== BS)) && GD(e, e.output, e.next_out, E - e.avail_out), C -= e.avail_in, E -= e.avail_out, e.total_in += C, e.total_out += E, t.total += E, t.wrap & 4 && E && (e.adler = t.check = /*UPDATE_CHECK(state.check, strm.next_out - _out, _out);*/
  t.flags ? li(t.check, o, E, e.next_out - E) : Np(t.check, o, E, e.next_out - E)), e.data_type = t.bits + (t.last ? 64 : 0) + (t.mode === Ri ? 128 : 0) + (t.mode === Tl || t.mode === zf ? 256 : 0), (C === 0 && E === 0 || r === BS) && k === ka && (k = Kb), k;
}, aP = (e) => {
  if (ja(e))
    return zn;
  let r = e.state;
  return r.window && (r.window = null), e.state = null, ka;
}, oP = (e, r) => {
  if (ja(e))
    return zn;
  const t = e.state;
  return (t.wrap & 2) === 0 ? zn : (t.head = r, r.done = !1, ka);
}, sP = (e, r) => {
  const t = r.length;
  let a, o, l;
  return ja(e) || (a = e.state, a.wrap !== 0 && a.mode !== Yl) ? zn : a.mode === Yl && (o = 1, o = Np(o, r, t, 0), o !== a.check) ? HD : (l = GD(e, r, t, t), l ? (a.mode = kD, VD) : (a.havedict = 1, ka));
};
var lP = UD, cP = BD, uP = xD, fP = rP, dP = $D, pP = iP, hP = aP, mP = oP, _P = sP, EP = "pako inflate (from Nodeca project)", yi = {
  inflateReset: lP,
  inflateReset2: cP,
  inflateResetKeep: uP,
  inflateInit: fP,
  inflateInit2: dP,
  inflate: pP,
  inflateEnd: hP,
  inflateGetHeader: mP,
  inflateSetDictionary: _P,
  inflateInfo: EP
};
function CP() {
  this.text = 0, this.time = 0, this.xflags = 0, this.os = 0, this.extra = null, this.extra_len = 0, this.name = "", this.comment = "", this.hcrc = 0, this.done = !1;
}
var SP = CP;
const ZD = Object.prototype.toString, {
  Z_NO_FLUSH: IP,
  Z_FINISH: vP,
  Z_OK: $s,
  Z_STREAM_END: Kf,
  Z_NEED_DICT: Xf,
  Z_STREAM_ERROR: gP,
  Z_DATA_ERROR: dI,
  Z_MEM_ERROR: DP
} = LD;
function Ec(e) {
  this.options = MD.assign({
    chunkSize: 1024 * 64,
    windowBits: 15,
    to: ""
  }, e || {});
  const r = this.options;
  r.raw && r.windowBits >= 0 && r.windowBits < 16 && (r.windowBits = -r.windowBits, r.windowBits === 0 && (r.windowBits = -15)), r.windowBits >= 0 && r.windowBits < 16 && !(e && e.windowBits) && (r.windowBits += 32), r.windowBits > 15 && r.windowBits < 48 && (r.windowBits & 15) === 0 && (r.windowBits |= 15), this.err = 0, this.msg = "", this.ended = !1, this.chunks = [], this.strm = new Fb(), this.strm.avail_out = 0;
  let t = yi.inflateInit2(
    this.strm,
    r.windowBits
  );
  if (t !== $s)
    throw new Error(Lp[t]);
  if (this.header = new SP(), yi.inflateGetHeader(this.strm, this.header), r.dictionary && (typeof r.dictionary == "string" ? r.dictionary = Mp.string2buf(r.dictionary) : ZD.call(r.dictionary) === "[object ArrayBuffer]" && (r.dictionary = new Uint8Array(r.dictionary)), r.raw && (t = yi.inflateSetDictionary(this.strm, r.dictionary), t !== $s)))
    throw new Error(Lp[t]);
}
Ec.prototype.push = function(e, r) {
  const t = this.strm, a = this.options.chunkSize, o = this.options.dictionary;
  let l, c, f;
  if (this.ended) return !1;
  for (r === ~~r ? c = r : c = r === !0 ? vP : IP, ZD.call(e) === "[object ArrayBuffer]" ? t.input = new Uint8Array(e) : t.input = e, t.next_in = 0, t.avail_in = t.input.length; ; ) {
    for (t.avail_out === 0 && (t.output = new Uint8Array(a), t.next_out = 0, t.avail_out = a), l = yi.inflate(t, c), l === Xf && o && (l = yi.inflateSetDictionary(t, o), l === $s ? l = yi.inflate(t, c) : l === dI && (l = Xf)); t.avail_in > 0 && l === Kf && t.state.wrap > 0 && e[t.next_in] !== 0; )
      yi.inflateReset(t), l = yi.inflate(t, c);
    switch (l) {
      case gP:
      case dI:
      case Xf:
      case DP:
        return this.onEnd(l), this.ended = !0, !1;
    }
    if (f = t.avail_out, t.next_out && (t.avail_out === 0 || l === Kf))
      if (this.options.to === "string") {
        let p = Mp.utf8border(t.output, t.next_out), u = t.next_out - p, h = Mp.buf2string(t.output, p);
        t.next_out = u, t.avail_out = a - u, u && t.output.set(t.output.subarray(p, p + u), 0), this.onData(h);
      } else
        this.onData(t.output.length === t.next_out ? t.output : t.output.subarray(0, t.next_out));
    if (!(l === $s && f === 0)) {
      if (l === Kf)
        return l = yi.inflateEnd(this.strm), this.onEnd(l), this.ended = !0, !0;
      if (t.avail_in === 0) break;
    }
  }
  return !0;
};
Ec.prototype.onData = function(e) {
  this.chunks.push(e);
};
Ec.prototype.onEnd = function(e) {
  e === $s && (this.options.to === "string" ? this.result = this.chunks.join("") : this.result = MD.flattenChunks(this.chunks)), this.chunks = [], this.err = e, this.msg = this.strm.msg;
};
function RP(e, r) {
  const t = new Ec(r);
  if (t.push(e), t.err) throw t.msg || Lp[t.err];
  return t.result;
}
var AP = RP, TP = {
  inflate: AP
};
const { inflate: OP } = TP;
var yP = OP;
class bp {
  constructor(r) {
    var l;
    const t = new NP(r);
    this.lowLvlResponse = t, this.rawResponse = r, this.TransactionInfo = r.TransactionInfo || {}, this.status = (l = t.statusResult()) == null ? void 0 : l.Status;
    const a = t.textResult();
    a && (this.text = new ab(a.Text));
    const o = t.imagesResult();
    o && (this.images = new sb(o.Images));
  }
  authenticity(r = 0) {
    const t = this.lowLvlResponse.resultByTypeAndPage(Tn.AUTHENTICITY, r);
    if (t)
      return new VS(t.AuthenticityCheckList, r);
  }
  json() {
    return JSON.stringify(this.lowLvlResponse);
  }
  authenticityPerPage() {
    return this.lowLvlResponse.resultsByType(Tn.AUTHENTICITY).map((r) => new VS(r.AuthenticityCheckList, r.page_idx || 0)).sort((r, t) => r.page_idx - t.page_idx);
  }
  imageQualityChecks(r = 0) {
    const t = this.lowLvlResponse.resultByTypeAndPage(Tn.IMAGE_QUALITY, r);
    if (t)
      return t.ImageQualityCheckList;
  }
  imageQualityChecksPerPage() {
    return this.lowLvlResponse.resultsByType(Tn.IMAGE_QUALITY);
  }
  documentType(r = 0) {
    const t = this.lowLvlResponse.resultByTypeAndPage(Tn.DOCUMENT_TYPE, r);
    if (t)
      return t.OneCandidate;
  }
  decodedLog() {
    const r = this.lowLvlResponse.log;
    if (r) {
      const t = OD(r), a = new Uint8Array(t);
      let o;
      try {
        const u = yP(a);
        o = u.length > a.length ? u : a;
      } catch (u) {
        o = a;
      }
      const l = o.length, c = 1e4, f = [], p = [].slice.call(o);
      for (let u = 0; u < l; u += c) {
        const h = String.fromCharCode.apply(null, p.slice(u, u + c));
        f.push(h);
      }
      return f.join("");
    }
  }
}
class NP {
  constructor(r) {
    this.ContainerList = r.ContainerList || { Count: 0, List: [] }, this.ProcessingFinished = r.ProcessingFinished || Wl.NOT_FINISHED, this.TransactionInfo = r.TransactionInfo || {}, this.ChipPage = r.ChipPage, this.morePagesAvailable = r.morePagesAvailable, this.elapsedTime = r.elapsedTime, "log" in r && (this.log = r.log), "passBackObject" in r && (this.passBackObject = r.passBackObject), "metadata" in r && (this.metadata = r.metadata), "CoreLibResultCode" in r && (this.CoreLibResultCode = r.CoreLibResultCode);
  }
  statusResult() {
    return this.resultByType(Tn.STATUS);
  }
  textResult() {
    return this.resultByType(Tn.TEXT);
  }
  imagesResult() {
    return this.resultByType(Tn.IMAGES);
  }
  barcodeResult() {
    return this.resultByType(Tn.BARCODES);
  }
  documentTypeResults() {
    return this.resultsByType(Tn.DOCUMENT_TYPE);
  }
  resultByType(r) {
    for (const t of this.ContainerList.List)
      if (t.result_type === r)
        return t;
  }
  resultByTypeAndPage(r, t = 0) {
    for (const a of this.ContainerList.List)
      if (a.result_type === r && a.page_idx == t)
        return a;
  }
  resultsByType(r) {
    return this.ContainerList.List.filter((t) => t.result_type === r);
  }
}
class yl {
  constructor(r = {}) {
    var t;
    this.apiKey = r.apiKey, this.username = r.username, this.password = r.password, this.accessToken = r.accessToken, this.basePath = r.basePath, this.serverIndex = r.serverIndex, this.baseOptions = Qi(be({}, r.baseOptions), {
      headers: be({}, (t = r.baseOptions) == null ? void 0 : t.headers)
    }), this.formDataCtor = r.formDataCtor;
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(r) {
    const t = new RegExp("^(application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(;.*)?$", "i");
    return r !== null && (t.test(r) || r.toLowerCase() === "application/json-patch+json");
  }
}
const LP = (e) => "images" in e;
class jD {
  constructor(r, t = pn, a = Rt) {
    this.healthcheckApi = new pM(new yl(r), t, a), this.processApi = new _M(new yl(r), t, a), this.transactionApi = new CM(new yl(r), t, a), this.resourcesApi = new vM(new yl(r), t, a);
  }
  doclist(r) {
    return Ae(this, null, function* () {
      return (yield this.resourcesApi.doclist(r)).data;
    });
  }
  ping(r, t) {
    return Ae(this, null, function* () {
      return (yield this.healthcheckApi.ping(r, t)).data;
    });
  }
  health(r, t) {
    return Ae(this, null, function* () {
      return (yield this.healthcheckApi.healthz(r, t)).data;
    });
  }
  /**
   *
   * @summary Process list of documents images and return extracted data
   * @param {ProcessRequestExt} [request] Request options such as image, results types and etc.
   * @param {string} xRequestID It allows the client and server to correlate each HTTP request.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError} If some request params are missed
   * */
  process(r, t, a) {
    return Ae(this, null, function* () {
      let o;
      LP(r) ? (r.processParam || (r.processParam = {
        scenario: TD.FULL_PROCESS,
        resultTypeOutput: [Tn.TEXT]
      }), r.systemInfo || (r.systemInfo = {}), !r.systemInfo.license && this.license && (r.systemInfo.license = this.license), o = MP(r)) : o = r;
      const l = yield this.processApi.apiProcess(o, t, a);
      return new bp(l.data);
    });
  }
  setLicense(r) {
    typeof r == "string" ? this.license = r : this.license = Th(r);
  }
  /**
   *
   * @summary Reprocess
   * @param {string} transactionId Transaction id
   * @param {TransactionProcessRequest} transactionProcessRequest
   * @param {boolean} useCache Get processed values from storage in case transaction has already processed.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  reprocessTransaction(r, t, a, o) {
    return this.transactionApi.apiV2TransactionTransactionIdProcessPost(
      r,
      t,
      a,
      o
    );
  }
  /**
   *
   * @summary Get Reprocess transaction result
   * @param {string} transactionId Transaction id
   * @param {boolean} [withImages] With base64 images or url
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getReprocessTransactionResult(r, t, a) {
    return Ae(this, null, function* () {
      const o = yield this.transactionApi.apiV2TransactionTransactionIdResultsGet(
        r,
        t,
        a
      );
      return new bp(o.data);
    });
  }
  /**
   *
   * @summary Get transactions by tag
   * @param {string} tagId Tag id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getTransactionsByTag(r, t) {
    return Ae(this, null, function* () {
      return this.transactionApi.apiV2TagTagIdTransactionsGet(r, t);
    });
  }
  /**
   *
   * @summary Delete Reprocess transactions by tag
   * @param {string} tagId Tag id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  deleteReprocessTransactionsByTag(r, t) {
    return Ae(this, null, function* () {
      return this.transactionApi.apiV2TagTagIdDelete(r, t);
    });
  }
  /**
   *
   * @summary Get Reprocess transaction file
   * @param {string} transactionId Transaction id
   * @param {string} name File name
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getReprocessTransactionFile(r, t, a) {
    return Ae(this, null, function* () {
      return this.transactionApi.apiV2TransactionTransactionIdFileGet(r, t, a);
    });
  }
  /**
   *
   * @summary Get Reprocess transaction data
   * @param {string} transactionId Transaction id
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   */
  getReprocessTransactionData(r, t) {
    return Ae(this, null, function* () {
      return this.transactionApi.apiV2TransactionTransactionIdGet(r, t);
    });
  }
}
function MP(e) {
  const r = [];
  return e.images.forEach((t, a) => {
    if (typeof t == "string")
      r.push({ ImageData: { image: t }, light: yp.WHITE, page_idx: a });
    else if (t instanceof ArrayBuffer) {
      const o = Th(t);
      r.push({ ImageData: { image: o }, light: yp.WHITE, page_idx: a });
    } else
      r.push(bP(t, a));
  }), Qi(be({}, e), {
    List: r
  });
}
function bP(e, r) {
  let t;
  return typeof e.ImageData == "string" ? t = e.ImageData : t = Th(e.ImageData), {
    ImageData: { image: t },
    light: e.light,
    page_idx: typeof e.page_idx > "u" ? r : e.page_idx
  };
}
function Th(e) {
  return ob(e);
}
function zD(e) {
  return Ae(this, null, function* () {
    const t = Array.from(e).map((a) => Ae(null, null, function* () {
      if (!a || !a.size) throw new $t(rr.INCORRECT_FILE);
      const o = URL.createObjectURL(a), c = yield ((f) => new Promise((p, u) => {
        const h = new Image();
        h.onload = () => {
          p(h), URL.revokeObjectURL(o);
        }, h.onerror = () => {
          u(new $t(rr.INCORRECT_FILE)), URL.revokeObjectURL(o);
        }, h.src = f;
      }))(o);
      if (c.width * c.height > eO)
        throw new $t(rr.INCORRECT_FILE);
      return {
        width: c.width,
        height: c.height,
        data: yield a.arrayBuffer()
      };
    }));
    return Promise.all(t);
  });
}
function PP(e, r) {
  var t;
  const a = {
    glareCheck: Mi.WAS_NOT_DONE,
    resolutionCheck: Mi.WAS_NOT_DONE,
    focusCheck: Mi.WAS_NOT_DONE,
    isDocumentAvailable: !1
  };
  return (t = e.ContainerList) === null || t === void 0 || t.List.forEach((o) => {
    o.page_idx === r && ("ImageQualityCheckList" in o && o.ImageQualityCheckList.List.forEach((l) => {
      l.result !== void 0 && (l.type === Fl.ImageFocus && (a.focusCheck = l.result), l.type === Fl.ImageGlares && (a.glareCheck = l.result), l.type === Fl.ImageResolution && (a.resolutionCheck = l.result));
    }), "DocumentPosition" in o && (a.isDocumentAvailable = !0));
  }), a;
}
function qD(e, r) {
  let t = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !1;
  const {
    glareCheck: a,
    resolutionCheck: o,
    focusCheck: l,
    isDocumentAvailable: c
  } = PP(e, r), f = !t || t && e.morePagesAvailable === 0;
  return e.ProcessingFinished === Wl.FINISHED ? f ? at.SUCCESS : at.START_NEXT_PAGE : e.ProcessingFinished === Wl.TIMEOUT ? at.TIMEOUT : "liveness" in e ? at.LIVENESS : c ? l === Mi.ERROR ? at.FOCUS : a === Mi.ERROR ? at.GLARE : o === Mi.ERROR ? at.RESOLUTION : at.HOLD : at.FINDING;
}
function wP(e, r) {
  return e.replace(/https:\/\/wasm\.regulaforensics\.com\/document\/\w+\/\d+\.\d+\/\w+\/[a-f0-9-]+/, r);
}
function HP(e, r) {
  var t, a;
  const o = {
    [wl.BarcodeMRZ]: {
      PROD: "https://wasm.regulaforensics.com/document/release/8.4/barcodemrz/3f91aa35-b10c745f5",
      DEV: "./wasm/barcode-mrz/"
    },
    [wl.BoundsLite]: {
      PROD: "https://wasm.regulaforensics.com/document/release/8.4/boundslite/3f91aa35-b10c745f5",
      DEV: "./wasm/bounds-lite/"
    }
  };
  return (t = (a = o[e]) === null || a === void 0 ? void 0 : a[r]) !== null && t !== void 0 ? t : o[wl.BarcodeMRZ][r];
}
function pI(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    r && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function hI(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? pI(Object(t), !0).forEach(function(a) {
      VP(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : pI(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function VP(e, r, t) {
  return (r = kP(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function kP(e) {
  var r = FP(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function FP(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const mI = jr.create("main");
function WD(e) {
  let {
    scenario: r,
    onError: t
  } = e;
  const {
    onEvent: a
  } = nr(), o = window.RegulaDocumentSDK, [l, c] = oe.useState({
    initialized: !1,
    initData: o.initData
  });
  return oe.useEffect(() => {
    if (!(!l.initData || l.initialized || !r))
      if (l.initData.license.errorCode === 0 && l.initData.license.status) {
        const f = l.initData.scenario.filter((u) => u.name !== lO);
        f.some((u) => u.name === r) ? (c({
          initialized: !0,
          initData: {
            scenario: f,
            license: l.initData.license
          }
        }), a({
          action: pt.SERVICE_INITIALIZED,
          data: null
        })) : (t(new $t(rr.INCORRECT_SCENARIO)), mI("Incorrect scenario: ".concat(r)));
      } else
        t(new $t(rr.WASM_LICENSE, l.initData.license.message)), mI("Problems with initialization.");
  }, [l, r]), oe.useEffect(() => {
    !o || o.isInitialized || o.initData || (o.initializeListener = (f) => {
      let {
        isInitialized: p
      } = f;
      !p || !o.initData || c((u) => hI(hI({}, u), {}, {
        initData: o.initData
      }));
    });
  }, [o]), l;
}
function xP(e, r) {
  const [t, a] = oe.useState(e), [o, l] = oe.useState(!1);
  return oe.useEffect(() => {
    o || a(e);
  }, [o, e]), oe.useEffect(() => {
    l(!0);
    const c = setTimeout(() => {
      l(!1);
    }, r);
    return () => {
      clearTimeout(c);
    };
  }, [t]), t;
}
const Qf = jr.create("main"), UP = 5;
function BP(e) {
  const [r, t] = oe.useState(!1), a = oe.useRef({
    x: 0,
    y: 0,
    z: 0
  }), o = xP(r, 1e3), l = (c) => {
    var f, p;
    if (!((f = c.acceleration) !== null && f !== void 0 && f.x) || !((p = c.acceleration) !== null && p !== void 0 && p.y) || !c.acceleration.z) return;
    const u = Math.abs(c.acceleration.x - a.current.x) + Math.abs(c.acceleration.y - a.current.y) + Math.abs(c.acceleration.z - a.current.z);
    t(u > UP), a.current.x = c.acceleration.x, a.current.y = c.acceleration.y, a.current.z = c.acceleration.z;
  };
  return oe.useEffect(() => {
    if (!e) return;
    const c = DeviceOrientationEvent.requestPermission;
    if (typeof c == "function")
      c().then((f) => {
        f === "granted" ? window.addEventListener("devicemotion", l) : Qf("Device orientation service permission denied");
      }).catch((f) => "Device orientation service error: ".concat(f));
    else if ("permissions" in navigator)
      navigator.permissions.query({
        name: "accelerometer"
      }).then((f) => {
        f.state === "granted" ? window.addEventListener("devicemotion", l) : Qf("Device orientation service permission denied");
      }).catch((f) => "Device orientation service error: ".concat(f));
    else
      return Qf("Device orientation service is missing");
    return () => {
      window.removeEventListener("devicemotion", l);
    };
  }, []), {
    isShake: o
  };
}
function _I(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    r && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function Dn(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? _I(Object(t), !0).forEach(function(a) {
      $P(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : _I(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function $P(e, r, t) {
  return (r = GP(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function GP(e) {
  var r = ZP(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function ZP(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const ea = jr.create("main");
function jP(e) {
  let {
    videoElementParams: r,
    videoStatusParams: t,
    mirroring: a,
    onError: o,
    controlsWidth: l,
    captureMode: c
  } = e;
  const f = window.RegulaDocumentSDK, {
    onEvent: p,
    multipageProcessing: u,
    internalScenario: h,
    videoCaptureMotionControl: C,
    nextPageAnimationStartDelay: E = R8,
    nextPageAnimationEndDelay: _ = cO,
    processingDelay: S = 0
  } = nr(), {
    isShake: v
  } = BP(C), g = oe.useRef(!1), O = oe.useRef(!1), [R, D] = oe.useState(!1), [T, L] = oe.useState(!1), [P, M] = oe.useState(!1), [k, H] = oe.useState(0), [w, $] = oe.useState(void 0), [B, Y] = oe.useState(null), [j, ie] = oe.useState(void 0), [se, le] = oe.useState({
    status: at.SERVICE_PREPARING,
    response: null
  }), {
    initData: U,
    initialized: X
  } = WD({
    scenario: w,
    onError: o
  }), K = wN({
    videoSize: r.videoParams,
    mirroring: a,
    controlsWidth: l,
    scenario: w,
    scenarioParams: U == null ? void 0 : U.scenario
  }), y = c === ia.captureFrame, G = se.status === at.START_NEXT_PAGE;
  return oe.useEffect(() => {
    if (f) {
      if (f.recognizerProcessParam = Zr(pO, f.recognizerProcessParam), u !== void 0) {
        const ce = {
          processParam: {
            multipageProcessing: u
          }
        };
        f.recognizerProcessParam = Zr(f.recognizerProcessParam, ce);
      }
      if (h !== void 0) {
        const ce = {
          processParam: {
            scenario: h
          }
        };
        f.recognizerProcessParam = Zr(f.recognizerProcessParam, ce);
      }
      ea("Current scenario: ".concat(f.recognizerProcessParam.processParam.scenario)), $(f.recognizerProcessParam.processParam.scenario);
    }
  }, [f, h, u]), oe.useEffect(() => {
    const {
      frameTop: ce,
      frameBottom: ue,
      frameLeft: ee,
      frameRight: ge
    } = K || {};
    ea("Frame params: ".concat(JSON.stringify(K))), f.recognizerProcessParam = Zr(f.recognizerProcessParam, {
      imageInputParam: {
        frameTop: ce,
        frameBottom: ue,
        frameLeft: ee,
        frameRight: ge,
        light: j,
        resolutionType: 0
      }
    });
  }, [K, j]), oe.useEffect(() => {
    var ce;
    if (!f || !X || T || y || t.videoStatus !== Ft.PLAY || !t.sortedDevices) return;
    const ue = W8([...t.sortedDevices.frontCameras, ...t.sortedDevices.backCameras], t.camera.deviceId, "8.4.2541".trim(), ((ce = f.recognizerProcessParam.processParam.backendProcessing) === null || ce === void 0 ? void 0 : ce.serviceURL) || "");
    ea("Metadata: ".concat(JSON.stringify(ue))), (f.recognizerProcessParam.processParam.backendProcessing ? f.createBackendTransaction(ue) : f.startNewDocument(ue)).then(() => {
      L(!0), ea("New document started");
    }).catch((ge) => {
      le((Oe) => Dn(Dn({}, Oe), {}, {
        status: at.FAILED
      })), o(new $t(rr.WASM_ERROR, ge));
    });
  }, [X, T, c, t]), oe.useEffect(() => {
    const ce = T && (!c || c === ia.auto), ue = T && c === ia.captureVideo;
    (X && c === ia.captureFrame || ue || ce) && (le((ge) => Dn(Dn({}, ge), {}, {
      status: at.FINDING
    })), ce && setTimeout(() => D(!0), S));
  }, [T, c, X, S]), oe.useEffect(() => {
    const ce = t.videoStatus === Ft.PLAY;
    if (!f || !ce || P || !R || !r.videoElement) return;
    if (g.current || (p({
      action: pt.CAMERA_PROCESS_STARTED,
      data: null
    }), g.current = !0), v)
      return le((ee) => Dn(Dn({}, ee), {}, {
        status: at.SHAKING
      }));
    M(!0);
    const {
      imageData: ue
    } = cc(r.videoElement, Ha.UINT);
    ea("Image processing started"), f.process(ue).then((ee) => {
      const ge = qD(ee.rawResponse, k, f.recognizerProcessParam.processParam.multipageProcessing);
      le((Se) => Dn(Dn({}, Se), {}, {
        status: ge,
        response: ee
      })), M(!1), ea("Image processing is finished");
      const Oe = !!ph[ge];
      if (ge === at.START_NEXT_PAGE || Oe) {
        const {
          multipageAnimationImage: Se
        } = ee.rawResponse;
        Se && Y({
          type: Ma.Flip,
          image: Se
        }), D(!1);
      }
      if ("lightType" in ee.rawResponse) {
        const {
          lightType: Se,
          liveness: Ne
        } = ee.rawResponse;
        Ne && (Ne.hologramTiltType !== void 0 && wo(Se) === fO ? Y({
          type: Ma.Tilt,
          image: [Ne.livenessAnimationImage],
          tiltType: Ne.hologramTiltType
        }) : Y(null), O.current || (p({
          action: pt.PROCESS_LIVENESS,
          data: null
        }), O.current = !0)), ie(wo(Se));
      } else
        ie(void 0);
    }).catch((ee) => {
      le({
        response: null,
        status: at.FAILED
      }), o(new $t(rr.WASM_ERROR, ee)), D(!1);
    });
  }, [P, r.videoElement, t.videoStatus, k, R, v]), oe.useEffect(() => {
    if (!f || !G) return;
    ea("More pages available"), p({
      action: pt.NEW_PAGE_AVAILABLE,
      data: null
    });
    const ce = setTimeout(() => Ae(null, null, function* () {
      try {
        yield f.startNewPage(), p({
          action: pt.NEW_PAGE_STARTED,
          data: null
        }), D(!0), H((ue) => ue + J9), Y(null), ea("New page started");
      } catch (ue) {
        le((ee) => Dn(Dn({}, ee), {}, {
          status: at.FAILED
        })), o(new $t(rr.WASM_ERROR, ue));
      }
    }), E + D8 + _);
    return () => {
      clearTimeout(ce);
    };
  }, [G]), Dn(Dn({}, se), {}, {
    frameParams: K,
    setIsRecognitionStarted: D,
    animation: B
  });
}
const Ns = jr.create("main");
function zP() {
  var e, r, t;
  const {
    mobileDelegate: a
  } = nr(), [o, l] = oe.useState(Ni.CHECKING), c = window.RegulaDocumentSDK, f = ((e = c.recognizerProcessParam) === null || e === void 0 ? void 0 : e.tag) || "", p = ((r = c.recognizerProcessParam.processParam.backendProcessing) === null || r === void 0 ? void 0 : r.serviceURL) || "", u = ((t = c.recognizerProcessParam.processParam.backendProcessing) === null || t === void 0 ? void 0 : t.httpHeaders) || {};
  return oe.useEffect(() => {
    if (!a)
      return Ns("Transaction check is disabled"), l(Ni.NOT_AVAILABLE);
    Ns("Transaction check parameters: ".concat(JSON.stringify({
      tag: f,
      basePath: p,
      headers: u
    }))), Ae(null, null, function* () {
      try {
        var C;
        const E = new jD({
          basePath: p,
          baseOptions: {
            headers: u
          }
        }), {
          data: _
        } = yield E.getTransactionsByTag(f, {
          headers: u
        });
        Ns("Transaction check data: ".concat(JSON.stringify(_)));
        const S = (C = _.items) !== null && C !== void 0 && C.some((v) => v.state === $l.PROCESSED) ? Ni.AVAILABLE : Ni.NOT_AVAILABLE;
        Ns("Transaction check status: ".concat(S)), l(S);
      } catch (E) {
        Ns("Transaction check status: ERROR. Details: ".concat(E)), l(Ni.ERROR);
      }
    });
  }, [a]), o;
}
const qP = ["data"];
function WP(e, r) {
  if (e == null) return {};
  var t, a, o = YP(e, r);
  if (Object.getOwnPropertySymbols) {
    var l = Object.getOwnPropertySymbols(e);
    for (a = 0; a < l.length; a++) t = l[a], r.indexOf(t) === -1 && {}.propertyIsEnumerable.call(e, t) && (o[t] = e[t]);
  }
  return o;
}
function YP(e, r) {
  if (e == null) return {};
  var t = {};
  for (var a in e) if ({}.hasOwnProperty.call(e, a)) {
    if (r.indexOf(a) !== -1) continue;
    t[a] = e[a];
  }
  return t;
}
function KP(e) {
  let {
    direction: r,
    onStatusChange: t,
    onFileImageSet: a,
    onError: o,
    onClose: l
  } = e;
  const {
    onEvent: c,
    cameraId: f,
    startScreen: p,
    captureButton: u,
    captureMode: h,
    resolution: C,
    cameraMode: E,
    videoRecord: _,
    mirrorType: S,
    mobileDelegate: v,
    finalizeOnTimeout: g = !0
  } = nr(), O = window.RegulaDocumentSDK, R = oe.useMemo(() => ({
    width: (C == null ? void 0 : C.width) || ui.FULL_HD.width,
    height: (C == null ? void 0 : C.height) || ui.FULL_HD.height
  }), [C]), D = oe.useRef(!0), T = oe.useRef(null), L = oe.useRef(null), [P, M] = oe.useState(!1), [k, H] = oe.useState(0), [w, $] = oe.useState({
    videoElement: null,
    videoParams: {
      width: 0,
      height: 0
    },
    videoContainerParams: {
      width: 0,
      height: 0
    }
  }), [B, Y] = oe.useState({
    videoStatus: Ft.PREPARING,
    camera: {
      deviceId: "",
      facing: void 0,
      groupId: "",
      label: ""
    },
    sortedDevices: null
  }), [j, ie] = oe.useState(f), {
    status: se,
    response: le,
    frameParams: U,
    setIsRecognitionStarted: X,
    animation: K
  } = jP({
    videoElementParams: w,
    videoStatusParams: B,
    mirroring: P,
    onError: o,
    captureMode: h,
    controlsWidth: k
  }), y = zP(), [G, ce] = oe.useState(null), ue = (Ke, ot, St) => Ae(null, null, function* () {
    t(Me.PROCESSING);
    const {
      backendProcessing: dt
    } = O.recognizerProcessParam.processParam, Je = {
      status: Ke,
      response: St
    };
    if (_ && G) {
      const je = yield G.getRecord();
      if (!je) return;
      if (Je.video = je, dt) {
        const {
          data: st
        } = je, de = WP(je, qP), Te = yield st.arrayBuffer(), Ue = new Uint8ClampedArray(Te);
        yield O.addDataToPackage(Ue, {
          sizeBytes: st.size,
          dataName: "processingVideo",
          metadata: de
        });
      }
    }
    if (dt)
      if (ot === Me.TIMEOUT && !g) {
        t(v ? Me.DELEGATE_SUCCESS : ot), c({
          action: pt.PROCESS_FINISHED,
          data: Je
        });
        return;
      } else
        O.onFinalize = (je) => {
          if (!je.transactionId) return t(Me.FAILED);
          t(v ? Me.DELEGATE_SUCCESS : Me.SUCCESS);
        };
    c({
      action: pt.PROCESS_FINISHED,
      data: Je
    }), t(dt ? Me.PROCESSING : ot);
  }), ee = () => {
    var Ke;
    c({
      action: pt.PRESS_MIRRORING_BUTTON,
      data: null
    }), (Ke = T.current) === null || Ke === void 0 || Ke.changeMirror();
  }, ge = oe.useCallback(() => {
    c({
      action: pt.CAMERA_PROCESS_CLOSED,
      data: null
    }), p && t(Me.CHOOSE_INPUT_SOURCE);
  }, [p]), Oe = () => Ae(null, null, function* () {
    c({
      action: pt.PRESS_SKIP_BUTTON,
      data: null
    }), L.current && (yield ue(Li.OK, Me.SUCCESS, L.current));
  }), Se = oe.useCallback(() => {
    if (c({
      action: pt.PRESS_CHANGE_CAMERA_BUTTON,
      data: null
    }), !B.sortedDevices) return;
    const Ke = Eh(B.sortedDevices, B.camera.deviceId);
    Ke && ie(Ke);
  }, [B.camera.deviceId, B.sortedDevices]), Ne = oe.useCallback(() => {
    if (c({
      action: pt.PRESS_CAPTURE_BUTTON,
      data: null
    }), h === ia.captureVideo && D.current)
      D.current = !1, X(!0);
    else {
      if (!w.videoElement) return;
      X(!1);
      const {
        imageData: Ke
      } = cc(w.videoElement, Ha.UINT);
      a(Ke);
    }
  }, [w.videoElement, h]), Le = (Ke) => {
    o(new $t(Ke));
  }, ct = u || u === void 0 || h === ia.captureFrame || h === ia.captureVideo;
  oe.useEffect(() => {
    if (le) {
      if (se === at.START_NEXT_PAGE && (L.current = le), se === at.SUCCESS) {
        const Ke = v ? Me.DELEGATE_SUCCESS : Me.SUCCESS;
        ue(Li.OK, Ke, le);
      }
      if (se === at.TIMEOUT) {
        const Ke = v ? Me.DELEGATE_SUCCESS : Me.TIMEOUT;
        ue(Li.TIMEOUT, Ke, le);
      }
    }
  }, [se, le, v]), oe.useEffect(() => {
    y === Ni.AVAILABLE && t(Me.DELEGATE_SUCCESS), y === Ni.ERROR && o(new $t(rr.CONNECTION_ERROR, "Transaction check failed."));
  }, [y]);
  const Ye = () => {
    c({
      action: pt.VIDEO_STARTED,
      data: null
    });
  }, nt = () => {
    c({
      action: pt.VIDEO_STOPPED,
      data: null
    });
  };
  return oe.useMemo(() => /* @__PURE__ */ Z.jsx(J8, { direction: r, mirroring: P, onChangeMirroring: ee, status: se, videoStatusParams: B, frameParams: U, videoElementParams: w, onProcessClose: ge, onClose: l, onSnapshotProcess: Ne, onSkip: Oe, onChangeCamera: Se, captureButton: ct, animation: K, onControlsWidth: H, children: y === Ni.NOT_AVAILABLE ? /* @__PURE__ */ Z.jsx(Y8, { onVideoSizeChange: $, onVideoStatusChange: Y, resolution: R, onFailStatus: Le, mode: E || hn.environment, cameraId: j, onRecordService: ce, videoRecord: _, onVideoStarted: Ye, onVideoStopped: nt, onMirroringChange: M, mirrorType: S, ref: T }) : null }), [j, P, Ne, se, B, U, ge, Se, w, ct, R, E, _, K, y]);
}
const XP = "_title_1fk4r_28", QP = "_subtitle_1fk4r_37", Ls = {
  "info-message": "_info-message_1fk4r_1",
  "text-container": "_text-container_1fk4r_10",
  title: XP,
  subtitle: QP,
  "retry-button": "_retry-button_1fk4r_46"
}, JP = "_button_7h3jm_1", ew = {
  button: JP
};
function Ul(e) {
  let {
    children: r,
    className: t,
    part: a,
    onClick: o,
    e2e: l
  } = e;
  return /* @__PURE__ */ Z.jsx("button", { part: a, className: "".concat(ew.button, " ").concat(t != null ? t : ""), "data-e2e": l, onClick: o, children: r });
}
function tr(e) {
  let {
    title: r,
    subtitle: t,
    className: a,
    onReset: o
  } = e;
  const {
    translate: l
  } = Hi.useLocalize();
  return /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
    /* @__PURE__ */ Z.jsx(Us, { text: r }),
    /* @__PURE__ */ Z.jsx("div", { part: "info-container", className: Ls["info-message"], children: /* @__PURE__ */ Z.jsxs("div", { part: "info-text-container", className: "".concat(Ls["text-container"], " ").concat(a != null ? a : ""), children: [
      /* @__PURE__ */ Z.jsx("p", { part: "info-title", "data-e2e": "info-msg-title", className: Ls.title, children: r }),
      t && /* @__PURE__ */ Z.jsx("p", { part: "info-subtitle", "data-e2e": "info-msg-subtitle", className: Ls.subtitle, children: t }),
      o && /* @__PURE__ */ Z.jsx(Ul, { part: "info-try-again-button", className: Ls["retry-button"], onClick: o, children: l("tryAgain") })
    ] }) })
  ] });
}
const tw = "_text_1ywb7_11", rw = "_title_1ywb7_19", nw = "_subtitle_1ywb7_28", iw = "_buttons_1ywb7_38", ta = {
  "start-window": "_start-window_1ywb7_1",
  text: tw,
  title: rw,
  subtitle: nw,
  buttons: iw,
  "camera-button": "_camera-button_1ywb7_46",
  "gallery-button": "_gallery-button_1ywb7_50",
  "phone-button": "_phone-button_1ywb7_54"
};
function YD(e) {
  let {
    onStart: r,
    onFileImageSet: t,
    title: a,
    subtitle: o,
    allowRemote: l = !1,
    onRemoteDevice: c
  } = e;
  const {
    onEvent: f,
    multipleFileInput: p = !0,
    fromCameraButton: u = !0,
    uploadFileButton: h = !0
  } = nr(), C = oe.useRef(null), {
    translate: E
  } = Hi.useLocalize(), _ = () => {
    const g = C.current;
    g && (f({
      action: pt.PRESS_FILE_BUTTON,
      data: null
    }), g.click());
  }, S = (g) => {
    var O;
    (O = g.target.files) !== null && O !== void 0 && O.length && t(g.target.files);
  }, v = () => {
    f({
      action: pt.PRESS_REMOTE_DEVICE_BUTTON,
      data: null
    }), c == null || c();
  };
  return /* @__PURE__ */ Z.jsxs("div", { part: "menu-container", className: ta["start-window"], children: [
    /* @__PURE__ */ Z.jsxs("div", { "aria-live": "polite", part: "menu-text-container", className: ta.text, children: [
      /* @__PURE__ */ Z.jsx("h1", { part: "menu-title", className: ta.title, children: a }),
      /* @__PURE__ */ Z.jsx("p", { part: "menu-subtitle", className: ta.subtitle, children: o })
    ] }),
    /* @__PURE__ */ Z.jsxs("div", { part: "menu-buttons-container", className: ta.buttons, children: [
      u && /* @__PURE__ */ Z.jsx(Ul, { part: "menu-from-camera-button", e2e: "from-camera", className: ta["camera-button"], onClick: r, children: E("camera") }),
      h && /* @__PURE__ */ Z.jsx(Ul, { part: "menu-from-gallery-button", e2e: "from-gallery", className: ta["gallery-button"], onClick: _, children: E(Kt.isMobile ? "gallery" : "files") }),
      l && c && /* @__PURE__ */ Z.jsx(Ul, { part: "menu-from-mobile-button", e2e: "from-other-phone", className: ta["phone-button"], onClick: v, children: E("mobileDevice") })
    ] }),
    /* @__PURE__ */ Z.jsx("input", { ref: C, style: {
      display: "none"
    }, type: "file", multiple: p, accept: EO.join(","), onChange: S })
  ] });
}
var EI = {}, CI;
function aw() {
  if (CI) return EI;
  CI = 1;
  var e = zt(), r = Js(), t = en(), a = or(), o = Ga(), l = Yn(), c = Za(), f = ac(), p = gt(), u = TypeError, h = p(function() {
    [].keys().reduce(function() {
    }, void 0);
  }), C = !h && c("reduce", u);
  return e({ target: "Iterator", proto: !0, real: !0, forced: h || C }, {
    reduce: function(_) {
      a(this);
      try {
        t(_);
      } catch (R) {
        l(this, "throw", R);
      }
      var S = arguments.length < 2, v = S ? void 0 : arguments[1];
      if (C)
        return f(C, this, S ? [_] : [_, v]);
      var g = o(this), O = 0;
      if (r(g, function(R) {
        S ? (S = !1, v = R) : v = _(v, R, O), O++;
      }, { IS_RECORD: !0 }), S) throw new u("Reduce of empty iterator with no initial value");
      return v;
    }
  }), EI;
}
aw();
function SI(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    r && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function II(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? SI(Object(t), !0).forEach(function(a) {
      ow(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : SI(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function ow(e, r, t) {
  return (r = sw(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function sw(e) {
  var r = lw(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function lw(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const vI = jr.create("main");
function cw(e) {
  let {
    imageDataArray: r,
    onEvent: t,
    onError: a,
    isRecognizerProcessParam: o
  } = e;
  const l = window.RegulaDocumentSDK, {
    internalScenario: c
  } = nr(), [f, p] = oe.useState(void 0), [u, h] = oe.useState({
    status: at.SERVICE_PREPARING,
    response: null
  }), {
    initialized: C
  } = WD({
    scenario: f,
    onError: a
  });
  return oe.useEffect(() => {
    if (l) {
      if (l.imageProcessParam = Zr(hO, l.imageProcessParam), c !== void 0) {
        const E = {
          processParam: {
            scenario: c
          }
        };
        l.imageProcessParam = Zr(l.imageProcessParam, E);
      }
      p(o ? l.recognizerProcessParam.processParam.scenario : l.imageProcessParam.processParam.scenario);
    }
  }, [l, c, o]), oe.useEffect(() => {
    const E = !!ph[u.status];
    if (!l || !C || !r.length || E) return;
    t({
      action: pt.FILE_PROCESS_STARTED,
      data: null
    });
    const _ = o ? l.recognizerProcessParam : l.imageProcessParam;
    l.processingListener = (S) => Ae(null, null, function* () {
      let {
        isProcessing: v
      } = S;
      if (!v) {
        l.processingListener = null, vI("Image processing started");
        try {
          var g;
          if ((g = l.imageProcessParam.processParam) !== null && g !== void 0 && g.backendProcessing) {
            var O;
            const D = W8([], "", "8.4.2541".trim(), ((O = l.recognizerProcessParam.processParam) === null || O === void 0 || (O = O.backendProcessing) === null || O === void 0 ? void 0 : O.serviceURL) || "");
            yield l.createBackendTransaction(D, l.imageProcessParam);
          }
          const R = yield l.processImage(r, _);
          h((D) => II(II({}, D), {}, {
            status: at.SUCCESS,
            response: R
          })), vI("Image processing is finished");
        } catch (R) {
          h({
            response: null,
            status: at.FAILED
          }), a(new $t(rr.WASM_ERROR, R));
        }
      }
    });
  }, [C, u.status, r, o]), u;
}
function uw(e) {
  let {
    onStatusChange: r,
    images: t,
    onError: a
  } = e;
  const o = window.RegulaDocumentSDK, l = oe.useRef(!1), {
    onEvent: c,
    mobileDelegate: f,
    maxImageSize: p,
    maxResolutionSize: u
  } = nr(), [h, C] = oe.useState(!1), [E, _] = oe.useState([]), {
    status: S,
    response: v
  } = cw({
    imageDataArray: E,
    onEvent: c,
    onError: a,
    isRecognizerProcessParam: h
  });
  return oe.useEffect(() => {
    if (!(!t || l.current)) {
      if (l.current = !0, !(t instanceof FileList))
        return C(!0), _(t);
      zD(t).then((g) => {
        const {
          resolution: O,
          bytes: R
        } = g.reduce((L, P) => (L.resolution += P.width * P.height, L.bytes += P.data.byteLength, L), {
          resolution: 0,
          bytes: 0
        }), D = p && R / 1024 > p;
        if (O > (u || g8) || D)
          a(new $t(rr.FILE_SIZE));
        else {
          const L = g.map((P) => {
            let {
              data: M
            } = P;
            return M;
          });
          _(L);
        }
      }).catch((g) => {
        a(g);
      }).then(() => {
        l.current = !1;
      });
    }
  }, [t, p, u]), oe.useEffect(() => {
    if (S === at.SUCCESS && v) {
      const O = o.recognizerProcessParam.processParam.backendProcessing && h;
      O && (o.onFinalize = () => r(f ? Me.DELEGATE_SUCCESS : Me.SUCCESS)), c({
        action: pt.PROCESS_FINISHED,
        data: {
          status: Li.OK,
          response: v
        }
      }), r(O ? Me.PROCESSING : Me.SUCCESS);
    }
  }, [S, v, h, o, f]), /* @__PURE__ */ Z.jsx(e2, {});
}
function fw() {
  if (typeof document == "undefined") return null;
  const e = document.documentElement;
  return e && typeof e.getAttribute == "function" ? e.getAttribute("lang") : null;
}
function dw() {
  return typeof navigator != "undefined" ? window.navigator.language : null;
}
function KD(e) {
  function r(t) {
    const {
      locale: a,
      translations: o,
      dictionaries: l
    } = t;
    let c = l;
    if (o)
      for (const h in o)
        if (Object.prototype.hasOwnProperty.call(l, h))
          c = Zr(c, {
            [h]: o[h]
          });
        else {
          const C = Zr(l.en, o[h]);
          c = Zr(c, {
            [h]: C
          });
        }
    let f = CO;
    const p = [a, fw(), dw()];
    for (const h of p) {
      if (!h) continue;
      const C = h.substring(0, 2).toLowerCase();
      if (Object.prototype.hasOwnProperty.call(c, C)) {
        f = C;
        break;
      }
    }
    const u = SO.includes(f) ? Zl.Rtl : Zl.Ltr;
    return /* @__PURE__ */ Z.jsx(Hi.LocalizationProvider, { disableCache: !0, locale: f, translations: c, children: /* @__PURE__ */ Z.jsx(e, Qi(be({}, t), { direction: u })) });
  }
  return r;
}
function XD(e) {
  function r(t) {
    return /* @__PURE__ */ Z.jsx(K8.Provider, { value: t, children: /* @__PURE__ */ Z.jsx(e, be({}, t)) });
  }
  return r;
}
function gI(e, r, t) {
  return (r = pw(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function pw(e) {
  var r = hw(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function hw(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class QD extends oe.Component {
  constructor(r) {
    super(r), gI(this, "onError", void 0), gI(this, "supportedBrowserVersions", void 0), this.supportedBrowserVersions = r.supportedBrowserVersions, this.onError = r.onError;
  }
  componentDidCatch(r) {
    this.onError(new $t("UNKNOWN_ERROR", r));
  }
  componentDidMount() {
    if (this.supportedBrowserVersions) {
      let r = null;
      if (Kt.isMobile && Kt.osName in this.supportedBrowserVersions && (r = this.supportedBrowserVersions[Kt.osName]), Kt.isDesktop && (r = this.supportedBrowserVersions.desktop), r && Kt.browserName in r) {
        const t = r[Kt.browserName];
        t !== void 0 && Number(Kt.browserVersion) < t && this.onError(new $t("NOT_SUPPORTED"));
      }
    }
  }
  render() {
    return this.props.children;
  }
}
function mw() {
  const e = () => window.matchMedia("(orientation: landscape)").matches ? "landscape" : "portrait", [r, t] = oe.useState(() => {
    const o = e();
    return {
      isPortrait: o === "portrait",
      isLandscape: o === "landscape",
      orientation: o
    };
  }), a = oe.useCallback(() => {
    const o = e();
    t((l) => l.orientation !== o ? {
      isPortrait: o === "portrait",
      isLandscape: o === "landscape",
      orientation: o
    } : l);
  }, []);
  return oe.useEffect(() => (typeof window != "undefined" && (a(), window.addEventListener("load", a, !1), window.addEventListener("resize", a, !1)), () => {
    window.removeEventListener("load", a, !1), window.removeEventListener("resize", a, !1);
  }), [a]), r;
}
const _w = "_text_18b5u_19", Ew = "_title_18b5u_27", Cw = "_subtitle_18b5u_36", Sw = "_divider_18b5u_52", Iw = "_button_18b5u_71", ra = {
  "remote-scanner-wrapper": "_remote-scanner-wrapper_18b5u_1",
  "qr-container": "_qr-container_18b5u_11",
  text: _w,
  title: Ew,
  subtitle: Cw,
  "content-container": "_content-container_18b5u_46",
  divider: Sw,
  button: Iw
};
var vw = Object.defineProperty, Kl = Object.getOwnPropertySymbols, JD = Object.prototype.hasOwnProperty, eR = Object.prototype.propertyIsEnumerable, DI = (e, r, t) => r in e ? vw(e, r, { enumerable: !0, configurable: !0, writable: !0, value: t }) : e[r] = t, Pp = (e, r) => {
  for (var t in r || (r = {}))
    JD.call(r, t) && DI(e, t, r[t]);
  if (Kl)
    for (var t of Kl(r))
      eR.call(r, t) && DI(e, t, r[t]);
  return e;
}, wp = (e, r) => {
  var t = {};
  for (var a in e)
    JD.call(e, a) && r.indexOf(a) < 0 && (t[a] = e[a]);
  if (e != null && Kl)
    for (var a of Kl(e))
      r.indexOf(a) < 0 && eR.call(e, a) && (t[a] = e[a]);
  return t;
};
/**
 * @license QR Code generator library (TypeScript)
 * Copyright (c) Project Nayuki.
 * SPDX-License-Identifier: MIT
 */
var Fa;
((e) => {
  const r = class Ct {
    /*-- Constructor (low level) and fields --*/
    // Creates a new QR Code with the given version number,
    // error correction level, data codeword bytes, and mask number.
    // This is a low-level API that most users should not use directly.
    // A mid-level API is the encodeSegments() function.
    constructor(p, u, h, C) {
      if (this.version = p, this.errorCorrectionLevel = u, this.modules = [], this.isFunction = [], p < Ct.MIN_VERSION || p > Ct.MAX_VERSION)
        throw new RangeError("Version value out of range");
      if (C < -1 || C > 7)
        throw new RangeError("Mask value out of range");
      this.size = p * 4 + 17;
      let E = [];
      for (let S = 0; S < this.size; S++)
        E.push(!1);
      for (let S = 0; S < this.size; S++)
        this.modules.push(E.slice()), this.isFunction.push(E.slice());
      this.drawFunctionPatterns();
      const _ = this.addEccAndInterleave(h);
      if (this.drawCodewords(_), C == -1) {
        let S = 1e9;
        for (let v = 0; v < 8; v++) {
          this.applyMask(v), this.drawFormatBits(v);
          const g = this.getPenaltyScore();
          g < S && (C = v, S = g), this.applyMask(v);
        }
      }
      o(0 <= C && C <= 7), this.mask = C, this.applyMask(C), this.drawFormatBits(C), this.isFunction = [];
    }
    /*-- Static factory functions (high level) --*/
    // Returns a QR Code representing the given Unicode text string at the given error correction level.
    // As a conservative upper bound, this function is guaranteed to succeed for strings that have 738 or fewer
    // Unicode code points (not UTF-16 code units) if the low error correction level is used. The smallest possible
    // QR Code version is automatically chosen for the output. The ECC level of the result may be higher than the
    // ecl argument if it can be done without increasing the version.
    static encodeText(p, u) {
      const h = e.QrSegment.makeSegments(p);
      return Ct.encodeSegments(h, u);
    }
    // Returns a QR Code representing the given binary data at the given error correction level.
    // This function always encodes using the binary segment mode, not any text mode. The maximum number of
    // bytes allowed is 2953. The smallest possible QR Code version is automatically chosen for the output.
    // The ECC level of the result may be higher than the ecl argument if it can be done without increasing the version.
    static encodeBinary(p, u) {
      const h = e.QrSegment.makeBytes(p);
      return Ct.encodeSegments([h], u);
    }
    /*-- Static factory functions (mid level) --*/
    // Returns a QR Code representing the given segments with the given encoding parameters.
    // The smallest possible QR Code version within the given range is automatically
    // chosen for the output. Iff boostEcl is true, then the ECC level of the result
    // may be higher than the ecl argument if it can be done without increasing the
    // version. The mask number is either between 0 to 7 (inclusive) to force that
    // mask, or -1 to automatically choose an appropriate mask (which may be slow).
    // This function allows the user to create a custom sequence of segments that switches
    // between modes (such as alphanumeric and byte) to encode text in less space.
    // This is a mid-level API; the high-level API is encodeText() and encodeBinary().
    static encodeSegments(p, u, h = 1, C = 40, E = -1, _ = !0) {
      if (!(Ct.MIN_VERSION <= h && h <= C && C <= Ct.MAX_VERSION) || E < -1 || E > 7)
        throw new RangeError("Invalid value");
      let S, v;
      for (S = h; ; S++) {
        const D = Ct.getNumDataCodewords(S, u) * 8, T = c.getTotalBits(p, S);
        if (T <= D) {
          v = T;
          break;
        }
        if (S >= C)
          throw new RangeError("Data too long");
      }
      for (const D of [Ct.Ecc.MEDIUM, Ct.Ecc.QUARTILE, Ct.Ecc.HIGH])
        _ && v <= Ct.getNumDataCodewords(S, D) * 8 && (u = D);
      let g = [];
      for (const D of p) {
        t(D.mode.modeBits, 4, g), t(D.numChars, D.mode.numCharCountBits(S), g);
        for (const T of D.getData())
          g.push(T);
      }
      o(g.length == v);
      const O = Ct.getNumDataCodewords(S, u) * 8;
      o(g.length <= O), t(0, Math.min(4, O - g.length), g), t(0, (8 - g.length % 8) % 8, g), o(g.length % 8 == 0);
      for (let D = 236; g.length < O; D ^= 253)
        t(D, 8, g);
      let R = [];
      for (; R.length * 8 < g.length; )
        R.push(0);
      return g.forEach((D, T) => R[T >>> 3] |= D << 7 - (T & 7)), new Ct(S, u, R, E);
    }
    /*-- Accessor methods --*/
    // Returns the color of the module (pixel) at the given coordinates, which is false
    // for light or true for dark. The top left corner has the coordinates (x=0, y=0).
    // If the given coordinates are out of bounds, then false (light) is returned.
    getModule(p, u) {
      return 0 <= p && p < this.size && 0 <= u && u < this.size && this.modules[u][p];
    }
    // Modified to expose modules for easy access
    getModules() {
      return this.modules;
    }
    /*-- Private helper methods for constructor: Drawing function modules --*/
    // Reads this object's version field, and draws and marks all function modules.
    drawFunctionPatterns() {
      for (let h = 0; h < this.size; h++)
        this.setFunctionModule(6, h, h % 2 == 0), this.setFunctionModule(h, 6, h % 2 == 0);
      this.drawFinderPattern(3, 3), this.drawFinderPattern(this.size - 4, 3), this.drawFinderPattern(3, this.size - 4);
      const p = this.getAlignmentPatternPositions(), u = p.length;
      for (let h = 0; h < u; h++)
        for (let C = 0; C < u; C++)
          h == 0 && C == 0 || h == 0 && C == u - 1 || h == u - 1 && C == 0 || this.drawAlignmentPattern(p[h], p[C]);
      this.drawFormatBits(0), this.drawVersion();
    }
    // Draws two copies of the format bits (with its own error correction code)
    // based on the given mask and this object's error correction level field.
    drawFormatBits(p) {
      const u = this.errorCorrectionLevel.formatBits << 3 | p;
      let h = u;
      for (let E = 0; E < 10; E++)
        h = h << 1 ^ (h >>> 9) * 1335;
      const C = (u << 10 | h) ^ 21522;
      o(C >>> 15 == 0);
      for (let E = 0; E <= 5; E++)
        this.setFunctionModule(8, E, a(C, E));
      this.setFunctionModule(8, 7, a(C, 6)), this.setFunctionModule(8, 8, a(C, 7)), this.setFunctionModule(7, 8, a(C, 8));
      for (let E = 9; E < 15; E++)
        this.setFunctionModule(14 - E, 8, a(C, E));
      for (let E = 0; E < 8; E++)
        this.setFunctionModule(this.size - 1 - E, 8, a(C, E));
      for (let E = 8; E < 15; E++)
        this.setFunctionModule(8, this.size - 15 + E, a(C, E));
      this.setFunctionModule(8, this.size - 8, !0);
    }
    // Draws two copies of the version bits (with its own error correction code),
    // based on this object's version field, iff 7 <= version <= 40.
    drawVersion() {
      if (this.version < 7)
        return;
      let p = this.version;
      for (let h = 0; h < 12; h++)
        p = p << 1 ^ (p >>> 11) * 7973;
      const u = this.version << 12 | p;
      o(u >>> 18 == 0);
      for (let h = 0; h < 18; h++) {
        const C = a(u, h), E = this.size - 11 + h % 3, _ = Math.floor(h / 3);
        this.setFunctionModule(E, _, C), this.setFunctionModule(_, E, C);
      }
    }
    // Draws a 9*9 finder pattern including the border separator,
    // with the center module at (x, y). Modules can be out of bounds.
    drawFinderPattern(p, u) {
      for (let h = -4; h <= 4; h++)
        for (let C = -4; C <= 4; C++) {
          const E = Math.max(Math.abs(C), Math.abs(h)), _ = p + C, S = u + h;
          0 <= _ && _ < this.size && 0 <= S && S < this.size && this.setFunctionModule(_, S, E != 2 && E != 4);
        }
    }
    // Draws a 5*5 alignment pattern, with the center module
    // at (x, y). All modules must be in bounds.
    drawAlignmentPattern(p, u) {
      for (let h = -2; h <= 2; h++)
        for (let C = -2; C <= 2; C++)
          this.setFunctionModule(p + C, u + h, Math.max(Math.abs(C), Math.abs(h)) != 1);
    }
    // Sets the color of a module and marks it as a function module.
    // Only used by the constructor. Coordinates must be in bounds.
    setFunctionModule(p, u, h) {
      this.modules[u][p] = h, this.isFunction[u][p] = !0;
    }
    /*-- Private helper methods for constructor: Codewords and masking --*/
    // Returns a new byte string representing the given data with the appropriate error correction
    // codewords appended to it, based on this object's version and error correction level.
    addEccAndInterleave(p) {
      const u = this.version, h = this.errorCorrectionLevel;
      if (p.length != Ct.getNumDataCodewords(u, h))
        throw new RangeError("Invalid argument");
      const C = Ct.NUM_ERROR_CORRECTION_BLOCKS[h.ordinal][u], E = Ct.ECC_CODEWORDS_PER_BLOCK[h.ordinal][u], _ = Math.floor(Ct.getNumRawDataModules(u) / 8), S = C - _ % C, v = Math.floor(_ / C);
      let g = [];
      const O = Ct.reedSolomonComputeDivisor(E);
      for (let D = 0, T = 0; D < C; D++) {
        let L = p.slice(T, T + v - E + (D < S ? 0 : 1));
        T += L.length;
        const P = Ct.reedSolomonComputeRemainder(L, O);
        D < S && L.push(0), g.push(L.concat(P));
      }
      let R = [];
      for (let D = 0; D < g[0].length; D++)
        g.forEach((T, L) => {
          (D != v - E || L >= S) && R.push(T[D]);
        });
      return o(R.length == _), R;
    }
    // Draws the given sequence of 8-bit codewords (data and error correction) onto the entire
    // data area of this QR Code. Function modules need to be marked off before this is called.
    drawCodewords(p) {
      if (p.length != Math.floor(Ct.getNumRawDataModules(this.version) / 8))
        throw new RangeError("Invalid argument");
      let u = 0;
      for (let h = this.size - 1; h >= 1; h -= 2) {
        h == 6 && (h = 5);
        for (let C = 0; C < this.size; C++)
          for (let E = 0; E < 2; E++) {
            const _ = h - E, v = (h + 1 & 2) == 0 ? this.size - 1 - C : C;
            !this.isFunction[v][_] && u < p.length * 8 && (this.modules[v][_] = a(p[u >>> 3], 7 - (u & 7)), u++);
          }
      }
      o(u == p.length * 8);
    }
    // XORs the codeword modules in this QR Code with the given mask pattern.
    // The function modules must be marked and the codeword bits must be drawn
    // before masking. Due to the arithmetic of XOR, calling applyMask() with
    // the same mask value a second time will undo the mask. A final well-formed
    // QR Code needs exactly one (not zero, two, etc.) mask applied.
    applyMask(p) {
      if (p < 0 || p > 7)
        throw new RangeError("Mask value out of range");
      for (let u = 0; u < this.size; u++)
        for (let h = 0; h < this.size; h++) {
          let C;
          switch (p) {
            case 0:
              C = (h + u) % 2 == 0;
              break;
            case 1:
              C = u % 2 == 0;
              break;
            case 2:
              C = h % 3 == 0;
              break;
            case 3:
              C = (h + u) % 3 == 0;
              break;
            case 4:
              C = (Math.floor(h / 3) + Math.floor(u / 2)) % 2 == 0;
              break;
            case 5:
              C = h * u % 2 + h * u % 3 == 0;
              break;
            case 6:
              C = (h * u % 2 + h * u % 3) % 2 == 0;
              break;
            case 7:
              C = ((h + u) % 2 + h * u % 3) % 2 == 0;
              break;
            default:
              throw new Error("Unreachable");
          }
          !this.isFunction[u][h] && C && (this.modules[u][h] = !this.modules[u][h]);
        }
    }
    // Calculates and returns the penalty score based on state of this QR Code's current modules.
    // This is used by the automatic mask choice algorithm to find the mask pattern that yields the lowest score.
    getPenaltyScore() {
      let p = 0;
      for (let E = 0; E < this.size; E++) {
        let _ = !1, S = 0, v = [0, 0, 0, 0, 0, 0, 0];
        for (let g = 0; g < this.size; g++)
          this.modules[E][g] == _ ? (S++, S == 5 ? p += Ct.PENALTY_N1 : S > 5 && p++) : (this.finderPenaltyAddHistory(S, v), _ || (p += this.finderPenaltyCountPatterns(v) * Ct.PENALTY_N3), _ = this.modules[E][g], S = 1);
        p += this.finderPenaltyTerminateAndCount(_, S, v) * Ct.PENALTY_N3;
      }
      for (let E = 0; E < this.size; E++) {
        let _ = !1, S = 0, v = [0, 0, 0, 0, 0, 0, 0];
        for (let g = 0; g < this.size; g++)
          this.modules[g][E] == _ ? (S++, S == 5 ? p += Ct.PENALTY_N1 : S > 5 && p++) : (this.finderPenaltyAddHistory(S, v), _ || (p += this.finderPenaltyCountPatterns(v) * Ct.PENALTY_N3), _ = this.modules[g][E], S = 1);
        p += this.finderPenaltyTerminateAndCount(_, S, v) * Ct.PENALTY_N3;
      }
      for (let E = 0; E < this.size - 1; E++)
        for (let _ = 0; _ < this.size - 1; _++) {
          const S = this.modules[E][_];
          S == this.modules[E][_ + 1] && S == this.modules[E + 1][_] && S == this.modules[E + 1][_ + 1] && (p += Ct.PENALTY_N2);
        }
      let u = 0;
      for (const E of this.modules)
        u = E.reduce((_, S) => _ + (S ? 1 : 0), u);
      const h = this.size * this.size, C = Math.ceil(Math.abs(u * 20 - h * 10) / h) - 1;
      return o(0 <= C && C <= 9), p += C * Ct.PENALTY_N4, o(0 <= p && p <= 2568888), p;
    }
    /*-- Private helper functions --*/
    // Returns an ascending list of positions of alignment patterns for this version number.
    // Each position is in the range [0,177), and are used on both the x and y axes.
    // This could be implemented as lookup table of 40 variable-length lists of integers.
    getAlignmentPatternPositions() {
      if (this.version == 1)
        return [];
      {
        const p = Math.floor(this.version / 7) + 2, u = this.version == 32 ? 26 : Math.ceil((this.version * 4 + 4) / (p * 2 - 2)) * 2;
        let h = [6];
        for (let C = this.size - 7; h.length < p; C -= u)
          h.splice(1, 0, C);
        return h;
      }
    }
    // Returns the number of data bits that can be stored in a QR Code of the given version number, after
    // all function modules are excluded. This includes remainder bits, so it might not be a multiple of 8.
    // The result is in the range [208, 29648]. This could be implemented as a 40-entry lookup table.
    static getNumRawDataModules(p) {
      if (p < Ct.MIN_VERSION || p > Ct.MAX_VERSION)
        throw new RangeError("Version number out of range");
      let u = (16 * p + 128) * p + 64;
      if (p >= 2) {
        const h = Math.floor(p / 7) + 2;
        u -= (25 * h - 10) * h - 55, p >= 7 && (u -= 36);
      }
      return o(208 <= u && u <= 29648), u;
    }
    // Returns the number of 8-bit data (i.e. not error correction) codewords contained in any
    // QR Code of the given version number and error correction level, with remainder bits discarded.
    // This stateless pure function could be implemented as a (40*4)-cell lookup table.
    static getNumDataCodewords(p, u) {
      return Math.floor(Ct.getNumRawDataModules(p) / 8) - Ct.ECC_CODEWORDS_PER_BLOCK[u.ordinal][p] * Ct.NUM_ERROR_CORRECTION_BLOCKS[u.ordinal][p];
    }
    // Returns a Reed-Solomon ECC generator polynomial for the given degree. This could be
    // implemented as a lookup table over all possible parameter values, instead of as an algorithm.
    static reedSolomonComputeDivisor(p) {
      if (p < 1 || p > 255)
        throw new RangeError("Degree out of range");
      let u = [];
      for (let C = 0; C < p - 1; C++)
        u.push(0);
      u.push(1);
      let h = 1;
      for (let C = 0; C < p; C++) {
        for (let E = 0; E < u.length; E++)
          u[E] = Ct.reedSolomonMultiply(u[E], h), E + 1 < u.length && (u[E] ^= u[E + 1]);
        h = Ct.reedSolomonMultiply(h, 2);
      }
      return u;
    }
    // Returns the Reed-Solomon error correction codeword for the given data and divisor polynomials.
    static reedSolomonComputeRemainder(p, u) {
      let h = u.map((C) => 0);
      for (const C of p) {
        const E = C ^ h.shift();
        h.push(0), u.forEach((_, S) => h[S] ^= Ct.reedSolomonMultiply(_, E));
      }
      return h;
    }
    // Returns the product of the two given field elements modulo GF(2^8/0x11D). The arguments and result
    // are unsigned 8-bit integers. This could be implemented as a lookup table of 256*256 entries of uint8.
    static reedSolomonMultiply(p, u) {
      if (p >>> 8 || u >>> 8)
        throw new RangeError("Byte out of range");
      let h = 0;
      for (let C = 7; C >= 0; C--)
        h = h << 1 ^ (h >>> 7) * 285, h ^= (u >>> C & 1) * p;
      return o(h >>> 8 == 0), h;
    }
    // Can only be called immediately after a light run is added, and
    // returns either 0, 1, or 2. A helper function for getPenaltyScore().
    finderPenaltyCountPatterns(p) {
      const u = p[1];
      o(u <= this.size * 3);
      const h = u > 0 && p[2] == u && p[3] == u * 3 && p[4] == u && p[5] == u;
      return (h && p[0] >= u * 4 && p[6] >= u ? 1 : 0) + (h && p[6] >= u * 4 && p[0] >= u ? 1 : 0);
    }
    // Must be called at the end of a line (row or column) of modules. A helper function for getPenaltyScore().
    finderPenaltyTerminateAndCount(p, u, h) {
      return p && (this.finderPenaltyAddHistory(u, h), u = 0), u += this.size, this.finderPenaltyAddHistory(u, h), this.finderPenaltyCountPatterns(h);
    }
    // Pushes the given value to the front and drops the last value. A helper function for getPenaltyScore().
    finderPenaltyAddHistory(p, u) {
      u[0] == 0 && (p += this.size), u.pop(), u.unshift(p);
    }
  };
  r.MIN_VERSION = 1, r.MAX_VERSION = 40, r.PENALTY_N1 = 3, r.PENALTY_N2 = 3, r.PENALTY_N3 = 40, r.PENALTY_N4 = 10, r.ECC_CODEWORDS_PER_BLOCK = [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    //0,  1,  2,  3,  4,  5,  6,  7,  8,  9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [-1, 7, 10, 15, 20, 26, 18, 20, 24, 30, 18, 20, 24, 26, 30, 22, 24, 28, 30, 28, 28, 28, 28, 30, 30, 26, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    // Low
    [-1, 10, 16, 26, 18, 24, 16, 18, 22, 22, 26, 30, 22, 22, 24, 24, 28, 28, 26, 26, 26, 26, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28, 28],
    // Medium
    [-1, 13, 22, 18, 26, 18, 24, 18, 22, 20, 24, 28, 26, 24, 20, 30, 24, 28, 28, 26, 30, 28, 30, 30, 30, 30, 28, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30],
    // Quartile
    [-1, 17, 28, 22, 16, 22, 28, 26, 26, 24, 28, 24, 28, 22, 24, 24, 30, 28, 28, 26, 28, 30, 24, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]
    // High
  ], r.NUM_ERROR_CORRECTION_BLOCKS = [
    // Version: (note that index 0 is for padding, and is set to an illegal value)
    //0, 1, 2, 3, 4, 5, 6, 7, 8, 9,10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40    Error correction level
    [-1, 1, 1, 1, 1, 1, 2, 2, 2, 2, 4, 4, 4, 4, 4, 6, 6, 6, 6, 7, 8, 8, 9, 9, 10, 12, 12, 12, 13, 14, 15, 16, 17, 18, 19, 19, 20, 21, 22, 24, 25],
    // Low
    [-1, 1, 1, 1, 2, 2, 4, 4, 4, 5, 5, 5, 8, 9, 9, 10, 10, 11, 13, 14, 16, 17, 17, 18, 20, 21, 23, 25, 26, 28, 29, 31, 33, 35, 37, 38, 40, 43, 45, 47, 49],
    // Medium
    [-1, 1, 1, 2, 2, 4, 4, 6, 6, 8, 8, 8, 10, 12, 16, 12, 17, 16, 18, 21, 20, 23, 23, 25, 27, 29, 34, 34, 35, 38, 40, 43, 45, 48, 51, 53, 56, 59, 62, 65, 68],
    // Quartile
    [-1, 1, 1, 2, 4, 4, 4, 5, 6, 8, 8, 11, 11, 16, 16, 18, 16, 19, 21, 25, 25, 25, 34, 30, 32, 35, 37, 40, 42, 45, 48, 51, 54, 57, 60, 63, 66, 70, 74, 77, 81]
    // High
  ], e.QrCode = r;
  function t(f, p, u) {
    if (p < 0 || p > 31 || f >>> p)
      throw new RangeError("Value out of range");
    for (let h = p - 1; h >= 0; h--)
      u.push(f >>> h & 1);
  }
  function a(f, p) {
    return (f >>> p & 1) != 0;
  }
  function o(f) {
    if (!f)
      throw new Error("Assertion error");
  }
  const l = class er {
    /*-- Constructor (low level) and fields --*/
    // Creates a new QR Code segment with the given attributes and data.
    // The character count (numChars) must agree with the mode and the bit buffer length,
    // but the constraint isn't checked. The given bit buffer is cloned and stored.
    constructor(p, u, h) {
      if (this.mode = p, this.numChars = u, this.bitData = h, u < 0)
        throw new RangeError("Invalid argument");
      this.bitData = h.slice();
    }
    /*-- Static factory functions (mid level) --*/
    // Returns a segment representing the given binary data encoded in
    // byte mode. All input byte arrays are acceptable. Any text string
    // can be converted to UTF-8 bytes and encoded as a byte mode segment.
    static makeBytes(p) {
      let u = [];
      for (const h of p)
        t(h, 8, u);
      return new er(er.Mode.BYTE, p.length, u);
    }
    // Returns a segment representing the given string of decimal digits encoded in numeric mode.
    static makeNumeric(p) {
      if (!er.isNumeric(p))
        throw new RangeError("String contains non-numeric characters");
      let u = [];
      for (let h = 0; h < p.length; ) {
        const C = Math.min(p.length - h, 3);
        t(parseInt(p.substring(h, h + C), 10), C * 3 + 1, u), h += C;
      }
      return new er(er.Mode.NUMERIC, p.length, u);
    }
    // Returns a segment representing the given text string encoded in alphanumeric mode.
    // The characters allowed are: 0 to 9, A to Z (uppercase only), space,
    // dollar, percent, asterisk, plus, hyphen, period, slash, colon.
    static makeAlphanumeric(p) {
      if (!er.isAlphanumeric(p))
        throw new RangeError("String contains unencodable characters in alphanumeric mode");
      let u = [], h;
      for (h = 0; h + 2 <= p.length; h += 2) {
        let C = er.ALPHANUMERIC_CHARSET.indexOf(p.charAt(h)) * 45;
        C += er.ALPHANUMERIC_CHARSET.indexOf(p.charAt(h + 1)), t(C, 11, u);
      }
      return h < p.length && t(er.ALPHANUMERIC_CHARSET.indexOf(p.charAt(h)), 6, u), new er(er.Mode.ALPHANUMERIC, p.length, u);
    }
    // Returns a new mutable list of zero or more segments to represent the given Unicode text string.
    // The result may use various segment modes and switch modes to optimize the length of the bit stream.
    static makeSegments(p) {
      return p == "" ? [] : er.isNumeric(p) ? [er.makeNumeric(p)] : er.isAlphanumeric(p) ? [er.makeAlphanumeric(p)] : [er.makeBytes(er.toUtf8ByteArray(p))];
    }
    // Returns a segment representing an Extended Channel Interpretation
    // (ECI) designator with the given assignment value.
    static makeEci(p) {
      let u = [];
      if (p < 0)
        throw new RangeError("ECI assignment value out of range");
      if (p < 128)
        t(p, 8, u);
      else if (p < 16384)
        t(2, 2, u), t(p, 14, u);
      else if (p < 1e6)
        t(6, 3, u), t(p, 21, u);
      else
        throw new RangeError("ECI assignment value out of range");
      return new er(er.Mode.ECI, 0, u);
    }
    // Tests whether the given string can be encoded as a segment in numeric mode.
    // A string is encodable iff each character is in the range 0 to 9.
    static isNumeric(p) {
      return er.NUMERIC_REGEX.test(p);
    }
    // Tests whether the given string can be encoded as a segment in alphanumeric mode.
    // A string is encodable iff each character is in the following set: 0 to 9, A to Z
    // (uppercase only), space, dollar, percent, asterisk, plus, hyphen, period, slash, colon.
    static isAlphanumeric(p) {
      return er.ALPHANUMERIC_REGEX.test(p);
    }
    /*-- Methods --*/
    // Returns a new copy of the data bits of this segment.
    getData() {
      return this.bitData.slice();
    }
    // (Package-private) Calculates and returns the number of bits needed to encode the given segments at
    // the given version. The result is infinity if a segment has too many characters to fit its length field.
    static getTotalBits(p, u) {
      let h = 0;
      for (const C of p) {
        const E = C.mode.numCharCountBits(u);
        if (C.numChars >= 1 << E)
          return 1 / 0;
        h += 4 + E + C.bitData.length;
      }
      return h;
    }
    // Returns a new array of bytes representing the given string encoded in UTF-8.
    static toUtf8ByteArray(p) {
      p = encodeURI(p);
      let u = [];
      for (let h = 0; h < p.length; h++)
        p.charAt(h) != "%" ? u.push(p.charCodeAt(h)) : (u.push(parseInt(p.substring(h + 1, h + 3), 16)), h += 2);
      return u;
    }
  };
  l.NUMERIC_REGEX = /^[0-9]*$/, l.ALPHANUMERIC_REGEX = /^[A-Z0-9 $%*+.\/:-]*$/, l.ALPHANUMERIC_CHARSET = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ $%*+-./:";
  let c = l;
  e.QrSegment = l;
})(Fa || (Fa = {}));
((e) => {
  ((r) => {
    const t = class {
      // The QR Code can tolerate about 30% erroneous codewords
      /*-- Constructor and fields --*/
      constructor(o, l) {
        this.ordinal = o, this.formatBits = l;
      }
    };
    t.LOW = new t(0, 1), t.MEDIUM = new t(1, 0), t.QUARTILE = new t(2, 3), t.HIGH = new t(3, 2), r.Ecc = t;
  })(e.QrCode || (e.QrCode = {}));
})(Fa || (Fa = {}));
((e) => {
  ((r) => {
    const t = class {
      /*-- Constructor and fields --*/
      constructor(o, l) {
        this.modeBits = o, this.numBitsCharCount = l;
      }
      /*-- Method --*/
      // (Package-private) Returns the bit width of the character count field for a segment in
      // this mode in a QR Code at the given version number. The result is in the range [0, 16].
      numCharCountBits(o) {
        return this.numBitsCharCount[Math.floor((o + 7) / 17)];
      }
    };
    t.NUMERIC = new t(1, [10, 12, 14]), t.ALPHANUMERIC = new t(2, [9, 11, 13]), t.BYTE = new t(4, [8, 16, 16]), t.KANJI = new t(8, [8, 10, 12]), t.ECI = new t(7, [0, 0, 0]), r.Mode = t;
  })(e.QrSegment || (e.QrSegment = {}));
})(Fa || (Fa = {}));
var Lo = Fa;
/**
 * @license qrcode.react
 * Copyright (c) Paul O'Shannessy
 * SPDX-License-Identifier: ISC
 */
var gw = {
  L: Lo.QrCode.Ecc.LOW,
  M: Lo.QrCode.Ecc.MEDIUM,
  Q: Lo.QrCode.Ecc.QUARTILE,
  H: Lo.QrCode.Ecc.HIGH
}, tR = 128, rR = "L", nR = "#FFFFFF", iR = "#000000", aR = !1, oR = 1, Dw = 4, Rw = 0, Aw = 0.1;
function sR(e, r = 0) {
  const t = [];
  return e.forEach(function(a, o) {
    let l = null;
    a.forEach(function(c, f) {
      if (!c && l !== null) {
        t.push(
          `M${l + r} ${o + r}h${f - l}v1H${l + r}z`
        ), l = null;
        return;
      }
      if (f === a.length - 1) {
        if (!c)
          return;
        l === null ? t.push(`M${f + r},${o + r} h1v1H${f + r}z`) : t.push(
          `M${l + r},${o + r} h${f + 1 - l}v1H${l + r}z`
        );
        return;
      }
      c && l === null && (l = f);
    });
  }), t.join("");
}
function lR(e, r) {
  return e.slice().map((t, a) => a < r.y || a >= r.y + r.h ? t : t.map((o, l) => l < r.x || l >= r.x + r.w ? o : !1));
}
function Tw(e, r, t, a) {
  if (a == null)
    return null;
  const o = e.length + t * 2, l = Math.floor(r * Aw), c = o / r, f = (a.width || l) * c, p = (a.height || l) * c, u = a.x == null ? e.length / 2 - f / 2 : a.x * c, h = a.y == null ? e.length / 2 - p / 2 : a.y * c, C = a.opacity == null ? 1 : a.opacity;
  let E = null;
  if (a.excavate) {
    let S = Math.floor(u), v = Math.floor(h), g = Math.ceil(f + u - S), O = Math.ceil(p + h - v);
    E = { x: S, y: v, w: g, h: O };
  }
  const _ = a.crossOrigin;
  return { x: u, y: h, h: p, w: f, excavation: E, opacity: C, crossOrigin: _ };
}
function Ow(e, r) {
  return r != null ? Math.max(Math.floor(r), 0) : e ? Dw : Rw;
}
function cR({
  value: e,
  level: r,
  minVersion: t,
  includeMargin: a,
  marginSize: o,
  imageSettings: l,
  size: c,
  boostLevel: f
}) {
  let p = _t.useMemo(() => {
    const S = (Array.isArray(e) ? e : [e]).reduce((v, g) => (v.push(...Lo.QrSegment.makeSegments(g)), v), []);
    return Lo.QrCode.encodeSegments(
      S,
      gw[r],
      t,
      void 0,
      void 0,
      f
    );
  }, [e, r, t, f]);
  const { cells: u, margin: h, numCells: C, calculatedImageSettings: E } = _t.useMemo(() => {
    let _ = p.getModules();
    const S = Ow(a, o), v = _.length + S * 2, g = Tw(
      _,
      c,
      S,
      l
    );
    return {
      cells: _,
      margin: S,
      numCells: v,
      calculatedImageSettings: g
    };
  }, [p, c, l, a, o]);
  return {
    qrcode: p,
    margin: h,
    cells: u,
    numCells: C,
    calculatedImageSettings: E
  };
}
var yw = function() {
  try {
    new Path2D().addPath(new Path2D());
  } catch (e) {
    return !1;
  }
  return !0;
}(), Nw = _t.forwardRef(
  function(r, t) {
    const a = r, {
      value: o,
      size: l = tR,
      level: c = rR,
      bgColor: f = nR,
      fgColor: p = iR,
      includeMargin: u = aR,
      minVersion: h = oR,
      boostLevel: C,
      marginSize: E,
      imageSettings: _
    } = a, v = wp(a, [
      "value",
      "size",
      "level",
      "bgColor",
      "fgColor",
      "includeMargin",
      "minVersion",
      "boostLevel",
      "marginSize",
      "imageSettings"
    ]), { style: g } = v, O = wp(v, ["style"]), R = _ == null ? void 0 : _.src, D = _t.useRef(null), T = _t.useRef(null), L = _t.useCallback(
      (j) => {
        D.current = j, typeof t == "function" ? t(j) : t && (t.current = j);
      },
      [t]
    ), [P, M] = _t.useState(!1), { margin: k, cells: H, numCells: w, calculatedImageSettings: $ } = cR({
      value: o,
      level: c,
      minVersion: h,
      boostLevel: C,
      includeMargin: u,
      marginSize: E,
      imageSettings: _,
      size: l
    });
    _t.useEffect(() => {
      if (D.current != null) {
        const j = D.current, ie = j.getContext("2d");
        if (!ie)
          return;
        let se = H;
        const le = T.current, U = $ != null && le !== null && le.complete && le.naturalHeight !== 0 && le.naturalWidth !== 0;
        U && $.excavation != null && (se = lR(
          H,
          $.excavation
        ));
        const X = window.devicePixelRatio || 1;
        j.height = j.width = l * X;
        const K = l / w * X;
        ie.scale(K, K), ie.fillStyle = f, ie.fillRect(0, 0, w, w), ie.fillStyle = p, yw ? ie.fill(new Path2D(sR(se, k))) : H.forEach(function(y, G) {
          y.forEach(function(ce, ue) {
            ce && ie.fillRect(ue + k, G + k, 1, 1);
          });
        }), $ && (ie.globalAlpha = $.opacity), U && ie.drawImage(
          le,
          $.x + k,
          $.y + k,
          $.w,
          $.h
        );
      }
    }), _t.useEffect(() => {
      M(!1);
    }, [R]);
    const B = Pp({ height: l, width: l }, g);
    let Y = null;
    return R != null && (Y = /* @__PURE__ */ _t.createElement(
      "img",
      {
        src: R,
        key: R,
        style: { display: "none" },
        onLoad: () => {
          M(!0);
        },
        ref: T,
        crossOrigin: $ == null ? void 0 : $.crossOrigin
      }
    )), /* @__PURE__ */ _t.createElement(_t.Fragment, null, /* @__PURE__ */ _t.createElement(
      "canvas",
      Pp({
        style: B,
        height: l,
        width: l,
        ref: L,
        role: "img"
      }, O)
    ), Y);
  }
);
Nw.displayName = "QRCodeCanvas";
var uR = _t.forwardRef(
  function(r, t) {
    const a = r, {
      value: o,
      size: l = tR,
      level: c = rR,
      bgColor: f = nR,
      fgColor: p = iR,
      includeMargin: u = aR,
      minVersion: h = oR,
      boostLevel: C,
      title: E,
      marginSize: _,
      imageSettings: S
    } = a, v = wp(a, [
      "value",
      "size",
      "level",
      "bgColor",
      "fgColor",
      "includeMargin",
      "minVersion",
      "boostLevel",
      "title",
      "marginSize",
      "imageSettings"
    ]), { margin: g, cells: O, numCells: R, calculatedImageSettings: D } = cR({
      value: o,
      level: c,
      minVersion: h,
      boostLevel: C,
      includeMargin: u,
      marginSize: _,
      imageSettings: S,
      size: l
    });
    let T = O, L = null;
    S != null && D != null && (D.excavation != null && (T = lR(
      O,
      D.excavation
    )), L = /* @__PURE__ */ _t.createElement(
      "image",
      {
        href: S.src,
        height: D.h,
        width: D.w,
        x: D.x + g,
        y: D.y + g,
        preserveAspectRatio: "none",
        opacity: D.opacity,
        crossOrigin: D.crossOrigin
      }
    ));
    const P = sR(T, g);
    return /* @__PURE__ */ _t.createElement(
      "svg",
      Pp({
        height: l,
        width: l,
        viewBox: `0 0 ${R} ${R}`,
        ref: t,
        role: "img"
      }, v),
      !!E && /* @__PURE__ */ _t.createElement("title", null, E),
      /* @__PURE__ */ _t.createElement(
        "path",
        {
          fill: f,
          d: `M0,0 h${R}v${R}H0z`,
          shapeRendering: "crispEdges"
        }
      ),
      /* @__PURE__ */ _t.createElement("path", { fill: p, d: P, shapeRendering: "crispEdges" }),
      L
    );
  }
);
uR.displayName = "QRCodeSVG";
var Jf, RI;
function Lw() {
  if (RI) return Jf;
  RI = 1;
  function e() {
    this.__data__ = [], this.size = 0;
  }
  return Jf = e, Jf;
}
var ed, AI;
function Oh() {
  if (AI) return ed;
  AI = 1;
  function e(r, t) {
    return r === t || r !== r && t !== t;
  }
  return ed = e, ed;
}
var td, TI;
function Cc() {
  if (TI) return td;
  TI = 1;
  var e = Oh();
  function r(t, a) {
    for (var o = t.length; o--; )
      if (e(t[o][0], a))
        return o;
    return -1;
  }
  return td = r, td;
}
var rd, OI;
function Mw() {
  if (OI) return rd;
  OI = 1;
  var e = Cc(), r = Array.prototype, t = r.splice;
  function a(o) {
    var l = this.__data__, c = e(l, o);
    if (c < 0)
      return !1;
    var f = l.length - 1;
    return c == f ? l.pop() : t.call(l, c, 1), --this.size, !0;
  }
  return rd = a, rd;
}
var nd, yI;
function bw() {
  if (yI) return nd;
  yI = 1;
  var e = Cc();
  function r(t) {
    var a = this.__data__, o = e(a, t);
    return o < 0 ? void 0 : a[o][1];
  }
  return nd = r, nd;
}
var id, NI;
function Pw() {
  if (NI) return id;
  NI = 1;
  var e = Cc();
  function r(t) {
    return e(this.__data__, t) > -1;
  }
  return id = r, id;
}
var ad, LI;
function ww() {
  if (LI) return ad;
  LI = 1;
  var e = Cc();
  function r(t, a) {
    var o = this.__data__, l = e(o, t);
    return l < 0 ? (++this.size, o.push([t, a])) : o[l][1] = a, this;
  }
  return ad = r, ad;
}
var od, MI;
function Sc() {
  if (MI) return od;
  MI = 1;
  var e = Lw(), r = Mw(), t = bw(), a = Pw(), o = ww();
  function l(c) {
    var f = -1, p = c == null ? 0 : c.length;
    for (this.clear(); ++f < p; ) {
      var u = c[f];
      this.set(u[0], u[1]);
    }
  }
  return l.prototype.clear = e, l.prototype.delete = r, l.prototype.get = t, l.prototype.has = a, l.prototype.set = o, od = l, od;
}
var sd, bI;
function Hw() {
  if (bI) return sd;
  bI = 1;
  var e = Sc();
  function r() {
    this.__data__ = new e(), this.size = 0;
  }
  return sd = r, sd;
}
var ld, PI;
function Vw() {
  if (PI) return ld;
  PI = 1;
  function e(r) {
    var t = this.__data__, a = t.delete(r);
    return this.size = t.size, a;
  }
  return ld = e, ld;
}
var cd, wI;
function kw() {
  if (wI) return cd;
  wI = 1;
  function e(r) {
    return this.__data__.get(r);
  }
  return cd = e, cd;
}
var ud, HI;
function Fw() {
  if (HI) return ud;
  HI = 1;
  function e(r) {
    return this.__data__.has(r);
  }
  return ud = e, ud;
}
var fd, VI;
function fR() {
  if (VI) return fd;
  VI = 1;
  var e = typeof yo == "object" && yo && yo.Object === Object && yo;
  return fd = e, fd;
}
var dd, kI;
function Vi() {
  if (kI) return dd;
  kI = 1;
  var e = fR(), r = typeof self == "object" && self && self.Object === Object && self, t = e || r || Function("return this")();
  return dd = t, dd;
}
var pd, FI;
function a2() {
  if (FI) return pd;
  FI = 1;
  var e = Vi(), r = e.Symbol;
  return pd = r, pd;
}
var hd, xI;
function xw() {
  if (xI) return hd;
  xI = 1;
  var e = a2(), r = Object.prototype, t = r.hasOwnProperty, a = r.toString, o = e ? e.toStringTag : void 0;
  function l(c) {
    var f = t.call(c, o), p = c[o];
    try {
      c[o] = void 0;
      var u = !0;
    } catch (C) {
    }
    var h = a.call(c);
    return u && (f ? c[o] = p : delete c[o]), h;
  }
  return hd = l, hd;
}
var md, UI;
function Uw() {
  if (UI) return md;
  UI = 1;
  var e = Object.prototype, r = e.toString;
  function t(a) {
    return r.call(a);
  }
  return md = t, md;
}
var _d, BI;
function o2() {
  if (BI) return _d;
  BI = 1;
  var e = a2(), r = xw(), t = Uw(), a = "[object Null]", o = "[object Undefined]", l = e ? e.toStringTag : void 0;
  function c(f) {
    return f == null ? f === void 0 ? o : a : l && l in Object(f) ? r(f) : t(f);
  }
  return _d = c, _d;
}
var Ed, $I;
function yh() {
  if ($I) return Ed;
  $I = 1;
  function e(r) {
    var t = typeof r;
    return r != null && (t == "object" || t == "function");
  }
  return Ed = e, Ed;
}
var Cd, GI;
function dR() {
  if (GI) return Cd;
  GI = 1;
  var e = o2(), r = yh(), t = "[object AsyncFunction]", a = "[object Function]", o = "[object GeneratorFunction]", l = "[object Proxy]";
  function c(f) {
    if (!r(f))
      return !1;
    var p = e(f);
    return p == a || p == o || p == t || p == l;
  }
  return Cd = c, Cd;
}
var Sd, ZI;
function Bw() {
  if (ZI) return Sd;
  ZI = 1;
  var e = Vi(), r = e["__core-js_shared__"];
  return Sd = r, Sd;
}
var Id, jI;
function $w() {
  if (jI) return Id;
  jI = 1;
  var e = Bw(), r = function() {
    var a = /[^.]+$/.exec(e && e.keys && e.keys.IE_PROTO || "");
    return a ? "Symbol(src)_1." + a : "";
  }();
  function t(a) {
    return !!r && r in a;
  }
  return Id = t, Id;
}
var vd, zI;
function pR() {
  if (zI) return vd;
  zI = 1;
  var e = Function.prototype, r = e.toString;
  function t(a) {
    if (a != null) {
      try {
        return r.call(a);
      } catch (o) {
      }
      try {
        return a + "";
      } catch (o) {
      }
    }
    return "";
  }
  return vd = t, vd;
}
var gd, qI;
function Gw() {
  if (qI) return gd;
  qI = 1;
  var e = dR(), r = $w(), t = yh(), a = pR(), o = /[\\^$.*+?()[\]{}|]/g, l = /^\[object .+?Constructor\]$/, c = Function.prototype, f = Object.prototype, p = c.toString, u = f.hasOwnProperty, h = RegExp(
    "^" + p.call(u).replace(o, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  );
  function C(E) {
    if (!t(E) || r(E))
      return !1;
    var _ = e(E) ? h : l;
    return _.test(a(E));
  }
  return gd = C, gd;
}
var Dd, WI;
function Zw() {
  if (WI) return Dd;
  WI = 1;
  function e(r, t) {
    return r == null ? void 0 : r[t];
  }
  return Dd = e, Dd;
}
var Rd, YI;
function za() {
  if (YI) return Rd;
  YI = 1;
  var e = Gw(), r = Zw();
  function t(a, o) {
    var l = r(a, o);
    return e(l) ? l : void 0;
  }
  return Rd = t, Rd;
}
var Ad, KI;
function Nh() {
  if (KI) return Ad;
  KI = 1;
  var e = za(), r = Vi(), t = e(r, "Map");
  return Ad = t, Ad;
}
var Td, XI;
function Ic() {
  if (XI) return Td;
  XI = 1;
  var e = za(), r = e(Object, "create");
  return Td = r, Td;
}
var Od, QI;
function jw() {
  if (QI) return Od;
  QI = 1;
  var e = Ic();
  function r() {
    this.__data__ = e ? e(null) : {}, this.size = 0;
  }
  return Od = r, Od;
}
var yd, JI;
function zw() {
  if (JI) return yd;
  JI = 1;
  function e(r) {
    var t = this.has(r) && delete this.__data__[r];
    return this.size -= t ? 1 : 0, t;
  }
  return yd = e, yd;
}
var Nd, ev;
function qw() {
  if (ev) return Nd;
  ev = 1;
  var e = Ic(), r = "__lodash_hash_undefined__", t = Object.prototype, a = t.hasOwnProperty;
  function o(l) {
    var c = this.__data__;
    if (e) {
      var f = c[l];
      return f === r ? void 0 : f;
    }
    return a.call(c, l) ? c[l] : void 0;
  }
  return Nd = o, Nd;
}
var Ld, tv;
function Ww() {
  if (tv) return Ld;
  tv = 1;
  var e = Ic(), r = Object.prototype, t = r.hasOwnProperty;
  function a(o) {
    var l = this.__data__;
    return e ? l[o] !== void 0 : t.call(l, o);
  }
  return Ld = a, Ld;
}
var Md, rv;
function Yw() {
  if (rv) return Md;
  rv = 1;
  var e = Ic(), r = "__lodash_hash_undefined__";
  function t(a, o) {
    var l = this.__data__;
    return this.size += this.has(a) ? 0 : 1, l[a] = e && o === void 0 ? r : o, this;
  }
  return Md = t, Md;
}
var bd, nv;
function Kw() {
  if (nv) return bd;
  nv = 1;
  var e = jw(), r = zw(), t = qw(), a = Ww(), o = Yw();
  function l(c) {
    var f = -1, p = c == null ? 0 : c.length;
    for (this.clear(); ++f < p; ) {
      var u = c[f];
      this.set(u[0], u[1]);
    }
  }
  return l.prototype.clear = e, l.prototype.delete = r, l.prototype.get = t, l.prototype.has = a, l.prototype.set = o, bd = l, bd;
}
var Pd, iv;
function Xw() {
  if (iv) return Pd;
  iv = 1;
  var e = Kw(), r = Sc(), t = Nh();
  function a() {
    this.size = 0, this.__data__ = {
      hash: new e(),
      map: new (t || r)(),
      string: new e()
    };
  }
  return Pd = a, Pd;
}
var wd, av;
function Qw() {
  if (av) return wd;
  av = 1;
  function e(r) {
    var t = typeof r;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? r !== "__proto__" : r === null;
  }
  return wd = e, wd;
}
var Hd, ov;
function vc() {
  if (ov) return Hd;
  ov = 1;
  var e = Qw();
  function r(t, a) {
    var o = t.__data__;
    return e(a) ? o[typeof a == "string" ? "string" : "hash"] : o.map;
  }
  return Hd = r, Hd;
}
var Vd, sv;
function Jw() {
  if (sv) return Vd;
  sv = 1;
  var e = vc();
  function r(t) {
    var a = e(this, t).delete(t);
    return this.size -= a ? 1 : 0, a;
  }
  return Vd = r, Vd;
}
var kd, lv;
function eH() {
  if (lv) return kd;
  lv = 1;
  var e = vc();
  function r(t) {
    return e(this, t).get(t);
  }
  return kd = r, kd;
}
var Fd, cv;
function tH() {
  if (cv) return Fd;
  cv = 1;
  var e = vc();
  function r(t) {
    return e(this, t).has(t);
  }
  return Fd = r, Fd;
}
var xd, uv;
function rH() {
  if (uv) return xd;
  uv = 1;
  var e = vc();
  function r(t, a) {
    var o = e(this, t), l = o.size;
    return o.set(t, a), this.size += o.size == l ? 0 : 1, this;
  }
  return xd = r, xd;
}
var Ud, fv;
function Lh() {
  if (fv) return Ud;
  fv = 1;
  var e = Xw(), r = Jw(), t = eH(), a = tH(), o = rH();
  function l(c) {
    var f = -1, p = c == null ? 0 : c.length;
    for (this.clear(); ++f < p; ) {
      var u = c[f];
      this.set(u[0], u[1]);
    }
  }
  return l.prototype.clear = e, l.prototype.delete = r, l.prototype.get = t, l.prototype.has = a, l.prototype.set = o, Ud = l, Ud;
}
var Bd, dv;
function nH() {
  if (dv) return Bd;
  dv = 1;
  var e = Sc(), r = Nh(), t = Lh(), a = 200;
  function o(l, c) {
    var f = this.__data__;
    if (f instanceof e) {
      var p = f.__data__;
      if (!r || p.length < a - 1)
        return p.push([l, c]), this.size = ++f.size, this;
      f = this.__data__ = new t(p);
    }
    return f.set(l, c), this.size = f.size, this;
  }
  return Bd = o, Bd;
}
var $d, pv;
function iH() {
  if (pv) return $d;
  pv = 1;
  var e = Sc(), r = Hw(), t = Vw(), a = kw(), o = Fw(), l = nH();
  function c(f) {
    var p = this.__data__ = new e(f);
    this.size = p.size;
  }
  return c.prototype.clear = r, c.prototype.delete = t, c.prototype.get = a, c.prototype.has = o, c.prototype.set = l, $d = c, $d;
}
var Gd, hv;
function aH() {
  if (hv) return Gd;
  hv = 1;
  var e = "__lodash_hash_undefined__";
  function r(t) {
    return this.__data__.set(t, e), this;
  }
  return Gd = r, Gd;
}
var Zd, mv;
function oH() {
  if (mv) return Zd;
  mv = 1;
  function e(r) {
    return this.__data__.has(r);
  }
  return Zd = e, Zd;
}
var jd, _v;
function sH() {
  if (_v) return jd;
  _v = 1;
  var e = Lh(), r = aH(), t = oH();
  function a(o) {
    var l = -1, c = o == null ? 0 : o.length;
    for (this.__data__ = new e(); ++l < c; )
      this.add(o[l]);
  }
  return a.prototype.add = a.prototype.push = r, a.prototype.has = t, jd = a, jd;
}
var zd, Ev;
function lH() {
  if (Ev) return zd;
  Ev = 1;
  function e(r, t) {
    for (var a = -1, o = r == null ? 0 : r.length; ++a < o; )
      if (t(r[a], a, r))
        return !0;
    return !1;
  }
  return zd = e, zd;
}
var qd, Cv;
function cH() {
  if (Cv) return qd;
  Cv = 1;
  function e(r, t) {
    return r.has(t);
  }
  return qd = e, qd;
}
var Wd, Sv;
function hR() {
  if (Sv) return Wd;
  Sv = 1;
  var e = sH(), r = lH(), t = cH(), a = 1, o = 2;
  function l(c, f, p, u, h, C) {
    var E = p & a, _ = c.length, S = f.length;
    if (_ != S && !(E && S > _))
      return !1;
    var v = C.get(c), g = C.get(f);
    if (v && g)
      return v == f && g == c;
    var O = -1, R = !0, D = p & o ? new e() : void 0;
    for (C.set(c, f), C.set(f, c); ++O < _; ) {
      var T = c[O], L = f[O];
      if (u)
        var P = E ? u(L, T, O, f, c, C) : u(T, L, O, c, f, C);
      if (P !== void 0) {
        if (P)
          continue;
        R = !1;
        break;
      }
      if (D) {
        if (!r(f, function(M, k) {
          if (!t(D, k) && (T === M || h(T, M, p, u, C)))
            return D.push(k);
        })) {
          R = !1;
          break;
        }
      } else if (!(T === L || h(T, L, p, u, C))) {
        R = !1;
        break;
      }
    }
    return C.delete(c), C.delete(f), R;
  }
  return Wd = l, Wd;
}
var Yd, Iv;
function uH() {
  if (Iv) return Yd;
  Iv = 1;
  var e = Vi(), r = e.Uint8Array;
  return Yd = r, Yd;
}
var Kd, vv;
function fH() {
  if (vv) return Kd;
  vv = 1;
  function e(r) {
    var t = -1, a = Array(r.size);
    return r.forEach(function(o, l) {
      a[++t] = [l, o];
    }), a;
  }
  return Kd = e, Kd;
}
var Xd, gv;
function dH() {
  if (gv) return Xd;
  gv = 1;
  function e(r) {
    var t = -1, a = Array(r.size);
    return r.forEach(function(o) {
      a[++t] = o;
    }), a;
  }
  return Xd = e, Xd;
}
var Qd, Dv;
function pH() {
  if (Dv) return Qd;
  Dv = 1;
  var e = a2(), r = uH(), t = Oh(), a = hR(), o = fH(), l = dH(), c = 1, f = 2, p = "[object Boolean]", u = "[object Date]", h = "[object Error]", C = "[object Map]", E = "[object Number]", _ = "[object RegExp]", S = "[object Set]", v = "[object String]", g = "[object Symbol]", O = "[object ArrayBuffer]", R = "[object DataView]", D = e ? e.prototype : void 0, T = D ? D.valueOf : void 0;
  function L(P, M, k, H, w, $, B) {
    switch (k) {
      case R:
        if (P.byteLength != M.byteLength || P.byteOffset != M.byteOffset)
          return !1;
        P = P.buffer, M = M.buffer;
      case O:
        return !(P.byteLength != M.byteLength || !$(new r(P), new r(M)));
      case p:
      case u:
      case E:
        return t(+P, +M);
      case h:
        return P.name == M.name && P.message == M.message;
      case _:
      case v:
        return P == M + "";
      case C:
        var Y = o;
      case S:
        var j = H & c;
        if (Y || (Y = l), P.size != M.size && !j)
          return !1;
        var ie = B.get(P);
        if (ie)
          return ie == M;
        H |= f, B.set(P, M);
        var se = a(Y(P), Y(M), H, w, $, B);
        return B.delete(P), se;
      case g:
        if (T)
          return T.call(P) == T.call(M);
    }
    return !1;
  }
  return Qd = L, Qd;
}
var Jd, Rv;
function mR() {
  if (Rv) return Jd;
  Rv = 1;
  function e(r, t) {
    for (var a = -1, o = t.length, l = r.length; ++a < o; )
      r[l + a] = t[a];
    return r;
  }
  return Jd = e, Jd;
}
var e5, Av;
function la() {
  if (Av) return e5;
  Av = 1;
  var e = Array.isArray;
  return e5 = e, e5;
}
var t5, Tv;
function hH() {
  if (Tv) return t5;
  Tv = 1;
  var e = mR(), r = la();
  function t(a, o, l) {
    var c = o(a);
    return r(a) ? c : e(c, l(a));
  }
  return t5 = t, t5;
}
var r5, Ov;
function mH() {
  if (Ov) return r5;
  Ov = 1;
  function e(r, t) {
    for (var a = -1, o = r == null ? 0 : r.length, l = 0, c = []; ++a < o; ) {
      var f = r[a];
      t(f, a, r) && (c[l++] = f);
    }
    return c;
  }
  return r5 = e, r5;
}
var n5, yv;
function _H() {
  if (yv) return n5;
  yv = 1;
  function e() {
    return [];
  }
  return n5 = e, n5;
}
var i5, Nv;
function EH() {
  if (Nv) return i5;
  Nv = 1;
  var e = mH(), r = _H(), t = Object.prototype, a = t.propertyIsEnumerable, o = Object.getOwnPropertySymbols, l = o ? function(c) {
    return c == null ? [] : (c = Object(c), e(o(c), function(f) {
      return a.call(c, f);
    }));
  } : r;
  return i5 = l, i5;
}
var a5, Lv;
function CH() {
  if (Lv) return a5;
  Lv = 1;
  function e(r, t) {
    for (var a = -1, o = Array(r); ++a < r; )
      o[a] = t(a);
    return o;
  }
  return a5 = e, a5;
}
var o5, Mv;
function s2() {
  if (Mv) return o5;
  Mv = 1;
  function e(r) {
    return r != null && typeof r == "object";
  }
  return o5 = e, o5;
}
var s5, bv;
function SH() {
  if (bv) return s5;
  bv = 1;
  var e = o2(), r = s2(), t = "[object Arguments]";
  function a(o) {
    return r(o) && e(o) == t;
  }
  return s5 = a, s5;
}
var l5, Pv;
function Mh() {
  if (Pv) return l5;
  Pv = 1;
  var e = SH(), r = s2(), t = Object.prototype, a = t.hasOwnProperty, o = t.propertyIsEnumerable, l = e(/* @__PURE__ */ function() {
    return arguments;
  }()) ? e : function(c) {
    return r(c) && a.call(c, "callee") && !o.call(c, "callee");
  };
  return l5 = l, l5;
}
var Vs = { exports: {} }, c5, wv;
function IH() {
  if (wv) return c5;
  wv = 1;
  function e() {
    return !1;
  }
  return c5 = e, c5;
}
Vs.exports;
var Hv;
function _R() {
  return Hv || (Hv = 1, function(e, r) {
    var t = Vi(), a = IH(), o = r && !r.nodeType && r, l = o && !0 && e && !e.nodeType && e, c = l && l.exports === o, f = c ? t.Buffer : void 0, p = f ? f.isBuffer : void 0, u = p || a;
    e.exports = u;
  }(Vs, Vs.exports)), Vs.exports;
}
var u5, Vv;
function bh() {
  if (Vv) return u5;
  Vv = 1;
  var e = 9007199254740991, r = /^(?:0|[1-9]\d*)$/;
  function t(a, o) {
    var l = typeof a;
    return o = o == null ? e : o, !!o && (l == "number" || l != "symbol" && r.test(a)) && a > -1 && a % 1 == 0 && a < o;
  }
  return u5 = t, u5;
}
var f5, kv;
function Ph() {
  if (kv) return f5;
  kv = 1;
  var e = 9007199254740991;
  function r(t) {
    return typeof t == "number" && t > -1 && t % 1 == 0 && t <= e;
  }
  return f5 = r, f5;
}
var d5, Fv;
function vH() {
  if (Fv) return d5;
  Fv = 1;
  var e = o2(), r = Ph(), t = s2(), a = "[object Arguments]", o = "[object Array]", l = "[object Boolean]", c = "[object Date]", f = "[object Error]", p = "[object Function]", u = "[object Map]", h = "[object Number]", C = "[object Object]", E = "[object RegExp]", _ = "[object Set]", S = "[object String]", v = "[object WeakMap]", g = "[object ArrayBuffer]", O = "[object DataView]", R = "[object Float32Array]", D = "[object Float64Array]", T = "[object Int8Array]", L = "[object Int16Array]", P = "[object Int32Array]", M = "[object Uint8Array]", k = "[object Uint8ClampedArray]", H = "[object Uint16Array]", w = "[object Uint32Array]", $ = {};
  $[R] = $[D] = $[T] = $[L] = $[P] = $[M] = $[k] = $[H] = $[w] = !0, $[a] = $[o] = $[g] = $[l] = $[O] = $[c] = $[f] = $[p] = $[u] = $[h] = $[C] = $[E] = $[_] = $[S] = $[v] = !1;
  function B(Y) {
    return t(Y) && r(Y.length) && !!$[e(Y)];
  }
  return d5 = B, d5;
}
var p5, xv;
function gH() {
  if (xv) return p5;
  xv = 1;
  function e(r) {
    return function(t) {
      return r(t);
    };
  }
  return p5 = e, p5;
}
var ks = { exports: {} };
ks.exports;
var Uv;
function DH() {
  return Uv || (Uv = 1, function(e, r) {
    var t = fR(), a = r && !r.nodeType && r, o = a && !0 && e && !e.nodeType && e, l = o && o.exports === a, c = l && t.process, f = function() {
      try {
        var p = o && o.require && o.require("util").types;
        return p || c && c.binding && c.binding("util");
      } catch (u) {
      }
    }();
    e.exports = f;
  }(ks, ks.exports)), ks.exports;
}
var h5, Bv;
function ER() {
  if (Bv) return h5;
  Bv = 1;
  var e = vH(), r = gH(), t = DH(), a = t && t.isTypedArray, o = a ? r(a) : e;
  return h5 = o, h5;
}
var m5, $v;
function RH() {
  if ($v) return m5;
  $v = 1;
  var e = CH(), r = Mh(), t = la(), a = _R(), o = bh(), l = ER(), c = Object.prototype, f = c.hasOwnProperty;
  function p(u, h) {
    var C = t(u), E = !C && r(u), _ = !C && !E && a(u), S = !C && !E && !_ && l(u), v = C || E || _ || S, g = v ? e(u.length, String) : [], O = g.length;
    for (var R in u)
      (h || f.call(u, R)) && !(v && // Safari 9 has enumerable `arguments.length` in strict mode.
      (R == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      _ && (R == "offset" || R == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      S && (R == "buffer" || R == "byteLength" || R == "byteOffset") || // Skip index properties.
      o(R, O))) && g.push(R);
    return g;
  }
  return m5 = p, m5;
}
var _5, Gv;
function AH() {
  if (Gv) return _5;
  Gv = 1;
  var e = Object.prototype;
  function r(t) {
    var a = t && t.constructor, o = typeof a == "function" && a.prototype || e;
    return t === o;
  }
  return _5 = r, _5;
}
var E5, Zv;
function TH() {
  if (Zv) return E5;
  Zv = 1;
  function e(r, t) {
    return function(a) {
      return r(t(a));
    };
  }
  return E5 = e, E5;
}
var C5, jv;
function OH() {
  if (jv) return C5;
  jv = 1;
  var e = TH(), r = e(Object.keys, Object);
  return C5 = r, C5;
}
var S5, zv;
function yH() {
  if (zv) return S5;
  zv = 1;
  var e = AH(), r = OH(), t = Object.prototype, a = t.hasOwnProperty;
  function o(l) {
    if (!e(l))
      return r(l);
    var c = [];
    for (var f in Object(l))
      a.call(l, f) && f != "constructor" && c.push(f);
    return c;
  }
  return S5 = o, S5;
}
var I5, qv;
function NH() {
  if (qv) return I5;
  qv = 1;
  var e = dR(), r = Ph();
  function t(a) {
    return a != null && r(a.length) && !e(a);
  }
  return I5 = t, I5;
}
var v5, Wv;
function LH() {
  if (Wv) return v5;
  Wv = 1;
  var e = RH(), r = yH(), t = NH();
  function a(o) {
    return t(o) ? e(o) : r(o);
  }
  return v5 = a, v5;
}
var g5, Yv;
function MH() {
  if (Yv) return g5;
  Yv = 1;
  var e = hH(), r = EH(), t = LH();
  function a(o) {
    return e(o, t, r);
  }
  return g5 = a, g5;
}
var D5, Kv;
function bH() {
  if (Kv) return D5;
  Kv = 1;
  var e = MH(), r = 1, t = Object.prototype, a = t.hasOwnProperty;
  function o(l, c, f, p, u, h) {
    var C = f & r, E = e(l), _ = E.length, S = e(c), v = S.length;
    if (_ != v && !C)
      return !1;
    for (var g = _; g--; ) {
      var O = E[g];
      if (!(C ? O in c : a.call(c, O)))
        return !1;
    }
    var R = h.get(l), D = h.get(c);
    if (R && D)
      return R == c && D == l;
    var T = !0;
    h.set(l, c), h.set(c, l);
    for (var L = C; ++g < _; ) {
      O = E[g];
      var P = l[O], M = c[O];
      if (p)
        var k = C ? p(M, P, O, c, l, h) : p(P, M, O, l, c, h);
      if (!(k === void 0 ? P === M || u(P, M, f, p, h) : k)) {
        T = !1;
        break;
      }
      L || (L = O == "constructor");
    }
    if (T && !L) {
      var H = l.constructor, w = c.constructor;
      H != w && "constructor" in l && "constructor" in c && !(typeof H == "function" && H instanceof H && typeof w == "function" && w instanceof w) && (T = !1);
    }
    return h.delete(l), h.delete(c), T;
  }
  return D5 = o, D5;
}
var R5, Xv;
function PH() {
  if (Xv) return R5;
  Xv = 1;
  var e = za(), r = Vi(), t = e(r, "DataView");
  return R5 = t, R5;
}
var A5, Qv;
function wH() {
  if (Qv) return A5;
  Qv = 1;
  var e = za(), r = Vi(), t = e(r, "Promise");
  return A5 = t, A5;
}
var T5, Jv;
function HH() {
  if (Jv) return T5;
  Jv = 1;
  var e = za(), r = Vi(), t = e(r, "Set");
  return T5 = t, T5;
}
var O5, eg;
function VH() {
  if (eg) return O5;
  eg = 1;
  var e = za(), r = Vi(), t = e(r, "WeakMap");
  return O5 = t, O5;
}
var y5, tg;
function kH() {
  if (tg) return y5;
  tg = 1;
  var e = PH(), r = Nh(), t = wH(), a = HH(), o = VH(), l = o2(), c = pR(), f = "[object Map]", p = "[object Object]", u = "[object Promise]", h = "[object Set]", C = "[object WeakMap]", E = "[object DataView]", _ = c(e), S = c(r), v = c(t), g = c(a), O = c(o), R = l;
  return (e && R(new e(new ArrayBuffer(1))) != E || r && R(new r()) != f || t && R(t.resolve()) != u || a && R(new a()) != h || o && R(new o()) != C) && (R = function(D) {
    var T = l(D), L = T == p ? D.constructor : void 0, P = L ? c(L) : "";
    if (P)
      switch (P) {
        case _:
          return E;
        case S:
          return f;
        case v:
          return u;
        case g:
          return h;
        case O:
          return C;
      }
    return T;
  }), y5 = R, y5;
}
var N5, rg;
function FH() {
  if (rg) return N5;
  rg = 1;
  var e = iH(), r = hR(), t = pH(), a = bH(), o = kH(), l = la(), c = _R(), f = ER(), p = 1, u = "[object Arguments]", h = "[object Array]", C = "[object Object]", E = Object.prototype, _ = E.hasOwnProperty;
  function S(v, g, O, R, D, T) {
    var L = l(v), P = l(g), M = L ? h : o(v), k = P ? h : o(g);
    M = M == u ? C : M, k = k == u ? C : k;
    var H = M == C, w = k == C, $ = M == k;
    if ($ && c(v)) {
      if (!c(g))
        return !1;
      L = !0, H = !1;
    }
    if ($ && !H)
      return T || (T = new e()), L || f(v) ? r(v, g, O, R, D, T) : t(v, g, M, O, R, D, T);
    if (!(O & p)) {
      var B = H && _.call(v, "__wrapped__"), Y = w && _.call(g, "__wrapped__");
      if (B || Y) {
        var j = B ? v.value() : v, ie = Y ? g.value() : g;
        return T || (T = new e()), D(j, ie, O, R, T);
      }
    }
    return $ ? (T || (T = new e()), a(v, g, O, R, D, T)) : !1;
  }
  return N5 = S, N5;
}
var L5, ng;
function xH() {
  if (ng) return L5;
  ng = 1;
  var e = FH(), r = s2();
  function t(a, o, l, c, f) {
    return a === o ? !0 : a == null || o == null || !r(a) && !r(o) ? a !== a && o !== o : e(a, o, l, c, t, f);
  }
  return L5 = t, L5;
}
var M5, ig;
function UH() {
  if (ig) return M5;
  ig = 1;
  var e = xH();
  function r(t, a) {
    return e(t, a);
  }
  return M5 = r, M5;
}
var BH = UH();
const $H = /* @__PURE__ */ Zs(BH);
var b5, ag;
function wh() {
  if (ag) return b5;
  ag = 1;
  var e = o2(), r = s2(), t = "[object Symbol]";
  function a(o) {
    return typeof o == "symbol" || r(o) && e(o) == t;
  }
  return b5 = a, b5;
}
var P5, og;
function GH() {
  if (og) return P5;
  og = 1;
  var e = la(), r = wh(), t = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, a = /^\w*$/;
  function o(l, c) {
    if (e(l))
      return !1;
    var f = typeof l;
    return f == "number" || f == "symbol" || f == "boolean" || l == null || r(l) ? !0 : a.test(l) || !t.test(l) || c != null && l in Object(c);
  }
  return P5 = o, P5;
}
var w5, sg;
function ZH() {
  if (sg) return w5;
  sg = 1;
  var e = Lh(), r = "Expected a function";
  function t(a, o) {
    if (typeof a != "function" || o != null && typeof o != "function")
      throw new TypeError(r);
    var l = function() {
      var c = arguments, f = o ? o.apply(this, c) : c[0], p = l.cache;
      if (p.has(f))
        return p.get(f);
      var u = a.apply(this, c);
      return l.cache = p.set(f, u) || p, u;
    };
    return l.cache = new (t.Cache || e)(), l;
  }
  return t.Cache = e, w5 = t, w5;
}
var H5, lg;
function jH() {
  if (lg) return H5;
  lg = 1;
  var e = ZH(), r = 500;
  function t(a) {
    var o = e(a, function(c) {
      return l.size === r && l.clear(), c;
    }), l = o.cache;
    return o;
  }
  return H5 = t, H5;
}
var V5, cg;
function zH() {
  if (cg) return V5;
  cg = 1;
  var e = jH(), r = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, t = /\\(\\)?/g, a = e(function(o) {
    var l = [];
    return o.charCodeAt(0) === 46 && l.push(""), o.replace(r, function(c, f, p, u) {
      l.push(p ? u.replace(t, "$1") : f || c);
    }), l;
  });
  return V5 = a, V5;
}
var k5, ug;
function qH() {
  if (ug) return k5;
  ug = 1;
  function e(r, t) {
    for (var a = -1, o = r == null ? 0 : r.length, l = Array(o); ++a < o; )
      l[a] = t(r[a], a, r);
    return l;
  }
  return k5 = e, k5;
}
var F5, fg;
function WH() {
  if (fg) return F5;
  fg = 1;
  var e = a2(), r = qH(), t = la(), a = wh(), o = e ? e.prototype : void 0, l = o ? o.toString : void 0;
  function c(f) {
    if (typeof f == "string")
      return f;
    if (t(f))
      return r(f, c) + "";
    if (a(f))
      return l ? l.call(f) : "";
    var p = f + "";
    return p == "0" && 1 / f == -1 / 0 ? "-0" : p;
  }
  return F5 = c, F5;
}
var x5, dg;
function YH() {
  if (dg) return x5;
  dg = 1;
  var e = WH();
  function r(t) {
    return t == null ? "" : e(t);
  }
  return x5 = r, x5;
}
var U5, pg;
function gc() {
  if (pg) return U5;
  pg = 1;
  var e = la(), r = GH(), t = zH(), a = YH();
  function o(l, c) {
    return e(l) ? l : r(l, c) ? [l] : t(a(l));
  }
  return U5 = o, U5;
}
var B5, hg;
function Hh() {
  if (hg) return B5;
  hg = 1;
  var e = wh();
  function r(t) {
    if (typeof t == "string" || e(t))
      return t;
    var a = t + "";
    return a == "0" && 1 / t == -1 / 0 ? "-0" : a;
  }
  return B5 = r, B5;
}
var $5, mg;
function KH() {
  if (mg) return $5;
  mg = 1;
  var e = gc(), r = Hh();
  function t(a, o) {
    o = e(o, a);
    for (var l = 0, c = o.length; a != null && l < c; )
      a = a[r(o[l++])];
    return l && l == c ? a : void 0;
  }
  return $5 = t, $5;
}
var G5, _g;
function CR() {
  if (_g) return G5;
  _g = 1;
  var e = za(), r = function() {
    try {
      var t = e(Object, "defineProperty");
      return t({}, "", {}), t;
    } catch (a) {
    }
  }();
  return G5 = r, G5;
}
var Z5, Eg;
function XH() {
  if (Eg) return Z5;
  Eg = 1;
  var e = CR();
  function r(t, a, o) {
    a == "__proto__" && e ? e(t, a, {
      configurable: !0,
      enumerable: !0,
      value: o,
      writable: !0
    }) : t[a] = o;
  }
  return Z5 = r, Z5;
}
var j5, Cg;
function QH() {
  if (Cg) return j5;
  Cg = 1;
  var e = XH(), r = Oh(), t = Object.prototype, a = t.hasOwnProperty;
  function o(l, c, f) {
    var p = l[c];
    (!(a.call(l, c) && r(p, f)) || f === void 0 && !(c in l)) && e(l, c, f);
  }
  return j5 = o, j5;
}
var z5, Sg;
function JH() {
  if (Sg) return z5;
  Sg = 1;
  var e = QH(), r = gc(), t = bh(), a = yh(), o = Hh();
  function l(c, f, p, u) {
    if (!a(c))
      return c;
    f = r(f, c);
    for (var h = -1, C = f.length, E = C - 1, _ = c; _ != null && ++h < C; ) {
      var S = o(f[h]), v = p;
      if (S === "__proto__" || S === "constructor" || S === "prototype")
        return c;
      if (h != E) {
        var g = _[S];
        v = u ? u(g, S, _) : void 0, v === void 0 && (v = a(g) ? g : t(f[h + 1]) ? [] : {});
      }
      e(_, S, v), _ = _[S];
    }
    return c;
  }
  return z5 = l, z5;
}
var q5, Ig;
function eV() {
  if (Ig) return q5;
  Ig = 1;
  var e = KH(), r = JH(), t = gc();
  function a(o, l, c) {
    for (var f = -1, p = l.length, u = {}; ++f < p; ) {
      var h = l[f], C = e(o, h);
      c(C, h) && r(u, t(h, o), C);
    }
    return u;
  }
  return q5 = a, q5;
}
var W5, vg;
function tV() {
  if (vg) return W5;
  vg = 1;
  function e(r, t) {
    return r != null && t in Object(r);
  }
  return W5 = e, W5;
}
var Y5, gg;
function rV() {
  if (gg) return Y5;
  gg = 1;
  var e = gc(), r = Mh(), t = la(), a = bh(), o = Ph(), l = Hh();
  function c(f, p, u) {
    p = e(p, f);
    for (var h = -1, C = p.length, E = !1; ++h < C; ) {
      var _ = l(p[h]);
      if (!(E = f != null && u(f, _)))
        break;
      f = f[_];
    }
    return E || ++h != C ? E : (C = f == null ? 0 : f.length, !!C && o(C) && a(_, C) && (t(f) || r(f)));
  }
  return Y5 = c, Y5;
}
var K5, Dg;
function nV() {
  if (Dg) return K5;
  Dg = 1;
  var e = tV(), r = rV();
  function t(a, o) {
    return a != null && r(a, o, e);
  }
  return K5 = t, K5;
}
var X5, Rg;
function iV() {
  if (Rg) return X5;
  Rg = 1;
  var e = eV(), r = nV();
  function t(a, o) {
    return e(a, o, function(l, c) {
      return r(a, c);
    });
  }
  return X5 = t, X5;
}
var Q5, Ag;
function aV() {
  if (Ag) return Q5;
  Ag = 1;
  var e = a2(), r = Mh(), t = la(), a = e ? e.isConcatSpreadable : void 0;
  function o(l) {
    return t(l) || r(l) || !!(a && l && l[a]);
  }
  return Q5 = o, Q5;
}
var J5, Tg;
function oV() {
  if (Tg) return J5;
  Tg = 1;
  var e = mR(), r = aV();
  function t(a, o, l, c, f) {
    var p = -1, u = a.length;
    for (l || (l = r), f || (f = []); ++p < u; ) {
      var h = a[p];
      o > 0 && l(h) ? o > 1 ? t(h, o - 1, l, c, f) : e(f, h) : c || (f[f.length] = h);
    }
    return f;
  }
  return J5 = t, J5;
}
var ep, Og;
function sV() {
  if (Og) return ep;
  Og = 1;
  var e = oV();
  function r(t) {
    var a = t == null ? 0 : t.length;
    return a ? e(t, 1) : [];
  }
  return ep = r, ep;
}
var tp, yg;
function lV() {
  if (yg) return tp;
  yg = 1;
  function e(r, t, a) {
    switch (a.length) {
      case 0:
        return r.call(t);
      case 1:
        return r.call(t, a[0]);
      case 2:
        return r.call(t, a[0], a[1]);
      case 3:
        return r.call(t, a[0], a[1], a[2]);
    }
    return r.apply(t, a);
  }
  return tp = e, tp;
}
var rp, Ng;
function cV() {
  if (Ng) return rp;
  Ng = 1;
  var e = lV(), r = Math.max;
  function t(a, o, l) {
    return o = r(o === void 0 ? a.length - 1 : o, 0), function() {
      for (var c = arguments, f = -1, p = r(c.length - o, 0), u = Array(p); ++f < p; )
        u[f] = c[o + f];
      f = -1;
      for (var h = Array(o + 1); ++f < o; )
        h[f] = c[f];
      return h[o] = l(u), e(a, this, h);
    };
  }
  return rp = t, rp;
}
var np, Lg;
function uV() {
  if (Lg) return np;
  Lg = 1;
  function e(r) {
    return function() {
      return r;
    };
  }
  return np = e, np;
}
var ip, Mg;
function fV() {
  if (Mg) return ip;
  Mg = 1;
  function e(r) {
    return r;
  }
  return ip = e, ip;
}
var ap, bg;
function dV() {
  if (bg) return ap;
  bg = 1;
  var e = uV(), r = CR(), t = fV(), a = r ? function(o, l) {
    return r(o, "toString", {
      configurable: !0,
      enumerable: !1,
      value: e(l),
      writable: !0
    });
  } : t;
  return ap = a, ap;
}
var op, Pg;
function pV() {
  if (Pg) return op;
  Pg = 1;
  var e = 800, r = 16, t = Date.now;
  function a(o) {
    var l = 0, c = 0;
    return function() {
      var f = t(), p = r - (f - c);
      if (c = f, p > 0) {
        if (++l >= e)
          return arguments[0];
      } else
        l = 0;
      return o.apply(void 0, arguments);
    };
  }
  return op = a, op;
}
var sp, wg;
function hV() {
  if (wg) return sp;
  wg = 1;
  var e = dV(), r = pV(), t = r(e);
  return sp = t, sp;
}
var lp, Hg;
function mV() {
  if (Hg) return lp;
  Hg = 1;
  var e = sV(), r = cV(), t = hV();
  function a(o) {
    return t(r(o, void 0, e), o + "");
  }
  return lp = a, lp;
}
var cp, Vg;
function _V() {
  if (Vg) return cp;
  Vg = 1;
  var e = iV(), r = mV(), t = r(function(a, o) {
    return a == null ? {} : e(a, o);
  });
  return cp = t, cp;
}
var EV = _V();
const kg = /* @__PURE__ */ Zs(EV), Nl = jr.create("main"), Fg = (e) => {
  var r;
  return ((r = e.recognizerProcessParam.delegateProcessing) === null || r === void 0 ? void 0 : r.httpHeaders) || {};
};
function CV(e) {
  var r, t, a;
  let {
    onError: o,
    onStatusChange: l
  } = e;
  const {
    onEvent: c,
    continueInBrowserButton: f = !0
  } = nr(), {
    translate: p
  } = Hi.useLocalize(), u = window.RegulaDocumentSDK, h = ((r = u.recognizerProcessParam) === null || r === void 0 ? void 0 : r.tag) || _p(), C = (((t = u.recognizerProcessParam) === null || t === void 0 || (t = t.delegateProcessing) === null || t === void 0 ? void 0 : t.delegateURL) || window.location.href).replace("{tag}", h), E = new jD({
    basePath: ((a = u.recognizerProcessParam.delegateProcessing) === null || a === void 0 ? void 0 : a.serviceURL) || "",
    baseOptions: {
      headers: Fg(u)
    }
  }), _ = oe.useRef(), S = oe.useRef(), [v, g] = oe.useState(!1);
  return oe.useEffect(() => {
    Nl("Remote scanner parameters: ".concat(JSON.stringify({
      tag: h,
      url: C
    })));
    const O = () => Ae(null, null, function* () {
      try {
        const {
          data: R
        } = yield E.getTransactionsByTag(h, {
          headers: Fg(u)
        }), D = wo(R.items);
        if (Nl("Remote scanner transaction data: ".concat(JSON.stringify(R))), D && ($H(kg(D, ["id", "state"]), kg(_.current, ["id", "state"])) || (D.state === $l.UPLOADED && (c({
          action: pt.REMOTE_TRANSACTION_UPLOADED,
          data: D
        }), g(!0)), Nl("Remote scanner status: UPLOADED"), _.current = D), D.state === $l.PROCESSED && D.id)) {
          clearInterval(S.current);
          const T = yield E.getReprocessTransactionResult(D.id, !0);
          Nl("Remote scanner reprocess result: ".concat(JSON.stringify(T))), c({
            action: pt.REMOTE_PROCESS_FINISHED,
            data: {
              status: Li.OK,
              response: T
            }
          }), l(Me.SUCCESS);
        }
      } catch (R) {
        clearInterval(S.current), o(new $t(rr.CONNECTION_ERROR, R)), l(Me.FAILED);
      }
    });
    return O(), S.current = setInterval(O, 5e3), () => clearInterval(S.current);
  }, []), v ? /* @__PURE__ */ Z.jsx(e2, {}) : /* @__PURE__ */ Z.jsxs("div", { part: "remote-scanner-container", className: ra["remote-scanner-wrapper"], children: [
    /* @__PURE__ */ Z.jsxs("div", { "aria-live": "assertive", part: "remote-scanner-text", className: ra.text, children: [
      /* @__PURE__ */ Z.jsx("p", { part: "remote-scanner-title", className: ra.title, children: p("switchToMobile") }),
      /* @__PURE__ */ Z.jsx("p", { part: "remote-scanner-subtitle", className: ra.subtitle, children: p("openPhoneCamera") })
    ] }),
    /* @__PURE__ */ Z.jsxs("div", { part: "remote-scanner-content", className: ra["content-container"], children: [
      /* @__PURE__ */ Z.jsx("div", { part: "remote-scanner-qr", className: ra["qr-container"], children: /* @__PURE__ */ Z.jsx(uR, { value: C }) }),
      f && /* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
        /* @__PURE__ */ Z.jsx("div", { part: "remote-scanner-divider", className: ra.divider, children: p("or") }),
        /* @__PURE__ */ Z.jsx("button", { part: "remote-scanner-continue-button", className: ra.button, onClick: () => l(Me.CAMERA_PROCESSING), children: p("continueInBrowser") })
      ] })
    ] })
  ] });
}
const SV = (e) => {
  var r, t;
  return !!((r = e.recognizerProcessParam.delegateProcessing) !== null && r !== void 0 && r.serviceURL) && !!((t = e.recognizerProcessParam) !== null && t !== void 0 && (t = t.delegateProcessing) !== null && t !== void 0 && t.delegateURL) && !Kt.isMobile;
}, IV = (e, r, t, a) => e ? r ? t ? "fromCameraGalleryMobile" : "fromMobileDesktop" : t ? "fromGalleryMobile" : "" : r ? t ? a ? "fromCameraFilesMobileDesktop" : "fromCameraFilesDesktop" : a ? "fromCameraMobileDesktop" : "fromCameraDesktop" : t ? a ? "fromFilesMobileDesktop" : "fromFilesDesktop" : a ? "fromMobileDesktop" : "", vV = (e, r, t, a) => e ? Me.CHOOSE_INPUT_SOURCE : r ? Me.CAMERA_PROCESSING : !r && a && !t ? Me.REMOTE_SCANNER : Me.CONFIGURATION_ERROR, gV = (e, r, t, a, o, l) => {
  const c = t && (o || r), f = a && (l || r);
  return e ? (t ? c : !0) && (a ? f : !0) : o || r;
}, cn = {
  "verified-screen": "_verified-screen_evxkx_1",
  "error-screen": "_error-screen_evxkx_5",
  "camera-disabled-screen": "_camera-disabled-screen_evxkx_9"
};
function DV(e) {
  let {
    direction: r
  } = e;
  const {
    onEvent: t,
    startScreen: a,
    internalScenario: o,
    fromCameraButton: l = !0,
    uploadFileButton: c = !0
  } = nr(), f = window.RegulaDocumentSDK, p = SV(f), u = vV(!!a, l, c, p), {
    translate: h
  } = Hi.useLocalize(), {
    orientation: C
  } = mw(), [E, _] = oe.useState(null), [S, v] = oe.useState(u), g = () => {
    t({
      action: pt.PRESS_CAMERA_BUTTON,
      data: null
    }), v(Me.CAMERA_PROCESSING);
  }, O = () => {
    t({
      action: pt.CLOSE,
      data: null
    });
  }, R = (M) => {
    _(M), v(Me.FILE_PROCESSING);
  }, D = () => {
    v(Me.REMOTE_SCANNER);
  }, T = (M) => {
    const k = A8[M.type] || Me.UNKNOWN_ERROR;
    v(k), t({
      action: pt.PROCESS_FINISHED,
      data: {
        status: Li.ERROR,
        reason: M.type,
        details: M.details
      }
    });
  }, L = () => {
    _(null), v(u);
  }, P = () => {
    t({
      action: pt.PRESS_RETRY_BUTTON,
      data: null
    }), v(Me.CAMERA_PROCESSING);
  };
  return oe.useEffect(() => {
    !Kt.isMobile || S !== Me.CAMERA_PROCESSING || L();
  }, [C]), oe.useLayoutEffect(() => {
    const M = f.recognizerProcessParam.processParam.scenario, k = f.imageProcessParam.processParam.scenario;
    if (!gV(!!a, !!o, l, c, !!M, !!k))
      return T(new $t(rr.MISSING_SCENARIO, "Set processing scenario (video and image)"));
    if (u === Me.CONFIGURATION_ERROR)
      return T(new $t(rr.BAD_CONFIGURATION, "Incorrect component configuration"));
  }, [o, a, l, c, u]), /* @__PURE__ */ Z.jsx(oe.StrictMode, { children: /* @__PURE__ */ Z.jsx(QD, { onError: T, supportedBrowserVersions: T8, children: /* @__PURE__ */ Z.jsx(gh, { showHeaderAndFooter: S !== Me.CAMERA_PROCESSING, onClose: O, direction: r, children: S === Me.CHOOSE_INPUT_SOURCE ? /* @__PURE__ */ Z.jsx(YD, { onStart: g, onFileImageSet: R, allowRemote: p, onRemoteDevice: D, title: h("verifyYourIdentity"), subtitle: h(IV(Kt.isMobile, l, c, p)) }) : S === Me.CAMERA_PROCESSING ? /* @__PURE__ */ Z.jsx(KP, { direction: r, onStatusChange: v, onFileImageSet: R, onError: T, onClose: O }) : S === Me.FILE_PROCESSING ? /* @__PURE__ */ Z.jsx(uw, { onStatusChange: v, images: E, onError: T }) : S === Me.REMOTE_SCANNER ? /* @__PURE__ */ Z.jsx(CV, { onError: T, onStatusChange: v }) : S === Me.SUCCESS ? /* @__PURE__ */ Z.jsx(tr, { className: cn["verified-screen"], title: h("done") }) : S === Me.FILE_SIZE_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: cn["error-screen"], title: h("largeFile") }) : S === Me.NOT_SUPPORTED_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: cn["error-screen"], title: h("versionNotSupported") }) : S === Me.WASM_LICENSE_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: cn["error-screen"], title: h("badLicense") }) : S === Me.INCORRECT_FILE_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: cn["error-screen"], title: h("fileCorrupt") }) : S === Me.CAMERA_PERMISSION_DENIED_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: cn["camera-disabled-screen"], title: h("cameraUnavailable") }) : S === Me.HTTP_NOT_SUPPORTED_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: cn["error-screen"], title: h("httpNotSupported") }) : S === Me.INSECURE_PAGE_CONTEXT_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: cn["error-screen"], title: h("insecurePageContext") }) : S === Me.NO_CAMERA_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: cn["camera-disabled-screen"], title: h("noCameraAvailable") }) : S === Me.INCORRECT_CAMERA_ID_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: cn["camera-disabled-screen"], title: h("incorrectCameraId") }) : S === Me.TIMEOUT ? /* @__PURE__ */ Z.jsx(tr, { className: cn["error-screen"], title: h("timeout"), onReset: P }) : S === Me.DELEGATE_SUCCESS ? /* @__PURE__ */ Z.jsx(tr, { className: cn["verified-screen"], title: h("returnToComputer"), subtitle: h("documentCaptured") }) : S === Me.PROCESSING ? /* @__PURE__ */ Z.jsx(e2, {}) : /* @__PURE__ */ Z.jsx(tr, { className: cn["error-screen"], title: h("somethingWentWrong") }) }) }) });
}
const RV = U8(XD, KD)(DV), SR = `*,*:before,*:after{box-sizing:border-box}:host{display:block;container-type:inline-size;container-name:host;width:100%;height:100%}._window_1m5c9_14{width:100%;height:100%;display:flex;flex-direction:column;background:#fff;box-shadow:0 8px 16px #0000000a,0 2px 4px #00000008,0 1px 2px #00000005;-webkit-backface-visibility:hidden;-moz-backface-visibility:hidden;-webkit-transform:translate3d(0,0,0);-moz-transform:translate3d(0,0,0);font-family:Inter,sans-serif}._window_1m5c9_14[data-direction=rtl]{direction:rtl}._window_1m5c9_14[data-direction=ltr]{direction:ltr}._header_1m5c9_36{display:flex;justify-content:flex-end;padding:16px 16px 0}._header_1m5c9_36 button{display:flex;justify-content:center;align-items:center;border:none;padding:0;margin:0;text-decoration:none;background:none;cursor:pointer;text-align:center;transition:background .25s ease-in-out,transform .15s ease;appearance:none}._footer_1m5c9_57{display:flex;align-items:center;padding:0 16px 10px}._close-button_1m5c9_63:before{content:"";display:inline-flex;width:32px;height:32px;background-image:url("data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M24%208L8%2024M8%208L24%2024'%20stroke='black'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'%20opacity='0.6'/%3e%3c/svg%3e");background-repeat:no-repeat;background-position:center;background-size:contain}._close-button_1m5c9_63:focus-visible{outline:2px solid blue}@media (max-width: 640px){._footer_1m5c9_57{justify-content:center}}@container host (max-width: 640px){._footer_1m5c9_57{justify-content:center}}`, IR = `._start-window_1ywb7_1{display:flex;flex:1;align-items:center;justify-content:center;flex-direction:column;row-gap:24px;padding:24px}._text_1ywb7_11{display:flex;flex-direction:column;row-gap:16px;align-items:center;text-align:center}._title_1ywb7_19{max-width:500px;color:#000;font-size:20px;font-weight:600;line-height:20px;margin:0}._subtitle_1ywb7_28{display:block;max-width:465px;color:#454545;font-size:14px;font-weight:400;line-height:20px;margin:0}._buttons_1ywb7_38{display:flex;width:100%;align-items:center;justify-content:center;column-gap:16px}._camera-button_1ywb7_46:before{background-image:url("data:image/svg+xml,%3csvg%20width='22'%20height='22'%20viewBox='0%200%2022%2022'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_21_211)'%3e%3cpath%20d='M16.1697%205.75397L16.2882%206.08594H16.6406H19.5625C20.236%206.08594%2020.7812%206.63122%2020.7812%207.30469V17.1016C20.7812%2017.775%2020.236%2018.3203%2019.5625%2018.3203H4.4375C3.76403%2018.3203%203.21875%2017.775%203.21875%2017.1016V7.30469C3.21875%206.63122%203.76403%206.08594%204.4375%206.08594H7.35938H7.71147L7.83013%205.75443L8.52837%203.80365L8.52891%203.80215C8.55435%203.73034%208.6245%203.67969%208.7043%203.67969L15.2957%203.67969L15.2961%203.67969C15.3351%203.67965%2015.373%203.69163%2015.4049%203.714C15.4366%203.73627%2015.4607%203.76776%2015.474%203.80419C15.474%203.80433%2015.4741%203.80448%2015.4741%203.80463L16.1697%205.75397ZM8.0625%2011.9453C8.0625%2014.1207%209.82464%2015.8828%2012%2015.8828C14.1754%2015.8828%2015.9375%2014.1207%2015.9375%2011.9453C15.9375%209.76995%2014.1754%208.00781%2012%208.00781C9.82464%208.00781%208.0625%209.76995%208.0625%2011.9453Z'%20stroke='%23211236'/%3e%3ccircle%20cx='18'%20cy='9'%20r='1'%20fill='%23211236'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_21_211'%3e%3crect%20width='22'%20height='22'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")}._gallery-button_1ywb7_50:before{background-image:url("data:image/svg+xml,%3csvg%20width='22'%20height='22'%20viewBox='0%200%2022%2022'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_21_213)'%3e%3cpath%20d='M11.685%2010.2487H15.4872V11.0062H11.684L11.685%2010.2487Z'%20fill='%23211236'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M10.3862%2014.1034L9.83531%2012.3636L8.00871%2011.9563L6.69453%2013.5517L5.37938%2011.9563L3.54894%2012.3636L3%2014.1034V7H10.39L10.3862%2014.1034ZM8.00679%208.11942V10.1613C8.00676%2010.3969%207.93334%2010.6274%207.79537%2010.8252C7.6574%2011.023%207.46075%2011.1796%207.22905%2011.2763C7.05875%2011.348%206.87387%2011.3851%206.68683%2011.385C6.4998%2011.3851%206.31492%2011.348%206.14463%2011.2763C5.91292%2011.1796%205.71627%2011.023%205.5783%2010.8252C5.44033%2010.6274%205.36691%2010.3969%205.36688%2010.1613V8.11942H8.00679Z'%20fill='%23211236'/%3e%3cpath%20d='M19%2016H11.684V15.2424H19V16Z'%20fill='%23211236'/%3e%3cpath%20d='M19%2013.5045H11.684V12.7469H19V13.5045Z'%20fill='%23211236'/%3e%3cpath%20d='M1.31939%204.66349C1.45107%204.5964%201.62491%204.55031%201.92748%204.52559C2.2359%204.50039%202.63205%204.50001%203.20034%204.50001L18.8%204.50004C19.3683%204.50004%2019.7645%204.50043%2020.0729%204.52563C20.3755%204.55035%2020.5493%204.59644%2020.681%204.66353C20.9632%204.80735%2021.1927%205.03682%2021.3365%205.31906C21.4036%205.45074%2021.4497%205.62458%2021.4744%205.92716C21.4996%206.23558%2021.5%206.63174%2021.5%207.20004L21.5%2015.8C21.5%2016.3683%2021.4996%2016.7645%2021.4744%2017.0729C21.4497%2017.3755%2021.4036%2017.5493%2021.3365%2017.681C21.1927%2017.9632%2020.9632%2018.1927%2020.681%2018.3365C20.5493%2018.4036%2020.3755%2018.4497%2020.0729%2018.4744C19.7645%2018.4996%2019.3683%2018.5%2018.8%2018.5L3.20009%2018.5C2.63177%2018.5%202.23561%2018.4996%201.92718%2018.4744C1.62459%2018.4497%201.45074%2018.4036%201.31906%2018.3365C1.03681%2018.1927%200.80734%2017.9632%200.663533%2017.681C0.596441%2017.5493%200.550357%2017.3754%200.525643%2017.0728C0.500451%2016.7644%200.500073%2016.3682%200.500089%2015.7999L0.500329%207.19993C0.500345%206.63164%200.500745%206.23549%200.525952%205.92708C0.550682%205.62451%200.596772%205.45067%200.663867%205.31899C0.80768%205.03676%201.03715%204.80729%201.31939%204.66349Z'%20stroke='%23211236'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_21_213'%3e%3crect%20width='22'%20height='22'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")}._phone-button_1ywb7_54:before{background-image:url("data:image/svg+xml,%3csvg%20width='22'%20height='22'%20viewBox='0%200%2022%2022'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20clip-path='url(%23clip0_21_218)'%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M20.782%201.0924C21%201.52022%2021%202.08025%2021%203.20033L21%2018.8C21%2019.9201%2021%2020.4802%2020.782%2020.908C20.5902%2021.2843%2020.2843%2021.5903%2019.9079%2021.782C19.4801%2022%2018.9201%2022%2017.8%2022H12.2C11.0799%2022%2010.5198%2022%2010.092%2021.782C9.71569%2021.5903%209.40973%2021.2843%209.21799%2020.908C9%2020.4802%209%2019.9201%209%2018.8V3.20012C9%202.07998%209%201.51991%209.218%201.09208C9.40975%200.715752%209.71573%200.409789%2010.0921%200.218047C10.5199%206.59147e-05%2011.08%208.49657e-05%2012.2001%200.000123068H12.2001L17.8001%200.000319782C18.9202%200.00035892%2019.4802%200.000378489%2019.908%200.218371C20.2843%200.410123%2020.5903%200.716083%2020.782%201.0924ZM10.109%201.54601C10%201.75992%2010%202.03995%2010%202.6V19.4C10%2019.9601%2010%2020.2401%2010.109%2020.454C10.2049%2020.6422%2010.3578%2020.7951%2010.546%2020.891C10.7599%2021%2011.0399%2021%2011.6%2021H18.4C18.9601%2021%2019.2401%2021%2019.454%2020.891C19.6422%2020.7951%2019.7951%2020.6422%2019.891%2020.454C20%2020.2401%2020%2019.9601%2020%2019.4V2.6C20%202.03995%2020%201.75992%2019.891%201.54601C19.7951%201.35785%2019.6422%201.20487%2019.454%201.10899C19.2401%201%2018.9601%201%2018.4%201H11.6C11.0399%201%2010.7599%201%2010.546%201.10899C10.3578%201.20487%2010.2049%201.35785%2010.109%201.54601Z'%20fill='%23211236'/%3e%3ccircle%20cx='15'%20cy='19'%20r='1'%20fill='%23211236'/%3e%3cpath%20d='M12%201H18C18%201.55228%2017.5523%202%2017%202H13C12.4477%202%2012%201.55228%2012%201Z'%20fill='%23211236'/%3e%3cpath%20d='M0%209.75H6V10.75H0V9.75Z'%20fill='%23211236'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M6.83358%2010.9314C7.199%2010.5452%207.19835%209.94063%206.83211%209.55524L4.56028%207.16458C4.36668%206.96085%204.04324%206.95673%203.84451%207.15546C3.65282%207.34715%203.64888%207.6567%203.83562%207.85321L5.45448%209.55675C5.82072%209.94215%205.82137%2010.5467%205.45596%2010.9329L3.83418%2012.6469C3.64815%2012.8435%203.65242%2013.1524%203.8438%2013.3438C4.04282%2013.5428%204.36683%2013.5383%204.56027%2013.3339L6.83358%2010.9314Z'%20fill='%23211236'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_21_218'%3e%3crect%20width='22'%20height='22'%20fill='white'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")}@media (max-width: 640px){._buttons_1ywb7_38{flex-direction:column;row-gap:16px}._title_1ywb7_19{font-size:18px}}@container host (max-width: 640px){._buttons_1ywb7_38{flex-direction:column;row-gap:16px}._title_1ywb7_19{font-size:18px}}`, vR = `._info-message_1fk4r_1{display:flex;flex:1;flex-direction:column;align-items:center;justify-content:center;padding:24px}._text-container_1fk4r_10{display:flex;flex-direction:column;align-items:center;word-break:break-word;row-gap:16px}._text-container_1fk4r_10:before{content:"";display:inline-flex;width:80px;height:80px;background-repeat:no-repeat;background-position:center;background-size:contain}._title_1fk4r_28{margin:0;font-size:20px;font-weight:600;line-height:120%;color:#262626;text-align:center}._subtitle_1fk4r_37{margin:0;font-size:16px;font-weight:400;line-height:100%;color:#454545;text-align:center}._retry-button_1fk4r_46:before{background-image:url("data:image/svg+xml,%3csvg%20width='21'%20height='20'%20viewBox='0%200%2021%2020'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M15.5737%204.07891C15.4824%203.99597%2015.3891%203.91522%2015.2939%203.83677M15.5737%204.07891L15.2939%203.83677M15.5737%204.07891C16.2977%204.73614%2016.9002%205.53165%2017.3422%206.42526M15.2939%203.83677C13.9798%202.7533%2012.3118%202.10522%2010.4966%202.10522C8.07269%202.10522%205.91117%203.26089%204.50449%205.06575M16.9822%2014.2243C15.621%2016.4305%2013.2251%2017.8947%2010.4966%2017.8947C7.51384%2017.8947%204.92843%2016.1447%203.65796%2013.5885'%20stroke='%23211236'%20stroke-linecap='round'/%3e%3cpath%20d='M18.0873%202.58536L17.4019%206.47276L13.5145%205.7873'%20stroke='%23211236'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M2.6126%2017.2589L3.29805%2013.3715L7.18545%2014.0569'%20stroke='%23211236'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e")}`, gR = "._container_zfhdf_1,._layout_zfhdf_2{display:flex;overflow:hidden}._container_zfhdf_1{position:relative;width:100%;height:100%}._layout_zfhdf_2{direction:ltr;justify-content:center;position:absolute;inset:0;box-shadow:0 0 0 1px #00000080}div[data-layout=new] ._layout_zfhdf_2{box-shadow:0 0 0 1px #f8f8f8}._loader_zfhdf_25{position:absolute;inset:0;box-shadow:none;z-index:999}", DR = `._top-functional-buttons_1df3q_1,._bottom-functional-buttons_1df3q_2,._left-functional-buttons_1df3q_3{position:absolute;padding:16px;display:flex;gap:15px;z-index:5}._top-functional-buttons_1df3q_1{top:0}._main-functional-buttons_1df3q_15{position:absolute;display:grid;grid-template-areas:"camera   copyright" "capture  copyright" "mirror   copyright";max-height:60%;height:100%;grid-template-columns:auto auto;grid-template-rows:2fr auto 2fr;align-items:center;justify-items:center;row-gap:5px;padding:0 15px}._bottom-functional-buttons_1df3q_2{bottom:0}._bottom-functional-buttons_1df3q_2 button:focus-visible,._top-functional-buttons_1df3q_1 button:focus-visible,._left-functional-buttons_1df3q_3 button:focus-visible,._main-functional-buttons_1df3q_15 button:focus-visible{outline:2px solid blue}._left-functional-buttons_1df3q_3,._main-functional-buttons_1df3q_15{bottom:50%;transform:translateY(50%);direction:ltr}._top-functional-buttons_1df3q_1 button:hover,._left-functional-buttons_1df3q_3 button:hover{transform:scale(1.1)}div[data-layout=new] ._top-functional-buttons_1df3q_1 button:hover{transform:none}._top-functional-buttons_1df3q_1 button,._bottom-functional-buttons_1df3q_2 button,._left-functional-buttons_1df3q_3 button,._main-functional-buttons_1df3q_15 button{display:flex;justify-content:center;align-items:center;border:none;padding:0;margin:0;text-decoration:none;background:none;cursor:pointer;text-align:center;transition:background .25s ease-in-out,transform .15s ease}div[data-layout=new] ._mirror-button_1df3q_76,div[data-layout=new] ._change-camera-button_1df3q_77{width:48px;height:48px;border-radius:50%;background:#3335431a;flex-shrink:0}div[data-layout=new] ._mirror-button_1df3q_76:hover,div[data-layout=new] ._change-camera-button_1df3q_77:hover{background:#33354333}div[data-layout=new] ._mirror-button_1df3q_76:active,div[data-layout=new] ._change-camera-button_1df3q_77:active{background:#3335434d}div[data-layout=new] ._mirror-button_1df3q_76{grid-area:mirror}div[data-layout=new] ._process-button_1df3q_99,div[data-layout=new] ._snapshot-button_1df3q_100{grid-area:capture}div[data-layout=new] ._change-camera-button_1df3q_77{grid-area:camera}._copyright_1df3q_108{grid-area:copyright}div[data-layout=new] ._skip-button_1df3q_112{position:absolute;display:flex;flex-direction:row-reverse;gap:5px;font-family:Inter,sans-serif;font-size:18px;line-height:24px;color:#fff;padding:8px 14px;background-color:#3d3d4780;border-radius:26px;right:180%;grid-area:capture}div[data-layout=new][data-orientation=landscape] ._skip-button_1df3q_112:hover{background-color:#3d3d4799}div[data-layout=new][data-orientation=landscape] ._skip-button_1df3q_112:active{background-color:#3d3d47b3}div[data-layout=new][data-orientation=portrait] ._skip-button_1df3q_112:hover{background-color:#33354333}div[data-layout=new][data-orientation=portrait] ._skip-button_1df3q_112:active{background-color:#3335434d}div[data-layout=new] ._process-button_1df3q_99:hover,div[data-layout=new] ._snapshot-button_1df3q_100:hover{filter:brightness(.5)}div[data-layout=new] ._process-button_1df3q_99:active,div[data-layout=new] ._snapshot-button_1df3q_100:active{filter:brightness(.1)}._left-functional-buttons_1df3q_3 ._skip-button_1df3q_112{padding:0 10px;border-radius:6px;background-color:#1b101f80}._controls-container_1df3q_160 button:before{content:"";display:inline-flex;background-repeat:no-repeat;background-position:center;background-size:contain}._process-close-button_1df3q_168:before{width:24px;height:24px;background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%20width='24'%20height='24'%20fill='%23ffffff'%3e%3cpath%20d='M19%206.41L17.59%205%2012%2010.59%206.41%205%205%206.41%2010.59%2012%205%2017.59%206.41%2019%2012%2013.41%2017.59%2019%2019%2017.59%2013.41%2012z'/%3e%3c/svg%3e")}div[data-layout=new] ._process-close-button_1df3q_168:before{width:32px;height:32px;background-image:url("data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M24%208L8%2024M8%208L24%2024'%20stroke='black'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'%20opacity='0.6'/%3e%3c/svg%3e")}._process-button_1df3q_99:before{width:40px;height:40px;background-image:url("data:image/svg+xml,%3csvg%20width='60'%20height='60'%20viewBox='0%200%2060%2060'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.6'%3e%3ccircle%20cx='30'%20cy='30'%20r='29.5'%20stroke='white'/%3e%3c/g%3e%3ccircle%20cx='30'%20cy='30'%20r='21'%20fill='white'/%3e%3c/svg%3e")}div[data-layout=new] ._process-button_1df3q_99:before{width:56px;height:56px;background-image:url("data:image/svg+xml,%3csvg%20width='56'%20height='56'%20viewBox='0%200%2056%2056'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='28'%20cy='28'%20r='21'%20fill='%23343644'%20stroke='%23343644'%20stroke-width='4'%20opacity='0.3'/%3e%3ccircle%20cx='28'%20cy='28'%20r='26.5'%20stroke='%23343644'%20stroke-width='3'%20opacity='0.3'/%3e%3c/svg%3e")}div[data-layout=new][data-orientation=portrait] ._process-button_1df3q_99:before{width:72px;height:72px;background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='72'%20height='72'%20viewBox='0%200%2072%2072'%20fill='none'%3e%3ccircle%20cx='36'%20cy='36'%20r='28'%20fill='%23343644'%20stroke='%23343644'%20stroke-width='4'%20opacity='0.3'/%3e%3ccircle%20cx='36'%20cy='36'%20r='34.25'%20stroke='%23343644'%20stroke-width='3.5'%20opacity='0.3'/%3e%3c/svg%3e")}._snapshot-button_1df3q_100:before{width:40px;height:40px;background-image:url("data:image/svg+xml,%3csvg%20width='60'%20height='60'%20viewBox='0%200%2060%2060'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.6'%3e%3ccircle%20cx='30'%20cy='30'%20r='29.5'%20stroke='white'/%3e%3c/g%3e%3ccircle%20cx='30'%20cy='30'%20r='21'%20fill='white'/%3e%3c/svg%3e")}div[data-layout=new] ._snapshot-button_1df3q_100:before{width:56px;height:56px;background-image:url("data:image/svg+xml,%3csvg%20width='56'%20height='56'%20viewBox='0%200%2056%2056'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='28'%20cy='28'%20r='21'%20fill='%23343644'%20stroke='%23343644'%20stroke-width='4'%20opacity='0.3'/%3e%3ccircle%20cx='28'%20cy='28'%20r='26.5'%20stroke='%23343644'%20stroke-width='3'%20opacity='0.3'/%3e%3c/svg%3e")}._skip-button_1df3q_112:before{width:40px;height:40px;background-image:url("data:image/svg+xml,%3csvg%20width='32'%20height='32'%20viewBox='0%200%2032%2032'%20fill='white'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M22,9a1,1,0,0,0,0,1.42l4.6,4.6H3.06a1,1,0,1,0,0,2H26.58L22,21.59A1,1,0,0,0,22,23a1,1,0,0,0,1.41,0l6.36-6.36a.88.88,0,0,0,0-1.27L23.42,9A1,1,0,0,0,22,9Z'/%3e%3c/svg%3e")}div[data-layout=new] ._skip-button_1df3q_112:before{width:13px;height:12px;background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='12'%20height='12'%20viewBox='0%200%2012%2012'%20fill='none'%3e%3cpath%20d='M11.5303%206.53033C11.8232%206.23744%2011.8232%205.76256%2011.5303%205.46967L6.75736%200.6967C6.46447%200.403806%205.98959%200.403806%205.6967%200.6967C5.40381%200.989593%205.40381%201.46447%205.6967%201.75736L9.93934%206L5.6967%2010.2426C5.40381%2010.5355%205.40381%2011.0104%205.6967%2011.3033C5.98959%2011.5962%206.46447%2011.5962%206.75736%2011.3033L11.5303%206.53033ZM1%205.25C0.585787%205.25%200.25%205.58579%200.25%206C0.25%206.41421%200.585787%206.75%201%206.75V5.25ZM11%206V5.25L1%205.25V6V6.75L11%206.75V6Z'%20fill='white'/%3e%3c/svg%3e")}div[data-layout=new][data-orientation=portrait] ._skip-button_1df3q_112:before{background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='13'%20height='12'%20viewBox='0%200%2013%2012'%20fill='none'%3e%3cpath%20d='M12.0303%206.53033C12.3232%206.23744%2012.3232%205.76256%2012.0303%205.46967L7.25736%200.6967C6.96447%200.403806%206.48959%200.403806%206.1967%200.6967C5.90381%200.989593%205.90381%201.46447%206.1967%201.75736L10.4393%206L6.1967%2010.2426C5.90381%2010.5355%205.90381%2011.0104%206.1967%2011.3033C6.48959%2011.5962%206.96447%2011.5962%207.25736%2011.3033L12.0303%206.53033ZM1.5%205.25C1.08579%205.25%200.75%205.58579%200.75%206C0.75%206.41421%201.08579%206.75%201.5%206.75V5.25ZM11.5%206V5.25L1.5%205.25V6V6.75L11.5%206.75V6Z'%20fill='%23343644'/%3e%3c/svg%3e")}._mirror-back-button_1df3q_226:before{width:30px;height:30px;background-image:url("data:image/svg+xml,%3csvg%20width='30'%20height='30'%20viewBox='0%200%2030%2030'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.9'%3e%3crect%20x='14'%20y='4'%20width='2'%20height='22'%20rx='1'%20fill='white'/%3e%3cpath%20d='M8.698%2015%20L1%205.762%201%2024.238%20Z'%20stroke='white'%20stroke-width='2'/%3e%3cpath%20d='M21.302%2015%20L29%205.762%2029%2024.238%20Z'%20fill='white'%20stroke='white'%20stroke-width='2'/%3e%3c/g%3e%3c/svg%3e")}._mirror-front-button_1df3q_232:before{width:30px;height:30px;background-image:url("data:image/svg+xml,%3csvg%20width='30'%20height='30'%20viewBox='0%200%2030%2030'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%20opacity='0.9'%3e%3crect%20x='14'%20y='4'%20width='2'%20height='22'%20rx='1'%20fill='white'/%3e%3cpath%20d='M21.302%2015%20L29%205.762%2029%2024.238%20Z'%20stroke='white'%20stroke-width='2'/%3e%3cpath%20d='M8.698%2015%20L1%205.762%201%2024.238%20Z'%20fill='white'%20stroke='white'%20stroke-width='2'/%3e%3c/g%3e%3c/svg%3e")}._mirror-button_1df3q_76:before{width:32px;height:24px;background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='32'%20height='24'%20viewBox='0%200%2032%2024'%20fill='none'%3e%3cpath%20d='M0.75%205.40137L10.6475%2012L0.75%2018.5986L0.75%205.40137Z'%20stroke='%23343644'%20stroke-width='1.5'/%3e%3cpath%20d='M31.25%205.40137L21.3525%2012L31.25%2018.5986L31.25%205.40137Z'%20stroke='%23343644'%20stroke-width='1.5'/%3e%3crect%20x='15.625'%20y='0.375'%20width='0.75'%20height='23.25'%20fill='white'%20stroke='%23343644'%20stroke-width='0.75'/%3e%3c/svg%3e")}._change-camera-button_1df3q_77:before{width:33px;height:33px;background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='white'%3e%3cpath%20d='M12.29,5.21l1.5,1.5a1,1,0,0,0,1.42,0,1,1,0,0,0,.13-1.21H19a1,1,0,0,0,0-2H15.34a1,1,0,0,0-.13-1.21,1,1,0,0,0-1.42,0l-1.5,1.5a1,1,0,0,0-.21.33,1,1,0,0,0,0,.76A1,1,0,0,0,12.29,5.21ZM22.92,9.12a1,1,0,0,0-.21-.33l-1.5-1.5a1,1,0,0,0-1.42,0,1,1,0,0,0-.13,1.21H16a1,1,0,0,0,0,2h3.66a1,1,0,0,0,.13,1.21,1,1,0,0,0,1.42,0l1.5-1.5a1,1,0,0,0,.21-.33A1,1,0,0,0,22.92,9.12ZM11,10a4,4,0,1,0,4,4A4,4,0,0,0,11,10Zm0,6a2,2,0,1,1,2-2A2,2,0,0,1,11,16Zm9-3a1,1,0,0,0-1,1v5a1,1,0,0,1-1,1H4a1,1,0,0,1-1-1V11a1,1,0,0,1,1-1H6a1,1,0,0,0,1-.69l.54-1.62A1,1,0,0,1,8.44,7H10a1,1,0,0,0,0-2H8.44A3,3,0,0,0,5.59,7.06L5.28,8H4a3,3,0,0,0-3,3v8a3,3,0,0,0,3,3H18a3,3,0,0,0,3-3V14A1,1,0,0,0,20,13Z'/%3e%3c/svg%3e")}div[data-layout=new] ._change-camera-button_1df3q_77:before{width:28px;height:24px;background-image:url("data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20width='29'%20height='24'%20viewBox='0%200%2029%2024'%20fill='none'%3e%3cpath%20d='M27.582%2019.7773C27.582%2020.6996%2027.2177%2021.5834%2026.5703%2022.2344C25.9231%2022.885%2025.0463%2023.2499%2024.1328%2023.25H4.5332C3.61955%2023.25%202.74203%2022.8852%202.09473%2022.2344C1.44736%2021.5835%201.08306%2020.6996%201.08301%2019.7773V8.5166L1.08691%208.34375C1.12931%207.48423%201.48774%206.6689%202.09473%206.05859C2.74202%205.40783%203.61961%205.04297%204.5332%205.04297H6.3252C6.65166%205.04283%206.94103%204.83162%207.04004%204.52051L7.48438%203.12207C7.7137%202.43138%208.15327%201.83156%208.73926%201.40625C9.32515%200.98102%2010.0283%200.7514%2010.75%200.75H17.9199C18.6345%200.747308%2019.333%200.967622%2019.918%201.38184C20.4299%201.74436%2020.833%202.23994%2021.0859%202.81348L21.1846%203.06445L21.626%204.4502C21.725%204.7614%2022.0142%204.97266%2022.3408%204.97266H24.1328C24.5901%204.97262%2025.0429%205.06442%2025.4648%205.24219C25.8868%205.41994%2026.2696%205.68047%2026.5908%206.00879C26.9121%206.33718%2027.1657%206.72702%2027.3359%207.15527C27.5062%207.58365%2027.5907%208.04243%2027.583%208.50391H27.582V19.7773Z'%20stroke='%23343644'%20stroke-width='1.5'%20stroke-linejoin='round'/%3e%3cpath%20d='M20.3785%2013C20.3785%2011.4087%2019.7463%209.88258%2018.6211%208.75736C17.4959%207.63214%2015.9698%207%2014.3785%207C13.1918%207%2012.0318%207.35189%2011.0451%208.01118C10.5338%208.35278%2010.081%208.76894%209.7002%209.2432'%20stroke='%23343644'%20stroke-width='1.5'/%3e%3cpath%20d='M21.4438%2013L20.3784%2014.5986L19.313%2013H21.4438Z'%20fill='white'%20stroke='%23343644'/%3e%3cpath%20d='M8.30022%2013C8.30022%2014.5913%208.93236%2016.1174%2010.0576%2017.2426C11.1828%2018.3679%2012.7089%2019%2014.3002%2019C15.4869%2019%2016.6469%2018.6481%2017.6336%2017.9888C18.1449%2017.6472%2018.5977%2017.2311%2018.9785%2016.7568'%20stroke='%23343644'%20stroke-width='1.5'/%3e%3cpath%20d='M7.23486%2013L8.30029%2011.4014L9.36572%2013H7.23486Z'%20fill='white'%20stroke='%23343644'/%3e%3c/svg%3e")}div[data-orientation=landscape] ._top-functional-buttons_1df3q_1,div[data-orientation=landscape] ._left-functional-buttons_1df3q_3,div[data-direction=rtl] div[data-orientation=portrait] ._top-functional-buttons_1df3q_1,div[data-direction=rtl] div[data-orientation=landscape] ._main-functional-buttons_1df3q_15,._bottom-functional-buttons_1df3q_2{left:0}div[data-orientation=portrait] ._bottom-functional-buttons_1df3q_2,div[data-direction=ltr] div[data-orientation=portrait] ._top-functional-buttons_1df3q_1{right:0}div[data-orientation=portrait] ._left-functional-buttons_1df3q_3{bottom:0;right:50%;transform:translate(50%);flex-direction:column-reverse;z-index:1}div[data-orientation=landscape] ._bottom-functional-buttons_1df3q_2{flex-direction:column}div[data-orientation=portrait] ._bottom-functional-buttons_1df3q_2{justify-content:space-between}div[data-orientation=portrait] ._main-functional-buttons_1df3q_15{grid-template-areas:"mirror     capture  camera" "copyright copyright copyright";max-height:none;height:auto;width:100%;grid-template-columns:2fr auto 2fr;grid-template-rows:auto auto;row-gap:0;column-gap:5px;padding:15px 0 30px;bottom:0;right:50%;transform:translate(50%)}div[data-direction=ltr] div[data-layout=new] ._top-functional-buttons_1df3q_1,div[data-direction=ltr] div[data-orientation=landscape] ._main-functional-buttons_1df3q_15{left:auto;right:0}div[data-orientation=landscape] ._main-functional-buttons_1df3q_15 button+._copyright_1df3q_108{padding-left:15px}div[data-orientation=portrait] ._main-functional-buttons_1df3q_15 button+._copyright_1df3q_108{padding-top:36px}div[data-layout=new][data-orientation=portrait] ._skip-button_1df3q_112{color:#343644;background-color:#3335431a;right:auto;bottom:155%;grid-area:capture}div[data-direction=rtl] div[data-orientation=landscape] ._main-functional-buttons_1df3q_15{top:50%;transform:rotate(180deg) translateY(50%);transform-origin:center}`, RR = '._svg_68emc_1{position:absolute;inset:0}._svg_68emc_1 rect,._svg_68emc_1 path{transition:.25s stroke}._svg_68emc_1 rect[mask="url(#bgClip)"]{opacity:.5;fill:#000}div[data-layout=new] ._svg_68emc_1 rect[mask="url(#bgClip)"]{opacity:1;fill:#f8f8f8}', AR = `._hint-container_1r2jg_1{display:flex;justify-content:center;position:absolute;inset:0;--message-top: 50px;--indicator-top: -50%}._tips-frameless_1r2jg_10 ._message_1r2jg_10{margin:0 36px}._fade-enter_1r2jg_14{opacity:0}._fade-enter-active_1r2jg_18{opacity:1;transition:opacity .3s}._fade-exit_1r2jg_23{opacity:1}._fade-exit-active_1r2jg_27{opacity:0;transition:opacity .3s}._message-container_1r2jg_32{display:flex;flex-direction:column;width:100%;max-width:370px;position:relative;align-self:center;align-items:center}._icon_1r2jg_42{position:absolute;display:flex;justify-content:center;align-items:center;transform:translateY(var(--indicator-top))}._message-container_1r2jg_32 ._icon_1r2jg_42:before{content:"";display:inline-flex;background-repeat:no-repeat;background-position:center;background-size:contain}._processing-error-icon_1r2jg_58:before{width:80px;height:80px;background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2080%2080'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='40'%20cy='40'%20r='40'%20fill='%23E95454'%20fill-opacity='0.45'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M40%2067C54.9117%2067%2067%2054.9117%2067%2040C67%2025.0883%2054.9117%2013%2040%2013C25.0883%2013%2013%2025.0883%2013%2040C13%2054.9117%2025.0883%2067%2040%2067ZM40%2064C53.2548%2064%2064%2053.2548%2064%2040C64%2026.7452%2053.2548%2016%2040%2016C26.7452%2016%2016%2026.7452%2016%2040C16%2053.2548%2026.7452%2064%2040%2064Z'%20fill='white'/%3e%3c/svg%3e")}._search-icon_1r2jg_64:before{width:80px;height:80px;background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2080%2080'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cg%3e%3ccircle%20cx='40'%20cy='40'%20r='40'%20fill='%231B101F'%20fill-opacity='0.5'/%3e%3c/g%3e%3cg%20opacity='0.8'%3e%3ccircle%20cx='40'%20cy='40'%20r='23.5'%20stroke='white'/%3e%3ccircle%20cx='40'%20cy='40'%20r='1'%20fill='white'/%3e%3c/g%3e%3c/svg%3e")}._square-icon_1r2jg_70:before{width:46px;height:46px;background-image:url("data:image/svg+xml,%3csvg%20width='46'%20height='46'%20viewBox='0%200%2046%2046'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M45%2034V41C45%2043.2091%2043.2091%2045%2041%2045H34M45%2012V5C45%202.79086%2043.2091%201%2041%201H34M12%201H5C2.79086%201%201%202.79086%201%205V12M1%2034V41C1%2043.2091%202.79086%2045%205%2045H12'%20stroke='white'%20stroke-width='1.5'/%3e%3c/svg%3e")}._message_1r2jg_10{position:absolute;left:0;right:0;display:flex;justify-content:center;transform:translateY(var(--message-top));z-index:10}._message-background_1r2jg_86{text-align:center;padding:12px 24px;border-radius:6px;color:#fff;background-color:#1b101f80}div[data-layout=new] ._message-background_1r2jg_86{padding:8px 14px;border-radius:14px;color:#000;background-color:#fff}div[data-layout=new][data-orientation=portrait] ._message-background_1r2jg_86{background-color:#e8e8e8}._title_1r2jg_105{font-weight:400;margin:0;font-size:18px;line-height:21px}._copyright_1r2jg_112{position:absolute;bottom:10px;right:20px;filter:drop-shadow(0 0 2px rgba(0,0,0,.5))}._copyright_1r2jg_112 span{color:#e9e9e9}`, TR = `._flip_1nryz_1,._one-side_1nryz_2{width:80%;height:100%;position:absolute;align-self:center;perspective:1000px}._front_1nryz_10:before,._back_1nryz_11:before,._one-side_1nryz_2:before{content:"";width:100%;height:100%;display:inline-flex;background-repeat:no-repeat;background-position:center;background-size:100% auto}._slide_1nryz_22:before{background-position:center 115%;animation:_slide_1nryz_22 var(--animation-duration) var(--animation-delay) ease-out forwards}._front_1nryz_10,._back_1nryz_11{position:absolute;display:flex;justify-content:center;align-items:center;top:0;left:0;width:100%;height:100%;backface-visibility:hidden;-webkit-backface-visibility:hidden}._front_1nryz_10{z-index:2;animation:_flip-front_1nryz_1 var(--animation-duration) var(--animation-delay) ease-out forwards}._back_1nryz_11{transform:rotateY(180deg);animation:_flip-back_1nryz_1 var(--animation-duration) var(--animation-delay) ease-out forwards}._id-front-icon_1nryz_51:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M101.246%2028.1982H22.4961V126.887C22.4962%20124.482%2027.1732%20123.323%2032.6526%20121.964C39.93%20120.16%2048.6229%20118.005%2049.6542%20112.116C44.6713%20108.96%2042.7698%20104.198%2040.8243%2099.3255C40.4465%2098.3791%2040.0669%2097.4286%2039.6629%2096.485C34.7738%20101.236%2032.5935%2079.4764%2036.9774%2079.4764C28.6435%2056.9793%2051.4615%2038.5191%2072.545%2051.2088C84.91%2048.5382%2091.7424%2063.3145%2084.3766%2079.4768C87.4153%2078.0182%2087.9964%2085.7946%2087.4153%2090.6287C87.4153%2091.8706%2086.1245%20100.564%2082.8626%2097.1966C82.4668%2098.1115%2082.0949%2099.0331%2081.7247%2099.9507L81.7241%2099.9523L81.7239%2099.9527C79.768%20104.801%2077.8573%20109.537%2072.6874%20112.594C74.1725%20118.123%2083.0554%20120.21%2090.5254%20121.964C96.3092%20123.323%20101.246%20124.482%20101.246%20126.887V28.1982Z'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='104.327'%20width='59.0625'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='182.812'%20y='104.327'%20width='64.6875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='28.1963'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='53.5742'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='78.9512'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='129.704'%20width='135'%20height='11.2787'%20fill='%23333543'/%3e%3c/svg%3e")}._passport-single-icon_1nryz_55:before{background-image:url("data:image/svg+xml,%3csvg%20width='309'%20height='219'%20viewBox='0%200%20309%20219'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.40455%20196.527C1.40455%20200.484%201.40564%20203.366%201.59124%20205.638C1.7755%20207.893%202.13459%20209.422%202.78232%20210.693C3.99425%20213.072%205.92806%20215.006%208.3066%20216.218C9.57784%20216.865%2011.1068%20217.225%2013.3621%20217.409C15.6337%20217.594%2018.5165%20217.595%2022.4727%20217.595H286.527C290.484%20217.595%20293.366%20217.594%20295.638%20217.409C297.893%20217.225%20299.422%20216.865%20300.693%20216.218C303.072%20215.006%20305.006%20213.072%20306.218%20210.693C306.865%20209.422%20307.224%20207.893%20307.409%20205.638C307.594%20203.366%20307.595%20200.484%20307.595%20196.527V1.40454H1.40455V196.527Z'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.80909'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M95.509%2033.6924H22.4727V129.154H22.4727C22.4729%20126.828%2026.8105%20125.706%2031.8923%20124.392L31.8924%20124.392C38.6418%20122.647%2046.7039%20120.562%2047.6604%20114.866C43.039%20111.813%2041.2755%20107.207%2039.4712%20102.494L39.4711%20102.494C39.1207%20101.578%2038.7687%20100.659%2038.394%2099.7463C33.8596%20104.342%2031.8376%2083.2938%2035.9034%2083.2938C28.1741%2061.5324%2049.3366%2043.6758%2068.8904%2055.9505C80.3582%2053.3672%2086.695%2067.6604%2079.8636%2083.2943C82.6818%2081.8833%2083.2207%2089.4054%2082.6818%2094.0815C82.6818%2095.2828%2081.4847%20103.692%2078.4594%20100.435C78.0921%20101.32%2077.747%20102.212%2077.4035%20103.1L77.4034%20103.1L77.4033%20103.101C75.5893%20107.79%2073.8173%20112.371%2069.0225%20115.329C70.3998%20120.677%2078.6382%20122.695%2085.5662%20124.392C90.9184%20125.703%2095.4886%20126.823%2095.509%20129.138V33.6924Z'%20fill='%23333543'/%3e%3crect%20x='22.4727'%20y='160.038'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='224.727'%20y='33.6924'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='33.6924'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='53.3457'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='73'%20width='103.936'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='92.6543'%20width='78.6545'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='112.308'%20width='154.5'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='131.962'%20width='50.5636'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='22.4727'%20y='185.308'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3c/svg%3e")}._passport-both-pages-icon_1nryz_59:before{background-image:url("data:image/svg+xml,%3csvg%20width='309'%20height='438'%20viewBox='0%200%20309%20438'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.40455%2022.4727C1.40455%2018.5165%201.40564%2015.6337%201.59124%2013.3621C1.7755%2011.1068%202.13459%209.57784%202.78232%208.3066C3.99425%205.92806%205.92806%203.99425%208.3066%202.78232C9.57784%202.13459%2011.1068%201.7755%2013.3621%201.59124C15.6337%201.40564%2018.5165%201.40455%2022.4727%201.40455H286.527C290.484%201.40455%20293.366%201.40564%20295.638%201.59124C297.893%201.7755%20299.422%202.13459%20300.693%202.78232C303.072%203.99425%20305.006%205.92806%20306.218%208.3066C306.865%209.57784%20307.224%2011.1068%20307.409%2013.3621C307.594%2015.6337%20307.595%2018.5165%20307.595%2022.4727V217.595H1.40455V22.4727Z'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.80909'/%3e%3cpath%20d='M1.40455%20415.527C1.40455%20419.484%201.40564%20422.366%201.59124%20424.638C1.7755%20426.893%202.13459%20428.422%202.78232%20429.693C3.99425%20432.072%205.92806%20434.006%208.3066%20435.218C9.57784%20435.865%2011.1068%20436.225%2013.3621%20436.409C15.6337%20436.594%2018.5165%20436.595%2022.4727%20436.595H286.527C290.484%20436.595%20293.366%20436.594%20295.638%20436.409C297.893%20436.225%20299.422%20435.865%20300.693%20435.218C303.072%20434.006%20305.006%20432.072%20306.218%20429.693C306.865%20428.422%20307.224%20426.893%20307.409%20424.638C307.594%20422.366%20307.595%20419.484%20307.595%20415.527V220.405H1.40455V415.527Z'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.80909'/%3e%3crect%20x='22.4727'%20y='379.038'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='224.727'%20y='252.692'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='252.692'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='272.346'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='292'%20width='103.936'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='311.654'%20width='78.6545'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='331.308'%20width='154.5'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='350.962'%20width='50.5636'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='22.4727'%20y='404.308'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M95.509%20252.692H22.4727V348.154H95.509V348.154H22.4727C22.4727%20345.828%2026.8104%20344.706%2031.8923%20343.392L31.8924%20343.392C38.6418%20341.647%2046.7039%20339.562%2047.6604%20333.866C43.039%20330.813%2041.2755%20326.206%2039.4712%20321.494L39.4711%20321.493C39.1207%20320.578%2038.7687%20319.659%2038.394%20318.746C33.8596%20323.342%2031.8376%20302.294%2035.9034%20302.294C28.1741%20280.532%2049.3366%20262.676%2068.8904%20274.95C80.3582%20272.367%2086.695%20286.66%2079.8636%20302.294C82.6818%20300.883%2083.2207%20308.405%2082.6818%20313.081C82.6818%20314.282%2081.4847%20322.692%2078.4594%20319.434C78.0921%20320.32%2077.747%20321.212%2077.4035%20322.1L77.4034%20322.1L77.4033%20322.1C75.5893%20326.79%2073.8173%20331.371%2069.0225%20334.328C70.3998%20339.677%2078.6382%20341.695%2085.5662%20343.392C90.9184%20344.703%2095.4886%20345.823%2095.509%20348.138V252.692Z'%20fill='%23333543'/%3e%3c/svg%3e")}._id-mrz-front-icon_1nryz_63:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3crect%20x='112.5'%20y='25.377'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='50.7539'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='76.1309'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='138.164'%20width='225'%20height='11.2787'%20fill='%23333543'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M101.25%2025.377H22.5V124.065C22.5003%20121.661%2027.1772%20120.502%2032.6565%20119.143C39.9339%20117.339%2048.6268%20115.184%2049.6581%20109.295C44.6752%20106.139%2042.7737%20101.377%2040.8282%2096.5044C40.4504%2095.558%2040.0708%2094.6075%2039.6668%2093.6639C34.7777%2098.4148%2032.5974%2076.6553%2036.9813%2076.6553C28.6474%2054.1582%2051.4654%2035.698%2072.5489%2048.3877C84.9139%2045.717%2091.7464%2060.4934%2084.3805%2076.6557C87.4192%2075.1971%2088.0003%2082.9735%2087.4192%2087.8076C87.4192%2089.0495%2086.1284%2097.7429%2082.8665%2094.3755C82.4704%2095.2911%2082.0983%2096.2133%2081.7279%2097.1316C79.7719%20101.98%2077.8612%20106.715%2072.6914%20109.773C74.1764%20115.302%2083.0593%20117.388%2090.5293%20119.143C96.3129%20120.502%20101.25%20121.661%20101.25%20124.065V25.377Z'%20fill='%23333543'/%3e%3c/svg%3e")}._id-back-icon_1nryz_67:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3crect%20x='22.5'%20y='22.5576'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='171.562'%20y='22.5576'%20width='75.9375'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='154.688'%20y='138.164'%20width='92.8125'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='47.9346'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='47.9346'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='73.3115'%20width='73.125'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='112.787'%20width='50.625'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='138.164'%20width='87.1875'%20height='11.2787'%20fill='%23333543'/%3e%3c/svg%3e")}._id-mrz-back-icon_1nryz_71:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40625'%20y='-1.40625'%20width='267.188'%20height='169.188'%20rx='12.6562'%20transform='matrix(1%200%200%20-1%200%20169.188)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.8125'/%3e%3crect%20x='22.5'%20y='124.065'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='107.147'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='25.377'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='50.7539'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='50.7539'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='140.983'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3c/svg%3e")}._id-barcode-back-icon_1nryz_75:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40625'%20y='-1.40625'%20width='267.188'%20height='169.188'%20rx='12.6562'%20transform='matrix(1%200%200%20-1%200%20169.188)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.8125'/%3e%3crect%20x='22.5'%20y='22.5576'%20width='225'%20height='33.8361'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='112.787'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='112.787'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='138.164'%20width='87.1875'%20height='11.2787'%20fill='%23333543'/%3e%3cg%20clip-path='url(%23clip0_10772_56590)'%3e%3cpath%20d='M247.5%2022.5576H22.5V64.8527H247.5V22.5576Z'%20fill='%23D6D6D6'/%3e%3cpath%20d='M37.4999%2022.5576H22.5V27.257H37.4999V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2022.5576H39.375V27.257H41.2501V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2022.5576H43.1328V27.257H45.0079V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2022.5576H46.8672V27.257H48.7423V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7577%2022.5576H54.3828V27.257H63.7577V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4962%2022.5576H65.6211V27.257H67.4962V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M71.254%2022.5576H69.3789V27.257H71.254V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4999%2022.5576H73.125V27.257H82.4999V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9921%2022.5576H86.2422V27.257H89.9921V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M93.754%2022.5576H91.8789V27.257H93.754V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3749%2022.5576H95.625V27.257H99.3749V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M110.621%2022.5576H104.996V27.257H110.621V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2022.5576H118.125V27.257H121.875V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M133.125%2022.5576H129.375V27.257H133.125V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M136.875%2022.5576H135V27.257H136.875V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M140.633%2022.5576H138.758V27.257H140.633V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M151.871%2022.5576H149.996V27.257H151.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M159.379%2022.5576H153.754V27.257H159.379V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M172.508%2022.5576H166.883V27.257H172.508V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M176.25%2022.5576H174.375V27.257H176.25V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M191.254%2022.5576H181.879V27.257H191.254V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M195.004%2022.5576H193.129V27.257H195.004V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M198.75%2022.5576H196.875V27.257H198.75V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M209.996%2022.5576H200.621V27.257H209.996V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2022.5576H213.75V27.257H226.875V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2022.5576H228.746V27.257H230.621V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2022.5576H236.25V27.257H238.125V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2022.5576H240.008V27.257H241.883V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2022.5576H245.621V27.257H247.496V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2027.2578H22.5V31.9572H37.4999V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2027.2578H39.375V31.9572H41.2501V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2027.2578H43.1328V31.9572H45.0079V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2027.2578H46.8672V31.9572H48.7423V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8829%2027.2578H54.3828V31.9572H61.8829V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M65.629%2027.2578H63.7539V31.9572H65.629V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3751%2027.2578H67.5V31.9572H69.3751V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M78.7462%2027.2578H76.8711V31.9572H78.7462V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M91.8672%2027.2578H86.2422V31.9572H91.8672V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M99.379%2027.2578H97.5039V31.9572H99.379V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M105%2027.2578H101.25V31.9572H105V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2027.2578H110.633V31.9572H112.508V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2027.2578H118.125V31.9572H121.875V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M133.129%2027.2578H125.629V31.9572H133.129V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M136.875%2027.2578H135V31.9572H136.875V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M148.133%2027.2578H138.758V31.9572H148.133V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M155.621%2027.2578H149.996V31.9572H155.621V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M163.121%2027.2578H161.246V31.9572H163.121V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M174.375%2027.2578H168.75V31.9572H174.375V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M180.004%2027.2578H176.254V31.9572H180.004V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M189.379%2027.2578H181.879V31.9572H189.379V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M193.125%2027.2578H191.25V31.9572H193.125V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M196.883%2027.2578H195.008V31.9572H196.883V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M202.496%2027.2578H200.621V31.9572H202.496V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2027.2578H213.75V31.9572H226.875V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2027.2578H228.746V31.9572H230.621V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2027.2578H236.25V31.9572H238.125V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2027.2578H240.008V31.9572H241.883V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2027.2578H245.621V31.9572H247.496V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2031.9561H22.5V36.6555H37.4999V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2031.9561H39.375V36.6555H41.2501V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2031.9561H43.1328V36.6555H45.0079V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2031.9561H46.8672V36.6555H48.7423V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M56.2579%2031.9561H54.3828V36.6555H56.2579V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M59.9923%2031.9561H58.1172V36.6555H59.9923V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7501%2031.9561H61.875V36.6555H63.7501V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M75.0001%2031.9561H67.5V36.6555H75.0001V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9921%2031.9561H86.2422V36.6555H89.9921V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M103.129%2031.9561H91.8789V36.6555H103.129V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2031.9561H104.996V36.6555H108.746V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2031.9561H110.633V36.6555H112.508V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M120%2031.9561H118.125V36.6555H120V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2031.9561H121.871V36.6555H123.746V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M136.871%2031.9561H133.121V36.6555H136.871V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M148.133%2031.9561H138.758V36.6555H148.133V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M151.871%2031.9561H149.996V36.6555H151.871V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M161.258%2031.9561H155.633V36.6555H161.258V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M172.492%2031.9561H170.617V36.6555H172.492V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M178.125%2031.9561H174.375V36.6555H178.125V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M183.754%2031.9561H181.879V36.6555H183.754V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M187.5%2031.9561H185.625V36.6555H187.5V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M191.246%2031.9561H189.371V36.6555H191.246V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M206.242%2031.9561H198.742V36.6555H206.242V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2031.9561H213.75V36.6555H226.875V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2031.9561H228.746V36.6555H230.621V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2031.9561H236.25V36.6555H238.125V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2031.9561H240.008V36.6555H241.883V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2031.9561H245.621V36.6555H247.496V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2036.6562H22.5V41.3557H37.4999V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2036.6562H39.375V41.3557H41.2501V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2036.6562H43.1328V41.3557H45.0079V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2036.6562H46.8672V41.3557H48.7423V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1327%2036.6562H54.3828V41.3557H58.1327V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8712%2036.6562H59.9961V41.3557H61.8712V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M71.254%2036.6562H63.7539V41.3557H71.254V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3671%2036.6562H74.9922V41.3557H84.3671V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M95.6171%2036.6562H86.2422V41.3557H95.6171V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M99.379%2036.6562H97.5039V41.3557H99.379V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M103.125%2036.6562H101.25V41.3557H103.125V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M116.25%2036.6562H106.875V41.3557H116.25V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M123.75%2036.6562H118.125V41.3557H123.75V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M131.254%2036.6562H125.629V41.3557H131.254V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M134.996%2036.6562H133.121V41.3557H134.996V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M140.633%2036.6562H138.758V41.3557H140.633V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2036.6562H149.996V41.3557H153.746V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M157.508%2036.6562H155.633V41.3557H157.508V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M168.758%2036.6562H166.883V41.3557H168.758V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M180.004%2036.6562H176.254V41.3557H180.004V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M185.629%2036.6562H181.879V41.3557H185.629V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M189.367%2036.6562H187.492V41.3557H189.367V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M198.75%2036.6562H191.25V41.3557H198.75V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M211.875%2036.6562H202.5V41.3557H211.875V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2036.6562H213.75V41.3557H226.875V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2036.6562H228.746V41.3557H230.621V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2036.6562H236.25V41.3557H238.125V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2036.6562H240.008V41.3557H241.883V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2036.6562H245.621V41.3557H247.496V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2041.3564H22.5V46.0559H37.4999V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2041.3564H39.375V46.0559H41.2501V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2041.3564H43.1328V46.0559H45.0079V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2041.3564H46.8672V46.0559H48.7423V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1327%2041.3564H54.3828V46.0559H58.1327V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8712%2041.3564H59.9961V46.0559H61.8712V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3789%2041.3564H63.7539V46.0559H69.3789V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M80.6251%2041.3564H78.75V46.0559H80.6251V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4922%2041.3564H86.2422V46.0559H97.4922V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M105.008%2041.3564H99.3828V46.0559H105.008V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M108.75%2041.3564H106.875V46.0559H108.75V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2041.3564H110.633V46.0559H112.508V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M123.75%2041.3564H118.125V46.0559H123.75V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M127.504%2041.3564H125.629V46.0559H127.504V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M134.992%2041.3564H131.242V46.0559H134.992V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M138.754%2041.3564H136.879V46.0559H138.754V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2041.3564H149.996V46.0559H153.746V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M166.879%2041.3564H165.004V46.0559H166.879V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M176.242%2041.3564H170.617V46.0559H176.242V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M179.996%2041.3564H178.121V46.0559H179.996V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M189.379%2041.3564H181.879V46.0559H189.379V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M193.125%2041.3564H191.25V46.0559H193.125V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M200.633%2041.3564H195.008V46.0559H200.633V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M210.004%2041.3564H204.379V46.0559H210.004V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2041.3564H213.75V46.0559H226.875V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2041.3564H228.746V46.0559H230.621V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2041.3564H236.25V46.0559H238.125V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2041.3564H240.008V46.0559H241.883V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2041.3564H245.621V46.0559H247.496V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2046.0537H22.5V50.7531H37.4999V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2046.0537H39.375V50.7531H41.2501V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2046.0537H43.1328V50.7531H45.0079V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2046.0537H46.8672V50.7531H48.7423V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7577%2046.0537H54.3828V50.7531H63.7577V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4962%2046.0537H65.6211V50.7531H67.4962V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M76.879%2046.0537H69.3789V50.7531H76.879V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4999%2046.0537H78.75V50.7531H82.4999V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M93.7423%2046.0537H86.2422V50.7531H93.7423V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M97.5001%2046.0537H95.625V50.7531H97.5001V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M108.75%2046.0537H101.25V50.7531H108.75V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2046.0537H110.633V50.7531H112.508V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M120%2046.0537H118.125V50.7531H120V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M127.496%2046.0537H121.871V50.7531H127.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M135%2046.0537H129.375V50.7531H135V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M148.125%2046.0537H140.625V50.7531H148.125V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2046.0537H149.996V50.7531H153.746V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M168.742%2046.0537H159.367V50.7531H168.742V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M174.371%2046.0537H172.496V50.7531H174.371V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M179.996%2046.0537H178.121V50.7531H179.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M189.379%2046.0537H181.879V50.7531H189.379V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M193.125%2046.0537H191.25V50.7531H193.125V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M204.383%2046.0537H195.008V50.7531H204.383V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M209.996%2046.0537H206.246V50.7531H209.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2046.0537H213.75V50.7531H226.875V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2046.0537H228.746V50.7531H230.621V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2046.0537H236.25V50.7531H238.125V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2046.0537H240.008V50.7531H241.883V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2046.0537H245.621V50.7531H247.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2050.7539H22.5V55.4533H37.4999V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2050.7539H39.375V55.4533H41.2501V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2050.7539H43.1328V55.4533H45.0079V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2050.7539H46.8672V55.4533H48.7423V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M60.0078%2050.7539H54.3828V55.4533H60.0078V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7501%2050.7539H61.875V55.4533H63.7501V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M73.125%2050.7539H67.5V55.4533H73.125V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3671%2050.7539H74.9922V55.4533H84.3671V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1173%2050.7539H86.2422V55.4533H88.1173V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3749%2050.7539H95.625V55.4533H99.3749V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2050.7539H104.996V55.4533H108.746V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M114.375%2050.7539H112.5V55.4533H114.375V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2050.7539H118.125V55.4533H121.875V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M129.379%2050.7539H125.629V55.4533H129.379V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M140.629%2050.7539H136.879V55.4533H140.629V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M148.121%2050.7539H144.371V55.4533H148.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M151.871%2050.7539H149.996V55.4533H151.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M163.121%2050.7539H161.246V55.4533H163.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M172.5%2050.7539H168.75V55.4533H172.5V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M178.125%2050.7539H174.375V55.4533H178.125V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M187.504%2050.7539H181.879V55.4533H187.504V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M191.246%2050.7539H189.371V55.4533H191.246V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M200.633%2050.7539H195.008V55.4533H200.633V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M211.875%2050.7539H202.5V55.4533H211.875V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2050.7539H213.75V55.4533H226.875V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2050.7539H228.746V55.4533H230.621V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2050.7539H236.25V55.4533H238.125V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2050.7539H240.008V55.4533H241.883V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2050.7539H245.621V55.4533H247.496V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2055.4551H22.5V60.1545H37.4999V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2055.4551H39.375V60.1545H41.2501V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2055.4551H43.1328V60.1545H45.0079V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2055.4551H46.8672V60.1545H48.7423V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6328%2055.4551H54.3828V60.1545H65.6328V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3751%2055.4551H67.5V60.1545H69.3751V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M75.0001%2055.4551H73.125V60.1545H75.0001V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4961%2055.4551H76.8711V60.1545H82.4961V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1173%2055.4551H86.2422V60.1545H88.1173V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M97.5001%2055.4551H90V60.1545H97.5001V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M103.133%2055.4551H99.3828V60.1545H103.133V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M114.371%2055.4551H104.996V60.1545H114.371V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M120%2055.4551H118.125V60.1545H120V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2055.4551H121.871V60.1545H123.746V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M133.129%2055.4551H125.629V60.1545H133.129V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M142.5%2055.4551H140.625V60.1545H142.5V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M157.496%2055.4551H149.996V60.1545H157.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M164.996%2055.4551H161.246V60.1545H164.996V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M172.5%2055.4551H168.75V60.1545H172.5V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M176.25%2055.4551H174.375V60.1545H176.25V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M183.754%2055.4551H181.879V60.1545H183.754V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M187.5%2055.4551H185.625V60.1545H187.5V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M200.621%2055.4551H189.371V60.1545H200.621V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M208.125%2055.4551H202.5V60.1545H208.125V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2055.4551H213.75V60.1545H226.875V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2055.4551H228.746V60.1545H230.621V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2055.4551H236.25V60.1545H238.125V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2055.4551H240.008V60.1545H241.883V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2055.4551H245.621V60.1545H247.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2060.1523H22.5V64.8518H37.4999V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2060.1523H39.375V64.8518H41.2501V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2060.1523H43.1328V64.8518H45.0079V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2060.1523H46.8672V64.8518H48.7423V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6328%2060.1523H54.3828V64.8518H65.6328V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3751%2060.1523H67.5V64.8518H69.3751V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M76.8749%2060.1523H73.125V64.8518H76.8749V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M82.504%2060.1523H80.6289V64.8518H82.504V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1173%2060.1523H86.2422V64.8518H88.1173V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3711%2060.1523H93.7461V64.8518H99.3711V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M103.125%2060.1523H101.25V64.8518H103.125V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2060.1523H108.754V64.8518H112.504V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2060.1523H118.125V64.8518H121.875V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M131.258%2060.1523H127.508V64.8518H131.258V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M138.754%2060.1523H136.879V64.8518H138.754V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M148.125%2060.1523H140.625V64.8518H148.125V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2060.1523H149.996V64.8518H153.746V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M159.383%2060.1523H155.633V64.8518H159.383V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M163.121%2060.1523H161.246V64.8518H163.121V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M172.504%2060.1523H165.004V64.8518H172.504V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M191.254%2060.1523H181.879V64.8518H191.254V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M195.004%2060.1523H193.129V64.8518H195.004V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M204.367%2060.1523H198.742V64.8518H204.367V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M208.121%2060.1523H206.246V64.8518H208.121V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2060.1523H213.75V64.8518H226.875V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2060.1523H228.746V64.8518H230.621V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2060.1523H236.25V64.8518H238.125V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2060.1523H240.008V64.8518H241.883V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2060.1523H245.621V64.8518H247.496V60.1523Z'%20fill='%23272833'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_10772_56590'%3e%3crect%20width='225'%20height='42.2951'%20fill='white'%20transform='translate(22.5%2022.5576)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")}._id-mrz-barcode-back-icon_1nryz_79:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3crect%20x='22.5'%20y='124.065'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='107.147'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='140.983'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='76.1309'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='76.1309'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3cg%20clip-path='url(%23clip0_10772_56870)'%3e%3cpath%20d='M247.496%2022.5576H22.4961V64.8527H247.496V22.5576Z'%20fill='%23D6D6D6'/%3e%3cpath%20d='M37.496%2022.5576H22.4961V27.257H37.496V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2022.5576H39.3711V27.257H41.2462V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2022.5576H43.1289V27.257H45.004V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2022.5576H46.8633V27.257H48.7384V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7538%2022.5576H54.3789V27.257H63.7538V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4923%2022.5576H65.6172V27.257H67.4923V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M71.2501%2022.5576H69.375V27.257H71.2501V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M82.496%2022.5576H73.1211V27.257H82.496V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9882%2022.5576H86.2383V27.257H89.9882V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M93.7501%2022.5576H91.875V27.257H93.7501V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M99.371%2022.5576H95.6211V27.257H99.371V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M110.617%2022.5576H104.992V27.257H110.617V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2022.5576H118.121V27.257H121.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M133.121%2022.5576H129.371V27.257H133.121V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M136.871%2022.5576H134.996V27.257H136.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M140.629%2022.5576H138.754V27.257H140.629V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M151.867%2022.5576H149.992V27.257H151.867V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M159.375%2022.5576H153.75V27.257H159.375V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M172.504%2022.5576H166.879V27.257H172.504V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M176.246%2022.5576H174.371V27.257H176.246V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M191.25%2022.5576H181.875V27.257H191.25V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M195%2022.5576H193.125V27.257H195V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M198.746%2022.5576H196.871V27.257H198.746V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M209.992%2022.5576H200.617V27.257H209.992V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2022.5576H213.746V27.257H226.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2022.5576H228.742V27.257H230.617V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2022.5576H236.246V27.257H238.121V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2022.5576H240.004V27.257H241.879V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2022.5576H245.617V27.257H247.492V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2027.2578H22.4961V31.9572H37.496V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2027.2578H39.3711V31.9572H41.2462V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2027.2578H43.1289V31.9572H45.004V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2027.2578H46.8633V31.9572H48.7384V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M61.879%2027.2578H54.3789V31.9572H61.879V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6251%2027.2578H63.75V31.9572H65.6251V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3712%2027.2578H67.4961V31.9572H69.3712V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M78.7423%2027.2578H76.8672V31.9572H78.7423V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M91.8633%2027.2578H86.2383V31.9572H91.8633V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3751%2027.2578H97.5V31.9572H99.3751V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M104.996%2027.2578H101.246V31.9572H104.996V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2027.2578H110.629V31.9572H112.504V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2027.2578H118.121V31.9572H121.871V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M133.125%2027.2578H125.625V31.9572H133.125V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M136.871%2027.2578H134.996V31.9572H136.871V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M148.129%2027.2578H138.754V31.9572H148.129V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M155.617%2027.2578H149.992V31.9572H155.617V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M163.117%2027.2578H161.242V31.9572H163.117V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M174.371%2027.2578H168.746V31.9572H174.371V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M180%2027.2578H176.25V31.9572H180V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M189.375%2027.2578H181.875V31.9572H189.375V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M193.121%2027.2578H191.246V31.9572H193.121V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M196.879%2027.2578H195.004V31.9572H196.879V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M202.492%2027.2578H200.617V31.9572H202.492V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2027.2578H213.746V31.9572H226.871V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2027.2578H228.742V31.9572H230.617V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2027.2578H236.246V31.9572H238.121V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2027.2578H240.004V31.9572H241.879V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2027.2578H245.617V31.9572H247.492V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2031.9561H22.4961V36.6555H37.496V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2031.9561H39.3711V36.6555H41.2462V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2031.9561H43.1289V36.6555H45.004V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2031.9561H46.8633V36.6555H48.7384V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M56.254%2031.9561H54.3789V36.6555H56.254V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M59.9884%2031.9561H58.1133V36.6555H59.9884V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7462%2031.9561H61.8711V36.6555H63.7462V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M74.9962%2031.9561H67.4961V36.6555H74.9962V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9882%2031.9561H86.2383V36.6555H89.9882V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M103.125%2031.9561H91.875V36.6555H103.125V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M108.742%2031.9561H104.992V36.6555H108.742V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2031.9561H110.629V36.6555H112.504V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M119.996%2031.9561H118.121V36.6555H119.996V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M123.742%2031.9561H121.867V36.6555H123.742V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M136.867%2031.9561H133.117V36.6555H136.867V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M148.129%2031.9561H138.754V36.6555H148.129V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M151.867%2031.9561H149.992V36.6555H151.867V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M161.254%2031.9561H155.629V36.6555H161.254V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M172.488%2031.9561H170.613V36.6555H172.488V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M178.121%2031.9561H174.371V36.6555H178.121V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M183.75%2031.9561H181.875V36.6555H183.75V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M187.496%2031.9561H185.621V36.6555H187.496V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M191.242%2031.9561H189.367V36.6555H191.242V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M206.238%2031.9561H198.738V36.6555H206.238V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2031.9561H213.746V36.6555H226.871V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2031.9561H228.742V36.6555H230.617V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2031.9561H236.246V36.6555H238.121V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2031.9561H240.004V36.6555H241.879V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2031.9561H245.617V36.6555H247.492V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2036.6562H22.4961V41.3557H37.496V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2036.6562H39.3711V41.3557H41.2462V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2036.6562H43.1289V41.3557H45.004V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2036.6562H46.8633V41.3557H48.7384V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1288%2036.6562H54.3789V41.3557H58.1288V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8673%2036.6562H59.9922V41.3557H61.8673V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M71.2501%2036.6562H63.75V41.3557H71.2501V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3632%2036.6562H74.9883V41.3557H84.3632V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M95.6132%2036.6562H86.2383V41.3557H95.6132V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3751%2036.6562H97.5V41.3557H99.3751V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M103.121%2036.6562H101.246V41.3557H103.121V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M116.246%2036.6562H106.871V41.3557H116.246V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2036.6562H118.121V41.3557H123.746V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M131.25%2036.6562H125.625V41.3557H131.25V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M134.992%2036.6562H133.117V41.3557H134.992V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M140.629%2036.6562H138.754V41.3557H140.629V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2036.6562H149.992V41.3557H153.742V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M157.504%2036.6562H155.629V41.3557H157.504V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M168.754%2036.6562H166.879V41.3557H168.754V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M180%2036.6562H176.25V41.3557H180V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M185.625%2036.6562H181.875V41.3557H185.625V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M189.363%2036.6562H187.488V41.3557H189.363V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M198.746%2036.6562H191.246V41.3557H198.746V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M211.871%2036.6562H202.496V41.3557H211.871V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2036.6562H213.746V41.3557H226.871V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2036.6562H228.742V41.3557H230.617V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2036.6562H236.246V41.3557H238.121V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2036.6562H240.004V41.3557H241.879V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2036.6562H245.617V41.3557H247.492V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2041.3555H22.4961V46.0549H37.496V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2041.3555H39.3711V46.0549H41.2462V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2041.3555H43.1289V46.0549H45.004V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2041.3555H46.8633V46.0549H48.7384V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1288%2041.3555H54.3789V46.0549H58.1288V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8673%2041.3555H59.9922V46.0549H61.8673V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M69.375%2041.3555H63.75V46.0549H69.375V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M80.6212%2041.3555H78.7461V46.0549H80.6212V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4883%2041.3555H86.2383V46.0549H97.4883V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M105.004%2041.3555H99.3789V46.0549H105.004V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2041.3555H106.871V46.0549H108.746V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2041.3555H110.629V46.0549H112.504V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2041.3555H118.121V46.0549H123.746V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M127.5%2041.3555H125.625V46.0549H127.5V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M134.988%2041.3555H131.238V46.0549H134.988V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M138.75%2041.3555H136.875V46.0549H138.75V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2041.3555H149.992V46.0549H153.742V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M166.875%2041.3555H165V46.0549H166.875V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M176.238%2041.3555H170.613V46.0549H176.238V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M179.992%2041.3555H178.117V46.0549H179.992V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M189.375%2041.3555H181.875V46.0549H189.375V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M193.121%2041.3555H191.246V46.0549H193.121V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M200.629%2041.3555H195.004V46.0549H200.629V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M210%2041.3555H204.375V46.0549H210V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2041.3555H213.746V46.0549H226.871V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2041.3555H228.742V46.0549H230.617V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2041.3555H236.246V46.0549H238.121V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2041.3555H240.004V46.0549H241.879V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2041.3555H245.617V46.0549H247.492V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2046.0537H22.4961V50.7531H37.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2046.0537H39.3711V50.7531H41.2462V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2046.0537H43.1289V50.7531H45.004V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2046.0537H46.8633V50.7531H48.7384V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7538%2046.0537H54.3789V50.7531H63.7538V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4923%2046.0537H65.6172V50.7531H67.4923V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M76.8751%2046.0537H69.375V50.7531H76.8751V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M82.496%2046.0537H78.7461V50.7531H82.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M93.7384%2046.0537H86.2383V50.7531H93.7384V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4962%2046.0537H95.6211V50.7531H97.4962V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2046.0537H101.246V50.7531H108.746V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2046.0537H110.629V50.7531H112.504V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M119.996%2046.0537H118.121V50.7531H119.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M127.492%2046.0537H121.867V50.7531H127.492V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M134.996%2046.0537H129.371V50.7531H134.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M148.121%2046.0537H140.621V50.7531H148.121V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2046.0537H149.992V50.7531H153.742V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M168.738%2046.0537H159.363V50.7531H168.738V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M174.367%2046.0537H172.492V50.7531H174.367V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M179.992%2046.0537H178.117V50.7531H179.992V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M189.375%2046.0537H181.875V50.7531H189.375V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M193.121%2046.0537H191.246V50.7531H193.121V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M204.379%2046.0537H195.004V50.7531H204.379V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M209.992%2046.0537H206.242V50.7531H209.992V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2046.0537H213.746V50.7531H226.871V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2046.0537H228.742V50.7531H230.617V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2046.0537H236.246V50.7531H238.121V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2046.0537H240.004V50.7531H241.879V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2046.0537H245.617V50.7531H247.492V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2050.7539H22.4961V55.4533H37.496V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2050.7539H39.3711V55.4533H41.2462V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2050.7539H43.1289V55.4533H45.004V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2050.7539H46.8633V55.4533H48.7384V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M60.0039%2050.7539H54.3789V55.4533H60.0039V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7462%2050.7539H61.8711V55.4533H63.7462V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M73.1211%2050.7539H67.4961V55.4533H73.1211V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3632%2050.7539H74.9883V55.4533H84.3632V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1134%2050.7539H86.2383V55.4533H88.1134V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M99.371%2050.7539H95.6211V55.4533H99.371V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M108.742%2050.7539H104.992V55.4533H108.742V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M114.371%2050.7539H112.496V55.4533H114.371V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2050.7539H118.121V55.4533H121.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M129.375%2050.7539H125.625V55.4533H129.375V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M140.625%2050.7539H136.875V55.4533H140.625V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M148.117%2050.7539H144.367V55.4533H148.117V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M151.867%2050.7539H149.992V55.4533H151.867V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M163.117%2050.7539H161.242V55.4533H163.117V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M172.496%2050.7539H168.746V55.4533H172.496V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M178.121%2050.7539H174.371V55.4533H178.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M187.5%2050.7539H181.875V55.4533H187.5V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M191.242%2050.7539H189.367V55.4533H191.242V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M200.629%2050.7539H195.004V55.4533H200.629V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M211.871%2050.7539H202.496V55.4533H211.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2050.7539H213.746V55.4533H226.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2050.7539H228.742V55.4533H230.617V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2050.7539H236.246V55.4533H238.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2050.7539H240.004V55.4533H241.879V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2050.7539H245.617V55.4533H247.492V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2055.4551H22.4961V60.1545H37.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2055.4551H39.3711V60.1545H41.2462V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2055.4551H43.1289V60.1545H45.004V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2055.4551H46.8633V60.1545H48.7384V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6289%2055.4551H54.3789V60.1545H65.6289V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3712%2055.4551H67.4961V60.1545H69.3712V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M74.9962%2055.4551H73.1211V60.1545H74.9962V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4922%2055.4551H76.8672V60.1545H82.4922V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1134%2055.4551H86.2383V60.1545H88.1134V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4962%2055.4551H89.9961V60.1545H97.4962V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M103.129%2055.4551H99.3789V60.1545H103.129V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M114.367%2055.4551H104.992V60.1545H114.367V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M119.996%2055.4551H118.121V60.1545H119.996V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M123.742%2055.4551H121.867V60.1545H123.742V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M133.125%2055.4551H125.625V60.1545H133.125V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M142.496%2055.4551H140.621V60.1545H142.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M157.492%2055.4551H149.992V60.1545H157.492V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M164.992%2055.4551H161.242V60.1545H164.992V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M172.496%2055.4551H168.746V60.1545H172.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M176.246%2055.4551H174.371V60.1545H176.246V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M183.75%2055.4551H181.875V60.1545H183.75V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M187.496%2055.4551H185.621V60.1545H187.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M200.617%2055.4551H189.367V60.1545H200.617V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M208.121%2055.4551H202.496V60.1545H208.121V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2055.4551H213.746V60.1545H226.871V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2055.4551H228.742V60.1545H230.617V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2055.4551H236.246V60.1545H238.121V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2055.4551H240.004V60.1545H241.879V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2055.4551H245.617V60.1545H247.492V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2060.1514H22.4961V64.8508H37.496V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2060.1514H39.3711V64.8508H41.2462V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2060.1514H43.1289V64.8508H45.004V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2060.1514H46.8633V64.8508H48.7384V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6289%2060.1514H54.3789V64.8508H65.6289V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3712%2060.1514H67.4961V64.8508H69.3712V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M76.871%2060.1514H73.1211V64.8508H76.871V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M82.5001%2060.1514H80.625V64.8508H82.5001V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1134%2060.1514H86.2383V64.8508H88.1134V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3672%2060.1514H93.7422V64.8508H99.3672V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M103.121%2060.1514H101.246V64.8508H103.121V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M112.5%2060.1514H108.75V64.8508H112.5V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2060.1514H118.121V64.8508H121.871V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M131.254%2060.1514H127.504V64.8508H131.254V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M138.75%2060.1514H136.875V64.8508H138.75V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M148.121%2060.1514H140.621V64.8508H148.121V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2060.1514H149.992V64.8508H153.742V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M159.379%2060.1514H155.629V64.8508H159.379V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M163.117%2060.1514H161.242V64.8508H163.117V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M172.5%2060.1514H165V64.8508H172.5V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M191.25%2060.1514H181.875V64.8508H191.25V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M195%2060.1514H193.125V64.8508H195V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M204.363%2060.1514H198.738V64.8508H204.363V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M208.117%2060.1514H206.242V64.8508H208.117V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2060.1514H213.746V64.8508H226.871V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2060.1514H228.742V64.8508H230.617V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2060.1514H236.246V64.8508H238.121V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2060.1514H240.004V64.8508H241.879V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2060.1514H245.617V64.8508H247.492V60.1514Z'%20fill='%23272833'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_10772_56870'%3e%3crect%20width='225'%20height='42.2951'%20fill='white'%20transform='translate(22.5%2022.5576)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")}._bank-card-front-icon_1nryz_83:before{background-image:url("data:image/svg+xml,%3csvg%20width='280'%20height='172'%20viewBox='0%200%20280%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.45763'%20y='-1.45763'%20width='277.085'%20height='169.085'%20rx='13.1186'%20transform='matrix(1%200%200%20-1%200%20169.085)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.91525'/%3e%3crect%20x='23.332'%20y='23.3223'%20width='107.917'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='93.332'%20y='142.848'%20width='99.1667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='145.832'%20y='122.44'%20width='37.9167'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='23.332'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='84.582'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='145.832'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='207.082'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='23.332'%20y='142.848'%20width='61.25'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='23.3359'%20y='52.4746'%20width='40.8333'%20height='37.8983'%20rx='5.83051'%20fill='%23333543'/%3e%3crect%20x='23.3359'%20y='58.3047'%20width='40.8333'%20height='1.45763'%20fill='white'/%3e%3crect%20x='23.3359'%20y='67.0508'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='49.5859'%20y='67.0508'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='23.3359'%20y='74.3389'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='49.5859'%20y='74.3389'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='44.4805'%20y='52.4746'%20width='5.83051'%20height='1.45833'%20transform='rotate(90%2044.4805%2052.4746)'%20fill='white'/%3e%3crect%20x='37.918'%20y='58.3047'%20width='26.2373'%20height='1.45833'%20transform='rotate(90%2037.918%2058.3047)'%20fill='white'/%3e%3crect%20x='51.043'%20y='67.0508'%20width='17.4915'%20height='1.45833'%20transform='rotate(90%2051.043%2067.0508)'%20fill='white'/%3e%3crect%20x='44.4805'%20y='84.542'%20width='5.83051'%20height='1.45833'%20transform='rotate(90%2044.4805%2084.542)'%20fill='white'/%3e%3crect%20x='23.3359'%20y='83.085'%20width='40.8333'%20height='1.45763'%20fill='white'/%3e%3ccircle%20cx='224.476'%20cy='137.017'%20r='17.4915'%20fill='%23333543'/%3e%3ccircle%20cx='247.796'%20cy='137.017'%20r='17.4915'%20fill='%23333543'/%3e%3c/svg%3e")}._bank-card-back-icon_1nryz_87:before{background-image:url("data:image/svg+xml,%3csvg%20width='280'%20height='172'%20viewBox='0%200%20280%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.45833'%20y='-1.45833'%20width='277.083'%20height='169.083'%20rx='13.125'%20transform='matrix(1%200%200%20-1%200%20169.083)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.91667'/%3e%3crect%20y='14.5762'%20width='280'%20height='40.8136'%20fill='%23333543'/%3e%3crect%20x='23.332'%20y='69.9658'%20width='37.9167'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='224.582'%20y='119.525'%20width='23.3333'%20height='34.9831'%20fill='%23333543'/%3e%3ccircle%20cx='224.582'%20cy='137.083'%20r='17.5'%20fill='%23333543'/%3e%3ccircle%20cx='247.918'%20cy='137.083'%20r='17.5'%20fill='%23333543'/%3e%3c/svg%3e")}._document-front-icon_1nryz_91:before{background-image:url("data:image/svg+xml,%3csvg%20width='920'%20height='640'%20viewBox='0%200%20920%20640'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M520%20200H800V240H520V200Z'%20fill='white'/%3e%3cpath%20d='M800%20300H520V340H800V300Z'%20fill='white'/%3e%3cpath%20d='M520%20400H800V440H520V400Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M274.943%20123.429L274.933%20123.432C266.551%20126.295%20258.863%20130.466%20251.927%20135.343C243.39%20140.807%20235.349%20147.484%20228.244%20155.117C216.999%20166.723%20206.985%20181.73%20202.638%20200.462C201.732%20203.954%20201.031%20207.508%20200.554%20211.114C198.857%20223.937%20199.991%20237.409%20204.799%20251.055C201.906%20250.776%20199.719%20251.697%20198.089%20253.419C191.062%20260.842%20194.356%20283.152%20195.842%20288.454C202.652%20312.775%20208.999%20319.597%20213.796%20319.988C216.486%20337.575%20230.545%20358.063%20243.587%20375.139C243.587%20405.888%20203.816%20413.339%20170.442%20419.591C162.723%20421.037%20155.346%20422.419%20148.883%20424.01C114.629%20432.436%20110.268%20472.281%20110.168%20504.349C110.141%20513.052%20117.321%20520%20126.023%20520H473.977C482.679%20520%20489.859%20513.052%20489.839%20504.349C489.769%20472.142%20485.483%20432.464%20451.117%20424.01C445.211%20422.556%20438.486%20421.191%20431.39%20419.752L431.388%20419.751C396.76%20412.725%20353.321%20403.912%20353.321%20374.203C353.664%20373.739%20354.01%20373.272%20354.358%20372.804C357.463%20368.617%20360.701%20364.25%20363.825%20359.791C372.128%20347.938%20379.624%20335.429%20381.652%20323.912C382.709%20324.634%20383.91%20325.123%20385.24%20325.123C385.796%20325.123%20386.374%20325.037%20386.972%20324.849C391.593%20323.394%20397.418%20315.772%20403.633%20293.568C410.9%20267.609%20406.477%20258.905%20400.199%20256.714C420.616%20157.928%20373.971%20154.617%20373.971%20154.617C373.971%20154.617%20366.934%20140.939%20348.397%20130.606C337.66%20124.183%20323.287%20119%20304.851%20119C301.953%20119%20298.964%20119.122%20295.865%20119.395C288.479%20119.744%20281.5%20121.188%20274.943%20123.429ZM321.183%20350.388C316.077%20357.278%20313.321%20365.627%20313.321%20374.203C313.321%20396.791%20323.959%20414.183%20337.296%20425.916C349.473%20436.63%20364.134%20443.009%20376.199%20447.154C388.689%20451.445%20401.819%20454.454%20412.943%20456.796C417.197%20457.692%20421.006%20458.464%20424.494%20459.171L424.495%20459.171C431.031%20460.495%20436.443%20461.592%20441.555%20462.85L441.562%20462.852C442.371%20463.051%20442.688%20463.234%20442.718%20463.251L442.719%20463.252L442.723%20463.254C442.746%20463.267%20442.79%20463.292%20442.907%20463.412C443.207%20463.723%20444.371%20465.103%20445.684%20468.766C446.817%20471.928%20447.691%20475.687%20448.338%20480H151.711C152.363%20475.717%20153.239%20471.971%20154.372%20468.81C155.699%20465.109%20156.878%20463.698%20157.192%20463.372L157.194%20463.369C157.207%20463.34%20157.301%20463.132%20158.438%20462.852L158.445%20462.85C163.729%20461.549%20169.527%20460.462%20176.817%20459.096L176.821%20459.095C179.572%20458.579%20182.535%20458.024%20185.763%20457.402C196.469%20455.34%20209.407%20452.649%20221.731%20448.562C233.686%20444.597%20248.469%20438.255%20260.709%20426.995C274.269%20414.522%20283.587%20396.915%20283.587%20375.139C283.587%20366.365%20280.702%20357.834%20275.376%20350.86C269.197%20342.77%20263.625%20334.956%20259.415%20327.693C254.949%20319.99%20253.579%20315.526%20253.336%20313.941C251.698%20303.233%20245.887%20294.002%20237.651%20287.879C236.767%20285.573%20235.697%20282.397%20234.493%20278.142C234.495%20278.139%20234.486%20278.086%20234.467%20277.984L234.452%20277.901C235.091%20277.195%20235.707%20276.464%20236.298%20275.708C244.717%20264.952%20247.065%20250.644%20242.526%20237.762C239.17%20228.237%20239.103%20219.19%20241.356%20210.506C241.443%20210.173%20241.525%20209.839%20241.603%20209.503C243.904%20199.588%20249.376%20190.79%20256.971%20182.951C257.156%20182.76%20257.34%20182.567%20257.521%20182.372C262.328%20177.208%20267.774%20172.691%20273.489%20169.034C273.978%20168.721%20274.46%20168.397%20274.936%20168.063C279.286%20165.004%20283.597%20162.748%20287.809%20161.303L287.883%20161.278C291.162%20160.157%20294.424%20159.508%20297.75%20159.351C298.292%20159.325%20298.833%20159.288%20299.374%20159.241C301.267%20159.074%20303.083%20159%20304.851%20159C315.374%20159%20322.72%20161.857%20327.864%20164.933C328.213%20165.142%20328.565%20165.345%20328.92%20165.543C333.473%20168.081%20336.341%20170.874%20337.886%20172.659C338.515%20173.386%20338.906%20173.925%20339.077%20174.173C344.22%20183.353%20352.722%20190.05%20362.636%20192.979C364.507%20197.532%20368.476%20212.578%20361.027%20248.618C358.865%20259.075%20361.005%20269.523%20366.336%20278.005C366.023%20279.378%20365.623%20280.965%20365.114%20282.784L365.113%20282.786C364.533%20284.861%20363.983%20286.685%20363.469%20288.283C352.34%20293.961%20344.445%20304.559%20342.258%20316.974C342.258%20316.974%20342.208%20317.246%20342.023%20317.818C341.833%20318.406%20341.53%20319.218%20341.065%20320.269C340.111%20322.423%20338.685%20325.105%20336.678%20328.368C332.654%20334.911%20327.684%20341.617%20321.853%20349.483L321.183%20350.388Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M80%200C35.8172%200%200%2035.8172%200%2080V560C0%20604.183%2035.8172%20640%2080%20640H840C884.183%20640%20920%20604.183%20920%20560V80C920%2035.8172%20884.183%200%20840%200H80ZM840%2040H80C57.9086%2040%2040%2057.9086%2040%2080V560C40%20582.091%2057.9086%20600%2080%20600H840C862.091%20600%20880%20582.091%20880%20560V80C880%2057.9086%20862.091%2040%20840%2040Z'%20fill='white'/%3e%3c/svg%3e")}._document-back-icon_1nryz_95:before{background-image:url("data:image/svg+xml,%3csvg%20width='920'%20height='640'%20viewBox='0%200%20920%20640'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M460%20300H140V340H460V300Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M100%200C44.7715%200%200%2044.7715%200%20100V540C0%20595.228%2044.7715%20640%20100%20640H820C875.228%20640%20920%20595.228%20920%20540V100C920%2044.7715%20875.229%200%20820%200H100ZM820%2040H100C66.8629%2040%2040%2066.8629%2040%20100V140H880V100C880%2066.8629%20853.137%2040%20820%2040ZM40%20540V240H880V540C880%20573.137%20853.137%20600%20820%20600H100C66.8629%20600%2040%20573.137%2040%20540Z'%20fill='white'/%3e%3c/svg%3e")}@keyframes _slide_1nryz_22{0%{background-position:center 115%}to{background-position:center -15%}}@keyframes _flip-front_1nryz_1{0%{transform:rotateY(0)}to{transform:rotateY(-180deg)}}@keyframes _flip-back_1nryz_1{0%{transform:rotateY(180deg)}to{transform:rotateY(0)}}`, OR = `._tilt_5ot88_1{width:80%;height:100%;position:absolute;align-self:center;perspective:1000px}._tilt_5ot88_1:before{content:"";width:100%;height:100%;display:inline-flex;background-repeat:no-repeat;background-position:center;background-size:100% auto}._vertical_5ot88_19:before{animation:_vertical_5ot88_19 2s .4s infinite linear}._horizontal_5ot88_23:before{animation:_horizontal_5ot88_23 2s .4s infinite linear}._left-bottom-right-top_5ot88_27:before{animation:_left-bottom-right-top_5ot88_27 2s .4s infinite linear}._right-bottom-left-top_5ot88_31:before{animation:_right-bottom-left-top_5ot88_31 2s .4s infinite linear}._id-front-icon_5ot88_35:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M101.246%2028.1982H22.4961V126.887C22.4962%20124.482%2027.1732%20123.323%2032.6526%20121.964C39.93%20120.16%2048.6229%20118.005%2049.6542%20112.116C44.6713%20108.96%2042.7698%20104.198%2040.8243%2099.3255C40.4465%2098.3791%2040.0669%2097.4286%2039.6629%2096.485C34.7738%20101.236%2032.5935%2079.4764%2036.9774%2079.4764C28.6435%2056.9793%2051.4615%2038.5191%2072.545%2051.2088C84.91%2048.5382%2091.7424%2063.3145%2084.3766%2079.4768C87.4153%2078.0182%2087.9964%2085.7946%2087.4153%2090.6287C87.4153%2091.8706%2086.1245%20100.564%2082.8626%2097.1966C82.4668%2098.1115%2082.0949%2099.0331%2081.7247%2099.9507L81.7241%2099.9523L81.7239%2099.9527C79.768%20104.801%2077.8573%20109.537%2072.6874%20112.594C74.1725%20118.123%2083.0554%20120.21%2090.5254%20121.964C96.3092%20123.323%20101.246%20124.482%20101.246%20126.887V28.1982Z'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='104.327'%20width='59.0625'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='182.812'%20y='104.327'%20width='64.6875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='28.1963'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='53.5742'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='78.9512'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='129.704'%20width='135'%20height='11.2787'%20fill='%23333543'/%3e%3c/svg%3e")}._passport-single-icon_5ot88_39:before{background-image:url("data:image/svg+xml,%3csvg%20width='309'%20height='219'%20viewBox='0%200%20309%20219'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.40455%20196.527C1.40455%20200.484%201.40564%20203.366%201.59124%20205.638C1.7755%20207.893%202.13459%20209.422%202.78232%20210.693C3.99425%20213.072%205.92806%20215.006%208.3066%20216.218C9.57784%20216.865%2011.1068%20217.225%2013.3621%20217.409C15.6337%20217.594%2018.5165%20217.595%2022.4727%20217.595H286.527C290.484%20217.595%20293.366%20217.594%20295.638%20217.409C297.893%20217.225%20299.422%20216.865%20300.693%20216.218C303.072%20215.006%20305.006%20213.072%20306.218%20210.693C306.865%20209.422%20307.224%20207.893%20307.409%20205.638C307.594%20203.366%20307.595%20200.484%20307.595%20196.527V1.40454H1.40455V196.527Z'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.80909'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M95.509%2033.6924H22.4727V129.154H22.4727C22.4729%20126.828%2026.8105%20125.706%2031.8923%20124.392L31.8924%20124.392C38.6418%20122.647%2046.7039%20120.562%2047.6604%20114.866C43.039%20111.813%2041.2755%20107.207%2039.4712%20102.494L39.4711%20102.494C39.1207%20101.578%2038.7687%20100.659%2038.394%2099.7463C33.8596%20104.342%2031.8376%2083.2938%2035.9034%2083.2938C28.1741%2061.5324%2049.3366%2043.6758%2068.8904%2055.9505C80.3582%2053.3672%2086.695%2067.6604%2079.8636%2083.2943C82.6818%2081.8833%2083.2207%2089.4054%2082.6818%2094.0815C82.6818%2095.2828%2081.4847%20103.692%2078.4594%20100.435C78.0921%20101.32%2077.747%20102.212%2077.4035%20103.1L77.4034%20103.1L77.4033%20103.101C75.5893%20107.79%2073.8173%20112.371%2069.0225%20115.329C70.3998%20120.677%2078.6382%20122.695%2085.5662%20124.392C90.9184%20125.703%2095.4886%20126.823%2095.509%20129.138V33.6924Z'%20fill='%23333543'/%3e%3crect%20x='22.4727'%20y='160.038'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='224.727'%20y='33.6924'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='33.6924'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='53.3457'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='73'%20width='103.936'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='92.6543'%20width='78.6545'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='112.308'%20width='154.5'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='131.962'%20width='50.5636'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='22.4727'%20y='185.308'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3c/svg%3e")}._passport-both-pages-icon_5ot88_43:before{background-image:url("data:image/svg+xml,%3csvg%20width='309'%20height='438'%20viewBox='0%200%20309%20438'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M1.40455%2022.4727C1.40455%2018.5165%201.40564%2015.6337%201.59124%2013.3621C1.7755%2011.1068%202.13459%209.57784%202.78232%208.3066C3.99425%205.92806%205.92806%203.99425%208.3066%202.78232C9.57784%202.13459%2011.1068%201.7755%2013.3621%201.59124C15.6337%201.40564%2018.5165%201.40455%2022.4727%201.40455H286.527C290.484%201.40455%20293.366%201.40564%20295.638%201.59124C297.893%201.7755%20299.422%202.13459%20300.693%202.78232C303.072%203.99425%20305.006%205.92806%20306.218%208.3066C306.865%209.57784%20307.224%2011.1068%20307.409%2013.3621C307.594%2015.6337%20307.595%2018.5165%20307.595%2022.4727V217.595H1.40455V22.4727Z'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.80909'/%3e%3cpath%20d='M1.40455%20415.527C1.40455%20419.484%201.40564%20422.366%201.59124%20424.638C1.7755%20426.893%202.13459%20428.422%202.78232%20429.693C3.99425%20432.072%205.92806%20434.006%208.3066%20435.218C9.57784%20435.865%2011.1068%20436.225%2013.3621%20436.409C15.6337%20436.594%2018.5165%20436.595%2022.4727%20436.595H286.527C290.484%20436.595%20293.366%20436.594%20295.638%20436.409C297.893%20436.225%20299.422%20435.865%20300.693%20435.218C303.072%20434.006%20305.006%20432.072%20306.218%20429.693C306.865%20428.422%20307.224%20426.893%20307.409%20424.638C307.594%20422.366%20307.595%20419.484%20307.595%20415.527V220.405H1.40455V415.527Z'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.80909'/%3e%3crect%20x='22.4727'%20y='379.038'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='224.727'%20y='252.692'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='252.692'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='272.346'%20width='61.8'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='292'%20width='103.936'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='311.654'%20width='78.6545'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='331.308'%20width='154.5'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='112.363'%20y='350.962'%20width='50.5636'%20height='11.2308'%20fill='%23333543'/%3e%3crect%20x='22.4727'%20y='404.308'%20width='264.055'%20height='11.2308'%20fill='%23333543'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M95.509%20252.692H22.4727V348.154H95.509V348.154H22.4727C22.4727%20345.828%2026.8104%20344.706%2031.8923%20343.392L31.8924%20343.392C38.6418%20341.647%2046.7039%20339.562%2047.6604%20333.866C43.039%20330.813%2041.2755%20326.206%2039.4712%20321.494L39.4711%20321.493C39.1207%20320.578%2038.7687%20319.659%2038.394%20318.746C33.8596%20323.342%2031.8376%20302.294%2035.9034%20302.294C28.1741%20280.532%2049.3366%20262.676%2068.8904%20274.95C80.3582%20272.367%2086.695%20286.66%2079.8636%20302.294C82.6818%20300.883%2083.2207%20308.405%2082.6818%20313.081C82.6818%20314.282%2081.4847%20322.692%2078.4594%20319.434C78.0921%20320.32%2077.747%20321.212%2077.4035%20322.1L77.4034%20322.1L77.4033%20322.1C75.5893%20326.79%2073.8173%20331.371%2069.0225%20334.328C70.3998%20339.677%2078.6382%20341.695%2085.5662%20343.392C90.9184%20344.703%2095.4886%20345.823%2095.509%20348.138V252.692Z'%20fill='%23333543'/%3e%3c/svg%3e")}._id-mrz-front-icon_5ot88_47:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3crect%20x='112.5'%20y='25.377'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='50.7539'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='112.5'%20y='76.1309'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='138.164'%20width='225'%20height='11.2787'%20fill='%23333543'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M101.25%2025.377H22.5V124.065C22.5003%20121.661%2027.1772%20120.502%2032.6565%20119.143C39.9339%20117.339%2048.6268%20115.184%2049.6581%20109.295C44.6752%20106.139%2042.7737%20101.377%2040.8282%2096.5044C40.4504%2095.558%2040.0708%2094.6075%2039.6668%2093.6639C34.7777%2098.4148%2032.5974%2076.6553%2036.9813%2076.6553C28.6474%2054.1582%2051.4654%2035.698%2072.5489%2048.3877C84.9139%2045.717%2091.7464%2060.4934%2084.3805%2076.6557C87.4192%2075.1971%2088.0003%2082.9735%2087.4192%2087.8076C87.4192%2089.0495%2086.1284%2097.7429%2082.8665%2094.3755C82.4704%2095.2911%2082.0983%2096.2133%2081.7279%2097.1316C79.7719%20101.98%2077.8612%20106.715%2072.6914%20109.773C74.1764%20115.302%2083.0593%20117.388%2090.5293%20119.143C96.3129%20120.502%20101.25%20121.661%20101.25%20124.065V25.377Z'%20fill='%23333543'/%3e%3c/svg%3e")}._id-back-icon_5ot88_51:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3crect%20x='22.5'%20y='22.5576'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='171.562'%20y='22.5576'%20width='75.9375'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='154.688'%20y='138.164'%20width='92.8125'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='47.9346'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='47.9346'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='73.3115'%20width='73.125'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='112.787'%20width='50.625'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='138.164'%20width='87.1875'%20height='11.2787'%20fill='%23333543'/%3e%3c/svg%3e")}._id-mrz-back-icon_5ot88_55:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40625'%20y='-1.40625'%20width='267.188'%20height='169.188'%20rx='12.6562'%20transform='matrix(1%200%200%20-1%200%20169.188)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.8125'/%3e%3crect%20x='22.5'%20y='124.065'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='107.147'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='25.377'%20width='104.062'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='50.7539'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='50.7539'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='140.983'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3c/svg%3e")}._id-barcode-back-icon_5ot88_59:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40625'%20y='-1.40625'%20width='267.188'%20height='169.188'%20rx='12.6562'%20transform='matrix(1%200%200%20-1%200%20169.188)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.8125'/%3e%3crect%20x='22.5'%20y='22.5576'%20width='225'%20height='33.8361'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='112.787'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='112.787'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='138.164'%20width='87.1875'%20height='11.2787'%20fill='%23333543'/%3e%3cg%20clip-path='url(%23clip0_10772_56590)'%3e%3cpath%20d='M247.5%2022.5576H22.5V64.8527H247.5V22.5576Z'%20fill='%23D6D6D6'/%3e%3cpath%20d='M37.4999%2022.5576H22.5V27.257H37.4999V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2022.5576H39.375V27.257H41.2501V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2022.5576H43.1328V27.257H45.0079V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2022.5576H46.8672V27.257H48.7423V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7577%2022.5576H54.3828V27.257H63.7577V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4962%2022.5576H65.6211V27.257H67.4962V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M71.254%2022.5576H69.3789V27.257H71.254V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4999%2022.5576H73.125V27.257H82.4999V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9921%2022.5576H86.2422V27.257H89.9921V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M93.754%2022.5576H91.8789V27.257H93.754V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3749%2022.5576H95.625V27.257H99.3749V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M110.621%2022.5576H104.996V27.257H110.621V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2022.5576H118.125V27.257H121.875V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M133.125%2022.5576H129.375V27.257H133.125V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M136.875%2022.5576H135V27.257H136.875V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M140.633%2022.5576H138.758V27.257H140.633V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M151.871%2022.5576H149.996V27.257H151.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M159.379%2022.5576H153.754V27.257H159.379V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M172.508%2022.5576H166.883V27.257H172.508V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M176.25%2022.5576H174.375V27.257H176.25V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M191.254%2022.5576H181.879V27.257H191.254V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M195.004%2022.5576H193.129V27.257H195.004V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M198.75%2022.5576H196.875V27.257H198.75V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M209.996%2022.5576H200.621V27.257H209.996V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2022.5576H213.75V27.257H226.875V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2022.5576H228.746V27.257H230.621V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2022.5576H236.25V27.257H238.125V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2022.5576H240.008V27.257H241.883V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2022.5576H245.621V27.257H247.496V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2027.2578H22.5V31.9572H37.4999V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2027.2578H39.375V31.9572H41.2501V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2027.2578H43.1328V31.9572H45.0079V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2027.2578H46.8672V31.9572H48.7423V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8829%2027.2578H54.3828V31.9572H61.8829V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M65.629%2027.2578H63.7539V31.9572H65.629V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3751%2027.2578H67.5V31.9572H69.3751V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M78.7462%2027.2578H76.8711V31.9572H78.7462V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M91.8672%2027.2578H86.2422V31.9572H91.8672V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M99.379%2027.2578H97.5039V31.9572H99.379V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M105%2027.2578H101.25V31.9572H105V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2027.2578H110.633V31.9572H112.508V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2027.2578H118.125V31.9572H121.875V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M133.129%2027.2578H125.629V31.9572H133.129V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M136.875%2027.2578H135V31.9572H136.875V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M148.133%2027.2578H138.758V31.9572H148.133V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M155.621%2027.2578H149.996V31.9572H155.621V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M163.121%2027.2578H161.246V31.9572H163.121V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M174.375%2027.2578H168.75V31.9572H174.375V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M180.004%2027.2578H176.254V31.9572H180.004V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M189.379%2027.2578H181.879V31.9572H189.379V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M193.125%2027.2578H191.25V31.9572H193.125V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M196.883%2027.2578H195.008V31.9572H196.883V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M202.496%2027.2578H200.621V31.9572H202.496V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2027.2578H213.75V31.9572H226.875V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2027.2578H228.746V31.9572H230.621V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2027.2578H236.25V31.9572H238.125V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2027.2578H240.008V31.9572H241.883V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2027.2578H245.621V31.9572H247.496V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2031.9561H22.5V36.6555H37.4999V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2031.9561H39.375V36.6555H41.2501V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2031.9561H43.1328V36.6555H45.0079V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2031.9561H46.8672V36.6555H48.7423V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M56.2579%2031.9561H54.3828V36.6555H56.2579V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M59.9923%2031.9561H58.1172V36.6555H59.9923V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7501%2031.9561H61.875V36.6555H63.7501V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M75.0001%2031.9561H67.5V36.6555H75.0001V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9921%2031.9561H86.2422V36.6555H89.9921V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M103.129%2031.9561H91.8789V36.6555H103.129V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2031.9561H104.996V36.6555H108.746V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2031.9561H110.633V36.6555H112.508V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M120%2031.9561H118.125V36.6555H120V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2031.9561H121.871V36.6555H123.746V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M136.871%2031.9561H133.121V36.6555H136.871V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M148.133%2031.9561H138.758V36.6555H148.133V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M151.871%2031.9561H149.996V36.6555H151.871V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M161.258%2031.9561H155.633V36.6555H161.258V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M172.492%2031.9561H170.617V36.6555H172.492V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M178.125%2031.9561H174.375V36.6555H178.125V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M183.754%2031.9561H181.879V36.6555H183.754V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M187.5%2031.9561H185.625V36.6555H187.5V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M191.246%2031.9561H189.371V36.6555H191.246V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M206.242%2031.9561H198.742V36.6555H206.242V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2031.9561H213.75V36.6555H226.875V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2031.9561H228.746V36.6555H230.621V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2031.9561H236.25V36.6555H238.125V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2031.9561H240.008V36.6555H241.883V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2031.9561H245.621V36.6555H247.496V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2036.6562H22.5V41.3557H37.4999V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2036.6562H39.375V41.3557H41.2501V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2036.6562H43.1328V41.3557H45.0079V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2036.6562H46.8672V41.3557H48.7423V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1327%2036.6562H54.3828V41.3557H58.1327V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8712%2036.6562H59.9961V41.3557H61.8712V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M71.254%2036.6562H63.7539V41.3557H71.254V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3671%2036.6562H74.9922V41.3557H84.3671V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M95.6171%2036.6562H86.2422V41.3557H95.6171V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M99.379%2036.6562H97.5039V41.3557H99.379V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M103.125%2036.6562H101.25V41.3557H103.125V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M116.25%2036.6562H106.875V41.3557H116.25V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M123.75%2036.6562H118.125V41.3557H123.75V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M131.254%2036.6562H125.629V41.3557H131.254V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M134.996%2036.6562H133.121V41.3557H134.996V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M140.633%2036.6562H138.758V41.3557H140.633V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2036.6562H149.996V41.3557H153.746V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M157.508%2036.6562H155.633V41.3557H157.508V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M168.758%2036.6562H166.883V41.3557H168.758V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M180.004%2036.6562H176.254V41.3557H180.004V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M185.629%2036.6562H181.879V41.3557H185.629V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M189.367%2036.6562H187.492V41.3557H189.367V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M198.75%2036.6562H191.25V41.3557H198.75V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M211.875%2036.6562H202.5V41.3557H211.875V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2036.6562H213.75V41.3557H226.875V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2036.6562H228.746V41.3557H230.621V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2036.6562H236.25V41.3557H238.125V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2036.6562H240.008V41.3557H241.883V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2036.6562H245.621V41.3557H247.496V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2041.3564H22.5V46.0559H37.4999V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2041.3564H39.375V46.0559H41.2501V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2041.3564H43.1328V46.0559H45.0079V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2041.3564H46.8672V46.0559H48.7423V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1327%2041.3564H54.3828V46.0559H58.1327V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8712%2041.3564H59.9961V46.0559H61.8712V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3789%2041.3564H63.7539V46.0559H69.3789V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M80.6251%2041.3564H78.75V46.0559H80.6251V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4922%2041.3564H86.2422V46.0559H97.4922V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M105.008%2041.3564H99.3828V46.0559H105.008V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M108.75%2041.3564H106.875V46.0559H108.75V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2041.3564H110.633V46.0559H112.508V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M123.75%2041.3564H118.125V46.0559H123.75V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M127.504%2041.3564H125.629V46.0559H127.504V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M134.992%2041.3564H131.242V46.0559H134.992V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M138.754%2041.3564H136.879V46.0559H138.754V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2041.3564H149.996V46.0559H153.746V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M166.879%2041.3564H165.004V46.0559H166.879V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M176.242%2041.3564H170.617V46.0559H176.242V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M179.996%2041.3564H178.121V46.0559H179.996V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M189.379%2041.3564H181.879V46.0559H189.379V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M193.125%2041.3564H191.25V46.0559H193.125V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M200.633%2041.3564H195.008V46.0559H200.633V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M210.004%2041.3564H204.379V46.0559H210.004V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2041.3564H213.75V46.0559H226.875V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2041.3564H228.746V46.0559H230.621V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2041.3564H236.25V46.0559H238.125V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2041.3564H240.008V46.0559H241.883V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2041.3564H245.621V46.0559H247.496V41.3564Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2046.0537H22.5V50.7531H37.4999V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2046.0537H39.375V50.7531H41.2501V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2046.0537H43.1328V50.7531H45.0079V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2046.0537H46.8672V50.7531H48.7423V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7577%2046.0537H54.3828V50.7531H63.7577V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4962%2046.0537H65.6211V50.7531H67.4962V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M76.879%2046.0537H69.3789V50.7531H76.879V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4999%2046.0537H78.75V50.7531H82.4999V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M93.7423%2046.0537H86.2422V50.7531H93.7423V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M97.5001%2046.0537H95.625V50.7531H97.5001V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M108.75%2046.0537H101.25V50.7531H108.75V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M112.508%2046.0537H110.633V50.7531H112.508V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M120%2046.0537H118.125V50.7531H120V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M127.496%2046.0537H121.871V50.7531H127.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M135%2046.0537H129.375V50.7531H135V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M148.125%2046.0537H140.625V50.7531H148.125V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2046.0537H149.996V50.7531H153.746V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M168.742%2046.0537H159.367V50.7531H168.742V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M174.371%2046.0537H172.496V50.7531H174.371V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M179.996%2046.0537H178.121V50.7531H179.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M189.379%2046.0537H181.879V50.7531H189.379V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M193.125%2046.0537H191.25V50.7531H193.125V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M204.383%2046.0537H195.008V50.7531H204.383V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M209.996%2046.0537H206.246V50.7531H209.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2046.0537H213.75V50.7531H226.875V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2046.0537H228.746V50.7531H230.621V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2046.0537H236.25V50.7531H238.125V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2046.0537H240.008V50.7531H241.883V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2046.0537H245.621V50.7531H247.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2050.7539H22.5V55.4533H37.4999V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2050.7539H39.375V55.4533H41.2501V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2050.7539H43.1328V55.4533H45.0079V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2050.7539H46.8672V55.4533H48.7423V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M60.0078%2050.7539H54.3828V55.4533H60.0078V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7501%2050.7539H61.875V55.4533H63.7501V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M73.125%2050.7539H67.5V55.4533H73.125V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3671%2050.7539H74.9922V55.4533H84.3671V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1173%2050.7539H86.2422V55.4533H88.1173V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3749%2050.7539H95.625V55.4533H99.3749V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2050.7539H104.996V55.4533H108.746V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M114.375%2050.7539H112.5V55.4533H114.375V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2050.7539H118.125V55.4533H121.875V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M129.379%2050.7539H125.629V55.4533H129.379V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M140.629%2050.7539H136.879V55.4533H140.629V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M148.121%2050.7539H144.371V55.4533H148.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M151.871%2050.7539H149.996V55.4533H151.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M163.121%2050.7539H161.246V55.4533H163.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M172.5%2050.7539H168.75V55.4533H172.5V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M178.125%2050.7539H174.375V55.4533H178.125V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M187.504%2050.7539H181.879V55.4533H187.504V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M191.246%2050.7539H189.371V55.4533H191.246V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M200.633%2050.7539H195.008V55.4533H200.633V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M211.875%2050.7539H202.5V55.4533H211.875V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2050.7539H213.75V55.4533H226.875V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2050.7539H228.746V55.4533H230.621V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2050.7539H236.25V55.4533H238.125V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2050.7539H240.008V55.4533H241.883V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2050.7539H245.621V55.4533H247.496V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2055.4551H22.5V60.1545H37.4999V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2055.4551H39.375V60.1545H41.2501V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2055.4551H43.1328V60.1545H45.0079V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2055.4551H46.8672V60.1545H48.7423V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6328%2055.4551H54.3828V60.1545H65.6328V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3751%2055.4551H67.5V60.1545H69.3751V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M75.0001%2055.4551H73.125V60.1545H75.0001V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4961%2055.4551H76.8711V60.1545H82.4961V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1173%2055.4551H86.2422V60.1545H88.1173V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M97.5001%2055.4551H90V60.1545H97.5001V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M103.133%2055.4551H99.3828V60.1545H103.133V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M114.371%2055.4551H104.996V60.1545H114.371V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M120%2055.4551H118.125V60.1545H120V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2055.4551H121.871V60.1545H123.746V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M133.129%2055.4551H125.629V60.1545H133.129V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M142.5%2055.4551H140.625V60.1545H142.5V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M157.496%2055.4551H149.996V60.1545H157.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M164.996%2055.4551H161.246V60.1545H164.996V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M172.5%2055.4551H168.75V60.1545H172.5V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M176.25%2055.4551H174.375V60.1545H176.25V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M183.754%2055.4551H181.879V60.1545H183.754V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M187.5%2055.4551H185.625V60.1545H187.5V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M200.621%2055.4551H189.371V60.1545H200.621V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M208.125%2055.4551H202.5V60.1545H208.125V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2055.4551H213.75V60.1545H226.875V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2055.4551H228.746V60.1545H230.621V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2055.4551H236.25V60.1545H238.125V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2055.4551H240.008V60.1545H241.883V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2055.4551H245.621V60.1545H247.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M37.4999%2060.1523H22.5V64.8518H37.4999V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2501%2060.1523H39.375V64.8518H41.2501V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M45.0079%2060.1523H43.1328V64.8518H45.0079V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7423%2060.1523H46.8672V64.8518H48.7423V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6328%2060.1523H54.3828V64.8518H65.6328V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3751%2060.1523H67.5V64.8518H69.3751V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M76.8749%2060.1523H73.125V64.8518H76.8749V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M82.504%2060.1523H80.6289V64.8518H82.504V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1173%2060.1523H86.2422V64.8518H88.1173V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3711%2060.1523H93.7461V64.8518H99.3711V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M103.125%2060.1523H101.25V64.8518H103.125V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2060.1523H108.754V64.8518H112.504V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M121.875%2060.1523H118.125V64.8518H121.875V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M131.258%2060.1523H127.508V64.8518H131.258V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M138.754%2060.1523H136.879V64.8518H138.754V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M148.125%2060.1523H140.625V64.8518H148.125V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M153.746%2060.1523H149.996V64.8518H153.746V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M159.383%2060.1523H155.633V64.8518H159.383V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M163.121%2060.1523H161.246V64.8518H163.121V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M172.504%2060.1523H165.004V64.8518H172.504V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M191.254%2060.1523H181.879V64.8518H191.254V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M195.004%2060.1523H193.129V64.8518H195.004V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M204.367%2060.1523H198.742V64.8518H204.367V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M208.121%2060.1523H206.246V64.8518H208.121V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M226.875%2060.1523H213.75V64.8518H226.875V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M230.621%2060.1523H228.746V64.8518H230.621V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M238.125%2060.1523H236.25V64.8518H238.125V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M241.883%2060.1523H240.008V64.8518H241.883V60.1523Z'%20fill='%23272833'/%3e%3cpath%20d='M247.496%2060.1523H245.621V64.8518H247.496V60.1523Z'%20fill='%23272833'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_10772_56590'%3e%3crect%20width='225'%20height='42.2951'%20fill='white'%20transform='translate(22.5%2022.5576)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")}._id-mrz-barcode-back-icon_5ot88_63:before{background-image:url("data:image/svg+xml,%3csvg%20width='270'%20height='172'%20viewBox='0%200%20270%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.40984'%20y='-1.40984'%20width='267.18'%20height='169.18'%20rx='12.6885'%20transform='matrix(1%200%200%20-1%200%20169.18)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.81967'/%3e%3crect%20x='22.5'%20y='124.065'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='107.147'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='140.983'%20width='225'%20height='8.45902'%20fill='%23333543'/%3e%3crect%20x='22.5'%20y='76.1309'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3crect%20x='95.625'%20y='76.1309'%20width='61.875'%20height='11.2787'%20fill='%23333543'/%3e%3cg%20clip-path='url(%23clip0_10772_56870)'%3e%3cpath%20d='M247.496%2022.5576H22.4961V64.8527H247.496V22.5576Z'%20fill='%23D6D6D6'/%3e%3cpath%20d='M37.496%2022.5576H22.4961V27.257H37.496V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2022.5576H39.3711V27.257H41.2462V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2022.5576H43.1289V27.257H45.004V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2022.5576H46.8633V27.257H48.7384V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7538%2022.5576H54.3789V27.257H63.7538V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4923%2022.5576H65.6172V27.257H67.4923V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M71.2501%2022.5576H69.375V27.257H71.2501V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M82.496%2022.5576H73.1211V27.257H82.496V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9882%2022.5576H86.2383V27.257H89.9882V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M93.7501%2022.5576H91.875V27.257H93.7501V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M99.371%2022.5576H95.6211V27.257H99.371V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M110.617%2022.5576H104.992V27.257H110.617V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2022.5576H118.121V27.257H121.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M133.121%2022.5576H129.371V27.257H133.121V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M136.871%2022.5576H134.996V27.257H136.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M140.629%2022.5576H138.754V27.257H140.629V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M151.867%2022.5576H149.992V27.257H151.867V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M159.375%2022.5576H153.75V27.257H159.375V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M172.504%2022.5576H166.879V27.257H172.504V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M176.246%2022.5576H174.371V27.257H176.246V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M191.25%2022.5576H181.875V27.257H191.25V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M195%2022.5576H193.125V27.257H195V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M198.746%2022.5576H196.871V27.257H198.746V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M209.992%2022.5576H200.617V27.257H209.992V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2022.5576H213.746V27.257H226.871V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2022.5576H228.742V27.257H230.617V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2022.5576H236.246V27.257H238.121V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2022.5576H240.004V27.257H241.879V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2022.5576H245.617V27.257H247.492V22.5576Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2027.2578H22.4961V31.9572H37.496V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2027.2578H39.3711V31.9572H41.2462V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2027.2578H43.1289V31.9572H45.004V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2027.2578H46.8633V31.9572H48.7384V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M61.879%2027.2578H54.3789V31.9572H61.879V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6251%2027.2578H63.75V31.9572H65.6251V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3712%2027.2578H67.4961V31.9572H69.3712V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M78.7423%2027.2578H76.8672V31.9572H78.7423V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M91.8633%2027.2578H86.2383V31.9572H91.8633V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3751%2027.2578H97.5V31.9572H99.3751V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M104.996%2027.2578H101.246V31.9572H104.996V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2027.2578H110.629V31.9572H112.504V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2027.2578H118.121V31.9572H121.871V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M133.125%2027.2578H125.625V31.9572H133.125V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M136.871%2027.2578H134.996V31.9572H136.871V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M148.129%2027.2578H138.754V31.9572H148.129V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M155.617%2027.2578H149.992V31.9572H155.617V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M163.117%2027.2578H161.242V31.9572H163.117V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M174.371%2027.2578H168.746V31.9572H174.371V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M180%2027.2578H176.25V31.9572H180V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M189.375%2027.2578H181.875V31.9572H189.375V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M193.121%2027.2578H191.246V31.9572H193.121V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M196.879%2027.2578H195.004V31.9572H196.879V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M202.492%2027.2578H200.617V31.9572H202.492V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2027.2578H213.746V31.9572H226.871V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2027.2578H228.742V31.9572H230.617V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2027.2578H236.246V31.9572H238.121V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2027.2578H240.004V31.9572H241.879V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2027.2578H245.617V31.9572H247.492V27.2578Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2031.9561H22.4961V36.6555H37.496V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2031.9561H39.3711V36.6555H41.2462V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2031.9561H43.1289V36.6555H45.004V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2031.9561H46.8633V36.6555H48.7384V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M56.254%2031.9561H54.3789V36.6555H56.254V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M59.9884%2031.9561H58.1133V36.6555H59.9884V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7462%2031.9561H61.8711V36.6555H63.7462V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M74.9962%2031.9561H67.4961V36.6555H74.9962V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M89.9882%2031.9561H86.2383V36.6555H89.9882V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M103.125%2031.9561H91.875V36.6555H103.125V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M108.742%2031.9561H104.992V36.6555H108.742V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2031.9561H110.629V36.6555H112.504V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M119.996%2031.9561H118.121V36.6555H119.996V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M123.742%2031.9561H121.867V36.6555H123.742V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M136.867%2031.9561H133.117V36.6555H136.867V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M148.129%2031.9561H138.754V36.6555H148.129V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M151.867%2031.9561H149.992V36.6555H151.867V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M161.254%2031.9561H155.629V36.6555H161.254V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M172.488%2031.9561H170.613V36.6555H172.488V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M178.121%2031.9561H174.371V36.6555H178.121V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M183.75%2031.9561H181.875V36.6555H183.75V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M187.496%2031.9561H185.621V36.6555H187.496V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M191.242%2031.9561H189.367V36.6555H191.242V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M206.238%2031.9561H198.738V36.6555H206.238V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2031.9561H213.746V36.6555H226.871V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2031.9561H228.742V36.6555H230.617V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2031.9561H236.246V36.6555H238.121V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2031.9561H240.004V36.6555H241.879V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2031.9561H245.617V36.6555H247.492V31.9561Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2036.6562H22.4961V41.3557H37.496V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2036.6562H39.3711V41.3557H41.2462V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2036.6562H43.1289V41.3557H45.004V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2036.6562H46.8633V41.3557H48.7384V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1288%2036.6562H54.3789V41.3557H58.1288V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8673%2036.6562H59.9922V41.3557H61.8673V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M71.2501%2036.6562H63.75V41.3557H71.2501V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3632%2036.6562H74.9883V41.3557H84.3632V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M95.6132%2036.6562H86.2383V41.3557H95.6132V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3751%2036.6562H97.5V41.3557H99.3751V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M103.121%2036.6562H101.246V41.3557H103.121V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M116.246%2036.6562H106.871V41.3557H116.246V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2036.6562H118.121V41.3557H123.746V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M131.25%2036.6562H125.625V41.3557H131.25V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M134.992%2036.6562H133.117V41.3557H134.992V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M140.629%2036.6562H138.754V41.3557H140.629V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2036.6562H149.992V41.3557H153.742V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M157.504%2036.6562H155.629V41.3557H157.504V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M168.754%2036.6562H166.879V41.3557H168.754V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M180%2036.6562H176.25V41.3557H180V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M185.625%2036.6562H181.875V41.3557H185.625V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M189.363%2036.6562H187.488V41.3557H189.363V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M198.746%2036.6562H191.246V41.3557H198.746V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M211.871%2036.6562H202.496V41.3557H211.871V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2036.6562H213.746V41.3557H226.871V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2036.6562H228.742V41.3557H230.617V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2036.6562H236.246V41.3557H238.121V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2036.6562H240.004V41.3557H241.879V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2036.6562H245.617V41.3557H247.492V36.6562Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2041.3555H22.4961V46.0549H37.496V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2041.3555H39.3711V46.0549H41.2462V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2041.3555H43.1289V46.0549H45.004V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2041.3555H46.8633V46.0549H48.7384V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M58.1288%2041.3555H54.3789V46.0549H58.1288V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M61.8673%2041.3555H59.9922V46.0549H61.8673V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M69.375%2041.3555H63.75V46.0549H69.375V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M80.6212%2041.3555H78.7461V46.0549H80.6212V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4883%2041.3555H86.2383V46.0549H97.4883V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M105.004%2041.3555H99.3789V46.0549H105.004V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2041.3555H106.871V46.0549H108.746V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2041.3555H110.629V46.0549H112.504V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M123.746%2041.3555H118.121V46.0549H123.746V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M127.5%2041.3555H125.625V46.0549H127.5V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M134.988%2041.3555H131.238V46.0549H134.988V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M138.75%2041.3555H136.875V46.0549H138.75V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2041.3555H149.992V46.0549H153.742V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M166.875%2041.3555H165V46.0549H166.875V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M176.238%2041.3555H170.613V46.0549H176.238V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M179.992%2041.3555H178.117V46.0549H179.992V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M189.375%2041.3555H181.875V46.0549H189.375V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M193.121%2041.3555H191.246V46.0549H193.121V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M200.629%2041.3555H195.004V46.0549H200.629V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M210%2041.3555H204.375V46.0549H210V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2041.3555H213.746V46.0549H226.871V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2041.3555H228.742V46.0549H230.617V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2041.3555H236.246V46.0549H238.121V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2041.3555H240.004V46.0549H241.879V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2041.3555H245.617V46.0549H247.492V41.3555Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2046.0537H22.4961V50.7531H37.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2046.0537H39.3711V50.7531H41.2462V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2046.0537H43.1289V50.7531H45.004V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2046.0537H46.8633V50.7531H48.7384V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7538%2046.0537H54.3789V50.7531H63.7538V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M67.4923%2046.0537H65.6172V50.7531H67.4923V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M76.8751%2046.0537H69.375V50.7531H76.8751V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M82.496%2046.0537H78.7461V50.7531H82.496V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M93.7384%2046.0537H86.2383V50.7531H93.7384V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4962%2046.0537H95.6211V50.7531H97.4962V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M108.746%2046.0537H101.246V50.7531H108.746V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M112.504%2046.0537H110.629V50.7531H112.504V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M119.996%2046.0537H118.121V50.7531H119.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M127.492%2046.0537H121.867V50.7531H127.492V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M134.996%2046.0537H129.371V50.7531H134.996V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M148.121%2046.0537H140.621V50.7531H148.121V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2046.0537H149.992V50.7531H153.742V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M168.738%2046.0537H159.363V50.7531H168.738V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M174.367%2046.0537H172.492V50.7531H174.367V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M179.992%2046.0537H178.117V50.7531H179.992V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M189.375%2046.0537H181.875V50.7531H189.375V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M193.121%2046.0537H191.246V50.7531H193.121V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M204.379%2046.0537H195.004V50.7531H204.379V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M209.992%2046.0537H206.242V50.7531H209.992V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2046.0537H213.746V50.7531H226.871V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2046.0537H228.742V50.7531H230.617V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2046.0537H236.246V50.7531H238.121V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2046.0537H240.004V50.7531H241.879V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2046.0537H245.617V50.7531H247.492V46.0537Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2050.7539H22.4961V55.4533H37.496V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2050.7539H39.3711V55.4533H41.2462V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2050.7539H43.1289V55.4533H45.004V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2050.7539H46.8633V55.4533H48.7384V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M60.0039%2050.7539H54.3789V55.4533H60.0039V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M63.7462%2050.7539H61.8711V55.4533H63.7462V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M73.1211%2050.7539H67.4961V55.4533H73.1211V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M84.3632%2050.7539H74.9883V55.4533H84.3632V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1134%2050.7539H86.2383V55.4533H88.1134V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M99.371%2050.7539H95.6211V55.4533H99.371V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M108.742%2050.7539H104.992V55.4533H108.742V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M114.371%2050.7539H112.496V55.4533H114.371V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2050.7539H118.121V55.4533H121.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M129.375%2050.7539H125.625V55.4533H129.375V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M140.625%2050.7539H136.875V55.4533H140.625V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M148.117%2050.7539H144.367V55.4533H148.117V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M151.867%2050.7539H149.992V55.4533H151.867V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M163.117%2050.7539H161.242V55.4533H163.117V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M172.496%2050.7539H168.746V55.4533H172.496V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M178.121%2050.7539H174.371V55.4533H178.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M187.5%2050.7539H181.875V55.4533H187.5V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M191.242%2050.7539H189.367V55.4533H191.242V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M200.629%2050.7539H195.004V55.4533H200.629V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M211.871%2050.7539H202.496V55.4533H211.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2050.7539H213.746V55.4533H226.871V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2050.7539H228.742V55.4533H230.617V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2050.7539H236.246V55.4533H238.121V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2050.7539H240.004V55.4533H241.879V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2050.7539H245.617V55.4533H247.492V50.7539Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2055.4551H22.4961V60.1545H37.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2055.4551H39.3711V60.1545H41.2462V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2055.4551H43.1289V60.1545H45.004V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2055.4551H46.8633V60.1545H48.7384V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6289%2055.4551H54.3789V60.1545H65.6289V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3712%2055.4551H67.4961V60.1545H69.3712V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M74.9962%2055.4551H73.1211V60.1545H74.9962V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M82.4922%2055.4551H76.8672V60.1545H82.4922V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1134%2055.4551H86.2383V60.1545H88.1134V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M97.4962%2055.4551H89.9961V60.1545H97.4962V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M103.129%2055.4551H99.3789V60.1545H103.129V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M114.367%2055.4551H104.992V60.1545H114.367V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M119.996%2055.4551H118.121V60.1545H119.996V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M123.742%2055.4551H121.867V60.1545H123.742V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M133.125%2055.4551H125.625V60.1545H133.125V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M142.496%2055.4551H140.621V60.1545H142.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M157.492%2055.4551H149.992V60.1545H157.492V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M164.992%2055.4551H161.242V60.1545H164.992V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M172.496%2055.4551H168.746V60.1545H172.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M176.246%2055.4551H174.371V60.1545H176.246V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M183.75%2055.4551H181.875V60.1545H183.75V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M187.496%2055.4551H185.621V60.1545H187.496V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M200.617%2055.4551H189.367V60.1545H200.617V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M208.121%2055.4551H202.496V60.1545H208.121V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2055.4551H213.746V60.1545H226.871V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2055.4551H228.742V60.1545H230.617V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2055.4551H236.246V60.1545H238.121V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2055.4551H240.004V60.1545H241.879V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2055.4551H245.617V60.1545H247.492V55.4551Z'%20fill='%23272833'/%3e%3cpath%20d='M37.496%2060.1514H22.4961V64.8508H37.496V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M41.2462%2060.1514H39.3711V64.8508H41.2462V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M45.004%2060.1514H43.1289V64.8508H45.004V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M48.7384%2060.1514H46.8633V64.8508H48.7384V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M65.6289%2060.1514H54.3789V64.8508H65.6289V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M69.3712%2060.1514H67.4961V64.8508H69.3712V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M76.871%2060.1514H73.1211V64.8508H76.871V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M82.5001%2060.1514H80.625V64.8508H82.5001V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M88.1134%2060.1514H86.2383V64.8508H88.1134V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M99.3672%2060.1514H93.7422V64.8508H99.3672V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M103.121%2060.1514H101.246V64.8508H103.121V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M112.5%2060.1514H108.75V64.8508H112.5V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M121.871%2060.1514H118.121V64.8508H121.871V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M131.254%2060.1514H127.504V64.8508H131.254V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M138.75%2060.1514H136.875V64.8508H138.75V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M148.121%2060.1514H140.621V64.8508H148.121V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M153.742%2060.1514H149.992V64.8508H153.742V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M159.379%2060.1514H155.629V64.8508H159.379V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M163.117%2060.1514H161.242V64.8508H163.117V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M172.5%2060.1514H165V64.8508H172.5V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M191.25%2060.1514H181.875V64.8508H191.25V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M195%2060.1514H193.125V64.8508H195V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M204.363%2060.1514H198.738V64.8508H204.363V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M208.117%2060.1514H206.242V64.8508H208.117V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M226.871%2060.1514H213.746V64.8508H226.871V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M230.617%2060.1514H228.742V64.8508H230.617V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M238.121%2060.1514H236.246V64.8508H238.121V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M241.879%2060.1514H240.004V64.8508H241.879V60.1514Z'%20fill='%23272833'/%3e%3cpath%20d='M247.492%2060.1514H245.617V64.8508H247.492V60.1514Z'%20fill='%23272833'/%3e%3c/g%3e%3cdefs%3e%3cclipPath%20id='clip0_10772_56870'%3e%3crect%20width='225'%20height='42.2951'%20fill='white'%20transform='translate(22.5%2022.5576)'/%3e%3c/clipPath%3e%3c/defs%3e%3c/svg%3e")}._bank-card-front-icon_5ot88_67:before{background-image:url("data:image/svg+xml,%3csvg%20width='280'%20height='172'%20viewBox='0%200%20280%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.45763'%20y='-1.45763'%20width='277.085'%20height='169.085'%20rx='13.1186'%20transform='matrix(1%200%200%20-1%200%20169.085)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.91525'/%3e%3crect%20x='23.332'%20y='23.3223'%20width='107.917'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='93.332'%20y='142.848'%20width='99.1667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='145.832'%20y='122.44'%20width='37.9167'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='23.332'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='84.582'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='145.832'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='207.082'%20y='99.1182'%20width='46.6667'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='23.332'%20y='142.848'%20width='61.25'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='23.3359'%20y='52.4746'%20width='40.8333'%20height='37.8983'%20rx='5.83051'%20fill='%23333543'/%3e%3crect%20x='23.3359'%20y='58.3047'%20width='40.8333'%20height='1.45763'%20fill='white'/%3e%3crect%20x='23.3359'%20y='67.0508'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='49.5859'%20y='67.0508'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='23.3359'%20y='74.3389'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='49.5859'%20y='74.3389'%20width='14.5833'%20height='1.45763'%20fill='white'/%3e%3crect%20x='44.4805'%20y='52.4746'%20width='5.83051'%20height='1.45833'%20transform='rotate(90%2044.4805%2052.4746)'%20fill='white'/%3e%3crect%20x='37.918'%20y='58.3047'%20width='26.2373'%20height='1.45833'%20transform='rotate(90%2037.918%2058.3047)'%20fill='white'/%3e%3crect%20x='51.043'%20y='67.0508'%20width='17.4915'%20height='1.45833'%20transform='rotate(90%2051.043%2067.0508)'%20fill='white'/%3e%3crect%20x='44.4805'%20y='84.542'%20width='5.83051'%20height='1.45833'%20transform='rotate(90%2044.4805%2084.542)'%20fill='white'/%3e%3crect%20x='23.3359'%20y='83.085'%20width='40.8333'%20height='1.45763'%20fill='white'/%3e%3ccircle%20cx='224.476'%20cy='137.017'%20r='17.4915'%20fill='%23333543'/%3e%3ccircle%20cx='247.796'%20cy='137.017'%20r='17.4915'%20fill='%23333543'/%3e%3c/svg%3e")}._bank-card-back-icon_5ot88_71:before{background-image:url("data:image/svg+xml,%3csvg%20width='280'%20height='172'%20viewBox='0%200%20280%20172'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20x='1.45833'%20y='-1.45833'%20width='277.083'%20height='169.083'%20rx='13.125'%20transform='matrix(1%200%200%20-1%200%20169.083)'%20fill='white'%20fill-opacity='0.8'%20stroke='%231B1C23'%20stroke-width='2.91667'/%3e%3crect%20y='14.5762'%20width='280'%20height='40.8136'%20fill='%23333543'/%3e%3crect%20x='23.332'%20y='69.9658'%20width='37.9167'%20height='11.661'%20fill='%23333543'/%3e%3crect%20x='224.582'%20y='119.525'%20width='23.3333'%20height='34.9831'%20fill='%23333543'/%3e%3ccircle%20cx='224.582'%20cy='137.083'%20r='17.5'%20fill='%23333543'/%3e%3ccircle%20cx='247.918'%20cy='137.083'%20r='17.5'%20fill='%23333543'/%3e%3c/svg%3e")}._document-front-icon_5ot88_75:before{background-image:url("data:image/svg+xml,%3csvg%20width='920'%20height='640'%20viewBox='0%200%20920%20640'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M520%20200H800V240H520V200Z'%20fill='white'/%3e%3cpath%20d='M800%20300H520V340H800V300Z'%20fill='white'/%3e%3cpath%20d='M520%20400H800V440H520V400Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M274.943%20123.429L274.933%20123.432C266.551%20126.295%20258.863%20130.466%20251.927%20135.343C243.39%20140.807%20235.349%20147.484%20228.244%20155.117C216.999%20166.723%20206.985%20181.73%20202.638%20200.462C201.732%20203.954%20201.031%20207.508%20200.554%20211.114C198.857%20223.937%20199.991%20237.409%20204.799%20251.055C201.906%20250.776%20199.719%20251.697%20198.089%20253.419C191.062%20260.842%20194.356%20283.152%20195.842%20288.454C202.652%20312.775%20208.999%20319.597%20213.796%20319.988C216.486%20337.575%20230.545%20358.063%20243.587%20375.139C243.587%20405.888%20203.816%20413.339%20170.442%20419.591C162.723%20421.037%20155.346%20422.419%20148.883%20424.01C114.629%20432.436%20110.268%20472.281%20110.168%20504.349C110.141%20513.052%20117.321%20520%20126.023%20520H473.977C482.679%20520%20489.859%20513.052%20489.839%20504.349C489.769%20472.142%20485.483%20432.464%20451.117%20424.01C445.211%20422.556%20438.486%20421.191%20431.39%20419.752L431.388%20419.751C396.76%20412.725%20353.321%20403.912%20353.321%20374.203C353.664%20373.739%20354.01%20373.272%20354.358%20372.804C357.463%20368.617%20360.701%20364.25%20363.825%20359.791C372.128%20347.938%20379.624%20335.429%20381.652%20323.912C382.709%20324.634%20383.91%20325.123%20385.24%20325.123C385.796%20325.123%20386.374%20325.037%20386.972%20324.849C391.593%20323.394%20397.418%20315.772%20403.633%20293.568C410.9%20267.609%20406.477%20258.905%20400.199%20256.714C420.616%20157.928%20373.971%20154.617%20373.971%20154.617C373.971%20154.617%20366.934%20140.939%20348.397%20130.606C337.66%20124.183%20323.287%20119%20304.851%20119C301.953%20119%20298.964%20119.122%20295.865%20119.395C288.479%20119.744%20281.5%20121.188%20274.943%20123.429ZM321.183%20350.388C316.077%20357.278%20313.321%20365.627%20313.321%20374.203C313.321%20396.791%20323.959%20414.183%20337.296%20425.916C349.473%20436.63%20364.134%20443.009%20376.199%20447.154C388.689%20451.445%20401.819%20454.454%20412.943%20456.796C417.197%20457.692%20421.006%20458.464%20424.494%20459.171L424.495%20459.171C431.031%20460.495%20436.443%20461.592%20441.555%20462.85L441.562%20462.852C442.371%20463.051%20442.688%20463.234%20442.718%20463.251L442.719%20463.252L442.723%20463.254C442.746%20463.267%20442.79%20463.292%20442.907%20463.412C443.207%20463.723%20444.371%20465.103%20445.684%20468.766C446.817%20471.928%20447.691%20475.687%20448.338%20480H151.711C152.363%20475.717%20153.239%20471.971%20154.372%20468.81C155.699%20465.109%20156.878%20463.698%20157.192%20463.372L157.194%20463.369C157.207%20463.34%20157.301%20463.132%20158.438%20462.852L158.445%20462.85C163.729%20461.549%20169.527%20460.462%20176.817%20459.096L176.821%20459.095C179.572%20458.579%20182.535%20458.024%20185.763%20457.402C196.469%20455.34%20209.407%20452.649%20221.731%20448.562C233.686%20444.597%20248.469%20438.255%20260.709%20426.995C274.269%20414.522%20283.587%20396.915%20283.587%20375.139C283.587%20366.365%20280.702%20357.834%20275.376%20350.86C269.197%20342.77%20263.625%20334.956%20259.415%20327.693C254.949%20319.99%20253.579%20315.526%20253.336%20313.941C251.698%20303.233%20245.887%20294.002%20237.651%20287.879C236.767%20285.573%20235.697%20282.397%20234.493%20278.142C234.495%20278.139%20234.486%20278.086%20234.467%20277.984L234.452%20277.901C235.091%20277.195%20235.707%20276.464%20236.298%20275.708C244.717%20264.952%20247.065%20250.644%20242.526%20237.762C239.17%20228.237%20239.103%20219.19%20241.356%20210.506C241.443%20210.173%20241.525%20209.839%20241.603%20209.503C243.904%20199.588%20249.376%20190.79%20256.971%20182.951C257.156%20182.76%20257.34%20182.567%20257.521%20182.372C262.328%20177.208%20267.774%20172.691%20273.489%20169.034C273.978%20168.721%20274.46%20168.397%20274.936%20168.063C279.286%20165.004%20283.597%20162.748%20287.809%20161.303L287.883%20161.278C291.162%20160.157%20294.424%20159.508%20297.75%20159.351C298.292%20159.325%20298.833%20159.288%20299.374%20159.241C301.267%20159.074%20303.083%20159%20304.851%20159C315.374%20159%20322.72%20161.857%20327.864%20164.933C328.213%20165.142%20328.565%20165.345%20328.92%20165.543C333.473%20168.081%20336.341%20170.874%20337.886%20172.659C338.515%20173.386%20338.906%20173.925%20339.077%20174.173C344.22%20183.353%20352.722%20190.05%20362.636%20192.979C364.507%20197.532%20368.476%20212.578%20361.027%20248.618C358.865%20259.075%20361.005%20269.523%20366.336%20278.005C366.023%20279.378%20365.623%20280.965%20365.114%20282.784L365.113%20282.786C364.533%20284.861%20363.983%20286.685%20363.469%20288.283C352.34%20293.961%20344.445%20304.559%20342.258%20316.974C342.258%20316.974%20342.208%20317.246%20342.023%20317.818C341.833%20318.406%20341.53%20319.218%20341.065%20320.269C340.111%20322.423%20338.685%20325.105%20336.678%20328.368C332.654%20334.911%20327.684%20341.617%20321.853%20349.483L321.183%20350.388Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M80%200C35.8172%200%200%2035.8172%200%2080V560C0%20604.183%2035.8172%20640%2080%20640H840C884.183%20640%20920%20604.183%20920%20560V80C920%2035.8172%20884.183%200%20840%200H80ZM840%2040H80C57.9086%2040%2040%2057.9086%2040%2080V560C40%20582.091%2057.9086%20600%2080%20600H840C862.091%20600%20880%20582.091%20880%20560V80C880%2057.9086%20862.091%2040%20840%2040Z'%20fill='white'/%3e%3c/svg%3e")}._document-back-icon_5ot88_79:before{background-image:url("data:image/svg+xml,%3csvg%20width='920'%20height='640'%20viewBox='0%200%20920%20640'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M460%20300H140V340H460V300Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M100%200C44.7715%200%200%2044.7715%200%20100V540C0%20595.228%2044.7715%20640%20100%20640H820C875.228%20640%20920%20595.228%20920%20540V100C920%2044.7715%20875.229%200%20820%200H100ZM820%2040H100C66.8629%2040%2040%2066.8629%2040%20100V140H880V100C880%2066.8629%20853.137%2040%20820%2040ZM40%20540V240H880V540C880%20573.137%20853.137%20600%20820%20600H100C66.8629%20600%2040%20573.137%2040%20540Z'%20fill='white'/%3e%3c/svg%3e")}@keyframes _vertical_5ot88_19{0%{transform:rotateX(0)}25%{transform:rotateX(-30deg)}50%{transform:rotateX(0)}75%{transform:rotateX(30deg)}to{transform:rotateX(0)}}@keyframes _horizontal_5ot88_23{0%{transform:rotateY(0)}25%{transform:rotateY(-30deg)}50%{transform:rotateY(0)}75%{transform:rotateY(30deg)}to{transform:rotateY(0)}}@keyframes _left-bottom-right-top_5ot88_27{0%{transform:rotateX(0) rotateY(0)}25%{transform:rotateX(30deg) rotateY(-30deg)}50%{transform:rotateX(0) rotateY(0)}75%{transform:rotateX(-30deg) rotateY(30deg)}to{transform:rotateX(0) rotateY(0)}}@keyframes _right-bottom-left-top_5ot88_31{0%{transform:rotateX(0) rotateY(0)}25%{transform:rotateX(-30deg) rotateY(-30deg)}50%{transform:rotateX(0) rotateY(0)}75%{transform:rotateX(30deg) rotateY(30deg)}to{transform:rotateX(0) rotateY(0)}}`, yR = '._spinner_1vpw0_1{width:48px;height:48px;position:relative}._spinner_1vpw0_1 div{position:absolute;top:0;left:0;box-sizing:border-box;width:100%;height:100%;border-radius:50%;border:2px solid #7E57C5;border-bottom-color:transparent;animation:_spin_1vpw0_1 1s linear infinite}._spinner_1vpw0_1:before{content:"";width:100%;height:100%;border-radius:50%;border:2px solid #D9D9D9;position:absolute;top:0;left:0;box-sizing:border-box}@keyframes _spin_1vpw0_1{0%{transform:rotate(0)}to{transform:rotate(360deg)}}._process-message_1vpw0_41{display:flex;flex:1;flex-direction:column;align-items:center;justify-content:center;padding:24px;row-gap:24px}._message_1vpw0_51{display:block;font-size:14px;line-height:20px;color:#000}', NR = '._button_7h3jm_1{display:flex;width:100%;max-width:290px;padding:12px 24px;justify-content:center;column-gap:5px;background:#fff;border:1px solid #211236;border-radius:112px;cursor:pointer;font-family:Inter,sans-serif;font-style:normal;line-height:135%;font-size:18px;font-weight:400;color:#211236;white-space:nowrap}._button_7h3jm_1:before{content:"";display:inline-flex;width:22px;height:22px;background-repeat:no-repeat;background-position:center;background-size:contain}._button_7h3jm_1:hover:not(:disabled),._button_7h3jm_1:focus:not(:disabled){background:#f5f5f5}._button_7h3jm_1:active:not(:disabled){background:#e2e2e2}._button_7h3jm_1:disabled{opacity:.5;cursor:default}._button_7h3jm_1:focus-visible{outline:2px solid blue}', LR = "._copyright_aog6z_1{display:flex;justify-content:center;align-items:center;gap:3px;direction:ltr}._copyright_aog6z_1 span{font-size:10px;font-weight:500;letter-spacing:-.1px;color:#8c8c8c}._copyright_aog6z_1._vertical_aog6z_16{flex-direction:column-reverse}._copyright_aog6z_1._horizontal_aog6z_20 img{padding-top:3px}._copyright_aog6z_1._vertical_aog6z_16 img{padding-left:3px}._vertical_aog6z_16 span{writing-mode:vertical-rl;transform:rotate(180deg);text-orientation:mixed}", AV = '._remote-scanner-wrapper_18b5u_1{display:flex;flex:1;flex-direction:column;align-items:center;row-gap:24px;justify-content:center;padding:24px}._qr-container_18b5u_11{display:flex;flex-direction:column;align-items:center;max-width:350px;max-height:140px}._text_18b5u_19{display:flex;flex-direction:column;align-items:center;text-align:center;row-gap:16px}._title_18b5u_27{max-width:465px;color:#000;font-size:20px;font-weight:600;line-height:20px;margin:0}._subtitle_18b5u_36{display:block;max-width:465px;color:#454545;font-size:14px;font-weight:400;line-height:20px;margin:0}._content-container_18b5u_46{display:flex;flex-direction:column;row-gap:10px}._divider_18b5u_52{display:flex;align-items:center;text-align:center;column-gap:10px;color:#b5b5b5;font-size:12px;font-weight:400;line-height:12px;text-transform:uppercase}._divider_18b5u_52:before,._divider_18b5u_52:after{content:"";flex:1;border-top:1px solid #B5B5B5}._button_18b5u_71{align-self:center;padding:0;border:none;cursor:pointer;background:none;color:#454545;font-size:12px;font-weight:500;line-height:12px;font-family:Inter,sans-serif}._button_18b5u_71:hover{color:#7e57c5}._button_18b5u_71:focus-visible{outline:2px solid blue}', TV = `._verified-screen_evxkx_1:before{background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2086%2084'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cellipse%20cx='43'%20cy='42'%20rx='40'%20ry='40'%20transform='rotate(90%2043%2042)'%20stroke='%235DA600'%20stroke-width='3'/%3e%3cpath%20d='M66%2030L40.5069%2054L28%2042.2256'%20stroke='%235DA600'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e")}._error-screen_evxkx_5:before{background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2086%2084'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cellipse%20cx='43'%20cy='42'%20rx='40'%20ry='40'%20transform='rotate(90%2043%2042)'%20stroke='%23FF0000'%20stroke-width='3'/%3e%3cpath%20d='M57%2028L29%2056M29%2028L57%2056'%20stroke='%23FF0000'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e")}._camera-disabled-screen_evxkx_9:before{background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2080%2080'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='40'%20cy='40'%20r='37'%20stroke='%23FF0000'%20stroke-width='3'/%3e%3cpath%20d='M40.213%2030.6667H44.6663C45.3736%2030.6667%2046.0519%2030.9476%2046.552%2031.4477C47.0521%2031.9478%2047.333%2032.6261%2047.333%2033.3334V37.7867L48.6663%2038.12L56.6663%2033.3334V46.6667M47.333%2045.3334V46.6667C47.333%2047.3739%2047.0521%2048.0522%2046.552%2048.5523C46.0519%2049.0524%2045.3736%2049.3334%2044.6663%2049.3334H29.9997C29.2924%2049.3334%2028.6142%2049.0524%2028.1141%2048.5523C27.614%2048.0522%2027.333%2047.3739%2027.333%2046.6667V33.3334C27.333%2032.6261%2027.614%2031.9478%2028.1141%2031.4477C28.6142%2030.9476%2029.2924%2030.6667%2029.9997%2030.6667H32.6663L47.333%2045.3334Z'%20stroke='%23FF0000'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M27.333%2025.3333L56.6663%2054.6666'%20stroke='%23FF0000'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e")}`, MR = "._container_1mtmn_1{display:flex;position:relative;flex:1}._video_1mtmn_7{position:absolute;background-color:#fff;width:100%;height:100%;object-fit:contain}", bR = "._announcer_1qj2e_1{position:absolute;width:1px;height:1px;margin:-1px;padding:0;overflow:hidden;clip:rect(0 0 0 0);border:0}", OV = "Подготовка камеры...", yV = "Тайм-аут", NV = "Нет фокусировки камеры", LV = "Что-то пошло не так", MV = "Камера с заданным ID не найдена.", bV = "Готово!", PV = "Камера недоступна!", wV = "Версия вашего браузера не поддерживается", HV = "HTTPS не используется", VV = "Небезопасный контекст", kV = "Лицензия не найдена или недействительна", FV = "Файл поврежден или не поддерживается", xV = "Размер загружаемого файла слишком велик", UV = "Поместите документ в рамку", BV = "Держите документ прямо", $V = "Избегайте бликов на документе", GV = "Повторите попытку", ZV = "Отсутствует камера", jV = "Расположите документ в центре", zV = "Загрузите фото", qV = "Подвиньтесь ближе", WV = "Держите устройство неподвижно", YV = "Камера", KV = "Перейдите к мобильному устройству", XV = "Откройте камеру мобильного устройства, отсканируйте QR-код и перейдите по ссылке", QV = "Пожалуйста, подождите…", JV = "Мобильное устройство", ek = "Проверка документа, удостоверяющего личность", tk = "Сделайте снимок документа камерой компьютера, загрузите из файлов или отсканируйте с мобильного устройства", rk = "Сделайте снимок документа камерой компьютера или загрузите из файлов", nk = "Сделайте снимок документа камерой компьютера или отсканируйте с мобильного устройства", ik = "Загрузите документ из файлов или отсканируйте его с мобильного устройства", ak = "Воспользуйтесь камерой компьютера, чтобы сделать снимок документа", ok = "Выберите документ из файлов и загрузите его", sk = "Воспользуйтесь камерой мобильного устройства, чтобы сделать снимок документа", lk = "Сделайте снимок документа камерой мобильного устройства или загрузите из галереи", ck = "Выберите документ из галереи и загрузите его", uk = "Галерея", fk = "Файлы", dk = "Вернитесь к компьютеру", pk = "Ваш документ захвачен", hk = "или", mk = "Нажмите сюда, чтобы продолжить в браузере", _k = "Пропустить", Ek = "Переверните документ", Ck = "Наклоните документ", Sk = {
  preparingCamera: OV,
  timeout: yV,
  noFocus: NV,
  somethingWentWrong: LV,
  incorrectCameraId: MV,
  done: bV,
  cameraUnavailable: PV,
  versionNotSupported: wV,
  httpNotSupported: HV,
  insecurePageContext: VV,
  badLicense: kV,
  fileCorrupt: FV,
  largeFile: xV,
  placeDocumentIntoFrame: UV,
  holdDocumentStraight: BV,
  glaresOnDocument: $V,
  tryAgain: GV,
  noCameraAvailable: ZV,
  positionDocumentCenter: jV,
  uploadPhoto: zV,
  moveCloser: qV,
  keepDeviceStill: WV,
  camera: YV,
  switchToMobile: KV,
  openPhoneCamera: XV,
  pleaseWait: QV,
  mobileDevice: JV,
  verifyYourIdentity: ek,
  fromCameraFilesMobileDesktop: tk,
  fromCameraFilesDesktop: rk,
  fromCameraMobileDesktop: nk,
  fromFilesMobileDesktop: ik,
  fromCameraDesktop: ak,
  fromFilesDesktop: ok,
  fromMobileDesktop: sk,
  fromCameraGalleryMobile: lk,
  fromGalleryMobile: ck,
  gallery: uk,
  files: fk,
  returnToComputer: dk,
  documentCaptured: pk,
  or: hk,
  continueInBrowser: mk,
  skip: _k,
  flipTheDocument: Ek,
  tiltTheDocument: Ck
}, Ik = "Preparing the camera...", vk = "Timeout", gk = "No camera focus", Dk = "Something went wrong", Rk = "No camera with the specified ID found.", Ak = "Done!", Tk = "Camera unavailable!", Ok = "Your browser version is not supported", yk = "HTTPS not used", Nk = "Insecure context", Lk = "The license cannot be found or has expired", Mk = "This file is corrupt or not supported", bk = "This file is too large to be uploaded", Pk = "Fit the document into the frame", wk = "Hold the document straight", Hk = "Avoid glare on the document", Vk = "Try again", kk = "No camera available", Fk = "Position the document in the center", xk = "Upload a photo", Uk = "Move closer", Bk = "Hold the device still", $k = "Camera", Gk = "Switch to mobile", Zk = "Open the camera on your mobile device, scan the QR code, and follow the link", jk = "Please wait...", zk = "Mobile device", qk = "Identity document verification", Wk = "Capture a document using the computer’s camera, upload it from files, or scan it on a mobile device", Yk = "Capture a document using the computer’s camera or upload it from files", Kk = "Capture a document using the computer’s camera or scan it on a mobile device", Xk = "Upload a document from files or scan it on a mobile device", Qk = "Use the computer's camera to capture a document", Jk = "Pick a document from files and upload it", eF = "Use your mobile camera to capture a document", tF = "Capture a document using the mobile's camera or upload it from gallery", rF = "Pick a document from the gallery and upload it", nF = "Gallery", iF = "Files", aF = "Return to the computer", oF = "Your document has been captured", sF = "or", lF = "Click here to continue in browser", cF = "Skip", uF = "Flip the document", fF = "Tilt the document", dF = {
  preparingCamera: Ik,
  timeout: vk,
  noFocus: gk,
  somethingWentWrong: Dk,
  incorrectCameraId: Rk,
  done: Ak,
  cameraUnavailable: Tk,
  versionNotSupported: Ok,
  httpNotSupported: yk,
  insecurePageContext: Nk,
  badLicense: Lk,
  fileCorrupt: Mk,
  largeFile: bk,
  placeDocumentIntoFrame: Pk,
  holdDocumentStraight: wk,
  glaresOnDocument: Hk,
  tryAgain: Vk,
  noCameraAvailable: kk,
  positionDocumentCenter: Fk,
  uploadPhoto: xk,
  moveCloser: Uk,
  keepDeviceStill: Bk,
  camera: $k,
  switchToMobile: Gk,
  openPhoneCamera: Zk,
  pleaseWait: jk,
  mobileDevice: zk,
  verifyYourIdentity: qk,
  fromCameraFilesMobileDesktop: Wk,
  fromCameraFilesDesktop: Yk,
  fromCameraMobileDesktop: Kk,
  fromFilesMobileDesktop: Xk,
  fromCameraDesktop: Qk,
  fromFilesDesktop: Jk,
  fromMobileDesktop: eF,
  fromCameraGalleryMobile: tF,
  fromGalleryMobile: rF,
  gallery: nF,
  files: iF,
  returnToComputer: aF,
  documentCaptured: oF,
  or: sF,
  continueInBrowser: lF,
  skip: cF,
  flipTheDocument: uF,
  tiltTheDocument: fF
}, pF = "Kamera wird vorbereitet...", hF = "Timeout", mF = "Kein Kamerafokus", _F = "Etwas ist schief gelaufen", EF = "Keine Kamera mit angegebener ID gefunden", CF = "Fertig!", SF = "Kamera nicht verfügbar!", IF = "Ihre Browserversion wird nicht unterstützt", vF = "HTTPS nicht verwendet", gF = "Unsicherer Kontext", DF = "Die Lizenz kann nicht gefunden werden oder ist abgelaufen", RF = "Diese Datei ist beschädigt oder wird nicht unterstützt", AF = "Diese Datei ist zu groß, um hochgeladen zu werden", TF = "Passen Sie das Dokument in den Rahmen ein", OF = "Halten Sie das Dokument gerade", yF = "Vermeiden Sie Blendungen auf dem Dokument", NF = "Erneut versuchen", LF = "Keine Kamera vorhanden", MF = "Positionieren Sie das Dokument in der Mitte", bF = "Foto hochladen", PF = "Näher an die Kamera", wF = "Halten Sie das Gerät still", HF = "Kamera", VF = "Wechseln Sie zurück zum Smartphone", kF = "Öffnen Sie die Kamera auf Ihrem mobilen Gerät, scannen Sie den QR-Code und folgen Sie dem Link", FF = "Bitte warten...", xF = "Mobiles Gerät", UF = "Verifizierung von Ausweisdokumenten", BF = "Erfassen Sie ein Dokument mit der Computerkamera, laden Sie es aus Dateien hoch oder scannen Sie es mit einem mobilen Gerät", $F = "Erfassen Sie ein Dokument mit der Kamera des Computers oder laden Sie es als Datei hoch", GF = "Erfassen Sie ein Dokument mit der Kamera des Computers oder scannen Sie es mit einem mobilen Gerät ein.", ZF = "Laden Sie ein Dokument aus den Dateien oder scannen Sie es mit einem mobilen Gerät", jF = "Verwenden Sie die Kamera des Computers, um ein Dokument zu erfassen", zF = "Wählen Sie ein Dokument aus den Dateien aus und laden Sie es hoch", qF = "Verwenden Sie Ihre Smartphone-Kamera, um ein Dokument zu erfassen", WF = "Erfassen Sie ein Dokument mit der Kamera des Smartphones oder laden Sie es aus der Galerie hoch.", YF = "Wählen Sie ein Dokument aus der Galerie und laden Sie es hoch", KF = "Galerie", XF = "Dateien", QF = "Kehren Sie zum Computer zurück", JF = "Ihr Dokument wurde erfasst", ex = "oder", tx = "Klicken Sie hier, um im Browser fortzufahren", rx = "Überspringen", nx = "Dokument drehen", ix = "Kippen Sie das Dokument", ax = {
  preparingCamera: pF,
  timeout: hF,
  noFocus: mF,
  somethingWentWrong: _F,
  incorrectCameraId: EF,
  done: CF,
  cameraUnavailable: SF,
  versionNotSupported: IF,
  httpNotSupported: vF,
  insecurePageContext: gF,
  badLicense: DF,
  fileCorrupt: RF,
  largeFile: AF,
  placeDocumentIntoFrame: TF,
  holdDocumentStraight: OF,
  glaresOnDocument: yF,
  tryAgain: NF,
  noCameraAvailable: LF,
  positionDocumentCenter: MF,
  uploadPhoto: bF,
  moveCloser: PF,
  keepDeviceStill: wF,
  camera: HF,
  switchToMobile: VF,
  openPhoneCamera: kF,
  pleaseWait: FF,
  mobileDevice: xF,
  verifyYourIdentity: UF,
  fromCameraFilesMobileDesktop: BF,
  fromCameraFilesDesktop: $F,
  fromCameraMobileDesktop: GF,
  fromFilesMobileDesktop: ZF,
  fromCameraDesktop: jF,
  fromFilesDesktop: zF,
  fromMobileDesktop: qF,
  fromCameraGalleryMobile: WF,
  fromGalleryMobile: YF,
  gallery: KF,
  files: XF,
  returnToComputer: QF,
  documentCaptured: JF,
  or: ex,
  continueInBrowser: tx,
  skip: rx,
  flipTheDocument: nx,
  tiltTheDocument: ix
}, ox = "Przygotowywanie kamery...", sx = "Limit czasu", lx = "Brak ostrości", cx = "Coś poszło nie tak", ux = "Nie znaleziono kamery o podanym ID", fx = "Gotowe!", dx = "Aparat jest niedostępny!", px = "Twoja wersja przeglądarki nie jest obsługiwana", hx = "HTTPS nie jest wykorzystywany", mx = "Niebezpieczny kontekst", _x = "Licencja nie została znaleziona lub jest nieważna", Ex = "Plik jest uszkodzony albo nie jest obsługiwany", Cx = "Rozmiar ładowanego pliku jest zbyt duży", Sx = "Dopasuj dokument do ramki", Ix = "Trzymaj urządzenie prosto", vx = "Unikaj oślepiania dokumentu", gx = "Powtórz próbę", Dx = "Brak aparatu", Rx = "Umieść dokument pośrodku", Ax = "Załaduj zdjęcie", Tx = "Przysuń się bliżej", Ox = "Trzymaj urządzenie nieruchomo", yx = "Kamera", Nx = "Przekaż na urządzenie mobilne", Lx = "Włącz aparat urządzenia mobilnego, zeskanuj kod QR i skorzystaj z linku", Mx = "Czekaj…", bx = "Urządzenie mobilne", Px = "Weryfikacja dokumentu tożsamości", wx = "Zrób zdjęcie dokumentu przy pomocy kamery komputera, prześlij z plików lub zeskanuj urządzeniem mobilnym", Hx = "Zrób zdjęcie dokumentu przy pomocy kamery komputera albo prześlij z plików", Vx = "Zrób zdjęcie dokumentu przy pomocy kamery komputera albo zeskanuj urządzeniem mobilnym", kx = "Prześlij dokument z plików albo zeskanuj urządzeniem mobilnym", Fx = "Użyj kamery komputera, aby zrobić zdjęcie dokumentu", xx = "Wybierz dokument z plików i prześlij go", Ux = "Użyj aparatu urządzenia mobilnego, aby zrobić zdjęcie dokumentu", Bx = "Zrób zdjęcie dokumentu przy pomocy kamery komputera albo prześlij z galerii", $x = "Wybierz dokument z galerii i prześlj go", Gx = "Galeria", Zx = "Pliki", jx = "Wróć do komputera", zx = "Dokument został uchwycony", qx = "albo", Wx = "Naciśnij tutaj, żeby kontynuować w przeglądare", Yx = "Pomiń", Kx = "Odwróć dokument", Xx = "Pochyl dokument", Qx = {
  preparingCamera: ox,
  timeout: sx,
  noFocus: lx,
  somethingWentWrong: cx,
  incorrectCameraId: ux,
  done: fx,
  cameraUnavailable: dx,
  versionNotSupported: px,
  httpNotSupported: hx,
  insecurePageContext: mx,
  badLicense: _x,
  fileCorrupt: Ex,
  largeFile: Cx,
  placeDocumentIntoFrame: Sx,
  holdDocumentStraight: Ix,
  glaresOnDocument: vx,
  tryAgain: gx,
  noCameraAvailable: Dx,
  positionDocumentCenter: Rx,
  uploadPhoto: Ax,
  moveCloser: Tx,
  keepDeviceStill: Ox,
  camera: yx,
  switchToMobile: Nx,
  openPhoneCamera: Lx,
  pleaseWait: Mx,
  mobileDevice: bx,
  verifyYourIdentity: Px,
  fromCameraFilesMobileDesktop: wx,
  fromCameraFilesDesktop: Hx,
  fromCameraMobileDesktop: Vx,
  fromFilesMobileDesktop: kx,
  fromCameraDesktop: Fx,
  fromFilesDesktop: xx,
  fromMobileDesktop: Ux,
  fromCameraGalleryMobile: Bx,
  fromGalleryMobile: $x,
  gallery: Gx,
  files: Zx,
  returnToComputer: jx,
  documentCaptured: zx,
  or: qx,
  continueInBrowser: Wx,
  skip: Yx,
  flipTheDocument: Kx,
  tiltTheDocument: Xx
}, Jx = "Preparazione della fotocamera in corso...", eU = "Timeout", tU = "Nessuna messa a fuoco della fotocamera", rU = "Qualcosa è andato storto", nU = "Nessuna telecamera trovata con l'ID specificato", iU = "Fatto!", aU = "Fotocamera non disponibile!", oU = "La versione del tuo browser non è supportata", sU = "HTTPS non utilizzato", lU = "Contesto incerto", cU = "La licenza non è stata trovata o è scaduta", uU = "Questo file è danneggiato o non supportato", fU = "Questo file è troppo grande per essere caricato", dU = "Adatta il documento alla cornice", pU = "Tieni il documento dritto", hU = "Evita il riflesso sul documento", mU = "Prova di nuovo", _U = "Non c'è la fotocamera", EU = "Posiziona il documento al centro", CU = "Carica una foto", SU = "Avvicinati", IU = "Tieni fermo il dispositivo", vU = "Fotocamera", gU = "Passa al cellulare", DU = "Apri la fotocamera del tuo dispositivo mobile, scansiona il codice QR e segui il collegamento", RU = "Attendere prego…", AU = "Dispositivo mobile", TU = "Verifica del documento di identità", OU = "Acquisisci un documento utilizzando la fotocamera del computer, caricalo da file o scansionalo su un dispositivo mobile", yU = "Acquisisci un documento utilizzando la fotocamera del computer o caricalo dai file", NU = "Acquisisci un documento utilizzando la fotocamera del computer o scansionalo su un dispositivo mobile", LU = "Carica un documento da file o scansionalo su un dispositivo mobile", MU = "Utilizza la fotocamera del computer per acquisire un documento", bU = "Scegli un documento dai file e caricalo", PU = "Utilizza la fotocamera del tuo cellulare per acquisire un documento", wU = "Acquisisci un documento utilizzando la fotocamera del dispositivo mobile o caricalo dalla galleria", HU = "Scegli un documento dalla galleria e caricalo", VU = "Galleria", kU = "File", FU = "Ritorna al computer", xU = "Il tuo documento è stato acquisito", UU = "o", BU = "Clicca qui per continuare nel browser", $U = "Salta", GU = "Capovolgi il documento", ZU = "Inclina il documento", jU = {
  preparingCamera: Jx,
  timeout: eU,
  noFocus: tU,
  somethingWentWrong: rU,
  incorrectCameraId: nU,
  done: iU,
  cameraUnavailable: aU,
  versionNotSupported: oU,
  httpNotSupported: sU,
  insecurePageContext: lU,
  badLicense: cU,
  fileCorrupt: uU,
  largeFile: fU,
  placeDocumentIntoFrame: dU,
  holdDocumentStraight: pU,
  glaresOnDocument: hU,
  tryAgain: mU,
  noCameraAvailable: _U,
  positionDocumentCenter: EU,
  uploadPhoto: CU,
  moveCloser: SU,
  keepDeviceStill: IU,
  camera: vU,
  switchToMobile: gU,
  openPhoneCamera: DU,
  pleaseWait: RU,
  mobileDevice: AU,
  verifyYourIdentity: TU,
  fromCameraFilesMobileDesktop: OU,
  fromCameraFilesDesktop: yU,
  fromCameraMobileDesktop: NU,
  fromFilesMobileDesktop: LU,
  fromCameraDesktop: MU,
  fromFilesDesktop: bU,
  fromMobileDesktop: PU,
  fromCameraGalleryMobile: wU,
  fromGalleryMobile: HU,
  gallery: VU,
  files: kU,
  returnToComputer: FU,
  documentCaptured: xU,
  or: UU,
  continueInBrowser: BU,
  skip: $U,
  flipTheDocument: GU,
  tiltTheDocument: ZU
}, zU = "A kamera előkészítése...", qU = "Időkorlát", WU = "Nem fókuszál a kamera", YU = "Valami félresikerült", KU = "Nem található ilyen azonosítójú kamera", XU = "Kész!", QU = "Nem érhető el kamera!", JU = "Nem támogatott a böngésző verziója", eB = "HTTPS nincs használatban", tB = "Bizonytalan kontextus", rB = "Nem található vagy lejárt az engedély", nB = "Ez a fájl sérült vagy nem támogatott", iB = "A feltöltendő fájl túl nagy", aB = "Igazítsa a dokumentumot a keretbe", oB = "A készüléket tartsa mozdulatlanul", sB = "Kerülje a fény megcsillanását a dokumentumon", lB = "Próbálja újra", cB = "Nincs kamera", uB = "Helyezze az okiratot középre", fB = "Fénykép feltöltése", dB = "Vigye közelebb", pB = "A készüléket tartsa mozdulatlanul", hB = "Kamera", mB = "Váltás mobilra", _B = "Nyissa meg a kamerát mobilkészülékén, olvassa be a QR-kódot, és kövesse a hivatkozást", EB = "Please wait...", CB = "Mobilkészülék", SB = "Személyazonosító okirat ellenőrzése", IB = "Fotózzon le egy okiratot a számítógépe kamerájával, töltse fel a fájlok közül, vagy olvassa be egy mobilkészülékkel", vB = "Fotózzon le egy okiratot a számítógépe kamerájával, vagy töltse fel a fájlok közül", gB = "Fotózzon le egy okiratot a számítógépe kamerájával, vagy olvassa be egy mobilkészülékkel", DB = "Töltsön fel egy okiratot a fájlok közül, vagy olvassa be egy mobilkészülékkel", RB = "Használja a számítógép kameráját egy okirat beolvasására", AB = "Válasszon egy okiratot a fájlok közül, és töltse fel", TB = "Használja a mobilja kameráját egy okirat beolvasására", OB = "Fotózzon le egy okiratot a mobilja kamerájával, vagy töltse fel a galériából", yB = "Válasszon egy okiratot a galériából, és töltse fel", NB = "Galéria", LB = "Fájlok", MB = "Vissza a számítógépre", bB = "Lefényképeztük az okiratát", PB = "vagy", wB = "Kattinson ide a böngészőben történő folytatáshoz", HB = "Kihagyás", VB = "Fordítsa meg az okiratot", kB = "Döntse meg az okiratot!", FB = {
  preparingCamera: zU,
  timeout: qU,
  noFocus: WU,
  somethingWentWrong: YU,
  incorrectCameraId: KU,
  done: XU,
  cameraUnavailable: QU,
  versionNotSupported: JU,
  httpNotSupported: eB,
  insecurePageContext: tB,
  badLicense: rB,
  fileCorrupt: nB,
  largeFile: iB,
  placeDocumentIntoFrame: aB,
  holdDocumentStraight: oB,
  glaresOnDocument: sB,
  tryAgain: lB,
  noCameraAvailable: cB,
  positionDocumentCenter: uB,
  uploadPhoto: fB,
  moveCloser: dB,
  keepDeviceStill: pB,
  camera: hB,
  switchToMobile: mB,
  openPhoneCamera: _B,
  pleaseWait: EB,
  mobileDevice: CB,
  verifyYourIdentity: SB,
  fromCameraFilesMobileDesktop: IB,
  fromCameraFilesDesktop: vB,
  fromCameraMobileDesktop: gB,
  fromFilesMobileDesktop: DB,
  fromCameraDesktop: RB,
  fromFilesDesktop: AB,
  fromMobileDesktop: TB,
  fromCameraGalleryMobile: OB,
  fromGalleryMobile: yB,
  gallery: NB,
  files: LB,
  returnToComputer: MB,
  documentCaptured: bB,
  or: PB,
  continueInBrowser: wB,
  skip: HB,
  flipTheDocument: VB,
  tiltTheDocument: kB
}, xB = "正在准备相机", UB = "超时", BB = "没有摄像头对焦", $B = "出了问题", GB = "未找到具有指定 ID 的像机", ZB = "完成！", jB = "相机不可用！", zB = "不支持您的浏览器版本", qB = "未使用 HTTPS", WB = "不安全的环境", YB = "无法找到许可证或已过期", KB = "该文件已损坏或不被支持", XB = "该文件太大，无法上传", QB = "对准证件使其在框中", JB = "保持证件直接", e$ = "避免证件的反射过强的光", t$ = "再试一次", r$ = "没有相机", n$ = "将证件置于中心", i$ = "上传一张照片", a$ = "靠近点", o$ = "保持设备固定，不要移动", s$ = "相机", l$ = "切换到移动设备", c$ = "打开移动设备上的相机，扫描二维码，并点击链接", u$ = "请等待...", f$ = "移动设备", d$ = "身份证明文件验证", p$ = "使用电脑的摄像头拍摄证件，上传它或使用移动设备扫描文件", h$ = "使用电脑的摄像头拍摄证件或者把文件上传", m$ = "使用电脑的摄像头拍摄证件的照片或使用移动设备扫描它", _$ = "从文件中上传证件或使用移动设备扫描证件", E$ = "使用电脑的摄像头拍摄证件", C$ = "从文件中选择一个证件并上传", S$ = "使用手机摄像头拍摄证件", I$ = "使用手机相机拍摄证件或从图库上传", v$ = "从图库中选择一个证件并上传", g$ = "图库", D$ = "文件", R$ = "返回电脑", A$ = "您的文件已被捕获", T$ = "或者", O$ = "点击此处继续在浏览器中操作", y$ = "跳跃", N$ = "翻转证件", L$ = "请倾斜证件", M$ = {
  preparingCamera: xB,
  timeout: UB,
  noFocus: BB,
  somethingWentWrong: $B,
  incorrectCameraId: GB,
  done: ZB,
  cameraUnavailable: jB,
  versionNotSupported: zB,
  httpNotSupported: qB,
  insecurePageContext: WB,
  badLicense: YB,
  fileCorrupt: KB,
  largeFile: XB,
  placeDocumentIntoFrame: QB,
  holdDocumentStraight: JB,
  glaresOnDocument: e$,
  tryAgain: t$,
  noCameraAvailable: r$,
  positionDocumentCenter: n$,
  uploadPhoto: i$,
  moveCloser: a$,
  keepDeviceStill: o$,
  camera: s$,
  switchToMobile: l$,
  openPhoneCamera: c$,
  pleaseWait: u$,
  mobileDevice: f$,
  verifyYourIdentity: d$,
  fromCameraFilesMobileDesktop: p$,
  fromCameraFilesDesktop: h$,
  fromCameraMobileDesktop: m$,
  fromFilesMobileDesktop: _$,
  fromCameraDesktop: E$,
  fromFilesDesktop: C$,
  fromMobileDesktop: S$,
  fromCameraGalleryMobile: I$,
  fromGalleryMobile: v$,
  gallery: g$,
  files: D$,
  returnToComputer: R$,
  documentCaptured: A$,
  or: T$,
  continueInBrowser: O$,
  skip: y$,
  flipTheDocument: N$,
  tiltTheDocument: L$
}, b$ = "Príprava fotoaparátu...", P$ = "Čas vypršal", w$ = "Žiadne zaostrenie fotoaparátu", H$ = "Niečo sa pokazilo", V$ = "Nenašiel sa žiadny fotoaparát s určeným ID", k$ = "Hotovo!", F$ = "Fotoaparát je nedostupný!", x$ = "Verzia vášho prehliadača nie je podporovaná", U$ = "HTPPS nepoužité", B$ = "Neistý kontext", $$ = "Licenciu nie je možné nájsť, prípadne už nie je platná", G$ = "Súbor je poškodený, prípadne nie je podporovaný", Z$ = "Súbor je príliš veľký na odovzdávanie", j$ = "Vložte dokument do rámu", z$ = "Držte dokument rovno", q$ = "Vyhnite sa odleskom na dokumente", W$ = "Skúste to znova", Y$ = "Žiadny fotoaparát", K$ = "Umiestnite dokument do stredu", X$ = "Odovzdať fotografiu", Q$ = "Posuňte bližšie", J$ = "Držte zariadenie nehybne", eG = "Fotoaparát", tG = "Prepnúť na mobil", rG = "Otvorte na svojom mobilnom zariadení fotoaparát, neskenujte QR kód a otvorte odkaz", nG = "Please wait...", iG = "Mobilné zariadenie", aG = "Overenie dokladu totožnosti", oG = "Nasnímajte dokument pomocou kamery počítača, nahrajte ho zo súborov alebo naskenujte na mobilnom zariadení", sG = "Nasnímajte dokument pomocou kamery počítača, prípadne ho nahrajte zo súborov", lG = "Nasnímajte dokument pomocou kamery počítača, prípadne ho naskenujte na mobilnom zariadení", cG = "Nahrajte dokument zo súborov, prípadne ho naskenujte na mobilnom zariadení", uG = "Pomocou kamery počítača nasnímajte dokument", fG = "Vyberte dokument spomedzi súborov a nahrajte ho", dG = "Pomocou fotoaparátu mobilu nasnímajte dokument", pG = "Nasnímajte dokument pomocou fotoaparátu mobilu, prípadne ho nahrajte z galérie", hG = "Vyberte dokument v galérii a nahrajte ho", mG = "Galéria", _G = "Súbory", EG = "Návrat na počítač", CG = "Váš dokument bol nasnímaný", SG = "alebo", IG = "Kliknutím sem pokračujte v prehliadači", vG = "Preskočiť", gG = "Prevrátiť dokument", DG = "Nakloniť dokument", RG = {
  preparingCamera: b$,
  timeout: P$,
  noFocus: w$,
  somethingWentWrong: H$,
  incorrectCameraId: V$,
  done: k$,
  cameraUnavailable: F$,
  versionNotSupported: x$,
  httpNotSupported: U$,
  insecurePageContext: B$,
  badLicense: $$,
  fileCorrupt: G$,
  largeFile: Z$,
  placeDocumentIntoFrame: j$,
  holdDocumentStraight: z$,
  glaresOnDocument: q$,
  tryAgain: W$,
  noCameraAvailable: Y$,
  positionDocumentCenter: K$,
  uploadPhoto: X$,
  moveCloser: Q$,
  keepDeviceStill: J$,
  camera: eG,
  switchToMobile: tG,
  openPhoneCamera: rG,
  pleaseWait: nG,
  mobileDevice: iG,
  verifyYourIdentity: aG,
  fromCameraFilesMobileDesktop: oG,
  fromCameraFilesDesktop: sG,
  fromCameraMobileDesktop: lG,
  fromFilesMobileDesktop: cG,
  fromCameraDesktop: uG,
  fromFilesDesktop: fG,
  fromMobileDesktop: dG,
  fromCameraGalleryMobile: pG,
  fromGalleryMobile: hG,
  gallery: mG,
  files: _G,
  returnToComputer: EG,
  documentCaptured: CG,
  or: SG,
  continueInBrowser: IG,
  skip: vG,
  flipTheDocument: gG,
  tiltTheDocument: DG
}, AG = "Підготовка камери...", TG = "Тайм-аут", OG = "Немає фокусування камери", yG = "Щось пішло не так", NG = "Камеру з заданим ID не знайдено", LG = "Готово!", MG = "Камера недоступна!", bG = "Версія вашого браузера не підтримується", PG = "HTTPS не використовується", wG = "Небезпечний контекст", HG = "Ліцензію не знайдено або вона не є дійсною", VG = "Файл пошкоджено або він не підтримується", kG = "Розмір файлу, що завантажується, занадто великий", FG = "Помістіть документ в рамку", xG = "Тримайте документ прямо", UG = "Уникайте відблисків на документі", BG = "Спробуйте ще раз", $G = "Камера відсутня", GG = "Розташуйте документ у центрі", ZG = "Завантажте фото", jG = "Підсуньтеся ближче", zG = "Тримайте пристрій нерухомо", qG = "Камера", WG = "Перейдіть до мобільного пристрою", YG = "Відкрийте камеру мобільного пристрою, відскануйте QR-код і перейдіть за посиланням", KG = "Будь-ласка зачекайте…", XG = "Мобільний пристрій", QG = "Перевірка документа, що засвідчує особу", JG = "Зробіть знімок документа камерою комп'ютера, завантажте з файлів або відскануйте з мобільного пристрою", eZ = "Зробіть знімок документа камерою комп'ютера або завантажте з файлів", tZ = "Зробіть знімок документа камерою комп'ютера або відскануйте з мобільного пристрою", rZ = "Завантажте документ з файлів або відскануйте його з мобільного пристрою", nZ = "Скористайтеся камерою комп'ютера, щоб зробити знімок документа", iZ = "Оберіть документ з файлів і завантажте його", aZ = "Скористайтеся камерою мобільного пристрою, щоб зробити знімок документа", oZ = "Зробіть знімок документа камерою мобільного пристрою або завантажте з галереї", sZ = "Оберіть документ з галереї та завантажте його", lZ = "Галерея", cZ = "Файли", uZ = "Поверніться до комп'ютера", fZ = "Ваш документ захоплено", dZ = "або", pZ = "Натисніть сюди, щоб продовжити в браузері", hZ = "Пропустити", mZ = "Переверніть документ", _Z = "Нахиліть документ", EZ = {
  preparingCamera: AG,
  timeout: TG,
  noFocus: OG,
  somethingWentWrong: yG,
  incorrectCameraId: NG,
  done: LG,
  cameraUnavailable: MG,
  versionNotSupported: bG,
  httpNotSupported: PG,
  insecurePageContext: wG,
  badLicense: HG,
  fileCorrupt: VG,
  largeFile: kG,
  placeDocumentIntoFrame: FG,
  holdDocumentStraight: xG,
  glaresOnDocument: UG,
  tryAgain: BG,
  noCameraAvailable: $G,
  positionDocumentCenter: GG,
  uploadPhoto: ZG,
  moveCloser: jG,
  keepDeviceStill: zG,
  camera: qG,
  switchToMobile: WG,
  openPhoneCamera: YG,
  pleaseWait: KG,
  mobileDevice: XG,
  verifyYourIdentity: QG,
  fromCameraFilesMobileDesktop: JG,
  fromCameraFilesDesktop: eZ,
  fromCameraMobileDesktop: tZ,
  fromFilesMobileDesktop: rZ,
  fromCameraDesktop: nZ,
  fromFilesDesktop: iZ,
  fromMobileDesktop: aZ,
  fromCameraGalleryMobile: oZ,
  fromGalleryMobile: sZ,
  gallery: lZ,
  files: cZ,
  returnToComputer: uZ,
  documentCaptured: fZ,
  or: dZ,
  continueInBrowser: pZ,
  skip: hZ,
  flipTheDocument: mZ,
  tiltTheDocument: _Z
}, CZ = "Caméra en préparation...", SZ = "Délai d'expiration", IZ = "Caméra non focalisée", vZ = "Anomalie", gZ = "Aucune caméra ayant l'ID spécifié", DZ = "Terminé!", RZ = "Caméra indisponible!", AZ = "Version de navigateur non compatible", TZ = "HTTPS non utilis", OZ = "Contexte non sûr", yZ = "License introuvable ou expirée", NZ = "Fichier corrompu ou non supporté", LZ = "Fichier trop volumineux pour être transféré", MZ = "Ajuster le document dans le cadre", bZ = "Garder le document droit", PZ = "Eviter les reflets sur le document", wZ = "Réessayer", HZ = "Caméra introuvable", VZ = "Positionner le document au centre", kZ = "Envoyez une photo", FZ = "Rapprochez", xZ = "Maintenir l'appareil immobile", UZ = "Caméra", BZ = "Basculer vers le mobile", $Z = "Ouvrez la caméra de votre appareil mobile, scannez le QR-code, et suivez les instructions", GZ = "Veuillez patienter...", ZZ = "Appareil mobile", jZ = "Vérification du document d'identité", zZ = "Capturez un document avec la caméra de l'ordinateur, ouvrez-en un à partir d'un fichier, ou scannez-le avec un mobile", qZ = "Capturez un document avec la caméra de l'ordinateur, ou ouvrez-en un à partir d'un fichier", WZ = "Capturez un document avec la caméra de l'ordinateur, ou scannez-le avec un mobile", YZ = "Ouvrez un document à partir d'un fichier, ou scannez-le avec un mobile", KZ = "Utilisez la caméra de l'ordinateur pour capturer un document", XZ = "Ouvrez un document à partir d'un fichier", QZ = "Utilisez la caméra de votre mobile pour capturer un document", JZ = "Capturez un document avec la caméra de votre mobile, ou chargez-le à partir de la galerie", ej = "Chargez un document à partir de la galerie", tj = "Galerie", rj = "Fichiers", nj = "Retourner à l'ordinateur", ij = "Votre document a été capturé", aj = "ou", oj = "Cliquer ici pour continuer dans le navigateur", sj = "Sauter", lj = "Inverser le document", cj = "Incliner le document", uj = {
  preparingCamera: CZ,
  timeout: SZ,
  noFocus: IZ,
  somethingWentWrong: vZ,
  incorrectCameraId: gZ,
  done: DZ,
  cameraUnavailable: RZ,
  versionNotSupported: AZ,
  httpNotSupported: TZ,
  insecurePageContext: OZ,
  badLicense: yZ,
  fileCorrupt: NZ,
  largeFile: LZ,
  placeDocumentIntoFrame: MZ,
  holdDocumentStraight: bZ,
  glaresOnDocument: PZ,
  tryAgain: wZ,
  noCameraAvailable: HZ,
  positionDocumentCenter: VZ,
  uploadPhoto: kZ,
  moveCloser: FZ,
  keepDeviceStill: xZ,
  camera: UZ,
  switchToMobile: BZ,
  openPhoneCamera: $Z,
  pleaseWait: GZ,
  mobileDevice: ZZ,
  verifyYourIdentity: jZ,
  fromCameraFilesMobileDesktop: zZ,
  fromCameraFilesDesktop: qZ,
  fromCameraMobileDesktop: WZ,
  fromFilesMobileDesktop: YZ,
  fromCameraDesktop: KZ,
  fromFilesDesktop: XZ,
  fromMobileDesktop: QZ,
  fromCameraGalleryMobile: JZ,
  fromGalleryMobile: ej,
  gallery: tj,
  files: rj,
  returnToComputer: nj,
  documentCaptured: ij,
  or: aj,
  continueInBrowser: oj,
  skip: sj,
  flipTheDocument: lj,
  tiltTheDocument: cj
}, fj = "Preparando la cámara...", dj = "Tiempo de espera", pj = "No hay enfoque de la cámara", hj = "Algo salió mal", mj = "La cámara con el identificador especificado no encontrada", _j = "¡Hecho!", Ej = "¡Cámara no disponible!", Cj = "La versión de su navegador no es compatible", Sj = "HTTPS no utilizado", Ij = "Contexto inseguro", vj = "La licencia no se encuentra o ha expirado", gj = "Este archivo está dañado o no es compatible", Dj = "Este archivo es demasiado grande para cargarlo", Rj = "Encaje el documento en el marco", Aj = "Sostenga el documento recto", Tj = "Evite el brillo en el documento", Oj = "Inténtelo de nuevo", yj = "No hay cámara disponible", Nj = "Coloque el documento en el centro", Lj = "Suba una foto", Mj = "Acérquese", bj = "Sostenga el dispositivo quieto", Pj = "Cámara", wj = "Cámbiese al móvil", Hj = "Abra la cámara de su dispositivo móvil, escanee el código QR y siga el enlace", Vj = "Por favor espere...", kj = "Dispositivo móvil", Fj = "Verificación de documentos de identidad", xj = "Capture un documento utilizando la cámara del PC, escanéelo con un dispositivo móvil o cargue la imagen previamente capturada", Uj = "Capture un documento con la cámara del PC o cargue la imagen previamente capturada", Bj = "Capture un documento con la cámara del PC o escanéelo con un dispositivo móvil", $j = "Cargue una imagen de documento previamente capturada o escanee el documento con un dispositivo móvil", Gj = "Utilice la cámara del PC para capturar un documento", Zj = "Elige un documento de los archivos y cárgalo", jj = "Utilice la cámara de su móvil para capturar un documento", zj = "Capture un documento con la cámara de su móvil o súbalo desde la galería", qj = "Elija un documento de la galería y cárguelo", Wj = "Galería", Yj = "Archivos", Kj = "Regrese al PC", Xj = "Su documento ha sido capturado", Qj = "o", Jj = "Haga clic aquí para continuar en el navegador", ez = "Omitir", tz = "Déle la vuelta al documento", rz = "Incline el documento", nz = {
  preparingCamera: fj,
  timeout: dj,
  noFocus: pj,
  somethingWentWrong: hj,
  incorrectCameraId: mj,
  done: _j,
  cameraUnavailable: Ej,
  versionNotSupported: Cj,
  httpNotSupported: Sj,
  insecurePageContext: Ij,
  badLicense: vj,
  fileCorrupt: gj,
  largeFile: Dj,
  placeDocumentIntoFrame: Rj,
  holdDocumentStraight: Aj,
  glaresOnDocument: Tj,
  tryAgain: Oj,
  noCameraAvailable: yj,
  positionDocumentCenter: Nj,
  uploadPhoto: Lj,
  moveCloser: Mj,
  keepDeviceStill: bj,
  camera: Pj,
  switchToMobile: wj,
  openPhoneCamera: Hj,
  pleaseWait: Vj,
  mobileDevice: kj,
  verifyYourIdentity: Fj,
  fromCameraFilesMobileDesktop: xj,
  fromCameraFilesDesktop: Uj,
  fromCameraMobileDesktop: Bj,
  fromFilesMobileDesktop: $j,
  fromCameraDesktop: Gj,
  fromFilesDesktop: Zj,
  fromMobileDesktop: jj,
  fromCameraGalleryMobile: zj,
  fromGalleryMobile: qj,
  gallery: Wj,
  files: Yj,
  returnToComputer: Kj,
  documentCaptured: Xj,
  or: Qj,
  continueInBrowser: Jj,
  skip: ez,
  flipTheDocument: tz,
  tiltTheDocument: rz
}, iz = "Preparando a câmara...", az = "Tempo esgotado", oz = "Sem foco da câmara", sz = "Algo correu mal", lz = "Não foi encontrada nenhuma câmara com o ID especificado", cz = "Feito!", uz = "Câmara indisponível!", fz = "A versão do seu navegador não é compatível", dz = "HTTPS não utilizado", pz = "Contexto inseguro", hz = "A licença não pode ser encontrada ou expirou", mz = "Este arquivo está corrompido ou não é compatível", _z = "Este arquivo é muito grande para ser carregado", Ez = "Encaixe o documento no quadro", Cz = "Mantenha o dispositio reto", Sz = "Evite luz sobre o documento", Iz = "Tente outra vez", vz = "Não há câmara", gz = "Posicione o documento no centro", Dz = "Carregue uma foto", Rz = "Aproxime-se", Az = "Mantenha o dispositivo imóvel", Tz = "Câmera", Oz = "Mudar para o telemóvel", yz = "Abra a câmara do seu dispositivo móvel, leia o código QR e siga a ligação", Nz = "Aguarde...", Lz = "Dispositivo móvel", Mz = "Verificação de documento de identidade", bz = "Capture um documento utilizando a câmara do computador, carregue-o a partir de ficheiros ou digitalize-o num dispositivo móvel", Pz = "Capture um documento utilizando a câmara do computador ou carregue-o a partir de ficheiros", wz = "Capture um documento utilizando a câmara do computador ou digitalizá-lo com um dispositivo móvel", Hz = "Carregue um documento a partir de ficheiros ou digitalize-o num dispositivo móvel", Vz = "Utilize a câmara do computador para capturar um documento", kz = "Escolha um documento dos ficheiros e carregue-o", Fz = "Utilize a câmara do telemóvel para capturar um documento", xz = "Capture um documento utilizando a câmara do telemóvel ou carregue-o a partir da galeria", Uz = "Escolha um documento da galeria e carregue-o", Bz = "Galeria", $z = "Ficheiros", Gz = "Regressar ao computador", Zz = "O seu documento foi capturado", jz = "ou", zz = "Clique aqui para continuar no navegador", qz = "Omitir", Wz = "Vire o documento", Yz = "Incline o documento", Kz = {
  preparingCamera: iz,
  timeout: az,
  noFocus: oz,
  somethingWentWrong: sz,
  incorrectCameraId: lz,
  done: cz,
  cameraUnavailable: uz,
  versionNotSupported: fz,
  httpNotSupported: dz,
  insecurePageContext: pz,
  badLicense: hz,
  fileCorrupt: mz,
  largeFile: _z,
  placeDocumentIntoFrame: Ez,
  holdDocumentStraight: Cz,
  glaresOnDocument: Sz,
  tryAgain: Iz,
  noCameraAvailable: vz,
  positionDocumentCenter: gz,
  uploadPhoto: Dz,
  moveCloser: Rz,
  keepDeviceStill: Az,
  camera: Tz,
  switchToMobile: Oz,
  openPhoneCamera: yz,
  pleaseWait: Nz,
  mobileDevice: Lz,
  verifyYourIdentity: Mz,
  fromCameraFilesMobileDesktop: bz,
  fromCameraFilesDesktop: Pz,
  fromCameraMobileDesktop: wz,
  fromFilesMobileDesktop: Hz,
  fromCameraDesktop: Vz,
  fromFilesDesktop: kz,
  fromMobileDesktop: Fz,
  fromCameraGalleryMobile: xz,
  fromGalleryMobile: Uz,
  gallery: Bz,
  files: $z,
  returnToComputer: Gz,
  documentCaptured: Zz,
  or: jz,
  continueInBrowser: zz,
  skip: qz,
  flipTheDocument: Wz,
  tiltTheDocument: Yz
}, Xz = "تحضير الكاميرا...", Qz = "انتهاء المهلة", Jz = "لا يوجد تركيز الكاميرا", eq = "شيء سار على نحو خاطئ", tq = "لا يتم العثور على الكاميرا ذات المعرّف المحدد", rq = "تم!", nq = "الكاميرا غير متاحة!", iq = "إصدار المتصفح الخاص بك غير مدعوم", aq = "HTTPS غير مستخدم", oq = "سياق غير آمن", sq = "لا يتم العثور على الترخيص أو انتهت صلاحيته", lq = "هذا الملف تالف أو غير مدعوم", cq = "هذا الملف كبير جدًا بحيث لا يمكن تحميله", uq = "تأطير الوثيقة", fq = "أمسك الوثيقة بشكل مستقيم", dq = "تجنب الضوء على الوثيقة", pq = "حاول مرة أخرى", hq = "الكاميرا غير موجودة", mq = "ضع المستند في الوسط", _q = "حمّل الصورة", Eq = "إقترب أكثر", Cq = "أمسك الجهاز بشكل ثابت", Sq = "كاميرا", Iq = "تبديل إلى المحمول", vq = "افتح كاميرا جهازك المحمول، وامسح رمز QR، ثم اتبع الرابط", gq = "يرجى الانتظار...", Dq = "الجهاز المحمول", Rq = "التحقق من وثيقة الهوية", Aq = "التقط صورة للمستند باستخدام كاميرا الحاسوب، أو قم بتحميله من الملفات، أو قم بمسحه ضوئيًا باستخدام جهاز محمول", Tq = "التقط صورة للمستند باستخدام كاميرا الحاسوب أو قم بتحميله من الملفات", Oq = "التقط صورة للمستند باستخدام كاميرا الحاسوب أو قم بمسحه ضوئيًا باستخدام جهاز محمول", yq = "حمّل صورة للمستند من الملفات أو قم بمسحه ضوئيًا باستخدام جهاز محمول", Nq = "استخدم كاميرا الحاسوب لالتقاط صورة للمستند", Lq = "اختر مستندًا من الملفات وقم بتحميله", Mq = "استخدم كاميرا جهازك المحمول لالتقاط صورة للمستند", bq = "التقط صورة للمستند باستخدام كاميرا الجهاز المحمول أو قم بتحميله من معرض الصور", Pq = "اختر مستندًا من معرض الصور وقم بتحميله", wq = "معرض الصور", Hq = "الملفات", Vq = "عودة إلى الحاسوب", kq = "تم مسح مستندك بنجاح", Fq = "أو", xq = "اضغط هنا للمتابعة عبر المتصفح", Uq = "تخطى", Bq = "اقلب المستند", $q = "يرجى إمالة المستند", Gq = {
  preparingCamera: Xz,
  timeout: Qz,
  noFocus: Jz,
  somethingWentWrong: eq,
  incorrectCameraId: tq,
  done: rq,
  cameraUnavailable: nq,
  versionNotSupported: iq,
  httpNotSupported: aq,
  insecurePageContext: oq,
  badLicense: sq,
  fileCorrupt: lq,
  largeFile: cq,
  placeDocumentIntoFrame: uq,
  holdDocumentStraight: fq,
  glaresOnDocument: dq,
  tryAgain: pq,
  noCameraAvailable: hq,
  positionDocumentCenter: mq,
  uploadPhoto: _q,
  moveCloser: Eq,
  keepDeviceStill: Cq,
  camera: Sq,
  switchToMobile: Iq,
  openPhoneCamera: vq,
  pleaseWait: gq,
  mobileDevice: Dq,
  verifyYourIdentity: Rq,
  fromCameraFilesMobileDesktop: Aq,
  fromCameraFilesDesktop: Tq,
  fromCameraMobileDesktop: Oq,
  fromFilesMobileDesktop: yq,
  fromCameraDesktop: Nq,
  fromFilesDesktop: Lq,
  fromMobileDesktop: Mq,
  fromCameraGalleryMobile: bq,
  fromGalleryMobile: Pq,
  gallery: wq,
  files: Hq,
  returnToComputer: Vq,
  documentCaptured: kq,
  or: Fq,
  continueInBrowser: xq,
  skip: Uq,
  flipTheDocument: Bq,
  tiltTheDocument: $q
}, Zq = "De camera aan het voorbereiden...", jq = "Time-out", zq = "Geen camera-focus", qq = "Er ging iets fout", Wq = "Geen camera met de opgegeven ID gevonden", Yq = "Uitgevoerd!", Kq = "Camera onbeschikbaar!", Xq = "Uw browserversie wordt niet ondersteund", Qq = "HTTPS niet gebruikt", Jq = "Onzekere context", eW = "De licentie kan niet gevonden worden of is verlopen", tW = "Dit bestand is corrupt of wordt niet ondersteund", rW = "Dit bestand is te groot om geüpload te worden", nW = "Pas het document in het kader", iW = "Houd het document recht", aW = "Vermijd glans op het document", oW = "Probeer opnieuw", sW = "Er is geen camera", lW = "Plaats het document in het midden", cW = "Upload een foto", uW = "Kom dichter", fW = "Houd het toestel stil", dW = "Camera", pW = "Schakel over naar mobiel", hW = "Open de camera op uw mobiele apparaat, scan de QR-code en volg de link", mW = "Please wait...", _W = "Mobiel apparaat", EW = "Verificatie van identiteitsdocumenten", CW = "Leg een document vast met de camera van de computer, upload het vanuit bestanden of scan het op een mobiel apparaat", SW = "Leg een document vast met de camera van de computer of upload het vanuit bestanden", IW = "Leg een document vast met de camera van de computer of scan het op een mobiel apparaat", vW = "Upload een document of scan het op een mobiel apparaat", gW = "Gebruik de camera van de computer om een document vast te leggen", DW = "Kies een document uit bestanden en upload het", RW = "Gebruik een mobiele camera om een document vast te leggen", AW = "Leg een document vast met de mobiele camera of upload het vanuit de galerij", TW = "Kies een document uit de galerij en upload het", OW = "Galerij", yW = "Bestanden", NW = "Ga terug naar de computer", LW = "Uw document is vastgelegd", MW = "of", bW = "Klik hier om verder te gaan in de browser.", PW = "Sla over", wW = "Draai het document om", HW = "Kantel het document", VW = {
  preparingCamera: Zq,
  timeout: jq,
  noFocus: zq,
  somethingWentWrong: qq,
  incorrectCameraId: Wq,
  done: Yq,
  cameraUnavailable: Kq,
  versionNotSupported: Xq,
  httpNotSupported: Qq,
  insecurePageContext: Jq,
  badLicense: eW,
  fileCorrupt: tW,
  largeFile: rW,
  placeDocumentIntoFrame: nW,
  holdDocumentStraight: iW,
  glaresOnDocument: aW,
  tryAgain: oW,
  noCameraAvailable: sW,
  positionDocumentCenter: lW,
  uploadPhoto: cW,
  moveCloser: uW,
  keepDeviceStill: fW,
  camera: dW,
  switchToMobile: pW,
  openPhoneCamera: hW,
  pleaseWait: mW,
  mobileDevice: _W,
  verifyYourIdentity: EW,
  fromCameraFilesMobileDesktop: CW,
  fromCameraFilesDesktop: SW,
  fromCameraMobileDesktop: IW,
  fromFilesMobileDesktop: vW,
  fromCameraDesktop: gW,
  fromFilesDesktop: DW,
  fromMobileDesktop: RW,
  fromCameraGalleryMobile: AW,
  fromGalleryMobile: TW,
  gallery: OW,
  files: yW,
  returnToComputer: NW,
  documentCaptured: LW,
  or: MW,
  continueInBrowser: bW,
  skip: PW,
  flipTheDocument: wW,
  tiltTheDocument: HW
}, kW = "Menyiapkan kamera...", FW = "Batas waktu", xW = "Tidak ada fokus kamera", UW = "Terjadi kesalahan", BW = "Tidak ditemukan kamera dengan ID yang disebutkan", $W = "Selesai!", GW = "Kamera tidak tersedia!", ZW = "Versi browser Anda tidak didukung", jW = "HTTPS tidak digunakan", zW = "Konteks tidak aman", qW = "Lisensi tidak dapat ditemukan atau telah habis masa berlakunya", WW = "File ini rusak atau tidak didukung", YW = "File ini terlalu besar untuk diunggah", KW = "Sesuaikan dokumen dengan bingkainya", XW = "Tahan dokumen tatap lurus", QW = "Hindari pantulan cahaya pada dokumen", JW = "Coba lagi", eY = "Tidak ada kamera", tY = "Posisikan dokumen di tengah", rY = "Unggah foto", nY = "Geser mendekat", iY = "Tahan perangkat tetap diam", aY = "Kamera", oY = "Beralih ke seluler", sY = "Buka kamera pada perangkat seluler Anda, pindai kode QR, dan ikuti tautannya", lY = "Please wait...", cY = "Perangkat seluler", uY = "Verifikasi dokumen identitas", fY = "Ambil gambar dokumen menggunakan kamera komputer, unggah dari file, atau pindai pada perangkat seluler Anda", dY = "Ambil gambar dokumen menggunakan kamera komputer atau unggah dari file", pY = "Ambil gambar dokumen menggunakan kamera komputer atau pindah pada perangkat seluler", hY = "Unggah dokumen dari file atau pindai pada perangkat seluler", mY = "Gunakan kamera komputer untuk mengambil gambar dokumen", _Y = "Pilih dokumen dari file dan unggah", EY = "Gunakan kamera seluler Anda untuk menangkap gambar dokumen", CY = "Tangkap gambar dokumen menggunakan kamera seluler atau unggah dari galeri", SY = "Pilih dokumen dari galeri dan unggah", IY = "Galeri", vY = "File", gY = "Kembali ke komputer", DY = "Tangkapan layar dokumen telah diambil", RY = "atau", AY = "Klik di sini untuk melanjutkan di browser", TY = "Lewati", OY = "Putar balik dokumen", yY = "Miringkan dokumen", NY = {
  preparingCamera: kW,
  timeout: FW,
  noFocus: xW,
  somethingWentWrong: UW,
  incorrectCameraId: BW,
  done: $W,
  cameraUnavailable: GW,
  versionNotSupported: ZW,
  httpNotSupported: jW,
  insecurePageContext: zW,
  badLicense: qW,
  fileCorrupt: WW,
  largeFile: YW,
  placeDocumentIntoFrame: KW,
  holdDocumentStraight: XW,
  glaresOnDocument: QW,
  tryAgain: JW,
  noCameraAvailable: eY,
  positionDocumentCenter: tY,
  uploadPhoto: rY,
  moveCloser: nY,
  keepDeviceStill: iY,
  camera: aY,
  switchToMobile: oY,
  openPhoneCamera: sY,
  pleaseWait: lY,
  mobileDevice: cY,
  verifyYourIdentity: uY,
  fromCameraFilesMobileDesktop: fY,
  fromCameraFilesDesktop: dY,
  fromCameraMobileDesktop: pY,
  fromFilesMobileDesktop: hY,
  fromCameraDesktop: mY,
  fromFilesDesktop: _Y,
  fromMobileDesktop: EY,
  fromCameraGalleryMobile: CY,
  fromGalleryMobile: SY,
  gallery: IY,
  files: vY,
  returnToComputer: gY,
  documentCaptured: DY,
  or: RY,
  continueInBrowser: AY,
  skip: TY,
  flipTheDocument: OY,
  tiltTheDocument: yY
}, LY = "Đang chuẩn bị camera...", MY = "Thời gian chờ", bY = "Không có tiêu điểm camera", PY = "Có lỗi xảy ra", wY = "Không tìm thấy camera nào có ID đã nêu", HY = "Xong rồi!", VY = "Camera không có sẵn!", kY = "Phiên bản trình duyệt của bạn không được hỗ trợ", FY = "HTTPS không được sử dụng", xY = "Ngữ cảnh không bảo mật", UY = "Không tìm thấy giấy phép hoặc giấy phép đã hết hạn", BY = "Tệp này bị hỏng hoặc không được hỗ trợ", $Y = "Tệp này quá lớn để tải lên", GY = "Chỉnh giấy tờ nằm gọn trong khung", ZY = "Giữ cho giấy tờ được thẳng", jY = "Tránh cho giấy tờ bị lóe sáng", zY = "Thử lại", qY = "Không có camera", WY = "Đưa giấy tờ vào chính giữa", YY = "Tải ảnh lên", KY = "Di chuyển tới gần hơn", XY = "Giữ thiết bị ở nguyên vị trí", QY = "Camera", JY = "Chuyển qua di động", eK = "Bật camera trên thiết bị di động của bạn, quét mã QR và theo dõi liên kết", tK = "Please wait...", rK = "Thiết bị di động", nK = "Xác minh giấy tờ tuỳ thân", iK = "Chụp tài liệu bằng camera của máy tính, tải lên từ các tập tin hoặc quét trên một thiết bị di động", aK = "Chụp tài liệu bằng camera của máy tính hoặc tải lên từ các tập tin", oK = "Chụp tài liệu bằng camera của máy tính hoặc quét trên thiết bị di động", sK = "Tải lên tài liệu từ các tập tin hoặc quét trên một thiết bị di động", lK = "Sử dụng camera của máy tính để chụp một tài liệu", cK = "Chọn một tài liệu từ các tập tin và tải lên", uK = "Sử dụng camera của thiết bị di động của bạn để chụp một tài liệu", fK = "Chụp một tài liệu bằng camera của thiết bị di động hoặc tải lên từ thư viện", dK = "Chọn một tài liệu từ thư viện và tải lên", pK = "Thư viện", hK = "Tập tin", mK = "Quay trở lại máy tính", _K = "Tài liệu của bạn đã được chụp", EK = "hoặc", CK = "Nhấp vào đây để tiếp tục ở trình duyệt", SK = "Bỏ qua", IK = "Lật giấy tờ", vK = "Nghiêng tài liệu", gK = {
  preparingCamera: LY,
  timeout: MY,
  noFocus: bY,
  somethingWentWrong: PY,
  incorrectCameraId: wY,
  done: HY,
  cameraUnavailable: VY,
  versionNotSupported: kY,
  httpNotSupported: FY,
  insecurePageContext: xY,
  badLicense: UY,
  fileCorrupt: BY,
  largeFile: $Y,
  placeDocumentIntoFrame: GY,
  holdDocumentStraight: ZY,
  glaresOnDocument: jY,
  tryAgain: zY,
  noCameraAvailable: qY,
  positionDocumentCenter: WY,
  uploadPhoto: YY,
  moveCloser: KY,
  keepDeviceStill: XY,
  camera: QY,
  switchToMobile: JY,
  openPhoneCamera: eK,
  pleaseWait: tK,
  mobileDevice: rK,
  verifyYourIdentity: nK,
  fromCameraFilesMobileDesktop: iK,
  fromCameraFilesDesktop: aK,
  fromCameraMobileDesktop: oK,
  fromFilesMobileDesktop: sK,
  fromCameraDesktop: lK,
  fromFilesDesktop: cK,
  fromMobileDesktop: uK,
  fromCameraGalleryMobile: fK,
  fromGalleryMobile: dK,
  gallery: pK,
  files: hK,
  returnToComputer: mK,
  documentCaptured: _K,
  or: EK,
  continueInBrowser: CK,
  skip: SK,
  flipTheDocument: IK,
  tiltTheDocument: vK
}, DK = "카메라 준비 중...", RK = "시간 제한", AK = "카메라 초점", TK = "오류가 발생했습니다", OK = "지정된 ID가 있는 카메라를 찾을 수 없음", yK = "완료!", NK = "카메라를 사용할 수 없습니다!", LK = "사용 중인 브라우저는 지원되지 않습니다", MK = "HTTPS가 사용되지 않음", bK = "보안이 취약한 맥락", PK = "라이선스를 찾을 수 없거나 만료되었습니다", wK = "이 파일은 손상되었거나 지원되지 않습니다", HK = "이 파일은 대용량이어서 업로드할 수 없습니다", VK = "문서를 프레임에 맞춤", kK = "문서를 똑바로 놓으십시오", FK = "문서에서 눈부심을 피하십시오", xK = "다시 시도", UK = "카메라가 없습니다", BK = "문서를 가운데에 위치시키십시오", $K = "사진 업로드", GK = "더 가까이 이동", ZK = "장치를 꽉 잡으십시오", jK = "카메라", zK = "모바일로 전환", qK = "모바일 장치에서 카메라를 열고 QR 코드를 스캔한 후 링크를 따라가십시오", WK = "Please wait...", YK = "모바일 장치", KK = "ID 문서 검증", XK = "컴퓨터의 카메라를 사용하여 문서를 캡처하거나 파일에서 업로드하거나 모바일 장치에서 스캔하십시오", QK = "컴퓨터의 카메라를 사용하여 문서를 캡처하거나 파일에서 업로드하십시오", JK = "컴퓨터의 카메라를 사용하여 문서를 캡처하거나 모바일 장치에서 스캔하십시오", eX = "파일에서 문서를 업로드하거나 모바일 장치에서 스캔하십시오", tX = "컴퓨터의 카메라를 사용하여 문서를 캡처하십시오", rX = "파일에서 문서를 선택하여 업로드하십시오", nX = "모바일 카메라를 사용하여 문서를 캡처하십시오", iX = "모바일의 카메라를 사용하여 문서를 캡처하거나 갤러리에서 업로드하십시오", aX = "갤러리에서 문서를 선택하여 업로드하십시오", oX = "갤러리", sX = "파일", lX = "컴퓨터로 돌아가기", cX = "서류가 캡처되었습니다", uX = "또는", fX = "브라우저에서 계속하려면 여기를 클릭하세요", dX = "건너뛰기", pX = "문서를 뒤집으십시오", hX = "문서를 기울이십시오", mX = {
  preparingCamera: DK,
  timeout: RK,
  noFocus: AK,
  somethingWentWrong: TK,
  incorrectCameraId: OK,
  done: yK,
  cameraUnavailable: NK,
  versionNotSupported: LK,
  httpNotSupported: MK,
  insecurePageContext: bK,
  badLicense: PK,
  fileCorrupt: wK,
  largeFile: HK,
  placeDocumentIntoFrame: VK,
  holdDocumentStraight: kK,
  glaresOnDocument: FK,
  tryAgain: xK,
  noCameraAvailable: UK,
  positionDocumentCenter: BK,
  uploadPhoto: $K,
  moveCloser: GK,
  keepDeviceStill: ZK,
  camera: jK,
  switchToMobile: zK,
  openPhoneCamera: qK,
  pleaseWait: WK,
  mobileDevice: YK,
  verifyYourIdentity: KK,
  fromCameraFilesMobileDesktop: XK,
  fromCameraFilesDesktop: QK,
  fromCameraMobileDesktop: JK,
  fromFilesMobileDesktop: eX,
  fromCameraDesktop: tX,
  fromFilesDesktop: rX,
  fromMobileDesktop: nX,
  fromCameraGalleryMobile: iX,
  fromGalleryMobile: aX,
  gallery: oX,
  files: sX,
  returnToComputer: lX,
  documentCaptured: cX,
  or: uX,
  continueInBrowser: fX,
  skip: dX,
  flipTheDocument: pX,
  tiltTheDocument: hX
}, _X = "Menyediakan kamera...", EX = "Ralat masa", CX = "Tiada fokus kamera", SX = "Ada masalah", IX = "Tiada kamera dengan ID yang ditentukan ditemui", vX = "Selesai!", gX = "Kamera tidak tersedia!", DX = "Versi pelayar web anda tidak disokong", RX = "HTTPS tidak digunakan", AX = "Konteks tidak selamat", TX = "Lesen tidak dapat dicari atau telah tamat tempoh", OX = "Fail ini rosak atau tidak disokong", yX = "Fail ini terlalu besar untuk dimuat naik", NX = "Muatkan dokumen dalam bingkai", LX = "Pengang dokumen secara tegak", MX = "Elakan silau pada dokumen", bX = "Sila cuba lagi", PX = "Tiada kamera", wX = "Letakkan dokumen di tengah", HX = "Muat naik gambar", VX = "Dekatkan", kX = "Pegang peranti dengan tenang", FX = "Kamera", xX = "Beralih ke mudah alih", UX = "Buka kamera pada peranti mudah alih anda, imbas kod QR, dan ikuti pautan", BX = "Please wait...", $X = "Peranti mudah alih", GX = "Pengesahan dokumen identiti", ZX = "Tangkap gambar dokumen menggunakan kamera komputer, muat naik daripada fail atau imbas pada peranti mudah alih", jX = "Tangkap gambar dokumen menggunakan kamera komputer atau muat naik daripada fail", zX = "Tangkap gambar dokumen menggunakan kamera komputer atau imbas pada peranti mudah alih", qX = "Muat naik dokumen daripada fail atau imbas pada peranti mudah alih", WX = "Guna kamera komputer untuk menangkap gambar dokumen", YX = "Pilih dokumen daripada fail dan muat naik", KX = "Guna kamera mudah alih anda untuk menangkap gambar dokumen", XX = "Tangkap gambar dokumen dengan menggunakan kamera mudah alih atau muat naik daripada galeri", QX = "Pilih dokumen daripada galeri dan muat naik", JX = "Galeri", eQ = "Fail", tQ = "Kembali ke komputer", rQ = "Dokumen anda telah dirakam", nQ = "atau", iQ = "Klik sini untuk meneruskan dalam pelayar", aQ = "Langkau", oQ = "Terbalikkan dokumen", sQ = "Condongkan dokumen", lQ = {
  preparingCamera: _X,
  timeout: EX,
  noFocus: CX,
  somethingWentWrong: SX,
  incorrectCameraId: IX,
  done: vX,
  cameraUnavailable: gX,
  versionNotSupported: DX,
  httpNotSupported: RX,
  insecurePageContext: AX,
  badLicense: TX,
  fileCorrupt: OX,
  largeFile: yX,
  placeDocumentIntoFrame: NX,
  holdDocumentStraight: LX,
  glaresOnDocument: MX,
  tryAgain: bX,
  noCameraAvailable: PX,
  positionDocumentCenter: wX,
  uploadPhoto: HX,
  moveCloser: VX,
  keepDeviceStill: kX,
  camera: FX,
  switchToMobile: xX,
  openPhoneCamera: UX,
  pleaseWait: BX,
  mobileDevice: $X,
  verifyYourIdentity: GX,
  fromCameraFilesMobileDesktop: ZX,
  fromCameraFilesDesktop: jX,
  fromCameraMobileDesktop: zX,
  fromFilesMobileDesktop: qX,
  fromCameraDesktop: WX,
  fromFilesDesktop: YX,
  fromMobileDesktop: KX,
  fromCameraGalleryMobile: XX,
  fromGalleryMobile: QX,
  gallery: JX,
  files: eQ,
  returnToComputer: tQ,
  documentCaptured: rQ,
  or: nQ,
  continueInBrowser: iQ,
  skip: aQ,
  flipTheDocument: oQ,
  tiltTheDocument: sQ
}, cQ = "Se pregătește camera...", uQ = "Pauză", fQ = "Cameră nefocalizată", dQ = "Ceva n-a mers bine", pQ = "Nu a fost găsită nicio cameră cu ID-ul specificat", hQ = "Terminat!", mQ = "Camera foto indisponibilă!", _Q = "Versiunea browserului dvs. nu este acceptată", EQ = "Nu au fost utilizate HTTPS-uri", CQ = "Context nesigur", SQ = "Licența nu poate fi găsită sau a expirat", IQ = "Acest fișier este corupt sau nu este acceptat", vQ = "Fișierul este prea mare pentru a fi încărcat", gQ = "Încadrați documentul în cadru", DQ = "Țineți documentul drept", RQ = "Evitați strălucirea de pe document", AQ = "Încercați încă o dată", TQ = "Nu există cameră", OQ = "Poziționați documentul în centru", yQ = "Încărcați o fotografie", NQ = "Apropiați-vă", LQ = "Țineți dispozitivul nemișcat", MQ = "Camera", bQ = "Treceți pe mobil", PQ = "Activați camera dispozitivului dumneavoastră mobil, scanați codul QR și urmați link-ul", wQ = "Aşteptaţi Vă rog…", HQ = "Dispozitiv mobil", VQ = "Verificarea actelor de identitate", kQ = "Fotografiați un document utilizând camera computerului, încărcați-l din fișiere sau scanați-l pe un dispozitiv mobil", FQ = "Fotografiați un document utilizând camera computerului sau încărcați-l din fișiere", xQ = "Fotografiați un document utilizând camera computerului sau scanați-l pe un dispozitiv mobil", UQ = "Încărcați un document din fișiere sau scanați-l pe un dispozitiv mobil", BQ = "Utilizați camera computerului pentru a fotografia un document", $Q = "Selectați un document din fișiere și încărcați-l", GQ = "Utilizați camera dispozitivului dumneavoastră mobil pentru a fotografia un document", ZQ = "Fotografiați un document utilizând camera dispozitivului mobil sau încărcați-l din galerie", jQ = "Selectați un document din galerie și încărcați-l", zQ = "Galerie", qQ = "Fișiere", WQ = "Întoarceți-vă la computer", YQ = "Documentul dumneavoastră a fost fotografiat", KQ = "sau", XQ = "Faceți clic aici pentru a continua în browser", QQ = "Sari peste", JQ = "Întoarceți documentul", eJ = "Rotiți documentul", tJ = {
  preparingCamera: cQ,
  timeout: uQ,
  noFocus: fQ,
  somethingWentWrong: dQ,
  incorrectCameraId: pQ,
  done: hQ,
  cameraUnavailable: mQ,
  versionNotSupported: _Q,
  httpNotSupported: EQ,
  insecurePageContext: CQ,
  badLicense: SQ,
  fileCorrupt: IQ,
  largeFile: vQ,
  placeDocumentIntoFrame: gQ,
  holdDocumentStraight: DQ,
  glaresOnDocument: RQ,
  tryAgain: AQ,
  noCameraAvailable: TQ,
  positionDocumentCenter: OQ,
  uploadPhoto: yQ,
  moveCloser: NQ,
  keepDeviceStill: LQ,
  camera: MQ,
  switchToMobile: bQ,
  openPhoneCamera: PQ,
  pleaseWait: wQ,
  mobileDevice: HQ,
  verifyYourIdentity: VQ,
  fromCameraFilesMobileDesktop: kQ,
  fromCameraFilesDesktop: FQ,
  fromCameraMobileDesktop: xQ,
  fromFilesMobileDesktop: UQ,
  fromCameraDesktop: BQ,
  fromFilesDesktop: $Q,
  fromMobileDesktop: GQ,
  fromCameraGalleryMobile: ZQ,
  fromGalleryMobile: jQ,
  gallery: zQ,
  files: qQ,
  returnToComputer: WQ,
  documentCaptured: YQ,
  or: KQ,
  continueInBrowser: XQ,
  skip: QQ,
  flipTheDocument: JQ,
  tiltTheDocument: eJ
}, rJ = "Προετοιμασία της κάμερας...", nJ = "Εξωχρονισμός", iJ = "Δεν υπάρχει εστίαση κάμερας", aJ = "Κάτι πήγε στραβά", oJ = "Δεν βρέθηκε κάμερα με το καθορισμένο ID", sJ = "Έτοιμο!", lJ = "Η κάμερα δεν είναι διαθέσιμη!", cJ = "Η έκδοση του προγράμματος περιήγησής σας δεν υποστηρίζεται", uJ = "Το HTTPS δεν χρησιμοποιείται", fJ = "Μη ασφαλές περιβάλλον", dJ = "Η άδεια χρήσης δεν μπορεί να βρεθεί ή έχει λήξει", pJ = "Αυτό το αρχείο είναι κατεστραμμένο ή δεν υποστηρίζεται", hJ = "Αυτό το αρχείο δεν δύναται να μεταφορτωθεί λόγω υπερβολικού μεγέθους", mJ = "Προσαρμόστε το έγγραφο, ώστε να βρίσκεται μέσα στο πλαίσιο", _J = "Κρατήστε το έγγραφο ίσιο", EJ = "Προσέχετε το έγγραφο να μην έχει αντανάκλαση", CJ = "Προσπαθήστε ξανά", SJ = "Δεν υπάρχει κάμερα", IJ = "Τοποθετήστε το έγγραφο στο κέντρο", vJ = "Ανέβασε μια φωτογραφία", gJ = "Πλησιάστε", DJ = "Κρατήστε ακίνητη τη συσκευή", RJ = "Κάμερα", AJ = "Μεταβείτε στην κινητή συσκευή", TJ = "Ανοίξτε την κάμερα στην κινητή συσκευή σας, σαρώστε τον κωδικό QR και μεταβείτε στον σύνδεσμο", OJ = "Please wait...", yJ = "Κινητή συσκευή", NJ = "Επαλήθευση εγγράφου ταυτότητας", LJ = "Πραγματοποιήστε τη λήψη εικόνας εγγράφου χρησιμοποιώντας την κάμερα του υπολογιστή, ανεβάστε το από τα αρχεία ή σαρώστε το με μια κινητή συσκευή", MJ = "Πραγματοποιήστε τη λήψη εικόνας εγγράφου χρησιμοποιώντας την κάμερα του υπολογιστή ή ανεβάστε το από τα αρχεία", bJ = "Πραγματοποιήστε τη λήψη εικόνας εγγράφου χρησιμοποιώντας την κάμερα του υπολογιστή ή σαρώστε το με μια κινητή συσκευή", PJ = "Ανεβάστε ένα έγγραφο από τα αρχεία ή σαρώστε το με μια κινητή συσκευή", wJ = "Χρησιμοποιήστε την κάμερα του υπολογιστή για τη λήψη εικόνας εγγράφου", HJ = "Επιλέξτε ένα έγγραφο από τα αρχεία και ανεβάστε το", VJ = "Χρησιμοποιήστε την κάμερα της κινητής συσκευής σας για τη λήψη εικόνας εγγράφου", kJ = "Πραγματοποιήστε τη λήψη εικόνας εγγράφου χρησιμοποιώντας την κάμερα της κινητής συσκευής σας ή ανεβάστε το από την γκαλερί", FJ = "Επιλέξτε ένα έγγραφο από την γκαλερί και ανεβάστε το", xJ = "Γκαλερί", UJ = "Αρχεία", BJ = "Επιστρέψτε στον υπολογιστή", $J = "Λήψη εικόνας του εγγράφου σας έχει πραγματοποιηθεί", GJ = "ή", ZJ = "Κάντε κλικ εδώ για να συνεχίσετε στο πρόγραμμα περιήγησης", jJ = "Παράλειψη", zJ = "Γυρίστε το έγγραφο", qJ = "Γείρετε το έγγραφο", WJ = {
  preparingCamera: rJ,
  timeout: nJ,
  noFocus: iJ,
  somethingWentWrong: aJ,
  incorrectCameraId: oJ,
  done: sJ,
  cameraUnavailable: lJ,
  versionNotSupported: cJ,
  httpNotSupported: uJ,
  insecurePageContext: fJ,
  badLicense: dJ,
  fileCorrupt: pJ,
  largeFile: hJ,
  placeDocumentIntoFrame: mJ,
  holdDocumentStraight: _J,
  glaresOnDocument: EJ,
  tryAgain: CJ,
  noCameraAvailable: SJ,
  positionDocumentCenter: IJ,
  uploadPhoto: vJ,
  moveCloser: gJ,
  keepDeviceStill: DJ,
  camera: RJ,
  switchToMobile: AJ,
  openPhoneCamera: TJ,
  pleaseWait: OJ,
  mobileDevice: yJ,
  verifyYourIdentity: NJ,
  fromCameraFilesMobileDesktop: LJ,
  fromCameraFilesDesktop: MJ,
  fromCameraMobileDesktop: bJ,
  fromFilesMobileDesktop: PJ,
  fromCameraDesktop: wJ,
  fromFilesDesktop: HJ,
  fromMobileDesktop: VJ,
  fromCameraGalleryMobile: kJ,
  fromGalleryMobile: FJ,
  gallery: xJ,
  files: UJ,
  returnToComputer: BJ,
  documentCaptured: $J,
  or: GJ,
  continueInBrowser: ZJ,
  skip: jJ,
  flipTheDocument: zJ,
  tiltTheDocument: qJ
}, YJ = "Kamera hazırlanıyor...", KJ = "Zaman aşımı", XJ = "Kamera odağı yok", QJ = "Bir hata oluştu", JJ = "Belirtilen kimliğe sahip kamera bulunamadı", eee = "Tamam!", tee = "Kamera kullanılamıyor!", ree = "Tarayıcı sürümünüz desteklenmiyor", nee = "HTTPS kullanılmamış", iee = "Güvenilmeyen bağlam", aee = "Lisans bulunamadı veya lisansın süresi dolmuş", oee = "Dosya bozuk veya desteklenmiyor", see = "Dosya boyutu yüklenemeyecek kadar büyük", lee = "Belgeyi çerçeve içine yerleştir", cee = "Dokümanı düz bir zemine yerleştirin", uee = "Belge üzerinde parlama olmamasına özen gösterin", fee = "Tekrar deneyin", dee = "Kamera yok", pee = "Belgeyi ortaya konumlandırın", hee = "Fotoğraf yükleyin", mee = "Yakına gelin", _ee = "Cihazı sabit tutun", Eee = "Kamera", Cee = "Mobil cihaza geçin", See = "Mobil cihazınızdaki kamerayı açın, QR kodunu taratın ve bağlantıyı izleyin", Iee = "Lütfen bekleyiniz", vee = "Mobil cihazı", gee = "Kimlik belgesi doğrulaması", Dee = "Belgeyi bilgisayarın kamerasını kullanarak taratın, dosyalardan karşıya yükleyin veya bir mobil cihazda taratın", Ree = "Belgeyi bilgisayarın kamerasını kullanarak taratın veya dosyalardan karşıya yükleyin", Aee = "Belgeyi bilgisayarın kamerasını kullanarak veya bir mobil cihazda taratın", Tee = "Belgeyi dosyalardan karşıya yükleyin veya mobil bir cihazda taratın", Oee = "Belgeyi taratmak için bilgisayarın kamerasını kullanın", yee = "Dosyalardan bir belge seçip karşıya yükleyin", Nee = "Belgeyi taratmak için mobil cihazınızın kamerasını kullanın", Lee = "Belgeyi mobil cihazınızın kamerasını kullanarak taratın veya galeriden karşıya yükleyin", Mee = "Galeriden bir belge seçip karşıya yükleyin", bee = "Galeri", Pee = "Dosyalar", wee = "Bilgisayara dön", Hee = "Belge yakalandı", Vee = "veya", kee = "Tarayıcıda devam etmek için tıklayın", Fee = "Geç", xee = "Belgeyi ters çevirin", Uee = "Belgeyi Eğ", Bee = {
  preparingCamera: YJ,
  timeout: KJ,
  noFocus: XJ,
  somethingWentWrong: QJ,
  incorrectCameraId: JJ,
  done: eee,
  cameraUnavailable: tee,
  versionNotSupported: ree,
  httpNotSupported: nee,
  insecurePageContext: iee,
  badLicense: aee,
  fileCorrupt: oee,
  largeFile: see,
  placeDocumentIntoFrame: lee,
  holdDocumentStraight: cee,
  glaresOnDocument: uee,
  tryAgain: fee,
  noCameraAvailable: dee,
  positionDocumentCenter: pee,
  uploadPhoto: hee,
  moveCloser: mee,
  keepDeviceStill: _ee,
  camera: Eee,
  switchToMobile: Cee,
  openPhoneCamera: See,
  pleaseWait: Iee,
  mobileDevice: vee,
  verifyYourIdentity: gee,
  fromCameraFilesMobileDesktop: Dee,
  fromCameraFilesDesktop: Ree,
  fromCameraMobileDesktop: Aee,
  fromFilesMobileDesktop: Tee,
  fromCameraDesktop: Oee,
  fromFilesDesktop: yee,
  fromMobileDesktop: Nee,
  fromCameraGalleryMobile: Lee,
  fromGalleryMobile: Mee,
  gallery: bee,
  files: Pee,
  returnToComputer: wee,
  documentCaptured: Hee,
  or: Vee,
  continueInBrowser: kee,
  skip: Fee,
  flipTheDocument: xee,
  tiltTheDocument: Uee
}, $ee = "カメラ準備中...", Gee = "タイムアウト", Zee = "カメラの焦点が合っていません", jee = "何らかの問題が発生しました", zee = "指定されたIDを持つカメラがみつかりませんでした", qee = "完了！", Wee = "カメラが利用できません！", Yee = "ご利用のブラウザのバージョンはサポートされていません", Kee = "HTTPSが使用されていません", Xee = "不安定なコンテキスト", Qee = "ライセンスがみつからないか有効期限が切れています", Jee = "このファイルは破損しているかサポートされていません", ete = "このファイルはアップロードするには大きすぎます", tte = "フレームに文書をフィットさせます", rte = "文書をまっすぐに持ってください", nte = "文書にテカリが発生しないようにしてください", ite = "もう一度お試しください", ate = "カメラがありません", ote = "書類を中心に配置してください", ste = "写真をアップロード", lte = "近寄ってください", cte = "デバイスを構えて静止してください", ute = "カメラ", fte = "モバイルに切り替えてください", dte = "ご利用のモバイル機器でカメラを起動し、QRコードをスキャンし、リンクをクリックしてください", pte = "Please wait...", hte = "モバイル機器", mte = "ID書類の照合", _te = "コンピューターのカメラを使って書類を撮影し、その画像をファイルからアップロードするか、モバイル機器でスキャンしてください", Ete = "コンピューターのカメラを使って書類を撮影し、その画像をファイルからアップロードしてください", Cte = "コンピューターのカメラを使って書類を撮影するか、モバイル機器でスキャンしてください", Ste = "ファイルから書類をアップロードするか、モバイル機器でスキャンしてください", Ite = "コンピューターのカメラを使って書類を撮影してください", vte = "ファイルから書類を選択してアップロードしてください", gte = "モバイル機器のカメラを使って書類を撮影してください", Dte = "モバイル機器のカメラを使って書類を撮影するか、ギャラリーからアップロードしてください", Rte = "ギャラリーから書類を選択してアップロードしてください", Ate = "ギャラリー", Tte = "ファイル", Ote = "コンピューターに戻ってください", yte = "書類がキャプチャされました", Nte = "または", Lte = "ブラウザで継続するにはこちらをクリックしてください", Mte = "スキップ", bte = "書類を裏返す", Pte = "文書を傾けてください", wte = {
  preparingCamera: $ee,
  timeout: Gee,
  noFocus: Zee,
  somethingWentWrong: jee,
  incorrectCameraId: zee,
  done: qee,
  cameraUnavailable: Wee,
  versionNotSupported: Yee,
  httpNotSupported: Kee,
  insecurePageContext: Xee,
  badLicense: Qee,
  fileCorrupt: Jee,
  largeFile: ete,
  placeDocumentIntoFrame: tte,
  holdDocumentStraight: rte,
  glaresOnDocument: nte,
  tryAgain: ite,
  noCameraAvailable: ate,
  positionDocumentCenter: ote,
  uploadPhoto: ste,
  moveCloser: lte,
  keepDeviceStill: cte,
  camera: ute,
  switchToMobile: fte,
  openPhoneCamera: dte,
  pleaseWait: pte,
  mobileDevice: hte,
  verifyYourIdentity: mte,
  fromCameraFilesMobileDesktop: _te,
  fromCameraFilesDesktop: Ete,
  fromCameraMobileDesktop: Cte,
  fromFilesMobileDesktop: Ste,
  fromCameraDesktop: Ite,
  fromFilesDesktop: vte,
  fromMobileDesktop: gte,
  fromCameraGalleryMobile: Dte,
  fromGalleryMobile: Rte,
  gallery: Ate,
  files: Tte,
  returnToComputer: Ote,
  documentCaptured: yte,
  or: Nte,
  continueInBrowser: Lte,
  skip: Mte,
  flipTheDocument: bte,
  tiltTheDocument: Pte
}, Hte = "Příprava fotoaparátu...", Vte = "Časový limit", kte = "Fotoaparát není zaostřen", Fte = "Něco se pokazilo", xte = "Nebyl nalezen žádný fotoaparát se zadaným ID", Ute = "Hotovo!", Bte = "Fotoaparát není k dispozici!", $te = "Vaše verze prohlížeče není podporována", Gte = "Nebylo použito HTTPS", Zte = "Nejistý kontext", jte = "Licenci nelze nalézt nebo vypršela její platnost", zte = "Tento soubor je poškozený nebo není podporován", qte = "Tento soubor je příliš velký na to, aby mohl být nahrán", Wte = "Umístěte dokument do rámečku", Yte = "Držte dokument rovně", Kte = "Vyvarujte se ostrému osvětlení dokumentu", Xte = "Zkusit to znovu", Qte = "Chybí fotoaparát", Jte = "Umístěte dokumentu do středu", ere = "Nahrát fotografii", tre = "Přibližte se", rre = "Držte zařízení tak, aby se nehnulo", nre = "Fotoaparát", ire = "Přejděte do mobilní verze", are = "Otevřete fotoaparát na mobilním zařízení, naskenujte QR kód a přejděte na odkaz", ore = "Please wait...", sre = "Mobilní zařízení", lre = "Ověřování dokladů totožnosti", cre = "Pořiďte snímek dokumentu pomocí kamery v počítači, nahrajte jej ze souborů nebo jej naskenujte na mobilním zařízení", ure = "Pořiďte snímek dokumentu pomocí kamery v počítači nebo jej nahrajte ze souborů", fre = "Pořiďte snímek dokumentu pomocí kamery v počítači nebo jej naskenujte na mobilním zařízení", dre = "Nahrajte dokument ze souborů nebo jej naskenujte na mobilním zařízení", pre = "Pořiďte snímek dokumentu pomocí kamery v počítači", hre = "Vyberte dokument ze souborů a nahrajte jej", mre = "Pořiďte snímek dokumentu pomocí fotoaparátu na mobilu", _re = "Pořiďte snímek dokumentu pomocí fotoaparátu na mobilu nebo jej nahrajte z galerie", Ere = "Vyberte dokument z galerie a nahrajte jej", Cre = "Galerie", Sre = "Soubory", Ire = "Vraťte se k počítači", vre = "Dokument byl zaznamenán", gre = "nebo", Dre = "Po kliknutí zde budete pokračovat v prohlížeči", Rre = "Přeskočit", Are = "Obraťte dokument", Tre = "Nakloňte dokument", Ore = {
  preparingCamera: Hte,
  timeout: Vte,
  noFocus: kte,
  somethingWentWrong: Fte,
  incorrectCameraId: xte,
  done: Ute,
  cameraUnavailable: Bte,
  versionNotSupported: $te,
  httpNotSupported: Gte,
  insecurePageContext: Zte,
  badLicense: jte,
  fileCorrupt: zte,
  largeFile: qte,
  placeDocumentIntoFrame: Wte,
  holdDocumentStraight: Yte,
  glaresOnDocument: Kte,
  tryAgain: Xte,
  noCameraAvailable: Qte,
  positionDocumentCenter: Jte,
  uploadPhoto: ere,
  moveCloser: tre,
  keepDeviceStill: rre,
  camera: nre,
  switchToMobile: ire,
  openPhoneCamera: are,
  pleaseWait: ore,
  mobileDevice: sre,
  verifyYourIdentity: lre,
  fromCameraFilesMobileDesktop: cre,
  fromCameraFilesDesktop: ure,
  fromCameraMobileDesktop: fre,
  fromFilesMobileDesktop: dre,
  fromCameraDesktop: pre,
  fromFilesDesktop: hre,
  fromMobileDesktop: mre,
  fromCameraGalleryMobile: _re,
  fromGalleryMobile: Ere,
  gallery: Cre,
  files: Sre,
  returnToComputer: Ire,
  documentCaptured: vre,
  or: gre,
  continueInBrowser: Dre,
  skip: Rre,
  flipTheDocument: Are,
  tiltTheDocument: Tre
}, yre = "กำลังเตรียมกล้องถ่ายรูป...", Nre = "หมดเวลา", Lre = "ไม่มีโฟกัสกล้อง", Mre = "มีบางอย่างผิดพลาด", bre = "ไม่พบกล้องที่มี ID ที่ระบุ", Pre = "เสร็จ!", wre = "กล้องถ่ายรูปไม่พร้อมใช้งาน!", Hre = "ไม่รองรับเบราว์เซอร์รุ่นที่คุณใช้งาน", Vre = "ไม่ได้ใช้ HTTPS", kre = "เนื้อหาไม่รัดกุม", Fre = "ไม่พบใบอนุญาติ หรือใบอนุญาตหมดอายุ", xre = "ไฟล์นี้เสียหายหรือระบบไม่รองรับไฟล์นี้", Ure = "ไฟล์นี้ใหญ่เกินกว่าจะอัปโหลดได้", Bre = "จัดเอกสารให้พอดีกับกรอบ", $re = "ถือเอกสารให้ตรง", Gre = "โปรดหลีกเลี่ยงไม่ให้แสงส่องจ้าบนเอกสาร", Zre = "ลองอีกครั้ง", jre = "ไม่มีกล้องถ่ายรูป", zre = "จัดวางเอกสารไว้ตรงกลาง", qre = "อัปโหลดรูปภาพ", Wre = "เข้ามาใกล้กว่านี้", Yre = "ถืออุปกรณ์นิ่ง ๆ", Kre = "กล้องถ่ายรูป", Xre = "สลับไปใช้โทรศัพท์", Qre = "เปิดกล้องถ่ายรูปในอุปกรณ์เคลื่อนที่ สแกนรหัส QR และไปตามลิงก์", Jre = "Please wait...", ene = "อุปกรณ์เคลื่อนที่", tne = "การยืนยันเอกสารประจำตัว", rne = "จับภาพเอกสารโดยใช้กล้องถ่ายรูปของคอมพิวเตอร์ อัปโหลดภาพจากไฟล์ หรือสแกนลงในอุปกรณ์เคลื่อนที่", nne = "จับภาพเอกสารโดยใช้กล้องถ่ายรูปของคอมพิวเตอร์ หรืออัปโหลดภาพจากไฟล์", ine = "จับภาพเอกสารโดยใช้กล้องถ่ายรูปของคอมพิวเตอร์ หรือสแกนลงในอุปกรณ์เคลื่อนที่", ane = "อัปโหลดภาพจากไฟล์ หรือสแกนลงในอุปกรณ์เคลื่อนที่", one = "จับภาพเอกสารโดยใช้กล้องถ่ายรูปของคอมพิวเตอร์", sne = "เลือกเอกสารจากไฟล์และอัปโหลด", lne = "ใช้กล้องจากอุปกรณ์เคลื่อนที่ของคุณเพื่อจับภาพเอกสาร", cne = "จับภาพเอกสารโดยใช้กล้องถ่ายรูปของอุปกรณ์เคลื่อนที่ หรืออัปโหลดจากแกลเลอรี", une = "เลือกเอกสารจากแกลเลอรีและอัปโหลด", fne = "แกลเลอรี", dne = "ไฟล์", pne = "กลับไปที่คอมพิวเตอร์ของคุณ", hne = "จับภาพเอกสารของคุณแล้ว", mne = "หรือ", _ne = "คลิกที่นี่เพื่อดำเนินการต่อในเบราว์เซอร์", Ene = "ข้าม", Cne = "พลิกเอกสาร", Sne = "เอียงเอกสาร", Ine = {
  preparingCamera: yre,
  timeout: Nre,
  noFocus: Lre,
  somethingWentWrong: Mre,
  incorrectCameraId: bre,
  done: Pre,
  cameraUnavailable: wre,
  versionNotSupported: Hre,
  httpNotSupported: Vre,
  insecurePageContext: kre,
  badLicense: Fre,
  fileCorrupt: xre,
  largeFile: Ure,
  placeDocumentIntoFrame: Bre,
  holdDocumentStraight: $re,
  glaresOnDocument: Gre,
  tryAgain: Zre,
  noCameraAvailable: jre,
  positionDocumentCenter: zre,
  uploadPhoto: qre,
  moveCloser: Wre,
  keepDeviceStill: Yre,
  camera: Kre,
  switchToMobile: Xre,
  openPhoneCamera: Qre,
  pleaseWait: Jre,
  mobileDevice: ene,
  verifyYourIdentity: tne,
  fromCameraFilesMobileDesktop: rne,
  fromCameraFilesDesktop: nne,
  fromCameraMobileDesktop: ine,
  fromFilesMobileDesktop: ane,
  fromCameraDesktop: one,
  fromFilesDesktop: sne,
  fromMobileDesktop: lne,
  fromCameraGalleryMobile: cne,
  fromGalleryMobile: une,
  gallery: fne,
  files: dne,
  returnToComputer: pne,
  documentCaptured: hne,
  or: mne,
  continueInBrowser: _ne,
  skip: Ene,
  flipTheDocument: Cne,
  tiltTheDocument: Sne
}, vne = "कैमरा तैयार करना...", gne = "समय समाप्त", Dne = "कैमरा फ़ोकस नहीं", Rne = "कुछ त्रुटि हुई", Ane = "निर्दिष्ट ID वाला कोई कैमरा नहीं मिला", Tne = "ठीक है!", One = "कैमरा उपलब्ध नहीं है!", yne = "आपका ब्राउज़र संस्करण समर्थित नहीं है", Nne = "HTTPS का उपयोग नहीं किया गया", Lne = "असुरक्षित प्रसंग", Mne = "लाइसेंस नहीं मिला या समाप्त हो गया है", bne = "यह फ़ाइल करप्ट है या समर्थित नहीं है", Pne = "यह फ़ाइल अपलोड करने के लिए बहुत बड़ी है", wne = "दस्तावेज़ को फ्रेम में फिट करें", Hne = "दस्तावेज़ को सीधे रखें", Vne = "दस्तावेज़ को चमक से बचाएं", kne = "पुनः प्रयास करें", Fne = "कोई कैमरा नहीं है", xne = "दस्तावेज़ को बीच में रखें", Une = "एक फ़ोटो अपलोड करें", Bne = "नजदीक आएं", $ne = "डिवाइस को स्थिर अवस्था में पकड़ें", Gne = "कैमरा", Zne = "मोबाइल पर स्विच करें", jne = "अपने मोबाइल डिवाइस पर कैमरा खोलें, QR कोड स्कैन करें और लिंक फॉलो करें", zne = "Please wait...", qne = "मोबाइल डिवाइस", Wne = "पहचान दस्तावेज़ सत्यापन", Yne = "कंप्यूटर के कैमरे का उपयोग करके किसी दस्तावेज़ को कैप्चर करें, उसे फ़ाइलों से अपलोड करें, या मोबाइल डिवाइस पर स्कैन करें", Kne = "कंप्यूटर के कैमरे का उपयोग करके किसी दस्तावेज़ को कैप्चर करें या उसे फ़ाइलों से अपलोड करें", Xne = "कंप्यूटर के कैमरे का उपयोग करके किसी दस्तावेज़ को कैप्चर करें या मोबाइल डिवाइस पर स्कैन करें", Qne = "किसी दस्तावेज़ को फ़ाइलों से अपलोड करें या उसे मोबाइल डिवाइस पर स्कैन करें", Jne = "किसी दस्तावेज़ को कैप्चर करने के लिए कंप्यूटर के कैमरे का उपयोग करें", eie = "फ़ाइलों में से एक दस्तावेज़ चुनें और उसे अपलोड करें", tie = "किसी दस्तावेज़ को कैप्चर करने के लिए अपने मोबाइल के कैमरे का उपयोग करें", rie = "मोबाइल के कैमरे का उपयोग करके किसी दस्तावेज़ को कैप्चर करें या गैलरी से अपलोड करें", nie = "गैलरी से एक दस्तावेज़ चुनें और उसे अपलोड करें", iie = "गैलरी से", aie = "फाइल से", oie = "कंप्यूटर पर लौटें", sie = "आपका दस्तावेज़ कैप्चर कर लिया गया है", lie = "या", cie = "ब्राउज़र में जारी रखने के लिए यहां क्लिक करें", uie = "छोड़ें", fie = "दस्तावेज़ पलटें", die = "दस्तावेज़ को टिल्ट करें", pie = {
  preparingCamera: vne,
  timeout: gne,
  noFocus: Dne,
  somethingWentWrong: Rne,
  incorrectCameraId: Ane,
  done: Tne,
  cameraUnavailable: One,
  versionNotSupported: yne,
  httpNotSupported: Nne,
  insecurePageContext: Lne,
  badLicense: Mne,
  fileCorrupt: bne,
  largeFile: Pne,
  placeDocumentIntoFrame: wne,
  holdDocumentStraight: Hne,
  glaresOnDocument: Vne,
  tryAgain: kne,
  noCameraAvailable: Fne,
  positionDocumentCenter: xne,
  uploadPhoto: Une,
  moveCloser: Bne,
  keepDeviceStill: $ne,
  camera: Gne,
  switchToMobile: Zne,
  openPhoneCamera: jne,
  pleaseWait: zne,
  mobileDevice: qne,
  verifyYourIdentity: Wne,
  fromCameraFilesMobileDesktop: Yne,
  fromCameraFilesDesktop: Kne,
  fromCameraMobileDesktop: Xne,
  fromFilesMobileDesktop: Qne,
  fromCameraDesktop: Jne,
  fromFilesDesktop: eie,
  fromMobileDesktop: tie,
  fromCameraGalleryMobile: rie,
  fromGalleryMobile: nie,
  gallery: iie,
  files: aie,
  returnToComputer: oie,
  documentCaptured: sie,
  or: lie,
  continueInBrowser: cie,
  skip: uie,
  flipTheDocument: fie,
  tiltTheDocument: die
}, hie = "ক্যামেরা প্রস্তুত করা হচ্ছে...", mie = "টাইম আউট", _ie = "ক্যামেরার ফোকাস হয়নি", Eie = "কিছু একটা ভুল হয়েছে", Cie = "নির্দিষ্ট আইডি সহ কোনো ক্যামেরা পাওয়া যায়নি", Sie = "হয়ে গেছে!", Iie = "ক্যামেরা বিদ্যমান নেই!", vie = "আপনার ব্রাউজারের সংস্করণটি সমর্থিত নয়", gie = "HTTPS ব্যবহৃত হয়নি", Die = "অনিরাপদ কন্টেক্সট", Rie = "লাইসেন্স পাওয়া যায়নি বা মেয়াদ শেষ হয়ে গেছে", Aie = "এই ফাইলটি অকার্যকর বা সমর্থিত নয়", Tie = "এই ফাইলটি আপলোড করার জন্য খুবই বড়", Oie = "ডকুমেন্টটি ফ্রেমের মাঝে রাখুন", yie = "ডকুমেন্টটি সোজাভাবে ধরে রাখুন", Nie = "ডকুমেন্টে আলোর ঝলকানি এড়িয়ে চলুন", Lie = "আবার চেষ্টা করুন", Mie = "কোনো ক্যামেরা নেই", bie = "ডকুমেন্টটি কেন্দ্রে রাখুন", Pie = "একটি ছবি আপলোড করুন", wie = "কাছে যান", Hie = "ডিভাইসটি ধরে রাখুন", Vie = "ক্যামেরা", kie = "মোবাইলে স্যুইচ করুন", Fie = "আপনার মোবাইল ডিভাইসের ক্যামেরা দিয়ে QR কোডটি স্ক্যান করুন এবং লিঙ্কটি অনুসরণ করুন", xie = "Please wait...", Uie = "মোবাইল ডিভাইস", Bie = "পরিচয় যাচাইকরণ ডকুমেন্ট", $ie = "কম্পিউটারের ক্যামেরা ব্যবহার করে একটি ডকুমেন্ট ক্যাপচার করুন, ফাইল থেকে আপলোড করুন বা মোবাইল ডিভাইসে এটি স্ক্যান করুন", Gie = "কম্পিউটারের ক্যামেরা ব্যবহার করে একটি ডকুমেন্ট ক্যাপচার করুন বা ফাইল থেকে আপলোড করুন", Zie = "কম্পিউটারের ক্যামেরা ব্যবহার করে একটি ডকুমেন্ট ক্যাপচার করুন বা একটি মোবাইল ডিভাইসে এটি স্ক্যান করুন", jie = "ফাইল থেকে একটি ডকুমেন্ট আপলোড করুন বা একটি মোবাইল ডিভাইসে এটি স্ক্যান করুন", zie = "একটি ডকুমেন্ট ক্যাপচার করতে কম্পিউটারের ক্যামেরা ব্যবহার করুন", qie = "ফাইল থেকে একটি ডকুমেন্ট বাছাই করুন এবং এটি আপলোড করুন", Wie = "একটি ডকুমেন্ট ক্যাপচার করতে আপনার মোবাইল ক্যামেরা ব্যবহার করুন", Yie = "মোবাইলের ক্যামেরা ব্যবহার করে একটি ডকুমেন্ট ক্যাপচার করুন বা গ্যালারি থেকে আপলোড করুন", Kie = "গ্যালারি থেকে একটি ডকুমেন্ট বাছাই করুন এবং এটি আপলোড করুন", Xie = "গ্যালারি", Qie = "ফাইল", Jie = "কম্পিউটারে ফিরে যান", eae = "আপনার ডকুমেন্ট ক্যাপচার করা হয়েছে", tae = "অথবা", rae = "ব্রাউজারে চালিয়ে যেতে এখানে ক্লিক করুন", nae = "এড়িয়ে যান", iae = "ডকুমেন্টটি উল্টান", aae = "ডকুমেন্টটি কাত করুন", oae = {
  preparingCamera: hie,
  timeout: mie,
  noFocus: _ie,
  somethingWentWrong: Eie,
  incorrectCameraId: Cie,
  done: Sie,
  cameraUnavailable: Iie,
  versionNotSupported: vie,
  httpNotSupported: gie,
  insecurePageContext: Die,
  badLicense: Rie,
  fileCorrupt: Aie,
  largeFile: Tie,
  placeDocumentIntoFrame: Oie,
  holdDocumentStraight: yie,
  glaresOnDocument: Nie,
  tryAgain: Lie,
  noCameraAvailable: Mie,
  positionDocumentCenter: bie,
  uploadPhoto: Pie,
  moveCloser: wie,
  keepDeviceStill: Hie,
  camera: Vie,
  switchToMobile: kie,
  openPhoneCamera: Fie,
  pleaseWait: xie,
  mobileDevice: Uie,
  verifyYourIdentity: Bie,
  fromCameraFilesMobileDesktop: $ie,
  fromCameraFilesDesktop: Gie,
  fromCameraMobileDesktop: Zie,
  fromFilesMobileDesktop: jie,
  fromCameraDesktop: zie,
  fromFilesDesktop: qie,
  fromMobileDesktop: Wie,
  fromCameraGalleryMobile: Yie,
  fromGalleryMobile: Kie,
  gallery: Xie,
  files: Qie,
  returnToComputer: Jie,
  documentCaptured: eae,
  or: tae,
  continueInBrowser: rae,
  skip: nae,
  flipTheDocument: iae,
  tiltTheDocument: aae
}, sae = "המצלמה בהכנה...", lae = "זמן קצוב לתפוגה", cae = "המצלמה לא בפוקוס", uae = "משהו השתבש", fae = "לא נמצאה מצלמה עם המזהה שצוין", dae = "סיימת!", pae = "המצלמה לא זמינה", hae = "אין תמיכה בגרסה הנוכחית של הדפדפן", mae = "לא נעשה שימוש ב-HTTPS", _ae = "הקשר לא בטוח", Eae = "הרישיון לא נמצא או לא בתוקף", Cae = "הקובץ פגום או בפורמט שלא נתמך", Sae = "הקובץ גדול מדי ולא ניתן להעלות אותו", Iae = "התאמת המסמך בתוך המסגרת", vae = "יש ליישר את המסמך", gae = "יש לוודא שאין ברק בזמן צילום המסמך", Dae = "כדאי לנסות שוב", Rae = "אין מצלמה", Aae = "יש למקם את המסמך במרכז", Tae = "העלאת תמונה", Oae = "להתקרב", yae = "יש להחזיק את המכשיר בלי לזוז", Nae = "מצלמה", Lae = "מעבר לנייד", Mae = "צריך לפתוח את המצלמה בנייד, לסרוק את קוד ה-QR וללחוץ על הקישור", bae = "Please wait...", Pae = "נייד", wae = "אימות של מסמך זיהוי", Hae = "צריך לצלם את המסמך באמצעות מצלמת המחשב, להעלות אותו מתוך הקבצים או לסרוק אותו בנייד", Vae = "צריך לצלם את המסמך באמצעות מצלמת המחשב או להעלות אותו מתוך הקבצים", kae = "צריך לצלם את המסמך באמצעות מצלמת המחשב או לסרוק אותו בנייד", Fae = "צריך להעלות את המסמך מתוך הקבצים או לסרוק אותו בנייד", xae = "צריך לצלם את המסמך באמצעות מצלמת המחשב", Uae = "צריך לבחור את המסמך מתוך הקבצים ולהעלות אותו", Bae = "צריך לצלם את המסמך באמצעות מצלמת הנייד", $ae = "צריך לצלם את המסמך באמצעות מצלמת הנייד או להעלות אותו מהגלריה", Gae = "צריך לבחור את המסמך מהגלריה ולהעלות אותו", Zae = "גלריה", jae = "קבצים", zae = "חזרה למחשב", qae = "המסמך צולם", Wae = "או", Yae = "מקישים כאן כדי לפתוח בדפדפן", Kae = "דילוג", Xae = "יש להפוך את המסמך לצידו השני", Qae = "צריך להטות את המסמך הצידה", Jae = {
  preparingCamera: sae,
  timeout: lae,
  noFocus: cae,
  somethingWentWrong: uae,
  incorrectCameraId: fae,
  done: dae,
  cameraUnavailable: pae,
  versionNotSupported: hae,
  httpNotSupported: mae,
  insecurePageContext: _ae,
  badLicense: Eae,
  fileCorrupt: Cae,
  largeFile: Sae,
  placeDocumentIntoFrame: Iae,
  holdDocumentStraight: vae,
  glaresOnDocument: gae,
  tryAgain: Dae,
  noCameraAvailable: Rae,
  positionDocumentCenter: Aae,
  uploadPhoto: Tae,
  moveCloser: Oae,
  keepDeviceStill: yae,
  camera: Nae,
  switchToMobile: Lae,
  openPhoneCamera: Mae,
  pleaseWait: bae,
  mobileDevice: Pae,
  verifyYourIdentity: wae,
  fromCameraFilesMobileDesktop: Hae,
  fromCameraFilesDesktop: Vae,
  fromCameraMobileDesktop: kae,
  fromFilesMobileDesktop: Fae,
  fromCameraDesktop: xae,
  fromFilesDesktop: Uae,
  fromMobileDesktop: Bae,
  fromCameraGalleryMobile: $ae,
  fromGalleryMobile: Gae,
  gallery: Zae,
  files: jae,
  returnToComputer: zae,
  documentCaptured: qae,
  or: Wae,
  continueInBrowser: Yae,
  skip: Kae,
  flipTheDocument: Xae,
  tiltTheDocument: Qae
}, eoe = "Valmistellaan kameraa...", toe = "Aikakatkaisu", roe = "Kamera ei tarkennettu", noe = "Jokin epäonnistui", ioe = "Kameraa, jonka tunniste on määritetty, ei löydy.", aoe = "Valmis!", ooe = "Kamera ei ole käytettävissä!", soe = "Selaimesi versiota ei tueta", loe = "HTTPS ei käytössä", coe = "Konteksti ei turvallinen", uoe = "Lisenssiä ei löydy tai se on vanhentunut", foe = "Tämä tiedosto on vioittunut tai sitä ei tueta", doe = "Tiedosto on liian suuri ladattavaksi", poe = "Kohdista asiakirja kehykseen", hoe = "Pidä asiakirjaa suorassa", moe = "Vältä heijastuksia asiakirjassa", _oe = "Yritä uudelleen!", Eoe = "Kameraa ei ole", Coe = "Sijoita asiakirja keskelle", Soe = "Lataa valokuva", Ioe = "Siirry lähemmäs", voe = "Pidä laitetta paikallaan", goe = "Kamera", Doe = "Vaihda mobiiliin", Roe = "Avaa mobiililaitteesi kamera, skannaa QR-koodi ja siirry linkin sivustoon", Aoe = "Please wait...", Toe = "Mobiililaite", Ooe = "Henkilöllisyystodistusten todennus", yoe = "Kuvaa asiakirja tietokoneen kameralla, lataa se tiedostoista tai skannaa se mobiililaitteella", Noe = "Kuvaa asiakirja tietokoneen kameralla tai lataa se tiedostoista", Loe = "Kuvaa asiakirja tietokoneen kameralla tai skannaa se mobiililaitteella", Moe = "Lataa asiakirja tiedostoista tai skannaa se mobiililaitteella", boe = "Kuvaa asiakirja tietokoneen kameralla", Poe = "Valitse asiakirja tiedostoista ja lataa se", woe = "Kuvaa asiakirja mobiililaitteesi kameralla", Hoe = "Kuvaa asiakirja mobiililaitteen kameralla tai lataa se galleriasta", Voe = "Valitse asiakirja galleriasta ja lataa se", koe = "Galleria", Foe = "Tiedostot", xoe = "Palaa tietokoneeseen", Uoe = "Asiakirjasi on kuvattu", Boe = "tai", $oe = "Jatka selaimessa napsauttamalla tätä", Goe = "Ohita", Zoe = "Käännä asiakirja", joe = "Kallista asiakirjaa", zoe = {
  preparingCamera: eoe,
  timeout: toe,
  noFocus: roe,
  somethingWentWrong: noe,
  incorrectCameraId: ioe,
  done: aoe,
  cameraUnavailable: ooe,
  versionNotSupported: soe,
  httpNotSupported: loe,
  insecurePageContext: coe,
  badLicense: uoe,
  fileCorrupt: foe,
  largeFile: doe,
  placeDocumentIntoFrame: poe,
  holdDocumentStraight: hoe,
  glaresOnDocument: moe,
  tryAgain: _oe,
  noCameraAvailable: Eoe,
  positionDocumentCenter: Coe,
  uploadPhoto: Soe,
  moveCloser: Ioe,
  keepDeviceStill: voe,
  camera: goe,
  switchToMobile: Doe,
  openPhoneCamera: Roe,
  pleaseWait: Aoe,
  mobileDevice: Toe,
  verifyYourIdentity: Ooe,
  fromCameraFilesMobileDesktop: yoe,
  fromCameraFilesDesktop: Noe,
  fromCameraMobileDesktop: Loe,
  fromFilesMobileDesktop: Moe,
  fromCameraDesktop: boe,
  fromFilesDesktop: Poe,
  fromMobileDesktop: woe,
  fromCameraGalleryMobile: Hoe,
  fromGalleryMobile: Voe,
  gallery: koe,
  files: Foe,
  returnToComputer: xoe,
  documentCaptured: Uoe,
  or: Boe,
  continueInBrowser: $oe,
  skip: Goe,
  flipTheDocument: Zoe,
  tiltTheDocument: joe
}, qoe = "Förbereder kameran...", Woe = "Paus", Yoe = "Ingen kamerafokus", Koe = "Ett fel inträffade", Xoe = "Ingen kamera med specificerat ID hittat", Qoe = "Klart!", Joe = "Kameran är inte tillgänglig!", ese = "Din webbläsarversion stöds inte", tse = "HTTPS används inte", rse = "Otryggt sammanhang", nse = "Licensen går antingen inte att hitta eller så har den utgått", ise = "Filen är antingen korrupt eller stöds inte", ase = "Filen är för stor för att kunna laddas upp", ose = "Placera dokumentet i ramen", sse = "Håll dokumentet rakt", lse = "Undvik reflexer på dokumentet", cse = "Försök igen", use = "Det finns ingen kamera", fse = "Placera dokumentet i mitten", dse = "Ladda upp foto", pse = "Flytta närmare", hse = "Håll enheten stilla", mse = "Kamera", _se = "Byt till mobil", Ese = "Öppna kameran på din mobila enhet, skanna QR-koden och följ länken", Cse = "Please wait...", Sse = "Mobil enhet", Ise = "Verifiering av ID-handlingar", vse = "Skanna ett dokument med datorns kamera, ladda upp det från filerna eller skanna det med en mobil enhet", gse = "Skanna ett dokument med datorns kamera eller ladda upp det från filerna", Dse = "Skanna ett dokument med datorns kamera eller med en mobil enhet", Rse = "Ladda upp det från filer eller skanna det med en mobil enhet", Ase = "Använd datorns kamera till att skanna ett dokument", Tse = "Välj ett dokument från filerna och ladda upp det", Ose = "Använd din mobila kamera till att skanna ett dokument", yse = "Skanna ett dokument med mobilens kamera eller ladda upp det från bildgalleriet", Nse = "Välj ett dokument från bildgalleriet och ladda upp det", Lse = "Galleri", Mse = "Filer", bse = "Gå tillbaka till datorn", Pse = "Ditt dokument har fångats", wse = "eller", Hse = "Klicka här för att fortsätta i webbläsaren", Vse = "Hoppa över", kse = "Vänd på dokumentet", Fse = "Luta dokumentet", xse = {
  preparingCamera: qoe,
  timeout: Woe,
  noFocus: Yoe,
  somethingWentWrong: Koe,
  incorrectCameraId: Xoe,
  done: Qoe,
  cameraUnavailable: Joe,
  versionNotSupported: ese,
  httpNotSupported: tse,
  insecurePageContext: rse,
  badLicense: nse,
  fileCorrupt: ise,
  largeFile: ase,
  placeDocumentIntoFrame: ose,
  holdDocumentStraight: sse,
  glaresOnDocument: lse,
  tryAgain: cse,
  noCameraAvailable: use,
  positionDocumentCenter: fse,
  uploadPhoto: dse,
  moveCloser: pse,
  keepDeviceStill: hse,
  camera: mse,
  switchToMobile: _se,
  openPhoneCamera: Ese,
  pleaseWait: Cse,
  mobileDevice: Sse,
  verifyYourIdentity: Ise,
  fromCameraFilesMobileDesktop: vse,
  fromCameraFilesDesktop: gse,
  fromCameraMobileDesktop: Dse,
  fromFilesMobileDesktop: Rse,
  fromCameraDesktop: Ase,
  fromFilesDesktop: Tse,
  fromMobileDesktop: Ose,
  fromCameraGalleryMobile: yse,
  fromGalleryMobile: Nse,
  gallery: Lse,
  files: Mse,
  returnToComputer: bse,
  documentCaptured: Pse,
  or: wse,
  continueInBrowser: Hse,
  skip: Vse,
  flipTheDocument: kse,
  tiltTheDocument: Fse
}, Use = "Gør kameraet klar...", Bse = "Timeout", $se = "Ingen kamerafokus", Gse = "Noget gik galt", Zse = "Intet kamera med det specificeret ID fundet", jse = "Færdig!", zse = "Kamera utilgængelig!", qse = "Din browserversion er ikke understøttet", Wse = "HTTPS ikke brugt", Yse = "Usikker kontekst", Kse = "Licensen kan ikke findes eller er udløbet", Xse = "Filen er ødelagt eller understøttes ikke", Qse = "Denne fil er for stor til at blive overført", Jse = "Tilpas dokumentet til rammen", e2e = "Hold dokumentet lige", t2e = "Undgå genskin på dokumentet", r2e = "Prøv igen", n2e = "Der er intet kamera", i2e = "Placer dokumentet i midten", a2e = "Upload et foto", o2e = "Flyt tættere på", s2e = "Hold enheden stille", l2e = "Kamera", c2e = "Skift til mobil", u2e = "Åben kameraet på din mobile enhed, scan QR-koden, og følg linket", f2e = "Please wait...", d2e = "Mobil enhed", p2e = "Bekræftelse af ID-dokument", h2e = "Fang et dokument ved hjælp af computerens kamera, upload det fra filer, eller scan det på en mobil enhed", m2e = "Fang et dokument ved hjælp af computerens kamera eller upload det fra filer", _2e = "Fang et dokument ved hjælp af computerens kamera, upload det fra filer, eller scan det på en mobil enhed", E2e = "Upload et dokument fra filer eller scan det på en mobil enhed", C2e = "Brug computerens kamera til at fange et dokument", S2e = "Vælg et dokument fra filer og upload det", I2e = "Brug dit mobilkamera til at fange et dokument", v2e = "Fang et dokument ved hjælp af mobilens kamera eller upload det fra galleri", g2e = "Vælg et dokument fra galleriet og upload det", D2e = "Galleri", R2e = "Filer", A2e = "Vend tilbage til computeren", T2e = "Dit dokument er blevet fanget", O2e = "eller", y2e = "Klik her for at fortsætte i browser", N2e = "Spring over", L2e = "Vend dokumentet", M2e = "Vip dokumentet", b2e = {
  preparingCamera: Use,
  timeout: Bse,
  noFocus: $se,
  somethingWentWrong: Gse,
  incorrectCameraId: Zse,
  done: jse,
  cameraUnavailable: zse,
  versionNotSupported: qse,
  httpNotSupported: Wse,
  insecurePageContext: Yse,
  badLicense: Kse,
  fileCorrupt: Xse,
  largeFile: Qse,
  placeDocumentIntoFrame: Jse,
  holdDocumentStraight: e2e,
  glaresOnDocument: t2e,
  tryAgain: r2e,
  noCameraAvailable: n2e,
  positionDocumentCenter: i2e,
  uploadPhoto: a2e,
  moveCloser: o2e,
  keepDeviceStill: s2e,
  camera: l2e,
  switchToMobile: c2e,
  openPhoneCamera: u2e,
  pleaseWait: f2e,
  mobileDevice: d2e,
  verifyYourIdentity: p2e,
  fromCameraFilesMobileDesktop: h2e,
  fromCameraFilesDesktop: m2e,
  fromCameraMobileDesktop: _2e,
  fromFilesMobileDesktop: E2e,
  fromCameraDesktop: C2e,
  fromFilesDesktop: S2e,
  fromMobileDesktop: I2e,
  fromCameraGalleryMobile: v2e,
  fromGalleryMobile: g2e,
  gallery: D2e,
  files: R2e,
  returnToComputer: A2e,
  documentCaptured: T2e,
  or: O2e,
  continueInBrowser: y2e,
  skip: N2e,
  flipTheDocument: L2e,
  tiltTheDocument: M2e
}, P2e = "Priprema kamere...", w2e = "Pauza", H2e = "Nema fokusa kamere", V2e = "Nešto je pošlo po zlu", k2e = "Nije pronađena kamera s navedenim ID-om", F2e = "Gotovo!", x2e = "Kamera nije dostupna!", U2e = "Vaša verzija preglednika nije podržana", B2e = "HTTPS se ne koristi", $2e = "Nesiguran kontekst", G2e = "Licenca se ne može pronaći ili je istekla", Z2e = "Ova datoteka je oštećena ili nije podržana", j2e = "Ova je datoteka prevelika za prijenos", z2e = "Prilagodite dokument okviru", q2e = "Držite dokument ravno", W2e = "Izbjegavajte odsjaj na dokumentu", Y2e = "Pokušajte ponovno", K2e = "Nema kamere", X2e = "Postavite dokument u sredinu", Q2e = "Uploadujte sliku", J2e = "Priđite bliže", ele = "Držite uređaj mirno", tle = "Kamera", rle = "Prebacivanje na mobilni uređaj", nle = "Otvorite kameru na svom mobilnom uređaju, skenirajte QR kod i slijedite poveznicu", ile = "Please wait...", ale = "Mobilni uređaj", ole = "Provjera osobnih dokumenata", sle = "Snimite dokument pomoću kamere računala, prenesite ga iz datoteka ili skenirajte na mobilnom uređaju", lle = "Snimite dokument pomoću kamere računala ili ga prenesite iz datoteka", cle = "Snimite dokument pomoću kamere računala ili ga skenirajte na mobilnom uređaju", ule = "Prenesite dokument iz datoteka ili ga skenirajte na mobilnom uređaju", fle = "Koristite kameru računala za snimanje dokumenta", dle = "Odaberite dokument iz datoteka i prenesite ga", ple = "Koristite svoju mobilnu kameru za snimanje dokumenta", hle = "Snimite dokument pomoću kamere mobilnog telefona ili ga prenesite iz galerije", mle = "Odaberite dokument iz galerije i prenesite ga", _le = "Galerija", Ele = "Datoteke", Cle = "Vrati se na računalo", Sle = "Vaš dokument je snimljen", Ile = "ili", vle = "Kliknite ovdje za nastavak u pregledniku", gle = "Prekočiti", Dle = "Okrenite dokument", Rle = "Nagnite dokument", Ale = {
  preparingCamera: P2e,
  timeout: w2e,
  noFocus: H2e,
  somethingWentWrong: V2e,
  incorrectCameraId: k2e,
  done: F2e,
  cameraUnavailable: x2e,
  versionNotSupported: U2e,
  httpNotSupported: B2e,
  insecurePageContext: $2e,
  badLicense: G2e,
  fileCorrupt: Z2e,
  largeFile: j2e,
  placeDocumentIntoFrame: z2e,
  holdDocumentStraight: q2e,
  glaresOnDocument: W2e,
  tryAgain: Y2e,
  noCameraAvailable: K2e,
  positionDocumentCenter: X2e,
  uploadPhoto: Q2e,
  moveCloser: J2e,
  keepDeviceStill: ele,
  camera: tle,
  switchToMobile: rle,
  openPhoneCamera: nle,
  pleaseWait: ile,
  mobileDevice: ale,
  verifyYourIdentity: ole,
  fromCameraFilesMobileDesktop: sle,
  fromCameraFilesDesktop: lle,
  fromCameraMobileDesktop: cle,
  fromFilesMobileDesktop: ule,
  fromCameraDesktop: fle,
  fromFilesDesktop: dle,
  fromMobileDesktop: ple,
  fromCameraGalleryMobile: hle,
  fromGalleryMobile: mle,
  gallery: _le,
  files: Ele,
  returnToComputer: Cle,
  documentCaptured: Sle,
  or: Ile,
  continueInBrowser: vle,
  skip: gle,
  flipTheDocument: Dle,
  tiltTheDocument: Rle
}, Tle = "Forbereder kameraet...", Ole = "Pause", yle = "Ingen kamerafokus", Nle = "Noe gikk galt", Lle = "Kamera med den spesifikke ID-en ble ikke funnet", Mle = "Ferdig!", ble = "Kameraet er ikke tilgjengelig!", Ple = "Din nettleserversjon støttes ikke", wle = "HTTPS ikke brukt", Hle = "Usikker kontekst", Vle = "Lisensen finnes ikke eller har utløpt", kle = "Denne filen er skadet eller støttes ikke", Fle = "Denne filen er for stor til å lastes opp", xle = "Plasser dokumentet i rammen", Ule = "Hold dokumentet rett", Ble = "Unngå gjenskinn på dokumentet", $le = "Prøv igjen", Gle = "Ingen kamera tilgjengelig", Zle = "Plasser dokumentet i midten", jle = "Last opp et bilde", zle = "Kom nærmere", qle = "Hold enheten i ro", Wle = "Kamera", Yle = "Bytt til mobil", Kle = "Åpne kameraet på mobilenheten din, skann QR-koden og følg linken", Xle = "Please wait...", Qle = "Mobilenhet", Jle = "Identitetsverifikasjon av dokumenter", ece = "Fang et dokument med datamaskinens kamera, last det opp fra filer eller skann det på en mobilenhet", tce = "Fang et dokument med datamaskinens kamera eller last det opp fra filer", rce = "Fang et dokument med datamaskinens kamera eller skann det på en mobilenhet", nce = "Last opp et dokument fra filer eller skann det på en mobilenhet", ice = "Bruk datamaskinens kamera til å fange et dokument", ace = "Velg et dokument fra filer og last det opp", oce = "Bruk mobilkameraet til å fange et dokument", sce = "Fang et dokument med mobilens kamera eller last det opp fra galleriet", lce = "Velg et dokument fra galleriet og last det opp", cce = "Galleri", uce = "Filer", fce = "Gå tilbake til datamaskinen", dce = "Dokumentet ditt har blitt registrert", pce = "eller", hce = "Klikk her for å fortsette i nettleseren", mce = "Hopp over", _ce = "Vend dokumentet", Ece = "Vipp dokumentet", Cce = {
  preparingCamera: Tle,
  timeout: Ole,
  noFocus: yle,
  somethingWentWrong: Nle,
  incorrectCameraId: Lle,
  done: Mle,
  cameraUnavailable: ble,
  versionNotSupported: Ple,
  httpNotSupported: wle,
  insecurePageContext: Hle,
  badLicense: Vle,
  fileCorrupt: kle,
  largeFile: Fle,
  placeDocumentIntoFrame: xle,
  holdDocumentStraight: Ule,
  glaresOnDocument: Ble,
  tryAgain: $le,
  noCameraAvailable: Gle,
  positionDocumentCenter: Zle,
  uploadPhoto: jle,
  moveCloser: zle,
  keepDeviceStill: qle,
  camera: Wle,
  switchToMobile: Yle,
  openPhoneCamera: Kle,
  pleaseWait: Xle,
  mobileDevice: Qle,
  verifyYourIdentity: Jle,
  fromCameraFilesMobileDesktop: ece,
  fromCameraFilesDesktop: tce,
  fromCameraMobileDesktop: rce,
  fromFilesMobileDesktop: nce,
  fromCameraDesktop: ice,
  fromFilesDesktop: ace,
  fromMobileDesktop: oce,
  fromCameraGalleryMobile: sce,
  fromGalleryMobile: lce,
  gallery: cce,
  files: uce,
  returnToComputer: fce,
  documentCaptured: dce,
  or: pce,
  continueInBrowser: hce,
  skip: mce,
  flipTheDocument: _ce,
  tiltTheDocument: Ece
}, Sce = "Kamerani tayyorlash...", Ice = "Vaqt tugashi", vce = "Kamera fokusi yo'q", gce = "Nimadir noto'g'ri ketdi", Dce = "Berilgan ID bilan kamera topilmadi.", Rce = "Tayyor!", Ace = "Kamera mavjud emas!", Tce = "Brauzeringiz versiyasi qo'llab-quvvatlanmaydi", Oce = "HTTPS ishlatilmaydi", yce = "Xavfli kontekst", Nce = "Litsenziya topilmadi yoki bekor qilindi", Lce = "Fayl buzilgan yoki qo'llab-quvvatlanmaydi", Mce = "Yuklab olinadigan fayl hajmi juda katta", bce = "Hujjatni ramkaga joylashtiring", Pce = "Hujjatni to'g'ri ushlang", wce = "Hujjatingizni yorug'likdan saqlang", Hce = "Qayta urinib ko'ring", Vce = "Kamera yo'q", kce = "Hujjatni markazga joylashtiring", Fce = "Fotosuratni yuklang", xce = "Yaqinroq keling", Uce = "Qurilmani harakatsiz ushlang", Bce = "Kamera", $ce = "Mobil qurilmangizga o'ting", Gce = "Mobil qurilmangiz kamerasini oching, QR kodini skanerlang va havolaga o'ting", Zce = "Iltimos kuting…", jce = "Mobil qurilma", zce = "Shaxsni tasdiqlovchi hujjatni tekshirish", qce = "Hujjatni kompyuter kamerasi bilan suratga oling, fayllardan yuklang yoki mobil qurilmangizdan skanerlang", Wce = "Hujjatni kompyuter kamerasi bilan suratga oling yoki fayllardan yuklang", Yce = "Hujjatni kompyuter kamerasi bilan suratga oling yoki mobil qurilmadan skanerlang", Kce = "Hujjatni fayllardan yuklang yoki mobil qurilmadan skanerlang", Xce = "Hujjatni suratga olish uchun kompyuter kamerasidan foydalaning", Qce = "Fayllardan hujjatni tanlang va uni yuklang", Jce = "Hujjatni suratga olish uchun mobil qurilmangiz kamerasidan foydalaning", eue = "Hujjatni mobil qurilmangiz kamerasi bilan suratga oling yoki galereyadan yuklang", tue = "Galereyadan hujjatni tanlang va uni yuklab oling", rue = "Galereya", nue = "Fayllar", iue = "Kompyuterga qaytish", aue = "Hujjatingiz yozib olindi", oue = "yoki", sue = "Brauzerda davom ettirish uchun shu yerga bosing", lue = "O'tkazib yuborish", cue = "Hujjatni aylantiring", uue = "Hujjatni egib oling", fue = {
  preparingCamera: Sce,
  timeout: Ice,
  noFocus: vce,
  somethingWentWrong: gce,
  incorrectCameraId: Dce,
  done: Rce,
  cameraUnavailable: Ace,
  versionNotSupported: Tce,
  httpNotSupported: Oce,
  insecurePageContext: yce,
  badLicense: Nce,
  fileCorrupt: Lce,
  largeFile: Mce,
  placeDocumentIntoFrame: bce,
  holdDocumentStraight: Pce,
  glaresOnDocument: wce,
  tryAgain: Hce,
  noCameraAvailable: Vce,
  positionDocumentCenter: kce,
  uploadPhoto: Fce,
  moveCloser: xce,
  keepDeviceStill: Uce,
  camera: Bce,
  switchToMobile: $ce,
  openPhoneCamera: Gce,
  pleaseWait: Zce,
  mobileDevice: jce,
  verifyYourIdentity: zce,
  fromCameraFilesMobileDesktop: qce,
  fromCameraFilesDesktop: Wce,
  fromCameraMobileDesktop: Yce,
  fromFilesMobileDesktop: Kce,
  fromCameraDesktop: Xce,
  fromFilesDesktop: Qce,
  fromMobileDesktop: Jce,
  fromCameraGalleryMobile: eue,
  fromGalleryMobile: tue,
  gallery: rue,
  files: nue,
  returnToComputer: iue,
  documentCaptured: aue,
  or: oue,
  continueInBrowser: sue,
  skip: lue,
  flipTheDocument: cue,
  tiltTheDocument: uue
}, due = "Տեսախցիկի նախապատրաստում․․․", pue = "Թայմաութ", hue = "Տեսախցիկի ֆոկուսավորում չկա", mue = "Ինչ-որ բան սխալ է", _ue = "Նշված ID-ով տեսախցիկ չգտնվեց։", Eue = "Պատրաստ է", Cue = "Տեսախցիկը հասանելի չէ։", Sue = "Ձեր դիտարկիչի տարբերակը չի աջակցվում", Iue = "HTTPS չի օգտագործվում", vue = "Վտանգավոր համատեքստ", gue = "Արտոնագիրը չի գտնվել կամ այն անվավեր է", Due = "Ֆայլը վնասված է կամ չի աջակցվում", Rue = "Բեռնված ֆայլի չափը շատ մեծ է", Aue = "Փաստաթուղթը տեղադրեք շրջանակի մեջ", Tue = "Փաստաթուղթը պահեք ուղիղ", Oue = "Խուսափեք փաստաթղթի վրա փայլեր հայտնվելուց", yue = "Կրկնեք փորձը", Nue = "Տեսախցիկը բացակայում է", Lue = "Փաստաթուղթը տեղադրեք կենտրոնում", Mue = "Բեռնել լուսանկարը", bue = "Ավելի մոտ տեղավորվերք", Pue = "Սարքը պահեք անշարժ", wue = "Տեսախցիկ", Hue = "Անցնել բջջային սարքին", Vue = "բացեք բջջային սարքի տեսախցիկը, սկանավորեք QR կոդը և անցեք հղումով", kue = "Խնդրում ենք սպասել...", Fue = "Բջջային սարք", xue = "Անձը հաստատող փաստաթղթի ստուգում", Uue = "Համակարգչի տեսախցիկով լուսանկարեք փաստաթուղթը, բեռնեք ֆայլերից կամ սկանավորեք բջջային սարքից", Bue = "Փաստաթուղթը լուսանկարեք համակարգչի տեսախցիկի օգնությամբ կամ բեռնեք այն ֆայլերի ցանկից", $ue = "Համակարգչի տեսախցիկով լուսանկարեք փաստաթուղթը կամ սկանավորեք բջջային սարքից", Gue = "Փաստաթուղթը բեռնեք ֆայլերի ցանկից կամ սկանավորեք այն բջջային սարքից", Zue = "Օգտվեք համակարգչի տեսախցիկից՝ փաստաթուղթը լուսանկարելու համար", jue = "Ֆայլերի ցանկից փաստաթուղթ ընտրեք և բեռնեք այն", zue = "Օգտվեք բջջային սարքի տեսախցիկից՝ փաստաթուղթը լուսանկարելու համար", que = "Փաստաթուղթը լուսանկարեք բջջային սարքի տեսախցիկի օգնությամբ կամ բեռնեք այն պատկերադարանից", Wue = "Պատկերադարանից ընտրեք փաստաթուղթը և բեռնեք այն", Yue = "Պատկերադարան", Kue = "Ֆայլեր", Xue = "Վերադարձեք համակարգչի մոտ", Que = "Ձեր փաստաթուղթը տեսագրված է", Jue = "կամ", e0e = "Սեղմեք այստեղ՝ դիտարկիչում շարունակելու համար", t0e = "Բաց թողնել", r0e = "Շրջել փաստաթուղթը", n0e = "Թեքեք նկարը", i0e = {
  preparingCamera: due,
  timeout: pue,
  noFocus: hue,
  somethingWentWrong: mue,
  incorrectCameraId: _ue,
  done: Eue,
  cameraUnavailable: Cue,
  versionNotSupported: Sue,
  httpNotSupported: Iue,
  insecurePageContext: vue,
  badLicense: gue,
  fileCorrupt: Due,
  largeFile: Rue,
  placeDocumentIntoFrame: Aue,
  holdDocumentStraight: Tue,
  glaresOnDocument: Oue,
  tryAgain: yue,
  noCameraAvailable: Nue,
  positionDocumentCenter: Lue,
  uploadPhoto: Mue,
  moveCloser: bue,
  keepDeviceStill: Pue,
  camera: wue,
  switchToMobile: Hue,
  openPhoneCamera: Vue,
  pleaseWait: kue,
  mobileDevice: Fue,
  verifyYourIdentity: xue,
  fromCameraFilesMobileDesktop: Uue,
  fromCameraFilesDesktop: Bue,
  fromCameraMobileDesktop: $ue,
  fromFilesMobileDesktop: Gue,
  fromCameraDesktop: Zue,
  fromFilesDesktop: jue,
  fromMobileDesktop: zue,
  fromCameraGalleryMobile: que,
  fromGalleryMobile: Wue,
  gallery: Yue,
  files: Kue,
  returnToComputer: Xue,
  documentCaptured: Que,
  or: Jue,
  continueInBrowser: e0e,
  skip: t0e,
  flipTheDocument: r0e,
  tiltTheDocument: n0e
}, a0e = "Камера даярдалууда...", o0e = "Тайм-аут", s0e = "Камеранын фокусу жок", l0e = "Бир жерден ката кетти", c0e = "Көрсөтүлгөн ID менен камера табылган жок.", u0e = "Даяр!", f0e = "Камера жеткиликтүү эмес!", d0e = "Сиздин браузердин версиясы колдоого алынбайт", p0e = "HTTPS колдонулбайт", h0e = "Коопсуз контекст", m0e = "Лицензия табылган жок же жараксыз", _0e = "Файл бузулган же колдоого алынбайт", E0e = "Жүктөлүп берилген файлдын өлчөмү өтө чоң", C0e = "Документти алкакка жайгаштырыңыз:", S0e = "Документти түз кармаңыз", I0e = "Документиңизде жаркырап калбаңыз", v0e = "Кайра аракет кылып көрүңүз", g0e = "Камера жок", D0e = "Документти борборго коюңуз", R0e = "Сүрөт жүктөө", A0e = "Жакыныраак жылыңыз", T0e = "Түзмөктү кыймылдатпаңыз", O0e = "Камера", y0e = "Мобилдик түзмөккө өтүңүз", N0e = "Мобилдик түзмөгүңүздүн камерасын ачып, QR кодун сканерлеп, шилтемени басыңыз", L0e = "Сураныч, күтө туруңуз...", M0e = "Мобилдик түзмөк", b0e = "Өздүгүн тастыктаган документти текшерүү", P0e = "Компьютериңиздин камерасы менен документти сүрөткө тартыңыз, файлдардан жүктөңүз же мобилдик түзмөгүңүздөн сканерлеңиз", w0e = "Компьютериңиздин камерасы менен документти сүрөткө тартыңыз же файлдардан жүктөңүз", H0e = "Компьютериңиздин камерасы менен документти сүрөткө тартыңыз же мобилдик түзмөгүңүздөн сканерлеңиз", V0e = "Документти файлдардан жүктөө же мобилдик түзмөктөн сканерлөө", k0e = "Документти сүрөткө тартуу үчүн компьютериңиздин камерасын колдонуңуз", F0e = "Файлдардан документти тандап, жүктөңүз", x0e = "Документти сүрөткө тартуу үчүн мобилдик түзмөгүңүздүн камерасын колдонуңуз", U0e = "Мобилдик түзмөгүңүздүн камерасы менен документтин сүрөтүн тартыңыз же галереяңыздан жүктөңүз", B0e = "Галереядан документти тандап, жүктөңүз", $0e = "Галерея", G0e = "Файлдар", Z0e = "Компьютерге кайтыңыз", j0e = "Документиңиз алынды", z0e = "же", q0e = "Браузерде улантуу үчүн бул жакты басыңыз.", W0e = "Өткөрүп жиберүү", Y0e = "Документти которуңуз", K0e = "Документти ийиңиз", X0e = {
  preparingCamera: a0e,
  timeout: o0e,
  noFocus: s0e,
  somethingWentWrong: l0e,
  incorrectCameraId: c0e,
  done: u0e,
  cameraUnavailable: f0e,
  versionNotSupported: d0e,
  httpNotSupported: p0e,
  insecurePageContext: h0e,
  badLicense: m0e,
  fileCorrupt: _0e,
  largeFile: E0e,
  placeDocumentIntoFrame: C0e,
  holdDocumentStraight: S0e,
  glaresOnDocument: I0e,
  tryAgain: v0e,
  noCameraAvailable: g0e,
  positionDocumentCenter: D0e,
  uploadPhoto: R0e,
  moveCloser: A0e,
  keepDeviceStill: T0e,
  camera: O0e,
  switchToMobile: y0e,
  openPhoneCamera: N0e,
  pleaseWait: L0e,
  mobileDevice: M0e,
  verifyYourIdentity: b0e,
  fromCameraFilesMobileDesktop: P0e,
  fromCameraFilesDesktop: w0e,
  fromCameraMobileDesktop: H0e,
  fromFilesMobileDesktop: V0e,
  fromCameraDesktop: k0e,
  fromFilesDesktop: F0e,
  fromMobileDesktop: x0e,
  fromCameraGalleryMobile: U0e,
  fromGalleryMobile: B0e,
  gallery: $0e,
  files: G0e,
  returnToComputer: Z0e,
  documentCaptured: j0e,
  or: z0e,
  continueInBrowser: q0e,
  skip: W0e,
  flipTheDocument: Y0e,
  tiltTheDocument: K0e
}, PR = {
  ru: Sk,
  en: dF,
  de: ax,
  pl: Qx,
  it: jU,
  hu: FB,
  zh: M$,
  sk: RG,
  uk: EZ,
  fr: uj,
  es: nz,
  pt: Kz,
  ar: Gq,
  nl: VW,
  id: NY,
  vi: gK,
  ko: mX,
  ms: lQ,
  ro: tJ,
  el: WJ,
  tr: Bee,
  ja: wte,
  cs: Ore,
  th: Ine,
  hi: pie,
  bn: oae,
  he: Jae,
  fi: zoe,
  sv: xse,
  da: b2e,
  hr: Ale,
  no: Cce,
  uz: fue,
  hy: i0e,
  ky: X0e
};
function Ll(e, r, t) {
  return (r = Q0e(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function Q0e(e) {
  var r = J0e(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function J0e(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const Ml = jr.create("main");
class e3e extends HTMLElement {
  constructor() {
    super(), Ll(this, "_root", o8.createRoot(this.attachShadow({
      mode: "open"
    }))), Ll(this, "_mounted", !1), Ll(this, "_translations", null), Ll(this, "_settings", {});
  }
  static get observedAttributes() {
    return Object.values(fn);
  }
  onEvent(r) {
    const t = B8(X9, r);
    this.dispatchEvent(t), Ml("Component event: ".concat(JSON.stringify(t.detail)));
  }
  attributeChangedCallback(r) {
    Ml("Attribute change: ".concat(r));
    const t = this.getAttribute(r), a = x8(t), o = {
      [fn.locale]: () => t && (this._settings.locale = t),
      [fn.multiple]: () => {
        this._settings.multipleFileInput = a;
      },
      [fn.copyright]: () => {
        this._settings.copyright = a;
      },
      [fn.startScreen]: () => {
        this._settings.startScreen = a;
      },
      [fn.internalScenario]: () => t && (this._settings.internalScenario = t),
      [fn.multipageProcessing]: () => {
        this._settings.multipageProcessing = a;
      },
      [fn.cameraId]: () => t && (this._settings.cameraId = t),
      [fn.changeCamera]: () => {
        this._settings.changeCameraButton = a;
      },
      [fn.closeButton]: () => {
        this._settings.closeButton = a;
      },
      [fn.captureButton]: () => {
        this._settings.captureButton = a;
      },
      [fn.newLayout]: () => {
        this._settings.newLayout = a;
      }
    };
    o[r] && o[r](), this._mounted && this.render();
  }
  connectedCallback() {
    setTimeout(() => {
      Ml("Component mounted"), this.render(), this._mounted = !0, this.onEvent({
        action: pt.ELEMENT_VISIBLE,
        data: null
      });
    });
  }
  set translations(r) {
    this._translations = r, this._mounted && this.render();
  }
  get translations() {
    return this._translations;
  }
  set settings(r) {
    this._settings = Zr(this._settings, r), this._mounted && this.render();
  }
  get settings() {
    return this._settings;
  }
  render() {
    this._root.render(/* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
      /* @__PURE__ */ Z.jsx("style", { nonce: this._settings.nonce, children: SR + IR + vR + gR + DR + RR + AR + TR + OR + yR + NR + LR + AV + TV + MR + bR }),
      /* @__PURE__ */ Z.jsx(RV, be({ dictionaries: PR, onEvent: this.onEvent.bind(this), translations: this._translations }, this._settings))
    ] }));
  }
  disconnectedCallback() {
    setTimeout(() => this._root.unmount()), Ml("Component disconnected"), jr.saveLogs();
  }
}
function t3e(e) {
  let {
    onStatusChange: r,
    onCapture: t,
    onError: a,
    onClose: o
  } = e;
  const {
    onEvent: l,
    cameraId: c,
    startScreen: f,
    resolution: p,
    cameraMode: u,
    mirrorType: h
  } = nr(), C = oe.useRef(null), E = {
    width: (p == null ? void 0 : p.width) || ui.FULL_HD.width,
    height: (p == null ? void 0 : p.height) || ui.FULL_HD.height
  }, [_, S] = oe.useState(!1), [v, g] = oe.useState({
    videoElement: null,
    videoParams: {
      width: 0,
      height: 0
    },
    videoContainerParams: {
      width: 0,
      height: 0
    }
  }), [O, R] = oe.useState({
    videoStatus: Ft.PREPARING,
    camera: {
      deviceId: "",
      facing: void 0,
      groupId: "",
      label: ""
    },
    sortedDevices: null
  }), [D, T] = oe.useState(c), L = () => {
    var B;
    l({
      action: pt.PRESS_MIRRORING_BUTTON,
      data: null
    }), (B = C.current) === null || B === void 0 || B.changeMirror();
  }, P = () => {
    l({
      action: pt.CAMERA_PROCESS_CLOSED,
      data: null
    }), f && r(Me.CHOOSE_INPUT_SOURCE);
  }, M = () => {
    if (l({
      action: pt.PRESS_CAPTURE_BUTTON,
      data: null
    }), !v.videoElement) return;
    const {
      raw: B,
      mimeType: Y
    } = cc(v.videoElement, Ha.BASE64);
    t([{
      raw: B,
      mimeType: Y
    }]), r(Me.SUCCESS);
  }, k = () => {
    if (!O.sortedDevices) return;
    l({
      action: pt.PRESS_CHANGE_CAMERA_BUTTON,
      data: null
    });
    const B = Eh(O.sortedDevices, O.camera.deviceId);
    B && T(B);
  }, H = (B) => {
    a(new $t(B));
  }, w = () => {
    l({
      action: pt.VIDEO_STARTED,
      data: null
    });
  }, $ = () => {
    l({
      action: pt.VIDEO_STOPPED,
      data: null
    });
  };
  return /* @__PURE__ */ Z.jsx(J8, { mirroring: _, onChangeMirroring: L, status: at.SNAPSHOT, videoStatusParams: O, onCameraSnapshot: M, onProcessClose: P, onClose: o, onChangeCamera: k, videoElementParams: v, children: /* @__PURE__ */ Z.jsx(Y8, { onVideoSizeChange: g, onVideoStatusChange: R, resolution: E, onFailStatus: H, mode: u || hn.environment, cameraId: D, onVideoStarted: w, onVideoStopped: $, onMirroringChange: S, mirrorType: h, ref: C }) });
}
function up(e, r, t) {
  return (r = r3e(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function r3e(e) {
  var r = n3e(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function n3e(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class i3e {
  constructor(r) {
    up(this, "mimeType", void 0), up(this, "raw", void 0), up(this, "extension", void 0), this.mimeType = r.split(";")[0].replace("data:", ""), this.extension = this.mimeType.split("/")[1], this.raw = r.substring(r.indexOf(",") + 1);
  }
}
function a3e(e) {
  return Ae(this, null, function* () {
    const r = [];
    for (let t = 0; t < e.length; t++) {
      const a = new Promise((o, l) => {
        const c = e.item(t);
        if (c) {
          const f = URL.createObjectURL(c), p = new Image();
          p.onload = () => {
            const u = new FileReader();
            u.readAsDataURL(c), u.onload = () => {
              if (typeof u.result == "string") {
                const {
                  raw: h,
                  mimeType: C
                } = new i3e(u.result);
                o({
                  raw: h,
                  mimeType: C
                });
              } else
                l(new $t(rr.INCORRECT_FILE));
              URL.revokeObjectURL(f);
            }, u.onerror = () => l(new $t(rr.INCORRECT_FILE));
          }, p.src = f, p.onerror = () => l(new $t(rr.INCORRECT_FILE));
        }
      });
      r.push(a);
    }
    return r;
  });
}
function o3e(e) {
  let {
    onStatusChange: r,
    onCapture: t,
    images: a,
    onError: o
  } = e;
  const {
    onEvent: l
  } = nr(), [c, f] = oe.useState([]);
  return oe.useEffect(() => {
    a != null && a.length && !(c != null && c.length) && (l({
      action: pt.FILE_PROCESS_STARTED,
      data: null
    }), a3e(a).then((p) => {
      Promise.all(p).then((u) => {
        f(u);
      }).catch((u) => {
        o(u);
      });
    })), c.length && (t(c), r(Me.SUCCESS));
  }, [a, c]), /* @__PURE__ */ Z.jsx(e2, {});
}
const s3e = (e, r, t) => e ? r ? t ? "fromCameraGalleryMobile" : "fromMobileDesktop" : t ? "fromGalleryMobile" : "" : r ? t ? "fromCameraFilesDesktop" : "fromCameraDesktop" : t ? "fromFilesDesktop" : "", Ai = {
  "verified-screen": "_verified-screen_evxkx_1",
  "error-screen": "_error-screen_evxkx_5",
  "camera-disabled-screen": "_camera-disabled-screen_evxkx_9"
};
function l3e(e) {
  let {
    direction: r
  } = e;
  const {
    onEvent: t,
    startScreen: a,
    fromCameraButton: o = !0,
    uploadFileButton: l = !0
  } = nr(), {
    translate: c
  } = Hi.useLocalize(), [f, p] = oe.useState(a ? Me.CHOOSE_INPUT_SOURCE : Me.CAMERA_PROCESSING), [u, h] = oe.useState(null), [C, E] = oe.useState([{
    raw: "",
    mimeType: ""
  }]), _ = (R) => {
    h(R), p(Me.FILE_PROCESSING);
  }, S = () => {
    t({
      action: pt.PRESS_CAMERA_BUTTON,
      data: null
    }), p(Me.CAMERA_PROCESSING);
  }, v = (R) => {
    const D = A8[R.type] || Me.UNKNOWN_ERROR;
    p(D), t({
      action: pt.PROCESS_FINISHED,
      data: {
        status: Li.ERROR,
        reason: R.type
      }
    });
  }, g = () => {
    h(null), E([{
      raw: "",
      mimeType: ""
    }]), p(a ? Me.CHOOSE_INPUT_SOURCE : Me.CAMERA_PROCESSING), t({
      action: pt.PRESS_RETRY_BUTTON,
      data: null
    });
  }, O = () => {
    t({
      action: pt.CLOSE,
      data: null
    });
  };
  return oe.useEffect(() => {
    f === Me.SUCCESS && t({
      action: pt.PROCESS_FINISHED,
      data: {
        status: Li.OK,
        response: C
      }
    });
  }, [f, C]), /* @__PURE__ */ Z.jsx(QD, { onError: v, supportedBrowserVersions: T8, children: /* @__PURE__ */ Z.jsx(gh, { showHeaderAndFooter: f !== Me.CAMERA_PROCESSING, onClose: O, direction: r, children: f === Me.CHOOSE_INPUT_SOURCE ? /* @__PURE__ */ Z.jsx(YD, { onStart: S, onFileImageSet: _, title: c("uploadPhoto"), subtitle: c(s3e(Kt.isMobile, o, l)) }) : f === Me.CAMERA_PROCESSING ? /* @__PURE__ */ Z.jsx(t3e, { onStatusChange: p, onCapture: E, onClose: O, onError: v }) : f === Me.FILE_PROCESSING ? /* @__PURE__ */ Z.jsx(o3e, { onStatusChange: p, onCapture: E, images: u, onError: v }) : f === Me.SUCCESS ? /* @__PURE__ */ Z.jsx(tr, { className: Ai["verified-screen"], title: c("done") }) : f === Me.NOT_SUPPORTED_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: Ai["error-screen"], title: c("versionNotSupported") }) : f === Me.INCORRECT_FILE_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: Ai["error-screen"], title: c("fileCorrupt"), onReset: g }) : f === Me.CAMERA_PERMISSION_DENIED_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: Ai["camera-disabled-screen"], title: c("cameraUnavailable") }) : f === Me.HTTP_NOT_SUPPORTED_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: Ai["error-screen"], title: c("httpNotSupported") }) : f === Me.INSECURE_PAGE_CONTEXT_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: Ai["error-screen"], title: c("insecurePageContext") }) : f === Me.NO_CAMERA_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: Ai["camera-disabled-screen"], title: c("noCameraAvailable") }) : f === Me.INCORRECT_CAMERA_ID_ERROR ? /* @__PURE__ */ Z.jsx(tr, { className: Ai["camera-disabled-screen"], title: c("incorrectCameraId") }) : /* @__PURE__ */ Z.jsx(tr, { className: Ai["error-screen"], title: c("somethingWentWrong"), onReset: g }) }) });
}
const c3e = U8(XD, KD)(l3e), u3e = `._verified-screen_evxkx_1:before{background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2086%2084'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cellipse%20cx='43'%20cy='42'%20rx='40'%20ry='40'%20transform='rotate(90%2043%2042)'%20stroke='%235DA600'%20stroke-width='3'/%3e%3cpath%20d='M66%2030L40.5069%2054L28%2042.2256'%20stroke='%235DA600'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e")}._error-screen_evxkx_5:before{background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2086%2084'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cellipse%20cx='43'%20cy='42'%20rx='40'%20ry='40'%20transform='rotate(90%2043%2042)'%20stroke='%23FF0000'%20stroke-width='3'/%3e%3cpath%20d='M57%2028L29%2056M29%2028L57%2056'%20stroke='%23FF0000'%20stroke-width='3'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e")}._camera-disabled-screen_evxkx_9:before{background-image:url("data:image/svg+xml,%3csvg%20width='80'%20height='80'%20viewBox='0%200%2080%2080'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3ccircle%20cx='40'%20cy='40'%20r='37'%20stroke='%23FF0000'%20stroke-width='3'/%3e%3cpath%20d='M40.213%2030.6667H44.6663C45.3736%2030.6667%2046.0519%2030.9476%2046.552%2031.4477C47.0521%2031.9478%2047.333%2032.6261%2047.333%2033.3334V37.7867L48.6663%2038.12L56.6663%2033.3334V46.6667M47.333%2045.3334V46.6667C47.333%2047.3739%2047.0521%2048.0522%2046.552%2048.5523C46.0519%2049.0524%2045.3736%2049.3334%2044.6663%2049.3334H29.9997C29.2924%2049.3334%2028.6142%2049.0524%2028.1141%2048.5523C27.614%2048.0522%2027.333%2047.3739%2027.333%2046.6667V33.3334C27.333%2032.6261%2027.614%2031.9478%2028.1141%2031.4477C28.6142%2030.9476%2029.2924%2030.6667%2029.9997%2030.6667H32.6663L47.333%2045.3334Z'%20stroke='%23FF0000'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M27.333%2025.3333L56.6663%2054.6666'%20stroke='%23FF0000'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e")}`;
function bl(e, r, t) {
  return (r = f3e(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function f3e(e) {
  var r = d3e(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function d3e(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const p3e = jr.create("main");
class h3e extends HTMLElement {
  constructor() {
    super(), bl(this, "_root", o8.createRoot(this.attachShadow({
      mode: "open"
    }))), bl(this, "_mounted", !1), bl(this, "_translations", null), bl(this, "_settings", {});
  }
  static get observedAttributes() {
    return Object.values(Ti);
  }
  onEvent(r) {
    const t = B8(Q9, r);
    this.dispatchEvent(t), p3e("Component event: ".concat(JSON.stringify(t.detail)));
  }
  attributeChangedCallback(r) {
    const t = this.getAttribute(r), a = x8(t), o = {
      [Ti.locale]: () => t && (this._settings.locale = t),
      [Ti.multiple]: () => {
        this._settings.multipleFileInput = a;
      },
      [Ti.copyright]: () => {
        this._settings.copyright = a;
      },
      [Ti.startScreen]: () => {
        this._settings.startScreen = a;
      },
      [Ti.cameraId]: () => t && (this._settings.cameraId = t),
      [Ti.changeCamera]: () => {
        this._settings.changeCameraButton = a;
      },
      [Ti.closeButton]: () => {
        this._settings.closeButton = a;
      }
    };
    o[r] && o[r](), this._mounted && this.render();
  }
  connectedCallback() {
    setTimeout(() => {
      this.render(), this._mounted = !0, this.onEvent({
        action: pt.ELEMENT_VISIBLE,
        data: null
      });
    });
  }
  set translations(r) {
    this._translations = r, this._mounted && this.render();
  }
  get translations() {
    return this._translations;
  }
  set settings(r) {
    this._settings = Zr(this._settings, r), this._mounted && this.render();
  }
  get settings() {
    return this._settings;
  }
  render() {
    this._root.render(/* @__PURE__ */ Z.jsxs(Z.Fragment, { children: [
      /* @__PURE__ */ Z.jsx("style", { nonce: this._settings.nonce, children: SR + IR + vR + gR + DR + RR + AR + TR + OR + yR + NR + LR + u3e + MR + bR }),
      /* @__PURE__ */ Z.jsx(c3e, be({ dictionaries: PR, onEvent: this.onEvent.bind(this), translations: this._translations }, this._settings))
    ] }));
  }
  disconnectedCallback() {
    setTimeout(() => this._root.unmount()), jr.saveLogs();
  }
}
function m3e(e, r, t) {
  return (r = _3e(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function _3e(e) {
  var r = E3e(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function E3e(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class C3e extends HTMLElement {
  constructor() {
    super(), m3e(this, "_root", void 0), this._root = this.attachShadow({
      mode: "open"
    }), this._root.innerHTML = `
            <style>
            *, *::before, *::after {
                box-sizing: border-box;
            }
            :host {
                display: block;
                position: fixed;
                height: 100%;
                width: 100%;
                top: 0;
                left: 0;
                overflow: auto;
                z-index: 100;
            }
            </style>
            <slot />
        `;
  }
}
var Hp = function(e, r) {
  return Hp = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(t, a) {
    t.__proto__ = a;
  } || function(t, a) {
    for (var o in a) Object.prototype.hasOwnProperty.call(a, o) && (t[o] = a[o]);
  }, Hp(e, r);
};
function l2(e, r) {
  if (typeof r != "function" && r !== null)
    throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");
  Hp(e, r);
  function t() {
    this.constructor = e;
  }
  e.prototype = r === null ? Object.create(r) : (t.prototype = r.prototype, new t());
}
function S3e(e, r, t, a) {
  function o(l) {
    return l instanceof t ? l : new t(function(c) {
      c(l);
    });
  }
  return new (t || (t = Promise))(function(l, c) {
    function f(h) {
      try {
        u(a.next(h));
      } catch (C) {
        c(C);
      }
    }
    function p(h) {
      try {
        u(a.throw(h));
      } catch (C) {
        c(C);
      }
    }
    function u(h) {
      h.done ? l(h.value) : o(h.value).then(f, p);
    }
    u((a = a.apply(e, r || [])).next());
  });
}
function wR(e, r) {
  var t = { label: 0, sent: function() {
    if (l[0] & 1) throw l[1];
    return l[1];
  }, trys: [], ops: [] }, a, o, l, c = Object.create((typeof Iterator == "function" ? Iterator : Object).prototype);
  return c.next = f(0), c.throw = f(1), c.return = f(2), typeof Symbol == "function" && (c[Symbol.iterator] = function() {
    return this;
  }), c;
  function f(u) {
    return function(h) {
      return p([u, h]);
    };
  }
  function p(u) {
    if (a) throw new TypeError("Generator is already executing.");
    for (; c && (c = 0, u[0] && (t = 0)), t; ) try {
      if (a = 1, o && (l = u[0] & 2 ? o.return : u[0] ? o.throw || ((l = o.return) && l.call(o), 0) : o.next) && !(l = l.call(o, u[1])).done) return l;
      switch (o = 0, l && (u = [u[0] & 2, l.value]), u[0]) {
        case 0:
        case 1:
          l = u;
          break;
        case 4:
          return t.label++, { value: u[1], done: !1 };
        case 5:
          t.label++, o = u[1], u = [0];
          continue;
        case 7:
          u = t.ops.pop(), t.trys.pop();
          continue;
        default:
          if (l = t.trys, !(l = l.length > 0 && l[l.length - 1]) && (u[0] === 6 || u[0] === 2)) {
            t = 0;
            continue;
          }
          if (u[0] === 3 && (!l || u[1] > l[0] && u[1] < l[3])) {
            t.label = u[1];
            break;
          }
          if (u[0] === 6 && t.label < l[1]) {
            t.label = l[1], l = u;
            break;
          }
          if (l && t.label < l[2]) {
            t.label = l[2], t.ops.push(u);
            break;
          }
          l[2] && t.ops.pop(), t.trys.pop();
          continue;
      }
      u = r.call(e, t);
    } catch (h) {
      u = [6, h], o = 0;
    } finally {
      a = l = 0;
    }
    if (u[0] & 5) throw u[1];
    return { value: u[0] ? u[1] : void 0, done: !0 };
  }
}
function Vo(e) {
  var r = typeof Symbol == "function" && Symbol.iterator, t = r && e[r], a = 0;
  if (t) return t.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && a >= e.length && (e = void 0), { value: e && e[a++], done: !e };
    }
  };
  throw new TypeError(r ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function Vp(e, r) {
  var t = typeof Symbol == "function" && e[Symbol.iterator];
  if (!t) return e;
  var a = t.call(e), o, l = [], c;
  try {
    for (; (r === void 0 || r-- > 0) && !(o = a.next()).done; ) l.push(o.value);
  } catch (f) {
    c = { error: f };
  } finally {
    try {
      o && !o.done && (t = a.return) && t.call(a);
    } finally {
      if (c) throw c.error;
    }
  }
  return l;
}
function kp(e, r, t) {
  if (t || arguments.length === 2) for (var a = 0, o = r.length, l; a < o; a++)
    (l || !(a in r)) && (l || (l = Array.prototype.slice.call(r, 0, a)), l[a] = r[a]);
  return e.concat(l || Array.prototype.slice.call(r));
}
function bo(e) {
  return this instanceof bo ? (this.v = e, this) : new bo(e);
}
function I3e(e, r, t) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var a = t.apply(e, r || []), o, l = [];
  return o = Object.create((typeof AsyncIterator == "function" ? AsyncIterator : Object).prototype), f("next"), f("throw"), f("return", c), o[Symbol.asyncIterator] = function() {
    return this;
  }, o;
  function c(_) {
    return function(S) {
      return Promise.resolve(S).then(_, C);
    };
  }
  function f(_, S) {
    a[_] && (o[_] = function(v) {
      return new Promise(function(g, O) {
        l.push([_, v, g, O]) > 1 || p(_, v);
      });
    }, S && (o[_] = S(o[_])));
  }
  function p(_, S) {
    try {
      u(a[_](S));
    } catch (v) {
      E(l[0][3], v);
    }
  }
  function u(_) {
    _.value instanceof bo ? Promise.resolve(_.value.v).then(h, C) : E(l[0][2], _);
  }
  function h(_) {
    p("next", _);
  }
  function C(_) {
    p("throw", _);
  }
  function E(_, S) {
    _(S), l.shift(), l.length && p(l[0][0], l[0][1]);
  }
}
function v3e(e) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var r = e[Symbol.asyncIterator], t;
  return r ? r.call(e) : (e = typeof Vo == "function" ? Vo(e) : e[Symbol.iterator](), t = {}, a("next"), a("throw"), a("return"), t[Symbol.asyncIterator] = function() {
    return this;
  }, t);
  function a(l) {
    t[l] = e[l] && function(c) {
      return new Promise(function(f, p) {
        c = e[l](c), o(f, p, c.done, c.value);
      });
    };
  }
  function o(l, c, f, p) {
    Promise.resolve(p).then(function(u) {
      l({ value: u, done: f });
    }, c);
  }
}
function pr(e) {
  return typeof e == "function";
}
function HR(e) {
  var r = function(a) {
    Error.call(a), a.stack = new Error().stack;
  }, t = e(r);
  return t.prototype = Object.create(Error.prototype), t.prototype.constructor = t, t;
}
var fp = HR(function(e) {
  return function(t) {
    e(this), this.message = t ? t.length + ` errors occurred during unsubscription:
` + t.map(function(a, o) {
      return o + 1 + ") " + a.toString();
    }).join(`
  `) : "", this.name = "UnsubscriptionError", this.errors = t;
  };
});
function Fp(e, r) {
  if (e) {
    var t = e.indexOf(r);
    0 <= t && e.splice(t, 1);
  }
}
var Dc = function() {
  function e(r) {
    this.initialTeardown = r, this.closed = !1, this._parentage = null, this._finalizers = null;
  }
  return e.prototype.unsubscribe = function() {
    var r, t, a, o, l;
    if (!this.closed) {
      this.closed = !0;
      var c = this._parentage;
      if (c)
        if (this._parentage = null, Array.isArray(c))
          try {
            for (var f = Vo(c), p = f.next(); !p.done; p = f.next()) {
              var u = p.value;
              u.remove(this);
            }
          } catch (v) {
            r = { error: v };
          } finally {
            try {
              p && !p.done && (t = f.return) && t.call(f);
            } finally {
              if (r) throw r.error;
            }
          }
        else
          c.remove(this);
      var h = this.initialTeardown;
      if (pr(h))
        try {
          h();
        } catch (v) {
          l = v instanceof fp ? v.errors : [v];
        }
      var C = this._finalizers;
      if (C) {
        this._finalizers = null;
        try {
          for (var E = Vo(C), _ = E.next(); !_.done; _ = E.next()) {
            var S = _.value;
            try {
              xg(S);
            } catch (v) {
              l = l != null ? l : [], v instanceof fp ? l = kp(kp([], Vp(l)), Vp(v.errors)) : l.push(v);
            }
          }
        } catch (v) {
          a = { error: v };
        } finally {
          try {
            _ && !_.done && (o = E.return) && o.call(E);
          } finally {
            if (a) throw a.error;
          }
        }
      }
      if (l)
        throw new fp(l);
    }
  }, e.prototype.add = function(r) {
    var t;
    if (r && r !== this)
      if (this.closed)
        xg(r);
      else {
        if (r instanceof e) {
          if (r.closed || r._hasParent(this))
            return;
          r._addParent(this);
        }
        (this._finalizers = (t = this._finalizers) !== null && t !== void 0 ? t : []).push(r);
      }
  }, e.prototype._hasParent = function(r) {
    var t = this._parentage;
    return t === r || Array.isArray(t) && t.includes(r);
  }, e.prototype._addParent = function(r) {
    var t = this._parentage;
    this._parentage = Array.isArray(t) ? (t.push(r), t) : t ? [t, r] : r;
  }, e.prototype._removeParent = function(r) {
    var t = this._parentage;
    t === r ? this._parentage = null : Array.isArray(t) && Fp(t, r);
  }, e.prototype.remove = function(r) {
    var t = this._finalizers;
    t && Fp(t, r), r instanceof e && r._removeParent(this);
  }, e.EMPTY = function() {
    var r = new e();
    return r.closed = !0, r;
  }(), e;
}(), VR = Dc.EMPTY;
function kR(e) {
  return e instanceof Dc || e && "closed" in e && pr(e.remove) && pr(e.add) && pr(e.unsubscribe);
}
function xg(e) {
  pr(e) ? e() : e.unsubscribe();
}
var g3e = {
  Promise: void 0
}, D3e = {
  setTimeout: function(e, r) {
    for (var t = [], a = 2; a < arguments.length; a++)
      t[a - 2] = arguments[a];
    return setTimeout.apply(void 0, kp([e, r], Vp(t)));
  },
  clearTimeout: function(e) {
    return clearTimeout(e);
  },
  delegate: void 0
};
function FR(e) {
  D3e.setTimeout(function() {
    throw e;
  });
}
function Ug() {
}
function Bl(e) {
  e();
}
var Vh = function(e) {
  l2(r, e);
  function r(t) {
    var a = e.call(this) || this;
    return a.isStopped = !1, t ? (a.destination = t, kR(t) && t.add(a)) : a.destination = T3e, a;
  }
  return r.create = function(t, a, o) {
    return new xp(t, a, o);
  }, r.prototype.next = function(t) {
    this.isStopped || this._next(t);
  }, r.prototype.error = function(t) {
    this.isStopped || (this.isStopped = !0, this._error(t));
  }, r.prototype.complete = function() {
    this.isStopped || (this.isStopped = !0, this._complete());
  }, r.prototype.unsubscribe = function() {
    this.closed || (this.isStopped = !0, e.prototype.unsubscribe.call(this), this.destination = null);
  }, r.prototype._next = function(t) {
    this.destination.next(t);
  }, r.prototype._error = function(t) {
    try {
      this.destination.error(t);
    } finally {
      this.unsubscribe();
    }
  }, r.prototype._complete = function() {
    try {
      this.destination.complete();
    } finally {
      this.unsubscribe();
    }
  }, r;
}(Dc), R3e = function() {
  function e(r) {
    this.partialObserver = r;
  }
  return e.prototype.next = function(r) {
    var t = this.partialObserver;
    if (t.next)
      try {
        t.next(r);
      } catch (a) {
        Pl(a);
      }
  }, e.prototype.error = function(r) {
    var t = this.partialObserver;
    if (t.error)
      try {
        t.error(r);
      } catch (a) {
        Pl(a);
      }
    else
      Pl(r);
  }, e.prototype.complete = function() {
    var r = this.partialObserver;
    if (r.complete)
      try {
        r.complete();
      } catch (t) {
        Pl(t);
      }
  }, e;
}(), xp = function(e) {
  l2(r, e);
  function r(t, a, o) {
    var l = e.call(this) || this, c;
    return pr(t) || !t ? c = {
      next: t != null ? t : void 0,
      error: a != null ? a : void 0,
      complete: o != null ? o : void 0
    } : c = t, l.destination = new R3e(c), l;
  }
  return r;
}(Vh);
function Pl(e) {
  FR(e);
}
function A3e(e) {
  throw e;
}
var T3e = {
  closed: !0,
  next: Ug,
  error: A3e,
  complete: Ug
}, kh = function() {
  return typeof Symbol == "function" && Symbol.observable || "@@observable";
}();
function O3e(e) {
  return e;
}
function y3e(e) {
  return e.length === 0 ? O3e : e.length === 1 ? e[0] : function(t) {
    return e.reduce(function(a, o) {
      return o(a);
    }, t);
  };
}
var qn = function() {
  function e(r) {
    r && (this._subscribe = r);
  }
  return e.prototype.lift = function(r) {
    var t = new e();
    return t.source = this, t.operator = r, t;
  }, e.prototype.subscribe = function(r, t, a) {
    var o = this, l = L3e(r) ? r : new xp(r, t, a);
    return Bl(function() {
      var c = o, f = c.operator, p = c.source;
      l.add(f ? f.call(l, p) : p ? o._subscribe(l) : o._trySubscribe(l));
    }), l;
  }, e.prototype._trySubscribe = function(r) {
    try {
      return this._subscribe(r);
    } catch (t) {
      r.error(t);
    }
  }, e.prototype.forEach = function(r, t) {
    var a = this;
    return t = Bg(t), new t(function(o, l) {
      var c = new xp({
        next: function(f) {
          try {
            r(f);
          } catch (p) {
            l(p), c.unsubscribe();
          }
        },
        error: l,
        complete: o
      });
      a.subscribe(c);
    });
  }, e.prototype._subscribe = function(r) {
    var t;
    return (t = this.source) === null || t === void 0 ? void 0 : t.subscribe(r);
  }, e.prototype[kh] = function() {
    return this;
  }, e.prototype.pipe = function() {
    for (var r = [], t = 0; t < arguments.length; t++)
      r[t] = arguments[t];
    return y3e(r)(this);
  }, e.prototype.toPromise = function(r) {
    var t = this;
    return r = Bg(r), new r(function(a, o) {
      var l;
      t.subscribe(function(c) {
        return l = c;
      }, function(c) {
        return o(c);
      }, function() {
        return a(l);
      });
    });
  }, e.create = function(r) {
    return new e(r);
  }, e;
}();
function Bg(e) {
  var r;
  return (r = e != null ? e : g3e.Promise) !== null && r !== void 0 ? r : Promise;
}
function N3e(e) {
  return e && pr(e.next) && pr(e.error) && pr(e.complete);
}
function L3e(e) {
  return e && e instanceof Vh || N3e(e) && kR(e);
}
function M3e(e) {
  return pr(e == null ? void 0 : e.lift);
}
function c2(e) {
  return function(r) {
    if (M3e(r))
      return r.lift(function(t) {
        try {
          return e(t, this);
        } catch (a) {
          this.error(a);
        }
      });
    throw new TypeError("Unable to lift unknown Observable type");
  };
}
function Gs(e, r, t, a, o) {
  return new b3e(e, r, t, a, o);
}
var b3e = function(e) {
  l2(r, e);
  function r(t, a, o, l, c, f) {
    var p = e.call(this, t) || this;
    return p.onFinalize = c, p.shouldUnsubscribe = f, p._next = a ? function(u) {
      try {
        a(u);
      } catch (h) {
        t.error(h);
      }
    } : e.prototype._next, p._error = l ? function(u) {
      try {
        l(u);
      } catch (h) {
        t.error(h);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._error, p._complete = o ? function() {
      try {
        o();
      } catch (u) {
        t.error(u);
      } finally {
        this.unsubscribe();
      }
    } : e.prototype._complete, p;
  }
  return r.prototype.unsubscribe = function() {
    var t;
    if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
      var a = this.closed;
      e.prototype.unsubscribe.call(this), !a && ((t = this.onFinalize) === null || t === void 0 || t.call(this));
    }
  }, r;
}(Vh), P3e = HR(function(e) {
  return function() {
    e(this), this.name = "ObjectUnsubscribedError", this.message = "object unsubscribed";
  };
}), xR = function(e) {
  l2(r, e);
  function r() {
    var t = e.call(this) || this;
    return t.closed = !1, t.currentObservers = null, t.observers = [], t.isStopped = !1, t.hasError = !1, t.thrownError = null, t;
  }
  return r.prototype.lift = function(t) {
    var a = new $g(this, this);
    return a.operator = t, a;
  }, r.prototype._throwIfClosed = function() {
    if (this.closed)
      throw new P3e();
  }, r.prototype.next = function(t) {
    var a = this;
    Bl(function() {
      var o, l;
      if (a._throwIfClosed(), !a.isStopped) {
        a.currentObservers || (a.currentObservers = Array.from(a.observers));
        try {
          for (var c = Vo(a.currentObservers), f = c.next(); !f.done; f = c.next()) {
            var p = f.value;
            p.next(t);
          }
        } catch (u) {
          o = { error: u };
        } finally {
          try {
            f && !f.done && (l = c.return) && l.call(c);
          } finally {
            if (o) throw o.error;
          }
        }
      }
    });
  }, r.prototype.error = function(t) {
    var a = this;
    Bl(function() {
      if (a._throwIfClosed(), !a.isStopped) {
        a.hasError = a.isStopped = !0, a.thrownError = t;
        for (var o = a.observers; o.length; )
          o.shift().error(t);
      }
    });
  }, r.prototype.complete = function() {
    var t = this;
    Bl(function() {
      if (t._throwIfClosed(), !t.isStopped) {
        t.isStopped = !0;
        for (var a = t.observers; a.length; )
          a.shift().complete();
      }
    });
  }, r.prototype.unsubscribe = function() {
    this.isStopped = this.closed = !0, this.observers = this.currentObservers = null;
  }, Object.defineProperty(r.prototype, "observed", {
    get: function() {
      var t;
      return ((t = this.observers) === null || t === void 0 ? void 0 : t.length) > 0;
    },
    enumerable: !1,
    configurable: !0
  }), r.prototype._trySubscribe = function(t) {
    return this._throwIfClosed(), e.prototype._trySubscribe.call(this, t);
  }, r.prototype._subscribe = function(t) {
    return this._throwIfClosed(), this._checkFinalizedStatuses(t), this._innerSubscribe(t);
  }, r.prototype._innerSubscribe = function(t) {
    var a = this, o = this, l = o.hasError, c = o.isStopped, f = o.observers;
    return l || c ? VR : (this.currentObservers = null, f.push(t), new Dc(function() {
      a.currentObservers = null, Fp(f, t);
    }));
  }, r.prototype._checkFinalizedStatuses = function(t) {
    var a = this, o = a.hasError, l = a.thrownError, c = a.isStopped;
    o ? t.error(l) : c && t.complete();
  }, r.prototype.asObservable = function() {
    var t = new qn();
    return t.source = this, t;
  }, r.create = function(t, a) {
    return new $g(t, a);
  }, r;
}(qn), $g = function(e) {
  l2(r, e);
  function r(t, a) {
    var o = e.call(this) || this;
    return o.destination = t, o.source = a, o;
  }
  return r.prototype.next = function(t) {
    var a, o;
    (o = (a = this.destination) === null || a === void 0 ? void 0 : a.next) === null || o === void 0 || o.call(a, t);
  }, r.prototype.error = function(t) {
    var a, o;
    (o = (a = this.destination) === null || a === void 0 ? void 0 : a.error) === null || o === void 0 || o.call(a, t);
  }, r.prototype.complete = function() {
    var t, a;
    (a = (t = this.destination) === null || t === void 0 ? void 0 : t.complete) === null || a === void 0 || a.call(t);
  }, r.prototype._subscribe = function(t) {
    var a, o;
    return (o = (a = this.source) === null || a === void 0 ? void 0 : a.subscribe(t)) !== null && o !== void 0 ? o : VR;
  }, r;
}(xR), UR = function(e) {
  return e && typeof e.length == "number" && typeof e != "function";
};
function BR(e) {
  return pr(e == null ? void 0 : e.then);
}
function $R(e) {
  return pr(e[kh]);
}
function GR(e) {
  return Symbol.asyncIterator && pr(e == null ? void 0 : e[Symbol.asyncIterator]);
}
function ZR(e) {
  return new TypeError("You provided " + (e !== null && typeof e == "object" ? "an invalid object" : "'" + e + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}
function w3e() {
  return typeof Symbol != "function" || !Symbol.iterator ? "@@iterator" : Symbol.iterator;
}
var jR = w3e();
function zR(e) {
  return pr(e == null ? void 0 : e[jR]);
}
function qR(e) {
  return I3e(this, arguments, function() {
    var t, a, o, l;
    return wR(this, function(c) {
      switch (c.label) {
        case 0:
          t = e.getReader(), c.label = 1;
        case 1:
          c.trys.push([1, , 9, 10]), c.label = 2;
        case 2:
          return [4, bo(t.read())];
        case 3:
          return a = c.sent(), o = a.value, l = a.done, l ? [4, bo(void 0)] : [3, 5];
        case 4:
          return [2, c.sent()];
        case 5:
          return [4, bo(o)];
        case 6:
          return [4, c.sent()];
        case 7:
          return c.sent(), [3, 2];
        case 8:
          return [3, 10];
        case 9:
          return t.releaseLock(), [7];
        case 10:
          return [2];
      }
    });
  });
}
function WR(e) {
  return pr(e == null ? void 0 : e.getReader);
}
function jo(e) {
  if (e instanceof qn)
    return e;
  if (e != null) {
    if ($R(e))
      return H3e(e);
    if (UR(e))
      return V3e(e);
    if (BR(e))
      return k3e(e);
    if (GR(e))
      return YR(e);
    if (zR(e))
      return F3e(e);
    if (WR(e))
      return x3e(e);
  }
  throw ZR(e);
}
function H3e(e) {
  return new qn(function(r) {
    var t = e[kh]();
    if (pr(t.subscribe))
      return t.subscribe(r);
    throw new TypeError("Provided object does not correctly implement Symbol.observable");
  });
}
function V3e(e) {
  return new qn(function(r) {
    for (var t = 0; t < e.length && !r.closed; t++)
      r.next(e[t]);
    r.complete();
  });
}
function k3e(e) {
  return new qn(function(r) {
    e.then(function(t) {
      r.closed || (r.next(t), r.complete());
    }, function(t) {
      return r.error(t);
    }).then(null, FR);
  });
}
function F3e(e) {
  return new qn(function(r) {
    var t, a;
    try {
      for (var o = Vo(e), l = o.next(); !l.done; l = o.next()) {
        var c = l.value;
        if (r.next(c), r.closed)
          return;
      }
    } catch (f) {
      t = { error: f };
    } finally {
      try {
        l && !l.done && (a = o.return) && a.call(o);
      } finally {
        if (t) throw t.error;
      }
    }
    r.complete();
  });
}
function YR(e) {
  return new qn(function(r) {
    U3e(e, r).catch(function(t) {
      return r.error(t);
    });
  });
}
function x3e(e) {
  return YR(qR(e));
}
function U3e(e, r) {
  var t, a, o, l;
  return S3e(this, void 0, void 0, function() {
    var c, f;
    return wR(this, function(p) {
      switch (p.label) {
        case 0:
          p.trys.push([0, 5, 6, 11]), t = v3e(e), p.label = 1;
        case 1:
          return [4, t.next()];
        case 2:
          if (a = p.sent(), !!a.done) return [3, 4];
          if (c = a.value, r.next(c), r.closed)
            return [2];
          p.label = 3;
        case 3:
          return [3, 1];
        case 4:
          return [3, 11];
        case 5:
          return f = p.sent(), o = { error: f }, [3, 11];
        case 6:
          return p.trys.push([6, , 9, 10]), a && !a.done && (l = t.return) ? [4, l.call(t)] : [3, 8];
        case 7:
          p.sent(), p.label = 8;
        case 8:
          return [3, 10];
        case 9:
          if (o) throw o.error;
          return [7];
        case 10:
          return [7];
        case 11:
          return r.complete(), [2];
      }
    });
  });
}
function wa(e, r, t, a, o) {
  a === void 0 && (a = 0), o === void 0 && (o = !1);
  var l = r.schedule(function() {
    t(), o ? e.add(this.schedule(null, a)) : this.unsubscribe();
  }, a);
  if (e.add(l), !o)
    return l;
}
function KR(e, r) {
  return r === void 0 && (r = 0), c2(function(t, a) {
    t.subscribe(Gs(a, function(o) {
      return wa(a, e, function() {
        return a.next(o);
      }, r);
    }, function() {
      return wa(a, e, function() {
        return a.complete();
      }, r);
    }, function(o) {
      return wa(a, e, function() {
        return a.error(o);
      }, r);
    }));
  });
}
function XR(e, r) {
  return r === void 0 && (r = 0), c2(function(t, a) {
    a.add(e.schedule(function() {
      return t.subscribe(a);
    }, r));
  });
}
function B3e(e, r) {
  return jo(e).pipe(XR(r), KR(r));
}
function $3e(e, r) {
  return jo(e).pipe(XR(r), KR(r));
}
function G3e(e, r) {
  return new qn(function(t) {
    var a = 0;
    return r.schedule(function() {
      a === e.length ? t.complete() : (t.next(e[a++]), t.closed || this.schedule());
    });
  });
}
function Z3e(e, r) {
  return new qn(function(t) {
    var a;
    return wa(t, r, function() {
      a = e[jR](), wa(t, r, function() {
        var o, l, c;
        try {
          o = a.next(), l = o.value, c = o.done;
        } catch (f) {
          t.error(f);
          return;
        }
        c ? t.complete() : t.next(l);
      }, 0, !0);
    }), function() {
      return pr(a == null ? void 0 : a.return) && a.return();
    };
  });
}
function QR(e, r) {
  if (!e)
    throw new Error("Iterable cannot be null");
  return new qn(function(t) {
    wa(t, r, function() {
      var a = e[Symbol.asyncIterator]();
      wa(t, r, function() {
        a.next().then(function(o) {
          o.done ? t.complete() : t.next(o.value);
        });
      }, 0, !0);
    });
  });
}
function j3e(e, r) {
  return QR(qR(e), r);
}
function z3e(e, r) {
  if (e != null) {
    if ($R(e))
      return B3e(e, r);
    if (UR(e))
      return G3e(e, r);
    if (BR(e))
      return $3e(e, r);
    if (GR(e))
      return QR(e, r);
    if (zR(e))
      return Z3e(e, r);
    if (WR(e))
      return j3e(e, r);
  }
  throw ZR(e);
}
function Gg(e, r) {
  return r ? z3e(e, r) : jo(e);
}
function q3e(e, r) {
  return c2(function(t, a) {
    var o = 0;
    t.subscribe(Gs(a, function(l) {
      a.next(e.call(r, l, o++));
    }));
  });
}
function W3e(e, r, t, a, o, l, c, f) {
  var p = [], u = 0, h = 0, C = !1, E = function() {
    C && !p.length && !u && r.complete();
  }, _ = function(v) {
    return u < a ? S(v) : p.push(v);
  }, S = function(v) {
    u++;
    var g = !1;
    jo(t(v, h++)).subscribe(Gs(r, function(O) {
      r.next(O);
    }, function() {
      g = !0;
    }, void 0, function() {
      if (g)
        try {
          u--;
          for (var O = function() {
            var R = p.shift();
            c || S(R);
          }; p.length && u < a; )
            O();
          E();
        } catch (R) {
          r.error(R);
        }
    }));
  };
  return e.subscribe(Gs(r, _, function() {
    C = !0, E();
  })), function() {
  };
}
function Up(e, r, t) {
  return t === void 0 && (t = 1 / 0), pr(r) ? Up(function(a, o) {
    return q3e(function(l, c) {
      return r(a, l, o, c);
    })(jo(e(a, o)));
  }, t) : (typeof r == "number" && (t = r), c2(function(a, o) {
    return W3e(a, o, e, t);
  }));
}
function JR(e) {
  return c2(function(r, t) {
    var a = null, o = !1, l;
    a = r.subscribe(Gs(t, void 0, void 0, function(c) {
      l = jo(e(c, JR(e)(r))), a ? (a.unsubscribe(), a = null, l.subscribe(t)) : o = !0;
    })), o && (a.unsubscribe(), a = null, l.subscribe(t));
  });
}
function Y3e(e, r) {
  return pr(r) ? Up(e, r, 1) : Up(e, 1);
}
function K3e(e, r, t) {
  return (r = X3e(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function X3e(e) {
  var r = Q3e(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function Q3e(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class J3e {
  constructor() {
    K3e(this, "taskSubject", new xR()), this.taskSubject.pipe(Y3e((r) => Gg(r()).pipe(JR((t) => Gg(Promise.reject(t)))))).subscribe();
  }
  addTask(r) {
    return new Promise((t, a) => {
      this.taskSubject.next(() => Ae(this, null, function* () {
        try {
          const o = yield r();
          t(o);
        } catch (o) {
          a(o);
        }
      }));
    });
  }
}
const e1e = "text/plain", t1e = "us-ascii", dp = (e, r) => r.some((t) => t instanceof RegExp ? t.test(e) : t === e), r1e = /* @__PURE__ */ new Set([
  "https:",
  "http:",
  "file:"
]), n1e = (e) => {
  try {
    const { protocol: r } = new URL(e);
    return r.endsWith(":") && !r.includes(".") && !r1e.has(r);
  } catch (r) {
    return !1;
  }
}, i1e = (e, { stripHash: r }) => {
  var C, E;
  const t = new RegExp("^data:(?<type>[^,]*?),(?<data>[^#]*?)(?:#(?<hash>.*))?$").exec(e);
  if (!t)
    throw new Error(`Invalid URL: ${e}`);
  let { type: a, data: o, hash: l } = t.groups;
  const c = a.split(";");
  l = r ? "" : l;
  let f = !1;
  c[c.length - 1] === "base64" && (c.pop(), f = !0);
  const p = (E = (C = c.shift()) == null ? void 0 : C.toLowerCase()) != null ? E : "", h = [
    ...c.map((_) => {
      let [S, v = ""] = _.split("=").map((g) => g.trim());
      return S === "charset" && (v = v.toLowerCase(), v === t1e) ? "" : `${S}${v ? `=${v}` : ""}`;
    }).filter(Boolean)
  ];
  return f && h.push("base64"), (h.length > 0 || p && p !== e1e) && h.unshift(p), `data:${h.join(";")},${f ? o.trim() : o}${l ? `#${l}` : ""}`;
};
function a1e(e, r) {
  if (r = be({
    defaultProtocol: "http",
    normalizeProtocol: !0,
    forceHttp: !1,
    forceHttps: !1,
    stripAuthentication: !0,
    stripHash: !1,
    stripTextFragment: !0,
    stripWWW: !0,
    removeQueryParameters: [/^utm_\w+/i],
    removeTrailingSlash: !0,
    removeSingleSlash: !0,
    removeDirectoryIndex: !1,
    removeExplicitPort: !1,
    sortQueryParameters: !0,
    removePath: !1,
    transformPath: !1
  }, r), typeof r.defaultProtocol == "string" && !r.defaultProtocol.endsWith(":") && (r.defaultProtocol = `${r.defaultProtocol}:`), e = e.trim(), /^data:/i.test(e))
    return i1e(e, r);
  if (n1e(e))
    return e;
  const t = e.startsWith("//");
  !t && /^\.*\//.test(e) || (e = e.replace(/^(?!(?:\w+:)?\/\/)|^\/\//, r.defaultProtocol));
  const o = new URL(e);
  if (r.forceHttp && r.forceHttps)
    throw new Error("The `forceHttp` and `forceHttps` options cannot be used together");
  if (r.forceHttp && o.protocol === "https:" && (o.protocol = "http:"), r.forceHttps && o.protocol === "http:" && (o.protocol = "https:"), r.stripAuthentication && (o.username = "", o.password = ""), r.stripHash ? o.hash = "" : r.stripTextFragment && (o.hash = o.hash.replace(/#?:~:text.*?$/i, "")), o.pathname) {
    const c = /\b[a-z][a-z\d+\-.]{1,50}:\/\//g;
    let f = 0, p = "";
    for (; ; ) {
      const h = c.exec(o.pathname);
      if (!h)
        break;
      const C = h[0], E = h.index, _ = o.pathname.slice(f, E);
      p += _.replace(/\/{2,}/g, "/"), p += C, f = E + C.length;
    }
    const u = o.pathname.slice(f, o.pathname.length);
    p += u.replace(/\/{2,}/g, "/"), o.pathname = p;
  }
  if (o.pathname)
    try {
      o.pathname = decodeURI(o.pathname).replace(/\\/g, "%5C");
    } catch (c) {
    }
  if (r.removeDirectoryIndex === !0 && (r.removeDirectoryIndex = [/^index\.[a-z]+$/]), Array.isArray(r.removeDirectoryIndex) && r.removeDirectoryIndex.length > 0) {
    let c = o.pathname.split("/");
    const f = c[c.length - 1];
    dp(f, r.removeDirectoryIndex) && (c = c.slice(0, -1), o.pathname = c.slice(1).join("/") + "/");
  }
  if (r.removePath && (o.pathname = "/"), r.transformPath && typeof r.transformPath == "function") {
    const c = o.pathname.split("/").filter(Boolean), f = r.transformPath(c);
    o.pathname = (f == null ? void 0 : f.length) > 0 ? `/${f.join("/")}` : "/";
  }
  if (o.hostname && (o.hostname = o.hostname.replace(/\.$/, ""), r.stripWWW && /^www\.(?!www\.)[a-z\-\d]{1,63}\.[a-z.\-\d]{2,63}$/.test(o.hostname) && (o.hostname = o.hostname.replace(/^www\./, ""))), Array.isArray(r.removeQueryParameters))
    for (const c of [...o.searchParams.keys()])
      dp(c, r.removeQueryParameters) && o.searchParams.delete(c);
  if (!Array.isArray(r.keepQueryParameters) && r.removeQueryParameters === !0 && (o.search = ""), Array.isArray(r.keepQueryParameters) && r.keepQueryParameters.length > 0)
    for (const c of [...o.searchParams.keys()])
      dp(c, r.keepQueryParameters) || o.searchParams.delete(c);
  if (r.sortQueryParameters) {
    const c = o.search;
    o.searchParams.sort();
    try {
      o.search = decodeURIComponent(o.search);
    } catch (p) {
    }
    const f = c.slice(1).split("&").filter((p) => p && !p.includes("="));
    for (const p of f) {
      const u = decodeURIComponent(p);
      o.search = o.search.replace(`?${u}=`, `?${u}`).replace(`&${u}=`, `&${u}`);
    }
  }
  r.removeTrailingSlash && (o.pathname = o.pathname.replace(/\/$/, "")), r.removeExplicitPort && o.port && (o.port = "");
  const l = e;
  return e = o.toString(), !r.removeSingleSlash && o.pathname === "/" && !l.endsWith("/") && o.hash === "" && (e = e.replace(/\/$/, "")), (r.removeTrailingSlash || o.pathname === "/") && o.hash === "" && r.removeSingleSlash && (e = e.replace(/\/$/, "")), t && !r.normalizeProtocol && (e = e.replace(/^http:\/\//, "//")), r.stripProtocol && (e = e.replace(/^(?:https?:)?\/\//, "")), e;
}
function Zg(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(e);
    r && (a = a.filter(function(o) {
      return Object.getOwnPropertyDescriptor(e, o).enumerable;
    })), t.push.apply(t, a);
  }
  return t;
}
function na(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = arguments[r] != null ? arguments[r] : {};
    r % 2 ? Zg(Object(t), !0).forEach(function(a) {
      wr(e, a, t[a]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : Zg(Object(t)).forEach(function(a) {
      Object.defineProperty(e, a, Object.getOwnPropertyDescriptor(t, a));
    });
  }
  return e;
}
function wr(e, r, t) {
  return (r = o1e(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function o1e(e) {
  var r = s1e(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function s1e(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
const pp = jr.create("wasm"), Sr = jr.create("main");
class l1e {
  constructor() {
    wr(this, "_worker", null), wr(this, "_initializeListener", null), wr(this, "_processingListener", null), wr(this, "_queueService", new J3e()), wr(this, "_initProcess", null), wr(this, "version", {
      component: "8.4.2541".trim()
    }), wr(this, "onFinalize", null), wr(this, "isPrepared", !1), wr(this, "isInitialized", !1), wr(this, "isProcessing", !1), wr(this, "initData", null), wr(this, "recognizerProcessParam", {
      processParam: {}
    }), wr(this, "imageProcessParam", {
      processParam: {}
    }), wr(this, "recognizeListener", null), wr(this, "workerPath", "https://wasm.regulaforensics.com/document/release/8.4/barcodemrz/3f91aa35-b10c745f5");
  }
  get processingListener() {
    return this._processingListener;
  }
  set processingListener(r) {
    this._processingListener = r, r && r({
      isProcessing: this.isProcessing
    });
  }
  get initializeListener() {
    return this._initializeListener;
  }
  set initializeListener(r) {
    this._initializeListener = r, r && r({
      isInitialized: this.isInitialized
    });
  }
  createProcessImageRequest(r, t) {
    const a = r.map((o, l) => ({
      data: o,
      light: 6,
      pageIdx: l
    }));
    return na(na({}, t), {}, {
      imagesList: a
    });
  }
  prepareImageData(r) {
    return r.map((t) => t instanceof ImageData ? {
      width: t.width,
      height: t.height,
      data: t.data.buffer
    } : {
      data: t
    });
  }
  sendMessage(r) {
    return this._queueService.addTask(() => new Promise((t, a) => {
      if (!this._worker)
        return Sr("Worker is missing)"), a("Worker is missing");
      this._worker.onmessage = (o) => {
        if (o.data.target === dn.custom) {
          const {
            method: l,
            response: c,
            code: f
          } = o.data.data, p = c && "reject_message" in c ? c.reject_message : "";
          if (f === hp.ok || f === hp.badLicense && !p)
            Sr("Method ".concat(l, ": { code: ").concat(f, " } ")), t(c);
          else {
            const u = dO[f] || f, h = "Method ".concat(l, ": ").concat(u).concat(p ? " Reject message: ".concat(p) : "");
            Sr(h), a(h);
          }
        }
        o.data.target === dn.stdout && pp(JSON.stringify(o.data.content)), o.data.target === dn.stderr && (pp(JSON.stringify(o.data.content)), a(o.data.content));
      }, this._worker.onerror = (o) => {
        pp(JSON.stringify(o.message)), a(o);
      }, Sr("Send message to worker: { target: ".concat(r.target, ", method: ").concat(r.method, " }")), this._worker.postMessage(na(na({}, r), {}, {
        preMain: !0
      }), "data" in r && r.data ? r.data.map((o) => o.data) : []);
    }));
  }
  prepare(r) {
    return Ae(this, null, function* () {
      var t;
      Sr("Preparing the service");
      {
        const a = this.workerPath === "https://wasm.regulaforensics.com/document/release/8.4/barcodemrz/3f91aa35-b10c745f5", o = a1e(r ? HP(r, "PROD") : this.workerPath);
        let c = yield (yield fetch("".concat(o, "/").concat(uO))).text();
        !a && !r && (c = wP(c, o));
        const f = new Blob([c], {
          type: "text/plain"
        }), p = URL.createObjectURL(f);
        this._worker = new Worker(p), URL.revokeObjectURL(p);
      }
      (t = this._worker) === null || t === void 0 || t.postMessage({
        method: Rn.prepare,
        target: dn.gl,
        preMain: !0,
        op: "setPrefetched"
      }), yield this.sendMessage({
        method: Rn.prepare,
        target: dn.init,
        URL: document.URL
      }), this.isPrepared = !0, Sr("Service prepared");
    });
  }
  initialize(r) {
    return Ae(this, null, function* () {
      return this._initProcess || (this._initProcess = this.doInitialize(r), this._initProcess.catch(() => {
        this._initProcess = null;
      })), this._initProcess;
    });
  }
  doInitialize(r) {
    return Ae(this, null, function* () {
      var t, a;
      this.isPrepared || (yield this.prepare(r == null ? void 0 : r.module)), Sr("Initializing the service");
      const {
        scenario: o,
        license: l
      } = yield this.sendMessage({
        target: dn.custom,
        method: Rn.initialize,
        request: {
          systemInfo: {
            userID: q8(M8),
            hostName: (t = document.location) === null || t === void 0 ? void 0 : t.origin,
            license: r == null ? void 0 : r.license
          }
        }
      });
      return this.initData = {
        scenario: o,
        license: l
      }, this.isInitialized = !0, (a = this._initializeListener) === null || a === void 0 || a.call(this, {
        isInitialized: this.isInitialized
      }), Sr("Service initialized: ".concat(JSON.stringify({
        scenario: o,
        license: l
      }))), this.initData;
    });
  }
  doProcess(r, t, a) {
    return Ae(this, null, function* () {
      var o, l;
      Sr("Process method ".concat(r, " started")), this.isProcessing = !0, (o = this._processingListener) === null || o === void 0 || o.call(this, {
        isProcessing: this.isProcessing
      });
      const c = yield this.sendMessage({
        target: dn.custom,
        method: r,
        request: t,
        data: a
      });
      return this.isProcessing = !1, (l = this._processingListener) === null || l === void 0 || l.call(this, {
        isProcessing: this.isProcessing
      }), Sr("Process method ".concat(r, " finished")), new bp(c);
    });
  }
  processImageBase64(r, t) {
    return Ae(this, null, function* () {
      return this.doProcess(Rn.processImage, this.createProcessImageRequest(r, t));
    });
  }
  process(r, t) {
    return Ae(this, null, function* () {
      var a;
      const o = this.prepareImageData(r), l = yield this.doProcess(Rn.process, t || this.recognizerProcessParam, o);
      return (a = this.recognizeListener) === null || a === void 0 || a.call(this, l), l;
    });
  }
  processImage(r, t) {
    return Ae(this, null, function* () {
      const a = this.prepareImageData(r);
      return this.doProcess(Rn.processImage, t || this.imageProcessParam, a);
    });
  }
  startNewPage() {
    return Ae(this, null, function* () {
      Sr("Starting new page"), yield this.sendMessage({
        target: dn.custom,
        method: Rn.startNewPage
      });
    });
  }
  startNewDocument(r, t) {
    return Ae(this, null, function* () {
      return Sr("Starting new document"), yield this.sendMessage({
        target: dn.custom,
        method: Rn.startNewDocument,
        request: na(na({}, t || this.recognizerProcessParam), {}, {
          metadata: r
        })
      });
    });
  }
  createBackendTransaction(r, t) {
    return Ae(this, null, function* () {
      return Sr("Create backend transaction"), yield this.sendMessage({
        target: dn.custom,
        method: Rn.createBackendTransaction,
        request: na(na({}, t || this.recognizerProcessParam), {}, {
          metadata: r
        })
      });
    });
  }
  finalizePackage() {
    return Ae(this, null, function* () {
      try {
        var r;
        Sr("Finalize package");
        const a = yield this.sendMessage({
          target: dn.custom,
          method: Rn.finalizePackage
        });
        return (r = this.onFinalize) === null || r === void 0 || r.call(this, a), a;
      } catch (a) {
        var t;
        return (t = this.onFinalize) === null || t === void 0 || t.call(this, {
          tag: "",
          transactionId: ""
        }), Promise.reject(a);
      }
    });
  }
  addDataToPackage(r, t) {
    return Ae(this, null, function* () {
      Sr("Add data to package"), yield this.sendMessage({
        target: dn.custom,
        method: Rn.addDataToPackage,
        request: t,
        data: [{
          data: r.buffer
        }]
      }), Sr("Data added to package");
    });
  }
  shutdown() {
    Sr("Shutdown service"), this._worker && (this._worker.terminate(), Sr("Worker terminated")), this.isPrepared = !1, this.isInitialized = !1, this.isProcessing = !1, this._initProcess = null;
  }
}
function un(e, r, t) {
  return (r = c1e(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e;
}
function c1e(e) {
  var r = u1e(e, "string");
  return typeof r == "symbol" ? r : r + "";
}
function u1e(e, r) {
  if (typeof e != "object" || !e) return e;
  var t = e[Symbol.toPrimitive];
  if (t !== void 0) {
    var a = t.call(e, r);
    if (typeof a != "object") return a;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (r === "string" ? String : Number)(e);
}
class L1e {
  constructor(r) {
    un(this, "_streamData", null), un(this, "_documentReaderService", new l1e()), un(this, "_canvas", document.createElement("canvas")), un(this, "_cameraInfo", null), un(this, "_sortedDevices", null), un(this, "_devices", null), un(this, "_videoEventListener", null), un(this, "_frameListener", null), un(this, "_pageIdx", 0), un(this, "_streamParam", {
      cameraMode: hn.environment,
      preferredCameraId: "",
      resolution: ui.HD
    }), un(this, "isProcessing", !1), un(this, "isInitialized", !1), un(this, "videoElement", null), this.videoElement = r || null, this._documentReaderService.recognizerProcessParam = mO, this._documentReaderService.imageProcessParam = _O;
  }
  get recognizeListener() {
    return this._documentReaderService.recognizeListener;
  }
  set recognizeListener(r) {
    this._documentReaderService.recognizeListener = r;
  }
  get streamParam() {
    return this._streamParam;
  }
  set streamParam(r) {
    this._streamParam = Zr(this._streamParam, r);
  }
  get recognizerProcessParam() {
    return this._documentReaderService.recognizerProcessParam;
  }
  set recognizerProcessParam(r) {
    this._documentReaderService.recognizerProcessParam = Zr(this._documentReaderService.recognizerProcessParam, r);
  }
  get imageProcessParam() {
    return this._documentReaderService.imageProcessParam;
  }
  set imageProcessParam(r) {
    this._documentReaderService.imageProcessParam = Zr(this._documentReaderService.imageProcessParam, r);
  }
  get workerPath() {
    return this._documentReaderService.workerPath;
  }
  set workerPath(r) {
    this._documentReaderService.workerPath = r;
  }
  startStream() {
    return new Promise((r, t) => {
      Ae(this, null, function* () {
        try {
          if (this._devices || (this._devices = yield $8()), this._sortedDevices || (this._sortedDevices = yield G8(this._devices), this._devices.isCameraAllowed = !0), this._cameraInfo = Z8(this._streamParam.cameraMode, this._sortedDevices, this._streamParam.preferredCameraId), this._streamData = yield new Promise((o, l) => {
            Ae(this, null, function* () {
              const f = Kt.isFirefox ? N8 : 0;
              yield z8(f);
              try {
                if (!this._cameraInfo) return;
                const p = yield j8({
                  width: this._streamParam.resolution.width || ui.HD.width,
                  height: this._streamParam.resolution.height || ui.HD.height
                }, this._cameraInfo, this._streamParam.preferredCameraId);
                o(p);
              } catch (p) {
                l(p);
              }
            });
          }), this._cameraInfo = this._streamData.camera, this._streamData.stream && this.videoElement)
            this.videoElement.srcObject = this._streamData.stream, this._videoEventListener = () => {
              this.videoElement && (this._canvas.width = this.videoElement.videoWidth, this._canvas.height = this.videoElement.videoHeight, r());
            }, this.videoElement.addEventListener("loadeddata", this._videoEventListener);
          else {
            const o = L8[this._streamData.status] || rr.CAMERA_UNKNOWN_ERROR;
            t(new $t(o));
          }
        } catch (o) {
          if (o instanceof Error && o.name === y8)
            return t(new $t(rr.CAMERA_PERMISSION_DENIED, o));
          t(new $t(rr.CAMERA_UNKNOWN_ERROR, o));
        }
      });
    });
  }
  stopStream() {
    var r;
    this._videoEventListener && this.videoElement && (this.videoElement.removeEventListener("play", this._videoEventListener), this._videoEventListener = null), (r = this._streamData) !== null && r !== void 0 && r.stream && (Ep(this._streamData.stream), this._streamData = null);
  }
  startRecognizeProcess() {
    return Ae(this, null, function* () {
      for (this.isProcessing = !0; this.isProcessing; ) {
        if (!this.videoElement) return;
        const {
          imageData: r
        } = cc(this.videoElement, Ha.UINT), t = yield this._documentReaderService.process(r);
        this._frameListener ? this._frameListener(t) : this.stopRecognizeProcess();
      }
    });
  }
  stopRecognizeProcess() {
    this.isProcessing = !1;
  }
  startNewPage() {
    return Ae(this, null, function* () {
      this._pageIdx++, yield this._documentReaderService.startNewPage();
    });
  }
  startNewDocument() {
    return Ae(this, null, function* () {
      yield this._documentReaderService.startNewDocument();
    });
  }
  switchCamera() {
    return Ae(this, null, function* () {
      this._cameraInfo && (this.stopRecognizeProcess(), this.stopStream(), this._sortedDevices && (this._streamParam.preferredCameraId = Eh(this._sortedDevices, this._cameraInfo.deviceId), yield this.startStream(), yield this.startRecognizeProcess()));
    });
  }
  startRecognition(r) {
    return Ae(this, null, function* () {
      return yield this.startNewDocument(), this._streamData || (yield this.startStream()), new Promise((t) => {
        this._frameListener = (a) => {
          const o = qD(a.rawResponse, this._pageIdx, this._documentReaderService.recognizerProcessParam.processParam.multipageProcessing), l = () => {
            this.stopRecognition(), t(a);
          }, c = () => Ae(this, null, function* () {
            yield this.startNewPage(), yield this.startRecognizeProcess();
          });
          if (o === at.START_NEXT_PAGE && r)
            return this.stopRecognizeProcess(), r({
              data: a,
              startNextPage: c,
              finishRecognition: l
            });
          if (ph[o])
            return l();
          if (!this.isProcessing && !this._devices && !this._cameraInfo)
            return t(null);
        }, this.startRecognizeProcess();
      });
    });
  }
  processImage(r) {
    return Ae(this, null, function* () {
      const t = yield zD(r);
      if (t.reduce((o, l) => o + l.width * l.height, 0) > g8)
        return Promise.reject(new $t(rr.FILE_SIZE));
      {
        const o = t.map((l) => {
          let {
            data: c
          } = l;
          return c;
        });
        return yield this._documentReaderService.processImage(o);
      }
    });
  }
  stopRecognition() {
    this._pageIdx = 0, this._cameraInfo = null, this._devices = null, this._sortedDevices = null, this.stopRecognizeProcess(), this.stopStream();
  }
  initialize(r) {
    return Ae(this, null, function* () {
      const t = yield this._documentReaderService.initialize({
        license: r == null ? void 0 : r.license
      });
      return this.isInitialized = this._documentReaderService.isInitialized, t;
    });
  }
  shutdown() {
    this.isProcessing = !1, this.isInitialized = !1, this._documentReaderService.shutdown();
  }
}
function M1e() {
  return Ae(this, null, function* () {
    const e = window.customElements.get("document-reader"), r = window.customElements.get("camera-snapshot"), t = window.customElements.get("fullscreen-container");
    e || window.customElements.define("document-reader", e3e), r || window.customElements.define("camera-snapshot", h3e), t || window.customElements.define("fullscreen-container", C3e);
    const a = window.customElements.whenDefined("document-reader"), o = window.customElements.whenDefined("camera-snapshot"), l = window.customElements.whenDefined("fullscreen-container");
    yield Promise.all([a, o, l]);
  });
}
export {
  VS as Authenticity,
  dr as AuthenticityResultType,
  gM as BarCodeModuleType,
  DM as BarcodeType,
  hn as CameraFacingMode,
  ia as CaptureMode,
  RM as CheckDiagnose,
  Mi as CheckResult,
  yl as Configuration,
  AM as Critical,
  TM as DocumentFormat,
  jD as DocumentReaderApi,
  h3e as DocumentReaderCaptureWebComponent,
  L1e as DocumentReaderProcessor,
  l1e as DocumentReaderService,
  e3e as DocumentReaderWebComponent,
  OM as DocumentType,
  yM as DocumentTypeRecognitionResult,
  rr as ErrorTypes,
  pt as EventActions,
  ub as FiberChecks,
  v8 as FrameLineCap,
  Mo as FrameShapeType,
  C3e as FullScreenContainer,
  NM as GraphicFieldType,
  fb as IdentChecks,
  Fl as ImageQualityCheckType,
  K9 as ImageQualityChecks,
  sb as ImagesExt,
  lb as ImagesFieldWrapper,
  LM as InputBarcodeType,
  MM as InputImageQualityChecks,
  Y9 as InternalScenarios,
  Op as LCID,
  yp as Light,
  bM as LogLevel,
  jr as Logger,
  NP as LowLvlResponse,
  PM as MRZFormat,
  wM as MeasureSystem,
  mp as MirrorType,
  wl as ModuleType,
  HM as MrzDetectModeEnum,
  pb as OCRSecurityTextChecks,
  VM as ParsingErrorCodes,
  kM as ParsingNotificationCodes,
  bp as ProcessResult,
  Wl as ProcessingStatus,
  FM as RFIDErrorCodes,
  xM as RFIDPKDResourceType,
  bp as Response,
  Li as ResponseCode,
  Tn as Result,
  UM as RfidAChip,
  BM as RfidAccessControlProcedureType,
  $M as RfidApplicationType,
  GM as RfidAuthenticationProcedureType,
  ZM as RfidBaudRate,
  jM as RfidCertificateOrigin,
  zM as RfidCertificateType,
  qM as RfidDataFileType,
  WM as RfidLocation,
  YM as RfidPasswordType,
  KM as RfidTerminalType,
  XM as RfidType,
  TD as Scenario,
  hb as SecurityFeatureChecks,
  QM as SecurityFeatureType,
  xl as Source,
  ab as TextExt,
  ib as TextFieldExt,
  JM as TextFieldType,
  eb as TextPostProcessing,
  $l as TransactionStateStatus,
  tb as VerificationResult,
  rb as Visibility,
  M1e as defineComponents,
  LP as instanceOfProcessRequest,
  MP as requestToBaseRequest
};
